/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A type representing a formatted java.math.BigDecimal */
  BigDecimal: { input: string; output: string; }
  /** An RFC-3339 compliant Full Date Scalar */
  Date: { input: any; output: any; }
  /** A type representing a formatted java.time.OffsetDateTime in UTC timezone */
  DateTime: { input: any; output: any; }
  /** A type representing a formatted kotlin.time.Duration */
  Duration: { input: any; output: any; }
  /** An instantaneous point on the time-line represented by a standard date time string */
  Instant: { input: any; output: any; }
  /** A type representing a formatted java.time.LocalDate */
  LocalDate: { input: any; output: any; }
  /** A type representing a formatted java.time.LocalDatetime */
  LocalDatetime: { input: any; output: any; }
  /** A type representing a formatted java.lang.Long */
  Long: { input: string; output: string; }
  /** A type representing a formatted kotlin.collections.Map */
  Map: { input: Record<string, any>; output: Record<string, any>; }
  /** A date-time with an offset from UTC/Greenwich in the ISO-8601 calendar system using the format 1970-01-01T00:00:00Z */
  OffsetDateTime: { input: string; output: string; }
  Time: { input: any; output: any; }
  /** A type representing a formatted java.net.URL */
  URL: { input: string; output: string; }
  UnixTimestamp: { input: number; output: number; }
  /** plain http url */
  Url: { input: string; output: string; }
  /** A type representing a formatted java.util.YearMonth */
  YearMonth: { input: any; output: any; }
  /** A type representing a formatted java.time.ZonedDateTime */
  ZonedDatetime: { input: string; output: string; }
};

/** AI Agent interaction. */
export type AiAgentInteraction = {
  __typename?: 'AIAgentInteraction';
  /** Signed URLs for downloading attachments. */
  attachmentUrls: Array<Scalars['Url']['output']>;
  /** List of attachment file paths. */
  attachments: Array<Scalars['String']['output']>;
  /** Creation time. */
  createdAt: Scalars['DateTime']['output'];
  /** AI Agent interaction ID. */
  id: Scalars['ID']['output'];
  /** Message content. */
  message: Scalars['String']['output'];
  /** Sender type. */
  senderType: SenderType;
  /** AI Agent session. */
  session: AiAgentSession;
  /** AI Agent session ID. */
  sessionId: Scalars['ID']['output'];
};

/** Output type for an AI Agent message. */
export type AiAgentMessageOutput = {
  __typename?: 'AIAgentMessageOutput';
  /** AI Agent interaction ID. */
  interactionId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

/** AI Agent session. */
export type AiAgentSession = {
  __typename?: 'AIAgentSession';
  /** AI Agent session ID. */
  id: Scalars['ID']['output'];
  /** AI Agent interactions. */
  interactions: Array<AiAgentInteraction>;
  /** AI Agent session started at. */
  startedAt: Scalars['DateTime']['output'];
  /** AI Agent session title. */
  title: Scalars['String']['output'];
  /** User ID. */
  userId: Scalars['ID']['output'];
};

/** Create Input for chat session. */
export type AiAgentSessionCreateInput = {
  /** List of file attachments. */
  files?: InputMaybe<Array<FileInput>>;
  /** Chat message. */
  message: Scalars['String']['input'];
};

/** Delete Input for AI Agent session. */
export type AiAgentSessionDeleteInput = {
  /** AI Agent session ID. */
  id: Scalars['ID']['input'];
};

/** Input for AI Agent session operations. */
export type AiAgentSessionInput = {
  /** AI Agent session ID. */
  id: Scalars['ID']['input'];
};

export type AiAgentSessionList = {
  __typename?: 'AIAgentSessionList';
  items: Array<AiAgentSession>;
  totalCount: Scalars['Int']['output'];
};

/** Output type for an AI Agent session. */
export type AiAgentSessionOutput = {
  __typename?: 'AIAgentSessionOutput';
  /** AI Agent session ID. */
  id: Scalars['ID']['output'];
  /** AI Agent session. */
  session?: Maybe<AiAgentSession>;
};

/** Regenerate Input for AI Agent session. */
export type AiAgentSessionRegenerateInput = {
  /** AI Agent session ID. */
  id: Scalars['ID']['input'];
};

/** Update Input for AI Agent session. */
export type AiAgentSessionUpdateInput = {
  /** List of file attachments. */
  files?: InputMaybe<Array<FileInput>>;
  /** AI Agent session ID. */
  id: Scalars['ID']['input'];
  /** AI Agent message. */
  message: Scalars['String']['input'];
};

/** Input for generating a signed URL for file upload */
export type AiAgentSessionUploadInput = {
  /** Name of the file to be uploaded */
  fileName: Scalars['String']['input'];
  /** MIME type of the file (e.g., image/jpeg, application/pdf) */
  mimeType: AiAgentSupportedMimeType;
};

/** Output containing the signed URL for file upload */
export type AiAgentSessionUploadOutput = {
  __typename?: 'AIAgentSessionUploadOutput';
  /** Signed URL for uploading the file */
  signedUrl: Scalars['Url']['output'];
};

/** Supported MIME types for AI Agent file uploads. */
export const AiAgentSupportedMimeType = {
  /** application/pdf */
  APPLICATION_PDF: 'APPLICATION_PDF',
  /** audio/x-aac */
  AUDIO_AAC: 'AUDIO_AAC',
  /** audio/flac */
  AUDIO_FLAC: 'AUDIO_FLAC',
  /** audio/m4a */
  AUDIO_M4A: 'AUDIO_M4A',
  /** audio/mp3 */
  AUDIO_MP3: 'AUDIO_MP3',
  /** audio/mp4 */
  AUDIO_MP4: 'AUDIO_MP4',
  /** audio/mpeg */
  AUDIO_MPEG: 'AUDIO_MPEG',
  /** audio/mpga */
  AUDIO_MPGA: 'AUDIO_MPGA',
  /** audio/opus */
  AUDIO_OPUS: 'AUDIO_OPUS',
  /** audio/pcm */
  AUDIO_PCM: 'AUDIO_PCM',
  /** audio/wav */
  AUDIO_WAV: 'AUDIO_WAV',
  /** audio/webm */
  AUDIO_WEBM: 'AUDIO_WEBM',
  /** image/jpeg */
  IMAGE_JPEG: 'IMAGE_JPEG',
  /** image/png */
  IMAGE_PNG: 'IMAGE_PNG',
  /** image/webp */
  IMAGE_WEBP: 'IMAGE_WEBP',
  /** text/plain */
  TEXT_PLAIN: 'TEXT_PLAIN',
  /** video/3gpp */
  VIDEO_3GPP: 'VIDEO_3GPP',
  /** video/x-flv */
  VIDEO_FLV: 'VIDEO_FLV',
  /** video/mp4 */
  VIDEO_MP4: 'VIDEO_MP4',
  /** video/mpeg */
  VIDEO_MPEG: 'VIDEO_MPEG',
  /** video/mpegs */
  VIDEO_MPEGS: 'VIDEO_MPEGS',
  /** video/mpg */
  VIDEO_MPG: 'VIDEO_MPG',
  /** video/quicktime */
  VIDEO_QUICKTIME: 'VIDEO_QUICKTIME',
  /** video/webm */
  VIDEO_WEBM: 'VIDEO_WEBM',
  /** video/wmv */
  VIDEO_WMV: 'VIDEO_WMV'
} as const;

export type AiAgentSupportedMimeType = typeof AiAgentSupportedMimeType[keyof typeof AiAgentSupportedMimeType];
export type AiAuthor = {
  __typename?: 'AIAuthor';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type AiAutoReplyStoreSetting = {
  __typename?: 'AIAutoReplyStoreSetting';
  contextConfigId?: Maybe<Scalars['String']['output']>;
  hasAiFooter: Scalars['Boolean']['output'];
};

export type AiMessageFailedToSendEvent = {
  __typename?: 'AIMessageFailedToSendEvent';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type AccountAlreadyHaveConnection = {
  __typename?: 'AccountAlreadyHaveConnection';
  message: Scalars['String']['output'];
};

export type AccountCourierSettings = {
  __typename?: 'AccountCourierSettings';
  accountId: Scalars['ID']['output'];
  companyName: Scalars['String']['output'];
  country: Country;
  ready: AccountCourierSettingsStatus;
  updated?: Maybe<Scalars['Date']['output']>;
  websiteUrl: Scalars['String']['output'];
};

export const AccountCourierSettingsStatus = {
  NOT_READY: 'NOT_READY',
  READY: 'READY'
} as const;

export type AccountCourierSettingsStatus = typeof AccountCourierSettingsStatus[keyof typeof AccountCourierSettingsStatus];
export const Action = {
  INITIAL_ORDER_SYNC: 'INITIAL_ORDER_SYNC',
  INITIAL_SYNC: 'INITIAL_SYNC',
  LISTING_SYNC: 'LISTING_SYNC',
  ORDER_SYNC: 'ORDER_SYNC'
} as const;

export type Action = typeof Action[keyof typeof Action];
export type ActionLabelV2 = {
  __typename?: 'ActionLabelV2';
  action: LineCardButtonAction;
  label: Scalars['String']['output'];
};

export type ActionSettingBlock = {
  __typename?: 'ActionSettingBlock';
  actions: Array<WorkflowAction>;
  nextBlockId?: Maybe<Scalars['String']['output']>;
};

export type ActionSettingBlockInput = {
  actions: Array<WorkflowActionInput>;
  nextBlockId?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateAi = {
  __typename?: 'ActivateAI';
  isAuto: Scalars['Boolean']['output'];
};

/** The active (unfinished) session of a livestream room, including its compose preview videos. */
export type ActiveSessionOutput = {
  __typename?: 'ActiveSessionOutput';
  /** Compose progress from 0 to 100 reported by the worker; null until the first report. */
  composeProgress?: Maybe<Scalars['Int']['output']>;
  /** The product currently pinned on the live platform (see reportProductSwitched), as a 0-based POSITION in room product order (order_index ASC, id ASC) — NOT a livestream_room_product.id or an order_index value, which a delete can leave gaps in. Reported by the supervisor; null until it reports a position. */
  currentProductIdx?: Maybe<Scalars['Int']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  platformConfig?: Maybe<LivestreamSessionPlatformConfigOutput>;
  /** Sum of previewVideos durations in milliseconds; null until the preview is received. */
  previewTotalDurationMs?: Maybe<Scalars['Long']['output']>;
  /** Per-product lip-synced preview videos (compose output); empty until the preview is received. */
  previewVideos: Array<SessionPreviewVideoOutput>;
  scheduledEndTime?: Maybe<Scalars['DateTime']['output']>;
  /** When set, the session goes live by itself at this time (momo Auto Start): the room prepares itself 14 minutes before it and streams at it. Set automatically for a composed momo room connected to a live whose start is still more than 15 minutes away; null means no scheduled start. */
  scheduledStartTime?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  state: Scalars['String']['output'];
};

export type AdCampaignDetailedReportDimensionValuesPayload = {
  __typename?: 'AdCampaignDetailedReportDimensionValuesPayload';
  clicks: Scalars['BigDecimal']['output'];
  conversions: Scalars['BigDecimal']['output'];
  cost: Scalars['BigDecimal']['output'];
  cpa: Scalars['BigDecimal']['output'];
  cpc: Scalars['BigDecimal']['output'];
  cpm: Scalars['BigDecimal']['output'];
  ctr: Scalars['BigDecimal']['output'];
  cvr: Scalars['BigDecimal']['output'];
  day?: Maybe<Scalars['LocalDate']['output']>;
  impressions: Scalars['BigDecimal']['output'];
  month?: Maybe<Scalars['YearMonth']['output']>;
  roas: Scalars['BigDecimal']['output'];
  sales: Scalars['BigDecimal']['output'];
  week?: Maybe<Scalars['LocalDate']['output']>;
};

export type AdCampaignDetailedReportInput = {
  adPlatforms?: InputMaybe<Array<AdReportPlatform>>;
  dimension: AdReportDimension;
  endDate: Scalars['LocalDate']['input'];
  masterDataAccountId?: InputMaybe<Scalars['Long']['input']>;
  masterDataStoreIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pricesView: AdReportPricesView;
  startDate: Scalars['LocalDate']['input'];
};

export type AdCampaignDetailedReportPayload = {
  __typename?: 'AdCampaignDetailedReportPayload';
  budget?: Maybe<Scalars['BigDecimal']['output']>;
  budgetType?: Maybe<Scalars['String']['output']>;
  clicks: Scalars['BigDecimal']['output'];
  conversions: Scalars['BigDecimal']['output'];
  cost: Scalars['BigDecimal']['output'];
  cpa: Scalars['BigDecimal']['output'];
  cpc: Scalars['BigDecimal']['output'];
  cpm: Scalars['BigDecimal']['output'];
  ctr: Scalars['BigDecimal']['output'];
  currency: ReportSupportedCurrency;
  cvr: Scalars['BigDecimal']['output'];
  datasourceId: Scalars['Long']['output'];
  dimensionValues?: Maybe<Array<AdCampaignDetailedReportDimensionValuesPayload>>;
  id: Scalars['Long']['output'];
  impressions: Scalars['BigDecimal']['output'];
  masterDataStoreId: Scalars['Long']['output'];
  name?: Maybe<Scalars['String']['output']>;
  platform: AdReportPlatform;
  roas: Scalars['BigDecimal']['output'];
  sales: Scalars['BigDecimal']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AdCampaignDetailedReportPayloadList = {
  __typename?: 'AdCampaignDetailedReportPayloadList';
  items: Array<AdCampaignDetailedReportPayload>;
  meta: ReportListMeta;
};

export type AdChartInput = {
  adPlatforms?: InputMaybe<Array<AdReportPlatform>>;
  campaignId?: InputMaybe<Scalars['Long']['input']>;
  datasourceId?: InputMaybe<Scalars['Long']['input']>;
  dimension: AdReportDimension;
  endDate: Scalars['LocalDate']['input'];
  groupId?: InputMaybe<Scalars['Long']['input']>;
  masterDataAccountId?: InputMaybe<Scalars['Long']['input']>;
  masterDataStoreIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  pricesView: AdReportPricesView;
  startDate: Scalars['LocalDate']['input'];
};

export type AdChartPayload = {
  __typename?: 'AdChartPayload';
  clicks: Array<Scalars['Map']['output']>;
  conversions: Array<Scalars['Map']['output']>;
  cost: Array<Scalars['Map']['output']>;
  cpa: Array<Scalars['Map']['output']>;
  cpc: Array<Scalars['Map']['output']>;
  cpm: Array<Scalars['Map']['output']>;
  ctr: Array<Scalars['Map']['output']>;
  currency: ReportSupportedCurrency;
  cvr: Array<Scalars['Map']['output']>;
  impressions: Array<Scalars['Map']['output']>;
  roas: Array<Scalars['Map']['output']>;
  sales: Array<Scalars['Map']['output']>;
};

export type AdCostCampaignMappingInfoPayload = {
  __typename?: 'AdCostCampaignMappingInfoPayload';
  adsCostType: AdsCostType;
  campaignName: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  masterDataStoreId: Scalars['Long']['output'];
  products: Array<AdCostCampaignMappingProductInfoPayload>;
  saleChannelType: SaleChannelType;
};

export type AdCostCampaignMappingListFilterInput = {
  adCostCampaignMappingIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  adType?: InputMaybe<AdsCostType>;
  campaignKeyword?: InputMaybe<Scalars['String']['input']>;
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  saleChannelType: SaleChannelType;
};

export type AdCostCampaignMappingListInfoPayload = {
  __typename?: 'AdCostCampaignMappingListInfoPayload';
  adCostCampaignMappingGroupId: Scalars['Long']['output'];
  adsCostType: AdsCostType;
  campaignName: Scalars['String']['output'];
  numberOfProductVariants?: Maybe<Scalars['Int']['output']>;
};

export type AdCostCampaignMappingListPayload = {
  __typename?: 'AdCostCampaignMappingListPayload';
  items: Array<AdCostCampaignMappingListInfoPayload>;
  meta: ReportListMeta;
};

export type AdCostCampaignMappingProductInfoPayload = {
  __typename?: 'AdCostCampaignMappingProductInfoPayload';
  media?: Maybe<Scalars['String']['output']>;
  productCode: Scalars['String']['output'];
  productId: Scalars['Long']['output'];
  productName: Scalars['String']['output'];
  productVariantId: Scalars['Long']['output'];
  productVariantName: Scalars['String']['output'];
  saleChannels?: Maybe<Array<ListingInfoPayload>>;
};

export type AdCostCampaignMappingSaveInput = {
  adCostCampaignMappingIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  masterDataStoreId: Scalars['Long']['input'];
  productVariantIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type AdCostCampaignMappingSavePayload = {
  __typename?: 'AdCostCampaignMappingSavePayload';
  ok: Scalars['Boolean']['output'];
};

export type AdDetailedListMeta = {
  __typename?: 'AdDetailedListMeta';
  length: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  types: Array<Scalars['String']['output']>;
};

export type AdDetailedReportDimensionValuesPayload = {
  __typename?: 'AdDetailedReportDimensionValuesPayload';
  clicks: Scalars['BigDecimal']['output'];
  conversions: Scalars['BigDecimal']['output'];
  cost: Scalars['BigDecimal']['output'];
  cpa: Scalars['BigDecimal']['output'];
  cpc: Scalars['BigDecimal']['output'];
  cpm: Scalars['BigDecimal']['output'];
  ctr: Scalars['BigDecimal']['output'];
  cvr: Scalars['BigDecimal']['output'];
  day?: Maybe<Scalars['LocalDate']['output']>;
  impressions: Scalars['BigDecimal']['output'];
  month?: Maybe<Scalars['YearMonth']['output']>;
  roas: Scalars['BigDecimal']['output'];
  sales: Scalars['BigDecimal']['output'];
  week?: Maybe<Scalars['LocalDate']['output']>;
};

export type AdDetailedReportInput = {
  adTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  campaignId: Scalars['Long']['input'];
  datasourceId: Scalars['Long']['input'];
  dimension: AdReportDimension;
  endDate: Scalars['LocalDate']['input'];
  groupId: Scalars['Long']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pricesView: AdReportPricesView;
  startDate: Scalars['LocalDate']['input'];
};

export type AdDetailedReportPayload = {
  __typename?: 'AdDetailedReportPayload';
  adGroupId: Scalars['Long']['output'];
  clicks: Scalars['BigDecimal']['output'];
  conversions: Scalars['BigDecimal']['output'];
  cost: Scalars['BigDecimal']['output'];
  cpa: Scalars['BigDecimal']['output'];
  cpc: Scalars['BigDecimal']['output'];
  cpm: Scalars['BigDecimal']['output'];
  ctr: Scalars['BigDecimal']['output'];
  currency: ReportSupportedCurrency;
  cvr: Scalars['BigDecimal']['output'];
  datasourceId: Scalars['Long']['output'];
  dimensionValues?: Maybe<Array<AdDetailedReportDimensionValuesPayload>>;
  id: Scalars['Long']['output'];
  impressions: Scalars['BigDecimal']['output'];
  name?: Maybe<Scalars['String']['output']>;
  roas: Scalars['BigDecimal']['output'];
  sales: Scalars['BigDecimal']['output'];
  status?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AdDetailedReportPayloadList = {
  __typename?: 'AdDetailedReportPayloadList';
  items: Array<AdDetailedReportPayload>;
  meta: AdDetailedListMeta;
};

export type AdGroupDetailedReportDimensionValuesPayload = {
  __typename?: 'AdGroupDetailedReportDimensionValuesPayload';
  clicks: Scalars['BigDecimal']['output'];
  conversions: Scalars['BigDecimal']['output'];
  cost: Scalars['BigDecimal']['output'];
  cpa: Scalars['BigDecimal']['output'];
  cpc: Scalars['BigDecimal']['output'];
  cpm: Scalars['BigDecimal']['output'];
  ctr: Scalars['BigDecimal']['output'];
  cvr: Scalars['BigDecimal']['output'];
  day?: Maybe<Scalars['LocalDate']['output']>;
  impressions: Scalars['BigDecimal']['output'];
  month?: Maybe<Scalars['YearMonth']['output']>;
  roas: Scalars['BigDecimal']['output'];
  sales: Scalars['BigDecimal']['output'];
  week?: Maybe<Scalars['LocalDate']['output']>;
};

export type AdGroupDetailedReportInput = {
  campaignId: Scalars['Long']['input'];
  datasourceId: Scalars['Long']['input'];
  dimension: AdReportDimension;
  endDate: Scalars['LocalDate']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pricesView: AdReportPricesView;
  startDate: Scalars['LocalDate']['input'];
};

export type AdGroupDetailedReportPayload = {
  __typename?: 'AdGroupDetailedReportPayload';
  budget?: Maybe<Scalars['BigDecimal']['output']>;
  budgetType?: Maybe<Scalars['String']['output']>;
  clicks: Scalars['BigDecimal']['output'];
  conversions: Scalars['BigDecimal']['output'];
  cost: Scalars['BigDecimal']['output'];
  cpa: Scalars['BigDecimal']['output'];
  cpc: Scalars['BigDecimal']['output'];
  cpm: Scalars['BigDecimal']['output'];
  ctr: Scalars['BigDecimal']['output'];
  currency: ReportSupportedCurrency;
  cvr: Scalars['BigDecimal']['output'];
  datasourceId: Scalars['Long']['output'];
  dimensionValues?: Maybe<Array<AdGroupDetailedReportDimensionValuesPayload>>;
  id: Scalars['Long']['output'];
  impressions: Scalars['BigDecimal']['output'];
  name?: Maybe<Scalars['String']['output']>;
  roas: Scalars['BigDecimal']['output'];
  sales: Scalars['BigDecimal']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AdGroupDetailedReportPayloadList = {
  __typename?: 'AdGroupDetailedReportPayloadList';
  items: Array<AdGroupDetailedReportPayload>;
  meta: ReportListMeta;
};

export type AdOverviewReportInput = {
  adPlatforms?: InputMaybe<Array<AdReportPlatform>>;
  dimension: AdReportDimension;
  endDate: Scalars['LocalDate']['input'];
  masterDataAccountId?: InputMaybe<Scalars['Long']['input']>;
  masterDataStoreIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pricesView: AdReportPricesView;
  startDate: Scalars['LocalDate']['input'];
};

export type AdOverviewReportPayload = {
  __typename?: 'AdOverviewReportPayload';
  clicks: Scalars['BigDecimal']['output'];
  conversions: Scalars['BigDecimal']['output'];
  cost: Scalars['BigDecimal']['output'];
  cpa: Scalars['BigDecimal']['output'];
  cpc: Scalars['BigDecimal']['output'];
  cpm: Scalars['BigDecimal']['output'];
  ctr: Scalars['BigDecimal']['output'];
  currency: ReportSupportedCurrency;
  cvr: Scalars['BigDecimal']['output'];
  day?: Maybe<Scalars['LocalDate']['output']>;
  impressions: Scalars['BigDecimal']['output'];
  month?: Maybe<Scalars['YearMonth']['output']>;
  roas: Scalars['BigDecimal']['output'];
  sales: Scalars['BigDecimal']['output'];
  week?: Maybe<Scalars['LocalDate']['output']>;
};

export type AdOverviewReportPayloadList = {
  __typename?: 'AdOverviewReportPayloadList';
  items: Array<AdOverviewReportPayload>;
  meta: ReportListMeta;
};

export const AdReportDimension = {
  DAY: 'DAY',
  MONTH: 'MONTH',
  NONE: 'NONE',
  WEEK: 'WEEK'
} as const;

export type AdReportDimension = typeof AdReportDimension[keyof typeof AdReportDimension];
export const AdReportPlatform = {
  FACEBOOK: 'FACEBOOK',
  GOOGLE: 'GOOGLE',
  TIKTOK: 'TIKTOK',
  YAHOO_DISPLAY: 'YAHOO_DISPLAY',
  YAHOO_SEARCH: 'YAHOO_SEARCH'
} as const;

export type AdReportPlatform = typeof AdReportPlatform[keyof typeof AdReportPlatform];
export const AdReportPricesView = {
  GROSS: 'GROSS',
  NET: 'NET'
} as const;

export type AdReportPricesView = typeof AdReportPricesView[keyof typeof AdReportPricesView];
export const AdSetCampaignStatus = {
  FACEBOOKADS_ACTIVE: 'FACEBOOKADS_ACTIVE',
  FACEBOOKADS_ADS_OFF_OR_AD_SET_OFF: 'FACEBOOKADS_ADS_OFF_OR_AD_SET_OFF',
  FACEBOOKADS_ARCHIVED: 'FACEBOOKADS_ARCHIVED',
  FACEBOOKADS_COMPLETED: 'FACEBOOKADS_COMPLETED',
  FACEBOOKADS_IN_REVIEW: 'FACEBOOKADS_IN_REVIEW',
  FACEBOOKADS_LEARNING: 'FACEBOOKADS_LEARNING',
  FACEBOOKADS_LEARNING_LIMITED: 'FACEBOOKADS_LEARNING_LIMITED',
  FACEBOOKADS_NO_ADS: 'FACEBOOKADS_NO_ADS',
  FACEBOOKADS_PROCESSING: 'FACEBOOKADS_PROCESSING',
  FACEBOOKADS_REJECTED: 'FACEBOOKADS_REJECTED',
  FACEBOOKADS_SCHEDULED: 'FACEBOOKADS_SCHEDULED',
  GOOGLEADS_ELIGIBLE: 'GOOGLEADS_ELIGIBLE',
  GOOGLEADS_ELIGIBLE_LIMITED: 'GOOGLEADS_ELIGIBLE_LIMITED',
  GOOGLEADS_ENDED: 'GOOGLEADS_ENDED',
  GOOGLEADS_NOT_ELIGIBLE: 'GOOGLEADS_NOT_ELIGIBLE',
  GOOGLEADS_PAUSED: 'GOOGLEADS_PAUSED',
  GOOGLEADS_PENDING: 'GOOGLEADS_PENDING',
  GOOGLEADS_REMOVED: 'GOOGLEADS_REMOVED',
  TIKTOKADS_ACTIVE: 'TIKTOKADS_ACTIVE',
  TIKTOKADS_CLOSED: 'TIKTOKADS_CLOSED',
  TIKTOKADS_COMPLETED: 'TIKTOKADS_COMPLETED',
  TIKTOKADS_DELETED: 'TIKTOKADS_DELETED',
  TIKTOKADS_INACTIVE: 'TIKTOKADS_INACTIVE',
  TIKTOKADS_NOT_DELIVERING: 'TIKTOKADS_NOT_DELIVERING',
  YAHOODISPLAYADS_ENDED: 'YAHOODISPLAYADS_ENDED',
  YAHOODISPLAYADS_PENDING: 'YAHOODISPLAYADS_PENDING',
  YAHOODISPLAYADS_SERVING: 'YAHOODISPLAYADS_SERVING',
  YAHOODISPLAYADS_STOP: 'YAHOODISPLAYADS_STOP',
  YAHOODISPLAYADS_UNKNOWN: 'YAHOODISPLAYADS_UNKNOWN',
  YAHOOSEARCHADS_ENDED: 'YAHOOSEARCHADS_ENDED',
  YAHOOSEARCHADS_PENDING: 'YAHOOSEARCHADS_PENDING',
  YAHOOSEARCHADS_SERVING: 'YAHOOSEARCHADS_SERVING',
  YAHOOSEARCHADS_STOP: 'YAHOOSEARCHADS_STOP',
  YAHOOSEARCHADS_UNKNOWN: 'YAHOOSEARCHADS_UNKNOWN'
} as const;

export type AdSetCampaignStatus = typeof AdSetCampaignStatus[keyof typeof AdSetCampaignStatus];
export const AdSetGroupStatus = {
  FACEBOOKADS_ACTIVE: 'FACEBOOKADS_ACTIVE',
  FACEBOOKADS_ADS_OFF_OR_AD_SET_OFF: 'FACEBOOKADS_ADS_OFF_OR_AD_SET_OFF',
  FACEBOOKADS_ARCHIVED: 'FACEBOOKADS_ARCHIVED',
  FACEBOOKADS_COMPLETED: 'FACEBOOKADS_COMPLETED',
  FACEBOOKADS_IN_REVIEW: 'FACEBOOKADS_IN_REVIEW',
  FACEBOOKADS_LEARNING: 'FACEBOOKADS_LEARNING',
  FACEBOOKADS_LEARNING_LIMITED: 'FACEBOOKADS_LEARNING_LIMITED',
  FACEBOOKADS_NO_ADS: 'FACEBOOKADS_NO_ADS',
  FACEBOOKADS_PROCESSING: 'FACEBOOKADS_PROCESSING',
  FACEBOOKADS_REJECTED: 'FACEBOOKADS_REJECTED',
  FACEBOOKADS_SCHEDULED: 'FACEBOOKADS_SCHEDULED',
  GOOGLEADS_ELIGIBLE: 'GOOGLEADS_ELIGIBLE',
  GOOGLEADS_INCOMPLETE: 'GOOGLEADS_INCOMPLETE',
  GOOGLEADS_NOT_ELIGIBLE: 'GOOGLEADS_NOT_ELIGIBLE',
  GOOGLEADS_PAUSED: 'GOOGLEADS_PAUSED',
  GOOGLEADS_REMOVED: 'GOOGLEADS_REMOVED',
  TIKTOKADS_ACTIVE: 'TIKTOKADS_ACTIVE',
  TIKTOKADS_CLOSED: 'TIKTOKADS_CLOSED',
  TIKTOKADS_COMPLETED: 'TIKTOKADS_COMPLETED',
  TIKTOKADS_DELETED: 'TIKTOKADS_DELETED',
  TIKTOKADS_INACTIVE: 'TIKTOKADS_INACTIVE',
  TIKTOKADS_NOT_DELIVERING: 'TIKTOKADS_NOT_DELIVERING'
} as const;

export type AdSetGroupStatus = typeof AdSetGroupStatus[keyof typeof AdSetGroupStatus];
export type AdSetMappingCampaignListFilterInput = {
  campaignKeyword?: InputMaybe<Scalars['String']['input']>;
  datasourceId: Scalars['Long']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<AdSetCampaignStatus>;
  statusRaw?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdSetMappingCampaignPayload = {
  __typename?: 'AdSetMappingCampaignPayload';
  adSetMappingCampaignId: Scalars['Long']['output'];
  campaignId: Scalars['Long']['output'];
  campaignName: Scalars['String']['output'];
  campaignStatus?: Maybe<AdSetCampaignStatus>;
  marginPercentage: Scalars['BigDecimal']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type AdSetMappingCampaignsListPayload = {
  __typename?: 'AdSetMappingCampaignsListPayload';
  items: Array<AdSetMappingCampaignPayload>;
  meta: ReportListMeta;
};

export type AdSetMappingGroupInfoPayload = {
  __typename?: 'AdSetMappingGroupInfoPayload';
  adGroupId: Scalars['Long']['output'];
  adGroupName: Scalars['String']['output'];
  campaignId: Scalars['Long']['output'];
  campaignName: Scalars['String']['output'];
  products: Array<ProductAdSetMappingInfoPayload>;
  saleChannels: Array<Scalars['String']['output']>;
};

export type AdSetMappingGroupListFilterInput = {
  adGroupKeyword?: InputMaybe<Scalars['String']['input']>;
  adSetMappingCampaignId?: InputMaybe<Scalars['Long']['input']>;
  adSetMappingGroupIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  campaignId?: InputMaybe<Scalars['Long']['input']>;
  datasourceId?: InputMaybe<Scalars['Long']['input']>;
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<AdSetGroupStatus>;
  statusRaw?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdSetMappingGroupListInfoPayload = {
  __typename?: 'AdSetMappingGroupListInfoPayload';
  adGroupId: Scalars['Long']['output'];
  adGroupName: Scalars['String']['output'];
  adGroupStatus?: Maybe<AdSetGroupStatus>;
  adSetMappingGroupId: Scalars['Long']['output'];
  numberOfProductVariants: Scalars['Int']['output'];
  numberOfSaleChannels: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type AdSetMappingGroupListPayload = {
  __typename?: 'AdSetMappingGroupListPayload';
  items: Array<AdSetMappingGroupListInfoPayload>;
  meta: ReportListMeta;
};

export type AdSetMappingGroupProductPayload = {
  __typename?: 'AdSetMappingGroupProductPayload';
  media?: Maybe<Scalars['String']['output']>;
  productCode: Scalars['String']['output'];
  productId: Scalars['Long']['output'];
  productName: Scalars['String']['output'];
  productVariantId: Scalars['Long']['output'];
  productVariantName: Scalars['String']['output'];
  saleChannels?: Maybe<Array<ListingInfo>>;
};

export type AdSetMappingGroupProductsListPayload = {
  __typename?: 'AdSetMappingGroupProductsListPayload';
  items: Array<AdSetMappingGroupProductPayload>;
  meta: ReportListMeta;
};

export type AdSetMappingProductListFilterInput = {
  channels?: InputMaybe<Array<SaleChannelType>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type AdSetMappingSaveInput = {
  adSetMappingGroupIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  campaignMappingId: Scalars['Long']['input'];
  datasourceId?: InputMaybe<Scalars['Long']['input']>;
  masterDataStoreId: Scalars['Long']['input'];
  productVariantIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  saleChannels: Array<SaleChannelType>;
};

export type AdSetMappingSavePayload = {
  __typename?: 'AdSetMappingSavePayload';
  ok: Scalars['Boolean']['output'];
};

export type AdSetMappingSetMarginInput = {
  settings: Array<MarginSettingInput>;
};

export type AdSetMappingSetMarginPayload = {
  __typename?: 'AdSetMappingSetMarginPayload';
  ok: Scalars['Boolean']['output'];
};

export type AdSummaryInput = {
  adPlatforms?: InputMaybe<Array<AdReportPlatform>>;
  campaignId?: InputMaybe<Scalars['Long']['input']>;
  datasourceId?: InputMaybe<Scalars['Long']['input']>;
  endDate: Scalars['LocalDate']['input'];
  groupId?: InputMaybe<Scalars['Long']['input']>;
  masterDataAccountId?: InputMaybe<Scalars['Long']['input']>;
  masterDataStoreIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  pricesView: AdReportPricesView;
  startDate: Scalars['LocalDate']['input'];
};

export type AdSummaryPayload = {
  __typename?: 'AdSummaryPayload';
  clicks: NumericValueWithDiffPayload;
  conversions: NumericValueWithDiffPayload;
  cost: NumericValueWithDiffPayload;
  cpa: NumericValueWithDiffPayload;
  currency: ReportSupportedCurrency;
  impressions: NumericValueWithDiffPayload;
  roas: NumericValueWithDiffPayload;
  sales: NumericValueWithDiffPayload;
};

export type AddAutomationFlowRequest = {
  eventType: AutomationFlowEventType;
  name: Scalars['String']['input'];
  replyContents: Array<AutomationFlowContentInput>;
  sendWhen: LiveCommentAutoReplyTiming;
  storeId: Scalars['Long']['input'];
  trigger: AutomationFlowTriggerInput;
};

export type AddCustomerTagRequest = {
  customerTagNames: Array<Scalars['String']['input']>;
  storeId: Scalars['Long']['input'];
};

export type AddUserToAssigneeList = {
  __typename?: 'AddUserToAssigneeList';
  user: BasicUser;
};

export type Address = {
  __typename?: 'Address';
  addressFirst: Scalars['String']['output'];
  addressSecond: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Country;
  postalCode: Scalars['String']['output'];
  provinceId: Scalars['String']['output'];
};

export type AdsCostByCampaignCsvPayload = {
  __typename?: 'AdsCostByCampaignCSVPayload';
  campaignName: Scalars['String']['output'];
  clicks: Scalars['Long']['output'];
  cpc: Scalars['BigDecimal']['output'];
  cpcCurrency: ReportSupportedCurrency;
  ctr: Scalars['BigDecimal']['output'];
  date: Scalars['LocalDate']['output'];
  impressions: Scalars['Long']['output'];
  numberOfOrders: Scalars['Long']['output'];
  roas: Scalars['BigDecimal']['output'];
  spend: Scalars['BigDecimal']['output'];
  spendCurrency: ReportSupportedCurrency;
  totalSales: Scalars['BigDecimal']['output'];
  totalSalesCurrency: ReportSupportedCurrency;
};

export type AdsCostByCampaignCsvPayloadList = {
  __typename?: 'AdsCostByCampaignCSVPayloadList';
  items: Array<AdsCostByCampaignCsvPayload>;
  meta: ReportListMeta;
};

export type AdsCostCsvFilterInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  saleChannelId?: InputMaybe<Scalars['Long']['input']>;
  startDate: Scalars['ZonedDatetime']['input'];
  type?: InputMaybe<AdsCostType>;
};

export type AdsCostRangePerProductDailyCsvFilterInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  productVariantId?: InputMaybe<Scalars['Long']['input']>;
  saleChannelId?: InputMaybe<Scalars['Long']['input']>;
  startDate: Scalars['ZonedDatetime']['input'];
  type?: InputMaybe<AdsCostType>;
};

export type AdsCostRangePerProductDailyCsvPayload = {
  __typename?: 'AdsCostRangePerProductDailyCSVPayload';
  clicks: Scalars['BigDecimal']['output'];
  conversions: Scalars['BigDecimal']['output'];
  ctr: Scalars['BigDecimal']['output'];
  date: Scalars['LocalDate']['output'];
  expense: Scalars['BigDecimal']['output'];
  expenseCurrency: ReportSupportedCurrency;
  externalId: Scalars['String']['output'];
  gmv: Scalars['BigDecimal']['output'];
  gmvCurrency: ReportSupportedCurrency;
  impressions: Scalars['BigDecimal']['output'];
  masterDataStoreId: Scalars['Long']['output'];
  productName: Scalars['String']['output'];
  productVariantId: Scalars['Long']['output'];
  roi: Scalars['BigDecimal']['output'];
  roiCurrency: ReportSupportedCurrency;
  saleChannelMarketplace: Scalars['String']['output'];
  saleChannelType: SaleChannelType;
  sourceUrl: Scalars['String']['output'];
  spend: Scalars['BigDecimal']['output'];
  spendCurrency: ReportSupportedCurrency;
  totalSales: Scalars['BigDecimal']['output'];
  totalSalesCurrency: ReportSupportedCurrency;
};

export type AdsCostRangePerProductDailyCsvPayloadList = {
  __typename?: 'AdsCostRangePerProductDailyCSVPayloadList';
  items: Array<AdsCostRangePerProductDailyCsvPayload>;
  meta: ReportListMeta;
};

export type AdsCostRangeProductLevelDailyCsvFilterInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  productId?: InputMaybe<Scalars['Long']['input']>;
  saleChannelId?: InputMaybe<Scalars['Long']['input']>;
  startDate: Scalars['ZonedDatetime']['input'];
  type?: InputMaybe<AdsCostType>;
};

export type AdsCostRangeProductLevelDailyCsvPayload = {
  __typename?: 'AdsCostRangeProductLevelDailyCSVPayload';
  clicks: Scalars['BigDecimal']['output'];
  ctr: Scalars['BigDecimal']['output'];
  date: Scalars['LocalDate']['output'];
  impressions: Scalars['BigDecimal']['output'];
  masterDataStoreId: Scalars['Long']['output'];
  productId: Scalars['Long']['output'];
  productName: Scalars['String']['output'];
  roi?: Maybe<Scalars['BigDecimal']['output']>;
  roiCurrency?: Maybe<ReportSupportedCurrency>;
  saleChannelMarketplace: Scalars['String']['output'];
  saleChannelType: SaleChannelType;
  sourceUrl: Scalars['String']['output'];
  spend: Scalars['BigDecimal']['output'];
  spendCurrency: ReportSupportedCurrency;
  totalSales: Scalars['BigDecimal']['output'];
  totalSalesCurrency: ReportSupportedCurrency;
};

export type AdsCostRangeProductLevelDailyCsvPayloadList = {
  __typename?: 'AdsCostRangeProductLevelDailyCSVPayloadList';
  items: Array<AdsCostRangeProductLevelDailyCsvPayload>;
  lastUpdated?: Maybe<Scalars['ZonedDatetime']['output']>;
  meta: ReportListMeta;
};

export const AdsCostType = {
  AMAZON_SPONSOR_BRAND: 'AMAZON_SPONSOR_BRAND',
  AMAZON_SPONSOR_DISPLAY: 'AMAZON_SPONSOR_DISPLAY',
  AMAZON_SPONSOR_PRODUCT: 'AMAZON_SPONSOR_PRODUCT',
  LAZADA_SPONSOR_DISCOVERY: 'LAZADA_SPONSOR_DISCOVERY',
  RAKUTEN_COUPON_ADVANCED: 'RAKUTEN_COUPON_ADVANCED',
  RAKUTEN_RPP: 'RAKUTEN_RPP',
  SHOPEE_ADS: 'SHOPEE_ADS',
  TOKOPEDIA_ADS: 'TOKOPEDIA_ADS',
  UNKNOWN: 'UNKNOWN',
  YAHOO_ITEM_MATCH_AD: 'YAHOO_ITEM_MATCH_AD',
  ZOZOTOWN_ADS: 'ZOZOTOWN_ADS'
} as const;

export type AdsCostType = typeof AdsCostType[keyof typeof AdsCostType];
export type AdsCostZozotownCsvPayload = {
  __typename?: 'AdsCostZozotownCSVPayload';
  clicks: Scalars['Long']['output'];
  cpc: Scalars['BigDecimal']['output'];
  cpcCurrency: ReportSupportedCurrency;
  ctr: Scalars['BigDecimal']['output'];
  date: Scalars['LocalDate']['output'];
  displayLocation: Scalars['String']['output'];
  impressions: Scalars['Long']['output'];
  numberOfOrders: Scalars['Long']['output'];
  productId: Scalars['Long']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  productVariantId: Scalars['Long']['output'];
  roas: Scalars['BigDecimal']['output'];
  spend: Scalars['BigDecimal']['output'];
  spendCurrency: ReportSupportedCurrency;
  totalSales: Scalars['BigDecimal']['output'];
  totalSalesCurrency: ReportSupportedCurrency;
};

export type AdsCostZozotownCsvPayloadList = {
  __typename?: 'AdsCostZozotownCSVPayloadList';
  items: Array<AdsCostZozotownCsvPayload>;
  meta: ReportListMeta;
};

export type AdsMappingProductListFilterInput = {
  channels?: InputMaybe<Array<SaleChannelType>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type AdsMappingProductPayload = {
  __typename?: 'AdsMappingProductPayload';
  media?: Maybe<Scalars['String']['output']>;
  productCode: Scalars['String']['output'];
  productId: Scalars['Long']['output'];
  productName: Scalars['String']['output'];
  productVariantId: Scalars['Long']['output'];
  productVariantName: Scalars['String']['output'];
  saleChannels?: Maybe<Array<ListingInfo>>;
};

export type AdsMappingProductsListPayload = {
  __typename?: 'AdsMappingProductsListPayload';
  items: Array<AdsMappingProductPayload>;
  meta: ReportListMeta;
};

export const AdsMetricsType = {
  GROSS: 'GROSS',
  NET: 'NET'
} as const;

export type AdsMetricsType = typeof AdsMetricsType[keyof typeof AdsMetricsType];
export type All = {
  __typename?: 'All';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type AmazonSaleChannelData = {
  __typename?: 'AmazonSaleChannelData';
  marketplace: AmazonSellerCentralMarketplace;
};

export type AmazonSalesChartInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type AmazonSalesChartPayload = {
  __typename?: 'AmazonSalesChartPayload';
  averageNumberOfUnitsPerOrderItem: Array<Scalars['Map']['output']>;
  currency: ReportSupportedCurrency;
  itemAverageCost: Array<Scalars['Map']['output']>;
  itemsOrdered: Array<Scalars['Map']['output']>;
  sales: Array<Scalars['Map']['output']>;
  unitAverageCost: Array<Scalars['Map']['output']>;
  unitsOrdered: Array<Scalars['Map']['output']>;
};

export type AmazonSalesDetailedReportInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type AmazonSalesDetailedReportPayload = {
  __typename?: 'AmazonSalesDetailedReportPayload';
  averageNumberOfUnitsPerOrderItem: Scalars['BigDecimal']['output'];
  currency: ReportSupportedCurrency;
  date: Scalars['LocalDate']['output'];
  itemAverageCost: Scalars['BigDecimal']['output'];
  itemsOrdered: Scalars['Long']['output'];
  sales: Scalars['BigDecimal']['output'];
  unitAverageCost: Scalars['BigDecimal']['output'];
  unitsOrdered: Scalars['Long']['output'];
};

export type AmazonSalesDetailedReportPayloadList = {
  __typename?: 'AmazonSalesDetailedReportPayloadList';
  items: Array<AmazonSalesDetailedReportPayload>;
  meta: ReportListMeta;
  total: AmazonSalesDetailedReportTotalPayload;
};

export type AmazonSalesDetailedReportTotalPayload = {
  __typename?: 'AmazonSalesDetailedReportTotalPayload';
  averageNumberOfUnitsPerOrderItem: Scalars['BigDecimal']['output'];
  currency: ReportSupportedCurrency;
  itemAverageCost: Scalars['BigDecimal']['output'];
  itemsOrdered: Scalars['Long']['output'];
  sales: Scalars['BigDecimal']['output'];
  unitAverageCost: Scalars['BigDecimal']['output'];
  unitsOrdered: Scalars['Long']['output'];
};

export type AmazonSalesSummaryInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type AmazonSalesSummaryPayload = {
  __typename?: 'AmazonSalesSummaryPayload';
  averageNumberOfUnitsPerOrderItem: NumericValueWithDiffPayload;
  currency: ReportSupportedCurrency;
  itemAverageCost: NumericValueWithDiffPayload;
  itemsOrdered: NumericValueWithDiffPayload;
  sales: NumericValueWithDiffPayload;
  unitAverageCost: NumericValueWithDiffPayload;
  unitsOrdered: NumericValueWithDiffPayload;
};

export type AmazonSellerCentralFileUploadInput = {
  /** start from gs://~~~ */
  fileUri: Scalars['String']['input'];
  saleChannelId: Scalars['Long']['input'];
  type: AmazonSellerCentralFileUploadType;
};

export const AmazonSellerCentralFileUploadType = {
  AD_COST_SPONSOR_BRAND: 'AD_COST_SPONSOR_BRAND',
  AD_COST_SPONSOR_DISPLAY: 'AD_COST_SPONSOR_DISPLAY',
  AD_COST_SPONSOR_PRODUCT: 'AD_COST_SPONSOR_PRODUCT',
  SESSION: 'SESSION'
} as const;

export type AmazonSellerCentralFileUploadType = typeof AmazonSellerCentralFileUploadType[keyof typeof AmazonSellerCentralFileUploadType];
export type AmazonSellerCentralLoginUrlV2Input = {
  marketplace: AmazonSellerCentralMarketplace;
  redirectUri: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export const AmazonSellerCentralMarketplace = {
  AE: 'AE',
  CA: 'CA',
  DE: 'DE',
  ES: 'ES',
  FR: 'FR',
  IN: 'IN',
  IT: 'IT',
  JP: 'JP',
  NL: 'NL',
  SA: 'SA',
  SG: 'SG',
  UK: 'UK',
  US: 'US'
} as const;

export type AmazonSellerCentralMarketplace = typeof AmazonSellerCentralMarketplace[keyof typeof AmazonSellerCentralMarketplace];
export type AnimatedSticker = {
  __typename?: 'AnimatedSticker';
  url: Scalars['String']['output'];
};

export type AnyChatCustomerProfile = {
  __typename?: 'AnyChatCustomerProfile';
  address?: Maybe<CustomerAddress>;
  age?: Maybe<Scalars['Int']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  height?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type AnyChatGetStoreRequest = {
  id: Scalars['Long']['input'];
};

export type AnyChatMoney = {
  __typename?: 'AnyChatMoney';
  amount: Scalars['BigDecimal']['output'];
  currencyCode: Scalars['String']['output'];
};

export type AnyChatOkResponse = {
  __typename?: 'AnyChatOKResponse';
  ok: Scalars['Boolean']['output'];
};

export type AnyChatSaleChannelCustomer = {
  __typename?: 'AnyChatSaleChannelCustomer';
  channelType: AnyChatSaleChannelType;
  createdAt: Scalars['UnixTimestamp']['output'];
  customerProfile?: Maybe<AnyChatCustomerProfile>;
  externalCustomerId: Scalars['String']['output'];
};

export const AnyChatSaleChannelType = {
  LAZADA: 'LAZADA',
  SHOPEE: 'SHOPEE',
  SHOPIFY: 'SHOPIFY'
} as const;

export type AnyChatSaleChannelType = typeof AnyChatSaleChannelType[keyof typeof AnyChatSaleChannelType];
export type AnyChatStore = {
  __typename?: 'AnyChatStore';
  accountId: Scalars['String']['output'];
  chatCount: OngoingCount;
  chats: Array<StoreChat>;
  crmType: CrmType;
  draftReplyEnabled: Scalars['Boolean']['output'];
  /** @deprecated Prompt is now hardcoded in the service */
  draftReplyPrompt?: Maybe<Scalars['String']['output']>;
  hasSlackNotifications: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  isCrmEnabled: Scalars['Boolean']['output'];
  isCrmMerchantEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  saleChannels: Array<StoreSaleChannel>;
  slackChannelId?: Maybe<Scalars['String']['output']>;
  unrepliedLineNotificationEnabled: Scalars['Boolean']['output'];
  unrepliedLineNotificationSlackChannelId?: Maybe<Scalars['String']['output']>;
};

export type AnyChatStoreCrmConfigUpdateRequest = {
  crmType: CrmType;
  draftReplyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  slackChannelId?: InputMaybe<Scalars['String']['input']>;
  storeId: Scalars['Long']['input'];
  unrepliedLineNotificationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  unrepliedLineNotificationSlackChannelId?: InputMaybe<Scalars['String']['input']>;
};

export type AnyContent = {
  __typename?: 'AnyContent';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

/** A public closing script template, spoken verbatim immediately before a stream ends. */
export type AnyLiveClosingScript = {
  __typename?: 'AnyLiveClosingScript';
  active: Scalars['Boolean']['output'];
  closingContent: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  language: TtsAudioLanguage;
  latestRevisionCreatedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  /** The previous revision's id; null when there is only one revision. */
  previousRevisionId?: Maybe<Scalars['ID']['output']>;
  /** The current revision's number (increments per content edit). */
  revisionNumber: Scalars['Int']['output'];
  store?: Maybe<MdStore>;
  storeId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Create input for a closing script. */
export type AnyLiveClosingScriptCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  closingContent: Scalars['String']['input'];
  language: TtsAudioLanguage;
  name: Scalars['String']['input'];
  storeId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter input for closing scripts. */
export type AnyLiveClosingScriptFilterInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<TtsAudioLanguage>;
  search?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
};

/** Paginated list of closing scripts. */
export type AnyLiveClosingScriptList = PaginatedList & {
  __typename?: 'AnyLiveClosingScriptList';
  items: Array<AnyLiveClosingScript>;
  totalCount: Scalars['Int']['output'];
};

/** An immutable revision of a closing script. Revisions are append-only. */
export type AnyLiveClosingScriptRevision = {
  __typename?: 'AnyLiveClosingScriptRevision';
  closingContent: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Audit: the user id that created this revision; null when unset. */
  createdBy?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  language: TtsAudioLanguage;
  name: Scalars['String']['output'];
  /** The previous revision's id; null for the first revision. */
  previousRevisionId?: Maybe<Scalars['ID']['output']>;
  /** Revision number; 1 is the first revision, increments per edit. */
  revisionNumber: Scalars['Int']['output'];
  /** The logical entry id this revision belongs to. */
  templateId: Scalars['ID']['output'];
};

/** Update input for a closing script. */
export type AnyLiveClosingScriptUpdateInput = {
  closingContent?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<TtsAudioLanguage>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Create input for a fallback template. */
export type AnyLiveCreateFallbackTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  language: TtsAudioLanguage;
  name: Scalars['String']['input'];
  storeId?: InputMaybe<Scalars['ID']['input']>;
};

/** Create input for a sensitive word. Always no-reply-only -- a match silences the comment. */
export type AnyLiveCreateSensitiveWordInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  term: Scalars['String']['input'];
};

export const AnyLiveErrorCode = {
  ALREADY_EXISTS: 'ALREADY_EXISTS',
  AVATAR_TRAINING_ERROR: 'AVATAR_TRAINING_ERROR',
  BYTEPLUS_API_ERROR: 'BYTEPLUS_API_ERROR',
  BYTEPLUS_AUTH_FAILED: 'BYTEPLUS_AUTH_FAILED',
  BYTEPLUS_CREDENTIAL_NOT_FOUND: 'BYTEPLUS_CREDENTIAL_NOT_FOUND',
  BYTEPLUS_EVENT_ID_REQUIRED: 'BYTEPLUS_EVENT_ID_REQUIRED',
  BYTEPLUS_EVENT_NOT_SELECTED: 'BYTEPLUS_EVENT_NOT_SELECTED',
  BYTEPLUS_EXPLAIN_PRODUCT_FAILED: 'BYTEPLUS_EXPLAIN_PRODUCT_FAILED',
  COMMENT_REPLY_RECORD_FEEDBACK_INVALID: 'COMMENT_REPLY_RECORD_FEEDBACK_INVALID',
  COMMENT_REPLY_RECORD_NOT_FOUND: 'COMMENT_REPLY_RECORD_NOT_FOUND',
  FAILED_PRECONDITION: 'FAILED_PRECONDITION',
  GOOGLE_REAUTH_REQUIRED: 'GOOGLE_REAUTH_REQUIRED',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
  INVALID_ARGUMENT: 'INVALID_ARGUMENT',
  LLM_CONFIG_ROOM_PRODUCT_NOT_FOUND: 'LLM_CONFIG_ROOM_PRODUCT_NOT_FOUND',
  NOT_FOUND: 'NOT_FOUND',
  NOT_READY: 'NOT_READY',
  OBJECT_STORAGE_ERROR: 'OBJECT_STORAGE_ERROR',
  PERMISSION_DENIED: 'PERMISSION_DENIED',
  PRONUNCIATION_DICTIONARY_ALREADY_EXISTS: 'PRONUNCIATION_DICTIONARY_ALREADY_EXISTS',
  PRONUNCIATION_DICTIONARY_NOT_FOUND: 'PRONUNCIATION_DICTIONARY_NOT_FOUND',
  PRONUNCIATION_RULE_CONFLICT: 'PRONUNCIATION_RULE_CONFLICT',
  PRONUNCIATION_RULE_NOT_FOUND: 'PRONUNCIATION_RULE_NOT_FOUND',
  /** The room's voice pitch is outside the allowed range (-12 to 12). */
  ROOM_SETTINGS_INVALID_VOICE_PITCH: 'ROOM_SETTINGS_INVALID_VOICE_PITCH',
  /** The room's voice speed is outside the allowed range (0.5 to 2.0). */
  ROOM_SETTINGS_INVALID_VOICE_SPEED: 'ROOM_SETTINGS_INVALID_VOICE_SPEED',
  /** The room's settings cannot be changed while it is live or provisioning. */
  ROOM_SETTINGS_ROOM_LIVE: 'ROOM_SETTINGS_ROOM_LIVE',
  /** The livestream room does not exist, or is not in one of the caller's stores. */
  ROOM_SETTINGS_ROOM_NOT_FOUND: 'ROOM_SETTINGS_ROOM_NOT_FOUND',
  /** The voice clone chosen for the room is in a different language from the room. */
  ROOM_SETTINGS_VOICE_CLONE_LANGUAGE_MISMATCH: 'ROOM_SETTINGS_VOICE_CLONE_LANGUAGE_MISMATCH',
  /** The voice clone chosen for the room does not exist. */
  ROOM_SETTINGS_VOICE_CLONE_NOT_FOUND: 'ROOM_SETTINGS_VOICE_CLONE_NOT_FOUND',
  /** The voice clone chosen for the room has not finished training. */
  ROOM_SETTINGS_VOICE_CLONE_NOT_READY: 'ROOM_SETTINGS_VOICE_CLONE_NOT_READY',
  SLACK_AI_CALL_FAILED: 'SLACK_AI_CALL_FAILED',
  SLACK_AI_SESSION_PERSISTENCE_FAILED: 'SLACK_AI_SESSION_PERSISTENCE_FAILED',
  SLACK_API_CALL_FAILED: 'SLACK_API_CALL_FAILED',
  SLACK_OAUTH_STATE_NOT_FOUND: 'SLACK_OAUTH_STATE_NOT_FOUND',
  SLACK_TOKEN_EXCHANGE_FAILED: 'SLACK_TOKEN_EXCHANGE_FAILED',
  SLACK_TOKEN_NOT_FOUND: 'SLACK_TOKEN_NOT_FOUND',
  SLACK_TOKEN_PERSISTENCE_FAILED: 'SLACK_TOKEN_PERSISTENCE_FAILED',
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  UPSTREAM_UNAVAILABLE: 'UPSTREAM_UNAVAILABLE'
} as const;

export type AnyLiveErrorCode = typeof AnyLiveErrorCode[keyof typeof AnyLiveErrorCode];
/** Fallback template used when auto-reply cannot produce a response. */
export type AnyLiveFallbackTemplate = {
  __typename?: 'AnyLiveFallbackTemplate';
  active: Scalars['Boolean']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  language: TtsAudioLanguage;
  latestRevisionCreatedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  /** The previous revision's id; null when there is only one revision. */
  previousRevisionId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Reply Channel was removed from fallback templates; this field has no backing data and always resolves NO_REPLY. */
  replyChannel: AnyLiveReplyChannel;
  /** The current revision's number (increments per content edit). */
  revisionNumber: Scalars['Int']['output'];
  /** @deprecated No longer used to select or validate a template; this field has no backing data and always resolves GENERAL. */
  scenario: AnyLiveFallbackTemplateScenario;
  store?: Maybe<MdStore>;
  storeId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Filter input for fallback templates. */
export type AnyLiveFallbackTemplateFilterInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, return Common templates only (store_id IS NULL). */
  commonOnly?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<TtsAudioLanguage>;
  search?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
};

/** Fallback template list type. */
export type AnyLiveFallbackTemplateList = PaginatedList & {
  __typename?: 'AnyLiveFallbackTemplateList';
  items: Array<AnyLiveFallbackTemplate>;
  totalCount: Scalars['Int']['output'];
};

/** An immutable revision of a fallback template. Revisions are append-only; the current revision is exposed on AnyLiveFallbackTemplate. */
export type AnyLiveFallbackTemplateRevision = {
  __typename?: 'AnyLiveFallbackTemplateRevision';
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Audit: the user id that created this revision; null when unset. */
  createdBy?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  language: TtsAudioLanguage;
  name: Scalars['String']['output'];
  /** The previous revision's id; null for the first revision. */
  previousRevisionId?: Maybe<Scalars['ID']['output']>;
  /** Revision number; 1 is the first revision, increments per edit. */
  revisionNumber: Scalars['Int']['output'];
  /** The logical template id this revision belongs to. */
  templateId: Scalars['ID']['output'];
};

/** Scenario in which a fallback template is used. */
export const AnyLiveFallbackTemplateScenario = {
  GENERAL: 'GENERAL',
  SENSITIVE_WORDS: 'SENSITIVE_WORDS'
} as const;

export type AnyLiveFallbackTemplateScenario = typeof AnyLiveFallbackTemplateScenario[keyof typeof AnyLiveFallbackTemplateScenario];
/** Represents a monetary value with a specific currency. */
export type AnyLiveMoney = {
  __typename?: 'AnyLiveMoney';
  amount: Scalars['BigDecimal']['output'];
  currency: Currency;
};

/** Product. */
export type AnyLiveProduct = {
  __typename?: 'AnyLiveProduct';
  createdAt: Scalars['DateTime']['output'];
  /** Product-specific FAQ content. Only fetched when explicitly requested. */
  faqs: Array<ProductFaq>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  scriptVersionId: Scalars['ID']['output'];
  sellingPoint?: Maybe<Scalars['String']['output']>;
  /** Position in the live asset version's product list, 0-based. `products` is already returned in this order; set it with `liveAssetProductReorder`. */
  sortIndex: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['Url']['output']>;
};

/** Create input for a product. */
export type AnyLiveProductCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  sellingPoint?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['Url']['input']>;
};

/** Geographic region for AnyLive marketplace operations */
export const AnyLiveRegion = {
  /** United Kingdom */
  GB: 'GB',
  /** Indonesia */
  ID: 'ID',
  /** Japan */
  JP: 'JP',
  /** Malaysia */
  MY: 'MY',
  /** Philippines */
  PH: 'PH',
  /** Singapore */
  SG: 'SG',
  /** Thailand */
  TH: 'TH',
  /** Taiwan */
  TW: 'TW',
  /** Vietnam */
  VN: 'VN'
} as const;

export type AnyLiveRegion = typeof AnyLiveRegion[keyof typeof AnyLiveRegion];
/** Reply channel for AI Reply Settings entries (Fallback Templates). */
export const AnyLiveReplyChannel = {
  /** Do not reply to the matched comment. */
  NO_REPLY: 'NO_REPLY',
  /** Reply with a text message. */
  TEXT_REPLY: 'TEXT_REPLY',
  /** Reply with a voice message. */
  VOICE_REPLY: 'VOICE_REPLY'
} as const;

export type AnyLiveReplyChannel = typeof AnyLiveReplyChannel[keyof typeof AnyLiveReplyChannel];
/** A sensitive word rule used for exact-match filtering. Always silences a matched comment. */
export type AnyLiveSensitiveWord = {
  __typename?: 'AnyLiveSensitiveWord';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Sensitive words no longer link a Fallback Template. Always null. */
  fallbackTemplate?: Maybe<AnyLiveFallbackTemplate>;
  /** Sensitive words no longer link a Fallback Template. Always null. */
  fallbackTemplateId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** Sensitive words are no-reply-only and carry no language. Always null. */
  language?: Maybe<TtsAudioLanguage>;
  /** The creation time of the current revision, independent of active toggles. */
  latestRevisionCreatedAt: Scalars['DateTime']['output'];
  /** The previous revision's id; null when there is only one revision. */
  previousRevisionId?: Maybe<Scalars['ID']['output']>;
  /** Sensitive words are no-reply-only. Always NO_REPLY. */
  replyChannel: AnyLiveReplyChannel;
  /** The current revision's number (increments per content edit). */
  revisionNumber: Scalars['Int']['output'];
  store?: Maybe<MdStore>;
  /** Optional store scoping. null = Common; non-null = store-only. Immutable after creation. */
  storeId?: Maybe<Scalars['ID']['output']>;
  term: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Filter input for sensitive words. */
export type AnyLiveSensitiveWordFilterInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-insensitive substring search on the current revision's term. */
  search?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
};

/** Paginated list of sensitive words. */
export type AnyLiveSensitiveWordList = PaginatedList & {
  __typename?: 'AnyLiveSensitiveWordList';
  items: Array<AnyLiveSensitiveWord>;
  totalCount: Scalars['Int']['output'];
};

/** An immutable revision of a sensitive word. Revisions are append-only. */
export type AnyLiveSensitiveWordRevision = {
  __typename?: 'AnyLiveSensitiveWordRevision';
  createdAt: Scalars['DateTime']['output'];
  /** Audit: the user id that created this revision; null when unset. */
  createdBy?: Maybe<Scalars['ID']['output']>;
  /** Sensitive words no longer link a Fallback Template. Always null. */
  fallbackTemplate?: Maybe<AnyLiveFallbackTemplate>;
  /** Sensitive words no longer link a Fallback Template. Always null. */
  fallbackTemplateId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** Sensitive words are no-reply-only and carry no language. Always null. */
  language?: Maybe<TtsAudioLanguage>;
  /** The previous revision's id; null for the first revision. */
  previousRevisionId?: Maybe<Scalars['ID']['output']>;
  /** Sensitive words are no-reply-only. Always NO_REPLY. */
  replyChannel: AnyLiveReplyChannel;
  /** Revision number; 1 is the first revision, increments per edit. */
  revisionNumber: Scalars['Int']['output'];
  /** The logical word id this revision belongs to. */
  templateId: Scalars['ID']['output'];
  term: Scalars['String']['output'];
};

/** Update input for a fallback template. */
export type AnyLiveUpdateFallbackTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  language?: InputMaybe<TtsAudioLanguage>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Update input for a sensitive word. */
export type AnyLiveUpdateSensitiveWordInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
};

export type AnyLogiOrderAddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country: Country;
  name: NameInput;
  phoneNumber: PhoneNumberInput;
  provinceCode?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type AnyLogiOrderCustomerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name: NameInput;
  phoneNumber: PhoneNumberInput;
};

export type AnyLogiSkuForOrderDetailed = {
  __typename?: 'AnyLogiSkuForOrderDetailed';
  code: Scalars['String']['output'];
  currency: AnylogiMoney;
  declaredUnitPrice?: Maybe<Scalars['String']['output']>;
  gtin: Scalars['String']['output'];
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  shippingNotRequired: Scalars['Boolean']['output'];
  shippingStatus?: Maybe<AnylogiItemShippingStatus>;
  suggestedDeclaredUnitPrice: Scalars['String']['output'];
  unknown: Scalars['Boolean']['output'];
};

export type AnyTagInfluencer = {
  __typename?: 'AnyTagInfluencer';
  avatar: Scalars['String']['output'];
  countryName?: Maybe<Scalars['String']['output']>;
  followersCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Long']['output'];
  linkStatus: AnyTagInfluencerLinkStatus;
  /**
   * Chat of the other customer the influencer is linked to. Null unless LINKED_TO_OTHER_CUSTOMER and that customer is in the same account.
   * @deprecated Use linkedChats
   */
  linkedChatId?: Maybe<Scalars['String']['output']>;
  /** Chats of the other customers the influencer is linked to, in every influencer-mode store, newest link first */
  linkedChats: Array<AnyTagLinkedChat>;
  name: Scalars['String']['output'];
  profileUrl: Scalars['String']['output'];
  socialAccounts: Array<AnyTagSocialAccount>;
};

export const AnyTagInfluencerLinkStatus = {
  LINKED_TO_OTHER_CUSTOMER: 'LINKED_TO_OTHER_CUSTOMER',
  LINKED_TO_THIS_CUSTOMER: 'LINKED_TO_THIS_CUSTOMER',
  NOT_LINKED: 'NOT_LINKED'
} as const;

export type AnyTagInfluencerLinkStatus = typeof AnyTagInfluencerLinkStatus[keyof typeof AnyTagInfluencerLinkStatus];
export type AnyTagInfluencerMergeCount = {
  __typename?: 'AnyTagInfluencerMergeCount';
  /** What AnyTag moves, e.g. social accounts or campaigns */
  group: Scalars['String']['output'];
  moved: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type AnyTagInfluencerMergeResponse = {
  __typename?: 'AnyTagInfluencerMergeResponse';
  /** One per duplicate merged, in mergeInfluencerIds order. Duplicates AnyTag no longer has are left out. */
  results: Array<AnyTagInfluencerMergeResult>;
};

export type AnyTagInfluencerMergeResult = {
  __typename?: 'AnyTagInfluencerMergeResult';
  counts: Array<AnyTagInfluencerMergeCount>;
  /** Deleted on AnyTag by the merge */
  fromId: Scalars['Long']['output'];
  /** Kept */
  toId: Scalars['Long']['output'];
  warnings: Array<AnyTagInfluencerMergeWarning>;
};

export type AnyTagInfluencerMergeWarning = {
  __typename?: 'AnyTagInfluencerMergeWarning';
  affectedIds: Array<Scalars['Long']['output']>;
  /** e.g. ACCOUNT_COLLISION_DISCARDED, CAMPAIGN_OVERLAP_LEFT_ON_DUPLICATE */
  kind: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type AnyTagInfluencersRequest = {
  chatId: Scalars['String']['input'];
  /** Handle (a leading @ is ignored) or AnyTag name. Blank returns no results. */
  keyword: Scalars['String']['input'];
  /** 1..50, default 20 */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type AnyTagInfluencersResponse = {
  __typename?: 'AnyTagInfluencersResponse';
  influencers: Array<AnyTagInfluencer>;
};

export type AnyTagLinkedChat = {
  __typename?: 'AnyTagLinkedChat';
  chatId: Scalars['String']['output'];
  /** AnyX store of the chat, which may not be the one being searched from */
  storeId: Scalars['Long']['output'];
};

export type AnyTagSocialAccount = {
  __typename?: 'AnyTagSocialAccount';
  followersCount: Scalars['Int']['output'];
  /** AnyTag platform name, e.g. INSTAGRAM, TIKTOK, YOUTUBE */
  platform: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export const AnyXDeliveryStatus = {
  CANCELLED: 'CANCELLED',
  PAYING: 'PAYING',
  PENDING: 'PENDING',
  SHIPPED: 'SHIPPED'
} as const;

export type AnyXDeliveryStatus = typeof AnyXDeliveryStatus[keyof typeof AnyXDeliveryStatus];
/** Inbound overview view to represent the total record of each inbound status */
export type AnyXInboundOverview = {
  __typename?: 'AnyXInboundOverview';
  allCount: Scalars['Int']['output'];
  completedCount: Scalars['Int']['output'];
  reviewingCount: Scalars['Int']['output'];
  warehousingCount: Scalars['Int']['output'];
};

export const AnyXInboundStatus = {
  Canceled: 'Canceled',
  Completed: 'Completed',
  Reviewing: 'Reviewing',
  Warehousing: 'Warehousing'
} as const;

export type AnyXInboundStatus = typeof AnyXInboundStatus[keyof typeof AnyXInboundStatus];
export type AnyXSupplier = {
  __typename?: 'AnyXSupplier';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AnyXWarehouse = {
  __typename?: 'AnyXWarehouse';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Input for creating scraper integration credentials. */
export type AnyliveCredentialCreateInput = {
  /** Google Calendar embed URL for the AI live calendar (optional). The `src` query parameter is extracted and forwarded to the scraper. */
  aiLiveCalendarUrl?: InputMaybe<Scalars['String']['input']>;
  /** AnyX store ID. */
  anyxStoreId: Scalars['String']['input'];
  /** Password for authentication. */
  password: Scalars['String']['input'];
  /** Region code. */
  region: AnyLiveRegion;
  /** Sales channel type (TIKTOK or SHOPEE). */
  salesChannelType: SalesChannelType;
  /** Shopee account type: SUBACCOUNT (default) or AGENT_ACCOUNT. */
  shopeeAccountType?: InputMaybe<ShopeeAccountType>;
  /** Shopee center domain (optional). */
  shopeeCenterDomain?: InputMaybe<Scalars['String']['input']>;
  /** Shopee sub-account domain (optional). */
  shopeeSubAccountDomain?: InputMaybe<Scalars['String']['input']>;
  /** Subaccount identifier. */
  subaccount: Scalars['String']['input'];
};

/** Output type for creating scraper integration credentials. */
export type AnyliveCredentialOutput = {
  __typename?: 'AnyliveCredentialOutput';
  /** The ID of the created scraper integration credential. */
  id: Scalars['ID']['output'];
};

/** Input for updating scraper integration credentials. */
export type AnyliveCredentialUpdateInput = {
  /** Google Calendar embed URL for the AI live calendar (optional). The `src` query parameter is extracted and forwarded to the scraper. */
  aiLiveCalendarUrl?: InputMaybe<Scalars['String']['input']>;
  /** AnyX store ID. */
  anyxStoreId: Scalars['String']['input'];
  /** The ID of the credential to update. */
  id: Scalars['ID']['input'];
  /** Password for authentication. */
  password: Scalars['String']['input'];
  /** Region code. */
  region: AnyLiveRegion;
  /** Sales channel type (TIKTOK or SHOPEE). */
  salesChannelType: SalesChannelType;
  /** Shopee account type: SUBACCOUNT (default) or AGENT_ACCOUNT. */
  shopeeAccountType?: InputMaybe<ShopeeAccountType>;
  /** Shopee center domain (optional). */
  shopeeCenterDomain?: InputMaybe<Scalars['String']['input']>;
  /** Shopee sub-account domain (optional). */
  shopeeSubAccountDomain?: InputMaybe<Scalars['String']['input']>;
  /** Subaccount identifier. */
  subaccount: Scalars['String']['input'];
};

/** Input for updating scraper integration fields that do not require a re-login (e.g. AI live calendar URL). Only applies to credentials whose status is DONE. */
export type AnyliveCredentialUpdateNonLoginFieldsInput = {
  /** Google Calendar embed URL for the AI live calendar (optional). The `src` query parameter is extracted and written to Firestore as `ai_live_calendar_id`. Pass null to clear the calendar. */
  aiLiveCalendarUrl?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the credential to update. */
  id: Scalars['ID']['input'];
};

/** Integration credential for scraper services. */
export type AnyliveIntegrationCredential = {
  __typename?: 'AnyliveIntegrationCredential';
  /** Google Calendar embed URL for the AI live calendar, if configured. */
  aiLiveCalendarUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Store identifier from AnyX.
   * @deprecated Use storeId instead., replace with storeId
   */
  anyxStoreId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated Use subaccount instead., replace with subaccount */
  email: Scalars['String']['output'];
  /** Postgres column mirrored to Firestore. Only available when status is DONE and firebaseCredentialId exists. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Whether this credential may be used for live control. Distinct from `enabled`, which is data collection. Set to true when the test login completes; null when never explicitly set — this covers every credential that predates the migration that introduced this column as well as those that have not yet completed login. Treat null as off. */
  livestreamEnabled?: Maybe<Scalars['Boolean']['output']>;
  loginErrorCode?: Maybe<LoginErrorCode>;
  region: AnyLiveRegion;
  salesChannelType: SalesChannelType;
  /** Shopee account type: SUBACCOUNT (default) or AGENT_ACCOUNT. Null for non-Shopee channels. */
  shopeeAccountType?: Maybe<ShopeeAccountType>;
  shopeeCenterDomain?: Maybe<Scalars['String']['output']>;
  shopeeSubAccountDomain?: Maybe<Scalars['String']['output']>;
  status: ScraperIntegrationStatus;
  /** Store reference from AnyX. */
  store?: Maybe<MdStore>;
  /** Store identifier from AnyX. */
  storeId: Scalars['ID']['output'];
  storeName: Scalars['String']['output'];
  subaccount: Scalars['String']['output'];
  tiktokAccountUsername?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Filter input for integration credentials. */
export type AnyliveIntegrationCredentialFilterInput = {
  anyxStoreId?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<AnyLiveRegion>;
  salesChannelType?: InputMaybe<SalesChannelType>;
  /** Search by store name. */
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ScraperIntegrationStatus>;
};

/** Integration credential list type. */
export type AnyliveIntegrationCredentialList = PaginatedList & {
  __typename?: 'AnyliveIntegrationCredentialList';
  items: Array<AnyliveIntegrationCredential>;
  totalCount: Scalars['Int']['output'];
};

/** Sort field for integration credentials. */
export const AnyliveIntegrationCredentialSortField = {
  CREATED_AT: 'CREATED_AT',
  ID: 'ID',
  STATUS: 'STATUS',
  UPDATED_AT: 'UPDATED_AT'
} as const;

export type AnyliveIntegrationCredentialSortField = typeof AnyliveIntegrationCredentialSortField[keyof typeof AnyliveIntegrationCredentialSortField];
/** Sort input for integration credentials. */
export type AnyliveIntegrationCredentialSortInput = {
  /** Default is descending. */
  direction?: InputMaybe<SortDirection>;
  /** Default is ID. */
  field?: InputMaybe<AnyliveIntegrationCredentialSortField>;
};

export type AnylogiCrossBorderShippingInput = {
  boxSizes?: InputMaybe<Array<ShippingBoxSizeInput>>;
  deliveryDutyPaid: Scalars['Boolean']['input'];
  insurance?: InputMaybe<AnylogiMoneyInput>;
  shipmentCategory?: InputMaybe<Category>;
  shipperAddressID: Scalars['String']['input'];
  signatureOption: Scalars['Boolean']['input'];
};

export const AnylogiCurrency = {
  AED: 'AED',
  AFN: 'AFN',
  ALL: 'ALL',
  AMD: 'AMD',
  ANG: 'ANG',
  AOA: 'AOA',
  ARS: 'ARS',
  AUD: 'AUD',
  AWG: 'AWG',
  AZN: 'AZN',
  BAM: 'BAM',
  BBD: 'BBD',
  BDT: 'BDT',
  BGN: 'BGN',
  BHD: 'BHD',
  BIF: 'BIF',
  BMD: 'BMD',
  BND: 'BND',
  BOB: 'BOB',
  BRL: 'BRL',
  BSD: 'BSD',
  BTN: 'BTN',
  BWP: 'BWP',
  BYN: 'BYN',
  BYR: 'BYR',
  BZD: 'BZD',
  CAD: 'CAD',
  CDF: 'CDF',
  CHF: 'CHF',
  CLF: 'CLF',
  CLP: 'CLP',
  CNY: 'CNY',
  COP: 'COP',
  CRC: 'CRC',
  CUC: 'CUC',
  CUP: 'CUP',
  CVE: 'CVE',
  CZK: 'CZK',
  DJF: 'DJF',
  DKK: 'DKK',
  DOP: 'DOP',
  DZD: 'DZD',
  EEK: 'EEK',
  EGP: 'EGP',
  ERN: 'ERN',
  ETB: 'ETB',
  EUR: 'EUR',
  FJD: 'FJD',
  FKP: 'FKP',
  GBP: 'GBP',
  GEL: 'GEL',
  GGP: 'GGP',
  GHC: 'GHC',
  GHS: 'GHS',
  GIP: 'GIP',
  GMD: 'GMD',
  GNF: 'GNF',
  GTQ: 'GTQ',
  GYD: 'GYD',
  HKD: 'HKD',
  HNL: 'HNL',
  HRK: 'HRK',
  HTG: 'HTG',
  HUF: 'HUF',
  IDR: 'IDR',
  ILS: 'ILS',
  IMP: 'IMP',
  INR: 'INR',
  IQD: 'IQD',
  IRR: 'IRR',
  ISK: 'ISK',
  JEP: 'JEP',
  JMD: 'JMD',
  JOD: 'JOD',
  JPY: 'JPY',
  KES: 'KES',
  KGS: 'KGS',
  KHR: 'KHR',
  KMF: 'KMF',
  KPW: 'KPW',
  KRW: 'KRW',
  KWD: 'KWD',
  KYD: 'KYD',
  KZT: 'KZT',
  LAK: 'LAK',
  LBP: 'LBP',
  LKR: 'LKR',
  LRD: 'LRD',
  LSL: 'LSL',
  LTL: 'LTL',
  LVL: 'LVL',
  LYD: 'LYD',
  MAD: 'MAD',
  MDL: 'MDL',
  MGA: 'MGA',
  MKD: 'MKD',
  MMK: 'MMK',
  MNT: 'MNT',
  MOP: 'MOP',
  MUR: 'MUR',
  MVR: 'MVR',
  MWK: 'MWK',
  MXN: 'MXN',
  MYR: 'MYR',
  MZN: 'MZN',
  NAD: 'NAD',
  NGN: 'NGN',
  NIO: 'NIO',
  NOK: 'NOK',
  NPR: 'NPR',
  NZD: 'NZD',
  OMR: 'OMR',
  PAB: 'PAB',
  PEN: 'PEN',
  PGK: 'PGK',
  PHP: 'PHP',
  PKR: 'PKR',
  PLN: 'PLN',
  PYG: 'PYG',
  QAR: 'QAR',
  RON: 'RON',
  RSD: 'RSD',
  RUB: 'RUB',
  RUR: 'RUR',
  RWF: 'RWF',
  SAR: 'SAR',
  SBD: 'SBD',
  SCR: 'SCR',
  SDG: 'SDG',
  SEK: 'SEK',
  SGD: 'SGD',
  SHP: 'SHP',
  SKK: 'SKK',
  SLL: 'SLL',
  SOS: 'SOS',
  SRD: 'SRD',
  SSP: 'SSP',
  STD: 'STD',
  SVC: 'SVC',
  SYP: 'SYP',
  SZL: 'SZL',
  THB: 'THB',
  TJS: 'TJS',
  TMT: 'TMT',
  TND: 'TND',
  TOP: 'TOP',
  TRL: 'TRL',
  TRY: 'TRY',
  TTD: 'TTD',
  TWD: 'TWD',
  TZS: 'TZS',
  UAH: 'UAH',
  UGX: 'UGX',
  USD: 'USD',
  UYU: 'UYU',
  UZS: 'UZS',
  VEF: 'VEF',
  VND: 'VND',
  VUV: 'VUV',
  WST: 'WST',
  XAF: 'XAF',
  XAG: 'XAG',
  XAU: 'XAU',
  XCD: 'XCD',
  XDR: 'XDR',
  XOF: 'XOF',
  XPF: 'XPF',
  YER: 'YER',
  ZAR: 'ZAR',
  ZMW: 'ZMW',
  ZWD: 'ZWD'
} as const;

export type AnylogiCurrency = typeof AnylogiCurrency[keyof typeof AnylogiCurrency];
export const AnylogiCurrencyInput = {
  AED: 'AED',
  AUD: 'AUD',
  BHD: 'BHD',
  BRL: 'BRL',
  CAD: 'CAD',
  CNY: 'CNY',
  EGP: 'EGP',
  EUR: 'EUR',
  GBP: 'GBP',
  HKD: 'HKD',
  IDR: 'IDR',
  INR: 'INR',
  JOD: 'JOD',
  JPY: 'JPY',
  KHR: 'KHR',
  KRW: 'KRW',
  KWD: 'KWD',
  MMK: 'MMK',
  MXN: 'MXN',
  MYR: 'MYR',
  OMR: 'OMR',
  PHP: 'PHP',
  PKR: 'PKR',
  PLN: 'PLN',
  QAR: 'QAR',
  SAR: 'SAR',
  SEK: 'SEK',
  SGD: 'SGD',
  THB: 'THB',
  TRY: 'TRY',
  TWD: 'TWD',
  USD: 'USD',
  VND: 'VND'
} as const;

export type AnylogiCurrencyInput = typeof AnylogiCurrencyInput[keyof typeof AnylogiCurrencyInput];
export const AnylogiItemShippingStatus = {
  ALLOCATED: 'ALLOCATED',
  ALLOCATING: 'ALLOCATING',
  CANCELED: 'CANCELED'
} as const;

export type AnylogiItemShippingStatus = typeof AnylogiItemShippingStatus[keyof typeof AnylogiItemShippingStatus];
export type AnylogiMoney = {
  __typename?: 'AnylogiMoney';
  amount: Scalars['BigDecimal']['output'];
  currency: AnylogiCurrency;
};

export type AnylogiMoneyInput = {
  amount: Scalars['BigDecimal']['input'];
  currency: AnylogiCurrencyInput;
};

export type AnylogiOrder = {
  __typename?: 'AnylogiOrder';
  account: IdName;
  anyXOrderId: Scalars['Long']['output'];
  anylogiId: Scalars['ID']['output'];
  billingAddress?: Maybe<FullAddress>;
  channelOrderId: Scalars['String']['output'];
  channelProvider: ChannelProvider;
  channelUrl?: Maybe<Scalars['String']['output']>;
  codFee?: Maybe<Scalars['Float']['output']>;
  courierType?: Maybe<CourierType>;
  created: Scalars['ZonedDatetime']['output'];
  crossBorderValidationErrors?: Maybe<Array<CrossBorderValidationError>>;
  currency: Scalars['String']['output'];
  customer?: Maybe<AnylogiReadOrderCustomer>;
  deliveryStatus: DeliveryStatus;
  discount?: Maybe<Scalars['Float']['output']>;
  displayId: Scalars['String']['output'];
  editable: Scalars['Boolean']['output'];
  fulfillmentAmount?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  items: Scalars['Int']['output'];
  labelCreated?: Maybe<Scalars['ZonedDatetime']['output']>;
  laterPay?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  paymentMethod: AnylogiPaymentMethod;
  paymentStatus: AnylogiPaymentStatus;
  pickupNumber?: Maybe<Scalars['String']['output']>;
  preferredDeliveryDate?: Maybe<Scalars['Date']['output']>;
  preferredDeliveryTime?: Maybe<DeliveryTimeframe>;
  productCount: Scalars['Int']['output'];
  products: Array<AnyLogiSkuForOrderDetailed>;
  shipping: AnylogiShipping;
  shippingAddress?: Maybe<FullAddress>;
  shippingCost?: Maybe<Scalars['Float']['output']>;
  shippingDate?: Maybe<Scalars['ZonedDatetime']['output']>;
  shippingInstructions?: Maybe<Scalars['String']['output']>;
  store: IdName;
  subtotalAmount?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  temperature: Temperature;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  totalWeight?: Maybe<Scalars['Float']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingStatus?: Maybe<AnylogiOrderTrackingStatus>;
  trackingStatusOriginal?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
  translatedShippingAddress?: Maybe<FullAddress>;
  validationStatus?: Maybe<ValidationStatus>;
  warehouse: IdName;
  warehouseName: Scalars['String']['output'];
};

export const AnylogiOrderTrackingStatus = {
  DELIVERED: 'DELIVERED',
  LABEL_CREATED: 'LABEL_CREATED',
  ON_THE_WAY: 'ON_THE_WAY',
  PENDING: 'PENDING',
  VOIDED: 'VOIDED'
} as const;

export type AnylogiOrderTrackingStatus = typeof AnylogiOrderTrackingStatus[keyof typeof AnylogiOrderTrackingStatus];
export type AnylogiOrdersPaginated = Paginated & {
  __typename?: 'AnylogiOrdersPaginated';
  page: Scalars['Int']['output'];
  records: Array<AnylogiOrder>;
  total: Scalars['Int']['output'];
  totalInvalid: Scalars['Int']['output'];
};

export const AnylogiPaymentMethod = {
  ALIPAY: 'ALIPAY',
  AMAZON_PAYMENTS: 'AMAZON_PAYMENTS',
  APPLE_PAY: 'APPLE_PAY',
  AUTO_LOAN: 'AUTO_LOAN',
  BANK: 'BANK',
  CASH: 'CASH',
  CASH_ON_DELIVERY: 'CASH_ON_DELIVERY',
  CREDIT_CARD: 'CREDIT_CARD',
  GMO_CREDIT: 'GMO_CREDIT',
  GMO_CVS: 'GMO_CVS',
  GMO_SMARTPHONE: 'GMO_SMARTPHONE',
  INSTALLMENT: 'INSTALLMENT',
  INVOICE: 'INVOICE',
  KOMOJU_BANK: 'KOMOJU_BANK',
  KOMOJU_CVS: 'KOMOJU_CVS',
  KOMOJU_SMARTPHONE: 'KOMOJU_SMARTPHONE',
  LEASE: 'LEASE',
  LOAN: 'LOAN',
  MOBILE_CREDITS: 'MOBILE_CREDITS',
  NO_PAYMENT: 'NO_PAYMENT',
  NP_ATOBARAI: 'NP_ATOBARAI',
  OTHER: 'OTHER',
  PAIDY_NEXT_MONTH_CVS_BANK: 'PAIDY_NEXT_MONTH_CVS_BANK',
  PAIDY_PAY_LATER: 'PAIDY_PAY_LATER',
  PAYPAL: 'PAYPAL',
  PAY_LATER_1: 'PAY_LATER_1',
  PAY_LATER_2: 'PAY_LATER_2',
  PRE_PAY: 'PRE_PAY',
  RAKUTEN_POINT: 'RAKUTEN_POINT',
  REGISTERED_MAIL: 'REGISTERED_MAIL',
  SEVEN_PRE_PAY: 'SEVEN_PRE_PAY',
  SHOPIFY_PAYMENTS: 'SHOPIFY_PAYMENTS',
  STORE: 'STORE',
  VIRTUAL_ACCOUNT: 'VIRTUAL_ACCOUNT'
} as const;

export type AnylogiPaymentMethod = typeof AnylogiPaymentMethod[keyof typeof AnylogiPaymentMethod];
export const AnylogiPaymentStatus = {
  CANCELLED: 'CANCELLED',
  NONE: 'NONE',
  PAID: 'PAID',
  PAYING: 'PAYING'
} as const;

export type AnylogiPaymentStatus = typeof AnylogiPaymentStatus[keyof typeof AnylogiPaymentStatus];
export type AnylogiReadOrderCustomer = {
  __typename?: 'AnylogiReadOrderCustomer';
  email: Scalars['String']['output'];
  name: Name;
  numberOfPurchases: Scalars['Long']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type AnylogiShipping = {
  __typename?: 'AnylogiShipping';
  boxSizes?: Maybe<Array<ShippingBoxSize>>;
  deliveryDutyPaid: Scalars['Boolean']['output'];
  insurance?: Maybe<AnylogiMoney>;
  orderID: Scalars['ID']['output'];
  serviceCode?: Maybe<CrossBorderServiceCode>;
  shipmentCategory?: Maybe<Category>;
  shipmentPrice?: Maybe<AnylogiMoney>;
  shipperAddressID: Scalars['String']['output'];
  signatureOption: Scalars['Boolean']['output'];
  specialServiceTypes?: Maybe<Array<SpecialServiceType>>;
  status?: Maybe<ShippingStatus>;
  trackingURL: Scalars['String']['output'];
};

export const AnylogiTimezone = {
  ASIA_BANGKOK: 'ASIA_BANGKOK',
  ASIA_DHAKA: 'ASIA_DHAKA',
  ASIA_KOLKATA: 'ASIA_KOLKATA',
  ASIA_SINGAPORE: 'ASIA_SINGAPORE',
  ASIA_TOKYO: 'ASIA_TOKYO',
  ASIA_YANGON: 'ASIA_YANGON'
} as const;

export type AnylogiTimezone = typeof AnylogiTimezone[keyof typeof AnylogiTimezone];
export type AnylogiUpdateCrossBorderShippingOrderInput = {
  customer?: InputMaybe<AnyLogiOrderCustomerInput>;
  id: Scalars['ID']['input'];
  shipping?: InputMaybe<AnylogiCrossBorderShippingInput>;
  translatedShippingAddress?: InputMaybe<AnyLogiOrderAddressInput>;
};

export type AnylogiUser = {
  __typename?: 'AnylogiUser';
  created: Scalars['Time']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  role: AnylogiUserRoles;
  status: AnylogiUserStatus;
};

export type AnylogiUserDetailed = {
  __typename?: 'AnylogiUserDetailed';
  created: Scalars['Time']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  preferences?: Maybe<AnylogiUserPreferences>;
  role: AnylogiUserRoles;
  status: AnylogiUserStatus;
  supplier?: Maybe<Supplier>;
};

export type AnylogiUserFilters = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<AnylogiUserRoles>;
  status?: InputMaybe<AnylogiUserStatus>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type AnylogiUserPreferences = {
  __typename?: 'AnylogiUserPreferences';
  currency: AnylogiCurrency;
  language: Language;
  timezone: AnylogiTimezone;
};

export const AnylogiUserRoles = {
  ADMIN: 'ADMIN',
  MERCHANT: 'MERCHANT',
  STAFF: 'STAFF',
  SUPPLIER: 'SUPPLIER'
} as const;

export type AnylogiUserRoles = typeof AnylogiUserRoles[keyof typeof AnylogiUserRoles];
export const AnylogiUserStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ONBOARDING: 'ONBOARDING',
  PENDING: 'PENDING',
  REVIEW: 'REVIEW'
} as const;

export type AnylogiUserStatus = typeof AnylogiUserStatus[keyof typeof AnylogiUserStatus];
export type AnylogiUsersPaginated = Paginated & {
  __typename?: 'AnylogiUsersPaginated';
  page: Scalars['Int']['output'];
  records: Array<AnylogiUser>;
  total: Scalars['Int']['output'];
};

export type AnylogiWarehouse = {
  __typename?: 'AnylogiWarehouse';
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type ApplyGreetingMessageDraftRequest = {
  storeId: Scalars['Long']['input'];
};

export type ArchiveProductVariantsOutput = {
  __typename?: 'ArchiveProductVariantsOutput';
  ok: Scalars['Boolean']['output'];
};

export type AssetUploadUrl = {
  __typename?: 'AssetUploadUrl';
  originalUrl: UploadUrl;
  previewUrl?: Maybe<UploadUrl>;
};

/** A room's WELCOME and TIMED atmosphere timers — both fire on an interval. */
export type AtmosphereGuidanceGql = {
  __typename?: 'AtmosphereGuidanceGql';
  timed: LivestreamRoomAtmosphereGroupGql;
  welcome: LivestreamRoomAtmosphereGroupGql;
};

export type AutoAuthor = {
  __typename?: 'AutoAuthor';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type AutoReplyContent = {
  __typename?: 'AutoReplyContent';
  autoReplyId: Scalars['String']['output'];
};

export type AutoReplyInfo = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  trigger: AutomationFlowTrigger;
};

export type AutomationFlow = {
  __typename?: 'AutomationFlow';
  enabled: Scalars['Boolean']['output'];
  eventType: AutomationFlowEventType;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  replyContents: Array<AutomationFlowContent>;
  sendWhen: LiveCommentAutoReplyTiming;
  trigger: AutomationFlowTrigger;
};

export type AutomationFlowContent = AutomationTemplateContent | AutomationTextContent;

export type AutomationFlowContentInput = {
  contentType: AutomationFlowContentType;
  template?: InputMaybe<AutomationTemplateContentInput>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export const AutomationFlowContentType = {
  TemplateContent: 'TemplateContent',
  TextContent: 'TextContent'
} as const;

export type AutomationFlowContentType = typeof AutomationFlowContentType[keyof typeof AutomationFlowContentType];
export const AutomationFlowEventType = {
  InstagramLiveComment: 'InstagramLiveComment'
} as const;

export type AutomationFlowEventType = typeof AutomationFlowEventType[keyof typeof AutomationFlowEventType];
export type AutomationFlowTrigger = AnyContent | ContainsKeyword;

export type AutomationFlowTriggerInput = {
  containsKeyword?: InputMaybe<ContainsKeywordInput>;
};

export type AutomationTemplateButton = {
  __typename?: 'AutomationTemplateButton';
  buttonUrl: Scalars['Url']['output'];
  title: Scalars['String']['output'];
};

export type AutomationTemplateButtonInput = {
  buttonUrl: Scalars['Url']['input'];
  title: Scalars['String']['input'];
};

export type AutomationTemplateContent = {
  __typename?: 'AutomationTemplateContent';
  buttons: Array<AutomationTemplateButton>;
  imageUrl?: Maybe<Scalars['Url']['output']>;
  title: Scalars['String']['output'];
};

export type AutomationTemplateContentInput = {
  buttons: Array<AutomationTemplateButtonInput>;
  imageUrl?: InputMaybe<Scalars['Url']['input']>;
  title: Scalars['String']['input'];
};

export type AutomationTextContent = {
  __typename?: 'AutomationTextContent';
  text: Scalars['String']['output'];
};

export const AvatarGender = {
  FEMALE: 'FEMALE',
  MALE: 'MALE',
  UNKNOWN: 'UNKNOWN'
} as const;

export type AvatarGender = typeof AvatarGender[keyof typeof AvatarGender];
/** One of an avatar's training videos (main or a sub look), with its own thumbnail and preview. */
export type AvatarVideoGql = {
  __typename?: 'AvatarVideoGql';
  /** Training-video id — the stable look identity (use it to rename a sub-video or pin a product). */
  id: Scalars['ID']['output'];
  /** Variant name; null for the main video. */
  name?: Maybe<Scalars['String']['output']>;
  /** Short-lived signed GCS URL of this video, for preview. */
  previewVideo?: Maybe<Scalars['Url']['output']>;
  /** Thumbnail URL served from our storage; null while training / re-host pending. */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type BasicUser = {
  __typename?: 'BasicUser';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** BigDecimal range input type. */
export type BigDecimalRangeInput = {
  from?: InputMaybe<Scalars['BigDecimal']['input']>;
  to?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type BotReaction = {
  __typename?: 'BotReaction';
  sign: ReactionSign;
};

export type BoxSize = {
  __typename?: 'BoxSize';
  default: Scalars['Boolean']['output'];
  depth: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
  width: Scalars['Int']['output'];
};

export type BoxSizeInput = {
  default: Scalars['Boolean']['input'];
  depth: Scalars['Int']['input'];
  height: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Int']['input']>;
  width: Scalars['Int']['input'];
};

export type Brand = {
  __typename?: 'Brand';
  defaultCourierType?: Maybe<CourierType>;
  masterDataStoreId?: Maybe<Scalars['Long']['output']>;
  name: Scalars['String']['output'];
};

/**
 * example value for each condition type
 *
 * CUSTOMER_AGE = ["90"]
 * CUSTOMER_AMOUNT_SPENT = ["20.35"]
 * CUSTOMER_MONTH_OF_BIRTH = ["12"]
 * CUSTOMER_GENDER = ["MALE"],["FEMALE"],["OTHER"]
 * CUSTOMER_ITEM_PURCHASED = ["ITEMID"]
 * CUSTOMER_LAST_ORDER_DATE = ["32"]
 * CUSTOMER_NUMBER_OF_ORDERS = ["32"]
 * CUSTOMER_PROVINCE = ["JP","JP-01"]
 * CUSTOMER_TAGS = ["tag1","tag2"]
 * CUSTOMER_SHOPIFY_CONNECTED = [] (no value; use operator NULL or NOT_NULL)
 */
export type BroadcastCondition = {
  __typename?: 'BroadcastCondition';
  id: Scalars['String']['output'];
  operator: BroadcastConditionOperator;
  type: BroadcastConditionType;
  values: Array<Scalars['String']['output']>;
};

/**
 * example value for each condition type
 *
 * CUSTOMER_AGE = ["90"]
 * CUSTOMER_AMOUNT_SPENT = ["20.35"]
 * CUSTOMER_MONTH_OF_BIRTH = ["12"]
 * CUSTOMER_GENDER = ["MALE"],["FEMALE"],["OTHER"]
 * CUSTOMER_ITEM_PURCHASED = ["ITEMID"]
 * CUSTOMER_LAST_ORDER_DATE = ["32"]
 * CUSTOMER_NUMBER_OF_ORDERS = ["32"]
 * CUSTOMER_PROVINCE = ["JP","JP-01"]
 * CUSTOMER_TAGS = ["tag1","tag2"]
 * CUSTOMER_SHOPIFY_CONNECTED = [] (no value; use operator NULL or NOT_NULL)
 */
export type BroadcastConditionInput = {
  id: Scalars['String']['input'];
  operator: BroadcastConditionOperator;
  type: BroadcastConditionType;
  values: Array<Scalars['String']['input']>;
};

export const BroadcastConditionOperator = {
  BETWEEN: 'BETWEEN',
  BLANK: 'BLANK',
  CONTAINS_ALL: 'CONTAINS_ALL',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  EQUALS: 'EQUALS',
  GREATER_THAN: 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL_TO: 'GREATER_THAN_OR_EQUAL_TO',
  LESS_THAN: 'LESS_THAN',
  LESS_THAN_OR_EQUAL_TO: 'LESS_THAN_OR_EQUAL_TO',
  NOT_BLANK: 'NOT_BLANK',
  NOT_EQUAL_TO: 'NOT_EQUAL_TO',
  NOT_NULL: 'NOT_NULL',
  NULL: 'NULL'
} as const;

export type BroadcastConditionOperator = typeof BroadcastConditionOperator[keyof typeof BroadcastConditionOperator];
export const BroadcastConditionType = {
  CUSTOMER_AGE: 'CUSTOMER_AGE',
  CUSTOMER_AMOUNT_SPENT: 'CUSTOMER_AMOUNT_SPENT',
  CUSTOMER_GENDER: 'CUSTOMER_GENDER',
  CUSTOMER_ITEM_PURCHASED: 'CUSTOMER_ITEM_PURCHASED',
  CUSTOMER_LAST_ORDER_DATE: 'CUSTOMER_LAST_ORDER_DATE',
  CUSTOMER_MONTH_OF_BIRTH: 'CUSTOMER_MONTH_OF_BIRTH',
  CUSTOMER_NUMBER_OF_ORDERS: 'CUSTOMER_NUMBER_OF_ORDERS',
  CUSTOMER_PROVINCE: 'CUSTOMER_PROVINCE',
  CUSTOMER_SHOPIFY_CONNECTED: 'CUSTOMER_SHOPIFY_CONNECTED',
  CUSTOMER_TAGS: 'CUSTOMER_TAGS'
} as const;

export type BroadcastConditionType = typeof BroadcastConditionType[keyof typeof BroadcastConditionType];
export type BroadcastConditionWrapper = {
  __typename?: 'BroadcastConditionWrapper';
  combinator: BroadcastConditionsCombinator;
  conditions: Array<BroadcastCondition>;
};

export type BroadcastConditionWrapperInput = {
  combinator: BroadcastConditionsCombinator;
  conditions: Array<BroadcastConditionInput>;
};

export const BroadcastConditionsCombinator = {
  AND: 'AND',
  OR: 'OR'
} as const;

export type BroadcastConditionsCombinator = typeof BroadcastConditionsCombinator[keyof typeof BroadcastConditionsCombinator];
/**
 * INFLUENCER_TAG will be deprecated in future, please use INFLUENCER_CUSTOMER_TAGS instead
 *
 * example value for each condition type
 *
 * INFLUENCER_JOINING_CAMPAIGNS (1 JSON string) = ['{"id":"3302","campaignType":"CAMPAIGN_TYPE_MARKETPLACE"}']
 * INFLUENCER_CUSTOMER_TAGS (array of JSON string) = [
 *  '{"id":"1","name":"hakami","isInfluencerTag":true}',
 *  '{"id":"CT_1","name":"AnyChat","isInfluencerTag":false}'
 * ]
 */
export type BroadcastInfluencerCondition = {
  __typename?: 'BroadcastInfluencerCondition';
  id: Scalars['String']['output'];
  operator: BroadcastConditionOperator;
  type: BroadcastInfluencerConditionType;
  values: Array<Scalars['String']['output']>;
};

/**
 * INFLUENCER_TAG will be deprecated in future, please use INFLUENCER_CUSTOMER_TAGS instead
 *
 * example value for each condition type
 *
 * INFLUENCER_JOINING_CAMPAIGNS (1 JSON string) = ['{"id":"3302","campaignType":"CAMPAIGN_TYPE_MARKETPLACE"}']
 * INFLUENCER_CUSTOMER_TAGS (array of JSON string) = [
 *  '{"id":"1","name":"hakami","isInfluencerTag":true}',
 *  '{"id":"CT_1","name":"AnyChat","isInfluencerTag":false}'
 * ]
 */
export type BroadcastInfluencerConditionInput = {
  id: Scalars['String']['input'];
  operator: BroadcastConditionOperator;
  type: BroadcastInfluencerConditionType;
  values: Array<Scalars['String']['input']>;
};

export const BroadcastInfluencerConditionType = {
  INFLUENCER_AGE: 'INFLUENCER_AGE',
  INFLUENCER_CAMPAIGN_JOINING_STATUS: 'INFLUENCER_CAMPAIGN_JOINING_STATUS',
  INFLUENCER_CAMPAIGN_POSTING_STATUS: 'INFLUENCER_CAMPAIGN_POSTING_STATUS',
  INFLUENCER_CATEGORY: 'INFLUENCER_CATEGORY',
  INFLUENCER_CUSTOMER_TAGS: 'INFLUENCER_CUSTOMER_TAGS',
  INFLUENCER_GENDER: 'INFLUENCER_GENDER',
  INFLUENCER_JOINED_CAMPAIGNS: 'INFLUENCER_JOINED_CAMPAIGNS',
  INFLUENCER_JOINING_CAMPAIGNS: 'INFLUENCER_JOINING_CAMPAIGNS',
  INFLUENCER_NUMBER_OF_FOLLOWERS: 'INFLUENCER_NUMBER_OF_FOLLOWERS',
  INFLUENCER_PARTICIPATED_CAMPAIGNS: 'INFLUENCER_PARTICIPATED_CAMPAIGNS',
  INFLUENCER_REGISTERED_SOCIAL_MEDIA: 'INFLUENCER_REGISTERED_SOCIAL_MEDIA',
  INFLUENCER_SIGNED_UP_DATE: 'INFLUENCER_SIGNED_UP_DATE',
  INFLUENCER_TAG: 'INFLUENCER_TAG'
} as const;

export type BroadcastInfluencerConditionType = typeof BroadcastInfluencerConditionType[keyof typeof BroadcastInfluencerConditionType];
export type BroadcastInfluencerConditionWrapper = {
  __typename?: 'BroadcastInfluencerConditionWrapper';
  combinator: BroadcastConditionsCombinator;
  conditions: Array<BroadcastInfluencerCondition>;
};

export type BroadcastInfluencerConditionWrapperInput = {
  combinator: BroadcastConditionsCombinator;
  conditions: Array<BroadcastInfluencerConditionInput>;
};

export type BroadcastStatistics = {
  __typename?: 'BroadcastStatistics';
  averageOrderValue: Scalars['Float']['output'];
  clickCount: Scalars['Int']['output'];
  clickRate: Scalars['Float']['output'];
  conversionCount: Scalars['Int']['output'];
  conversionRate: Scalars['Float']['output'];
  deliveredCount: Scalars['Int']['output'];
  openCount: Scalars['Int']['output'];
  openRate: Scalars['Float']['output'];
  saleAmount: Scalars['Float']['output'];
};

export const BroadcastStatus = {
  DELIVERED: 'DELIVERED',
  DRAFT: 'DRAFT',
  ERROR: 'ERROR',
  SCHEDULED: 'SCHEDULED',
  SENDING: 'SENDING'
} as const;

export type BroadcastStatus = typeof BroadcastStatus[keyof typeof BroadcastStatus];
export type BulkInventorySyncInput = {
  filter?: InputMaybe<ProductVariantListFilterInput>;
  productVariantIds: Array<Scalars['Long']['input']>;
};

export type BulkOperationResponse = {
  __typename?: 'BulkOperationResponse';
  failed: Scalars['Int']['output'];
  succeeded: Scalars['Int']['output'];
};

export type ButtonActionLabelInput = {
  label: Scalars['String']['input'];
  linkedPostback?: InputMaybe<LinkedPostbackActionInput>;
  type: LineCardButtonActionType;
  url?: InputMaybe<UrlActionInput>;
  urlVariable?: InputMaybe<UrlVariableActionInput>;
};

export type ButtonCardImage = {
  __typename?: 'ButtonCardImage';
  action?: Maybe<LineCardButtonAction>;
  url: Scalars['String']['output'];
};

export type ButtonMessage = {
  __typename?: 'ButtonMessage';
  cards: Array<Card>;
};

export type ButtonMessageInputV2 = {
  cards: Array<CardInputV2>;
};

export type BytePlus = {
  __typename?: 'BytePlus';
  platform: Scalars['String']['output'];
};

/** List of BytePlus livestream events */
export type BytePlusEventListOutput = {
  __typename?: 'BytePlusEventListOutput';
  /** List of events */
  items: Array<BytePlusEventOutput>;
};

/** BytePlus livestream event */
export type BytePlusEventOutput = {
  __typename?: 'BytePlusEventOutput';
  /** Event ID */
  id: Scalars['String']['output'];
  /** Event status (e.g., LIVE, SCHEDULED, ENDED) */
  status: Scalars['String']['output'];
  /** Event thumbnail URL */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Event title */
  title: Scalars['String']['output'];
};

/** List of BytePlus products */
export type BytePlusProductListOutput = {
  __typename?: 'BytePlusProductListOutput';
  /** List of products */
  items: Array<BytePlusProductOutput>;
};

/** BytePlus product */
export type BytePlusProductOutput = {
  __typename?: 'BytePlusProductOutput';
  /** Product ID */
  id: Scalars['String']['output'];
  /** Product image URL */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Product name */
  name: Scalars['String']['output'];
};

export const CrmType = {
  COMMERCIAL: 'COMMERCIAL',
  INFLUENCER: 'INFLUENCER'
} as const;

export type CrmType = typeof CrmType[keyof typeof CrmType];
export type CampaignHistory = {
  __typename?: 'CampaignHistory';
  campaignName: Scalars['String']['output'];
  campaignUrl: Scalars['String']['output'];
  joinedDatetime: Scalars['OffsetDateTime']['output'];
  thumbnail: Scalars['String']['output'];
};

export type CancelOrderInput = {
  orderIds: Array<Scalars['Long']['input']>;
};

export type CancelOrderPayload = {
  __typename?: 'CancelOrderPayload';
  failureOrderIds: Array<FailureCancelOrder>;
  successOrderIds: Array<Scalars['Long']['output']>;
};

export type Card = {
  __typename?: 'Card';
  actionLabelsV2?: Maybe<Array<ActionLabelV2>>;
  description?: Maybe<TextComponent>;
  image?: Maybe<ButtonCardImage>;
  imageBelowDescription: Scalars['Boolean']['output'];
  title?: Maybe<TextComponent>;
};

export type CardInputV2 = {
  actionLabels?: InputMaybe<Array<ButtonActionLabelInput>>;
  description?: InputMaybe<TextComponentInput>;
  imageBelowDescription: Scalars['Boolean']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<TextComponentInput>;
};

export const Category = {
  GIFT: 'GIFT',
  MERCHANDISE: 'MERCHANDISE',
  NON_COMMERCIAL_DOCS: 'NON_COMMERCIAL_DOCS',
  OTHER: 'OTHER',
  PERSONAL: 'PERSONAL',
  REPAIR: 'REPAIR',
  RETURN: 'RETURN',
  SAMPLE: 'SAMPLE'
} as const;

export type Category = typeof Category[keyof typeof Category];
export type ChannelCustomerInput = {
  chatId?: InputMaybe<Scalars['String']['input']>;
  externalCustomerId?: InputMaybe<Scalars['String']['input']>;
  type: ChannelCustomerLookupType;
};

export const ChannelCustomerLookupType = {
  ByAnyTag: 'ByAnyTag',
  ByChatId: 'ByChatId',
  ByExternalCustomerId: 'ByExternalCustomerId'
} as const;

export type ChannelCustomerLookupType = typeof ChannelCustomerLookupType[keyof typeof ChannelCustomerLookupType];
export const ChannelFormStatus = {
  DELETED: 'DELETED',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS'
} as const;

export type ChannelFormStatus = typeof ChannelFormStatus[keyof typeof ChannelFormStatus];
export const ChannelProvider = {
  MANUAL: 'MANUAL',
  QOO10: 'QOO10',
  RAKUTEN: 'RAKUTEN',
  SHOPEE: 'SHOPEE',
  SHOPIFY: 'SHOPIFY'
} as const;

export type ChannelProvider = typeof ChannelProvider[keyof typeof ChannelProvider];
export type Chat = {
  __typename?: 'Chat';
  assignees: Array<BasicUser>;
  avatar: Scalars['String']['output'];
  checked: Scalars['Boolean']['output'];
  customerTags: Array<CustomerTag>;
  id: Scalars['String']['output'];
  isAIActivated: Scalars['Boolean']['output'];
  lastMessage: Scalars['String']['output'];
  lastMessageAt: Scalars['UnixTimestamp']['output'];
  muted: Scalars['Boolean']['output'];
  notices: Array<ChatNotice>;
  resolved: Scalars['Boolean']['output'];
  status: CustomerChatStatus;
  type: ChatType;
  userName: Scalars['String']['output'];
};

export type ChatAiAssignee = {
  __typename?: 'ChatAIAssignee';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type ChatActivateAiRequest = {
  chatId: Scalars['String']['input'];
};

export type ChatAddUserToAssigneesRequest = {
  chatId: Scalars['String']['input'];
  userId: Scalars['Long']['input'];
};

export type ChatAssignee = ChatAiAssignee | ChatUserAssignee;

export type ChatChannel = {
  __typename?: 'ChatChannel';
  channel: ChatType;
  chatId: Scalars['String']['output'];
  createdAt: Scalars['UnixTimestamp']['output'];
  customerProfile?: Maybe<AnyChatCustomerProfile>;
};

export type ChatCustomerDetail = {
  __typename?: 'ChatCustomerDetail';
  chatAvatar: Scalars['String']['output'];
  chatId: Scalars['String']['output'];
  chatPlatformDetail: SpecificChatPlatformDetail;
  chatUserName: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerTags: Array<CustomerTag>;
  /** AnyTag influencer this customer is linked to, even when STALE; null when not linked or not an influencer-mode account */
  influencerId?: Maybe<Scalars['Long']['output']>;
  influencerInfo?: Maybe<InfluencerInfo>;
  influencerLinkStatus: CustomerInfluencerLinkStatus;
  influencerName?: Maybe<Scalars['String']['output']>;
  lastOrderAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  name: Scalars['String']['output'];
  orderNum: Scalars['Int']['output'];
  shopifyCustomerFirstName?: Maybe<Scalars['String']['output']>;
  shopifyCustomerId?: Maybe<Scalars['String']['output']>;
  shopifyCustomerLastName?: Maybe<Scalars['String']['output']>;
  shopifyCustomerUrl?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['UnixTimestamp']['output'];
  totalSpent: Scalars['String']['output'];
  type: ChatType;
};

export type ChatDeactivateAiRequest = {
  chatId: Scalars['String']['input'];
};

export const ChatNotice = {
  RECEIPT_CAMPAIGN_WIZARD: 'RECEIPT_CAMPAIGN_WIZARD'
} as const;

export type ChatNotice = typeof ChatNotice[keyof typeof ChatNotice];
export type ChatRemoveUserFromAssigneesRequest = {
  chatId: Scalars['String']['input'];
  userId: Scalars['Long']['input'];
};

export type ChatResolveRequest = {
  chatId: Scalars['String']['input'];
};

export type ChatSetMutedRequest = {
  chatId: Scalars['String']['input'];
  muted: Scalars['Boolean']['input'];
};

export type ChatShopeeCoinCashBack = {
  __typename?: 'ChatShopeeCoinCashBack';
  percentage: Scalars['Int']['output'];
};

export type ChatShopeeDiscount = ChatShopeeCoinCashBack | ChatShopeeFixedDiscount | ChatShopeePercentageDiscount;

export type ChatShopeeFixedDiscount = {
  __typename?: 'ChatShopeeFixedDiscount';
  amount: Scalars['BigDecimal']['output'];
};

export type ChatShopeePercentageDiscount = {
  __typename?: 'ChatShopeePercentageDiscount';
  percentage: Scalars['Int']['output'];
};

export type ChatShopeeVoucher = {
  __typename?: 'ChatShopeeVoucher';
  currency: Scalars['String']['output'];
  discount: ChatShopeeDiscount;
  displayStartTime: Scalars['OffsetDateTime']['output'];
  minBasketPrice?: Maybe<Scalars['BigDecimal']['output']>;
  name: Scalars['String']['output'];
  status: ShopeeVoucherStatus;
  usageUrl: Scalars['String']['output'];
  validUntil: Scalars['OffsetDateTime']['output'];
  voucherCode: Scalars['String']['output'];
  voucherId: Scalars['Long']['output'];
};

export type ChatState = {
  __typename?: 'ChatState';
  shopifyCustomerId?: Maybe<Scalars['String']['output']>;
};

export type ChatStateUpdateRequest = {
  chatId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export const ChatType = {
  INSTAGRAM: 'INSTAGRAM',
  LAZADA: 'LAZADA',
  LINE: 'LINE',
  MESSENGER: 'MESSENGER',
  SHOPEE: 'SHOPEE',
  TIKTOK_SHOP: 'TIKTOK_SHOP',
  WHATSAPP: 'WHATSAPP'
} as const;

export type ChatType = typeof ChatType[keyof typeof ChatType];
export const ChatTypeFilter = {
  ACTIVATED: 'ACTIVATED',
  ALL: 'ALL',
  ASSIGNED_TO_ME: 'ASSIGNED_TO_ME',
  MUTED: 'MUTED',
  ONGOING: 'ONGOING',
  REPLIED: 'REPLIED',
  UNREAD: 'UNREAD'
} as const;

export type ChatTypeFilter = typeof ChatTypeFilter[keyof typeof ChatTypeFilter];
export type ChatUnresolveRequest = {
  chatId: Scalars['String']['input'];
};

export type ChatUserAssignee = {
  __typename?: 'ChatUserAssignee';
  user: BasicUser;
};

export type Chats = {
  __typename?: 'Chats';
  activatedCount: Scalars['Int']['output'];
  assignedToMeCount: Scalars['Int']['output'];
  chats: Array<Chat>;
  hasNext: Scalars['Boolean']['output'];
  mutedCount: Scalars['Int']['output'];
  ongoingCount: Scalars['Int']['output'];
  repliedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

/** Compare momo's current show for a live with a MOMO livestream room. */
export type CheckMomoConnectionInput = {
  /** The connect dialog's pre-check: other lives the operator selected with the checked one. Each must pass the same gates as a candidate; those whose goods differ from the checked live's are listed in goodsMismatchedConnectionIds. Nothing is connected. Omit for none. */
  additionalMomoConnectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The MOMO livestream room. */
  livestreamRoomId: Scalars['ID']['input'];
  /** Omit to check the room's current live; give a live of the room's queue, or a candidate to preview a connect / switch. */
  momoConnectionId?: InputMaybe<Scalars['ID']['input']>;
};

export type ClipboardAction = {
  __typename?: 'ClipboardAction';
  clipboardText: Scalars['String']['output'];
};

export type CloseChat = {
  __typename?: 'CloseChat';
  isAuto: Scalars['Boolean']['output'];
};

/** Input for creating a comment analysis report. */
export type CommentAnalysisReportCreateInput = {
  /** List of livestream IDs to analyze comments for. */
  livestreamIds: Array<Scalars['String']['input']>;
  /** User ID of the user requesting the analysis. */
  userId: Scalars['Long']['input'];
};

/** Output type for a comment analysis report. */
export type CommentAnalysisReportOutput = {
  __typename?: 'CommentAnalysisReportOutput';
  /** Comment analysis report ID. */
  id: Scalars['ID']['output'];
};

export const CommentFeedback = {
  THUMBS_DOWN: 'THUMBS_DOWN',
  THUMBS_UP: 'THUMBS_UP'
} as const;

export type CommentFeedback = typeof CommentFeedback[keyof typeof CommentFeedback];
/** Filter input for comment list within a session. */
export type CommentListFilterInput = {
  commentTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  commentTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  isProductSwitch?: InputMaybe<Scalars['Boolean']['input']>;
  replyMode?: InputMaybe<ReplyMode>;
  replyTypes?: InputMaybe<Array<ReplyType>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** A comment reply record capturing one reply event. */
export type CommentReplyRecordGql = {
  __typename?: 'CommentReplyRecordGql';
  anyliveRoomId: Scalars['ID']['output'];
  anyliveRoomName: Scalars['String']['output'];
  commentContent: Scalars['String']['output'];
  commentTime: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentProduct?: Maybe<Scalars['String']['output']>;
  extendedInfo?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<CommentFeedback>;
  /** Record ID. */
  id: Scalars['ID']['output'];
  livePlatform: LivePlatform;
  platformRoomName: Scalars['String']['output'];
  platformSessionId: Scalars['String']['output'];
  replyContent?: Maybe<Scalars['String']['output']>;
  replyMode: ReplyMode;
  replyType: ReplyType;
  username: Scalars['String']['output'];
};

/** A paginated list of comment reply records. */
export type CommentReplyRecordList = PaginatedList & {
  __typename?: 'CommentReplyRecordList';
  items: Array<CommentReplyRecordGql>;
  totalCount: Scalars['Int']['output'];
};

export type CommonChatEvent = {
  __typename?: 'CommonChatEvent';
  event: CommonChatEventData;
  id: Scalars['String']['output'];
  timestamp: Scalars['UnixTimestamp']['output'];
};

export type CommonChatEventData = AiMessageFailedToSendEvent | ActivateAi | AddUserToAssigneeList | CloseChat | DeactivateAi | ManualAssign | ManualUnassign | MessageSendFailedEvent | MuteChat | RemoveUserFromAssigneeList | ReopenChat | SystemAutoAssignAi | SystemAutoUnassignAi | UnmuteChat;

export type CompleteSendingMessengerBroadcastSuccess = {
  __typename?: 'CompleteSendingMessengerBroadcastSuccess';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type Condition = {
  __typename?: 'Condition';
  condition: BroadcastConditionWrapper;
};

export const ConditionOperator = {
  BEGINS_WITH: 'BEGINS_WITH',
  BETWEEN: 'BETWEEN',
  BLANK: 'BLANK',
  CONTAINS: 'CONTAINS',
  DOES_NOT_BEGIN_WITH: 'DOES_NOT_BEGIN_WITH',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  DOES_NOT_END_WITH: 'DOES_NOT_END_WITH',
  ENDS_WITH: 'ENDS_WITH',
  EQUALS: 'EQUALS',
  GREATER_THAN: 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL_TO: 'GREATER_THAN_OR_EQUAL_TO',
  IN: 'IN',
  LESS_THAN: 'LESS_THAN',
  LESS_THAN_OR_EQUAL_TO: 'LESS_THAN_OR_EQUAL_TO',
  NOT_BETWEEN: 'NOT_BETWEEN',
  NOT_BLANK: 'NOT_BLANK',
  NOT_EQUAL_TO: 'NOT_EQUAL_TO',
  NOT_IN: 'NOT_IN',
  NOT_NULL: 'NOT_NULL',
  NULL: 'NULL'
} as const;

export type ConditionOperator = typeof ConditionOperator[keyof typeof ConditionOperator];
export const ConditionType = {
  CUSTOMER_AMOUNT_SPENT: 'CUSTOMER_AMOUNT_SPENT',
  CUSTOMER_ITEM_PURCHASED: 'CUSTOMER_ITEM_PURCHASED',
  CUSTOMER_NUMBER_OF_ORDERS: 'CUSTOMER_NUMBER_OF_ORDERS',
  CUSTOMER_TAGS: 'CUSTOMER_TAGS',
  LINE_SHOPIFY_CONNECTED: 'LINE_SHOPIFY_CONNECTED',
  LINE_SHOPIFY_CUSTOMER_ENABLED: 'LINE_SHOPIFY_CUSTOMER_ENABLED',
  MESSAGE_TEXT: 'MESSAGE_TEXT',
  ORDER_FULFILLMENT_STATUS: 'ORDER_FULFILLMENT_STATUS',
  ORDER_GRAND_TOTAL: 'ORDER_GRAND_TOTAL',
  ORDER_PAYMENT_STATUS: 'ORDER_PAYMENT_STATUS',
  ORDER_QUANTITY_ITEMS: 'ORDER_QUANTITY_ITEMS',
  ORDER_SUBTOTAL: 'ORDER_SUBTOTAL',
  RICH_MENU_ID: 'RICH_MENU_ID',
  RICH_MENU_ID_AND_TRIGGER: 'RICH_MENU_ID_AND_TRIGGER',
  RICH_MENU_TRIGGER: 'RICH_MENU_TRIGGER'
} as const;

export type ConditionType = typeof ConditionType[keyof typeof ConditionType];
export type ConditionalSplitBlock = {
  __typename?: 'ConditionalSplitBlock';
  combinator: ConditionsCombinator;
  conditions: Array<WorkflowCondition>;
  nextMeetBlockId?: Maybe<Scalars['String']['output']>;
  nextOtherBlockId?: Maybe<Scalars['String']['output']>;
};

export type ConditionalSplitBlockInput = {
  combinator: ConditionsCombinator;
  conditions: Array<WorkflowConditionInput>;
  nextMeetBlockId?: InputMaybe<Scalars['String']['input']>;
  nextOtherBlockId?: InputMaybe<Scalars['String']['input']>;
};

export const ConditionsCombinator = {
  AND: 'AND',
  OR: 'OR'
} as const;

export type ConditionsCombinator = typeof ConditionsCombinator[keyof typeof ConditionsCombinator];
export type ConfirmValidJapanOrderAddressInput = {
  houseNumber: Scalars['String']['input'];
  orderId: Scalars['Long']['input'];
  validAddressId: Scalars['Int']['input'];
};

export type ConfirmValidJapanOrderAddressPayload = {
  __typename?: 'ConfirmValidJapanOrderAddressPayload';
  ok: Scalars['Boolean']['output'];
};

export type ConnectLazadaRequest = {
  code: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type ConnectLazadaResponse = ConnectLazadaResponseSuccess | UnknownErrorConnectLazadaError;

export type ConnectLazadaResponseSuccess = {
  __typename?: 'ConnectLazadaResponseSuccess';
  connectionId: Scalars['String']['output'];
};

export type ConnectShopeeChatContinueSelectShopResponse = {
  __typename?: 'ConnectShopeeChatContinueSelectShopResponse';
  shops: Array<ShopeeContinueShopSelectionItem>;
  tempConnectionId: Scalars['String']['output'];
};

export type ConnectShopeeChatForMainAccountRequest = {
  code: Scalars['String']['input'];
  mainAccountId: Scalars['Long']['input'];
  storeId: Scalars['Long']['input'];
};

export type ConnectShopeeChatForSelectedShopRequest = {
  shopId: Scalars['Long']['input'];
  tempConnectionId: Scalars['String']['input'];
};

export type ConnectShopeeChatForShopAccountRequest = {
  code: Scalars['String']['input'];
  shopId: Scalars['Long']['input'];
  storeId: Scalars['Long']['input'];
};

export type ConnectShopeeChatRequestInput = {
  inputType: ConnectShopeeInputType;
  mainAccountInput?: InputMaybe<ConnectShopeeChatForMainAccountRequest>;
  selectedShopInput?: InputMaybe<ConnectShopeeChatForSelectedShopRequest>;
  shopAccountInput?: InputMaybe<ConnectShopeeChatForShopAccountRequest>;
};

export type ConnectShopeeChatResponse = ConnectShopeeChatContinueSelectShopResponse | ConnectShopeeChatSuccessResponse;

export type ConnectShopeeChatSuccessResponse = {
  __typename?: 'ConnectShopeeChatSuccessResponse';
  connectionId: Scalars['String']['output'];
};

export const ConnectShopeeInputType = {
  MAIN_ACCOUNT: 'MAIN_ACCOUNT',
  SELECTED_SHOP: 'SELECTED_SHOP',
  SHOP_ACCOUNT: 'SHOP_ACCOUNT'
} as const;

export type ConnectShopeeInputType = typeof ConnectShopeeInputType[keyof typeof ConnectShopeeInputType];
export type ConnectTikTokShopRequest = {
  authCode: Scalars['String']['input'];
  region: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type ConnectTikTokShopResponse = {
  __typename?: 'ConnectTikTokShopResponse';
  id: Scalars['String']['output'];
};

export type ConnectToFacebookRequestV2Input = {
  accessToken: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  platform: MetaMessagingPlatform;
  storeId: Scalars['Long']['input'];
};

export type ConnectToFacebookResponseSuccess = {
  __typename?: 'ConnectToFacebookResponseSuccess';
  connectionId: Scalars['String']['output'];
};

export type ConnectToFacebookResponseV2 = AccountAlreadyHaveConnection | ConnectToFacebookResponseSuccess | MessengerNotSupportChatPlugInWithAnonymousUserFacebookError | NoInstagramAccountConnectToFacebookError | PageHaveConnectedToOtherStore | UnknownErrorConnectToFacebookError;

export type ConnectToWhatsAppAccountAlreadyHaveConnection = {
  __typename?: 'ConnectToWhatsAppAccountAlreadyHaveConnection';
  message: Scalars['String']['output'];
};

export type ConnectToWhatsAppResponse = ConnectToWhatsAppAccountAlreadyHaveConnection | ConnectToWhatsAppResponseSuccess | UnknownErrorConnectToWhatsAppError;

export type ConnectToWhatsAppResponseSuccess = {
  __typename?: 'ConnectToWhatsAppResponseSuccess';
  connectionId: Scalars['String']['output'];
};

export type ConnectWhatsAppRequestInput = {
  businessAccountId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type Contact = {
  attentionName?: InputMaybe<Scalars['String']['input']>;
  businessName: Scalars['String']['input'];
  contactName?: InputMaybe<ContactName>;
  contactType?: InputMaybe<UpsContactType>;
  departmentName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  mailStopCode?: InputMaybe<Scalars['String']['input']>;
  notificationPreference: Scalars['Boolean']['input'];
  phone?: InputMaybe<UpsPhone>;
};

export type ContactName = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ContainsKeyword = {
  __typename?: 'ContainsKeyword';
  value: Scalars['String']['output'];
};

export type ContainsKeywordInput = {
  value: Scalars['String']['input'];
};

export const ConversionReplyMode = {
  AGGRESSIVE: 'AGGRESSIVE',
  BALANCED: 'BALANCED',
  STABLE: 'STABLE'
} as const;

export type ConversionReplyMode = typeof ConversionReplyMode[keyof typeof ConversionReplyMode];
export const Country = {
  AC: 'AC',
  AD: 'AD',
  AE: 'AE',
  AF: 'AF',
  AG: 'AG',
  AI: 'AI',
  AL: 'AL',
  AM: 'AM',
  AN: 'AN',
  AO: 'AO',
  AQ: 'AQ',
  AR: 'AR',
  AS: 'AS',
  AT: 'AT',
  AU: 'AU',
  AW: 'AW',
  AX: 'AX',
  AZ: 'AZ',
  BA: 'BA',
  BB: 'BB',
  BD: 'BD',
  BE: 'BE',
  BF: 'BF',
  BG: 'BG',
  BH: 'BH',
  BI: 'BI',
  BJ: 'BJ',
  BL: 'BL',
  BM: 'BM',
  BN: 'BN',
  BO: 'BO',
  BQ: 'BQ',
  BR: 'BR',
  BS: 'BS',
  BT: 'BT',
  BV: 'BV',
  BW: 'BW',
  BY: 'BY',
  BZ: 'BZ',
  CA: 'CA',
  CC: 'CC',
  CD: 'CD',
  CF: 'CF',
  CG: 'CG',
  CH: 'CH',
  CI: 'CI',
  CK: 'CK',
  CL: 'CL',
  CM: 'CM',
  CN: 'CN',
  CO: 'CO',
  CR: 'CR',
  CU: 'CU',
  CV: 'CV',
  CW: 'CW',
  CX: 'CX',
  CY: 'CY',
  CZ: 'CZ',
  DE: 'DE',
  DJ: 'DJ',
  DK: 'DK',
  DM: 'DM',
  DO: 'DO',
  DZ: 'DZ',
  EC: 'EC',
  EE: 'EE',
  EG: 'EG',
  EH: 'EH',
  ER: 'ER',
  ES: 'ES',
  ET: 'ET',
  FI: 'FI',
  FJ: 'FJ',
  FK: 'FK',
  FM: 'FM',
  FO: 'FO',
  FR: 'FR',
  GA: 'GA',
  GB: 'GB',
  GD: 'GD',
  GE: 'GE',
  GF: 'GF',
  GG: 'GG',
  GH: 'GH',
  GI: 'GI',
  GL: 'GL',
  GM: 'GM',
  GN: 'GN',
  GP: 'GP',
  GQ: 'GQ',
  GR: 'GR',
  GS: 'GS',
  GT: 'GT',
  GU: 'GU',
  GW: 'GW',
  GY: 'GY',
  HK: 'HK',
  HM: 'HM',
  HN: 'HN',
  HR: 'HR',
  HT: 'HT',
  HU: 'HU',
  ID: 'ID',
  IE: 'IE',
  IL: 'IL',
  IM: 'IM',
  IN: 'IN',
  IO: 'IO',
  IQ: 'IQ',
  IR: 'IR',
  IS: 'IS',
  IT: 'IT',
  JE: 'JE',
  JM: 'JM',
  JO: 'JO',
  JP: 'JP',
  KE: 'KE',
  KG: 'KG',
  KH: 'KH',
  KI: 'KI',
  KM: 'KM',
  KN: 'KN',
  KP: 'KP',
  KR: 'KR',
  KW: 'KW',
  KY: 'KY',
  KZ: 'KZ',
  LA: 'LA',
  LB: 'LB',
  LC: 'LC',
  LI: 'LI',
  LK: 'LK',
  LR: 'LR',
  LS: 'LS',
  LT: 'LT',
  LU: 'LU',
  LV: 'LV',
  LY: 'LY',
  MA: 'MA',
  MC: 'MC',
  MD: 'MD',
  ME: 'ME',
  MF: 'MF',
  MG: 'MG',
  MH: 'MH',
  MK: 'MK',
  ML: 'ML',
  MM: 'MM',
  MN: 'MN',
  MO: 'MO',
  MP: 'MP',
  MQ: 'MQ',
  MR: 'MR',
  MS: 'MS',
  MT: 'MT',
  MU: 'MU',
  MV: 'MV',
  MW: 'MW',
  MX: 'MX',
  MY: 'MY',
  MZ: 'MZ',
  NA: 'NA',
  NC: 'NC',
  NE: 'NE',
  NF: 'NF',
  NG: 'NG',
  NI: 'NI',
  NL: 'NL',
  NO: 'NO',
  NP: 'NP',
  NR: 'NR',
  NU: 'NU',
  NZ: 'NZ',
  OM: 'OM',
  PA: 'PA',
  PE: 'PE',
  PF: 'PF',
  PG: 'PG',
  PH: 'PH',
  PK: 'PK',
  PL: 'PL',
  PM: 'PM',
  PN: 'PN',
  PR: 'PR',
  PS: 'PS',
  PT: 'PT',
  PW: 'PW',
  PY: 'PY',
  QA: 'QA',
  RE: 'RE',
  RO: 'RO',
  RS: 'RS',
  RU: 'RU',
  RW: 'RW',
  SA: 'SA',
  SB: 'SB',
  SC: 'SC',
  SD: 'SD',
  SE: 'SE',
  SG: 'SG',
  SH: 'SH',
  SI: 'SI',
  SJ: 'SJ',
  SK: 'SK',
  SL: 'SL',
  SM: 'SM',
  SN: 'SN',
  SO: 'SO',
  SR: 'SR',
  SS: 'SS',
  ST: 'ST',
  SV: 'SV',
  SX: 'SX',
  SY: 'SY',
  SZ: 'SZ',
  TA: 'TA',
  TC: 'TC',
  TD: 'TD',
  TF: 'TF',
  TG: 'TG',
  TH: 'TH',
  TJ: 'TJ',
  TK: 'TK',
  TL: 'TL',
  TM: 'TM',
  TN: 'TN',
  TO: 'TO',
  TR: 'TR',
  TT: 'TT',
  TV: 'TV',
  TW: 'TW',
  TZ: 'TZ',
  UA: 'UA',
  UG: 'UG',
  UM: 'UM',
  US: 'US',
  UY: 'UY',
  UZ: 'UZ',
  VA: 'VA',
  VC: 'VC',
  VE: 'VE',
  VG: 'VG',
  VI: 'VI',
  VN: 'VN',
  VU: 'VU',
  WF: 'WF',
  WS: 'WS',
  XK: 'XK',
  YE: 'YE',
  YT: 'YT',
  ZA: 'ZA',
  ZM: 'ZM',
  ZW: 'ZW'
} as const;

export type Country = typeof Country[keyof typeof Country];
export type CourierAccountDetails = {
  __typename?: 'CourierAccountDetails';
  account: IdName;
  courierDetails?: Maybe<CourierDetails>;
  created: Scalars['Date']['output'];
  crossBorderCourierProvider: CrossBorderCourierProvider;
  id: Scalars['ID']['output'];
  merchantId: Scalars['String']['output'];
  status: CourierStatus;
  updated: Scalars['Date']['output'];
};

export type CourierAccountDetailsListResponse = Paginated & {
  __typename?: 'CourierAccountDetailsListResponse';
  courierAccountDetails: Array<CourierAccountDetails>;
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CourierAccountSupported = {
  __typename?: 'CourierAccountSupported';
  crossBorderCourierProvider: CrossBorderCourierProvider;
  name: Scalars['String']['output'];
};

export type CourierDetails = DhlAccountDetails | FedExAccountDetails | JapanPostAccountDetails | UpsAccountDetails;

export const CourierService = {
  ACCEPTANCE_RECORDED_MAIL: 'ACCEPTANCE_RECORDED_MAIL',
  CHARTER: 'CHARTER',
  CLICK_POST: 'CLICK_POST',
  DELIVERY_PROVIDER: 'DELIVERY_PROVIDER',
  DHL: 'DHL',
  ECMS: 'ECMS',
  ECOHAI: 'ECOHAI',
  FED_EX: 'FED_EX',
  FUKUTSU: 'FUKUTSU',
  GLOBAL_E_PARCEL: 'GLOBAL_E_PARCEL',
  IN_STORE_PICKUP: 'IN_STORE_PICKUP',
  IN_WAREHOUSE_PICKUP: 'IN_WAREHOUSE_PICKUP',
  JAD: 'JAD',
  JAPAN_POST_EMS: 'JAPAN_POST_EMS',
  JAPAN_POST_INTERNATIONAL_E_PACKET: 'JAPAN_POST_INTERNATIONAL_E_PACKET',
  JAPAN_POST_INTERNATIONAL_PARCELS: 'JAPAN_POST_INTERNATIONAL_PARCELS',
  JAPAN_POST_RAKUTEN_CVS: 'JAPAN_POST_RAKUTEN_CVS',
  JAPAN_POST_RAKUTEN_PO: 'JAPAN_POST_RAKUTEN_PO',
  JAPAN_POST_SMALL_PACKING: 'JAPAN_POST_SMALL_PACKING',
  KINBUTSU_REX: 'KINBUTSU_REX',
  KURUME: 'KURUME',
  LAST_ONE_MILE_BUSINESS_DELIVERY: 'LAST_ONE_MILE_BUSINESS_DELIVERY',
  LAST_ONE_MILE_PERSONAL_DELIVERY: 'LAST_ONE_MILE_PERSONAL_DELIVERY',
  LETTER_PACK_LIGHT: 'LETTER_PACK_LIGHT',
  LETTER_PACK_PLUS: 'LETTER_PACK_PLUS',
  MANUFACTURER_DIRECT: 'MANUFACTURER_DIRECT',
  NITTSU: 'NITTSU',
  NITTSU_EXPRESS_HIGH_SPEED: 'NITTSU_EXPRESS_HIGH_SPEED',
  NON_STANDARD_SIZE_MAIL: 'NON_STANDARD_SIZE_MAIL',
  PEGASUS: 'PEGASUS',
  RAKUTEN_EXPRESS: 'RAKUTEN_EXPRESS',
  RAKUTEN_EXPRESS_MAIL: 'RAKUTEN_EXPRESS_MAIL',
  SAGAWA: 'SAGAWA',
  SAGAWA_MAIL: 'SAGAWA_MAIL',
  SAGAWA_RAKUTEN_CVS: 'SAGAWA_RAKUTEN_CVS',
  SAGAWA_YU_MAIL: 'SAGAWA_YU_MAIL',
  SAGAWA_YU_PACKET_1CM: 'SAGAWA_YU_PACKET_1CM',
  SAGAWA_YU_PACKET_2CM: 'SAGAWA_YU_PACKET_2CM',
  SAGAWA_YU_PACKET_3CM: 'SAGAWA_YU_PACKET_3CM',
  SANYO_JIDOSHA: 'SANYO_JIDOSHA',
  SBS_SOKUHAI: 'SBS_SOKUHAI',
  SEINO_EXPRESS: 'SEINO_EXPRESS',
  SEINO_MINI: 'SEINO_MINI',
  STANDARD_SIZE_MAIL: 'STANDARD_SIZE_MAIL',
  TOLL_EXPRESS: 'TOLL_EXPRESS',
  TONAMI: 'TONAMI',
  UPS: 'UPS',
  YAMATO: 'YAMATO',
  YAMATO_BOX_CHARTER: 'YAMATO_BOX_CHARTER',
  YAMATO_COMPACT: 'YAMATO_COMPACT',
  YAMATO_MAIL: 'YAMATO_MAIL',
  YAMATO_NEKOPOSU: 'YAMATO_NEKOPOSU',
  YAMATO_POA: 'YAMATO_POA',
  YAMATO_RAKUTEN_CVS: 'YAMATO_RAKUTEN_CVS',
  YU_MAIL: 'YU_MAIL',
  YU_MAIL_150G: 'YU_MAIL_150G',
  YU_MAIL_250G: 'YU_MAIL_250G',
  YU_MAIL_500G: 'YU_MAIL_500G',
  YU_MAIL_1000G: 'YU_MAIL_1000G',
  YU_PACK: 'YU_PACK',
  YU_PACKET: 'YU_PACKET',
  YU_PACKET_1CM: 'YU_PACKET_1CM',
  YU_PACKET_2CM: 'YU_PACKET_2CM',
  YU_PACKET_3CM: 'YU_PACKET_3CM',
  YU_PACK_POA: 'YU_PACK_POA'
} as const;

export type CourierService = typeof CourierService[keyof typeof CourierService];
export type CourierServiceDetail = {
  __typename?: 'CourierServiceDetail';
  paymentMethodsV2: Array<PaymentMethodV2>;
  preferredDeliveryTimeFrames: Array<PreferredDeliveryTime>;
};

export type CourierSettings = {
  __typename?: 'CourierSettings';
  accountId: Scalars['ID']['output'];
  boxSizes?: Maybe<Array<BoxSize>>;
  category: Category;
  letterHeadImage?: Maybe<Scalars['String']['output']>;
  signatureImage?: Maybe<Scalars['String']['output']>;
};

export type CourierSettingsFilterInput = {
  country?: InputMaybe<Country>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  ready?: InputMaybe<AccountCourierSettingsStatus>;
};

export type CourierSettingsInput = {
  accountId: Scalars['ID']['input'];
  boxSizes: Array<BoxSizeInput>;
  category: Category;
  letterHeadImage?: InputMaybe<Scalars['String']['input']>;
  signatureImage?: InputMaybe<Scalars['String']['input']>;
};

export const CourierStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
} as const;

export type CourierStatus = typeof CourierStatus[keyof typeof CourierStatus];
export const CourierType = {
  ACCEPTANCE_RECORDED_MAIL: 'ACCEPTANCE_RECORDED_MAIL',
  CHARTER: 'CHARTER',
  CLICK_POST: 'CLICK_POST',
  DELIVERY_PROVIDER: 'DELIVERY_PROVIDER',
  DHL: 'DHL',
  ECMS: 'ECMS',
  ECOHAI: 'ECOHAI',
  FED_EX: 'FED_EX',
  FUKUTSU: 'FUKUTSU',
  GLOBAL_E_PARCEL: 'GLOBAL_E_PARCEL',
  IN_STORE_PICKUP: 'IN_STORE_PICKUP',
  IN_WAREHOUSE_PICKUP: 'IN_WAREHOUSE_PICKUP',
  JAD: 'JAD',
  JAPAN_POST: 'JAPAN_POST',
  JAPAN_POST_EMS: 'JAPAN_POST_EMS',
  JAPAN_POST_INTERNATIONAL_E_PACKET: 'JAPAN_POST_INTERNATIONAL_E_PACKET',
  JAPAN_POST_INTERNATIONAL_PARCELS: 'JAPAN_POST_INTERNATIONAL_PARCELS',
  JAPAN_POST_RAKUTEN_CVS: 'JAPAN_POST_RAKUTEN_CVS',
  JAPAN_POST_RAKUTEN_PO: 'JAPAN_POST_RAKUTEN_PO',
  JAPAN_POST_SMALL_PACKING: 'JAPAN_POST_SMALL_PACKING',
  KINBUTSU_REX: 'KINBUTSU_REX',
  KURUME: 'KURUME',
  LAST_ONE_MILE_BUSINESS_DELIVERY: 'LAST_ONE_MILE_BUSINESS_DELIVERY',
  LAST_ONE_MILE_PERSONAL_DELIVERY: 'LAST_ONE_MILE_PERSONAL_DELIVERY',
  LETTER_PACK_LIGHT: 'LETTER_PACK_LIGHT',
  LETTER_PACK_PLUS: 'LETTER_PACK_PLUS',
  MANUFACTURER_DIRECT: 'MANUFACTURER_DIRECT',
  NITTSU: 'NITTSU',
  NITTSU_EXPRESS_HIGH_SPEED: 'NITTSU_EXPRESS_HIGH_SPEED',
  NON_STANDARD_SIZE_MAIL: 'NON_STANDARD_SIZE_MAIL',
  PEGASUS: 'PEGASUS',
  RAKUTEN_EXPRESS: 'RAKUTEN_EXPRESS',
  RAKUTEN_EXPRESS_MAIL: 'RAKUTEN_EXPRESS_MAIL',
  SAGAWA: 'SAGAWA',
  SAGAWA_MAIL: 'SAGAWA_MAIL',
  SAGAWA_RAKUTEN_CVS: 'SAGAWA_RAKUTEN_CVS',
  SAGAWA_YU_MAIL: 'SAGAWA_YU_MAIL',
  SANYO_JIDOSHA: 'SANYO_JIDOSHA',
  SBS_SOKUHAI: 'SBS_SOKUHAI',
  SEINO_EXPRESS: 'SEINO_EXPRESS',
  SEINO_MINI: 'SEINO_MINI',
  STANDARD_SIZE_MAIL: 'STANDARD_SIZE_MAIL',
  TOLL_EXPRESS: 'TOLL_EXPRESS',
  TONAMI: 'TONAMI',
  UPS: 'UPS',
  YAMATO: 'YAMATO',
  YAMATO_BOX_CHARTER: 'YAMATO_BOX_CHARTER',
  YAMATO_COMPACT: 'YAMATO_COMPACT',
  YAMATO_MAIL: 'YAMATO_MAIL',
  YAMATO_NEKOPOSU: 'YAMATO_NEKOPOSU',
  YAMATO_POA: 'YAMATO_POA',
  YAMATO_RAKUTEN_CVS: 'YAMATO_RAKUTEN_CVS',
  YOU_PACK: 'YOU_PACK',
  YOU_PACK_POA: 'YOU_PACK_POA',
  YU_MAIL: 'YU_MAIL',
  YU_MAIL_150G: 'YU_MAIL_150G',
  YU_MAIL_250G: 'YU_MAIL_250G',
  YU_MAIL_500G: 'YU_MAIL_500G',
  YU_MAIL_1000G: 'YU_MAIL_1000G',
  YU_PACK: 'YU_PACK',
  YU_PACKET: 'YU_PACKET',
  YU_PACKET_1CM: 'YU_PACKET_1CM',
  YU_PACKET_2CM: 'YU_PACKET_2CM',
  YU_PACKET_3CM: 'YU_PACKET_3CM',
  YU_PACK_POA: 'YU_PACK_POA'
} as const;

export type CourierType = typeof CourierType[keyof typeof CourierType];
export type CpMetricsSummaryOutput = {
  __typename?: 'CpMetricsSummaryOutput';
  activeStreams: Scalars['Int']['output'];
  availableWorkers: Scalars['Int']['output'];
  totalWorkers: Scalars['Int']['output'];
};

export type CreateDatasourceInput = {
  masterDataStoreId: Scalars['Long']['input'];
  setting: DatasourceSettingInput;
  tokenId?: InputMaybe<Scalars['Long']['input']>;
  type: DatasourceType;
};

export type CreateManualOrderInput = {
  billingAddress: OrderAddressInput;
  channelOrderId?: InputMaybe<Scalars['String']['input']>;
  currency: CurrencyCode;
  customer: OrderCustomerInput;
  customerNote: Scalars['String']['input'];
  discount: Scalars['BigDecimal']['input'];
  /** only for logistics connected store */
  logisticsInput?: InputMaybe<LogisticsInput>;
  orderProductsV2: Array<OrderProductInputV2Input>;
  paymentMethod: PaymentMethodV2;
  /** if saleChannelId is null, will use Manual SaleChannel */
  saleChannelId?: InputMaybe<Scalars['Long']['input']>;
  shipping: Scalars['BigDecimal']['input'];
  shippingAddress: OrderAddressInput;
  storeId: Scalars['Long']['input'];
  totalTax: Scalars['BigDecimal']['input'];
};

export type CreateMarketplaceCalendarEventInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId?: InputMaybe<Scalars['Long']['input']>;
  saleChannelCountry?: InputMaybe<Scalars['String']['input']>;
  saleChannelType: SaleChannelType;
  startDate: Scalars['ZonedDatetime']['input'];
  title: Scalars['String']['input'];
};

export type CreateProductV2Input = {
  description: Scalars['String']['input'];
  /** only for logistics connected store */
  logistics?: InputMaybe<ProductLogisticsInput>;
  media: Array<Scalars['URL']['input']>;
  name: Scalars['String']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  storeId: Scalars['Long']['input'];
  variant: CreateProductVariantV2Input;
};

export type CreateProductVariantV2Input = {
  countryOfOrigin?: InputMaybe<ShopifySupportedCountry>;
  hsCode?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<GraphQlMoneyInput>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  setItems: Array<ProductVariantSetItemInput>;
  tags: Array<Scalars['String']['input']>;
  unitCost?: InputMaybe<GraphQlMoneyInput>;
  weightInGrams?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export const CredentialExpiryType = {
  EXPIRES: 'EXPIRES',
  NEVER_EXPIRES: 'NEVER_EXPIRES',
  UNKNOWN: 'UNKNOWN'
} as const;

export type CredentialExpiryType = typeof CredentialExpiryType[keyof typeof CredentialExpiryType];
export type CrossBorderBasicAuth = {
  __typename?: 'CrossBorderBasicAuth';
  apiKey: Scalars['String']['output'];
  apiSecret: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mdAccount: MdAccount;
};

export const CrossBorderCourierProvider = {
  DHL: 'DHL',
  FED_EX: 'FED_EX',
  JAPAN_POST: 'JAPAN_POST',
  UPS: 'UPS'
} as const;

export type CrossBorderCourierProvider = typeof CrossBorderCourierProvider[keyof typeof CrossBorderCourierProvider];
export const CrossBorderCourierType = {
  DHL: 'DHL',
  FED_EX: 'FED_EX',
  JAPAN_POST_EMS: 'JAPAN_POST_EMS',
  JAPAN_POST_INTERNATIONAL_PARCELS: 'JAPAN_POST_INTERNATIONAL_PARCELS',
  JAPAN_POST_SMALL_PACKING: 'JAPAN_POST_SMALL_PACKING',
  UPS: 'UPS'
} as const;

export type CrossBorderCourierType = typeof CrossBorderCourierType[keyof typeof CrossBorderCourierType];
export type CrossBorderServiceCode = DhlServiceCodeWrapper | FedExServiceCodeWrapper | JapanPostServiceCodeWrapper | UpsServiceCodeWrapper;

export const CrossBorderValidationError = {
  BILLING_ADDRESS_CANNOT_BE_EMPTY: 'BILLING_ADDRESS_CANNOT_BE_EMPTY',
  INVALID_TRANSLATED_SHIPPING_ADDRESS_CITY: 'INVALID_TRANSLATED_SHIPPING_ADDRESS_CITY',
  INVALID_TRANSLATED_SHIPPING_ADDRESS_COUNTRY_CODE: 'INVALID_TRANSLATED_SHIPPING_ADDRESS_COUNTRY_CODE',
  INVALID_TRANSLATED_SHIPPING_ADDRESS_POSTAL_CODE: 'INVALID_TRANSLATED_SHIPPING_ADDRESS_POSTAL_CODE',
  INVALID_TRANSLATED_SHIPPING_ADDRESS_PROVINCE: 'INVALID_TRANSLATED_SHIPPING_ADDRESS_PROVINCE',
  PRODUCT_NAME_MUST_BE_ALPHABET: 'PRODUCT_NAME_MUST_BE_ALPHABET',
  TRANSLATED_SHIPPING_ADDRESS_CANNOT_BE_EMPTY: 'TRANSLATED_SHIPPING_ADDRESS_CANNOT_BE_EMPTY',
  TRANSLATED_SHIPPING_NAME_CANNOT_BE_EMPTY: 'TRANSLATED_SHIPPING_NAME_CANNOT_BE_EMPTY',
  TRANSLATED_SHIPPING_PHONE_CANNOT_BE_EMPTY: 'TRANSLATED_SHIPPING_PHONE_CANNOT_BE_EMPTY'
} as const;

export type CrossBorderValidationError = typeof CrossBorderValidationError[keyof typeof CrossBorderValidationError];
export type CsvExportJobResult = {
  __typename?: 'CsvExportJobResult';
  jobId: Scalars['String']['output'];
  state: JobState;
  url?: Maybe<Scalars['String']['output']>;
};

export const CsvImportOperation = {
  ADD: 'ADD',
  UPDATE: 'UPDATE',
  UPDATE_GTIN: 'UPDATE_GTIN'
} as const;

export type CsvImportOperation = typeof CsvImportOperation[keyof typeof CsvImportOperation];
export type CsvTemplate = {
  __typename?: 'CsvTemplate';
  columns: Array<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
};

/** Supported currencies in the AnyMind Group system. */
export const Currency = {
  AED: 'AED',
  CAD: 'CAD',
  CNY: 'CNY',
  EUR: 'EUR',
  GBP: 'GBP',
  HKD: 'HKD',
  IDR: 'IDR',
  INR: 'INR',
  JPY: 'JPY',
  KHR: 'KHR',
  KRW: 'KRW',
  KWD: 'KWD',
  MMK: 'MMK',
  MYR: 'MYR',
  PHP: 'PHP',
  SAR: 'SAR',
  SGD: 'SGD',
  THB: 'THB',
  TWD: 'TWD',
  USD: 'USD',
  VND: 'VND'
} as const;

export type Currency = typeof Currency[keyof typeof Currency];
export const CurrencyCode = {
  AED: 'AED',
  AUD: 'AUD',
  BHD: 'BHD',
  BRL: 'BRL',
  CAD: 'CAD',
  CNY: 'CNY',
  EGP: 'EGP',
  EUR: 'EUR',
  GBP: 'GBP',
  HKD: 'HKD',
  IDR: 'IDR',
  INR: 'INR',
  JOD: 'JOD',
  JPY: 'JPY',
  KHR: 'KHR',
  KRW: 'KRW',
  KWD: 'KWD',
  MMK: 'MMK',
  MXN: 'MXN',
  MYR: 'MYR',
  OMR: 'OMR',
  PHP: 'PHP',
  PKR: 'PKR',
  PLN: 'PLN',
  QAR: 'QAR',
  SAR: 'SAR',
  SEK: 'SEK',
  SGD: 'SGD',
  THB: 'THB',
  TRY: 'TRY',
  TWD: 'TWD',
  USD: 'USD',
  VND: 'VND'
} as const;

export type CurrencyCode = typeof CurrencyCode[keyof typeof CurrencyCode];
export type CurrentLineRichMenuInput = {
  storeId: Scalars['Long']['input'];
};

export type Custom = {
  __typename?: 'Custom';
  rtmpServerUrl: Scalars['String']['output'];
  streamKeyMasked: Scalars['String']['output'];
};

/** RTMP destination for a CUSTOM (admin-only test) room. Unlike the marketplace platforms nothing is fetched on the operator's behalf — these values are streamed to as given. */
export type CustomSessionConfigInput = {
  /** Full RTMP server URL, e.g. rtmp://live.example.com/app. Must start with rtmp:// or rtmps://. */
  rtmpServerUrl: Scalars['String']['input'];
  /** Stream key issued by the destination. Stored server-side and never returned in full. */
  streamKey: Scalars['String']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<CustomerAddress>;
  age?: Maybe<Scalars['Int']['output']>;
  amountOfOrders: Scalars['Int']['output'];
  amountSpent: Scalars['String']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  chatChannels: Array<ChatChannel>;
  createdAt: Scalars['UnixTimestamp']['output'];
  customerTags: Array<CustomerTag>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  /** AnyTag influencer this customer is linked to; null when not linked or not an influencer-mode account */
  influencerId?: Maybe<Scalars['Long']['output']>;
  /** When the customer was linked to the AnyTag influencer `influencerId`; null when not linked or not an influencer-mode account */
  influencerLinkedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  lastOrderedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  saleChannelCustomers: Array<AnyChatSaleChannelCustomer>;
  shopifyMetafields: Array<CustomerShopifyMetafield>;
  size?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CustomerActivityV4 = {
  id: Scalars['String']['output'];
  timestamp: Scalars['UnixTimestamp']['output'];
};

export type CustomerActivityV4UpdatedField = {
  __typename?: 'CustomerActivityV4UpdatedField';
  fieldName: Scalars['String']['output'];
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country: MdCountry;
  /** There can be a case which we know province name, but not the code so we can prioritize render on province then fallBack on fallBackProvinceName */
  fallBackProvinceName?: Maybe<Scalars['String']['output']>;
  province?: Maybe<MdProvince>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type CustomerChatKeyWordSearchItem = {
  __typename?: 'CustomerChatKeyWordSearchItem';
  chatIds: Array<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  influencerName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export const CustomerChatStatus = {
  ONGOING: 'ONGOING',
  REPLIED: 'REPLIED',
  RESOLVED: 'RESOLVED'
} as const;

export type CustomerChatStatus = typeof CustomerChatStatus[keyof typeof CustomerChatStatus];
export const CustomerClassificationType = {
  BUSINESS: 'BUSINESS'
} as const;

export type CustomerClassificationType = typeof CustomerClassificationType[keyof typeof CustomerClassificationType];
export type CustomerCreatedActivityV4 = CustomerActivityV4 & {
  __typename?: 'CustomerCreatedActivityV4';
  channel: CustomerCreatedChannel;
  id: Scalars['String']['output'];
  timestamp: Scalars['UnixTimestamp']['output'];
};

export type CustomerCreatedChannel = CustomerCreatedMessagingChannel | CustomerCreatedSaleChannel;

export type CustomerCreatedMessagingChannel = {
  __typename?: 'CustomerCreatedMessagingChannel';
  chatType: ChatType;
};

export type CustomerCreatedSaleChannel = {
  __typename?: 'CustomerCreatedSaleChannel';
  saleChannel: AnyChatSaleChannelType;
};

export type CustomerGroupProfileUpdateConflictError = {
  __typename?: 'CustomerGroupProfileUpdateConflictError';
  emailConflicts: Array<Scalars['String']['output']>;
  phoneConflicts: Array<Scalars['String']['output']>;
};

export type CustomerIdInput = {
  customerId: Scalars['String']['input'];
};

/** Whether the chat's customer is linked to an AnyTag influencer, and whether AnyTag still has it */
export const CustomerInfluencerLinkStatus = {
  NOT_LINKED: 'NOT_LINKED',
  STALE: 'STALE',
  SYNCED: 'SYNCED'
} as const;

export type CustomerInfluencerLinkStatus = typeof CustomerInfluencerLinkStatus[keyof typeof CustomerInfluencerLinkStatus];
export type CustomerName = {
  firstName: Scalars['String']['input'];
  surname: Scalars['String']['input'];
};

export type CustomerNote = {
  __typename?: 'CustomerNote';
  channel: CustomerCreatedChannel;
  createdAt: Scalars['UnixTimestamp']['output'];
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['UnixTimestamp']['output'];
  user: BasicUser;
};

export type CustomerNoteV3CreateRequest = {
  channelCustomer: ChannelCustomerInput;
  customerGroupId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type CustomerNoteV3DeleteRequest = {
  customerGroupId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type CustomerNoteV3UpdateRequest = {
  customerGroupId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type CustomerNotesV3Request = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelCustomer?: InputMaybe<ChannelCustomerInput>;
  customerGroupId: Scalars['String']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
};

export type CustomerOrder = {
  __typename?: 'CustomerOrder';
  anyxOrderId?: Maybe<Scalars['String']['output']>;
  items: Array<OrderItem>;
  orderId: Scalars['String']['output'];
  orderUrl?: Maybe<Scalars['String']['output']>;
  orderedAt: Scalars['UnixTimestamp']['output'];
  saleChannelType: AnyChatSaleChannelType;
  status: DeliveryStatus;
  totalPrice: AnyChatMoney;
};

export type CustomerShopifyMetafield = {
  __typename?: 'CustomerShopifyMetafield';
  displayName: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
  valueFormat: MetafieldValueFormat;
};

export type CustomerTag = {
  __typename?: 'CustomerTag';
  id: Scalars['String']['output'];
  isInfluencerTag: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  taggedCount: Scalars['Int']['output'];
};

export type CustomerTagDeleteFailure = {
  __typename?: 'CustomerTagDeleteFailure';
  customerTagInUses: Array<CustomerTag>;
};

export type CustomerTagDeleteResponse = CustomerTagDeleteFailure | CustomerTagDeleteSuccess;

export type CustomerTagDeleteSuccess = {
  __typename?: 'CustomerTagDeleteSuccess';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerTagName = {
  __typename?: 'CustomerTagName';
  name: Scalars['String']['output'];
};

export type CustomerTagNames = {
  __typename?: 'CustomerTagNames';
  names: Array<Scalars['String']['output']>;
};

export const CustomerTagOrdering = {
  ByAlphabetical: 'ByAlphabetical',
  ByDateCreated: 'ByDateCreated',
  ByFrequentlyUsed: 'ByFrequentlyUsed'
} as const;

export type CustomerTagOrdering = typeof CustomerTagOrdering[keyof typeof CustomerTagOrdering];
export type CustomerTags = {
  __typename?: 'CustomerTags';
  customerTags: Array<CustomerTag>;
  total: Scalars['Int']['output'];
};

export type Customers = {
  __typename?: 'Customers';
  customers: Array<Customer>;
  total: Scalars['Int']['output'];
};

export const CustomersSortField = {
  AmountOfOrders: 'AmountOfOrders',
  AmountSpent: 'AmountSpent',
  CreatedDate: 'CreatedDate',
  Email: 'Email',
  LastOrderDate: 'LastOrderDate',
  Name: 'Name'
} as const;

export type CustomersSortField = typeof CustomersSortField[keyof typeof CustomersSortField];
export type CustomersSortInput = {
  descending: Scalars['Boolean']['input'];
  field: CustomersSortField;
};

export type DhlAccountDetails = {
  __typename?: 'DHLAccountDetails';
  dhlAccountNumber: Scalars['String']['output'];
  dhlApiKey: Scalars['String']['output'];
  dhlApiSecret: Scalars['String']['output'];
  dhlCorporateNumber?: Maybe<Scalars['String']['output']>;
  dhlCorporateNumberInJP: Scalars['Boolean']['output'];
  dhlShipperAddressId: Scalars['ID']['output'];
  dhlSignatureImageURL?: Maybe<Scalars['String']['output']>;
  dhlSupportPackageTypes?: Maybe<Array<DhlPackageType>>;
};

export type DhlCreateCourierInput = {
  accountId: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
  apiSecret: Scalars['String']['input'];
  corporateNumber?: InputMaybe<Scalars['String']['input']>;
  corporateNumberInJP: Scalars['Boolean']['input'];
  shipperAddressId: Scalars['ID']['input'];
  signatureImageURL?: InputMaybe<Scalars['String']['input']>;
  supportPackageTypes?: InputMaybe<Array<DhlPackageType>>;
};

export const DhlPackageType = {
  DHL_BOX_2: 'DHL_BOX_2',
  DHL_BOX_3: 'DHL_BOX_3',
  DHL_BOX_4: 'DHL_BOX_4',
  DHL_BOX_5: 'DHL_BOX_5',
  DHL_BOX_6: 'DHL_BOX_6',
  DHL_BOX_7: 'DHL_BOX_7',
  DHL_BOX_8: 'DHL_BOX_8',
  DHL_CARD_ENVELOPE: 'DHL_CARD_ENVELOPE',
  DHL_EXPRESS_ENVELOPE: 'DHL_EXPRESS_ENVELOPE',
  DHL_TUBE_LARGE: 'DHL_TUBE_LARGE',
  DHL_TUBE_SMALL: 'DHL_TUBE_SMALL'
} as const;

export type DhlPackageType = typeof DhlPackageType[keyof typeof DhlPackageType];
export type DhlPackageWrapper = {
  __typename?: 'DHLPackageWrapper';
  DHLPackageType?: Maybe<DhlPackageType>;
};

export const DhlServiceCode = {
  B2C: 'B2C',
  BBX: 'BBX',
  BTC: 'BTC',
  CMX: 'CMX',
  DES: 'DES',
  DOK: 'DOK',
  DOL: 'DOL',
  DOM: 'DOM',
  DOT: 'DOT',
  DOX: 'DOX',
  ECX: 'ECX',
  EPA: 'EPA',
  EPP: 'EPP',
  ESI: 'ESI',
  ESU: 'ESU',
  FRT: 'FRT',
  GMB: 'GMB',
  JBX: 'JBX',
  NFO: 'NFO',
  SDX: 'SDX',
  SPL: 'SPL',
  TDE: 'TDE',
  TDK: 'TDK',
  TDL: 'TDL',
  TDM: 'TDM',
  TDT: 'TDT',
  TDY: 'TDY',
  WMX: 'WMX',
  WPX: 'WPX',
  XED: 'XED',
  XEP: 'XEP',
  XPD: 'XPD'
} as const;

export type DhlServiceCode = typeof DhlServiceCode[keyof typeof DhlServiceCode];
export type DhlServiceCodeWrapper = {
  __typename?: 'DHLServiceCodeWrapper';
  dhlServiceCode?: Maybe<DhlServiceCode>;
};

export type DhlUpdateCourierInput = {
  accountNumber: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
  apiSecret: Scalars['String']['input'];
  corporateNumber?: InputMaybe<Scalars['String']['input']>;
  corporateNumberInJP: Scalars['Boolean']['input'];
  courierId: Scalars['String']['input'];
  shipperAddressId: Scalars['ID']['input'];
  signatureImageURL?: InputMaybe<Scalars['String']['input']>;
  supportPackageTypes?: InputMaybe<Array<DhlPackageType>>;
};

/** Generation state of an AI Insights panel. PROCESSING means a background generation is in flight — poll this query until it becomes DONE or FAILED. FAILED is not retried automatically; use the refresh mutation. */
export const DashboardAiInsightStatus = {
  DONE: 'DONE',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING'
} as const;

export type DashboardAiInsightStatus = typeof DashboardAiInsightStatus[keyof typeof DashboardAiInsightStatus];
/** One host bucket (AI or Human) in the All-hosts comparison table (item 9): Live Hours, GMV, GMV/hour, Avg View Duration, and Conversion side by side. */
export type DashboardAiVsHumanOutput = {
  __typename?: 'DashboardAiVsHumanOutput';
  /** Average view duration in seconds. Null when this host has no session data. */
  avgViewDuration?: Maybe<Scalars['BigDecimal']['output']>;
  /** ISO currency code for the local money fields (e.g. THB). */
  currency: Scalars['String']['output'];
  /** Viewer-weighted conversion rate. Null when this host has no viewers. */
  cvr?: Maybe<Scalars['BigDecimal']['output']>;
  /** Conversion (orders over product clicks, or the platform's own reported rate) for this host with its availability; null value with UNSUPPORTED or NOT_YET_AVAILABLE when no platform supplies it for this host. See liveHoursMetric. */
  cvrMetric?: Maybe<DashboardKpiMetricOutput>;
  /** Total GMV in the brand's local currency for this host. */
  gmvLocal: Scalars['BigDecimal']['output'];
  /** GMV for this host with its availability: value in USD, localValue in the brand's currency; see liveHoursMetric. */
  gmvMetric?: Maybe<DashboardKpiMetricOutput>;
  /** GMV per live hour, in the brand's local currency. */
  gmvPerHour: Scalars['BigDecimal']['output'];
  /** GMV per live hour for this host with its availability, dividing only the days that have both GMV and hours: value in USD, localValue in the brand's currency; see liveHoursMetric. */
  gmvPerHourMetric?: Maybe<DashboardKpiMetricOutput>;
  /** Total GMV in USD for this host. */
  gmvUsd: Scalars['BigDecimal']['output'];
  /** Raw host type, either "AI" or "HUMAN". */
  hostType: Scalars['String']['output'];
  /** Total live hours for this host. */
  liveHours: Scalars['BigDecimal']['output'];
  /** Live hours for this host with its availability (anylive#397). A null value is not zero: NOT_YET_AVAILABLE when no platform has delivered hours for the range, UNSUPPORTED when none reports them. PARTIAL keeps the on-time platforms' hours (see incompletePlatforms). Null when not evaluated; use liveHours then. */
  liveHoursMetric?: Maybe<DashboardKpiMetricOutput>;
};

/** Brand View AI Insights panel (issue #182). */
export type DashboardBrandAiInsightOutput = {
  __typename?: 'DashboardBrandAiInsightOutput';
  /** The current BQ data max date at query time. Non-null only when stale=true. Show alongside generatedAt so the user sees how far the data has moved. */
  dataAsOfDate?: Maybe<Scalars['String']['output']>;
  /** When the warehouse last rebuilt the data, at query time (ISO-8601 UTC). Non-null only when stale=true. Show it in the banner so the user sees WHEN the recalculation happened, not just that one happened. */
  dataPipelineRunAt?: Maybe<Scalars['String']['output']>;
  /** When the panel was generated (ISO-8601 UTC). While status is PROCESSING this is the time the generation was claimed, not a generation time — branch on status, not on this field. */
  generatedAt: Scalars['String']['output'];
  /** The BQ data max date that was current when this panel was generated (ISO-8601 date, e.g. '2026-08-09'). Non-null for any stored panel that has a dataMaxDate recorded. Use alongside dataAsOfDate (the current BQ max) to show the staleness gap in the banner. */
  insightDataMaxDate?: Maybe<Scalars['String']['output']>;
  /** When the warehouse last rebuilt the data this panel cites (ISO-8601 UTC), as recorded at generation time. NULL for panels generated before the stamp existed. Compare with dataPipelineRunAt: a strictly newer live stamp on the SAME insightDataMaxDate means a same-day rebuild replaced the numbers, which is invisible to the date alone. */
  insightPipelineRunAt?: Maybe<Scalars['String']['output']>;
  /** LLM model that produced it. */
  model: Scalars['String']['output'];
  /** Three action items. */
  recommendations: Array<Scalars['String']['output']>;
  /** Narrative sections, in the order they should be rendered. */
  sections: Array<DashboardInsightSection>;
  /** True when source data has landed since this panel was generated. The panel is NOT regenerated automatically — call the refresh mutation, which starts a background regeneration and returns immediately with status PROCESSING. */
  stale: Scalars['Boolean']['output'];
  /** Generation state. Poll this query while PROCESSING. */
  status: DashboardAiInsightStatus;
};

/** Filter for brand KPI and store-list queries. */
export type DashboardBrandFilterInput = {
  /** ISO-3166 country code. Null means all countries. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Date range for the query. */
  dateRange: DashboardDateRangeInput;
  /** How the date range was selected (drives the PoP label). Null → label inferred from range length. */
  dateSelectionType?: InputMaybe<DashboardDateSelectionTypeInput>;
  /** Host type: AI or HUMAN. Null means all host types. */
  hostType?: InputMaybe<Scalars['String']['input']>;
  /** 1-based page number. */
  pageNumber: Scalars['Int']['input'];
  /** Page size (1-50). */
  pageSize: Scalars['Int']['input'];
  /** Platform: TIKTOK, SHOPEE or FIREWORKS. Null means all platforms. */
  platform?: InputMaybe<Scalars['String']['input']>;
  /** Optional single store ID to restrict results. */
  storeId?: InputMaybe<Scalars['String']['input']>;
};

/** Brand Health Radar scores vs market benchmark (§1.10); benchmark renders as a fixed 50-pt ring. */
export type DashboardBrandHealthRadarOutput = {
  __typename?: 'DashboardBrandHealthRadarOutput';
  /** CVR score vs market benchmark (0–100; benchmark = 50). */
  cvrScore: Scalars['BigDecimal']['output'];
  /** GMV per live hour score vs market benchmark (0–100; benchmark = 50). */
  gmvHScore: Scalars['BigDecimal']['output'];
  /** GMV score vs market benchmark (0–100; benchmark = 50). */
  gmvScore: Scalars['BigDecimal']['output'];
  /** Units sold score vs market benchmark (0–100; benchmark = 50). */
  unitsScore: Scalars['BigDecimal']['output'];
  /** Average viewers per session score vs market benchmark (0–100; benchmark = 50). */
  viewersScore: Scalars['BigDecimal']['output'];
};

/** One hour slot of the Hourly GMV & CVR trend (§1.11). */
export type DashboardBrandHourlyRowOutput = {
  __typename?: 'DashboardBrandHourlyRowOutput';
  /** Average CVR per hour slot, as a 0–1 fraction. Meaningless when cvrSampleCount is 0. */
  avgCvr: Scalars['BigDecimal']['output'];
  /** Average GMV per hour slot in USD. */
  avgGmv: Scalars['BigDecimal']['output'];
  /** Average GMV per hour slot in the brand's local currency (Brand Dashboard). */
  avgGmvLocal?: Maybe<Scalars['BigDecimal']['output']>;
  /** ISO currency code for the local GMV value (Brand Dashboard). */
  currency?: Maybe<Scalars['String']['output']>;
  /** How many dates contributed a CVR to this hour slot. 0 means CVR is unavailable here — the hour had no activity, or the platform reports no conversion rate (Shopee) — and the client should render "—" instead of plotting avgCvr as 0%. */
  cvrSampleCount: Scalars['Int']['output'];
  /** Hour of day (0–23). */
  hour: Scalars['Int']['output'];
};

/** Paginated list of brand KPI rows. */
export type DashboardBrandKpiListOutput = {
  __typename?: 'DashboardBrandKpiListOutput';
  /** ISO-4217 code for the whole filtered scope, not just this page — a page holding only one country's brands inside a multi-country scope still reads USD. */
  currency: Scalars['String']['output'];
  /** Brand KPI rows for the current page. */
  items: Array<DashboardBrandKpiOutput>;
  /** Total number of matching brands. */
  totalCount: Scalars['Int']['output'];
};

/** Brand KPI row in the brand detail table (F-13). */
export type DashboardBrandKpiOutput = {
  __typename?: 'DashboardBrandKpiOutput';
  /**
   * Average order value in USD: SUM(GMV) / SUM(Orders) over the rows in scope.
   * @deprecated Use avgAovMetric
   */
  avgAov?: Maybe<Scalars['BigDecimal']['output']>;
  /**
   * Same average order value in the scope's local currency.
   * @deprecated Use avgAovMetric
   */
  avgAovLocal?: Maybe<Scalars['BigDecimal']['output']>;
  /** Average order value with its availability. Replaces avgAov and avgAovLocal. */
  avgAovMetric?: Maybe<DashboardKpiMetricOutput>;
  /**
   * Average conversion rate (0.0-1.0).
   * @deprecated Use avgCvrMetric
   */
  avgCvr?: Maybe<Scalars['BigDecimal']['output']>;
  /** Average conversion rate with its availability. Replaces avgCvr. */
  avgCvrMetric?: Maybe<DashboardKpiMetricOutput>;
  /** ISO-3166 country code. */
  country: Scalars['String']['output'];
  /** Human-readable store name from account-master (null → client falls back to storeName). */
  displayName?: Maybe<Scalars['String']['output']>;
  /**
   * GMV per live hour.
   * @deprecated Use gmvPerHourMetric
   */
  gmvPerHour?: Maybe<Scalars['BigDecimal']['output']>;
  /**
   * Same GMV per live hour in the scope's local currency.
   * @deprecated Use gmvPerHourMetric
   */
  gmvPerHourLocal?: Maybe<Scalars['BigDecimal']['output']>;
  /** GMV per live hour with its availability. Replaces gmvPerHour and gmvPerHourLocal. */
  gmvPerHourMetric?: Maybe<DashboardKpiMetricOutput>;
  /** GMV Period-over-Period % change (null if insufficient data). */
  gmvPopPercentage?: Maybe<Scalars['BigDecimal']['output']>;
  /** Platform with the most GMV: TIKTOK, SHOPEE or FIREWORKS. */
  platform: Scalars['String']['output'];
  /** All platforms this brand streamed on in the period (one badge each). */
  platforms: Array<Scalars['String']['output']>;
  /**
   * Number of distinct live sessions.
   * @deprecated Use sessionCountMetric
   */
  sessionCount: Scalars['Int']['output'];
  /** Session count with its availability. Replaces sessionCount. */
  sessionCountMetric?: Maybe<DashboardKpiMetricOutput>;
  /** Store identifier for the brand row. */
  storeId: Scalars['String']['output'];
  /** Brand (store) name. */
  storeName: Scalars['String']['output'];
  /**
   * Total live duration in hours.
   * @deprecated Use totalDurationHoursMetric
   */
  totalDurationHours: Scalars['BigDecimal']['output'];
  /** Total live duration in hours with its availability. Replaces totalDurationHours. */
  totalDurationHoursMetric?: Maybe<DashboardKpiMetricOutput>;
  /**
   * Same total in the scope's local currency (raw pre-FX, not converted from totalGmvUsd).
   * @deprecated Use totalGmvMetric
   */
  totalGmvLocal: Scalars['BigDecimal']['output'];
  /** Total GMV with its availability. Replaces totalGmvUsd and totalGmvLocal. */
  totalGmvMetric?: Maybe<DashboardKpiMetricOutput>;
  /**
   * Total GMV in USD.
   * @deprecated Use totalGmvMetric
   */
  totalGmvUsd: Scalars['BigDecimal']['output'];
  /**
   * Total units sold.
   * @deprecated Use totalUnitsSoldMetric
   */
  totalUnitsSold: Scalars['Long']['output'];
  /** Total units sold with its availability. Replaces totalUnitsSold. */
  totalUnitsSoldMetric?: Maybe<DashboardKpiMetricOutput>;
  /**
   * Total viewer count.
   * @deprecated Use totalViewersMetric
   */
  totalViewers: Scalars['Long']['output'];
  /** Total viewer count with its availability. Replaces totalViewers. */
  totalViewersMetric?: Maybe<DashboardKpiMetricOutput>;
};

/** A Best-Selling product row (Brand View §1.13). */
export type DashboardBrandProductOutput = {
  __typename?: 'DashboardBrandProductOutput';
  /** Click-to-order rate (%) = orderCount / product clicks, summed over the range. The numerator is the ORDER count, not unitsSold — CTOR stayed click-to-order when the display column moved to the item grain. Not bounded by 100 — both platforms attribute orders without a product-card click, so the numerator is not drawn from the click population (e.g. 4,621 orders / 2,032 clicks = 227%). Null when no clicks were reported. */
  ctor?: Maybe<Scalars['BigDecimal']['output']>;
  /** Click-through rate (%) = product clicks / product impressions, summed over the range. Null when the platform reports no impressions (Shopee). */
  ctr?: Maybe<Scalars['BigDecimal']['output']>;
  /** ISO currency code for the local money fields (e.g. THB) */
  currency: Scalars['String']['output'];
  /** Total GMV in the brand's local currency */
  gmvLocal: Scalars['BigDecimal']['output'];
  /** Total GMV in USD (summed across the brand's sessions). */
  gmvUsd: Scalars['BigDecimal']['output'];
  /** Order count summed over the range — CTOR's numerator, and equal to unitsSold whenever unitsSoldLabel is "Orders". Surfaced so CTOR stays reproducible from the visible row. */
  orderCount: Scalars['Long']['output'];
  /** Product clicks summed over the range — the CTOR denominator. Null when not reported. */
  productClicks?: Maybe<Scalars['Long']['output']>;
  /** Product impressions summed over the range — the CTR denominator. Null on Shopee, which reports none. */
  productImpressions?: Maybe<Scalars['Long']['output']>;
  /** Product name. */
  productName: Scalars['String']['output'];
  /** 1-based rank by quantity sold, then GMV, then product name (1..5). */
  rank: Scalars['Int']['output'];
  /** Total quantity sold, in the grain named by unitsSoldLabel: the real item count on Shopee (confirmed_item_sold), the order count on TikTok, which publishes no per-product item quantity. Also the field the Top 5 is ranked by, so the displayed number and the ranking cannot disagree. */
  unitsSold: Scalars['Long']['output'];
  /** The header the client MUST render above unitsSold: "Units Sold" when the value is a real item count, "Orders" when the platform reports only orders. Rendering "Units Sold" over an order count is the defect this field exists to prevent — Shopee store 1752 sold 831 items across 680 orders on one product. When a range mixes platforms the labels can differ per row; a single column header should then use the widest label present. */
  unitsSoldLabel: Scalars['String']['output'];
};

/** 5-dimension radar score for one brand (F-5). All scores are in range [0, 100]; baseline = 50. */
export type DashboardBrandRadarEntryOutput = {
  __typename?: 'DashboardBrandRadarEntryOutput';
  /** Brand (store) name. */
  brandName: Scalars['String']['output'];
  /** The brand's conversion behind cvrScore (orders over product clicks, or the platform's own reported rate), with its availability; see gmvMetric. */
  cvrMetric?: Maybe<DashboardKpiMetricOutput>;
  /** CVR score vs. market average of the brands with a value (capped at 100). Null when this brand has no value on the axis (see cvrMetric) or that average is 0 — render a gap. */
  cvrScore?: Maybe<Scalars['BigDecimal']['output']>;
  /** GMV/h efficiency score vs. market average of the brands with a value (capped at 100). Null when this brand has no value on the axis (see gmvPerHourMetric) or that average is 0 — render a gap. */
  gmvHScore?: Maybe<Scalars['BigDecimal']['output']>;
  /** The brand's GMV (USD) behind gmvScore, with its availability (anylive#397). When the value is null (NOT_YET_AVAILABLE, UNSUPPORTED, or no basis) gmvScore is null too and the brand is left out of this axis's market average; draw a gap. PARTIAL: the value covers the range only through availableThrough. Null when not evaluated. */
  gmvMetric?: Maybe<DashboardKpiMetricOutput>;
  /** The brand's GMV per hour (USD, matched days) behind gmvHScore, with its availability; see gmvMetric. */
  gmvPerHourMetric?: Maybe<DashboardKpiMetricOutput>;
  /** GMV score vs. market average of the brands with a value (capped at 100). Null when this brand has no value on the axis (see gmvMetric) or that average is 0 — render a gap. */
  gmvScore?: Maybe<Scalars['BigDecimal']['output']>;
  /** Store identifier — stable key for joining radar scores to a brand row (store_name is not unique). */
  storeId: Scalars['String']['output'];
  /** The brand's units sold behind unitsScore, with its availability; see gmvMetric. */
  unitsMetric?: Maybe<DashboardKpiMetricOutput>;
  /** Units sold score vs. market average of the brands with a value (capped at 100). Null when this brand has no value on the axis (see unitsMetric) or that average is 0 — render a gap. */
  unitsScore?: Maybe<Scalars['BigDecimal']['output']>;
  /** The brand's viewers behind viewersScore, with its availability; see gmvMetric. */
  viewersMetric?: Maybe<DashboardKpiMetricOutput>;
  /** Viewers score vs. market average of the brands with a value (capped at 100). Null when this brand has no value on the axis (see viewersMetric) or that average is 0 — render a gap. */
  viewersScore?: Maybe<Scalars['BigDecimal']['output']>;
};

/** A single brand session row (Brand View Diagnosis + Sessions List). */
export type DashboardBrandSessionOutput = {
  __typename?: 'DashboardBrandSessionOutput';
  /** Average order value in USD. Null when the source has none. */
  aov?: Maybe<Scalars['BigDecimal']['output']>;
  /** Average order value in the store's local currency (see `currency`). Null when the source has none. */
  aovLocal?: Maybe<Scalars['BigDecimal']['output']>;
  /** ISO currency code for the local-money fields (gmvLocal, aovLocal), derived from the session's country. */
  currency: Scalars['String']['output'];
  /** Conversion rate (%). Null when the source has none. */
  cvr?: Maybe<Scalars['BigDecimal']['output']>;
  /** Session duration in hours. 0 when the source has no recorded duration (client shows N/A). */
  durationHours: Scalars['BigDecimal']['output'];
  /** Total GMV in the store's local currency (see `currency`). */
  gmvLocal: Scalars['BigDecimal']['output'];
  /** Total GMV in USD. */
  gmvUsd: Scalars['BigDecimal']['output'];
  /** Host type: AI or HUMAN. */
  hostType: Scalars['String']['output'];
  /** True when the platform snapshot behind this session may still change — Shopee within ~48h of session end. Clients should show a Processing state instead of a final-looking zero for this session's metrics. */
  isProvisional: Scalars['Boolean']['output'];
  /** When the underlying report table was last built, ISO-8601 UTC. Identical across every row of one read, so a client showing a scope-level "data as of" label can take the max. Null when the source has none. */
  pipelineRunAt?: Maybe<Scalars['String']['output']>;
  /** Sales channel: TIKTOK or SHOPEE. */
  platform: Scalars['String']['output'];
  /** Unique session identifier. */
  sessionId: Scalars['String']['output'];
  /** Session name/title. Null when the session has no live-stream stats row yet. */
  sessionName?: Maybe<Scalars['String']['output']>;
  /** Local date the session started. */
  startDate: Scalars['Date']['output'];
  /** Total units sold. */
  unitsSold: Scalars['Long']['output'];
  /** Total viewer count. */
  viewers: Scalars['Long']['output'];
};

/** Brand View KPI cards (§1.6): 12 single-store metrics, each with PoP. */
export type DashboardBrandSummaryOutput = {
  __typename?: 'DashboardBrandSummaryOutput';
  aov: DashboardKpiMetricOutput;
  atcCount: DashboardKpiMetricOutput;
  atcRate: DashboardKpiMetricOutput;
  /** ISO currency code for local money values. */
  currency: Scalars['String']['output'];
  cvr: DashboardKpiMetricOutput;
  durationHours: DashboardKpiMetricOutput;
  gmvPerHour: DashboardKpiMetricOutput;
  itemsSold: DashboardKpiMetricOutput;
  /** Paid product orders summed across all sessions in the period. */
  orders: DashboardKpiMetricOutput;
  peakViewers: DashboardKpiMetricOutput;
  totalComments: DashboardKpiMetricOutput;
  totalGmv: DashboardKpiMetricOutput;
  views: DashboardKpiMetricOutput;
};

/** Whether the stores in scope have one kind of data at all, judged from the platform registry (anylive#397). Not a number: it has no value and is never PARTIAL or NOT_YET_AVAILABLE. */
export type DashboardCapabilityOutput = {
  __typename?: 'DashboardCapabilityOutput';
  /** Platforms in scope without the data; for UNSUPPORTED, every platform in scope. E.g. FIREWORKS. */
  excludedPlatforms: Array<Scalars['String']['output']>;
  /** Every platform in scope, in contract order. */
  platforms: Array<Scalars['String']['output']>;
  /** AVAILABLE when at least one platform in scope has the data (or no platform is known); UNSUPPORTED when none does. */
  status: DashboardMetricAvailability;
};

/** Conversion funnel aggregate totals (F-9): 4 layers with inter-layer rates. */
export type DashboardConversionFunnelOutput = {
  __typename?: 'DashboardConversionFunnelOutput';
  /** Total add-to-cart count. */
  atc: Scalars['Long']['output'];
  /** Add to Cart step with its availability, over the same platforms as viewersMetric. */
  atcMetric?: Maybe<DashboardKpiMetricOutput>;
  /** Add to Cart → Items Sold conversion rate (%). */
  atcToSold: Scalars['BigDecimal']['output'];
  /** Product Clicks → Add to Cart conversion rate (%). */
  clicksToAtc: Scalars['BigDecimal']['output'];
  /** Platforms in scope left out of every step because they do not report all four steps, e.g. FIREWORKS. Empty when every platform counts or none reports all four. Null when not evaluated. */
  excludedPlatforms?: Maybe<Array<Scalars['String']['output']>>;
  /** Total product click count. */
  productClicks: Scalars['Long']['output'];
  /** Product Clicks step with its availability, over the same platforms as viewersMetric. */
  productClicksMetric?: Maybe<DashboardKpiMetricOutput>;
  /** Total items sold. */
  unitsSold: Scalars['Long']['output'];
  /** Items Sold step with its availability, over the same platforms as viewersMetric. UNSUPPORTED (null value) when no platform in scope reports items sold. */
  unitsSoldMetric?: Maybe<DashboardKpiMetricOutput>;
  /** Total viewer count. */
  viewers: Scalars['Long']['output'];
  /** Viewers step with its availability (anylive#397). Every step counts the same platforms: those in scope that report all four steps (see excludedPlatforms). Null when not evaluated. */
  viewersMetric?: Maybe<DashboardKpiMetricOutput>;
  /** Viewers → Product Clicks conversion rate (%). */
  viewersToClicks: Scalars['BigDecimal']['output'];
};

/** Date range input for dashboard queries (inclusive start and end). */
export type DashboardDateRangeInput = {
  /** Inclusive end date (ISO-8601, e.g. 2026-06-30). */
  endDate: Scalars['Date']['input'];
  /** Inclusive start date (ISO-8601, e.g. 2026-06-01). */
  startDate: Scalars['Date']['input'];
};

/** How the user selected the date range — drives the Period-over-Period label and comparison window. */
export const DashboardDateSelectionTypeInput = {
  BY_DAY: 'BY_DAY',
  BY_MONTH: 'BY_MONTH',
  BY_RANGE: 'BY_RANGE',
  BY_WEEK: 'BY_WEEK',
  LAST_7: 'LAST_7',
  LAST_14: 'LAST_14',
  LAST_30: 'LAST_30',
  YESTERDAY: 'YESTERDAY'
} as const;

export type DashboardDateSelectionTypeInput = typeof DashboardDateSelectionTypeInput[keyof typeof DashboardDateSelectionTypeInput];
/** Global filter for regional dashboard queries (F-1, F-2). */
export type DashboardFilterInput = {
  /** ISO-3166 country code (e.g. TH, VN). Null means all countries. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Date range for the query. */
  dateRange: DashboardDateRangeInput;
  /** How the date range was selected (drives the PoP label). Null → label inferred from range length. */
  dateSelectionType?: InputMaybe<DashboardDateSelectionTypeInput>;
  /** Host type: AI or HUMAN. Null means all host types. */
  hostType?: InputMaybe<Scalars['String']['input']>;
  /** Platform: TIKTOK, SHOPEE or FIREWORKS. Null means all platforms. */
  platform?: InputMaybe<Scalars['String']['input']>;
};

/** A single slice in the GMV share donut chart (F-7). */
export type DashboardGmvShareItemOutput = {
  __typename?: 'DashboardGmvShareItemOutput';
  /** Account-master display name (BRAND mode); null in COUNTRY mode and Others. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Same slice GMV in the scope's local currency (raw pre-FX, not converted from gmvUsd). */
  gmvLocal: Scalars['BigDecimal']['output'];
  /** This slice's GMV with its availability (anylive#397): value in USD, localValue in local currency. value is null when the slice has local GMV but no FX rate for USD (gmvUsd then reads 0 and is not a real zero). Slices whose GMV has not arrived are not returned at all. Null for Others and when not evaluated. */
  gmvMetric?: Maybe<DashboardKpiMetricOutput>;
  /** GMV in USD for this slice. */
  gmvUsd: Scalars['BigDecimal']['output'];
  /** True if this slice represents all brands outside the top 5. */
  isOthers: Scalars['Boolean']['output'];
  /** Country code (COUNTRY mode) or brand store_name (BRAND mode). */
  label: Scalars['String']['output'];
  /** Platform for this brand slice (BRAND mode); null in COUNTRY mode and Others. */
  platform?: Maybe<Scalars['String']['output']>;
};

/** GMV Share Donut chart data (F-7). Mode switches based on Country filter. */
export type DashboardGmvShareOutput = {
  __typename?: 'DashboardGmvShareOutput';
  /** ISO-4217 code the gmvLocal figures are expressed in (see overview.currency). */
  currency: Scalars['String']['output'];
  /** Donut slices ordered by GMV descending; Others bucket last if present. */
  items: Array<DashboardGmvShareItemOutput>;
  /** COUNTRY when Country=All, BRAND when a specific country is selected. */
  mode: Scalars['String']['output'];
  /** Chart title: 'GMV by Country' or 'GMV by Brand — TH'. */
  title: Scalars['String']['output'];
};

/** Time granularity for the GMV & Efficiency Trend chart (F-4). */
export const DashboardGranularityInput = {
  /** Group by calendar day. */
  DAY: 'DAY',
  /** Group by calendar month. */
  MONTH: 'MONTH',
  /** Group by calendar week (Monday-start). */
  WEEK: 'WEEK'
} as const;

export type DashboardGranularityInput = typeof DashboardGranularityInput[keyof typeof DashboardGranularityInput];
/** One titled narrative section of an AI Insights panel (Brand View or Regional View). */
export type DashboardInsightSection = {
  __typename?: 'DashboardInsightSection';
  /** Narrative body: at most 80 words, roughly three sentences, English. */
  body: Scalars['String']['output'];
  /** Stable section identifier. Brand View: performance_overview | product_highlights | engagement_patterns | growth_opportunities. Regional View: period_performance | top_performer | ai_vs_human. For test anchors and analytics — clients render sections in array order and must NOT switch on this. */
  key: Scalars['String']['output'];
  /** Display heading. */
  title: Scalars['String']['output'];
};

/** One KPI card: derived value plus its Period-over-Period change. */
export type DashboardKpiMetricOutput = {
  __typename?: 'DashboardKpiMetricOutput';
  /** PARTIAL only: the earliest date the value covers through (yyyy-MM-dd); null when that date is before the range start (each platform's date is still in incompletePlatforms). */
  availableThrough?: Maybe<Scalars['String']['output']>;
  /** Platforms in scope left out of this value by definition (unsupported, wrong host type, or not blendable). */
  excludedPlatforms: Array<Scalars['String']['output']>;
  /** PARTIAL only: each platform whose data stops early, with its date. */
  incompletePlatforms: Array<DashboardPlatformAvailabilityOutput>;
  /** Metric value in the brand's local currency; null for non-money metrics. */
  localValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Period-over-Period % change (null if comparison period has no data). */
  popPercentage?: Maybe<Scalars['BigDecimal']['output']>;
  /** PoP label type: DoD, WoW, MoM, or PoP. */
  popType?: Maybe<Scalars['String']['output']>;
  /** How much of the selected range the value covers (anylive#397). */
  status: DashboardMetricAvailability;
  /** NATIVE or APPROXIMATE (explained by tooltipKey). */
  support: DashboardMetricSupportLevel;
  /** i18n key of the explanation for an approximate or platform-specific value. */
  tooltipKey?: Maybe<Scalars['String']['output']>;
  /** Metric value; null when status is NOT_YET_AVAILABLE or UNSUPPORTED. AVAILABLE with a null value means there is no basis for the number (e.g. zero denominator), not missing data. */
  value?: Maybe<Scalars['BigDecimal']['output']>;
  /** % vs trailing-12-month average (per-day normalized); null if not benchmarked. */
  vs12moAvgPct?: Maybe<Scalars['BigDecimal']['output']>;
  /** % vs previous calendar month (per-day normalized); null if not benchmarked. */
  vsLastMonthPct?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Metric availability: AVAILABLE (covers the whole range, a real zero included; a null value means there is no basis for the number, e.g. zero denominator), PARTIAL (some days or platforms have not arrived; see availableThrough / incompletePlatforms), NOT_YET_AVAILABLE (nothing has arrived for the range), UNSUPPORTED (the platform never reports it, or not for the selected host type). */
export const DashboardMetricAvailability = {
  AVAILABLE: 'AVAILABLE',
  NOT_YET_AVAILABLE: 'NOT_YET_AVAILABLE',
  PARTIAL: 'PARTIAL',
  UNSUPPORTED: 'UNSUPPORTED'
} as const;

export type DashboardMetricAvailability = typeof DashboardMetricAvailability[keyof typeof DashboardMetricAvailability];
/** NATIVE: the platform's own figure. APPROXIMATE: a stand-in, explained by tooltipKey. */
export const DashboardMetricSupportLevel = {
  APPROXIMATE: 'APPROXIMATE',
  NATIVE: 'NATIVE'
} as const;

export type DashboardMetricSupportLevel = typeof DashboardMetricSupportLevel[keyof typeof DashboardMetricSupportLevel];
/** Overview banner metrics for the regional dashboard (F-1). */
export type DashboardOverviewOutput = {
  __typename?: 'DashboardOverviewOutput';
  /** Number of distinct active brands (store_id grain, platforms folded). */
  activeBrands: Scalars['Int']['output'];
  /**
   * Same average order value in the scope's local currency (raw pre-FX).
   * @deprecated Use avgAovMetric
   */
  avgAovLocal: Scalars['BigDecimal']['output'];
  /** Average order value with its availability. Replaces avgAovUsd / avgAovLocal. */
  avgAovMetric?: Maybe<DashboardKpiMetricOutput>;
  /**
   * Average order value in USD: SUM(GMV) / SUM(Orders) over the scope, so it reproduces exactly from the GMV and Orders reported alongside it. Same definition as the Brand View AOV.
   * @deprecated Use avgAovMetric
   */
  avgAovUsd: Scalars['BigDecimal']['output'];
  /**
   * Average efficiency = SUM(GMV) / SUM(duration hours), in USD/h.
   * @deprecated Use avgEfficiencyMetric
   */
  avgEfficiency: Scalars['BigDecimal']['output'];
  /**
   * Same efficiency in the scope's local currency, per hour.
   * @deprecated Use avgEfficiencyMetric
   */
  avgEfficiencyLocal: Scalars['BigDecimal']['output'];
  /** GMV per live hour with its availability. Replaces avgEfficiency / avgEfficiencyLocal. */
  avgEfficiencyMetric?: Maybe<DashboardKpiMetricOutput>;
  /** ISO-4217 code the money fields should be displayed in: the country's currency when the scope holds exactly one country, otherwise USD. Never infer this from the country filter. */
  currency: Scalars['String']['output'];
  /** Efficiency (GMV/h) Period-over-Period % change (null if insufficient data). */
  efficiencyPopPercentage?: Maybe<Scalars['BigDecimal']['output']>;
  /** Period-over-Period change percentage (null if insufficient data). */
  popPercentage?: Maybe<Scalars['BigDecimal']['output']>;
  /** PoP label type: DoD, WoW, MoM, or PoP. */
  popType?: Maybe<Scalars['String']['output']>;
  /**
   * Same total in the scope's local currency (raw pre-FX, not converted from totalGmvUsd). Display this instead of totalGmvUsd when currency is not USD.
   * @deprecated Use totalGmvMetric
   */
  totalGmvLocal: Scalars['BigDecimal']['output'];
  /** Total GMV (value USD, localValue local) with its availability. Replaces totalGmvUsd / totalGmvLocal. */
  totalGmvMetric?: Maybe<DashboardKpiMetricOutput>;
  /**
   * Total GMV in USD for the selected period.
   * @deprecated Use totalGmvMetric
   */
  totalGmvUsd: Scalars['BigDecimal']['output'];
  /**
   * Total units sold.
   * @deprecated Use totalUnitsSoldMetric
   */
  totalUnitsSold: Scalars['Long']['output'];
  /** Total units sold with its availability. Replaces totalUnitsSold. */
  totalUnitsSoldMetric?: Maybe<DashboardKpiMetricOutput>;
  /**
   * Total viewers across the selected period.
   * @deprecated Use totalViewersMetric
   */
  totalViewers: Scalars['Long']['output'];
  /** Total viewers with its availability. Replaces totalViewers. */
  totalViewersMetric?: Maybe<DashboardKpiMetricOutput>;
  /** Units-sold Period-over-Period % change (null if insufficient data). */
  unitsPopPercentage?: Maybe<Scalars['BigDecimal']['output']>;
  /** Viewers Period-over-Period % change (null if insufficient data). */
  viewersPopPercentage?: Maybe<Scalars['BigDecimal']['output']>;
};

/** A platform whose data stops before the selected range ends. */
export type DashboardPlatformAvailabilityOutput = {
  __typename?: 'DashboardPlatformAvailabilityOutput';
  /** Last date with data (yyyy-MM-dd); null when nothing has arrived for the range. */
  availableThrough?: Maybe<Scalars['String']['output']>;
  /** Platform value as published on the dashboard, e.g. FIREWORKS. */
  platform: Scalars['String']['output'];
};

/** Platform Performance Comparison (F-8): every platform's metrics side by side. */
export type DashboardPlatformComparisonOutput = {
  __typename?: 'DashboardPlatformComparisonOutput';
  /** ISO-4217 code the *Local figures are expressed in (see overview.currency). */
  currency: Scalars['String']['output'];
  /** One row per platform in scope, in contract order (TikTok, Shopee, Firework). Replaces tiktok / shopee. */
  platforms: Array<DashboardPlatformComparisonRowOutput>;
  /**
   * Shopee metrics.
   * @deprecated Use platforms
   */
  shopee: DashboardPlatformRowOutput;
  /**
   * TikTok metrics.
   * @deprecated Use platforms
   */
  tiktok: DashboardPlatformRowOutput;
};

/** One platform's column in Platform Comparison; every number carries its availability. */
export type DashboardPlatformComparisonRowOutput = {
  __typename?: 'DashboardPlatformComparisonRowOutput';
  /** CVR as a decimal (0.06 = 6%). Firework's is its own views-weighted reported rate. */
  cvr: DashboardKpiMetricOutput;
  /** Total GMV (value USD, localValue local). */
  gmv: DashboardKpiMetricOutput;
  /** GMV per live hour (value USD, localValue local). */
  gmvPerHour: DashboardKpiMetricOutput;
  /** Platform value, e.g. TIKTOK, SHOPEE or FIREWORKS. */
  platform: Scalars['String']['output'];
};

/** Per-platform metrics row for the Platform Comparison chart (F-8). */
export type DashboardPlatformRowOutput = {
  __typename?: 'DashboardPlatformRowOutput';
  /** Average CVR as decimal (0.06 = 6%). */
  avgCvr: Scalars['BigDecimal']['output'];
  /** Same total GMV in the scope's local currency (raw pre-FX, not converted from gmvUsd). */
  gmvLocal: Scalars['BigDecimal']['output'];
  /** GMV per live hour (SUM(gmv) / SUM(duration_h)). */
  gmvPerHour: Scalars['BigDecimal']['output'];
  /** Same GMV per live hour in the scope's local currency. */
  gmvPerHourLocal: Scalars['BigDecimal']['output'];
  /** Total GMV in USD. */
  gmvUsd: Scalars['BigDecimal']['output'];
};

/** Regional View AI Insights panel (issue #182, PRD §3). */
export type DashboardRegionalAiInsightOutput = {
  __typename?: 'DashboardRegionalAiInsightOutput';
  /** The current BQ data max date at query time. Non-null only when stale=true. Show alongside generatedAt so the user sees how far the data has moved. */
  dataAsOfDate?: Maybe<Scalars['String']['output']>;
  /** When the warehouse last rebuilt the data, at query time (ISO-8601 UTC). Non-null only when stale=true. Show it in the banner so the user sees WHEN the recalculation happened, not just that one happened. */
  dataPipelineRunAt?: Maybe<Scalars['String']['output']>;
  /** When the panel was generated (ISO-8601 UTC). While status is PROCESSING this is the time the generation was claimed, not a generation time — branch on status, not on this field. */
  generatedAt: Scalars['String']['output'];
  /** The BQ data max date that was current when this panel was generated (ISO-8601 date, e.g. '2026-08-09'). Non-null for any stored panel that has a dataMaxDate recorded. Use alongside dataAsOfDate (the current BQ max) to show the staleness gap in the banner. */
  insightDataMaxDate?: Maybe<Scalars['String']['output']>;
  /** When the warehouse last rebuilt the data this panel cites (ISO-8601 UTC), as recorded at generation time. NULL for panels generated before the stamp existed. Compare with dataPipelineRunAt: a strictly newer live stamp on the SAME insightDataMaxDate means a same-day rebuild replaced the numbers, which is invisible to the date alone. */
  insightPipelineRunAt?: Maybe<Scalars['String']['output']>;
  /** LLM model that produced it. */
  model: Scalars['String']['output'];
  /** Three action items. Empty when the period had no livestream activity. */
  recommendations: Array<Scalars['String']['output']>;
  /** Narrative sections, in the order they should be rendered. */
  sections: Array<DashboardInsightSection>;
  /** True when source data has landed since this panel was generated. The panel is NOT regenerated automatically — call the refresh mutation, which starts a background regeneration and returns immediately with status PROCESSING. */
  stale: Scalars['Boolean']['output'];
  /** Generation state. Poll this query while PROCESSING. */
  status: DashboardAiInsightStatus;
};

/** What kinds of data the stores under a dashboard filter have (anylive#397). */
export type DashboardScopeCapabilitiesOutput = {
  __typename?: 'DashboardScopeCapabilitiesOutput';
  /** Per-livestream data: sessions, hourly slots, session products, weekly report and session export. UNSUPPORTED means those panels have nothing to show for this scope (not zero). */
  sessionData: DashboardCapabilityOutput;
};

/** One row of the script category performance table (§2.3(a)). A row is identified by phase AND category together; the same category occurs under several phases and they stay separate rows. */
export type DashboardScriptCategoryOutput = {
  __typename?: 'DashboardScriptCategoryOutput';
  /** Category, e.g. "Exclusive Price". */
  category: Scalars['String']['output'];
  /** Items sold over viewers for this category (0.0-1.0), per PRD §2.3(a). Null when the category has no viewers — display `—` rather than 0% (BUG-CVR-05). */
  cvr?: Maybe<Scalars['BigDecimal']['output']>;
  /** Same attribution in the store's local currency (raw pre-FX, not converted from gmvUsd). */
  gmvLocal: Scalars['BigDecimal']['output'];
  /** Category GMV as a percentage of the session header GMV (dashboard_session_list.gmv_usd). Does not sum to 100% — unlabelled/uncategorized GMV is the shortfall. */
  gmvPct: Scalars['BigDecimal']['output'];
  /** GMV in USD attributed to this category. A segment's GMV is split evenly across its labels, so these sum back to the LABELLED GMV — short of the session total by whatever the model left unclassified. Compare gmvPct, whose denominator is the whole session. */
  gmvUsd: Scalars['BigDecimal']['output'];
  /** Items sold attributed to this category. */
  itemsSold: Scalars['Long']['output'];
  /** Parent phase, e.g. "Push-selling". Null for the tail of labels emitted without one. */
  phase?: Maybe<Scalars['String']['output']>;
  /** Number of 5-minute segments carrying this label. Not divided across a segment's labels. */
  segments: Scalars['Int']['output'];
  /** Viewers attributed to this category — the CVR denominator (PRD §2.3(a): items/viewers). */
  viewers: Scalars['Long']['output'];
  /** Views attributed to this category. */
  views: Scalars['Long']['output'];
};

/** Brand View Script Optimization Insights panel (PRD §2.3(c)). */
export type DashboardScriptInsightOutput = {
  __typename?: 'DashboardScriptInsightOutput';
  /** Insight cards; empty when the session has no segment data. */
  cards: Array<ScriptInsightCardOutput>;
  /** When the insights were generated (ISO-8601 UTC). */
  generatedAt: Scalars['String']['output'];
  /** LLM model that produced them. */
  model: Scalars['String']['output'];
};

/** A script classification: phase is the parent level, category the analysis granularity (§2.3). */
export type DashboardScriptLabelOutput = {
  __typename?: 'DashboardScriptLabelOutput';
  /** Category, e.g. "Exclusive Price". Not unique on its own — the same category occurs under several phases. */
  category: Scalars['String']['output'];
  /** Parent phase, e.g. "Push-selling". Null for the tail of labels emitted without one. */
  phase?: Maybe<Scalars['String']['output']>;
};

/** A single comment row in the Session Detail Comments tab. */
export type DashboardSessionCommentOutput = {
  __typename?: 'DashboardSessionCommentOutput';
  /** Comment timestamp (ISO-8601 UTC). */
  commentedAt: Scalars['String']['output'];
  /** Full comment text. */
  content: Scalars['String']['output'];
  /** Commenter username/user id. */
  username: Scalars['String']['output'];
};

/** Paginated list of session comments. */
export type DashboardSessionCommentsOutput = {
  __typename?: 'DashboardSessionCommentsOutput';
  /** Comment rows for the current page. */
  items: Array<DashboardSessionCommentOutput>;
  /** Total number of comments in the session. */
  totalCount: Scalars['Int']['output'];
};

/** Full detail for a single live session. */
export type DashboardSessionDetailOutput = {
  __typename?: 'DashboardSessionDetailOutput';
  /** Add-to-cart count. Null for TikTok (no source value). */
  atc?: Maybe<Scalars['Long']['output']>;
  /** Average order value in USD: session GMV / session orders, FX-converted. */
  avgAov?: Maybe<Scalars['BigDecimal']['output']>;
  /** Average order value in the brand's local currency: session GMV / session orders. */
  avgAovLocal?: Maybe<Scalars['BigDecimal']['output']>;
  /** Average conversion rate (0.0-1.0). */
  avgCvr?: Maybe<Scalars['BigDecimal']['output']>;
  /** Average view duration in seconds (§2.2). Null when the source has no recorded watch duration. */
  avgViewDuration?: Maybe<Scalars['BigDecimal']['output']>;
  /** ISO-3166 country code. */
  country: Scalars['String']['output'];
  /** ISO-4217 currency code derived from the session's country (item 8). */
  currency: Scalars['String']['output'];
  /** Session duration in hours. 0 when the source has no recorded duration (client shows N/A). */
  durationHours: Scalars['BigDecimal']['output'];
  /** GMV per live hour in USD. */
  gmvPerHour?: Maybe<Scalars['BigDecimal']['output']>;
  /** GMV per live hour in the brand's local currency (item 8). */
  gmvPerHourLocal?: Maybe<Scalars['BigDecimal']['output']>;
  /** Host type: AI or HUMAN. */
  hostType: Scalars['String']['output'];
  /** Peak concurrent viewers. Null for TikTok. */
  peakViewers?: Maybe<Scalars['Long']['output']>;
  /** Sales channel: TIKTOK or SHOPEE. */
  platform: Scalars['String']['output'];
  /** Unique session identifier. */
  sessionId: Scalars['String']['output'];
  /** Human-readable session name/title. Null when no stats row yet (client falls back to storeName). */
  sessionName?: Maybe<Scalars['String']['output']>;
  /** Local date the session started. */
  startDate: Scalars['Date']['output'];
  /** Brand (store) name. */
  storeName: Scalars['String']['output'];
  /** Total GMV in the brand's local currency (item 8). */
  totalGmvLocal: Scalars['BigDecimal']['output'];
  /** Total GMV in USD. */
  totalGmvUsd: Scalars['BigDecimal']['output'];
  /** Total units sold. */
  totalUnitsSold: Scalars['Long']['output'];
  /** Total viewer count. */
  totalViewers: Scalars['Long']['output'];
};

/** Filter for session list queries. */
export type DashboardSessionFilterInput = {
  /** ISO-3166 country code. Null means all countries. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Date range for the query. */
  dateRange: DashboardDateRangeInput;
  /** Host type: AI or HUMAN. Null means all host types. */
  hostType?: InputMaybe<Scalars['String']['input']>;
  /** 1-based page number. */
  pageNumber: Scalars['Int']['input'];
  /** Page size (1-50). */
  pageSize: Scalars['Int']['input'];
  /** Platform: TIKTOK, SHOPEE or FIREWORKS. Null means all platforms. */
  platform?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated list of live sessions. */
export type DashboardSessionListOutput = {
  __typename?: 'DashboardSessionListOutput';
  /** Session rows for the current page. */
  items: Array<DashboardSessionOutput>;
  /** When the underlying report table was last built, ISO-8601 UTC. Spans the whole filtered scope, so it does not change as the caller pages. Null when the scope matched no rows. */
  pipelineRunAt?: Maybe<Scalars['String']['output']>;
  /** Total number of matching sessions. */
  totalCount: Scalars['Int']['output'];
};

/** Single live session row. */
export type DashboardSessionOutput = {
  __typename?: 'DashboardSessionOutput';
  /** ISO-3166 country code. */
  country: Scalars['String']['output'];
  /** ISO-4217 currency code derived from the session's country (item 8). */
  currency: Scalars['String']['output'];
  /** Session duration in hours. */
  durationHours: Scalars['BigDecimal']['output'];
  /** True when the platform snapshot behind this session may still change — Shopee within ~48h of session end. Clients should show a Processing state instead of a final-looking zero for this session's metrics. */
  isProvisional: Scalars['Boolean']['output'];
  /** Sales channel: TIKTOK or SHOPEE. */
  platform: Scalars['String']['output'];
  /** Unique session identifier. */
  sessionId: Scalars['String']['output'];
  /** Local date the session started. */
  startDate: Scalars['Date']['output'];
  /** Brand (store) name. */
  storeName: Scalars['String']['output'];
  /** Total GMV in the brand's local currency (item 8). */
  totalGmvLocal: Scalars['BigDecimal']['output'];
  /** Total GMV in USD. */
  totalGmvUsd: Scalars['BigDecimal']['output'];
  /** Total units sold. */
  totalUnitsSold: Scalars['Long']['output'];
  /** Total viewer count. */
  totalViewers: Scalars['Long']['output'];
};

/** A single product row in the Session Detail Product List. */
export type DashboardSessionProductOutput = {
  __typename?: 'DashboardSessionProductOutput';
  /** Add-to-cart count. */
  addToCart: Scalars['Long']['output'];
  /** Average order value in USD. Null when the product had no paid orders — render —. */
  aov?: Maybe<Scalars['BigDecimal']['output']>;
  /** Average order value in the store's local currency. Null when the product had no paid orders — render —. */
  aovLocal?: Maybe<Scalars['BigDecimal']['output']>;
  /** Click-through rate (0.0-1.0). */
  ctr: Scalars['BigDecimal']['output'];
  /** Click-to-order / conversion rate (0.0-1.0). */
  cvr: Scalars['BigDecimal']['output'];
  /** Product GMV in the store's local currency. */
  gmvLocal: Scalars['BigDecimal']['output'];
  /** Product GMV in USD (summed within the session). */
  gmvUsd: Scalars['BigDecimal']['output'];
  /** Paid order count (TikTok paid_main_order_cnt) — the AOV denominator. One order may contain several units, so this is never above `orders`. Null on Shopee, which has no SKU/order split — render —. */
  mainOrders?: Maybe<Scalars['Long']['output']>;
  /** Units sold — the paid SKU line-item count (TikTok paid_order_cnt). Best Selling ranks on this. */
  orders: Scalars['Long']['output'];
  /** Product name. */
  productName: Scalars['String']['output'];
};

/** One 5-minute segment of a live session (§2.4 chart / §2.5 table). TikTok-only metrics are null for Shopee sessions. */
export type DashboardSessionSegmentOutput = {
  __typename?: 'DashboardSessionSegmentOutput';
  /** Ads GMV (TikTok only). */
  adsGmv?: Maybe<Scalars['BigDecimal']['output']>;
  /** Average order value (Shopee: derived). */
  aov?: Maybe<Scalars['BigDecimal']['output']>;
  /** Add-to-cart count for the interval. Null on TikTok, which publishes no interval-grain ATC — the session total on the header comes from a different, session-grain source and the two are not reconcilable by design. Shopee reports this natively. */
  atc?: Maybe<Scalars['Long']['output']>;
  /** Comments. */
  comments: Scalars['Long']['output'];
  /** Click-through rate (TikTok only). */
  ctr?: Maybe<Scalars['BigDecimal']['output']>;
  /** Conversion rate (0.0-1.0). */
  cvr?: Maybe<Scalars['BigDecimal']['output']>;
  /** Enter room rate (TikTok only). */
  enterRoomRate?: Maybe<Scalars['BigDecimal']['output']>;
  /** GMV in the store's local currency. */
  gmvLocal: Scalars['BigDecimal']['output'];
  /** GMV in USD. */
  gmvUsd: Scalars['BigDecimal']['output'];
  /** Items sold. */
  itemsSold: Scalars['Long']['output'];
  /** Likes. */
  likes: Scalars['Long']['output'];
  /** Main orders (TikTok only). */
  mainOrders?: Maybe<Scalars['Long']['output']>;
  /** New followers (TikTok only). */
  newFollowers?: Maybe<Scalars['Long']['output']>;
  /** Product clicks (TikTok only). */
  productClicks?: Maybe<Scalars['Long']['output']>;
  /** Product impressions (TikTok only). */
  productImpressions?: Maybe<Scalars['Long']['output']>;
  /** Category names for the segment, comma-joined (null when unclassified). Display only — use scriptLabels to group, rank or colour by classification. */
  scriptCategory?: Maybe<Scalars['String']['output']>;
  /** Short script key-points summary (no full transcription). */
  scriptKeypoints?: Maybe<Scalars['String']['output']>;
  /** Script classifications for the segment, split into phase and category. A segment usually carries several. */
  scriptLabels: Array<DashboardScriptLabelOutput>;
  /** Shares (TikTok only). */
  shares?: Maybe<Scalars['Long']['output']>;
  /** Show GPM (TikTok only). */
  showGpm?: Maybe<Scalars['BigDecimal']['output']>;
  /** SKU orders (TikTok only). */
  skuOrders?: Maybe<Scalars['Long']['output']>;
  /** Segment start, ISO-8601 UTC (5-min bucket boundary). */
  timestamp: Scalars['String']['output'];
  /** Concurrent viewers / CCU. */
  viewers: Scalars['Long']['output'];
  /** Views. */
  views: Scalars['Long']['output'];
  /** Watch GPM (TikTok only). */
  watchGpm?: Maybe<Scalars['BigDecimal']['output']>;
};

/** A single TikTok traffic-source row in the Session Detail Traffic Source tab. */
export type DashboardSessionTrafficOutput = {
  __typename?: 'DashboardSessionTrafficOutput';
  /** CTOR SKU orders, 0.0-1.0 (averaged). */
  ctorSkuOrders: Scalars['BigDecimal']['output'];
  /** Enter room rate, 0.0-1.0 (averaged). */
  enterRoomRate: Scalars['BigDecimal']['output'];
  /** Impressions (summed). */
  impressions: Scalars['Long']['output'];
  /** Live GMV in the store's local currency (summed). */
  liveGmvLocal: Scalars['BigDecimal']['output'];
  /** Live GMV in USD (summed). */
  liveGmvUsd: Scalars['BigDecimal']['output'];
  /** Product click rate, 0.0-1.0 (averaged). */
  productClickRate: Scalars['BigDecimal']['output'];
  /** Show GPM in USD — revenue per 1,000 views, converted (averaged). */
  showGpm: Scalars['BigDecimal']['output'];
  /** Same Show GPM in the store's local currency (raw pre-FX, not converted from showGpm). Display this one alongside liveGmvLocal so the tab reads in a single currency. */
  showGpmLocal: Scalars['BigDecimal']['output'];
  /** Traffic source enum (e.g. FOR_YOU_FEED, SEARCH). */
  sourceName: Scalars['String']['output'];
  /** Views (summed). */
  views: Scalars['Long']['output'];
};

/** Filter for store-list and session-detail queries. */
export type DashboardStoreFilterInput = {
  /** ISO-3166 country code. Null means all countries. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Date range for the query. */
  dateRange: DashboardDateRangeInput;
  /** Host type: AI or HUMAN. Null means all host types. */
  hostType?: InputMaybe<Scalars['String']['input']>;
  /** 1-based page number. */
  pageNumber: Scalars['Int']['input'];
  /** Page size (1-50). */
  pageSize: Scalars['Int']['input'];
  /** Platform: TIKTOK, SHOPEE or FIREWORKS. Null means all platforms. */
  platform?: InputMaybe<Scalars['String']['input']>;
  /** Sort direction: ASC or DESC. */
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  /** Column to sort by. */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** Store the session must belong to. Supply it on every session query: it pins the lookup to that store, so a sessionId from another store yields NOT_FOUND instead of that store's data, and PERMISSION_DENIED when the caller has no access to it. Null keeps the legacy unpinned lookup and is deprecated. */
  storeId?: InputMaybe<Scalars['String']['input']>;
};

/** A single store entry for the Store Nav Row. */
export type DashboardStoreItemOutput = {
  __typename?: 'DashboardStoreItemOutput';
  /** ISO-3166 country code. */
  country: Scalars['String']['output'];
  /** Human-readable store name from account-master (null → client falls back to storeName). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** True when this (store, platform) scope has rows inside the filter's dateRange. The list itself is NOT filtered by date — every scope the caller may select is returned, so a client can validate a store id against it — but a picker should offer only the scopes where this is true. */
  hasDataInRange: Scalars['Boolean']['output'];
  /** Sales channel: TIKTOK or SHOPEE. */
  platform: Scalars['String']['output'];
  /** Unique store identifier (maps to anyx_store_id in credentials). */
  storeId: Scalars['String']['output'];
  /** Store/brand name (raw credential label). */
  storeName: Scalars['String']['output'];
};

/** List of stores for the Store Nav Row. */
export type DashboardStoreListOutput = {
  __typename?: 'DashboardStoreListOutput';
  /** Store entries. */
  items: Array<DashboardStoreItemOutput>;
};

/** Single top-brand highlight card (F-2). */
export type DashboardTopBrandOutput = {
  __typename?: 'DashboardTopBrandOutput';
  /** ISO-3166 country code. */
  country: Scalars['String']['output'];
  /** Human-readable metric label (e.g. GMV, Units, GMV/h). */
  metricLabel: Scalars['String']['output'];
  /** Primary metric value (GMV, units, or GMV/h). */
  metricValue: Scalars['BigDecimal']['output'];
  /** Same value in the scope's local currency. Null when the metric is not money (Units is a count, identical in every currency). */
  metricValueLocal?: Maybe<Scalars['BigDecimal']['output']>;
  /** Sales channel: TIKTOK or SHOPEE. */
  platform: Scalars['String']['output'];
  /** Brand (store) name. */
  storeName: Scalars['String']['output'];
};

/** Top-3 brand highlight cards (F-2): best GMV, best units, best efficiency. */
export type DashboardTopBrandsOutput = {
  __typename?: 'DashboardTopBrandsOutput';
  /** Brand with highest GMV/h efficiency. */
  bestEfficiency?: Maybe<DashboardTopBrandOutput>;
  /** Brand with highest GMV. */
  bestGmv?: Maybe<DashboardTopBrandOutput>;
  /** Brand with highest units sold. */
  bestUnits?: Maybe<DashboardTopBrandOutput>;
  /** ISO-4217 code the metricValueLocal figures are expressed in (see overview.currency). */
  currency: Scalars['String']['output'];
};

/** Traffic vs Conversion matrix sessions (§1.9). */
export type DashboardTrafficMatrixOutput = {
  __typename?: 'DashboardTrafficMatrixOutput';
  sessions: Array<DashboardTrafficMatrixSessionOutput>;
};

/** One session bubble for the Traffic vs Conversion matrix (§1.9). */
export type DashboardTrafficMatrixSessionOutput = {
  __typename?: 'DashboardTrafficMatrixSessionOutput';
  /** Conversion rate for this session. */
  cvr: Scalars['BigDecimal']['output'];
  /** GMV in USD for this session. */
  gmvUsd: Scalars['BigDecimal']['output'];
  /** Store name. */
  name: Scalars['String']['output'];
  /** Session identifier. */
  sessionId: Scalars['String']['output'];
  /** Total viewers for this session. */
  viewers: Scalars['Long']['output'];
};

/** One time-bucket row in the GMV & Efficiency Trend chart (F-4). */
export type DashboardTrendRowOutput = {
  __typename?: 'DashboardTrendRowOutput';
  /** AI host total duration in hours (tooltip only). */
  aiDurationH: Scalars['BigDecimal']['output'];
  /** AI host duration in hours for this bucket with its availability (tooltip); see aiGmvMetric. */
  aiDurationMetric?: Maybe<DashboardKpiMetricOutput>;
  /** AI host total GMV in USD. */
  aiGmv: Scalars['BigDecimal']['output'];
  /** AI host GMV per hour. */
  aiGmvH: Scalars['BigDecimal']['output'];
  /** AI host GMV per hour in the local currency of the scope (Brand) or the resolved scope (Regional). */
  aiGmvHLocal?: Maybe<Scalars['BigDecimal']['output']>;
  /** AI host total GMV in the local currency of the scope (Brand) or the resolved scope (Regional). */
  aiGmvLocal?: Maybe<Scalars['BigDecimal']['output']>;
  /** AI host GMV for this bucket with its availability (anylive#397). A null value is a gap, not a zero: NOT_YET_AVAILABLE when no platform has delivered this bucket, UNSUPPORTED when none reports it. PARTIAL keeps the on-time platforms' value (see incompletePlatforms). Null when not evaluated. */
  aiGmvMetric?: Maybe<DashboardKpiMetricOutput>;
  /** AI host GMV per hour for this bucket with its availability, dividing only the days that have both GMV and hours; see aiGmvMetric. */
  aiGmvPerHourMetric?: Maybe<DashboardKpiMetricOutput>;
  /** ISO-4217 code for the local GMV values. On Regional it describes the whole scope, so it is identical on every row. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Human host total duration in hours (tooltip only). */
  humanDurationH: Scalars['BigDecimal']['output'];
  /** Human host duration in hours for this bucket with its availability (tooltip); see aiDurationMetric. */
  humanDurationMetric?: Maybe<DashboardKpiMetricOutput>;
  /** Human host total GMV in USD. */
  humanGmv: Scalars['BigDecimal']['output'];
  /** Human host GMV per hour. */
  humanGmvH: Scalars['BigDecimal']['output'];
  /** Human host GMV per hour in the local currency of the scope (Brand) or the resolved scope (Regional). */
  humanGmvHLocal?: Maybe<Scalars['BigDecimal']['output']>;
  /** Human host total GMV in the local currency of the scope (Brand) or the resolved scope (Regional). */
  humanGmvLocal?: Maybe<Scalars['BigDecimal']['output']>;
  /** Human host GMV for this bucket with its availability; see aiGmvMetric. */
  humanGmvMetric?: Maybe<DashboardKpiMetricOutput>;
  /** Human host GMV per hour for this bucket with its availability; see aiGmvPerHourMetric. */
  humanGmvPerHourMetric?: Maybe<DashboardKpiMetricOutput>;
  /** Ready-to-render X-axis label (e.g. 'Jun 3', 'Week of Jun 1', 'Jun 2026'). */
  label: Scalars['String']['output'];
};

export type DatasourceFilterInput = {
  masterDataStoreId?: InputMaybe<Scalars['Long']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DatasourceType>;
};

export type DatasourcePayload = {
  __typename?: 'DatasourcePayload';
  createdAt: Scalars['ZonedDatetime']['output'];
  fivetranSchemaName?: Maybe<Scalars['String']['output']>;
  fivetranTableName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  isActive: Scalars['Boolean']['output'];
  masterDataStoreId: Scalars['Long']['output'];
  masterDataUserId?: Maybe<Scalars['Long']['output']>;
  setting?: Maybe<Scalars['Map']['output']>;
  status: DatasourceStatus;
  statusDetail?: Maybe<Scalars['Map']['output']>;
  store: MdStore;
  tokenId?: Maybe<Scalars['Long']['output']>;
  type: DatasourceType;
  updatedAt: Scalars['ZonedDatetime']['output'];
  user?: Maybe<MdUser>;
};

export type DatasourcePayloadList = {
  __typename?: 'DatasourcePayloadList';
  items: Array<DatasourcePayload>;
  meta: ReportListMeta;
};

export type DatasourceSettingInput = {
  account?: InputMaybe<Scalars['String']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Scalars['String']['input']>;
  profileName?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
  propertyName?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
  viewName?: InputMaybe<Scalars['String']['input']>;
};

export const DatasourceSortByField = {
  CREATED_AT: 'CREATED_AT',
  ID: 'ID',
  TYPE: 'TYPE',
  UPDATED_AT: 'UPDATED_AT'
} as const;

export type DatasourceSortByField = typeof DatasourceSortByField[keyof typeof DatasourceSortByField];
export type DatasourceSortByInput = {
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  field: DatasourceSortByField;
};

export const DatasourceStatus = {
  ACTIVE: 'ACTIVE',
  FAILED: 'FAILED',
  INITIALIZING: 'INITIALIZING'
} as const;

export type DatasourceStatus = typeof DatasourceStatus[keyof typeof DatasourceStatus];
export type DatasourceTokenPayload = {
  __typename?: 'DatasourceTokenPayload';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  type: DatasourceType;
};

export const DatasourceType = {
  FacebookAds: 'FacebookAds',
  GoogleAds: 'GoogleAds',
  GoogleAnalytics4: 'GoogleAnalytics4',
  TikTokAds: 'TikTokAds',
  YahooDisplayAds: 'YahooDisplayAds',
  YahooSearchAds: 'YahooSearchAds'
} as const;

export type DatasourceType = typeof DatasourceType[keyof typeof DatasourceType];
export type DateRange = {
  __typename?: 'DateRange';
  from: Scalars['OffsetDateTime']['output'];
  to: Scalars['OffsetDateTime']['output'];
};

export type DateRangeInput = {
  from: Scalars['OffsetDateTime']['input'];
  to: Scalars['OffsetDateTime']['input'];
};

export type DateRangeResponse = {
  __typename?: 'DateRangeResponse';
  from?: Maybe<Scalars['Date']['output']>;
  to?: Maybe<Scalars['Date']['output']>;
};

/** DateTime range input type. */
export type DateTimeRangeInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DdiAnalyticsChartInput = {
  dimension: ReportDimensions;
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  saleChannelTypes?: InputMaybe<Array<SaleChannelType>>;
  sortBy?: InputMaybe<DdiAnalyticsReportSortBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['ZonedDatetime']['input'];
  warehouse?: InputMaybe<DdiWarehouse>;
};

export type DdiAnalyticsChartPayload = {
  __typename?: 'DdiAnalyticsChartPayload';
  currency: ReportSupportedCurrency;
  grossSales: Array<Scalars['Map']['output']>;
  marketplaceCalendarEvents: Array<MarketplaceCalendarEventChartPayload>;
  netSales: Array<Scalars['Map']['output']>;
  orders: Array<Scalars['Map']['output']>;
  saleChannelTypes: Array<SaleChannelType>;
};

export type DdiAnalyticsDetailedReportInput = {
  dimension: ReportDimensions;
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  saleChannelTypes?: InputMaybe<Array<SaleChannelType>>;
  sortBy?: InputMaybe<DdiAnalyticsReportSortBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['ZonedDatetime']['input'];
  warehouse?: InputMaybe<DdiWarehouse>;
};

export type DdiAnalyticsDetailedReportPayload = {
  __typename?: 'DdiAnalyticsDetailedReportPayload';
  avgOrderValue: Scalars['BigDecimal']['output'];
  cancellationRate: Scalars['BigDecimal']['output'];
  cancelledOrders: Scalars['Long']['output'];
  channel?: Maybe<SaleChannelType>;
  currency: ReportSupportedCurrency;
  cvr: Scalars['BigDecimal']['output'];
  day?: Maybe<Scalars['LocalDate']['output']>;
  discount: Scalars['BigDecimal']['output'];
  discountRate: Scalars['BigDecimal']['output'];
  dow?: Maybe<Scalars['Int']['output']>;
  grossSales: Scalars['BigDecimal']['output'];
  month?: Maybe<Scalars['YearMonth']['output']>;
  netSales: Scalars['BigDecimal']['output'];
  orders: Scalars['Long']['output'];
  sessions: Scalars['Long']['output'];
  subsidy: Scalars['BigDecimal']['output'];
  week?: Maybe<Scalars['LocalDate']['output']>;
};

export type DdiAnalyticsDetailedReportPayloadList = {
  __typename?: 'DdiAnalyticsDetailedReportPayloadList';
  items: Array<DdiAnalyticsDetailedReportPayload>;
  meta: ReportListMeta;
  total: DdiAnalyticsDetailedReportTotalPayload;
};

export type DdiAnalyticsDetailedReportTotalPayload = {
  __typename?: 'DdiAnalyticsDetailedReportTotalPayload';
  avgOrderValue: Scalars['BigDecimal']['output'];
  cancellationRate: Scalars['BigDecimal']['output'];
  cancelledOrders: Scalars['Long']['output'];
  currency: ReportSupportedCurrency;
  cvr: Scalars['BigDecimal']['output'];
  discount: Scalars['BigDecimal']['output'];
  discountRate: Scalars['BigDecimal']['output'];
  grossSales: Scalars['BigDecimal']['output'];
  netSales: Scalars['BigDecimal']['output'];
  orders: Scalars['Long']['output'];
  sessions: Scalars['Long']['output'];
  subsidy: Scalars['BigDecimal']['output'];
};

export type DdiAnalyticsReportExportInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  saleChannelTypes?: InputMaybe<Array<SaleChannelType>>;
  startDate: Scalars['ZonedDatetime']['input'];
  warehouse?: InputMaybe<DdiWarehouse>;
};

export const DdiAnalyticsReportSortBy = {
  AVG_ORDER_VALUES: 'AVG_ORDER_VALUES',
  CANCELLED_ORDERS: 'CANCELLED_ORDERS',
  CVR: 'CVR',
  DIMENSION: 'DIMENSION',
  DISCOUNTS: 'DISCOUNTS',
  DISCOUNTS_RATE: 'DISCOUNTS_RATE',
  GROSS_SALES: 'GROSS_SALES',
  NET_SALES: 'NET_SALES',
  ORDERS: 'ORDERS',
  SESSIONS: 'SESSIONS',
  SUBSIDY: 'SUBSIDY'
} as const;

export type DdiAnalyticsReportSortBy = typeof DdiAnalyticsReportSortBy[keyof typeof DdiAnalyticsReportSortBy];
export type DdiAnalyticsSummaryInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  saleChannelTypes?: InputMaybe<Array<SaleChannelType>>;
  startDate: Scalars['ZonedDatetime']['input'];
  warehouse?: InputMaybe<DdiWarehouse>;
};

export type DdiAnalyticsSummaryPayload = {
  __typename?: 'DdiAnalyticsSummaryPayload';
  currency: ReportSupportedCurrency;
  grossSales: NumericValueWithDiffPayload;
  netSales: NumericValueWithDiffPayload;
  orders: NumericValueWithDiffPayload;
};

export type DdiHomeReportChartPayload = {
  __typename?: 'DdiHomeReportChartPayload';
  currency: ReportSupportedCurrency;
  grossSales: Array<Scalars['Map']['output']>;
  netSales: Array<Scalars['Map']['output']>;
  orders: Array<Scalars['Map']['output']>;
};

export type DdiHomeReportInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreIds: Array<Scalars['Long']['input']>;
  saleChannelTypes: Array<SaleChannelType>;
  startDate: Scalars['ZonedDatetime']['input'];
};

export type DdiHomeReportPieChartPayload = {
  __typename?: 'DdiHomeReportPieChartPayload';
  currency: ReportSupportedCurrency;
  grossSales: Array<DdiHomeReportPieChartSectionPayload>;
  netSales: Array<DdiHomeReportPieChartSectionPayload>;
  orders: Array<DdiHomeReportPieChartSectionPayload>;
};

export type DdiHomeReportPieChartSectionPayload = {
  __typename?: 'DdiHomeReportPieChartSectionPayload';
  saleChannelType: SaleChannelType;
  value: Scalars['BigDecimal']['output'];
};

export type DdiHomeReportSummaryPayload = {
  __typename?: 'DdiHomeReportSummaryPayload';
  currency: ReportSupportedCurrency;
  grossSales: NumericValueWithDiffPayload;
  netSales: NumericValueWithDiffPayload;
  orders: NumericValueWithDiffPayload;
};

export type DdiHomeReportTopProductPayload = {
  __typename?: 'DdiHomeReportTopProductPayload';
  grossSales: Scalars['BigDecimal']['output'];
  netSales: Scalars['BigDecimal']['output'];
  orders: Scalars['Long']['output'];
  productId?: Maybe<Scalars['Long']['output']>;
  productImageUrl?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
};

export type DdiHomeReportTopProductsPayload = {
  __typename?: 'DdiHomeReportTopProductsPayload';
  currency: ReportSupportedCurrency;
  products: Array<DdiHomeReportTopProductPayload>;
};

export const DdiInventoryDailyReportSortBy = {
  AVAILABLE_TO_PURCHASE: 'AVAILABLE_TO_PURCHASE',
  DATE: 'DATE',
  DAYS_OF_INVENTORY: 'DAYS_OF_INVENTORY',
  STOCK_ON_HAND: 'STOCK_ON_HAND',
  STOCK_ON_HAND_VALUE: 'STOCK_ON_HAND_VALUE'
} as const;

export type DdiInventoryDailyReportSortBy = typeof DdiInventoryDailyReportSortBy[keyof typeof DdiInventoryDailyReportSortBy];
export const DdiInventoryProductReportSortBy = {
  DAYS_OF_INVENTORY: 'DAYS_OF_INVENTORY',
  INVENTORY_STATUS: 'INVENTORY_STATUS',
  PRODUCT_CODE: 'PRODUCT_CODE',
  PRODUCT_NAME: 'PRODUCT_NAME',
  STOCK_ON_HAND: 'STOCK_ON_HAND',
  STOCK_ON_HAND_VALUE: 'STOCK_ON_HAND_VALUE'
} as const;

export type DdiInventoryProductReportSortBy = typeof DdiInventoryProductReportSortBy[keyof typeof DdiInventoryProductReportSortBy];
export type DdiInventoryStockValueDailyReportExportInput = {
  endDate: Scalars['LocalDate']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  sortBy?: InputMaybe<DdiInventoryDailyReportSortBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  startDate: Scalars['LocalDate']['input'];
  warehouse: DdiWarehouse;
};

export type DdiInventoryStockValueDailyReportInput = {
  endDate: Scalars['LocalDate']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortBy?: InputMaybe<DdiInventoryDailyReportSortBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['LocalDate']['input'];
  warehouse: DdiWarehouse;
};

export type DdiInventoryStockValueDailyReportPayload = {
  __typename?: 'DdiInventoryStockValueDailyReportPayload';
  availableToPurchase: Scalars['BigDecimal']['output'];
  date: Scalars['LocalDate']['output'];
  daysOfInventory: Scalars['Long']['output'];
  stockOnHand: Scalars['Long']['output'];
  stockOnHandValue: Scalars['BigDecimal']['output'];
};

export type DdiInventoryStockValueDailyReportPayloadList = {
  __typename?: 'DdiInventoryStockValueDailyReportPayloadList';
  days: Array<DdiInventoryStockValueDailyReportPayload>;
  meta: ReportListMeta;
};

export type DdiInventoryStockValueProductReportExportInput = {
  date: Scalars['LocalDate']['input'];
  inventoryStatuses?: InputMaybe<Array<InventoryStatus>>;
  masterDataStoreId: Scalars['Long']['input'];
  productKeyword?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<DdiInventoryProductReportSortBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  warehouse: DdiWarehouse;
};

export type DdiInventoryStockValueProductReportInput = {
  date: Scalars['LocalDate']['input'];
  inventoryStatuses?: InputMaybe<Array<InventoryStatus>>;
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  productKeyword?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<DdiInventoryProductReportSortBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  warehouse: DdiWarehouse;
};

export type DdiInventoryStockValueProductReportPayload = {
  __typename?: 'DdiInventoryStockValueProductReportPayload';
  daysOfInventory: Scalars['Long']['output'];
  inventoryStatus: InventoryStatus;
  productCode?: Maybe<Scalars['String']['output']>;
  productId: Scalars['Long']['output'];
  productImageUrl?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productVariantId: Scalars['Long']['output'];
  productVariantName?: Maybe<Scalars['String']['output']>;
  stockOnHand: Scalars['Long']['output'];
  stockOnHandValue: Scalars['BigDecimal']['output'];
};

export type DdiInventoryStockValueProductReportPayloadList = {
  __typename?: 'DdiInventoryStockValueProductReportPayloadList';
  meta: ReportListMeta;
  products: Array<DdiInventoryStockValueProductReportPayload>;
};

export type DdiInventoryTrackerReportInput = {
  date: Scalars['LocalDate']['input'];
  masterDataStoreId: Scalars['Long']['input'];
};

export type DdiInventoryTrackerReportPayload = {
  __typename?: 'DdiInventoryTrackerReportPayload';
  warehouseData: Array<DdiInventoryTrackerReportWarehouseDataPayload>;
};

export type DdiInventoryTrackerReportSegmentDataPayload = {
  __typename?: 'DdiInventoryTrackerReportSegmentDataPayload';
  availableToPurchase: Scalars['BigDecimal']['output'];
  daysOfInventory: Scalars['Long']['output'];
  segment: DdiProductSegment;
  stockOnHand: Scalars['Long']['output'];
  stockOnHandValue: Scalars['BigDecimal']['output'];
};

export type DdiInventoryTrackerReportStore = {
  __typename?: 'DdiInventoryTrackerReportStore';
  masterDataStoreId: Scalars['Long']['output'];
  storeName: Scalars['String']['output'];
};

export type DdiInventoryTrackerReportStores = {
  __typename?: 'DdiInventoryTrackerReportStores';
  stores: Array<DdiInventoryTrackerReportStore>;
};

export type DdiInventoryTrackerReportWarehouseDataPayload = {
  __typename?: 'DdiInventoryTrackerReportWarehouseDataPayload';
  segmentData: Array<DdiInventoryTrackerReportSegmentDataPayload>;
  warehouse: DdiWarehouse;
};

export type DdiPersonInChargeAssignedStorePayload = {
  __typename?: 'DdiPersonInChargeAssignedStorePayload';
  masterDataStoreId: Scalars['Long']['output'];
  storeName: Scalars['String']['output'];
};

export type DdiPersonInChargePayload = {
  __typename?: 'DdiPersonInChargePayload';
  assignedStores: Array<DdiPersonInChargeAssignedStorePayload>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type DdiPersonInChargePayloadList = {
  __typename?: 'DdiPersonInChargePayloadList';
  data: Array<DdiPersonInChargePayload>;
};

export type DdiProductAnalyticsDetailedReportInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  masterDataStoreIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  saleChannelTypes?: InputMaybe<Array<SaleChannelType>>;
  sortBy?: InputMaybe<DdiProductAnalyticsReportSortBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['ZonedDatetime']['input'];
  warehouse?: InputMaybe<DdiWarehouse>;
};

export type DdiProductAnalyticsDetailedReportPayload = {
  __typename?: 'DdiProductAnalyticsDetailedReportPayload';
  avgSales: Scalars['BigDecimal']['output'];
  currency: ReportSupportedCurrency;
  discount: Scalars['BigDecimal']['output'];
  discountRate: Scalars['BigDecimal']['output'];
  grossSales: Scalars['BigDecimal']['output'];
  masterDataStoreId: Scalars['Long']['output'];
  netSales: Scalars['BigDecimal']['output'];
  productCode?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Long']['output']>;
  productMedia?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productStatus?: Maybe<ProductVariantStatus>;
  productVariantId?: Maybe<Scalars['Long']['output']>;
  subsidy: Scalars['BigDecimal']['output'];
  unitsSold: Scalars['Long']['output'];
};

export type DdiProductAnalyticsDetailedReportPayloadList = {
  __typename?: 'DdiProductAnalyticsDetailedReportPayloadList';
  items: Array<DdiProductAnalyticsDetailedReportPayload>;
  meta: ReportListMeta;
  total: DdiProductAnalyticsDetailedReportTotalPayload;
};

export type DdiProductAnalyticsDetailedReportTotalPayload = {
  __typename?: 'DdiProductAnalyticsDetailedReportTotalPayload';
  avgSales: Scalars['BigDecimal']['output'];
  currency: ReportSupportedCurrency;
  discount: Scalars['BigDecimal']['output'];
  discountRate: Scalars['BigDecimal']['output'];
  grossSales: Scalars['BigDecimal']['output'];
  netSales: Scalars['BigDecimal']['output'];
  subsidy: Scalars['BigDecimal']['output'];
  unitsSold: Scalars['Long']['output'];
};

export type DdiProductAnalyticsReportExportInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  masterDataStoreIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  saleChannelTypes?: InputMaybe<Array<SaleChannelType>>;
  startDate: Scalars['ZonedDatetime']['input'];
  warehouse?: InputMaybe<DdiWarehouse>;
};

export const DdiProductAnalyticsReportSortBy = {
  AVG_SALES: 'AVG_SALES',
  DISCOUNT: 'DISCOUNT',
  DISCOUNT_RATE: 'DISCOUNT_RATE',
  GROSS_SALES: 'GROSS_SALES',
  NET_SALES: 'NET_SALES',
  PRODUCT_CODE: 'PRODUCT_CODE',
  PRODUCT_NAME: 'PRODUCT_NAME',
  SUBSIDY: 'SUBSIDY',
  UNITS_SOLD: 'UNITS_SOLD'
} as const;

export type DdiProductAnalyticsReportSortBy = typeof DdiProductAnalyticsReportSortBy[keyof typeof DdiProductAnalyticsReportSortBy];
export type DdiProductAnalyticsSummaryInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  masterDataStoreIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  saleChannelTypes?: InputMaybe<Array<SaleChannelType>>;
  startDate: Scalars['ZonedDatetime']['input'];
  warehouse?: InputMaybe<DdiWarehouse>;
};

export type DdiProductAnalyticsSummaryPayload = {
  __typename?: 'DdiProductAnalyticsSummaryPayload';
  currency: ReportSupportedCurrency;
  grossSales: NumericValueWithDiffPayload;
  netSales: NumericValueWithDiffPayload;
  unitsSold: NumericValueWithDiffPayload;
};

export const DdiProductSegment = {
  ESSENTIAL: 'ESSENTIAL',
  NORMAL: 'NORMAL',
  SUPER_ESSENTIAL: 'SUPER_ESSENTIAL',
  SUPER_LOW: 'SUPER_LOW',
  TOTAL: 'TOTAL',
  UNSEGMENTED: 'UNSEGMENTED'
} as const;

export type DdiProductSegment = typeof DdiProductSegment[keyof typeof DdiProductSegment];
export type DdiProductStatusInput = {
  masterDataStoreId: Scalars['Long']['input'];
  productVariantIds: Array<Scalars['Long']['input']>;
};

export type DdiProductStatusPayload = {
  __typename?: 'DdiProductStatusPayload';
  imageUrl?: Maybe<Scalars['String']['output']>;
  isListed: Scalars['Boolean']['output'];
  productCode?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productVariantId: Scalars['Long']['output'];
  productVariantName?: Maybe<Scalars['String']['output']>;
  warehouseData: Array<DdiProductWarehouseStatusPayload>;
};

export type DdiProductStatusPayloadList = {
  __typename?: 'DdiProductStatusPayloadList';
  products: Array<DdiProductStatusPayload>;
};

export type DdiProductWarehouseStatusPayload = {
  __typename?: 'DdiProductWarehouseStatusPayload';
  isActive: Scalars['Boolean']['output'];
  segment: DdiProductSegment;
  warehouse: DdiWarehouse;
};

export const DdiWarehouse = {
  BANDUNG: 'BANDUNG',
  JAKARTA: 'JAKARTA',
  MEDAN: 'MEDAN',
  NON_GTL: 'NON_GTL',
  SURABAYA: 'SURABAYA'
} as const;

export type DdiWarehouse = typeof DdiWarehouse[keyof typeof DdiWarehouse];
export type DeactivateAi = {
  __typename?: 'DeactivateAI';
  isAuto: Scalars['Boolean']['output'];
};

export type DeclaredUnitPriceInput = {
  declaredUnitPrice: Scalars['String']['input'];
  skuCode: Scalars['String']['input'];
};

export type DecodeDraftUnitMessageContentRequest = {
  serializedContent: Scalars['String']['input'];
};

export type DelayAction = {
  __typename?: 'DelayAction';
  time: Scalars['Int']['output'];
  unit: DelayUnit;
};

export type DelayActionInput = {
  time: Scalars['Int']['input'];
  unit: DelayUnit;
};

export const DelayUnit = {
  DAYS: 'DAYS',
  HOURS: 'HOURS',
  MINUTES: 'MINUTES',
  SECONDS: 'SECONDS',
  WEEKS: 'WEEKS'
} as const;

export type DelayUnit = typeof DelayUnit[keyof typeof DelayUnit];
export type DeleteCustomerTagsRequest = {
  customerTagIds: Array<Scalars['String']['input']>;
};

export type DeleteMarketplaceCalendarEventInput = {
  id: Scalars['Long']['input'];
};

export type DeleteSaleChannelInput = {
  saleChannelId: Scalars['Long']['input'];
  storeId: Scalars['Long']['input'];
};

export type DeleteSaleChannelPayload = {
  __typename?: 'DeleteSaleChannelPayload';
  ok: Scalars['Boolean']['output'];
};

export const DeliveryStatus = {
  ALLOCATING: 'ALLOCATING',
  CANCELLED: 'CANCELLED',
  PAYING: 'PAYING',
  PENDING: 'PENDING',
  PREPARING: 'PREPARING',
  SHIPPED: 'SHIPPED',
  WORKING: 'WORKING'
} as const;

export type DeliveryStatus = typeof DeliveryStatus[keyof typeof DeliveryStatus];
export const DeliveryTimeframe = {
  AFTERNOON: 'AFTERNOON',
  MORNING: 'MORNING',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
  _12_14: '_12_14',
  _14_16: '_14_16',
  _16_18: '_16_18',
  _18_20: '_18_20',
  _18_21: '_18_21',
  _19_21: '_19_21',
  _20_21: '_20_21'
} as const;

export type DeliveryTimeframe = typeof DeliveryTimeframe[keyof typeof DeliveryTimeframe];
export type DeliveryTiming = Immediately | Schedule;

export type DeliveryTimingItemInput = {
  schedule?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  type: DeliveryTimingType;
};

export const DeliveryTimingType = {
  IMMEDIATELY_SEND: 'IMMEDIATELY_SEND',
  SCHEDULE_SEND: 'SCHEDULE_SEND'
} as const;

export type DeliveryTimingType = typeof DeliveryTimingType[keyof typeof DeliveryTimingType];
export type DisableInventorySyncOutput = {
  __typename?: 'DisableInventorySyncOutput';
  ok: Scalars['Boolean']['output'];
};

export type Document = {
  __typename?: 'Document';
  filepath: Scalars['String']['output'];
};

export type DocumentPayload = {
  __typename?: 'DocumentPayload';
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  status: DocumentStatus;
  url?: Maybe<Scalars['String']['output']>;
};

export const DocumentStatus = {
  FAIL: 'FAIL',
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS'
} as const;

export type DocumentStatus = typeof DocumentStatus[keyof typeof DocumentStatus];
export type DraftCandidateGql = {
  __typename?: 'DraftCandidateGQL';
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  tone: Scalars['String']['output'];
};

export type DraftUnitMessage = {
  __typename?: 'DraftUnitMessage';
  content: Array<LineMessage>;
  name: Scalars['String']['output'];
};

/** Duration range input type. */
export type DurationRangeInput = {
  from?: InputMaybe<Scalars['Duration']['input']>;
  to?: InputMaybe<Scalars['Duration']['input']>;
};

export const DutyDisplayOption = {
  WITHOUT_DUTIES_ONLY: 'WITHOUT_DUTIES_ONLY',
  WITH_AND_WITHOUT_DUTIES: 'WITH_AND_WITHOUT_DUTIES',
  WITH_DUTIES_ONLY: 'WITH_DUTIES_ONLY'
} as const;

export type DutyDisplayOption = typeof DutyDisplayOption[keyof typeof DutyDisplayOption];
export type Emoji = {
  __typename?: 'Emoji';
  code: Scalars['String']['output'];
};

export type EmptySaleChannelData = {
  __typename?: 'EmptySaleChannelData';
  dummyData: Scalars['Boolean']['output'];
};

export type EnableInventorySyncOutput = {
  __typename?: 'EnableInventorySyncOutput';
  forceSyncWarning?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EstimateRecipient = {
  __typename?: 'EstimateRecipient';
  estimateCount: Scalars['Int']['output'];
};

/** Response type for export operations containing report ID and name. The URL will be generated asynchronously and can be retrieved using the report ID. */
export type ExportResponse = {
  __typename?: 'ExportResponse';
  /** The name of the exported Google Sheets document. */
  name: Scalars['String']['output'];
  /** The ID of the created report export record. */
  reportId: Scalars['ID']['output'];
  /** @deprecated The 'url' field is deprecated. Use 'reportId' to query the ReportExport type for the URL when the export is ready. */
  url: Scalars['String']['output'];
};

export type Facebook = {
  __typename?: 'Facebook';
  description?: Maybe<Scalars['String']['output']>;
  privacy?: Maybe<FacebookPrivacy>;
  title?: Maybe<Scalars['String']['output']>;
};

export const FacebookAdAccountDisabledReasonResponse = {
  ADS_AFC_REVIEW: 'ADS_AFC_REVIEW',
  ADS_INTEGRITY_POLICY: 'ADS_INTEGRITY_POLICY',
  ADS_IP_REVIEW: 'ADS_IP_REVIEW',
  AOAB_DESHARE_LEGAL_ENTITY: 'AOAB_DESHARE_LEGAL_ENTITY',
  BUSINESS_INTEGRITY_RAR: 'BUSINESS_INTEGRITY_RAR',
  BUSINESS_MANAGER_INTEGRITY_POLICY: 'BUSINESS_MANAGER_INTEGRITY_POLICY',
  COMPROMISED_AD_ACCOUNT: 'COMPROMISED_AD_ACCOUNT',
  CTX_THREAD_REVIEW: 'CTX_THREAD_REVIEW',
  GRAY_ACCOUNT_SHUT_DOWN: 'GRAY_ACCOUNT_SHUT_DOWN',
  MISREPRESENTED_AD_ACCOUNT: 'MISREPRESENTED_AD_ACCOUNT',
  NONE: 'NONE',
  PERMANENT_CLOSE: 'PERMANENT_CLOSE',
  RISK_PAYMENT: 'RISK_PAYMENT',
  UMBRELLA_AD_ACCOUNT: 'UMBRELLA_AD_ACCOUNT',
  UNUSED_ACCOUNT: 'UNUSED_ACCOUNT',
  UNUSED_RESELLER_ACCOUNT: 'UNUSED_RESELLER_ACCOUNT'
} as const;

export type FacebookAdAccountDisabledReasonResponse = typeof FacebookAdAccountDisabledReasonResponse[keyof typeof FacebookAdAccountDisabledReasonResponse];
export const FacebookAdAccountStatusResponse = {
  ACTIVE: 'ACTIVE',
  ANY_ACTIVE: 'ANY_ACTIVE',
  ANY_CLOSED: 'ANY_CLOSED',
  CLOSED: 'CLOSED',
  DISABLED: 'DISABLED',
  IN_GRACE_PERIOD: 'IN_GRACE_PERIOD',
  PENDING_CLOSURE: 'PENDING_CLOSURE',
  PENDING_RISK_REVIEW: 'PENDING_RISK_REVIEW',
  PENDING_SETTLEMENT: 'PENDING_SETTLEMENT',
  UNSETTLED: 'UNSETTLED'
} as const;

export type FacebookAdAccountStatusResponse = typeof FacebookAdAccountStatusResponse[keyof typeof FacebookAdAccountStatusResponse];
export type FacebookAdsAdAccount = {
  __typename?: 'FacebookAdsAdAccount';
  accountStatus?: Maybe<FacebookAdAccountStatusResponse>;
  age?: Maybe<Scalars['Int']['output']>;
  amountSpent?: Maybe<Scalars['String']['output']>;
  balance?: Maybe<Scalars['String']['output']>;
  businessCity?: Maybe<Scalars['String']['output']>;
  businessCountryCode?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessState?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['ZonedDatetime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  disabledReason?: Maybe<FacebookAdAccountDisabledReasonResponse>;
  id: Scalars['String']['output'];
  mediaAgency?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Scalars['String']['output']>;
  timezoneName?: Maybe<Scalars['String']['output']>;
  timezoneOffsetHoursUtc?: Maybe<Scalars['Float']['output']>;
};

export type FacebookAdsAdAccountPayloadList = {
  __typename?: 'FacebookAdsAdAccountPayloadList';
  items: Array<FacebookAdsAdAccount>;
  meta: ReportListMeta;
};

export type FacebookExchangeCodePayload = {
  __typename?: 'FacebookExchangeCodePayload';
  datasourceTokenId: Scalars['Long']['output'];
  email?: Maybe<Scalars['String']['output']>;
};

/** A Facebook page manageable by the store's connected user. */
export type FacebookPageOutput = {
  __typename?: 'FacebookPageOutput';
  pageId: Scalars['String']['output'];
  pageName: Scalars['String']['output'];
};

export const FacebookPrivacy = {
  ALL_FRIENDS: 'ALL_FRIENDS',
  EVERYONE: 'EVERYONE',
  FRIENDS_OF_FRIENDS: 'FRIENDS_OF_FRIENDS',
  SELF: 'SELF'
} as const;

export type FacebookPrivacy = typeof FacebookPrivacy[keyof typeof FacebookPrivacy];
/** Optional configuration for a Facebook live video. */
export type FacebookSessionConfigInput = {
  /** Optional description for the live video. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Audience privacy for the live video. Required for personal user account connections; must be null for Page connections. */
  privacy?: InputMaybe<FacebookPrivacy>;
  /** Optional title for the live video. Maximum 254 characters. */
  title?: InputMaybe<Scalars['String']['input']>;
};

export const FacebookTargetType = {
  PAGE: 'PAGE',
  USER: 'USER'
} as const;

export type FacebookTargetType = typeof FacebookTargetType[keyof typeof FacebookTargetType];
export type FailToStartSendingMessengerBroadcastTooManyUnavailableCustomer = {
  __typename?: 'FailToStartSendingMessengerBroadcastTooManyUnavailableCustomer';
  availableRecipientsCount: Scalars['Int']['output'];
  waitUntil: Scalars['OffsetDateTime']['output'];
};

export type FailedMessageContent = FailedMessageFileContent | FailedMessageImageContent | FailedMessageTextContent | FailedMessageVideoContent;

export type FailedMessageFileContent = {
  __typename?: 'FailedMessageFileContent';
  url: Scalars['String']['output'];
};

export type FailedMessageImageContent = {
  __typename?: 'FailedMessageImageContent';
  url: Scalars['String']['output'];
};

export type FailedMessageTextContent = {
  __typename?: 'FailedMessageTextContent';
  text: Scalars['String']['output'];
};

export type FailedMessageVideoContent = {
  __typename?: 'FailedMessageVideoContent';
  url: Scalars['String']['output'];
};

export type FailureCancelOrder = {
  __typename?: 'FailureCancelOrder';
  orderId: Scalars['Long']['output'];
  reason: Scalars['String']['output'];
};

export const FaqCustomVideoAudioMode = {
  ORIGINAL: 'ORIGINAL',
  REPLACEMENT_TEXT: 'REPLACEMENT_TEXT'
} as const;

export type FaqCustomVideoAudioMode = typeof FaqCustomVideoAudioMode[keyof typeof FaqCustomVideoAudioMode];
/** Output type for FAQ regenerate. */
export type FaqRegenerateOutput = {
  __typename?: 'FaqRegenerateOutput';
  /** The generated answer for the FAQ. */
  answer: Scalars['String']['output'];
  /** The unique identifier of the FAQ. */
  id: Scalars['String']['output'];
  /** Comma-separated trigger words for the FAQ. */
  triggerWords: Scalars['String']['output'];
};

export type FedExAccountDetails = {
  __typename?: 'FedExAccountDetails';
  fedExAccountNumber: Scalars['String']['output'];
  fedExContactName: Scalars['String']['output'];
  fedExLetterheadImageURL?: Maybe<Scalars['String']['output']>;
  fedExShipperAddressId: Scalars['String']['output'];
  fedExSignatureImageURL?: Maybe<Scalars['String']['output']>;
  fedExSignatureOption: FedExSignatureOptionType;
  fedExSupportPackageTypes?: Maybe<Array<FedExPackageType>>;
};

export type FedExAddressInput = {
  addressFirst: Scalars['String']['input'];
  addressSecond?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country: Country;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceCode?: InputMaybe<Scalars['String']['input']>;
};

export type FedExAddressValidationDetails = {
  __typename?: 'FedExAddressValidationDetails';
  accountAuthToken: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  supportedValidationOptions: Array<ValidationOption>;
};

export type FedExAddressValidationInput = {
  accountNumber: Scalars['String']['input'];
  address: FedExAddressInput;
  contactName: Scalars['String']['input'];
  masterDataAccountId: Scalars['ID']['input'];
};

export type FedExCreateCourier = {
  accountAuthToken: Scalars['String']['input'];
  accountId: Scalars['ID']['input'];
  accountNumber: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  invoice?: InputMaybe<FedExInvoiceInput>;
  letterheadImageURL?: InputMaybe<Scalars['String']['input']>;
  secureCodePin?: InputMaybe<Scalars['String']['input']>;
  signatureImageURL?: InputMaybe<Scalars['String']['input']>;
  signatureOption: FedExSignatureOptionType;
  supportPackageTypes?: InputMaybe<Array<FedExPackageType>>;
};

export type FedExGeneratePinCodeInput = {
  accountAuthToken: Scalars['String']['input'];
  masterDataAccountId: Scalars['ID']['input'];
  option: ValidationOption;
};

export type FedExInvoiceInput = {
  amount: AnylogiMoneyInput;
  date: Scalars['Date']['input'];
  number: Scalars['Int']['input'];
};

export const FedExPackageType = {
  FEDEX_10KG_BOX: 'FEDEX_10KG_BOX',
  FEDEX_25KG_BOX: 'FEDEX_25KG_BOX',
  FEDEX_ENVELOPE: 'FEDEX_ENVELOPE',
  FEDEX_EXTRA_LARGE_BOX: 'FEDEX_EXTRA_LARGE_BOX',
  FEDEX_LARGE_BOX: 'FEDEX_LARGE_BOX',
  FEDEX_MEDIUM_BOX: 'FEDEX_MEDIUM_BOX',
  FEDEX_PAK: 'FEDEX_PAK',
  FEDEX_SMALL_BOX: 'FEDEX_SMALL_BOX',
  FEDEX_TUBE: 'FEDEX_TUBE',
  FEDEX_YOUR_PACKAGING: 'FEDEX_YOUR_PACKAGING'
} as const;

export type FedExPackageType = typeof FedExPackageType[keyof typeof FedExPackageType];
export type FedExPackageWrapper = {
  __typename?: 'FedExPackageWrapper';
  FedExPackageType?: Maybe<FedExPackageType>;
};

export const FedExServiceCode = {
  FEDEX_1_DAY_FREIGHT: 'FEDEX_1_DAY_FREIGHT',
  FEDEX_2_DAY: 'FEDEX_2_DAY',
  FEDEX_2_DAY_AM: 'FEDEX_2_DAY_AM',
  FEDEX_2_DAY_FREIGHT: 'FEDEX_2_DAY_FREIGHT',
  FEDEX_3_DAY_FREIGHT: 'FEDEX_3_DAY_FREIGHT',
  FEDEX_CARGO_AIRPORT_TO_AIRPORT: 'FEDEX_CARGO_AIRPORT_TO_AIRPORT',
  FEDEX_CARGO_INTERNATIONAL_PREMIUM: 'FEDEX_CARGO_INTERNATIONAL_PREMIUM',
  FEDEX_CARGO_MAIL: 'FEDEX_CARGO_MAIL',
  FEDEX_DISTANCE_DEFERRED: 'FEDEX_DISTANCE_DEFERRED',
  FEDEX_EXPRESS_SAVER: 'FEDEX_EXPRESS_SAVER',
  FEDEX_GROUND: 'FEDEX_GROUND',
  FEDEX_INTERNATIONAL_CONNECT_PLUS: 'FEDEX_INTERNATIONAL_CONNECT_PLUS',
  FEDEX_INTERNATIONAL_PRIORITY: 'FEDEX_INTERNATIONAL_PRIORITY',
  FEDEX_INTERNATIONAL_PRIORITY_EXPRESS: 'FEDEX_INTERNATIONAL_PRIORITY_EXPRESS',
  FEDEX_IP_DIRECT_DISTRIBUTION_FREIGHT: 'FEDEX_IP_DIRECT_DISTRIBUTION_FREIGHT',
  FEDEX_NEXT_DAY: 'FEDEX_NEXT_DAY',
  FEDEX_NEXT_DAY_10AM: 'FEDEX_NEXT_DAY_10AM',
  FEDEX_NEXT_DAY_12PM: 'FEDEX_NEXT_DAY_12PM',
  FEDEX_NEXT_DAY_END_OF_DAY: 'FEDEX_NEXT_DAY_END_OF_DAY',
  FEDEX_NEXT_DAY_FREIGHT: 'FEDEX_NEXT_DAY_FREIGHT',
  FEDEX_ONE_DAY_FREIGHT: 'FEDEX_ONE_DAY_FREIGHT',
  FEDEX_REGIONAL_ECONOMY: 'FEDEX_REGIONAL_ECONOMY',
  FIRST_OVERNIGHT: 'FIRST_OVERNIGHT',
  FIRST_OVERNIGHT_FREIGHT: 'FIRST_OVERNIGHT_FREIGHT',
  GROUND_HOME_DELIVERY: 'GROUND_HOME_DELIVERY',
  INTERNATIONAL_DISTRIBUTION_FREIGHT: 'INTERNATIONAL_DISTRIBUTION_FREIGHT',
  INTERNATIONAL_ECONOMY: 'INTERNATIONAL_ECONOMY',
  INTERNATIONAL_ECONOMY_DISTRIBUTION: 'INTERNATIONAL_ECONOMY_DISTRIBUTION',
  INTERNATIONAL_ECONOMY_FREIGHT: 'INTERNATIONAL_ECONOMY_FREIGHT',
  INTERNATIONAL_FIRST: 'INTERNATIONAL_FIRST',
  INTERNATIONAL_PRIORITY_DISTRIBUTION: 'INTERNATIONAL_PRIORITY_DISTRIBUTION',
  INTERNATIONAL_PRIORITY_FREIGHT: 'INTERNATIONAL_PRIORITY_FREIGHT',
  INTL_GROUND_DISTRIBUTION: 'INTL_GROUND_DISTRIBUTION',
  PRIORITY_OVERNIGHT: 'PRIORITY_OVERNIGHT',
  SAME_DAY: 'SAME_DAY',
  SAME_DAY_CITY: 'SAME_DAY_CITY',
  SMART_POST: 'SMART_POST',
  STANDARD_OVERNIGHT: 'STANDARD_OVERNIGHT'
} as const;

export type FedExServiceCode = typeof FedExServiceCode[keyof typeof FedExServiceCode];
export type FedExServiceCodeWrapper = {
  __typename?: 'FedExServiceCodeWrapper';
  fedExServiceCode?: Maybe<FedExServiceCode>;
};

export const FedExSignatureOptionType = {
  ADULT: 'ADULT',
  DIRECT: 'DIRECT',
  INDIRECT: 'INDIRECT'
} as const;

export type FedExSignatureOptionType = typeof FedExSignatureOptionType[keyof typeof FedExSignatureOptionType];
export type FedExUpdateCourier = {
  courierId: Scalars['String']['input'];
  letterheadImageURL?: InputMaybe<Scalars['String']['input']>;
  signatureImageURL?: InputMaybe<Scalars['String']['input']>;
  signatureOption: FedExSignatureOptionType;
  supportPackageTypes?: InputMaybe<Array<FedExPackageType>>;
};

export type FetchAiAutoReplyStoreSettingInput = {
  channel: ChatType;
  storeId: Scalars['Long']['input'];
};

export type FetchCustomerChatByKeywordRequestInput = {
  keyword: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type FetchUnitMessageRequest = {
  messageId: Scalars['String']['input'];
};

export type FetchUnitMessagesRequest = {
  messageIds: Array<Scalars['String']['input']>;
};

/** File input for chat session. */
export type FileInput = {
  /** File name with path. The format must be `{userId}/{uuid}/{fileName}`. */
  filePath: Scalars['String']['input'];
};

export type FileMessage = {
  __typename?: 'FileMessage';
  card: Card;
  fileUrl: Scalars['String']['output'];
};

export type FileMessageInput = {
  fileUrl: Scalars['String']['input'];
};

export const FileType = {
  CSV: 'CSV',
  IMAGE: 'IMAGE'
} as const;

export type FileType = typeof FileType[keyof typeof FileType];
export const FileUploadCategory = {
  Ads: 'Ads',
  CouponAdvanced: 'CouponAdvanced',
  Inventories: 'Inventories',
  Orders: 'Orders',
  Products: 'Products',
  RPP: 'RPP',
  Sales: 'Sales',
  Sessions: 'Sessions',
  SponsoredBrand: 'SponsoredBrand',
  SponsoredDiscovery: 'SponsoredDiscovery',
  SponsoredDisplay: 'SponsoredDisplay',
  SponsoredProduct: 'SponsoredProduct'
} as const;

export type FileUploadCategory = typeof FileUploadCategory[keyof typeof FileUploadCategory];
export type FileUploadHistoriesInput = {
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  saleChannelId: Scalars['Long']['input'];
};

export type FileUploadHistoriesPayloadV2 = {
  __typename?: 'FileUploadHistoriesPayloadV2';
  items: Array<FileUploadHistoryPayloadV2>;
  totalCount: Scalars['Int']['output'];
};

export type FileUploadHistoryItemPayload = {
  __typename?: 'FileUploadHistoryItemPayload';
  fileName: Scalars['String']['output'];
  fileType: InventoryFileType;
  fileUri: Scalars['String']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  saleChannelType?: Maybe<SaleChannelType>;
  status: FileUploadHistoryStatusReporting;
  uploadDate: Scalars['ZonedDatetime']['output'];
};

export type FileUploadHistoryPayloadV2 = {
  __typename?: 'FileUploadHistoryPayloadV2';
  createdAt: Scalars['OffsetDateTime']['output'];
  fileName: Scalars['String']['output'];
  fileUploadCategory: FileUploadCategory;
  fileUrl: Scalars['URL']['output'];
  id: Scalars['String']['output'];
  saleChannelId: Scalars['Long']['output'];
  status: FileUploadHistoryStatus;
};

export const FileUploadHistoryStatus = {
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING',
  UPLOADED: 'UPLOADED'
} as const;

export type FileUploadHistoryStatus = typeof FileUploadHistoryStatus[keyof typeof FileUploadHistoryStatus];
export const FileUploadHistoryStatusReporting = {
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING',
  UPLOADED: 'UPLOADED'
} as const;

export type FileUploadHistoryStatusReporting = typeof FileUploadHistoryStatusReporting[keyof typeof FileUploadHistoryStatusReporting];
export type FileUploadInputV2Input = {
  amazonSellerCentral?: InputMaybe<AmazonSellerCentralFileUploadInput>;
  lazada?: InputMaybe<LazadaFileUploadInput>;
  rakuten?: InputMaybe<RakutenFileUploadInput>;
  shopee?: InputMaybe<ShopeeFileUploadInput>;
  tiktok?: InputMaybe<TikTokFileUploadInput>;
  tokopedia?: InputMaybe<TokopediaFileUploadInput>;
  zozotown?: InputMaybe<ZozotownFileUploadInput>;
};

export type FileUploadPayload = {
  __typename?: 'FileUploadPayload';
  fileName: Scalars['String']['output'];
  fileUri: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type FileUploadStatus = {
  __typename?: 'FileUploadStatus';
  /** will be shown only when FileUploadWarning.NOT_UPLOADED_IN_LAST_7_DAYS. */
  lastUploadedAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  warning?: Maybe<FileUploadWarning>;
};

export const FileUploadWarning = {
  NOT_UPLOADED_IN_LAST_7_DAYS: 'NOT_UPLOADED_IN_LAST_7_DAYS',
  NO_FILE_UPLOADED: 'NO_FILE_UPLOADED'
} as const;

export type FileUploadWarning = typeof FileUploadWarning[keyof typeof FileUploadWarning];
export type FilterMerchants = {
  accountId: Scalars['Long']['input'];
};

export type FlowBlock = {
  __typename?: 'FlowBlock';
  actionBlock?: Maybe<ActionSettingBlock>;
  conditionalSplitBlock?: Maybe<ConditionalSplitBlock>;
  id: Scalars['String']['output'];
};

export type FlowBlockInput = {
  actionBlock?: InputMaybe<ActionSettingBlockInput>;
  conditionalSplitBlock?: InputMaybe<ConditionalSplitBlockInput>;
  id: Scalars['String']['input'];
};

export const FontSize = {
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xl: 'xl',
  xxl: 'xxl'
} as const;

export type FontSize = typeof FontSize[keyof typeof FontSize];
export type FullAddress = {
  __typename?: 'FullAddress';
  addressFirst: Scalars['String']['output'];
  addressSecond?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: PhoneNumber;
  postalCode?: Maybe<Scalars['String']['output']>;
  provinceId?: Maybe<Scalars['ID']['output']>;
  regionId?: Maybe<Scalars['ID']['output']>;
  regionLocalName?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
};

export const Gender = {
  FEMALE: 'FEMALE',
  MALE: 'MALE',
  OTHER: 'OTHER'
} as const;

export type Gender = typeof Gender[keyof typeof Gender];
/** A general FAQ item linked to a live asset version. */
export type GeneralFaq = {
  __typename?: 'GeneralFaq';
  /** The answer content for this FAQ. */
  answer?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the FAQ. */
  id: Scalars['ID']['output'];
  /** The name/title for this FAQ. */
  name: Scalars['String']['output'];
  /** Trigger words that activate this FAQ. */
  triggerWords?: Maybe<Scalars['String']['output']>;
  /** The TTS generation ID if TTS has been generated. */
  ttsId?: Maybe<Scalars['ID']['output']>;
  /** The TTS speed for this FAQ. */
  ttsSpeed: Scalars['Float']['output'];
  /** The version ID this FAQ belongs to. */
  versionId: Scalars['ID']['output'];
};

/** Input for creating a new general FAQ. */
export type GeneralFaqCreateInput = {
  /** The answer content for this FAQ. */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** The live asset version ID to create the FAQ for. */
  liveAssetVersionId: Scalars['ID']['input'];
  /** The name/title for this FAQ. */
  name: Scalars['String']['input'];
  /** Trigger words that will activate this FAQ. */
  triggerWords?: InputMaybe<Scalars['String']['input']>;
};

/** Input for deleting a general FAQ. */
export type GeneralFaqDeleteInput = {
  /** The ID of the general FAQ to delete. */
  id: Scalars['ID']['input'];
};

/** Input for submitting general FAQ generation. Generates FAQ based on knowledge base. */
export type GeneralFaqGenerationSubmitInput = {
  /** Live asset version ID. */
  liveAssetVersionId: Scalars['String']['input'];
};

/** Input type for regenerating a general FAQ using knowledgebase. */
export type GeneralFaqRegenerateInput = {
  /** The general FAQ ID to regenerate. */
  generalFaqId: Scalars['ID']['input'];
};

/** Input for updating an existing general FAQ. */
export type GeneralFaqUpdateInput = {
  /** Updated answer content for this FAQ. */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the general FAQ to update. */
  id: Scalars['ID']['input'];
  /** Updated name/title for this FAQ. */
  name: Scalars['String']['input'];
  /** Updated trigger words that will activate this FAQ. */
  triggerWords?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateAssetUploadUrlRequest = {
  fileName: Scalars['String']['input'];
  instagramTarget?: InputMaybe<InstagramTargetInput>;
  lazadaTarget?: InputMaybe<LazadaTargetInput>;
  lineTarget?: InputMaybe<LineTargetInput>;
  messengerTarget?: InputMaybe<MessengerTargetInput>;
  mimeType: Scalars['String']['input'];
  shopeeTarget?: InputMaybe<ShopeeTargetInput>;
  whatsAppTarget?: InputMaybe<WhatsAppTargetInput>;
};

export type GenerateDraftReplyRequest = {
  chatId: Scalars['String']['input'];
  customerMessage?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateDraftReplyResult = {
  __typename?: 'GenerateDraftReplyResult';
  candidates: Array<DraftCandidateGql>;
  unsupportedLanguage: Scalars['Boolean']['output'];
};

export type GenerateDraftUnitMessageContentRequest = {
  messageItems: Array<LineMessageItemInput>;
  name: Scalars['String']['input'];
};

export type GenerateShopeeChatAuthorizationLinkRequest = {
  redirectUrl: Scalars['Url']['input'];
};

export type GenerateShopeeChatAuthorizationLinkResponse = {
  __typename?: 'GenerateShopeeChatAuthorizationLinkResponse';
  url: Scalars['Url']['output'];
};

export type GenerateShopifyOauthUrlRequest = {
  shopifyStoreDomain: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type GenerateTrackingUrlRequest = {
  shorten: Scalars['Boolean']['input'];
  urlLinkGroupId: Scalars['String']['input'];
  urls: Array<Scalars['Url']['input']>;
};

/** Generated live asset type. */
export type GeneratedLiveAsset = {
  __typename?: 'GeneratedLiveAsset';
  sections: Array<GeneratedScriptSection>;
};

/** Generated script type. */
export type GeneratedScript = {
  __typename?: 'GeneratedScript';
  sections: Array<GeneratedScriptSection>;
};

/** Generated script section type (without ID). */
export type GeneratedScriptSection = {
  __typename?: 'GeneratedScriptSection';
  content: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GetAnyChatSaleChannelProductKeywordFilterInput = {
  keyword: Scalars['String']['input'];
  saleChannels: Array<AnyChatSaleChannelType>;
};

export type GetAnyChatSaleChannelProductsRequest = {
  filter: GetAnyChatSaleChannelProductKeywordFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
  storeId: Scalars['Long']['input'];
};

export type GetAutomationFlowRequest = {
  id: Scalars['String']['input'];
};

export type GetAutomationFlowsRequest = {
  eventTypes: Array<AutomationFlowEventType>;
  limit: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  storeId: Scalars['Long']['input'];
};

export type GetChatCustomerDetailRequest = {
  chatId: Scalars['String']['input'];
};

export type GetChatRequest = {
  chatId: Scalars['String']['input'];
};

export type GetChatShopeeVouchers = {
  __typename?: 'GetChatShopeeVouchers';
  vouchers: Array<ChatShopeeVoucher>;
};

export type GetChatStateRequest = {
  chatId: Scalars['String']['input'];
};

export type GetChatsRequest = {
  chatIds?: InputMaybe<Array<Scalars['String']['input']>>;
  chatTypeFilter: ChatTypeFilter;
  daysSinceLastReceivedMessageWithIn?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  messagingChannel?: InputMaybe<ChatType>;
  offset: Scalars['Int']['input'];
  storeId: Scalars['Long']['input'];
  /** If account is COMMERCIAL, tagFilter.crmType is ignored. */
  tagFilter?: InputMaybe<TagFilterInput>;
};

export type GetCourierAccountListInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  crossBorderCourierProvider?: InputMaybe<CrossBorderCourierProvider>;
};

export type GetCustomerActivitiesRequestV4 = {
  channelCustomerFilter?: InputMaybe<ChannelCustomerInput>;
  customerGroupId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  newerThan?: InputMaybe<Scalars['String']['input']>;
  olderThan?: InputMaybe<Scalars['String']['input']>;
};

export type GetCustomerOrderV2Request = {
  customerId: Scalars['String']['input'];
  saleChannel?: InputMaybe<AnyChatSaleChannelType>;
};

export type GetCustomerTagRequest = {
  customerTagId: Scalars['String']['input'];
};

export type GetCustomerTagsRequest = {
  /** Filter by CRM type. If account is COMMERCIAL, this field is ignored. */
  crmType?: InputMaybe<CrmType>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Default to 1000 if not provided */
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<CustomerTagOrdering>;
  storeId: Scalars['Long']['input'];
};

export type GetCustomersV2Request = {
  /** When true, also match customers linked to an AnyTag influencer (OR'd with saleChannels); influencer-mode accounts only */
  anyTagLinked?: InputMaybe<Scalars['Boolean']['input']>;
  chatPlatforms: Array<ChatType>;
  countries: Array<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  lastOrderMaxDays?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<CustomersSortInput>;
  saleChannels: Array<AnyChatSaleChannelType>;
  storeId: Scalars['Long']['input'];
};

export type GetDraftReplyCandidateRequest = {
  chatId: Scalars['String']['input'];
  draftId: Scalars['String']['input'];
};

export type GetEstimateRecipientRequestInput = {
  deliveryTiming: DeliveryTimingItemInput;
  recipient: RecipientItemInput;
  storeId: Scalars['Long']['input'];
};

export type GetInfluencerCampaignByIdsRequest = {
  campaigns: Array<InfluencerCampaignInput>;
};

export type GetInfluencerCampaignsRequest = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  status: InfluencerCampaignStatus;
  storeId: Scalars['Long']['input'];
};

export type GetInfluencerCategoriesByIdsRequest = {
  categories: Array<Scalars['Long']['input']>;
};

export type GetInstagramChatEventsRequestV2 = {
  chatId: Scalars['String']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  newerCursor?: InputMaybe<Scalars['String']['input']>;
  olderCursor?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Long']['input']>;
};

export type GetLineChatEventsRequest = {
  chatId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  /** Default to 20 if not provided (max 100) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  storeId?: InputMaybe<Scalars['Long']['input']>;
};

export type GetLazadaChatMessagesRequestV2Input = {
  chatId: Scalars['String']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  newerCursor?: InputMaybe<Scalars['String']['input']>;
  olderCursor?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Long']['input']>;
};

export type GetLazadaVouchersRequest = {
  name?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  status?: InputMaybe<LazadaVoucherStatus>;
  storeId: Scalars['Long']['input'];
  voucherType: LazadaVoucherType;
};

export type GetLineBroadcastMessageStatSummaryRequestInput = {
  deliveryDateRange?: InputMaybe<DateRangeInput>;
  deliveryDateRangeCompare?: InputMaybe<DateRangeInput>;
  storeId: Scalars['Long']['input'];
};

export type GetLineBroadcastMessagesRequestInput = {
  deliveredDateFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  deliveredDateTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sortBy?: InputMaybe<LineBroadcastSortByInput>;
  status?: InputMaybe<BroadcastStatus>;
  storeId: Scalars['Long']['input'];
  tagName?: InputMaybe<Scalars['String']['input']>;
};

export type GetLineChatEventSubRequest = {
  chatId: Scalars['String']['input'];
  newerThanEventId?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Long']['input']>;
};

export type GetLineScheduledMessageInput = {
  chatId: Scalars['String']['input'];
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<LineScheduledMessageStatus>>;
};

export type GetMessageQuotaInfoRequestInput = {
  storeId: Scalars['Long']['input'];
};

export type GetMessengerBroadcastMessageStatSummaryRequestInput = {
  deliveryDateRange?: InputMaybe<DateRangeInput>;
  deliveryDateRangeCompare?: InputMaybe<DateRangeInput>;
  storeId: Scalars['Long']['input'];
};

export type GetMessengerBroadcastMessagesRequestInput = {
  customerTag?: InputMaybe<Scalars['String']['input']>;
  deliveredDateFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  deliveredDateTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  status?: InputMaybe<BroadcastStatus>;
  storeId: Scalars['Long']['input'];
};

export type GetMessengerChatEventsRequestV2 = {
  chatId: Scalars['String']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  newerCursor?: InputMaybe<Scalars['String']['input']>;
  olderCursor?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Long']['input']>;
};

export type GetMessengerEstimateRecipientRequestInput = {
  deliveryTiming: DeliveryTimingItemInput;
  recipient: MessengerRecipientItemInput;
  storeId: Scalars['Long']['input'];
};

export type GetShopeeChatMessagesRequestV2 = {
  chatId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  newerCursor?: InputMaybe<Scalars['String']['input']>;
  olderCursor?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Long']['input']>;
};

export type GetSingleLineBroadcastMessageRequestInput = {
  lineBroadcastMessageId: Scalars['String']['input'];
};

export type GetSingleMessengerBroadcastMessageRequestInput = {
  messengerBroadcastId: Scalars['String']['input'];
};

export type GetSingleWhatsAppBroadcastMessageRequest = {
  whatsappBroadcastId: Scalars['String']['input'];
};

export type GetStoreGreetingMessageRequest = {
  storeId: Scalars['Long']['input'];
};

export type GetStoreMessengerOptInMessageRequestInput = {
  storeId: Scalars['Long']['input'];
};

export type GetWhatsAppBroadcastMessageStatSummaryRequest = {
  deliveryDateRange?: InputMaybe<DateRangeInput>;
  deliveryDateRangeCompare?: InputMaybe<DateRangeInput>;
  storeId: Scalars['Long']['input'];
};

export type GetWhatsAppBroadcastMessagesRequest = {
  customerTag?: InputMaybe<Scalars['String']['input']>;
  deliveredDateFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  deliveredDateTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  status?: InputMaybe<Array<WhatsAppBroadcastStatus>>;
  storeId: Scalars['Long']['input'];
};

export type GetWhatsAppChatMessagesRequestV2Input = {
  chatId: Scalars['String']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  newerCursor?: InputMaybe<Scalars['String']['input']>;
  olderCursor?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Long']['input']>;
};

export type GetWhatsAppEstimateRecipientRequest = {
  recipient: WhatsAppRecipientInput;
  storeId: Scalars['Long']['input'];
};

export type GoogleAdsAccountPayload = {
  __typename?: 'GoogleAdsAccountPayload';
  id: Scalars['String']['output'];
  manager: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type GoogleAdsAccountPayloadList = {
  __typename?: 'GoogleAdsAccountPayloadList';
  items: Array<GoogleAdsAccountPayload>;
  meta: ReportListMeta;
};

export type GoogleAdsCustomerPayload = {
  __typename?: 'GoogleAdsCustomerPayload';
  autoTaggingEnabled?: Maybe<Scalars['Boolean']['output']>;
  callReportingSetting?: Maybe<Scalars['Map']['output']>;
  conversionTrackingSetting?: Maybe<Scalars['Map']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  descriptiveName?: Maybe<Scalars['String']['output']>;
  finalUrlSuffix?: Maybe<Scalars['String']['output']>;
  hasPartnersBadge?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  manager?: Maybe<Scalars['Boolean']['output']>;
  optimizationScore?: Maybe<Scalars['Int']['output']>;
  optimizationScoreWeight?: Maybe<Scalars['Int']['output']>;
  payPerConversionEligibilityFailureReasons?: Maybe<Array<Scalars['String']['output']>>;
  remarketingSetting?: Maybe<Scalars['Map']['output']>;
  resourceName?: Maybe<Scalars['String']['output']>;
  testAccount?: Maybe<Scalars['Boolean']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  trackingUrlTemplate?: Maybe<Scalars['String']['output']>;
};

export type GoogleAdsCustomerPayloadList = {
  __typename?: 'GoogleAdsCustomerPayloadList';
  items: Array<GoogleAdsCustomerPayload>;
  meta: ReportListMeta;
};

export type GoogleAnalytics4AccountSummaries = {
  __typename?: 'GoogleAnalytics4AccountSummaries';
  accountSummaries: Array<GoogleAnalytics4AccountSummary>;
};

export type GoogleAnalytics4AccountSummary = {
  __typename?: 'GoogleAnalytics4AccountSummary';
  account: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  propertySummaries?: Maybe<Array<GoogleAnalytics4PropertySummary>>;
};

export type GoogleAnalytics4PropertySummary = {
  __typename?: 'GoogleAnalytics4PropertySummary';
  displayName: Scalars['String']['output'];
  property: Scalars['String']['output'];
  propertyType?: Maybe<Scalars['String']['output']>;
};

export type GoogleExchangeCodePayload = {
  __typename?: 'GoogleExchangeCodePayload';
  datasourceTokenId: Scalars['Long']['output'];
  email?: Maybe<Scalars['String']['output']>;
};

export const GoogleLoginUrlType = {
  GoogleAds: 'GoogleAds',
  GoogleAnalytics4: 'GoogleAnalytics4'
} as const;

export type GoogleLoginUrlType = typeof GoogleLoginUrlType[keyof typeof GoogleLoginUrlType];
export type GraphQlMoney = {
  __typename?: 'GraphQLMoney';
  amount: Scalars['BigDecimal']['output'];
  currency: CurrencyCode;
};

export type GraphQlMoneyInput = {
  amount: Scalars['BigDecimal']['input'];
  currency: CurrencyCode;
};

/** Green-screen segmentation settings; omitted FIELDS use server-side defaults. Omitting the whole object instead disables green-screen segmentation for that video. */
export type GreenScreenParamsInput = {
  /** Default 3. */
  blurKernelSize?: InputMaybe<Scalars['Int']['input']>;
  /** Default 100. */
  colorBalance?: InputMaybe<Scalars['Int']['input']>;
  /** Default 160. */
  refineThresholdHigh?: InputMaybe<Scalars['Int']['input']>;
  /** Default 40. */
  refineThresholdLow?: InputMaybe<Scalars['Int']['input']>;
  /** Background color composited behind the subject in the preview; default {255,255,255}. */
  sampleBackgroundColor?: InputMaybe<RgbInput>;
  /** Key color to sample; default {r:0,g:255,b:0}. */
  sampleColor?: InputMaybe<RgbInput>;
  /** Default 0.5. */
  spillByAlpha?: InputMaybe<Scalars['Float']['input']>;
};

export type GreetingMessage = {
  __typename?: 'GreetingMessage';
  content: Array<LineMessage>;
  createdAt: Scalars['Instant']['output'];
  enabled: Scalars['Boolean']['output'];
  storeId: Scalars['Long']['output'];
  updatedAt: Scalars['Instant']['output'];
};

export type HasLogisticsChannel = {
  __typename?: 'HasLogisticsChannel';
  boolean: Scalars['Boolean']['output'];
};

export const HomeDailyReportMetric = {
  AVG_ORDER_VALUES: 'AVG_ORDER_VALUES',
  MARGINAL_PROFIT: 'MARGINAL_PROFIT',
  MARGINAL_PROFIT_RATE: 'MARGINAL_PROFIT_RATE',
  ORDERS: 'ORDERS',
  REVENUE: 'REVENUE'
} as const;

export type HomeDailyReportMetric = typeof HomeDailyReportMetric[keyof typeof HomeDailyReportMetric];
export type HomeDailyReportView = {
  __typename?: 'HomeDailyReportView';
  currency: ReportSupportedCurrency;
  data: Array<ReportListKvData>;
  totalItems: Scalars['Int']['output'];
};

export type HomeReportFilterInput = {
  chartTab?: InputMaybe<ReportChartTab>;
  endDate: Scalars['ZonedDatetime']['input'];
  marketplaces: Array<SaleChannelType>;
  masterDataAccountId?: InputMaybe<Scalars['Long']['input']>;
  masterDataAccountIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  masterDataStoreIds: Array<Scalars['Long']['input']>;
  orderStatus: ReportOrderStatus;
  startDate: Scalars['ZonedDatetime']['input'];
};

export type HomeReportSaleChannelRevenuePayload = {
  __typename?: 'HomeReportSaleChannelRevenuePayload';
  grossSales: Scalars['BigDecimal']['output'];
  masterDataStoreId?: Maybe<Scalars['Long']['output']>;
  saleChannelType?: Maybe<SaleChannelType>;
  storeName?: Maybe<Scalars['String']['output']>;
};

export type HomeSaleChannelRevenueReportView = {
  __typename?: 'HomeSaleChannelRevenueReportView';
  currency: ReportSupportedCurrency;
  data: Array<HomeReportSaleChannelRevenuePayload>;
};

export type HomeSummaryReportView = {
  __typename?: 'HomeSummaryReportView';
  avgOrderValues: ReportCompareData;
  currency: ReportSupportedCurrency;
  marginalProfit: ReportCompareData;
  marginalProfitRate: ReportCompareData;
  orders: ReportCompareData;
  revenue: ReportCompareData;
};

export type HomeTop5ProductView = {
  __typename?: 'HomeTop5ProductView';
  currency: ReportSupportedCurrency;
  grossSales: Scalars['BigDecimal']['output'];
  image?: Maybe<Scalars['String']['output']>;
  orderCount: Scalars['Int']['output'];
  productId?: Maybe<Scalars['Long']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  revenue: Scalars['BigDecimal']['output'];
};

export type HomeTop5ProductsReportView = {
  __typename?: 'HomeTop5ProductsReportView';
  data: Array<HomeTop5ProductView>;
};

export const HorizontalAlignment = {
  center: 'center',
  end: 'end',
  start: 'start'
} as const;

export type HorizontalAlignment = typeof HorizontalAlignment[keyof typeof HorizontalAlignment];
/** Host. */
export type Host = {
  __typename?: 'Host';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

/** Create input for a host. */
export type HostCreateInput = {
  name: Scalars['String']['input'];
};

/** Filter input for hosts. */
export type HostFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export const HostIdentityType = {
  BEAUTY: 'BEAUTY',
  CUSTOM: 'CUSTOM',
  HOME_LIVING: 'HOME_LIVING',
  SKINCARE: 'SKINCARE',
  TECH: 'TECH',
  WELLNESS: 'WELLNESS'
} as const;

export type HostIdentityType = typeof HostIdentityType[keyof typeof HostIdentityType];
/** Host list type. */
export type HostList = PaginatedList & {
  __typename?: 'HostList';
  items: Array<Host>;
  totalCount: Scalars['Int']['output'];
};

/** Output type for a host. */
export type HostOutput = {
  __typename?: 'HostOutput';
  host?: Maybe<Host>;
  /** Host ID. */
  id: Scalars['ID']['output'];
};

/** Sort field for hosts. */
export const HostSortField = {
  CREATED_AT: 'CREATED_AT',
  ID: 'ID',
  NAME: 'NAME',
  UPDATED_AT: 'UPDATED_AT'
} as const;

export type HostSortField = typeof HostSortField[keyof typeof HostSortField];
/** Sort input for hosts. */
export type HostSortInput = {
  /** Default is descending. */
  direction?: InputMaybe<SortDirection>;
  /** Default is ID. */
  field?: InputMaybe<HostSortField>;
};

export const HostType = {
  AI: 'AI',
  HUMAN: 'HUMAN'
} as const;

export type HostType = typeof HostType[keyof typeof HostType];
/** Update input for a host. */
export type HostUpdateInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type Id = {
  __typename?: 'Id';
  id: Scalars['ID']['output'];
};

export type IdName = {
  __typename?: 'IdName';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type IdNameWms = {
  __typename?: 'IdNameWms';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  wms: Wms;
};

export type ImageItem = {
  __typename?: 'ImageItem';
  imageUrl: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  urlAction: LineUrlAction;
};

export type ImageItemInput = {
  imageUrl: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  urlAction: LineMessageUrlInput;
};

export type ImageMessage = {
  __typename?: 'ImageMessage';
  images: Array<ImageItem>;
};

export type ImageMessageContent = {
  __typename?: 'ImageMessageContent';
  originalUrl: Scalars['Url']['output'];
  previewUrl: Scalars['Url']['output'];
};

export type ImageMessageInput = {
  images: Array<ImageItemInput>;
};

export type Immediately = {
  __typename?: 'Immediately';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

/** A selected live-asset FAQ that was not imported. */
export type ImportLiveAssetFaqSkip = {
  __typename?: 'ImportLiveAssetFaqSkip';
  /** The live-asset FAQ id. */
  faqId: Scalars['ID']['output'];
  /** Why it was not imported. */
  reason: ImportLiveAssetFaqSkipReason;
};

/** Why a selected live-asset FAQ was not imported into the live room. */
export const ImportLiveAssetFaqSkipReason = {
  /** A trigger word already exists in the target section, or earlier in the same import. */
  DUPLICATE: 'DUPLICATE',
  /** The FAQ has no non-blank trigger word. */
  EMPTY_TRIGGER_WORDS: 'EMPTY_TRIGGER_WORDS',
  /** The room's FAQ reply mode needs a reply the FAQ cannot supply. */
  MISSING_REPLY: 'MISSING_REPLY'
} as const;

export type ImportLiveAssetFaqSkipReason = typeof ImportLiveAssetFaqSkipReason[keyof typeof ImportLiveAssetFaqSkipReason];
/** Input for importing selected general FAQs from a live asset version into a live room. */
export type ImportLiveAssetGeneralFaqsInput = {
  /** IDs of the general FAQs to import. */
  faqIds: Array<Scalars['ID']['input']>;
  /** The live room to import FAQs into. */
  liveRoomId: Scalars['ID']['input'];
  /** The live asset version to import FAQs from. */
  versionId: Scalars['ID']['input'];
};

/** Result of importing general FAQs from a live asset into a live room. */
export type ImportLiveAssetGeneralFaqsResult = {
  __typename?: 'ImportLiveAssetGeneralFaqsResult';
  /** The imported general FAQs. */
  generalFaqs: Array<LivestreamRoomGeneralFaqOutput>;
  /** Selected FAQs that were not imported, and why. */
  skipped: Array<ImportLiveAssetFaqSkip>;
};

/** Input for importing selected product FAQs from a live asset version into a live room. */
export type ImportLiveAssetProductFaqsInput = {
  /** IDs of the product FAQs to import. */
  faqIds: Array<Scalars['ID']['input']>;
  /** The live asset version to import FAQs from. */
  liveAssetVersionId: Scalars['ID']['input'];
  /** The live room to import FAQs into. */
  liveRoomId: Scalars['ID']['input'];
};

/** Result of importing product FAQs from a live asset into a live room. */
export type ImportLiveAssetProductFaqsResult = {
  __typename?: 'ImportLiveAssetProductFaqsResult';
  /** The successfully matched and imported product FAQs. */
  productFaqs: Array<LivestreamRoomProductFaqOutput>;
  /** Selected FAQs that were not imported, and why. */
  skipped: Array<ImportLiveAssetFaqSkip>;
  /** FAQs whose product had no match in the room — stored in the unmatched section. */
  unmatchedFaqs: Array<LivestreamRoomUnmatchedFaqOutput>;
};

/** Input for importing live asset script content. */
export type ImportLiveAssetScriptContentInput = {
  liveRoomProductId: Scalars['ID']['input'];
  scriptContentIds: Array<Scalars['ID']['input']>;
};

export type Inbound = {
  __typename?: 'Inbound';
  brand?: Maybe<Brand>;
  created: Scalars['Time']['output'];
  deliveryDestination?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  inboundDate: Scalars['Time']['output'];
  inboundId: Scalars['String']['output'];
  inspectedQuantity?: Maybe<Scalars['Int']['output']>;
  mdAccount?: Maybe<MdAccount>;
  mdStore?: Maybe<MdStore>;
  productCount: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  status: InboundStatus;
  supplier: Supplier;
};

/** Inbound delivery information. */
export type InboundDeliveryInformation = {
  __typename?: 'InboundDeliveryInformation';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  deliveryDestination: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  phoneNumberCountry: Scalars['String']['output'];
  province?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

/** Inbound detail view. */
export type InboundDetail = {
  __typename?: 'InboundDetail';
  createdAt: Scalars['OffsetDateTime']['output'];
  /** Warehouse delivery destination, as set on the warehouse page. */
  deliveryInformation: InboundDeliveryInformation;
  /** If the inbound shipment has arrived, the actual arrival date at the warehouse. Otherwise, the expected arrival date. */
  inboundAt: Scalars['OffsetDateTime']['output'];
  /** Inbound ID generated by the system in the format: '#{STORE_CODE}-{RUNNING_NUMBER}' */
  inboundId: Scalars['String']['output'];
  inboundStatus: AnyXInboundStatus;
  /** Total quantity of all products inspected in the inbound shipment. */
  inspectedQuantityCount: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  products: Array<InboundProduct>;
  /** Total quantity of all products scheduled to arrive in the inbound shipment. */
  scheduledQuantityCount: Scalars['Int']['output'];
  store: MdStore;
  supplier: AnyXSupplier;
};

export type InboundDetailed = {
  __typename?: 'InboundDetailed';
  brand?: Maybe<Brand>;
  comment: Scalars['String']['output'];
  created: Scalars['Time']['output'];
  deliveryAddress?: Maybe<Address>;
  deliveryDestination?: Maybe<Scalars['String']['output']>;
  deliveryPhoneNumber?: Maybe<PhoneNumber>;
  id: Scalars['ID']['output'];
  inboundDate: Scalars['Time']['output'];
  inboundId: Scalars['String']['output'];
  inspectedQuantity?: Maybe<Scalars['Int']['output']>;
  mdAccount?: Maybe<MdAccount>;
  mdStore?: Maybe<MdStore>;
  mdUser?: Maybe<MdUser>;
  products: Array<InboundProductDetailed>;
  quantity: Scalars['Int']['output'];
  status: InboundStatus;
  supplier: Supplier;
  user: User;
  warehouseArrivalDate?: Maybe<Scalars['Time']['output']>;
};

export type InboundFilters = {
  accountId?: InputMaybe<Scalars['Long']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InboundStatus>;
  storeId?: InputMaybe<Scalars['Long']['input']>;
  storeIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type InboundIds = {
  __typename?: 'InboundIds';
  id: Scalars['ID']['output'];
  inboundId: Scalars['String']['output'];
};

/** Inbound list view. {start}-{end} / {total}. page {page} of {totalPage} */
export type InboundListView = {
  __typename?: 'InboundListView';
  end: Scalars['Int']['output'];
  items: Array<InboundRecord>;
  page: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPage: Scalars['Int']['output'];
};

export type InboundListViewInput = {
  accountId?: InputMaybe<Scalars['Long']['input']>;
  /** Search by keyword in the Inbound ID, Delivery Destination, Inbound Source, ProductCode, Product Name */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Start from 1. */
  pageNumber: Scalars['Int']['input'];
  stockType?: InputMaybe<AnyXInboundStatus>;
  storeId?: InputMaybe<Scalars['Long']['input']>;
};

export type InboundOverview = {
  __typename?: 'InboundOverview';
  all: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  reviewing: Scalars['Int']['output'];
  warehousing: Scalars['Int']['output'];
};

export type InboundOverviewInput = {
  accountId?: InputMaybe<Scalars['Long']['input']>;
  /** Search by keyword in the Inbound ID, Delivery Destination, Inbound Source, ProductCode, Product Name */
  keyword?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Long']['input']>;
};

/** Inbound product information. */
export type InboundProduct = {
  __typename?: 'InboundProduct';
  /** the quantity of the product inspected in the inbound shipment. */
  inspectedQuantity: Scalars['Int']['output'];
  productCode: Scalars['String']['output'];
  productImage?: Maybe<Scalars['URL']['output']>;
  productName: Scalars['String']['output'];
  /** the quantity of the product scheduled to arrive in the inbound shipment. */
  scheduledQuantity: Scalars['Int']['output'];
};

export type InboundProductDetailed = {
  __typename?: 'InboundProductDetailed';
  code: Scalars['String']['output'];
  gtin: Scalars['String']['output'];
  image: Scalars['String']['output'];
  inspectedQuantity?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type InboundRecord = {
  __typename?: 'InboundRecord';
  createdAt: Scalars['OffsetDateTime']['output'];
  /** Warehouse delivery destination, as set on the warehouse page. */
  deliveryDestination: Scalars['String']['output'];
  image?: Maybe<Scalars['URL']['output']>;
  /** If the inbound shipment has arrived, the actual arrival date at the warehouse. Otherwise, the expected arrival date. */
  inboundAt: Scalars['OffsetDateTime']['output'];
  /** Inbound ID generated by the system in the format: '#{STORE_CODE}-{RUNNING_NUMBER}' */
  inboundId: Scalars['String']['output'];
  inboundStatus: AnyXInboundStatus;
  /** Total quantity of all products inspected in the inbound shipment. */
  inspectedQuantityCount: Scalars['Int']['output'];
  /** Number of products in the inbound shipment. */
  productCount: Scalars['Int']['output'];
  /** Total quantity of all products scheduled to arrive in the inbound shipment. */
  scheduledQuantityCount: Scalars['Int']['output'];
  store: MdStore;
  supplier: AnyXSupplier;
};

export type InboundSku = {
  gtin: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export const InboundStatus = {
  COMPLETED: 'COMPLETED',
  REVIEWING: 'REVIEWING',
  WAREHOUSING: 'WAREHOUSING'
} as const;

export type InboundStatus = typeof InboundStatus[keyof typeof InboundStatus];
export type InboundsPaginated = Paginated & {
  __typename?: 'InboundsPaginated';
  page: Scalars['Int']['output'];
  records: Array<Inbound>;
  total: Scalars['Int']['output'];
};

export type InfluencerCampaign = {
  __typename?: 'InfluencerCampaign';
  campaignType: InfluencerCampaignType;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type InfluencerCampaignInput = {
  campaignType: InfluencerCampaignType;
  id: Scalars['Long']['input'];
};

export const InfluencerCampaignStatus = {
  Finished: 'Finished',
  Running: 'Running'
} as const;

export type InfluencerCampaignStatus = typeof InfluencerCampaignStatus[keyof typeof InfluencerCampaignStatus];
export const InfluencerCampaignType = {
  CAMPAIGN_TYPE_AUTO_MANAGED: 'CAMPAIGN_TYPE_AUTO_MANAGED',
  CAMPAIGN_TYPE_ENGAGEMENT: 'CAMPAIGN_TYPE_ENGAGEMENT',
  CAMPAIGN_TYPE_MARKETPLACE: 'CAMPAIGN_TYPE_MARKETPLACE',
  CAMPAIGN_TYPE_TIKTOK_SPECIAL: 'CAMPAIGN_TYPE_TIKTOK_SPECIAL'
} as const;

export type InfluencerCampaignType = typeof InfluencerCampaignType[keyof typeof InfluencerCampaignType];
export type InfluencerCategory = {
  __typename?: 'InfluencerCategory';
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type InfluencerCondition = {
  __typename?: 'InfluencerCondition';
  influencerCondition: BroadcastInfluencerConditionWrapper;
};

export type InfluencerInfo = {
  __typename?: 'InfluencerInfo';
  engagementRate?: Maybe<Scalars['BigDecimal']['output']>;
  followersCount?: Maybe<Scalars['Long']['output']>;
  profileUrl: Scalars['String']['output'];
  registeredAt: Scalars['OffsetDateTime']['output'];
};

export type InfluencerJoinedCampaignActivityV4 = CustomerActivityV4 & {
  __typename?: 'InfluencerJoinedCampaignActivityV4';
  campaignName: Scalars['String']['output'];
  campaignUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  timestamp: Scalars['UnixTimestamp']['output'];
};

export type InfluencerPublishedPostActivityV4 = CustomerActivityV4 & {
  __typename?: 'InfluencerPublishedPostActivityV4';
  campaignName: Scalars['String']['output'];
  campaignUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  timestamp: Scalars['UnixTimestamp']['output'];
};

export type InfluencerSubmittedPostActivityV4 = CustomerActivityV4 & {
  __typename?: 'InfluencerSubmittedPostActivityV4';
  campaignName: Scalars['String']['output'];
  campaignUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  timestamp: Scalars['UnixTimestamp']['output'];
};

export type InputCreateLogisticChannelRequestForm = {
  accountId: Scalars['Long']['input'];
  marketplaceName: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  saleChannelId: Scalars['Long']['input'];
  saleChannelName: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type InputDateRange = {
  from?: InputMaybe<Scalars['ZonedDatetime']['input']>;
  to?: InputMaybe<Scalars['ZonedDatetime']['input']>;
};

export type InstagramBotAutoReplyMessage = InstagramMessage & {
  __typename?: 'InstagramBotAutoReplyMessage';
  autoReplyInfo: AutoReplyInfo;
  content: InstagramMessageContent;
  messageId: Scalars['String']['output'];
  reactions: Array<InstagramReaction>;
};

export type InstagramBotAutoReplyMessageDelete = InstagramMessage & {
  __typename?: 'InstagramBotAutoReplyMessageDelete';
  messageId: Scalars['String']['output'];
  reactions: Array<InstagramReaction>;
};

export type InstagramBotMessage = InstagramMessage & {
  __typename?: 'InstagramBotMessage';
  author: BasicUser;
  content: InstagramMessageContent;
  messageId: Scalars['String']['output'];
  messageState: MessageState;
  reactions: Array<InstagramReaction>;
};

export type InstagramBotMessageDeleted = InstagramMessage & {
  __typename?: 'InstagramBotMessageDeleted';
  author: BasicUser;
  messageId: Scalars['String']['output'];
  reactions: Array<InstagramReaction>;
};

export type InstagramChatEvent = CommonChatEvent | InstagramMessageEvent;

export type InstagramChatEvents = {
  __typename?: 'InstagramChatEvents';
  chatEvents: Array<InstagramChatEvent>;
  chatId: Scalars['String']['output'];
  lastCheckedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  newerCursor?: Maybe<Scalars['String']['output']>;
  olderCursor?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

export type InstagramChatPlatformDetail = {
  __typename?: 'InstagramChatPlatformDetail';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type InstagramMessage = {
  messageId: Scalars['String']['output'];
  reactions: Array<InstagramReaction>;
};

export type InstagramMessageContent = AutoReplyContent | ImageMessageContent | StoryMentionContent | TextLiveCommentContent | TextMessageContent | UnsupportedContent | VideoMessageContent;

export type InstagramMessageEvent = {
  __typename?: 'InstagramMessageEvent';
  id: Scalars['String']['output'];
  message: InstagramMessage;
  replyTo?: Maybe<ReplyTo>;
  timestamp: Scalars['UnixTimestamp']['output'];
};

export type InstagramReaction = BotReaction | UserReaction;

export type InstagramSendImageMessageRequest = {
  chatId: Scalars['String']['input'];
  originalUrl: Scalars['Url']['input'];
  previewUrl: Scalars['Url']['input'];
  replyTo?: InputMaybe<ReplyToInputInput>;
};

export type InstagramSendTextMessageRequest = {
  chatId: Scalars['String']['input'];
  replyTo?: InputMaybe<ReplyToInputInput>;
  text: Scalars['String']['input'];
};

export type InstagramSign = {
  __typename?: 'InstagramSign';
  name: Scalars['String']['output'];
};

export type InstagramStoreChat = StoreChat & {
  __typename?: 'InstagramStoreChat';
  createdAt: Scalars['OffsetDateTime']['output'];
  id: Scalars['String']['output'];
  isPrimaryReceiver: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
  storeProfilePicture?: Maybe<Scalars['String']['output']>;
  tokenStatusV2: MetaTokenStatus;
  type: ChatType;
  username: Scalars['String']['output'];
};

export type InstagramTargetInput = {
  type: InstagramTargetType;
};

export const InstagramTargetType = {
  AUTOMATION_FLOW: 'AUTOMATION_FLOW',
  CHAT_MESSAGE: 'CHAT_MESSAGE'
} as const;

export type InstagramTargetType = typeof InstagramTargetType[keyof typeof InstagramTargetType];
export type InstagramUserMessage = InstagramMessage & {
  __typename?: 'InstagramUserMessage';
  content: InstagramMessageContent;
  messageId: Scalars['String']['output'];
  reactions: Array<InstagramReaction>;
};

export type InstagramUserMessageDeleted = InstagramMessage & {
  __typename?: 'InstagramUserMessageDeleted';
  messageId: Scalars['String']['output'];
  reactions: Array<InstagramReaction>;
};

/** Int range input type. */
export type IntRangeInput = {
  from?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export type InventoryChannel = {
  __typename?: 'InventoryChannel';
  id: Scalars['Long']['output'];
  isActive: Scalars['Boolean']['output'];
  isManual: Scalars['Boolean']['output'];
  type: InventoryChannelType;
};

export const InventoryChannelType = {
  Anchanto: 'Anchanto',
  Jubelio: 'Jubelio'
} as const;

export type InventoryChannelType = typeof InventoryChannelType[keyof typeof InventoryChannelType];
export type InventoryExportCsvInput = {
  filter?: InputMaybe<InventoryListFilterInput>;
  productVariantIds: Array<Scalars['Long']['input']>;
};

export type InventoryExportCsvResult = {
  __typename?: 'InventoryExportCsvResult';
  fileUrl: Scalars['String']['output'];
};

export const InventoryFileType = {
  ANCHANTO_XLS: 'ANCHANTO_XLS',
  JUBELIO_CSV: 'JUBELIO_CSV'
} as const;

export type InventoryFileType = typeof InventoryFileType[keyof typeof InventoryFileType];
export type InventoryFileUploadHistoryInput = {
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  wms: WarehouseManagementSystem;
};

export type InventoryFileUploadHistoryPayload = {
  __typename?: 'InventoryFileUploadHistoryPayload';
  items: Array<FileUploadHistoryItemPayload>;
  meta: ReportListMeta;
};

export type InventoryListFilterInput = {
  accountId?: InputMaybe<Scalars['Long']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<ProductType>;
  sortBy?: InputMaybe<InventoryListSortInput>;
  stockType?: InputMaybe<StockType>;
  storeId?: InputMaybe<Scalars['Long']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InventoryListQueryInput = {
  filter: InventoryListFilterInput;
  /** Start from 1. */
  pageNumber: Scalars['Int']['input'];
};

export const InventoryListSortField = {
  PRODUCT_NAME: 'PRODUCT_NAME'
} as const;

export type InventoryListSortField = typeof InventoryListSortField[keyof typeof InventoryListSortField];
export type InventoryListSortInput = {
  descending: Scalars['Boolean']['input'];
  field: InventoryListSortField;
};

/** Inventory list view. {start}-{end} / {total}. page {page} of {totalPage} */
export type InventoryListView = {
  __typename?: 'InventoryListView';
  end: Scalars['Int']['output'];
  items: Array<InventoryRecord>;
  page: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPage: Scalars['Int']['output'];
};

export type InventoryOverviewOutput = {
  __typename?: 'InventoryOverviewOutput';
  allCount: Scalars['Int']['output'];
  allocatingCount: Scalars['Int']['output'];
  arrivingCount: Scalars['Int']['output'];
  damagedCount: Scalars['Int']['output'];
  freeCount: Scalars['Int']['output'];
  outOfStockCount: Scalars['Int']['output'];
  preparingCount: Scalars['Int']['output'];
  warehousingCount: Scalars['Int']['output'];
};

export type InventoryOverviewQueryInput = {
  accountId?: InputMaybe<Scalars['Long']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<ProductType>;
  storeId?: InputMaybe<Scalars['Long']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InventoryRecord = {
  __typename?: 'InventoryRecord';
  allocating?: Maybe<Scalars['Int']['output']>;
  arriving?: Maybe<Scalars['Int']['output']>;
  content: Scalars['String']['output'];
  damaged?: Maybe<Scalars['Int']['output']>;
  free?: Maybe<Scalars['Int']['output']>;
  media?: Maybe<Scalars['URL']['output']>;
  preparing?: Maybe<Scalars['Int']['output']>;
  productCode: Scalars['String']['output'];
  productId: Scalars['Long']['output'];
  productName: Scalars['String']['output'];
  productType: ProductType;
  productVariantId: Scalars['Long']['output'];
  store: MdStore;
  warehousing?: Maybe<Scalars['Int']['output']>;
};

export const InventoryStatus = {
  GOOD_STOCK: 'GOOD_STOCK',
  NEEDS_FLUSH_OUT: 'NEEDS_FLUSH_OUT',
  NEEDS_STOCK_UP: 'NEEDS_STOCK_UP'
} as const;

export type InventoryStatus = typeof InventoryStatus[keyof typeof InventoryStatus];
export type InventoryUploadInput = {
  fileName: Scalars['String']['input'];
  fileType: InventoryFileType;
  fileUri?: InputMaybe<Scalars['String']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  masterDataStoreId: Scalars['Long']['input'];
  saleChannelType?: InputMaybe<SaleChannelType>;
};

export type InvoiceSlip = {
  __typename?: 'InvoiceSlip';
  /** Every stored document for the order, carrier invoice first. */
  documents: Array<InvoiceSlipDocument>;
  /** Carrier commercial invoice; for Japan Post, the Detailed Description Document. */
  url: Scalars['String']['output'];
};

export type InvoiceSlipDocument = {
  __typename?: 'InvoiceSlipDocument';
  kind: InvoiceSlipDocumentKind;
  url: Scalars['String']['output'];
};

export const InvoiceSlipDocumentKind = {
  COMMERCIAL_INVOICE: 'COMMERCIAL_INVOICE',
  DETAILED_DESCRIPTION: 'DETAILED_DESCRIPTION'
} as const;

export type InvoiceSlipDocumentKind = typeof InvoiceSlipDocumentKind[keyof typeof InvoiceSlipDocumentKind];
export type ItemSource = {
  __typename?: 'ItemSource';
  externalLink: Scalars['Url']['output'];
  imageUrl?: Maybe<Scalars['Url']['output']>;
  itemUrlPath?: Maybe<Scalars['String']['output']>;
  shopeeItemId: Scalars['Long']['output'];
  title: Scalars['String']['output'];
};

export type JapanPostAccountDetails = {
  __typename?: 'JapanPostAccountDetails';
  japanPostCardNumber?: Maybe<Scalars['String']['output']>;
  japanPostSupportServiceCodes?: Maybe<Array<JapanPostServiceCode>>;
};

export type JapanPostCreateCourierInput = {
  accountId: Scalars['String']['input'];
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  supportServiceCodes?: InputMaybe<Array<JapanPostServiceCode>>;
};

export const JapanPostServiceCode = {
  EMS: 'EMS',
  INTERNATIONAL_PARCEL_AIR_MAIL: 'INTERNATIONAL_PARCEL_AIR_MAIL',
  INTERNATIONAL_PARCEL_SAL_MAIL: 'INTERNATIONAL_PARCEL_SAL_MAIL',
  INTERNATIONAL_PARCEL_SURFACE_MAIL: 'INTERNATIONAL_PARCEL_SURFACE_MAIL',
  REGISTERED_AIR_MAIL: 'REGISTERED_AIR_MAIL',
  REGISTERED_SAL_MAIL: 'REGISTERED_SAL_MAIL',
  REGISTERED_SURFACE_MAIL: 'REGISTERED_SURFACE_MAIL',
  SMALL_PACKAGE_AIR_MAIL: 'SMALL_PACKAGE_AIR_MAIL',
  SMALL_PACKAGE_SAL_MAIL: 'SMALL_PACKAGE_SAL_MAIL',
  SMALL_PACKAGE_SURFACE_MAIL: 'SMALL_PACKAGE_SURFACE_MAIL'
} as const;

export type JapanPostServiceCode = typeof JapanPostServiceCode[keyof typeof JapanPostServiceCode];
export type JapanPostServiceCodeWrapper = {
  __typename?: 'JapanPostServiceCodeWrapper';
  japanPostServiceCode?: Maybe<JapanPostServiceCode>;
};

export type JapanPostUpdateCourierInput = {
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  courierId: Scalars['String']['input'];
  supportServiceCodes?: InputMaybe<Array<JapanPostServiceCode>>;
};

export const JobState = {
  FAILURE: 'FAILURE',
  PENDING: 'PENDING',
  RECEIVED: 'RECEIVED',
  RETRY: 'RETRY',
  STARTED: 'STARTED',
  SUCCESS: 'SUCCESS'
} as const;

export type JobState = typeof JobState[keyof typeof JobState];
export type KeywordChartInput = {
  campaignId: Scalars['Long']['input'];
  datasourceId: Scalars['Long']['input'];
  dimension: AdReportDimension;
  endDate: Scalars['LocalDate']['input'];
  groupId: Scalars['Long']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  pricesView: AdReportPricesView;
  startDate: Scalars['LocalDate']['input'];
};

export type KeywordDetailedReportDimensionValuesPayload = {
  __typename?: 'KeywordDetailedReportDimensionValuesPayload';
  clicks: Scalars['BigDecimal']['output'];
  conversions: Scalars['BigDecimal']['output'];
  cost: Scalars['BigDecimal']['output'];
  cpa: Scalars['BigDecimal']['output'];
  cpc: Scalars['BigDecimal']['output'];
  cpm: Scalars['BigDecimal']['output'];
  ctr: Scalars['BigDecimal']['output'];
  cvr: Scalars['BigDecimal']['output'];
  day?: Maybe<Scalars['LocalDate']['output']>;
  impressions: Scalars['BigDecimal']['output'];
  month?: Maybe<Scalars['YearMonth']['output']>;
  roas: Scalars['BigDecimal']['output'];
  sales: Scalars['BigDecimal']['output'];
  week?: Maybe<Scalars['LocalDate']['output']>;
};

export type KeywordDetailedReportInput = {
  campaignId: Scalars['Long']['input'];
  datasourceId: Scalars['Long']['input'];
  dimension: AdReportDimension;
  endDate: Scalars['LocalDate']['input'];
  groupId: Scalars['Long']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pricesView: AdReportPricesView;
  startDate: Scalars['LocalDate']['input'];
};

export type KeywordDetailedReportPayload = {
  __typename?: 'KeywordDetailedReportPayload';
  adGroupId: Scalars['Long']['output'];
  clicks: Scalars['BigDecimal']['output'];
  conversions: Scalars['BigDecimal']['output'];
  cost: Scalars['BigDecimal']['output'];
  cpa: Scalars['BigDecimal']['output'];
  cpc: Scalars['BigDecimal']['output'];
  cpm: Scalars['BigDecimal']['output'];
  ctr: Scalars['BigDecimal']['output'];
  currency: ReportSupportedCurrency;
  cvr: Scalars['BigDecimal']['output'];
  datasourceId: Scalars['Long']['output'];
  dimensionValues?: Maybe<Array<KeywordDetailedReportDimensionValuesPayload>>;
  id: Scalars['Long']['output'];
  impressions: Scalars['BigDecimal']['output'];
  keyword: Scalars['String']['output'];
  roas: Scalars['BigDecimal']['output'];
  sales: Scalars['BigDecimal']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type KeywordDetailedReportPayloadList = {
  __typename?: 'KeywordDetailedReportPayloadList';
  items: Array<KeywordDetailedReportPayload>;
  meta: ReportListMeta;
};

export type KeywordSummaryInput = {
  campaignId: Scalars['Long']['input'];
  datasourceId: Scalars['Long']['input'];
  endDate: Scalars['LocalDate']['input'];
  groupId: Scalars['Long']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  pricesView: AdReportPricesView;
  startDate: Scalars['LocalDate']['input'];
};

export type LineConnection = {
  __typename?: 'LINEConnection';
  botBasicId: Scalars['String']['output'];
  botChannelId: Scalars['String']['output'];
  botDisplayName: Scalars['String']['output'];
  botUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  loginChannelId?: Maybe<Scalars['String']['output']>;
};

export type LineLoginRequest = {
  authorizationCode: Scalars['String']['input'];
  loginChannelId: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
};

export type LineLoginResponse = {
  __typename?: 'LINELoginResponse';
  idToken: Scalars['String']['output'];
  lineConnection: LineConnection;
  lineUser: LineUser;
};

export type LineMessageAction = {
  __typename?: 'LINEMessageAction';
  templateId: Scalars['String']['output'];
};

export type LineMessageActionInput = {
  templateContentJSON?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type LineMessageItemInput = {
  buttonMessageV2?: InputMaybe<ButtonMessageInputV2>;
  fileMessage?: InputMaybe<FileMessageInput>;
  imageMessage?: InputMaybe<ImageMessageInput>;
  plainTextMessage?: InputMaybe<PlainTextMessageInput>;
  richMessage?: InputMaybe<RichMessageInput>;
  singleImageMessage?: InputMaybe<SingleImageMessageInput>;
  type: LineMessageType;
  videoMessage?: InputMaybe<VideoMessageInput>;
};

export type LineUser = {
  __typename?: 'LINEUser';
  chatId?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export const Language = {
  EN_US: 'EN_US',
  JA_JP: 'JA_JP',
  KO_KR: 'KO_KR',
  ZH_CN: 'ZH_CN',
  ZH_TW: 'ZH_TW'
} as const;

export type Language = typeof Language[keyof typeof Language];
export type LazadaChatEvent = CommonChatEvent | LazadaMessageEvent;

export type LazadaChatEvents = {
  __typename?: 'LazadaChatEvents';
  chatEvents: Array<LazadaChatEvent>;
  chatId: Scalars['String']['output'];
  lastCheckedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  newerCursor?: Maybe<Scalars['String']['output']>;
  olderCursor?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

export type LazadaChatPlatformDetail = {
  __typename?: 'LazadaChatPlatformDetail';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type LazadaEmojiMessageContent = {
  __typename?: 'LazadaEmojiMessageContent';
  iconUrl: Scalars['Url']['output'];
  text: Scalars['String']['output'];
};

export type LazadaFaqBot = {
  __typename?: 'LazadaFAQBot';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type LazadaFaqMessageContent = {
  __typename?: 'LazadaFAQMessageContent';
  questions: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type LazadaFileUploadInput = {
  /** start from gs://~~~ */
  fileUri: Scalars['String']['input'];
  saleChannelId: Scalars['Long']['input'];
  type: LazadaFileUploadType;
};

export const LazadaFileUploadType = {
  AD_COST_SPONSOR_DISCOVERY: 'AD_COST_SPONSOR_DISCOVERY',
  SESSION: 'SESSION'
} as const;

export type LazadaFileUploadType = typeof LazadaFileUploadType[keyof typeof LazadaFileUploadType];
export type LazadaImageMessageContent = {
  __typename?: 'LazadaImageMessageContent';
  url: Scalars['Url']['output'];
};

export type LazadaItemMessageContent = {
  __typename?: 'LazadaItemMessageContent';
  actionUrl?: Maybe<Scalars['Url']['output']>;
  iconUrl: Scalars['Url']['output'];
  id: Scalars['String']['output'];
  itemUrlPath?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type LazadaLoginUrlV2Input = {
  redirectUri: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export const LazadaMarketplace = {
  ID: 'ID',
  MY: 'MY',
  PH: 'PH',
  SG: 'SG',
  TH: 'TH',
  VN: 'VN'
} as const;

export type LazadaMarketplace = typeof LazadaMarketplace[keyof typeof LazadaMarketplace];
export type LazadaMessage = {
  content: LazadaMessageContent;
  messageId: Scalars['String']['output'];
};

export type LazadaMessageAuthor = BasicUser | LazadaFaqBot | RepliedFromLazada;

export type LazadaMessageContent = LazadaEmojiMessageContent | LazadaFaqMessageContent | LazadaImageMessageContent | LazadaItemMessageContent | LazadaOrderMessageContent | LazadaTextMessageContent | LazadaUnsupportedMessageContent | LazadaVideoMessageContent | LazadaVoucherMessageContent;

export type LazadaMessageEvent = {
  __typename?: 'LazadaMessageEvent';
  id: Scalars['String']['output'];
  message: LazadaMessage;
  timestamp: Scalars['UnixTimestamp']['output'];
};

export type LazadaOrderMessageContent = {
  __typename?: 'LazadaOrderMessageContent';
  anyxOrderId?: Maybe<Scalars['Long']['output']>;
  iconUrl: Scalars['Url']['output'];
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type LazadaOrderProductDetail = {
  __typename?: 'LazadaOrderProductDetail';
  externalId: Scalars['String']['output'];
  isFreeGift: Scalars['Boolean']['output'];
  lazadaVoucher: Scalars['BigDecimal']['output'];
  paidPrice: Scalars['BigDecimal']['output'];
  sellerVoucher: Scalars['BigDecimal']['output'];
};

export type LazadaSaleChannelData = {
  __typename?: 'LazadaSaleChannelData';
  marketplace: LazadaMarketplace;
  refreshTokenExpirationDate: Scalars['OffsetDateTime']['output'];
  showReconnectButton: Scalars['Boolean']['output'];
};

export type LazadaSalesChartInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type LazadaSalesChartPayload = {
  __typename?: 'LazadaSalesChartPayload';
  conversionRate: Array<Scalars['Map']['output']>;
  currency: ReportSupportedCurrency;
  orders: Array<Scalars['Map']['output']>;
  sales: Array<Scalars['Map']['output']>;
  unitsOrdered: Array<Scalars['Map']['output']>;
  visitors: Array<Scalars['Map']['output']>;
};

export type LazadaSalesDetailedReportInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type LazadaSalesDetailedReportPayload = {
  __typename?: 'LazadaSalesDetailedReportPayload';
  conversionRate: Scalars['BigDecimal']['output'];
  currency: ReportSupportedCurrency;
  date: Scalars['LocalDate']['output'];
  orders: Scalars['Long']['output'];
  sales: Scalars['BigDecimal']['output'];
  unitsOrdered: Scalars['Long']['output'];
  visitors: Scalars['Long']['output'];
};

export type LazadaSalesDetailedReportPayloadList = {
  __typename?: 'LazadaSalesDetailedReportPayloadList';
  items: Array<LazadaSalesDetailedReportPayload>;
  meta: ReportListMeta;
  total: LazadaSalesDetailedReportTotalPayload;
};

export type LazadaSalesDetailedReportTotalPayload = {
  __typename?: 'LazadaSalesDetailedReportTotalPayload';
  conversionRate: Scalars['BigDecimal']['output'];
  currency: ReportSupportedCurrency;
  orders: Scalars['Long']['output'];
  sales: Scalars['BigDecimal']['output'];
  unitsOrdered: Scalars['Long']['output'];
  visitors: Scalars['Long']['output'];
};

export type LazadaSalesSummaryInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type LazadaSalesSummaryPayload = {
  __typename?: 'LazadaSalesSummaryPayload';
  conversionRate: NumericValueWithDiffPayload;
  currency: ReportSupportedCurrency;
  orders: NumericValueWithDiffPayload;
  sales: NumericValueWithDiffPayload;
  unitsOrdered: NumericValueWithDiffPayload;
  visitors: NumericValueWithDiffPayload;
};

export type LazadaSendImageMessageRequestInput = {
  chatId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type LazadaSendProductMessageRequestInput = {
  chatId: Scalars['String']['input'];
  itemId: Scalars['Long']['input'];
};

export type LazadaSendTextMessageRequestInput = {
  chatId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type LazadaSendVideoMessageRequestInput = {
  chatId: Scalars['String']['input'];
  height: Scalars['Int']['input'];
  thumbUrl: Scalars['Url']['input'];
  videoUrl: Scalars['Url']['input'];
  width: Scalars['Int']['input'];
};

export type LazadaSendVoucherMessageRequestInput = {
  chatId: Scalars['String']['input'];
  voucherId: Scalars['Long']['input'];
  voucherType: LazadaVoucherType;
};

export type LazadaSpecificData = {
  __typename?: 'LazadaSpecificData';
  orderProductDetails: Array<LazadaOrderProductDetail>;
  totalLazadaDiscount: Scalars['BigDecimal']['output'];
  totalSellerDiscount: Scalars['BigDecimal']['output'];
};

export type LazadaStoreCsMessage = LazadaMessage & {
  __typename?: 'LazadaStoreCSMessage';
  author: LazadaMessageAuthor;
  content: LazadaMessageContent;
  messageId: Scalars['String']['output'];
  messageState: MessageState;
  settingPageUrl?: Maybe<Scalars['Url']['output']>;
};

export type LazadaStoreChat = StoreChat & {
  __typename?: 'LazadaStoreChat';
  connectionExpiryTime: Scalars['OffsetDateTime']['output'];
  createdAt: Scalars['OffsetDateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tokenUpdatedSuccessfully: Scalars['Boolean']['output'];
  type: ChatType;
};

export type LazadaTargetInput = {
  type: LazadaTargetType;
};

export const LazadaTargetType = {
  CHAT_MESSAGE: 'CHAT_MESSAGE',
  CHAT_VIDEO_MESSAGE: 'CHAT_VIDEO_MESSAGE'
} as const;

export type LazadaTargetType = typeof LazadaTargetType[keyof typeof LazadaTargetType];
export type LazadaTextMessageContent = {
  __typename?: 'LazadaTextMessageContent';
  text: Scalars['String']['output'];
};

export type LazadaUnsupportedMessageContent = {
  __typename?: 'LazadaUnsupportedMessageContent';
  messageType: Scalars['String']['output'];
};

export type LazadaUserMessage = LazadaMessage & {
  __typename?: 'LazadaUserMessage';
  content: LazadaMessageContent;
  messageId: Scalars['String']['output'];
};

export type LazadaVideoMessageContent = {
  __typename?: 'LazadaVideoMessageContent';
  firstFrameUrl: Scalars['Url']['output'];
  videoUrl?: Maybe<Scalars['Url']['output']>;
};

export type LazadaVoucher = {
  __typename?: 'LazadaVoucher';
  currency: Scalars['String']['output'];
  discount: LazadaVoucherDiscount;
  endDate: Scalars['OffsetDateTime']['output'];
  id: Scalars['String']['output'];
  minSpend: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['OffsetDateTime']['output'];
  status: LazadaVoucherStatus;
  type: LazadaVoucherType;
};

export type LazadaVoucherDiscount = LazadaVoucherMoneyValueOff | LazadaVoucherPercentageDiscountOff;

export type LazadaVoucherMessageContent = {
  __typename?: 'LazadaVoucherMessageContent';
  currency: Scalars['String']['output'];
  discount: LazadaVoucherDiscount;
  endDate: Scalars['OffsetDateTime']['output'];
  id: Scalars['Long']['output'];
  minSpend: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['OffsetDateTime']['output'];
  status: LazadaVoucherStatus;
  type: LazadaVoucherType;
};

export type LazadaVoucherMoneyValueOff = {
  __typename?: 'LazadaVoucherMoneyValueOff';
  amount: Scalars['String']['output'];
};

export type LazadaVoucherPercentageDiscountOff = {
  __typename?: 'LazadaVoucherPercentageDiscountOff';
  maxValue: Scalars['String']['output'];
  percentage: Scalars['String']['output'];
};

export const LazadaVoucherStatus = {
  FINISH: 'FINISH',
  NOT_START: 'NOT_START',
  ONGOING: 'ONGOING',
  SUSPEND: 'SUSPEND'
} as const;

export type LazadaVoucherStatus = typeof LazadaVoucherStatus[keyof typeof LazadaVoucherStatus];
export const LazadaVoucherType = {
  CODE_VOUCHER: 'CODE_VOUCHER',
  COLLECTIBLE_VOUCHER: 'COLLECTIBLE_VOUCHER'
} as const;

export type LazadaVoucherType = typeof LazadaVoucherType[keyof typeof LazadaVoucherType];
export type LazadaVouchers = {
  __typename?: 'LazadaVouchers';
  total: Scalars['Int']['output'];
  vouchers: Array<LazadaVoucher>;
};

export type LiffIdTokenValidateRequest = {
  idToken: Scalars['String']['input'];
};

export type LiffIdTokenValidateResponse = {
  __typename?: 'LiffIdTokenValidateResponse';
  lineConnection: LineConnection;
  lineUser: LineUser;
  shopifyCustomer?: Maybe<ShopifyCustomer>;
};

export type LiffInfluencerConnectRequestInput = {
  idToken: Scalars['String']['input'];
  influencerId: Scalars['Long']['input'];
};

export type LiffInfluencerConnectResponse = {
  __typename?: 'LiffInfluencerConnectResponse';
  botBasicId: Scalars['String']['output'];
};

export type LiffInquirySendRequest = {
  email: Scalars['String']['input'];
  idToken: Scalars['String']['input'];
  name: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type LiffShopifyConnectRequest = {
  email: Scalars['String']['input'];
  idToken: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LiffShopifyCustomerCreateRequest = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  idToken: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LiffShopifyRedirectConnectRequest = {
  idToken: Scalars['String']['input'];
  shopifyCustomerId: Scalars['String']['input'];
  shopifyEmail: Scalars['String']['input'];
  shopifyPhoneNumber: Scalars['String']['input'];
};

export type LiffShopifyRedirectConnectRequestV2 = {
  idToken: Scalars['String']['input'];
  shopifyCustomerId: Scalars['String']['input'];
  shopifyEmail: Scalars['String']['input'];
  shopifyPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  verificationCode: Scalars['String']['input'];
};

export type LineBotGreetingMessageEvent = {
  __typename?: 'LineBotGreetingMessageEvent';
  templateId: Scalars['String']['output'];
};

export type LineBotImageMessageEvent = {
  __typename?: 'LineBotImageMessageEvent';
  author: BasicUser;
  canQuoteReply: Scalars['Boolean']['output'];
  originalUrl: Scalars['String']['output'];
  previewUrl: Scalars['String']['output'];
};

export type LineBotTextMessageEvent = {
  __typename?: 'LineBotTextMessageEvent';
  author: MessageAuthor;
  canQuoteReply: Scalars['Boolean']['output'];
  messageState: MessageState;
  quotedEvent?: Maybe<QuotedLineChatEvent>;
  text: Scalars['String']['output'];
};

export type LineBotUnitMessageEvent = {
  __typename?: 'LineBotUnitMessageEvent';
  author: MessageAuthor;
  messagesV2: Array<LineMessageWithQuote>;
};

export type LineBroadcastMessage = {
  __typename?: 'LineBroadcastMessage';
  content: Array<LineMessage>;
  createdAt: Scalars['OffsetDateTime']['output'];
  deliveredAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  deliveryTiming: DeliveryTiming;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastTestSend?: Maybe<LineBroadcastTestSendInfo>;
  name: Scalars['String']['output'];
  recipient: Recipient;
  statistics?: Maybe<BroadcastStatistics>;
  status: BroadcastStatus;
  trackingEnabled: Scalars['Boolean']['output'];
  trackingUrls?: Maybe<Array<TrackingUrl>>;
  urlLinkGroupId: Scalars['String']['output'];
};

export type LineBroadcastMessageCreateRequestInput = {
  deliveryTiming: DeliveryTimingItemInput;
  lineContent: LineContentInputInput;
  originalUrls: Array<Scalars['Url']['input']>;
  recipient: RecipientItemInput;
  storeId: Scalars['Long']['input'];
  title: Scalars['String']['input'];
  trackingEnabled: Scalars['Boolean']['input'];
  urlLinkGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type LineBroadcastMessageCreateResponse = {
  __typename?: 'LineBroadcastMessageCreateResponse';
  messageId: Scalars['String']['output'];
};

export type LineBroadcastMessageUpdateRequestInput = {
  deliveryTiming: DeliveryTimingItemInput;
  lineBroadcastMessageId: Scalars['String']['input'];
  lineContent: LineContentInputInput;
  originalUrls: Array<Scalars['Url']['input']>;
  recipient: RecipientItemInput;
  title: Scalars['String']['input'];
  trackingEnabled: Scalars['Boolean']['input'];
};

export type LineBroadcastMessageUpdateResponse = {
  __typename?: 'LineBroadcastMessageUpdateResponse';
  messageId: Scalars['String']['output'];
};

export type LineBroadcastMessages = {
  __typename?: 'LineBroadcastMessages';
  messages: Array<LineBroadcastMessage>;
  total: Scalars['Int']['output'];
};

export type LineBroadcastSortByInput = {
  descending: Scalars['Boolean']['input'];
  field: LineBroadcastSortField;
};

export const LineBroadcastSortField = {
  AverageOrderValue: 'AverageOrderValue',
  Click: 'Click',
  ClickRate: 'ClickRate',
  Conversion: 'Conversion',
  ConversionRate: 'ConversionRate',
  CreatedDate: 'CreatedDate',
  DeliveredCount: 'DeliveredCount',
  DeliveredDate: 'DeliveredDate',
  Open: 'Open',
  OpenRate: 'OpenRate',
  SaleAmount: 'SaleAmount'
} as const;

export type LineBroadcastSortField = typeof LineBroadcastSortField[keyof typeof LineBroadcastSortField];
export type LineBroadcastStatisticSummaries = {
  __typename?: 'LineBroadcastStatisticSummaries';
  compareStatistics?: Maybe<BroadcastStatistics>;
  diffStatistics?: Maybe<BroadcastStatistics>;
  sumStatistics: BroadcastStatistics;
};

export type LineBroadcastTestSendInfo = {
  __typename?: 'LineBroadcastTestSendInfo';
  status: LineBroadcastTestSendStatus;
  updatedAt: Scalars['OffsetDateTime']['output'];
};

export const LineBroadcastTestSendStatus = {
  DELIVERED: 'DELIVERED',
  ERROR: 'ERROR',
  SENDING: 'SENDING'
} as const;

export type LineBroadcastTestSendStatus = typeof LineBroadcastTestSendStatus[keyof typeof LineBroadcastTestSendStatus];
export type LineCardButtonAction = ClipboardAction | LinkedPostbackAction | UrlAction | UrlVariableAction;

export const LineCardButtonActionType = {
  LINKED_POSTBACK_BUTTON_ACTION: 'LINKED_POSTBACK_BUTTON_ACTION',
  URL_BUTTON_ACTION: 'URL_BUTTON_ACTION',
  URL_VARIABLE_BUTTON_ACTION: 'URL_VARIABLE_BUTTON_ACTION'
} as const;

export type LineCardButtonActionType = typeof LineCardButtonActionType[keyof typeof LineCardButtonActionType];
export type LineChatEvent = CommonChatEvent | LinePlatformEvent;

export type LineChatEvents = {
  __typename?: 'LineChatEvents';
  chatEvents: Array<LineChatEvent>;
  chatId: Scalars['String']['output'];
  lastCheckedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  newerCursor?: Maybe<Scalars['String']['output']>;
  olderCursor?: Maybe<Scalars['String']['output']>;
  userAvatar?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

export type LineChatMessageRequest = {
  chatId: Scalars['String']['input'];
  messages: Array<LineMessageItemInput>;
};

export type LineChatPlatformDetail = {
  __typename?: 'LineChatPlatformDetail';
  isFollow: Scalars['Boolean']['output'];
};

export type LineContentInputInput = {
  messages: Array<LineMessageItemInput>;
};

export type LineInfluencerJoinedCampaignEvent = {
  __typename?: 'LineInfluencerJoinedCampaignEvent';
  campaignName: Scalars['String']['output'];
};

export type LineInquiryEvent = {
  __typename?: 'LineInquiryEvent';
  inquiry: Scalars['String']['output'];
};

export type LineInquiryFinishEvent = {
  __typename?: 'LineInquiryFinishEvent';
  author: BasicUser;
};

export const LineMediaState = {
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  READY: 'READY'
} as const;

export type LineMediaState = typeof LineMediaState[keyof typeof LineMediaState];
export type LineMessage = ButtonMessage | FileMessage | ImageMessage | PlainTextMessage | RichMessage | SingleImageMessage | VideoMessage;

export type LineMessageQuotaInfo = {
  __typename?: 'LineMessageQuotaInfo';
  consumption: Scalars['Int']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
};

export type LineMessageTemplateEvent = {
  __typename?: 'LineMessageTemplateEvent';
  templateId: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
};

export const LineMessageType = {
  BUTTON: 'BUTTON',
  FILE: 'FILE',
  IMAGES: 'IMAGES',
  PLAIN_TEXT: 'PLAIN_TEXT',
  RICH: 'RICH',
  SINGLE_IMAGE: 'SINGLE_IMAGE',
  VIDEO: 'VIDEO'
} as const;

export type LineMessageType = typeof LineMessageType[keyof typeof LineMessageType];
export type LineMessageUrlInput = {
  type: LineUrlActionType;
  urlText?: InputMaybe<LineUrlTextInput>;
  urlVariable?: InputMaybe<LineUrlVariableInput>;
};

export type LineMessageWithQuote = {
  __typename?: 'LineMessageWithQuote';
  canQuoteReply: Scalars['Boolean']['output'];
  message: LineMessage;
};

export type LinePlatformEvent = {
  __typename?: 'LinePlatformEvent';
  id: Scalars['String']['output'];
  message: LinePlatformEventContent;
  timestamp: Scalars['UnixTimestamp']['output'];
};

export type LinePlatformEventContent = LineBotGreetingMessageEvent | LineBotImageMessageEvent | LineBotTextMessageEvent | LineBotUnitMessageEvent | LineInfluencerJoinedCampaignEvent | LineInquiryEvent | LineInquiryFinishEvent | LineMessageTemplateEvent | LineStateUpdateEvent | LineSystemFoundFollowerEvent | LineUserAudioMessageEvent | LineUserFileMessageEvent | LineUserFollowedEvent | LineUserImageMessageEvent | LineUserLocationMessageEvent | LineUserPostbackEvent | LineUserStickerMessageEvent | LineUserTextMessageEvent | LineUserUnFollowedEvent | LineUserUnsentMessageEvent | LineUserVideoMessageEvent;

export type LineRichMenu = {
  __typename?: 'LineRichMenu';
  chatBarText: Scalars['String']['output'];
  createdAt: Scalars['OffsetDateTime']['output'];
  displayPeriod?: Maybe<DateRange>;
  displayPeriodType: LineRichMenuDisplayPeriodType;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  showMenuByDefault: Scalars['Boolean']['output'];
  status: LineRichMenuStatus;
  template: LineRichMenuTemplate;
  title: Scalars['String']['output'];
  updatedAt: Scalars['OffsetDateTime']['output'];
};

export type LineRichMenuAction = LineRichMenuMessageAction | LineRichMenuPostbackAction | LineRichMenuUriAction;

export type LineRichMenuActionInput = {
  actionInputType: LineRichMenuActionType;
  postback?: InputMaybe<LineRichMenuPostbackActionInput>;
  text?: InputMaybe<LineRichMenuMessageActionInput>;
  uri?: InputMaybe<LineRichMenuUriActionInput>;
};

export const LineRichMenuActionType = {
  LINK: 'LINK',
  NO_ACTION: 'NO_ACTION',
  POSTBACK: 'POSTBACK',
  TEXT: 'TEXT'
} as const;

export type LineRichMenuActionType = typeof LineRichMenuActionType[keyof typeof LineRichMenuActionType];
export type LineRichMenuCreateDraftInput = {
  richMenu: LineRichMenuInput;
  storeId: Scalars['Long']['input'];
};

export type LineRichMenuCreateDraftResponse = {
  __typename?: 'LineRichMenuCreateDraftResponse';
  id: Scalars['String']['output'];
};

export type LineRichMenuDisplayPeriodInput = {
  dateRangeInput?: InputMaybe<DateRangeInput>;
  displayType?: InputMaybe<LineRichMenuDisplayPeriodType>;
};

export const LineRichMenuDisplayPeriodType = {
  DEFAULT: 'DEFAULT',
  ON_SHOPIFY_ID_SYNC: 'ON_SHOPIFY_ID_SYNC',
  SCHEDULE: 'SCHEDULE'
} as const;

export type LineRichMenuDisplayPeriodType = typeof LineRichMenuDisplayPeriodType[keyof typeof LineRichMenuDisplayPeriodType];
export type LineRichMenuInput = {
  chatBarText: Scalars['String']['input'];
  displayPeriod: LineRichMenuDisplayPeriodInput;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  showMenuByDefault: Scalars['Boolean']['input'];
  template: LineRichMenuTemplateInput;
  title: Scalars['String']['input'];
};

export type LineRichMenuListItem = {
  __typename?: 'LineRichMenuListItem';
  displayPeriod?: Maybe<DateRange>;
  displayPeriodType: LineRichMenuDisplayPeriodType;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  status: LineRichMenuStatus;
  title: Scalars['String']['output'];
};

export type LineRichMenuMessageAction = {
  __typename?: 'LineRichMenuMessageAction';
  text: Scalars['String']['output'];
};

export type LineRichMenuMessageActionInput = {
  text: Scalars['String']['input'];
};

export type LineRichMenuPostbackAction = {
  __typename?: 'LineRichMenuPostbackAction';
  trigger: Scalars['String']['output'];
};

export type LineRichMenuPostbackActionInput = {
  trigger: Scalars['String']['input'];
};

export const LineRichMenuStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  INACTIVE: 'INACTIVE',
  SCHEDULED: 'SCHEDULED'
} as const;

export type LineRichMenuStatus = typeof LineRichMenuStatus[keyof typeof LineRichMenuStatus];
export type LineRichMenuSubmitFailExistPermanent = {
  __typename?: 'LineRichMenuSubmitFailExistPermanent';
  existingId: Scalars['String']['output'];
};

export type LineRichMenuSubmitFailOverlap = {
  __typename?: 'LineRichMenuSubmitFailOverlap';
  overlapIds: Array<Scalars['String']['output']>;
};

export type LineRichMenuSubmitInput = {
  forceReplace: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  richMenu: LineRichMenuInput;
  storeId: Scalars['Long']['input'];
};

export type LineRichMenuSubmitResponse = LineRichMenuSubmitFailExistPermanent | LineRichMenuSubmitFailOverlap | LineRichMenuSubmitSuccess;

export type LineRichMenuSubmitSuccess = {
  __typename?: 'LineRichMenuSubmitSuccess';
  id: Scalars['String']['output'];
};

export type LineRichMenuTemplate = {
  __typename?: 'LineRichMenuTemplate';
  actions: Array<Maybe<LineRichMenuAction>>;
  id: LineRichMenuTemplateId;
};

export const LineRichMenuTemplateId = {
  T1: 'T1',
  T2: 'T2',
  T3: 'T3',
  T4: 'T4',
  T5: 'T5',
  T6: 'T6'
} as const;

export type LineRichMenuTemplateId = typeof LineRichMenuTemplateId[keyof typeof LineRichMenuTemplateId];
export type LineRichMenuTemplateInput = {
  actions: Array<LineRichMenuActionInput>;
  templateId: LineRichMenuTemplateId;
};

export type LineRichMenuUpdateFailExistPermanent = {
  __typename?: 'LineRichMenuUpdateFailExistPermanent';
  existingId: Scalars['String']['output'];
};

export type LineRichMenuUpdateFailOverlap = {
  __typename?: 'LineRichMenuUpdateFailOverlap';
  overlapIds: Array<Scalars['String']['output']>;
};

export type LineRichMenuUpdateInput = {
  backToDraft: Scalars['Boolean']['input'];
  forceReplace: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  richMenu: LineRichMenuInput;
};

export type LineRichMenuUpdateResponse = LineRichMenuUpdateFailExistPermanent | LineRichMenuUpdateFailOverlap | LineRichMenuUpdateSuccess;

export type LineRichMenuUpdateSuccess = {
  __typename?: 'LineRichMenuUpdateSuccess';
  id: Scalars['String']['output'];
};

export type LineRichMenuUriAction = {
  __typename?: 'LineRichMenuUriAction';
  uri: Scalars['Url']['output'];
};

export type LineRichMenuUriActionInput = {
  uri: Scalars['Url']['input'];
};

export type LineRichMenusInput = {
  dateRange?: InputMaybe<DateRangeInput>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  status?: InputMaybe<LineRichMenuStatus>;
  storeId: Scalars['Long']['input'];
};

export type LineScheduledMessage = {
  __typename?: 'LineScheduledMessage';
  createdAt: Scalars['OffsetDateTime']['output'];
  id: Scalars['String']['output'];
  messages: Array<LineMessage>;
  scheduledAt: Scalars['OffsetDateTime']['output'];
  status: LineScheduledMessageStatus;
  updatedAt: Scalars['OffsetDateTime']['output'];
};

export type LineScheduledMessageCreateInput = {
  chatId: Scalars['String']['input'];
  messages: Array<LineMessageItemInput>;
  scheduledAt: Scalars['OffsetDateTime']['input'];
};

export type LineScheduledMessageDeleteInput = {
  chatId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
};

export type LineScheduledMessageImmediateSendInput = {
  chatId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
};

export const LineScheduledMessageStatus = {
  ERROR: 'ERROR',
  SCHEDULED: 'SCHEDULED',
  SENDING: 'SENDING',
  SENT: 'SENT'
} as const;

export type LineScheduledMessageStatus = typeof LineScheduledMessageStatus[keyof typeof LineScheduledMessageStatus];
export type LineScheduledMessageUpdateInput = {
  chatId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  messages: Array<LineMessageItemInput>;
  scheduledAt: Scalars['OffsetDateTime']['input'];
};

export type LineStateUpdateEvent = {
  __typename?: 'LineStateUpdateEvent';
  id: Scalars['String']['output'];
};

export type LineStickerData = AnimatedSticker | OtherSticker | StaticSticker;

export type LineStoreChat = StoreChat & {
  __typename?: 'LineStoreChat';
  createdAt: Scalars['OffsetDateTime']['output'];
  id: Scalars['String']['output'];
  isAIReplyEnable: Scalars['Boolean']['output'];
  isRefreshTokenSuccess: Scalars['Boolean']['output'];
  liffUrl?: Maybe<Scalars['Url']['output']>;
  messageQuota: LineMessageQuotaInfo;
  name: Scalars['String']['output'];
  type: ChatType;
};

export type LineSystemFoundFollowerEvent = {
  __typename?: 'LineSystemFoundFollowerEvent';
  username: Scalars['String']['output'];
};

export type LineTargetInput = {
  messageType?: InputMaybe<LineMessageType>;
  type: LineTargetType;
};

export const LineTargetType = {
  BROADCAST_MESSAGE: 'BROADCAST_MESSAGE',
  CHAT_MESSAGE: 'CHAT_MESSAGE',
  GREETING_MESSAGE: 'GREETING_MESSAGE',
  RICH_MENU: 'RICH_MENU',
  UNIT_MESSAGE: 'UNIT_MESSAGE'
} as const;

export type LineTargetType = typeof LineTargetType[keyof typeof LineTargetType];
export type LineUrlAction = LineUrlText | LineUrlVariable;

export const LineUrlActionType = {
  URL_TEXT: 'URL_TEXT',
  URL_VARIABLE: 'URL_VARIABLE'
} as const;

export type LineUrlActionType = typeof LineUrlActionType[keyof typeof LineUrlActionType];
export type LineUrlText = {
  __typename?: 'LineUrlText';
  url: Scalars['String']['output'];
};

export type LineUrlTextInput = {
  url: Scalars['String']['input'];
};

export type LineUrlVariable = {
  __typename?: 'LineUrlVariable';
  variable: Scalars['String']['output'];
};

export type LineUrlVariableInput = {
  variable: Scalars['String']['input'];
};

export type LineUserAudioMessageEvent = {
  __typename?: 'LineUserAudioMessageEvent';
  contentUrl: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  mediaState: LineMediaState;
};

export type LineUserFileMessageEvent = {
  __typename?: 'LineUserFileMessageEvent';
  contentUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize?: Maybe<Scalars['Long']['output']>;
  format: Scalars['String']['output'];
  mediaState: LineMediaState;
};

export type LineUserFollowedEvent = {
  __typename?: 'LineUserFollowedEvent';
  username: Scalars['String']['output'];
};

export type LineUserImageMessageEvent = {
  __typename?: 'LineUserImageMessageEvent';
  canQuoteReply: Scalars['Boolean']['output'];
  imageUrl: Scalars['String']['output'];
  mediaState: LineMediaState;
};

export type LineUserLocationMessageEvent = {
  __typename?: 'LineUserLocationMessageEvent';
  address: Scalars['String']['output'];
  latitude: Scalars['String']['output'];
  longitude: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type LineUserPostbackEvent = {
  __typename?: 'LineUserPostbackEvent';
  displayText: Scalars['String']['output'];
};

export type LineUserStickerMessageEvent = {
  __typename?: 'LineUserStickerMessageEvent';
  canQuoteReply: Scalars['Boolean']['output'];
  quotedEvent?: Maybe<QuotedLineChatEvent>;
  stickerData: LineStickerData;
};

export type LineUserTextMessageEvent = {
  __typename?: 'LineUserTextMessageEvent';
  canQuoteReply: Scalars['Boolean']['output'];
  quotedEvent?: Maybe<QuotedLineChatEvent>;
  text: Scalars['String']['output'];
};

export type LineUserUnFollowedEvent = {
  __typename?: 'LineUserUnFollowedEvent';
  username: Scalars['String']['output'];
};

export type LineUserUnsentMessageEvent = {
  __typename?: 'LineUserUnsentMessageEvent';
  unsentAt: Scalars['UnixTimestamp']['output'];
};

export type LineUserVideoMessageEvent = {
  __typename?: 'LineUserVideoMessageEvent';
  canQuoteReply: Scalars['Boolean']['output'];
  contentUrl: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  mediaState: LineMediaState;
};

export type LinkedPostbackAction = {
  __typename?: 'LinkedPostbackAction';
  messageId: Scalars['String']['output'];
};

export type LinkedPostbackActionInput = {
  messageId: Scalars['String']['input'];
};

export const LipSyncMode = {
  ORIGINAL: 'ORIGINAL',
  UNIVERSAL: 'UNIVERSAL'
} as const;

export type LipSyncMode = typeof LipSyncMode[keyof typeof LipSyncMode];
export type ListMeta = {
  /** Length in this query */
  length: Scalars['Int']['output'];
  /** Page size */
  limit: Scalars['Int']['output'];
  /** Start position of this query */
  start: Scalars['Int']['output'];
  /** Total length of items including other pages */
  total: Scalars['Int']['output'];
};

export type Listing = {
  __typename?: 'Listing';
  createdAt: Scalars['OffsetDateTime']['output'];
  id: Scalars['Long']['output'];
  media: Array<Scalars['URL']['output']>;
  name: Scalars['String']['output'];
  saleChannel: SaleChannel;
  saleChannelId: Scalars['Long']['output'];
  status: ListingStatus;
  updatedAt: Scalars['OffsetDateTime']['output'];
};

export type ListingInfo = {
  __typename?: 'ListingInfo';
  country?: Maybe<Scalars['String']['output']>;
  saleChannelType: SaleChannelType;
};

export type ListingInfoPayload = {
  __typename?: 'ListingInfoPayload';
  country?: Maybe<Scalars['String']['output']>;
  saleChannelType: SaleChannelType;
};

export const ListingStatus = {
  ACTIVE: 'ACTIVE',
  UNLISTED: 'UNLISTED'
} as const;

export type ListingStatus = typeof ListingStatus[keyof typeof ListingStatus];
export type ListingTriggerSyncInput = {
  saleChannelId: Scalars['Long']['input'];
};

export type ListingVariant = {
  __typename?: 'ListingVariant';
  currency: Scalars['String']['output'];
  freeStock: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  listing: Listing;
  listingId: Scalars['Long']['output'];
  media: Array<Scalars['URL']['output']>;
  price: Scalars['BigDecimal']['output'];
  productVariantId: Scalars['Long']['output'];
  sellerSKUCode: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

/** Live asset type. */
export type LiveAsset = {
  __typename?: 'LiveAsset';
  commentsPerHour: Scalars['BigDecimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  gmvPerHour: AnyLiveMoney;
  id: Scalars['ID']['output'];
  itemsSoldPerHour: Scalars['BigDecimal']['output'];
  language: ScriptLanguage;
  name: Scalars['String']['output'];
  ordersConfirmedPerHour: Scalars['BigDecimal']['output'];
  ordersCreatedPerHour: Scalars['BigDecimal']['output'];
  store?: Maybe<MdStore>;
  storeId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versions: Array<LiveAssetVersion>;
  viewsPerHour: Scalars['BigDecimal']['output'];
};

/** Input for clearing all TTS IDs from live asset content. */
export type LiveAssetContentClearTtsInput = {
  /** Live asset version ID. */
  liveAssetVersionId: Scalars['ID']['input'];
};

/** Input for creating live asset content. */
export type LiveAssetContentCreateInput = {
  /** Content for the live asset section. */
  content: Scalars['String']['input'];
  /** Live asset version ID. */
  liveAssetVersionId: Scalars['ID']['input'];
  /** Title for the live asset section. */
  title: Scalars['String']['input'];
  /** TTS speed for the live asset section (1.0 = normal speed, range: 0.5 to 2.0). */
  ttsSpeed?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** Output type for a live asset content. */
export type LiveAssetContentOutput = {
  __typename?: 'LiveAssetContentOutput';
  /** Live asset content ID. */
  id: Scalars['ID']['output'];
};

/** Input for reordering live asset content. */
export type LiveAssetContentReorderInput = {
  /** Ordered list of live asset content IDs (preferred). Use this instead of scriptContentIds. */
  liveAssetContentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Live asset version ID. */
  liveAssetVersionId: Scalars['ID']['input'];
};

/** Input for updating live asset content. */
export type LiveAssetContentUpdateInput = {
  /** New content for the live asset section. */
  content: Scalars['String']['input'];
  /** Whether per-script voice control override is enabled. Null leaves the existing value unchanged. */
  customVoiceControlEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Live asset content ID to update. */
  id: Scalars['String']['input'];
  /** New title for the live asset section. */
  title: Scalars['String']['input'];
  /** TTS emotion override for the live asset section (happy, sad, angry, fearful, disgusted, surprised, neutral). Null leaves the existing value unchanged. */
  ttsEmotion?: InputMaybe<Scalars['String']['input']>;
  /** TTS pitch override for the live asset section (0 = normal pitch, range: -12 to 12). Null leaves the existing value unchanged. */
  ttsPitch?: InputMaybe<Scalars['Int']['input']>;
  /** TTS speed for the live asset section (1.0 = normal speed, range: 0.5 to 2.0). */
  ttsSpeed?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** Create input for a live asset. */
export type LiveAssetCreateInput = {
  language: ScriptLanguage;
  name: Scalars['String']['input'];
  storeId: Scalars['ID']['input'];
};

/** Delete bulk input for multiple live assets. */
export type LiveAssetDeleteBulkInput = {
  ids: Array<Scalars['ID']['input']>;
};

/** Live asset details type. */
export type LiveAssetDetails = {
  __typename?: 'LiveAssetDetails';
  brandBackground: Scalars['String']['output'];
  brandVoiceGuidelines: Scalars['String']['output'];
  liveObjective: Scalars['String']['output'];
  liveStructure: Scalars['String']['output'];
  liveStyle: Scalars['String']['output'];
  liveTimeSlot: Scalars['String']['output'];
};

/** Input for generating live asset details. */
export type LiveAssetDetailsGenerateInput = {
  language: ScriptLanguage;
  products: Array<AnyLiveProductCreateInput>;
};

/** Duplicate bulk input for multiple live assets. */
export type LiveAssetDuplicateBulkInput = {
  ids: Array<Scalars['ID']['input']>;
  option: LiveAssetDuplicateOption;
};

/** Options for live asset duplication. */
export const LiveAssetDuplicateOption = {
  ALL_VERSIONS: 'ALL_VERSIONS',
  ONLY_LATEST_VERSION: 'ONLY_LATEST_VERSION'
} as const;

export type LiveAssetDuplicateOption = typeof LiveAssetDuplicateOption[keyof typeof LiveAssetDuplicateOption];
/** Filter input for live asset export operations. */
export type LiveAssetExportFilterInput = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  commentsPerHour?: InputMaybe<BigDecimalRangeInput>;
  createdAt?: InputMaybe<DateTimeRangeInput>;
  gmvPerHour?: InputMaybe<BigDecimalRangeInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemsSoldPerHour?: InputMaybe<BigDecimalRangeInput>;
  languages?: InputMaybe<Array<ScriptLanguage>>;
  ordersConfirmedPerHour?: InputMaybe<BigDecimalRangeInput>;
  ordersCreatedPerHour?: InputMaybe<BigDecimalRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  viewsPerHour?: InputMaybe<BigDecimalRangeInput>;
};

/** Input for clearing TTS from all FAQ content (general and product FAQs) of a version. */
export type LiveAssetFaqContentClearTtsInput = {
  /** The live asset version ID to clear TTS for. */
  liveAssetVersionId: Scalars['ID']['input'];
};

export const LiveAssetFaqGenerationStatus = {
  DONE: 'DONE',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING'
} as const;

export type LiveAssetFaqGenerationStatus = typeof LiveAssetFaqGenerationStatus[keyof typeof LiveAssetFaqGenerationStatus];
/** Filter input for live assets. */
export type LiveAssetFilterInput = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  commentsPerHour?: InputMaybe<BigDecimalRangeInput>;
  createdAt?: InputMaybe<DateTimeRangeInput>;
  gmvPerHour?: InputMaybe<BigDecimalRangeInput>;
  itemsSoldPerHour?: InputMaybe<BigDecimalRangeInput>;
  languages?: InputMaybe<Array<ScriptLanguage>>;
  ordersConfirmedPerHour?: InputMaybe<BigDecimalRangeInput>;
  ordersCreatedPerHour?: InputMaybe<BigDecimalRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  viewsPerHour?: InputMaybe<BigDecimalRangeInput>;
};

/** Input for generating a live asset. */
export type LiveAssetGenerateInput = {
  brandBackground?: InputMaybe<Scalars['String']['input']>;
  brandVoiceGuidelines?: InputMaybe<Scalars['String']['input']>;
  language: ScriptLanguage;
  liveObjective?: InputMaybe<Scalars['String']['input']>;
  liveStructure?: InputMaybe<Scalars['String']['input']>;
  liveStyle?: InputMaybe<Scalars['String']['input']>;
  liveTimeSlot?: InputMaybe<Scalars['String']['input']>;
  products: Array<AnyLiveProductCreateInput>;
};

/** Input for submitting live asset generation. All required data will be fetched from the database based on the provided ID. */
export type LiveAssetGenerationSubmitInput = {
  /** Live asset version ID. */
  liveAssetVersionId: Scalars['String']['input'];
};

/** Live asset list type. */
export type LiveAssetList = PaginatedList & {
  __typename?: 'LiveAssetList';
  items: Array<LiveAsset>;
  totalCount: Scalars['Int']['output'];
};

/** Input for updating live knowledge settings of a live asset version. */
export type LiveAssetLiveKnowledgeUpdateInput = {
  /** Custom host identity text. Used when hostIdentityType is CUSTOM. */
  hostIdentity?: InputMaybe<Scalars['String']['input']>;
  /** Host identity type. */
  hostIdentityType?: InputMaybe<HostIdentityType>;
  /** The ID of the live asset version to update. */
  id: Scalars['ID']['input'];
  /** Knowledge base content for the live asset version. */
  knowledgeBase?: InputMaybe<Scalars['String']['input']>;
  /** Custom live objective text. Used when liveObjectiveType is CUSTOM. */
  liveObjective?: InputMaybe<Scalars['String']['input']>;
  /** Live objective type. */
  liveObjectiveType?: InputMaybe<LiveObjectiveType>;
  /** Live time slot type. */
  liveTimeSlotType?: InputMaybe<LiveTimeSlotType>;
};

/** Output type for a live asset. */
export type LiveAssetOutput = {
  __typename?: 'LiveAssetOutput';
  /** Live asset ID. */
  id: Scalars['ID']['output'];
  liveAsset?: Maybe<LiveAsset>;
};

/** Input for creating a product associated with a live asset version. */
export type LiveAssetProductCreateInput = {
  /** The ID of the live asset version to associate the product with. */
  liveAssetVersionId: Scalars['ID']['input'];
  /** Name of the product. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Selling point of the product. */
  sellingPoint?: InputMaybe<Scalars['String']['input']>;
  /** URL of the product. */
  url?: InputMaybe<Scalars['Url']['input']>;
};

/** Output for product creation containing the product ID. */
export type LiveAssetProductOutput = {
  __typename?: 'LiveAssetProductOutput';
  /** The ID of the created product. */
  id: Scalars['ID']['output'];
};

/** Input for reordering the products of a live asset version. */
export type LiveAssetProductReorderInput = {
  /** Every product ID of the live asset version, each exactly once, in the new order. Unlike liveAssetContentReorder, a product left out is not deleted: the whole request is rejected. */
  liveAssetProductIds: Array<Scalars['ID']['input']>;
  /** Live asset version ID. */
  liveAssetVersionId: Scalars['ID']['input'];
};

/** Input for updating an existing product. */
export type LiveAssetProductUpdateInput = {
  /** The ID of the product to update. */
  id: Scalars['ID']['input'];
  /** Name of the product. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Selling point of the product. */
  sellingPoint?: InputMaybe<Scalars['String']['input']>;
  /** URL of the product. */
  url?: InputMaybe<Scalars['Url']['input']>;
};

export const LiveAssetScriptGenerationStatus = {
  DONE: 'DONE',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING'
} as const;

export type LiveAssetScriptGenerationStatus = typeof LiveAssetScriptGenerationStatus[keyof typeof LiveAssetScriptGenerationStatus];
/** Script section type. */
export type LiveAssetScriptSection = {
  __typename?: 'LiveAssetScriptSection';
  /** Whether the generated TTS audio file is ready for this section. */
  audioReady: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  /** Whether per-script voice control override is enabled. */
  customVoiceControlEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  orderIndex: Scalars['Int']['output'];
  scriptVersionId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  /** TTS emotion override for this script section (null means inherit global default). */
  ttsEmotion?: Maybe<Scalars['String']['output']>;
  ttsId?: Maybe<Scalars['ID']['output']>;
  /** TTS pitch override for this script section (0 = normal pitch, range: -12 to 12, null means use version default). */
  ttsPitch?: Maybe<Scalars['Int']['output']>;
  /** TTS playback speed (1.0 = normal, 0.5 = half speed, 2.0 = double speed). */
  ttsSpeed: Scalars['BigDecimal']['output'];
};

/** Input for updating all script content for a live asset version. */
export type LiveAssetScriptUpdateInput = {
  /** Live asset version ID. */
  id: Scalars['ID']['input'];
  /** New script sections to replace existing content. */
  script: Array<LiveAssetSectionInput>;
};

/** Create input for live asset section. */
export type LiveAssetSectionInput = {
  content: Scalars['String']['input'];
  title: Scalars['String']['input'];
  /** Optional TTS generation ID to associate with this live asset section. */
  ttsId?: InputMaybe<Scalars['ID']['input']>;
};

/** Sort field for live assets. */
export const LiveAssetSortField = {
  COMMENTS_PER_HOUR: 'COMMENTS_PER_HOUR',
  CREATED_AT: 'CREATED_AT',
  GMV_PER_HOUR: 'GMV_PER_HOUR',
  ID: 'ID',
  ITEMS_SOLD_PER_HOUR: 'ITEMS_SOLD_PER_HOUR',
  NAME: 'NAME',
  ORDERS_CONFIRMED_PER_HOUR: 'ORDERS_CONFIRMED_PER_HOUR',
  ORDERS_CREATED_PER_HOUR: 'ORDERS_CREATED_PER_HOUR',
  UPDATED_AT: 'UPDATED_AT',
  VIEWS_PER_HOUR: 'VIEWS_PER_HOUR'
} as const;

export type LiveAssetSortField = typeof LiveAssetSortField[keyof typeof LiveAssetSortField];
/** Sort input for live assets. */
export type LiveAssetSortInput = {
  /** Default is descending. */
  direction?: InputMaybe<SortDirection>;
  /** Default is ID. */
  field?: InputMaybe<LiveAssetSortField>;
};

/** Update input for a live asset. */
export type LiveAssetUpdateInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Script version. */
export type LiveAssetVersion = {
  __typename?: 'LiveAssetVersion';
  brandBackground?: Maybe<Scalars['String']['output']>;
  brandVoiceGuidelines?: Maybe<Scalars['String']['output']>;
  commentsPerHour: Scalars['BigDecimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultTtsEmotion: Scalars['String']['output'];
  defaultTtsPitch: Scalars['Int']['output'];
  defaultTtsSpeed: Scalars['BigDecimal']['output'];
  defaultVoiceId?: Maybe<Scalars['ID']['output']>;
  generalFaqGenerationStatus?: Maybe<LiveAssetFaqGenerationStatus>;
  /** General FAQ content for this version. Only fetched when explicitly requested. */
  generalFaqs: Array<GeneralFaq>;
  /** Generated script content. Only fetched when explicitly requested. */
  generatedScript: Array<LiveAssetScriptSection>;
  gmvPerHour: AnyLiveMoney;
  hostIdentity?: Maybe<Scalars['String']['output']>;
  hostIdentityType?: Maybe<HostIdentityType>;
  id: Scalars['ID']['output'];
  itemsSoldPerHour: Scalars['BigDecimal']['output'];
  knowledgeBase?: Maybe<Scalars['String']['output']>;
  latestLiveStream?: Maybe<LiveStream>;
  liveAsset: LiveAsset;
  liveObjective?: Maybe<Scalars['String']['output']>;
  liveObjectiveType?: Maybe<LiveObjectiveType>;
  liveStructure?: Maybe<Scalars['String']['output']>;
  liveStyle?: Maybe<Scalars['String']['output']>;
  liveTimeSlot?: Maybe<Scalars['String']['output']>;
  liveTimeSlotType?: Maybe<LiveTimeSlotType>;
  ordersConfirmedPerHour: Scalars['BigDecimal']['output'];
  ordersCreatedPerHour: Scalars['BigDecimal']['output'];
  productFaqGenerationStatus?: Maybe<LiveAssetFaqGenerationStatus>;
  products: Array<AnyLiveProduct>;
  scriptGenerationStatus?: Maybe<LiveAssetScriptGenerationStatus>;
  scriptId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versionName: Scalars['String']['output'];
  viewsPerHour: Scalars['BigDecimal']['output'];
};

/** Delete bulk input for multiple live asset versions. */
export type LiveAssetVersionDeleteBulkInput = {
  /** List of live asset version IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Duplicate bulk input for multiple live asset versions. */
export type LiveAssetVersionDuplicateBulkInput = {
  /** List of live asset version IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Duplicate input for a live asset version. */
export type LiveAssetVersionDuplicateInput = {
  /** Live asset version ID */
  id: Scalars['ID']['input'];
  versionName: Scalars['String']['input'];
};

/** Filter input for live asset version export operations. */
export type LiveAssetVersionExportFilterInput = {
  commentsPerHour?: InputMaybe<BigDecimalRangeInput>;
  createdAt?: InputMaybe<DateTimeRangeInput>;
  gmvPerHour?: InputMaybe<BigDecimalRangeInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemsSoldPerHour?: InputMaybe<BigDecimalRangeInput>;
  /** Live asset ID filter (preferred). Use this instead of scriptId. */
  liveAssetId?: InputMaybe<Scalars['ID']['input']>;
  ordersConfirmedPerHour?: InputMaybe<BigDecimalRangeInput>;
  ordersCreatedPerHour?: InputMaybe<BigDecimalRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  viewsPerHour?: InputMaybe<BigDecimalRangeInput>;
};

/** Filter input for live asset versions. */
export type LiveAssetVersionFilterInput = {
  commentsPerHour?: InputMaybe<BigDecimalRangeInput>;
  createdAt?: InputMaybe<DateTimeRangeInput>;
  gmvPerHour?: InputMaybe<BigDecimalRangeInput>;
  itemsSoldPerHour?: InputMaybe<BigDecimalRangeInput>;
  /** Live asset ID filter (preferred). Use this instead of scriptId. */
  liveAssetId?: InputMaybe<Scalars['ID']['input']>;
  ordersConfirmedPerHour?: InputMaybe<BigDecimalRangeInput>;
  ordersCreatedPerHour?: InputMaybe<BigDecimalRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  viewsPerHour?: InputMaybe<BigDecimalRangeInput>;
};

/** Script version list type. */
export type LiveAssetVersionList = PaginatedList & {
  __typename?: 'LiveAssetVersionList';
  items: Array<LiveAssetVersion>;
  totalCount: Scalars['Int']['output'];
};

/** Output type for a live asset version. */
export type LiveAssetVersionOutput = {
  __typename?: 'LiveAssetVersionOutput';
  /** Live asset version ID. */
  id: Scalars['ID']['output'];
  liveAssetVersion?: Maybe<LiveAssetVersion>;
};

/** Sort input for live asset versions. */
export type LiveAssetVersionSortInput = {
  /** Default is descending. */
  direction?: InputMaybe<SortDirection>;
  /** Default is ID. */
  field?: InputMaybe<ScriptVersionSortField>;
};

/** Update input for a live asset version. */
export type LiveAssetVersionUpdateInput = {
  brandBackground?: InputMaybe<Scalars['String']['input']>;
  brandVoiceGuidelines?: InputMaybe<Scalars['String']['input']>;
  /** Live asset sections. This field is deprecated - use liveAssetContentUpdate endpoint to update live asset content. */
  generatedScript?: InputMaybe<Array<LiveAssetSectionInput>>;
  hostIdentity?: InputMaybe<Scalars['String']['input']>;
  hostIdentityType?: InputMaybe<HostIdentityType>;
  id: Scalars['ID']['input'];
  knowledgeBase?: InputMaybe<Scalars['String']['input']>;
  liveObjective?: InputMaybe<Scalars['String']['input']>;
  liveObjectiveType?: InputMaybe<LiveObjectiveType>;
  liveStructure?: InputMaybe<Scalars['String']['input']>;
  liveStyle?: InputMaybe<Scalars['String']['input']>;
  liveTimeSlot?: InputMaybe<Scalars['String']['input']>;
  liveTimeSlotType?: InputMaybe<LiveTimeSlotType>;
  products?: InputMaybe<Array<AnyLiveProductCreateInput>>;
  versionName: Scalars['String']['input'];
};

/** Input for updating a live asset version's TTS settings. */
export type LiveAssetVersionUpdateTtsSettingsInput = {
  /** Default TTS emotion for the live asset version (happy, sad, angry, fearful, disgusted, surprised, neutral). */
  defaultTtsEmotion?: InputMaybe<Scalars['String']['input']>;
  /** Default TTS pitch for the live asset version (0 = normal pitch, range: -12 to 12). */
  defaultTtsPitch?: InputMaybe<Scalars['Int']['input']>;
  /** Default TTS speed for the live asset version (1.0 = normal speed, range: 0.5 to 2.0). */
  defaultTtsSpeed?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The default voice clone ID for TTS generation. */
  defaultVoiceId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the live asset version to update. */
  id: Scalars['ID']['input'];
};

/** Input for updating a live asset version's version name. */
export type LiveAssetVersionUpdateVersionNameInput = {
  id: Scalars['ID']['input'];
  versionName: Scalars['String']['input'];
};

export type LiveCommentAutoReplyInfo = AutoReplyInfo & {
  __typename?: 'LiveCommentAutoReplyInfo';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  trigger: AutomationFlowTrigger;
};

export const LiveCommentAutoReplyTiming = {
  ON_COMMENT_RECEIVED: 'ON_COMMENT_RECEIVED',
  ON_LIVE_ENDED: 'ON_LIVE_ENDED'
} as const;

export type LiveCommentAutoReplyTiming = typeof LiveCommentAutoReplyTiming[keyof typeof LiveCommentAutoReplyTiming];
export const LiveObjectiveType = {
  BAU: 'BAU',
  CLEARANCE: 'CLEARANCE',
  CUSTOM: 'CUSTOM',
  GIFTING_HOLIDAY: 'GIFTING_HOLIDAY',
  MEGA_SALE: 'MEGA_SALE',
  NEW_LAUNCH: 'NEW_LAUNCH'
} as const;

export type LiveObjectiveType = typeof LiveObjectiveType[keyof typeof LiveObjectiveType];
export const LivePlatform = {
  BYTEPLUS: 'BYTEPLUS',
  FACEBOOK: 'FACEBOOK',
  FIREWORK: 'FIREWORK',
  MOMO: 'MOMO',
  RAKUTEN: 'RAKUTEN',
  SHOPEE: 'SHOPEE',
  TIKTOK: 'TIKTOK'
} as const;

export type LivePlatform = typeof LivePlatform[keyof typeof LivePlatform];
/** LiveStream type. */
export type LiveStream = {
  __typename?: 'LiveStream';
  /** ISO-8601 duration format. */
  avgViewDuration: Scalars['Duration']['output'];
  campaignTypes: Array<Scalars['String']['output']>;
  comments: Scalars['Int']['output'];
  countryIds: Array<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** ISO-8601 duration format. */
  duration: Scalars['Duration']['output'];
  /** External identifier from the sales channel platform. */
  externalId: Scalars['String']['output'];
  gmv: AnyLiveMoney;
  /** Host identifier for AI hosts. */
  hostId?: Maybe<Scalars['ID']['output']>;
  hostType: HostType;
  id: Scalars['ID']['output'];
  /** True while the platform may still revise this session's numbers. Shopee only; always false elsewhere. */
  isProvisional: Scalars['Boolean']['output'];
  itemsSold: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  ordersConfirmed: Scalars['Int']['output'];
  ordersCreated: Scalars['Int']['output'];
  salesChannel?: Maybe<SaleChannel>;
  salesChannelId: Scalars['ID']['output'];
  /** Sales channel platform type. */
  salesChannelType: SalesChannelType;
  /** Timestamp when the scraper last synced data for this shop. */
  scraperSyncUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use liveAssetVersions instead, replace with liveAssetVersions */
  scriptVersions: Array<ScriptVersion>;
  /** Social media platform type for human hosts. */
  socialMediaType?: Maybe<SocialMediaType>;
  /** Social media user identifier for human hosts. */
  socialMediaUserId?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
  store?: Maybe<MdStore>;
  storeId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  views: Scalars['Int']['output'];
};

/** Filter input for livestream export operations. */
export type LiveStreamExportFilterInput = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  avgViewDuration?: InputMaybe<DurationRangeInput>;
  campaignTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  comments?: InputMaybe<IntRangeInput>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<DateTimeRangeInput>;
  duration?: InputMaybe<DurationRangeInput>;
  gmv?: InputMaybe<BigDecimalRangeInput>;
  hostType?: InputMaybe<HostType>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemsSold?: InputMaybe<IntRangeInput>;
  ordersConfirmed?: InputMaybe<IntRangeInput>;
  ordersCreated?: InputMaybe<IntRangeInput>;
  scriptVersionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<DateTimeRangeInput>;
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  views?: InputMaybe<IntRangeInput>;
};

/** Filter input for livestreams. */
export type LiveStreamFilterInput = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  avgViewDuration?: InputMaybe<DurationRangeInput>;
  campaignTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  comments?: InputMaybe<IntRangeInput>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<DateTimeRangeInput>;
  duration?: InputMaybe<DurationRangeInput>;
  gmv?: InputMaybe<BigDecimalRangeInput>;
  hostType?: InputMaybe<HostType>;
  itemsSold?: InputMaybe<IntRangeInput>;
  ordersConfirmed?: InputMaybe<IntRangeInput>;
  ordersCreated?: InputMaybe<IntRangeInput>;
  scriptVersionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<DateTimeRangeInput>;
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  views?: InputMaybe<IntRangeInput>;
};

/** LiveStream list type. */
export type LiveStreamList = PaginatedList & {
  __typename?: 'LiveStreamList';
  items: Array<LiveStream>;
  totalCount: Scalars['Int']['output'];
};

/** Output type for a livestream. */
export type LiveStreamOutput = {
  __typename?: 'LiveStreamOutput';
  /** LiveStream ID. */
  id: Scalars['ID']['output'];
  livestream?: Maybe<LiveStream>;
};

/** Sort field for livestreams. */
export const LiveStreamSortField = {
  AVG_VIEW_DURATION: 'AVG_VIEW_DURATION',
  COMMENTS: 'COMMENTS',
  CREATED_AT: 'CREATED_AT',
  GMV: 'GMV',
  ID: 'ID',
  ITEMS_SOLD: 'ITEMS_SOLD',
  NAME: 'NAME',
  ORDERS_CONFIRMED: 'ORDERS_CONFIRMED',
  ORDERS_CREATED: 'ORDERS_CREATED',
  STARTED_AT: 'STARTED_AT',
  UPDATED_AT: 'UPDATED_AT',
  VIEWS: 'VIEWS'
} as const;

export type LiveStreamSortField = typeof LiveStreamSortField[keyof typeof LiveStreamSortField];
/** Sort input for livestreams. */
export type LiveStreamSortInput = {
  /** Default is descending. */
  direction?: InputMaybe<SortDirection>;
  /** Default is ID. */
  field?: InputMaybe<LiveStreamSortField>;
};

/** Update input for a livestream. */
export type LiveStreamUpdateInput = {
  campaignTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If hostType is AI, this field is required. */
  hostId?: InputMaybe<Scalars['ID']['input']>;
  hostType: HostType;
  id: Scalars['ID']['input'];
  scriptVersionIds: Array<Scalars['ID']['input']>;
  /** If hostType is HUMAN, this field is required. */
  socialMediaType?: InputMaybe<SocialMediaType>;
  /** If hostType is HUMAN, this field is required. */
  socialMediaUserId?: InputMaybe<Scalars['String']['input']>;
};

export const LiveTimeSlotType = {
  NON_PEAK_HOURS: 'NON_PEAK_HOURS',
  PEAK_HOURS: 'PEAK_HOURS'
} as const;

export type LiveTimeSlotType = typeof LiveTimeSlotType[keyof typeof LiveTimeSlotType];
/** Input for creating a livestream avatar by submitting an avatar training task. */
export type LivestreamAvatarCreateInput = {
  /** Presenter gender (MALE/FEMALE/UNKNOWN); defaults to UNKNOWN when omitted. */
  gender?: InputMaybe<AvatarGender>;
  /** The avatar's language. */
  language: TtsAudioLanguage;
  /** The main training video. */
  mainVideo: TrainingVideoInput;
  /** Name of the avatar. */
  name: Scalars['String']['input'];
  /** Optional variant looks, at most 49. The main video is ALWAYS duplicated as the first look, named `Default`, so a variant may not be named `Default`, and that look counts toward the training limits: at most 50 sub videos, shorter than 120 minutes and smaller than 10 GiB together. */
  subVideos?: InputMaybe<Array<SubTrainingVideoInput>>;
};

/** Livestream avatar type. */
export type LivestreamAvatarGql = {
  __typename?: 'LivestreamAvatarGql';
  createdAt: Scalars['DateTime']['output'];
  /** Fixed failure notice when status is FAILED; null otherwise. Never carries technical detail. */
  failedReason?: Maybe<Scalars['String']['output']>;
  /** The presenter gender: MALE, FEMALE or UNKNOWN. */
  gender: AvatarGender;
  id: Scalars['ID']['output'];
  /** The avatar's language. */
  language: TtsAudioLanguage;
  /** The main training video. */
  mainVideo: AvatarVideoGql;
  name: Scalars['String']['output'];
  /** Training lifecycle: PENDING, TRAINING, READY or FAILED. */
  status: LivestreamAvatarStatus;
  /** Additional look (variant) videos. */
  subVideos: Array<AvatarVideoGql>;
  /** Avatar representative thumbnail (its default look's), served from our storage. */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Request a green-screen segmentation preview for a still already uploaded to OSS. */
export type LivestreamAvatarGreenScreenPreviewInput = {
  /** Green-screen settings to apply (sampleBackgroundColor composited; default white). */
  greenScreen: GreenScreenParamsInput;
  /** OSS object key returned by livestreamAvatarGreenScreenPreviewUploadUrl. */
  ossObjectKey: Scalars['String']['input'];
};

/** Segmented preview image returned INLINE (base64) — never a vendor/OSS URL. */
export type LivestreamAvatarGreenScreenPreviewOutput = {
  __typename?: 'LivestreamAvatarGreenScreenPreviewOutput';
  /** Base64-encoded segmented image. Build a data URI: data:{mimeType};base64,{imageBase64}. */
  imageBase64: Scalars['String']['output'];
  /** Image MIME type, e.g. image/png. */
  mimeType: Scalars['String']['output'];
};

/** Request a presigned OSS upload URL for a green-screen preview still image. */
export type LivestreamAvatarGreenScreenPreviewUploadInput = {
  /** Name of the still image file (e.g. frame.png). */
  fileName: Scalars['String']['input'];
  /** MIME type of the image, e.g. image/png. */
  mimeType: Scalars['String']['input'];
};

/** Presigned OSS PUT target for the green-screen preview still image. */
export type LivestreamAvatarGreenScreenPreviewUploadOutput = {
  __typename?: 'LivestreamAvatarGreenScreenPreviewUploadOutput';
  /** OSS object key to echo into livestreamAvatarGreenScreenPreview. */
  objectKey: Scalars['String']['output'];
  /** Presigned OSS PUT URL; short expiry. */
  uploadUrl: Scalars['String']['output'];
};

/** Output type for a livestream avatar. */
export type LivestreamAvatarOutput = {
  __typename?: 'LivestreamAvatarOutput';
  /** Livestream avatar ID. */
  id: Scalars['ID']['output'];
  livestreamAvatar?: Maybe<LivestreamAvatarGql>;
};

export const LivestreamAvatarStatus = {
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  READY: 'READY',
  TRAINING: 'TRAINING'
} as const;

export type LivestreamAvatarStatus = typeof LivestreamAvatarStatus[keyof typeof LivestreamAvatarStatus];
/** Input for renaming one sub-video (look) of an avatar. */
export type LivestreamAvatarSubVideoRenameInput = {
  /** The sub-video's id (AvatarVideo.id). Must be a SUB video of a READY avatar. */
  id: Scalars['ID']['input'];
  /** New name; non-blank and unique among the avatar's sub-videos. */
  name: Scalars['String']['input'];
};

/** Supported MIME types for livestream avatar video uploads. */
export const LivestreamAvatarSupportedMimeType = {
  /** video/mp4 (.mp4) */
  VIDEO_MP4: 'VIDEO_MP4'
} as const;

export type LivestreamAvatarSupportedMimeType = typeof LivestreamAvatarSupportedMimeType[keyof typeof LivestreamAvatarSupportedMimeType];
/** One training video file to request an upload URL for. */
export type LivestreamAvatarTrainingUploadFileInput = {
  /** Name of the video file to be uploaded. */
  fileName: Scalars['String']['input'];
  /** MIME type of the video file, e.g. video/mp4. */
  mimeType: Scalars['String']['input'];
};

/** Dual-store upload targets for one avatar training video: the FE PUTs the file to BOTH URLs. */
export type LivestreamAvatarTrainingUploadUrlOutput = {
  __typename?: 'LivestreamAvatarTrainingUploadUrlOutput';
  /** The file these upload targets belong to. */
  fileName: Scalars['String']['output'];
  /** GCS object key to echo back in livestreamAvatarCreate. */
  gcsObjectKey: Scalars['String']['output'];
  /** Presigned GCS PUT URL (the preview copy); 60-minute expiry. */
  gcsUploadUrl: Scalars['String']['output'];
  /** OSS object key to echo back in livestreamAvatarCreate. */
  ossObjectKey: Scalars['String']['output'];
  /** Presigned OSS PUT URL against the transfer-acceleration endpoint; 60-minute expiry. */
  ossUploadUrl: Scalars['String']['output'];
};

/** Input for generating dual-store (OSS + GCS) upload URLs for avatar training videos. */
export type LivestreamAvatarTrainingUploadUrlsInput = {
  /** Files to upload: the main video first, then up to 49 variants (50 files at most). */
  files: Array<LivestreamAvatarTrainingUploadFileInput>;
};

/** Input for updating a livestream avatar. */
export type LivestreamAvatarUpdateInput = {
  /** Livestream avatar ID. */
  id: Scalars['ID']['input'];
  /** Name of the avatar. */
  name: Scalars['String']['input'];
};

/** Input for generating a signed URL for livestream avatar video upload. */
export type LivestreamAvatarVideoUploadInput = {
  /** Name of the video file to be uploaded. */
  fileName: Scalars['String']['input'];
  /** MIME type of the video file. */
  mimeType: LivestreamAvatarSupportedMimeType;
};

/** Output containing the signed URL for livestream avatar video upload. */
export type LivestreamAvatarVideoUploadOutput = {
  __typename?: 'LivestreamAvatarVideoUploadOutput';
  /** Signed URL for uploading the video file. */
  signedUrl: Scalars['Url']['output'];
  /** GCS URL to store in the database after the upload completes. */
  videoUrl: Scalars['String']['output'];
};

/** Capabilities of a sales channel's live platform. Read it when entering a live room and disable the controls for anything that is false. Extended with a new Boolean whenever a platform diverges from the others. */
export type LivestreamPlatformFeaturesOutput = {
  __typename?: 'LivestreamPlatformFeaturesOutput';
  /** False when the platform has no API to post a text reply into its live chat (MOMO): FAQ text replies, the text-reply frequency and TEXT_REPLY sensitive-word channels are unavailable for its rooms. Voice replies are unaffected. */
  enableFaqTextReply: Scalars['Boolean']['output'];
  /** The sales channel the flags describe. */
  salesChannelType: SalesChannelType;
};

/** One atmosphere timer's settings and the scripts it draws from. */
export type LivestreamRoomAtmosphereGroupGql = {
  __typename?: 'LivestreamRoomAtmosphereGroupGql';
  enabled: Scalars['Boolean']['output'];
  /** Minutes between plays. WELCOME accepts 0.1–1440.0 in 0.1 steps; TIMED accepts whole minutes 1–1440 only. */
  intervalMinutes: Scalars['Float']['output'];
  scripts: Array<LivestreamRoomAtmosphereScriptGql>;
};

export const LivestreamRoomAtmosphereGroupKind = {
  TIMED: 'TIMED',
  WELCOME: 'WELCOME'
} as const;

export type LivestreamRoomAtmosphereGroupKind = typeof LivestreamRoomAtmosphereGroupKind[keyof typeof LivestreamRoomAtmosphereGroupKind];
/** Input for toggling and re-intervaling one atmosphere timer. */
export type LivestreamRoomAtmosphereGroupUpdateInput = {
  enabled: Scalars['Boolean']['input'];
  /** WELCOME accepts 0.1–1440.0 minutes in 0.1 steps; TIMED accepts whole minutes 1–1440 only. */
  intervalMinutes: Scalars['Float']['input'];
  kind: LivestreamRoomAtmosphereGroupKind;
  /** The ID of the livestream room. */
  roomId: Scalars['ID']['input'];
};

/** Payload returned after updating an atmosphere group. */
export type LivestreamRoomAtmosphereGroupUpdatePayload = {
  __typename?: 'LivestreamRoomAtmosphereGroupUpdatePayload';
  atmosphereGuidance: AtmosphereGuidanceGql;
  /** The room whose atmosphere guidance was updated. */
  roomId: Scalars['ID']['output'];
};

/** Input for adding an atmosphere script to a livestream room. */
export type LivestreamRoomAtmosphereScriptAddInput = {
  kind: LivestreamRoomAtmosphereGroupKind;
  /** The ID of the livestream room. */
  roomId: Scalars['ID']['input'];
  /** Script text (max 500 characters, no '{' or '}' placeholders). */
  text: Scalars['String']['input'];
};

/** Payload returned after deleting an atmosphere script. */
export type LivestreamRoomAtmosphereScriptDeletePayload = {
  __typename?: 'LivestreamRoomAtmosphereScriptDeletePayload';
  /** Deleted atmosphere script ID. */
  id: Scalars['ID']['output'];
};

/** Payload returned after triggering TTS generation for an atmosphere script. */
export type LivestreamRoomAtmosphereScriptGenerateTtsPayload = {
  __typename?: 'LivestreamRoomAtmosphereScriptGenerateTtsPayload';
  atmosphereScript: LivestreamRoomAtmosphereScriptGql;
  /** Atmosphere script ID. */
  id: Scalars['ID']['output'];
};

/** A spoken line belonging to a room's WELCOME or TIMED atmosphere timer. */
export type LivestreamRoomAtmosphereScriptGql = {
  __typename?: 'LivestreamRoomAtmosphereScriptGql';
  /** Character count of the script text. */
  characterCount: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** True when the script text or the room's voice/speed/pitch/emotion has changed since ttsGenerationId's audio was generated. The existing audio still plays — this only signals that a regenerate is available. */
  isStale: Scalars['Boolean']['output'];
  /** Which timer this script belongs to. */
  kind: LivestreamRoomAtmosphereGroupKind;
  roomId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  /** TTS generation ID for this script's most recent audio. Poll status/signed URL/voice via Query.ttsInfo(ttsId) or Query.ttsInfos(ttsIds, contentType: ATMOSPHERE_SCRIPT). */
  ttsGenerationId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['String']['output'];
  /** Signed download URL for the uploaded voice reply audio, or null when none is attached. */
  voiceReplySignedUrl?: Maybe<Scalars['Url']['output']>;
  /** Uploaded audio file URL, if any. Mutually exclusive with ttsGenerationId. */
  voiceReplyUrl?: Maybe<Scalars['String']['output']>;
};

/** Payload returned after adding or updating an atmosphere script. */
export type LivestreamRoomAtmosphereScriptMutationPayload = {
  __typename?: 'LivestreamRoomAtmosphereScriptMutationPayload';
  atmosphereScript: LivestreamRoomAtmosphereScriptGql;
  /** Atmosphere script ID. */
  id: Scalars['ID']['output'];
};

/** Input for updating an atmosphere script's text. */
export type LivestreamRoomAtmosphereScriptUpdateInput = {
  /** The ID of the atmosphere script to update. */
  id: Scalars['ID']['input'];
  /** New script text (max 500 characters, no '{' or '}' placeholders). */
  text: Scalars['String']['input'];
};

/** Input for generating a signed URL for atmosphere script voice reply audio upload. */
export type LivestreamRoomAtmosphereScriptVoiceUploadInput = {
  /** Name of the audio file to be uploaded. */
  fileName: Scalars['String']['input'];
  /** Atmosphere script ID. */
  id: Scalars['ID']['input'];
  /** MIME type of the audio file. */
  mimeType: LivestreamRoomFaqAudioSupportedMimeType;
  mimeTypeDomain: MimeType;
};

/** Input for saving the voice reply URL of an atmosphere script after audio upload. */
export type LivestreamRoomAtmosphereScriptVoiceUrlUpdateInput = {
  /** Atmosphere script ID. */
  id: Scalars['ID']['input'];
  /** GCS URL of the uploaded audio file (gs:// format). */
  voiceReplyUrl: Scalars['String']['input'];
};

/** Input for updating a livestream room's comment-switch cooldowns. Range [0, 1440] minutes inclusive, 0 = no limit. STAFF/ADMIN only; rooms in LIVE or PROVISIONING reject with FAILED_PRECONDITION. */
export type LivestreamRoomCommentSwitchCooldownsUpdateInput = {
  /** Minutes to wait before a comment-triggered product switch takes effect again (0 = no limit). */
  commentSwitchProductCooldownMinutes: Scalars['Int']['input'];
  /** Minutes to wait before a comment-triggered custom-video switch takes effect again (0 = no limit). */
  commentSwitchVideoCooldownMinutes: Scalars['Int']['input'];
  /** The ID of the livestream room to update. */
  id: Scalars['ID']['input'];
};

/** Payload returned after updating a livestream room's comment-switch cooldowns. */
export type LivestreamRoomCommentSwitchCooldownsUpdatePayload = {
  __typename?: 'LivestreamRoomCommentSwitchCooldownsUpdatePayload';
  /** Livestream room ID. */
  id: Scalars['ID']['output'];
  livestreamRoom?: Maybe<LivestreamRoomGql>;
};

/** Compose input for a livestream room. */
export type LivestreamRoomComposeInput = {
  id: Scalars['ID']['input'];
};

/** Create input for a livestream room. */
export type LivestreamRoomCreateInput = {
  /** Room content language (issue #322). Fixed at creation, read-only thereafter. The Voice Clone dropdown on the Set Live Content screen lists only completed voice clones matching this language. Optional: if omitted, the language is derived from the seller region. The old FE does not send this field. */
  language?: InputMaybe<TtsAudioLanguage>;
  name: Scalars['String']['input'];
  salesChannelType: SalesChannelType;
  sellerRegion: AnyLiveRegion;
  storeId: Scalars['ID']['input'];
};

/** Create input for a livestream room decoration. */
export type LivestreamRoomDecorationCreateInput = {
  /** Original file name. */
  fileName: Scalars['String']['input'];
  /** GCS URL of the uploaded file. */
  fileUrl: Scalars['String']['input'];
  /** Livestream room ID. */
  livestreamRoomId: Scalars['ID']['input'];
  /** Livestream room product ID. Omit for a ROOM-scoped asset — one shared by every scene through the room's decoration group (livestreamRoomDecorationGroupSave). */
  livestreamRoomProductId?: InputMaybe<Scalars['ID']['input']>;
  /** Type of decoration (VIDEO or IMAGE). */
  type: LivestreamRoomDecorationTypeGql;
};

/** Bulk delete input for livestream room decorations. */
export type LivestreamRoomDecorationDeleteBulkInput = {
  ids: Array<Scalars['ID']['input']>;
};

/** A single overlay layer on the product's livestream decoration canvas. */
export type LivestreamRoomDecorationGql = {
  __typename?: 'LivestreamRoomDecorationGql';
  /** Avatar ID. Present for AVATAR type. Null for others. */
  avatarId?: Maybe<Scalars['ID']['output']>;
  /** Created timestamp. */
  createdAt: Scalars['DateTime']['output'];
  /** Decoration record ID. Present for IMAGE/VIDEO types. Null for AVATAR/CLOSE_UP. */
  decorationId?: Maybe<Scalars['ID']['output']>;
  /** Set when this layer is a projection of the room's decoration group (livestreamRoomDecorationGroup). Such a layer is LOCKED in this scene: it cannot be moved, resized, reordered or deleted here, and livestreamRoomDecorationSave ignores it. Edit it through livestreamRoomDecorationGroupSave, which changes every scene at once. Null = the scene's own layer. */
  groupItemId?: Maybe<Scalars['ID']['output']>;
  /** Unique overlay metadata ID. Use this to identify the layer. */
  id: Scalars['ID']['output'];
  /** Positioning metadata as a JSON string: x, y, width, height (pixels) only. Null if no metadata was set. */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Display name: original file name for IMAGE/VIDEO, 'Digital Human' for AVATAR, paragraph content for CLOSE_UP. */
  name?: Maybe<Scalars['String']['output']>;
  /** Relative z-order, ascending (higher = drawn on top). Never negative. Seeded from the item order of livestreamRoomDecorationSave, then appended past the current maximum for auto-created AVATAR/CLOSE_UP layers. Treat it as a sort key only: values are not guaranteed contiguous or zero-based, because deleting a decoration or paragraph removes its layer and leaves a gap. */
  orderIndex: Scalars['Int']['output'];
  /** Overlay type: IMAGE (uploaded image), VIDEO (uploaded video), AVATAR (digital human), CLOSE_UP (paragraph closeup video). */
  overlayType: LivestreamRoomDecorationOverlayTypeGql;
  /** Product paragraph ID. Present for CLOSE_UP type. Null for others. */
  paragraphId?: Maybe<Scalars['ID']['output']>;
  /** The product this overlay belongs to. */
  productId: Scalars['ID']['output'];
  /** Signed download URL for the overlay preview (15-min expiry). IMAGE/VIDEO: the uploaded file. AVATAR: the selected look's thumbnail (the product's pinned look, or the main video's as fallback). CLOSE_UP: the paragraph close-up video. Null if no source resolves. */
  signedFileUrl?: Maybe<Scalars['Url']['output']>;
  /** Updated timestamp. */
  updatedAt: Scalars['DateTime']['output'];
};

/** One element of the room's decoration group — a layer that appears, locked and in the same position, on every scene of the room. */
export type LivestreamRoomDecorationGroupItemGql = {
  __typename?: 'LivestreamRoomDecorationGroupItemGql';
  /** Created timestamp. */
  createdAt: Scalars['DateTime']['output'];
  /** Decoration record ID. Present for every type but AVATAR, which carries no file. */
  decorationId?: Maybe<Scalars['ID']['output']>;
  /** Unique group item ID. Projected overlays carry it as LivestreamRoomDecorationGql.groupItemId. */
  id: Scalars['ID']['output'];
  /** Positioning metadata as a JSON string: x, y, width, height (pixels) only. Always null for AVATAR — the marker says WHERE the group sits relative to the digital human and nothing else. */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Display name: the original file name, or 'Digital Human' for the AVATAR marker. */
  name?: Maybe<Scalars['String']['output']>;
  /** Relative z-order within the group, ascending (first = bottom layer). Dense and zero-based: the group is rewritten in full on every save. */
  orderIndex: Scalars['Int']['output'];
  /** Overlay type: IMAGE, VIDEO, BACKGROUND_IMAGE, BACKGROUND_VIDEO, or AVATAR (a position marker). CLOSE_UP can never be room-level. */
  overlayType: LivestreamRoomDecorationOverlayTypeGql;
  /** The room this element belongs to. */
  roomId: Scalars['ID']['output'];
  /** Signed download URL for the element's file (15-min expiry). Null for AVATAR: each scene resolves its own avatar look, so the group never carries one. */
  signedFileUrl?: Maybe<Scalars['Url']['output']>;
  /** Updated timestamp. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for replacing the room's whole decoration group. Bulk-replace: the list IS the group, and an empty list clears it. */
export type LivestreamRoomDecorationGroupSaveInput = {
  /** Ordered list of group elements. Index 0 = bottom layer, last item = top layer. */
  items: Array<LivestreamRoomDecorationGroupSaveItemInput>;
  /** The room whose group is being replaced. */
  livestreamRoomId: Scalars['ID']['input'];
};

/** One element of the room's decoration group. */
export type LivestreamRoomDecorationGroupSaveItemInput = {
  /** Required for every type but AVATAR. The decoration must be room-scoped in this room, or owned by one of its products — in which case it is server-side copied into a room-scoped asset, so deleting that product can never take the group down with it. The original row is left untouched. */
  decorationId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Positioning metadata as a JSON string. Only x, y, width, height are stored; any other key is silently ignored.
   * Must be null for AVATAR: the marker records WHERE the group sits relative to the digital human and nothing else — each scene keeps its own avatar, look and rect.
   * Example: {"x":0,"y":0,"width":1080,"height":1920}
   */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** IMAGE, VIDEO, BACKGROUND_IMAGE, BACKGROUND_VIDEO, or AVATAR. CLOSE_UP is rejected: a close-up belongs to a single paragraph and cannot be shared across scenes. */
  type: LivestreamRoomDecorationOverlayTypeGql;
};

/** What the group save changed, so the caller can refresh exactly what moved. */
export type LivestreamRoomDecorationGroupSaveOutput = {
  __typename?: 'LivestreamRoomDecorationGroupSaveOutput';
  /** Every product whose overlay stack was rewritten — re-bake exactly these decoration previews. The whole room, since the group applies to every scene. */
  affectedProductIds: Array<Scalars['ID']['output']>;
  /** Scenes whose OWN background was displaced by the group's. The displaced placement is not recoverable: the uploaded file stays in storage and can be re-picked by hand, but clearing the room background later leaves those scenes with no background at all. */
  backgroundReplacedProductIds: Array<Scalars['ID']['output']>;
};

/** Output type for a livestream room decoration. */
export type LivestreamRoomDecorationOutput = {
  __typename?: 'LivestreamRoomDecorationOutput';
  /** Livestream room decoration ID. */
  id: Scalars['ID']['output'];
};

/** Overlay type for livestream room decorations. */
export const LivestreamRoomDecorationOverlayTypeGql = {
  AVATAR: 'AVATAR',
  /** The scene background: at most one per scene, always full canvas. */
  BACKGROUND_IMAGE: 'BACKGROUND_IMAGE',
  /** The scene background: at most one per scene, always full canvas. */
  BACKGROUND_VIDEO: 'BACKGROUND_VIDEO',
  CLOSE_UP: 'CLOSE_UP',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO'
} as const;

export type LivestreamRoomDecorationOverlayTypeGql = typeof LivestreamRoomDecorationOverlayTypeGql[keyof typeof LivestreamRoomDecorationOverlayTypeGql];
/** Input for generating a signed URL to upload a decoration preview image (jpg) for a product. */
export type LivestreamRoomDecorationPreviewUploadInput = {
  /** Livestream room ID. */
  livestreamRoomId: Scalars['ID']['input'];
  /** Livestream room product ID. */
  livestreamRoomProductId: Scalars['ID']['input'];
};

/** Output containing the signed URL for uploading a decoration preview image. */
export type LivestreamRoomDecorationPreviewUploadOutput = {
  __typename?: 'LivestreamRoomDecorationPreviewUploadOutput';
  /** GCS object key of the preview; pass back as decorationPreviewGcsObjectKey on save. */
  previewGcsObjectKey: Scalars['String']['output'];
  /** Signed URL to PUT the preview jpg to. */
  signedUrl: Scalars['Url']['output'];
};

/** Input for saving all decoration overlays for a product. Deletes all existing overlays and inserts the provided list. */
export type LivestreamRoomDecorationSaveInput = {
  /** Optional GCS object key of the uploaded merged-layers preview image (from livestreamRoomDecorationPreviewUpload.previewGcsObjectKey). When provided it is persisted to the product; when omitted/null the existing preview is left unchanged. */
  decorationPreviewGcsObjectKey?: InputMaybe<Scalars['String']['input']>;
  /** Ordered list of overlay items. Index 0 = bottom layer (lowest z-index), last item = top layer. */
  items: Array<LivestreamRoomDecorationSaveItemInput>;
  /** The product to save overlays for. */
  livestreamRoomProductId: Scalars['ID']['input'];
};

/** A single overlay layer. Provide the source ID matching the overlay type. */
export type LivestreamRoomDecorationSaveItemInput = {
  /** Required for AVATAR. The avatar ID assigned to the product via livestreamRoomProductSelectAvatar. */
  avatarId?: InputMaybe<Scalars['ID']['input']>;
  /** Required for IMAGE/VIDEO. The decoration record ID from livestreamRoomDecorationCreate. */
  decorationId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Positioning metadata as a JSON string. Only x, y, width, height are stored; any other key is silently ignored.
   * All fields are nullable (FE uses defaults when null): "x"/"y" (int pixels, can be negative), "width"/"height" (int pixels, >= 0).
   * Example: {"x":0,"y":0,"width":1920,"height":1080}
   */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** Required for CLOSE_UP. The paragraph ID that has a closeup video set via livestreamRoomProductParagraphVideoUrlUpdate. */
  paragraphId?: InputMaybe<Scalars['ID']['input']>;
  /** Overlay type: IMAGE, VIDEO, AVATAR, or CLOSE_UP. */
  type: LivestreamRoomDecorationOverlayTypeGql;
};

/** Supported MIME types for livestream room decoration uploads. */
export const LivestreamRoomDecorationSupportedMimeType = {
  IMAGE_JPEG: 'IMAGE_JPEG',
  IMAGE_PNG: 'IMAGE_PNG',
  VIDEO_MP4: 'VIDEO_MP4'
} as const;

export type LivestreamRoomDecorationSupportedMimeType = typeof LivestreamRoomDecorationSupportedMimeType[keyof typeof LivestreamRoomDecorationSupportedMimeType];
/** Type of livestream room decoration. */
export const LivestreamRoomDecorationTypeGql = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO'
} as const;

export type LivestreamRoomDecorationTypeGql = typeof LivestreamRoomDecorationTypeGql[keyof typeof LivestreamRoomDecorationTypeGql];
/** Input for generating a signed URL for livestream room decoration upload. */
export type LivestreamRoomDecorationUploadInput = {
  /** Name of the file to be uploaded. */
  fileName: Scalars['String']['input'];
  /** Livestream room ID. */
  livestreamRoomId: Scalars['ID']['input'];
  /** Livestream room product ID. Omit for a ROOM-scoped asset — one shared by every scene through the room's decoration group (livestreamRoomDecorationGroupSave). */
  livestreamRoomProductId?: InputMaybe<Scalars['ID']['input']>;
  /** MIME type of the file. */
  mimeType: LivestreamRoomDecorationSupportedMimeType;
};

/** Output containing the signed URL for livestream room decoration upload. */
export type LivestreamRoomDecorationUploadOutput = {
  __typename?: 'LivestreamRoomDecorationUploadOutput';
  /** GCS URL to store in the database after the upload completes. */
  fileUrl: Scalars['String']['output'];
  /** Signed URL for uploading the file. */
  signedUrl: Scalars['Url']['output'];
};

/** Delete input for a livestream room. */
export type LivestreamRoomDeleteInput = {
  id: Scalars['ID']['input'];
};

/** Bulk duplicate input for livestream rooms. */
export type LivestreamRoomDuplicateBulkInput = {
  ids: Array<Scalars['ID']['input']>;
};

/** Supported MIME types for livestream room FAQ voice reply audio uploads. */
export const LivestreamRoomFaqAudioSupportedMimeType = {
  /** audio/mp3 (.mp3) */
  AUDIO_MP3: 'AUDIO_MP3'
} as const;

export type LivestreamRoomFaqAudioSupportedMimeType = typeof LivestreamRoomFaqAudioSupportedMimeType[keyof typeof LivestreamRoomFaqAudioSupportedMimeType];
/** Input for updating a livestream room's FAQ confidence threshold. Range [0.0, 1.0] inclusive; NaN and ±Infinity are rejected. Null resets the room to the default threshold (0.8). STAFF/ADMIN only; rooms in LIVE or PROVISIONING reject with FAILED_PRECONDITION. */
export type LivestreamRoomFaqConfidenceUpdateInput = {
  /** FAQ confidence cutoff at or above which a semantic FAQ match counts as a hit. Matching uses an inclusive `>=` rule, so an exactly-equal score is a FAQ hit. Null resets this room to the default threshold (0.8). */
  faqConfidenceThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** The ID of the livestream room to update. */
  id: Scalars['ID']['input'];
};

/** Payload returned after updating a livestream room's FAQ confidence threshold. */
export type LivestreamRoomFaqConfidenceUpdatePayload = {
  __typename?: 'LivestreamRoomFaqConfidenceUpdatePayload';
  /** Livestream room ID. */
  id: Scalars['ID']['output'];
  livestreamRoom?: Maybe<LivestreamRoomGql>;
};

/** Output containing the signed URL for livestream room FAQ custom video upload. */
export type LivestreamRoomFaqCustomVideoUploadOutput = {
  __typename?: 'LivestreamRoomFaqCustomVideoUploadOutput';
  /** GCS object key to attach after the upload completes. */
  objectKey: Scalars['String']['output'];
  /** Signed URL for uploading the video file. */
  signedUrl: Scalars['Url']['output'];
};

/** Input for updating a livestream room's FAQ Reply Mode. STAFF/ADMIN only; rooms in LIVE or PROVISIONING reject with FAILED_PRECONDITION. */
export type LivestreamRoomFaqReplyModeUpdateInput = {
  /** The ID of the livestream room to update. */
  id: Scalars['ID']['input'];
  /** Whether every Global FAQ and Product FAQ answer in this room is spoken, posted as text, or both. */
  replyMode: RoomReplyMode;
};

/** Payload returned after updating a livestream room's FAQ Reply Mode. */
export type LivestreamRoomFaqReplyModeUpdatePayload = {
  __typename?: 'LivestreamRoomFaqReplyModeUpdatePayload';
  /** Livestream room ID. */
  id: Scalars['ID']['output'];
  livestreamRoom?: Maybe<LivestreamRoomGql>;
};

/** Supported MIME types for livestream room FAQ custom video uploads. */
export const LivestreamRoomFaqVideoSupportedMimeType = {
  /** video/mp4 (.mp4) */
  VIDEO_MP4: 'VIDEO_MP4'
} as const;

export type LivestreamRoomFaqVideoSupportedMimeType = typeof LivestreamRoomFaqVideoSupportedMimeType[keyof typeof LivestreamRoomFaqVideoSupportedMimeType];
/** Output containing the signed URL for livestream room FAQ voice reply audio upload. */
export type LivestreamRoomFaqVoiceUploadOutput = {
  __typename?: 'LivestreamRoomFaqVoiceUploadOutput';
  /** GCS URL to store in the database after the upload completes. */
  fileUrl: Scalars['String']['output'];
  /** Signed URL for uploading the audio file. */
  signedUrl: Scalars['Url']['output'];
};

/** Filter input for livestream rooms. */
export type LivestreamRoomFilterInput = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<DateTimeRangeInput>;
  salesChannelTypes?: InputMaybe<Array<SalesChannelType>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<LivestreamRoomStatus>>;
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Bulk create input for livestream room general FAQs. All items belong to the same room and are processed atomically. */
export type LivestreamRoomGeneralFaqBulkCreateInput = {
  items: Array<LivestreamRoomGeneralFaqBulkCreateItemInput>;
  livestreamRoomId: Scalars['ID']['input'];
};

/** Single item input for bulk create of livestream room general FAQs. */
export type LivestreamRoomGeneralFaqBulkCreateItemInput = {
  switchProductId?: InputMaybe<Scalars['ID']['input']>;
  switchVideoUrl?: InputMaybe<Scalars['String']['input']>;
  textReply?: InputMaybe<Scalars['String']['input']>;
  triggerWords: Array<Scalars['String']['input']>;
  voiceReplyText?: InputMaybe<Scalars['String']['input']>;
  voiceReplyUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Create input for a livestream room general FAQ. */
export type LivestreamRoomGeneralFaqCreateInput = {
  livestreamRoomId: Scalars['ID']['input'];
  switchProductId?: InputMaybe<Scalars['ID']['input']>;
  switchVideoUrl?: InputMaybe<Scalars['String']['input']>;
  textReply?: InputMaybe<Scalars['String']['input']>;
  triggerWords: Array<Scalars['String']['input']>;
  voiceReplyText?: InputMaybe<Scalars['String']['input']>;
  voiceReplyUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Input for removing the custom-video comment action of a livestream room general FAQ. */
export type LivestreamRoomGeneralFaqCustomVideoRemoveInput = {
  /** Livestream room general FAQ ID. */
  id: Scalars['ID']['input'];
};

/** Input for generating or regenerating a livestream room general FAQ's custom-video replacement-script audio. */
export type LivestreamRoomGeneralFaqCustomVideoTtsGenerateInput = {
  /** Livestream room general FAQ ID. */
  id: Scalars['ID']['input'];
};

/** Input for attaching a livestream room general FAQ's custom-video comment action after upload completes. */
export type LivestreamRoomGeneralFaqCustomVideoUpdateInput = {
  /** Livestream room general FAQ ID. */
  id: Scalars['ID']['input'];
  /** GCS object key returned by the upload mutation (gs:// format). Omit to keep the FAQ's currently-attached video and only update replacementScript — the FAQ must already have a video attached. */
  objectKey?: InputMaybe<Scalars['String']['input']>;
  /** Replacement script text, at most 500 characters. When set, the video plays this script's TTS instead of its own audio; when omitted, the video plays its own audio track. */
  replacementScript?: InputMaybe<Scalars['String']['input']>;
};

/** Input for generating a signed URL for livestream room general FAQ custom video upload. */
export type LivestreamRoomGeneralFaqCustomVideoUploadInput = {
  /** Name of the video file to be uploaded. */
  fileName: Scalars['String']['input'];
  /** Livestream room general FAQ ID. */
  id: Scalars['ID']['input'];
  /** MIME type of the video file. */
  mimeType: LivestreamRoomFaqVideoSupportedMimeType;
};

/** Bulk delete input for livestream room general FAQs. */
export type LivestreamRoomGeneralFaqDeleteBulkInput = {
  ids: Array<Scalars['ID']['input']>;
};

/** Livestream room general FAQ type. */
export type LivestreamRoomGeneralFaqGql = {
  __typename?: 'LivestreamRoomGeneralFaqGql';
  /** The spoken text of the generated answer audio, one entry per tts_sentence row in sentence order. replacedText is null when no pronunciation rule applied to that sentence — display text falls back to text rather than an empty line. Empty until ttsGenerationId's audio completes, and always empty when the answer audio was uploaded rather than generated. */
  answerSentences: Array<TtsSentenceClipOutput>;
  createdAt: Scalars['DateTime']['output'];
  /** Derived from whether customVideoReplacementScript is set (REPLACEMENT_TEXT when present, ORIGINAL when absent); null when no custom video is attached. */
  customVideoAudioMode?: Maybe<FaqCustomVideoAudioMode>;
  /** Advisory only: since a General FAQ belongs to no product, true unless every product scene in the room is saturated — a BACKGROUND_VIDEO and a CLOSE_UP each occupy one of a scene's at most two compositor video layers. False does not block attaching a custom video; the worker's runtime check is final. */
  customVideoHasAdvisoryCapacity: Scalars['Boolean']['output'];
  /** True when customVideoReplacementScript or the room's voice/speed/pitch/emotion has changed since customVideoTtsGenerationId's audio was generated. Always false when no custom video is attached or its audio has never been generated. */
  customVideoIsStale: Scalars['Boolean']['output'];
  customVideoReplacementScript?: Maybe<Scalars['String']['output']>;
  /** Signed download URL for the attached custom video, or null when none is attached. */
  customVideoSignedUrl?: Maybe<Scalars['Url']['output']>;
  /** TTS generation ID for the custom video's replacement script audio, when generated. Poll status/signed URL via Query.ttsInfo(ttsId) or Query.ttsInfos(ttsIds, contentType: FAQ_CUSTOM_VIDEO_SCRIPT). */
  customVideoTtsGenerationId?: Maybe<Scalars['ID']['output']>;
  /** Null means hand-written; non-null (e.g. "room-overview") means this FAQ was drafted by Generate FAQ and is safe to regenerate. There is no mutation that sets this — only the generator. */
  generationKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** True when voiceReplyText or the room's voice/speed/pitch/emotion has changed since ttsGenerationId's audio was generated. Always false when the answer audio was uploaded rather than generated. */
  isStale: Scalars['Boolean']['output'];
  roomId: Scalars['ID']['output'];
  switchProductId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use the custom-video asset metadata (customVideoAudioMode, customVideoSignedUrl). */
  switchVideoUrl?: Maybe<Scalars['String']['output']>;
  /** Posted to chat -- independent of voiceReplyText. */
  textReply?: Maybe<Scalars['String']['output']>;
  triggerWords: Array<Scalars['String']['output']>;
  /** TTS generation ID for this FAQ's answer audio, when generated rather than uploaded. Mutually exclusive with voiceReplyUrl. Poll status/signed URL via Query.ttsInfo(ttsId) or Query.ttsInfos(ttsIds, contentType: ROOM_GENERAL_FAQ). */
  ttsGenerationId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  voiceReplySignedUrl?: Maybe<Scalars['Url']['output']>;
  /** TTS source text -- what ttsGenerationId's audio is generated from. Independent of textReply. */
  voiceReplyText?: Maybe<Scalars['String']['output']>;
  /** Uploaded voice reply URL. Mutually exclusive with ttsGenerationId — set only when the audio was uploaded rather than generated. */
  voiceReplyUrl?: Maybe<Scalars['String']['output']>;
};

/** Output type for a livestream room general FAQ. */
export type LivestreamRoomGeneralFaqOutput = {
  __typename?: 'LivestreamRoomGeneralFaqOutput';
  /** Livestream room general FAQ ID. */
  id: Scalars['ID']['output'];
  livestreamRoomGeneralFaq?: Maybe<LivestreamRoomGeneralFaqGql>;
};

/** Input for generating or regenerating a livestream room general FAQ's answer audio. */
export type LivestreamRoomGeneralFaqTtsGenerateInput = {
  /** Livestream room general FAQ ID. */
  id: Scalars['ID']['input'];
};

/** Update input for a livestream room general FAQ. */
export type LivestreamRoomGeneralFaqUpdateInput = {
  id: Scalars['ID']['input'];
  switchProductId?: InputMaybe<Scalars['ID']['input']>;
  textReply?: InputMaybe<Scalars['String']['input']>;
  triggerWords: Array<Scalars['String']['input']>;
  voiceReplyText?: InputMaybe<Scalars['String']['input']>;
};

/** Input for removing the voice reply audio of a livestream room general FAQ. */
export type LivestreamRoomGeneralFaqVoiceRemoveInput = {
  /** Livestream room general FAQ ID. */
  id: Scalars['ID']['input'];
};

/** Input for generating a signed URL for livestream room general FAQ voice reply audio upload. */
export type LivestreamRoomGeneralFaqVoiceUploadInput = {
  /** Name of the audio file to be uploaded. */
  fileName: Scalars['String']['input'];
  /** Livestream room general FAQ ID. */
  id: Scalars['ID']['input'];
  /** MIME type of the audio file. */
  mimeType: LivestreamRoomFaqAudioSupportedMimeType;
};

/** Input for saving the voice reply URL of a livestream room general FAQ after audio upload. */
export type LivestreamRoomGeneralFaqVoiceUrlUpdateInput = {
  /** Livestream room general FAQ ID. */
  id: Scalars['ID']['input'];
  /** GCS URL of the uploaded audio file (gs:// format). */
  voiceReplyUrl: Scalars['String']['input'];
};

/** Livestream room type. */
export type LivestreamRoomGql = {
  __typename?: 'LivestreamRoomGql';
  accountId: Scalars['ID']['output'];
  activeSession?: Maybe<ActiveSessionOutput>;
  /** The room's WELCOME and TIMED atmosphere timers, each with its own settings and scripts. */
  atmosphereGuidance: AtmosphereGuidanceGql;
  /** Minutes to wait before a comment-triggered product switch takes effect again (0 = no limit). Read at compose time; changes take effect after restarting the stream. */
  commentSwitchProductCooldownMinutes: Scalars['Int']['output'];
  /** Minutes to wait before a comment-triggered custom-video switch takes effect again (0 = no limit). Read at compose time; changes take effect after restarting the stream. */
  commentSwitchVideoCooldownMinutes: Scalars['Int']['output'];
  /** AI reply conversion mode controlling how aggressively the AI pursues purchase intent. */
  conversionReplyMode: ConversionReplyMode;
  createdAt: Scalars['DateTime']['output'];
  /** Sliding window in minutes for duplicate-comment suppression (0 = no suppression). */
  duplicateMemoryWindowMinutes: Scalars['Int']['output'];
  /** User-facing error message shown when status is FAILED (e.g. after a failed compose); null otherwise. */
  errorMsg?: Maybe<Scalars['String']['output']>;
  /** Per-room confidence cutoff at or above which a semantic FAQ match counts as a hit. Matching uses an inclusive `>=` rule, so an exactly-equal score is a FAQ hit. Range [0.0, 1.0] inclusive, NaN/±Infinity rejected. A room with no threshold set reports the default (0.8), which is also the threshold its matching applies. */
  faqConfidenceThreshold: Scalars['Float']['output'];
  /** Status of this room's async Generate FAQ run — one Global FAQ plus every product FAQ, drafted together. Null means never generated. */
  faqGenerationStatus?: Maybe<LiveAssetFaqGenerationStatus>;
  /** Whether every Global FAQ and Product FAQ answer in this room is spoken, posted as text, or both. A separate setting from llmReplyMode. */
  faqReplyMode: RoomReplyMode;
  generalFaqs: Array<LivestreamRoomGeneralFaqGql>;
  hostIdentity?: Maybe<Scalars['String']['output']>;
  hostIdentityType?: Maybe<HostIdentityType>;
  id: Scalars['ID']['output'];
  knowledgeBase?: Maybe<Scalars['String']['output']>;
  liveObjective?: Maybe<Scalars['String']['output']>;
  liveObjectiveType?: Maybe<LiveObjectiveType>;
  liveTimeSlotType?: Maybe<LiveTimeSlotType>;
  llmConfig?: Maybe<LivestreamRoomLlmConfigGql>;
  /** Master switch for whether the LLM Reply pipeline runs at all — distinct from llmReplyMode, which only decides how an answer already generated is delivered. Off beats any mode. Changes take effect after restarting the stream. */
  llmReplyEnabled: Scalars['Boolean']['output'];
  /** Whether every generated LLM answer in this room is spoken, posted as text, or both. A separate setting from faqReplyMode. */
  llmReplyMode: RoomReplyMode;
  /** Fallback strategy when conversion is below threshold. */
  lowConversionStrategy: LowConversionStrategy;
  name: Scalars['String']['output'];
  /** Short-lived signed GCS URL of the room's first product's saved decoration preview image; null when the room has no products or the first product has no saved preview. */
  previewUrl?: Maybe<Scalars['Url']['output']>;
  products: Array<LivestreamRoomProductGql>;
  /** Master switch for whether Q&A opening/closing scripts play at all, covering both kinds. Read at compose time; changes take effect after restarting the stream. */
  qaScriptsEnabled: Scalars['Boolean']['output'];
  replyTimingType: ReplyTimingType;
  /** Room content language (issue #322). Fixed at room creation, read-only thereafter; null only for legacy rooms created before the column existed. The Voice Clone dropdown on the Set Live Content screen lists only completed voice clones matching this language. */
  roomLanguage?: Maybe<TtsAudioLanguage>;
  salesChannelType: SalesChannelType;
  sellerRegion: AnyLiveRegion;
  status: LivestreamRoomStatus;
  store?: Maybe<MdStore>;
  storeId: Scalars['ID']['output'];
  /** Maximum trigger frequency for text replies in seconds (0 = every comment). */
  textReplyMaxTrigger: Scalars['Int']['output'];
  /** Q&A opening and closing scripts, with counts per kind. */
  transitionQaScripts: TransitionQaScriptList;
  /** Transition scripts for inter-product commentary, ordered for playback. */
  transitionScripts: Array<TransitionScriptGql>;
  unmatchedFaqs: Array<LivestreamRoomUnmatchedFaqGql>;
  updatedAt: Scalars['DateTime']['output'];
  /** Room voice settings — the one voice/speed/pitch/emotion reused by Q&A scripts, atmosphere, closing scripts, FAQ audio and LLM voice replies. */
  voiceConfig?: Maybe<LivestreamRoomVoiceConfigGql>;
  /** Maximum trigger frequency for voice replies in seconds (0 = every comment). */
  voiceReplyMaxTrigger: Scalars['Int']['output'];
};

/** Update input for a livestream room knowledge base. */
export type LivestreamRoomKnowledgeBaseUpdateInput = {
  /** Free-text description of the host identity. Omit to leave unchanged, send null to clear. */
  hostIdentity?: InputMaybe<Scalars['String']['input']>;
  /** The host identity type. Omit to leave unchanged, send null to clear. */
  hostIdentityType?: InputMaybe<HostIdentityType>;
  /** The ID of the livestream room to update. */
  id: Scalars['ID']['input'];
  /** The knowledge base content for the livestream room. Omit to leave unchanged, send null to clear. */
  knowledgeBase?: InputMaybe<Scalars['String']['input']>;
  /** Free-text description of the live objective. Omit to leave unchanged, send null to clear. */
  liveObjective?: InputMaybe<Scalars['String']['input']>;
  /** The live objective type. Omit to leave unchanged, send null to clear. */
  liveObjectiveType?: InputMaybe<LiveObjectiveType>;
  /** The live time slot type. Omit to leave unchanged, send null to clear. */
  liveTimeSlotType?: InputMaybe<LiveTimeSlotType>;
};

/** Input for setting a legacy livestream room's language exactly once, on a room in the caller's stores; refused once the room already has a language, on a LIVE or PROVISIONING room, or when the language has no completed voice clone yet. */
export type LivestreamRoomLanguageSetInput = {
  /** The ID of the livestream room to set the language for. */
  id: Scalars['ID']['input'];
  /** The language to set. Must have at least one completed voice clone. */
  language: TtsAudioLanguage;
};

/** Payload returned after setting a legacy livestream room's language. */
export type LivestreamRoomLanguageSetPayload = {
  __typename?: 'LivestreamRoomLanguageSetPayload';
  /** Livestream room ID. */
  id: Scalars['ID']['output'];
  livestreamRoom?: Maybe<LivestreamRoomGql>;
};

/** Livestream room list type. */
export type LivestreamRoomList = PaginatedList & {
  __typename?: 'LivestreamRoomList';
  items: Array<LivestreamRoomGql>;
  totalCount: Scalars['Int']['output'];
};

/** LLM Reply configuration for a livestream room. */
export type LivestreamRoomLlmConfigGql = {
  __typename?: 'LivestreamRoomLlmConfigGql';
  additionalInstructions?: Maybe<Scalars['String']['output']>;
  aiReplyRule?: Maybe<Scalars['String']['output']>;
  brandPersonality: Array<Scalars['String']['output']>;
  expertise?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxCharacters?: Maybe<Scalars['Int']['output']>;
  maxSentences?: Maybe<Scalars['Int']['output']>;
  model: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
  roomId: Scalars['ID']['output'];
  tone?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use LivestreamRoom.voiceConfig.voiceClone */
  voiceClone?: Maybe<TtsVoiceClone>;
  /** @deprecated Use LivestreamRoom.voiceConfig */
  voiceCloneId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use LivestreamRoom.voiceConfig */
  voiceEmotion?: Maybe<TtsEmotion>;
  /** @deprecated Use LivestreamRoom.voiceConfig */
  voicePitch: Scalars['Int']['output'];
  /** @deprecated Use LivestreamRoom.voiceConfig */
  voiceSpeed: Scalars['Float']['output'];
};

/** Input for upserting LLM Reply configuration on a livestream room. */
export type LivestreamRoomLlmConfigUpsertInput = {
  /** Optional additional prompt instructions. Omit to leave unchanged, send null to clear. */
  additionalInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Legacy freetext AI reply style/tone instructions. Omit to leave unchanged, send null to clear. */
  aiReplyRule?: InputMaybe<Scalars['String']['input']>;
  /** Brand personality traits (max 3). Omitted, the room keeps the traits it has. */
  brandPersonality?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Digital human expertise description. Omit to leave unchanged, send null to clear. */
  expertise?: InputMaybe<Scalars['String']['input']>;
  /** Maximum characters per reply. Omit to leave unchanged, send null to clear. */
  maxCharacters?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum sentences per reply (1–4). Omit to leave unchanged, send null to clear. */
  maxSentences?: InputMaybe<Scalars['Int']['input']>;
  /** LLM model to use. Omitted, the room keeps the model it has. */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Digital human role description. Omit to leave unchanged, send null to clear. */
  role?: InputMaybe<Scalars['String']['input']>;
  /** ID of the livestream room. */
  roomId: Scalars['ID']['input'];
  /** Response tone style. Omit to leave unchanged, send null to clear. */
  tone?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a livestream room's LLM Reply master switch. STAFF/ADMIN only; rooms in LIVE or PROVISIONING reject with FAILED_PRECONDITION. */
export type LivestreamRoomLlmReplyEnabledUpdateInput = {
  /** Whether the LLM Reply pipeline runs at all. */
  enabled: Scalars['Boolean']['input'];
  /** The ID of the livestream room to update. */
  id: Scalars['ID']['input'];
};

/** Payload returned after updating a livestream room's LLM Reply master switch. */
export type LivestreamRoomLlmReplyEnabledUpdatePayload = {
  __typename?: 'LivestreamRoomLlmReplyEnabledUpdatePayload';
  /** Livestream room ID. */
  id: Scalars['ID']['output'];
  livestreamRoom?: Maybe<LivestreamRoomGql>;
};

/** Input for updating a livestream room's LLM Reply Mode. STAFF/ADMIN only; rooms in LIVE or PROVISIONING reject with FAILED_PRECONDITION. */
export type LivestreamRoomLlmReplyModeUpdateInput = {
  /** The ID of the livestream room to update. */
  id: Scalars['ID']['input'];
  /** Whether every generated LLM answer in this room is spoken, posted as text, or both. */
  replyMode: RoomReplyMode;
};

/** Payload returned after updating a livestream room's LLM Reply Mode. */
export type LivestreamRoomLlmReplyModeUpdatePayload = {
  __typename?: 'LivestreamRoomLlmReplyModeUpdatePayload';
  /** Livestream room ID. */
  id: Scalars['ID']['output'];
  livestreamRoom?: Maybe<LivestreamRoomGql>;
};

/** Output type for a livestream room. */
export type LivestreamRoomOutput = {
  __typename?: 'LivestreamRoomOutput';
  /** Livestream room ID. */
  id: Scalars['ID']['output'];
  livestreamRoom?: Maybe<LivestreamRoomGql>;
};

/** Supported MIME types for livestream room product cover image uploads. */
export const LivestreamRoomProductCoverImageSupportedMimeType = {
  /** image/jpeg (.jpg, .jpeg) */
  IMAGE_JPEG: 'IMAGE_JPEG',
  /** image/png (.png) */
  IMAGE_PNG: 'IMAGE_PNG',
  /** image/webp (.webp) */
  IMAGE_WEBP: 'IMAGE_WEBP'
} as const;

export type LivestreamRoomProductCoverImageSupportedMimeType = typeof LivestreamRoomProductCoverImageSupportedMimeType[keyof typeof LivestreamRoomProductCoverImageSupportedMimeType];
/** Input for generating a signed URL for livestream room product cover image upload. */
export type LivestreamRoomProductCoverUrlUploadInput = {
  /** Name of the cover image file to be uploaded. */
  fileName: Scalars['String']['input'];
  /** MIME type of the cover image file. */
  mimeType: LivestreamRoomProductCoverImageSupportedMimeType;
};

/** Output containing the signed URL for livestream room product cover image upload. */
export type LivestreamRoomProductCoverUrlUploadOutput = {
  __typename?: 'LivestreamRoomProductCoverUrlUploadOutput';
  /** GCS URL to pass into the create mutation as productCoverUrl after the upload completes. */
  coverUrl: Scalars['String']['output'];
  /** Signed URL for uploading the cover image file. */
  signedUrl: Scalars['Url']['output'];
};

/** Create input for a livestream room product. */
export type LivestreamRoomProductCreateInput = {
  livestreamRoomId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  productCoverUrl?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  /** Product page link, used to ground FAQ generation. */
  url?: InputMaybe<Scalars['Url']['input']>;
};

/** Bulk delete input for livestream room products. */
export type LivestreamRoomProductDeleteBulkInput = {
  ids: Array<Scalars['ID']['input']>;
};

/** Bulk create input for livestream room product FAQs. Each item specifies its own target product and is processed atomically. */
export type LivestreamRoomProductFaqBulkCreateInput = {
  items: Array<LivestreamRoomProductFaqBulkCreateItemInput>;
};

/** Single item input for bulk create of livestream room product FAQs. */
export type LivestreamRoomProductFaqBulkCreateItemInput = {
  livestreamRoomProductId: Scalars['ID']['input'];
  switchProductId?: InputMaybe<Scalars['ID']['input']>;
  switchVideoUrl?: InputMaybe<Scalars['String']['input']>;
  textReply?: InputMaybe<Scalars['String']['input']>;
  triggerWords: Array<Scalars['String']['input']>;
  voiceReplyText?: InputMaybe<Scalars['String']['input']>;
  voiceReplyUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Create input for a livestream room product FAQ. */
export type LivestreamRoomProductFaqCreateInput = {
  livestreamRoomProductId: Scalars['ID']['input'];
  switchProductId?: InputMaybe<Scalars['ID']['input']>;
  switchVideoUrl?: InputMaybe<Scalars['String']['input']>;
  textReply?: InputMaybe<Scalars['String']['input']>;
  triggerWords: Array<Scalars['String']['input']>;
  voiceReplyText?: InputMaybe<Scalars['String']['input']>;
  voiceReplyUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Input for removing the custom-video comment action of a livestream room product FAQ. */
export type LivestreamRoomProductFaqCustomVideoRemoveInput = {
  /** Livestream room product FAQ ID. */
  id: Scalars['ID']['input'];
};

/** Input for generating or regenerating a livestream room product FAQ's custom-video replacement-script audio. */
export type LivestreamRoomProductFaqCustomVideoTtsGenerateInput = {
  /** Livestream room product FAQ ID. */
  id: Scalars['ID']['input'];
};

/** Input for attaching a livestream room product FAQ's custom-video comment action after upload completes. */
export type LivestreamRoomProductFaqCustomVideoUpdateInput = {
  /** Livestream room product FAQ ID. */
  id: Scalars['ID']['input'];
  /** GCS object key returned by the upload mutation (gs:// format). Omit to keep the FAQ's currently-attached video and only update replacementScript — the FAQ must already have a video attached. */
  objectKey?: InputMaybe<Scalars['String']['input']>;
  /** Replacement script text, at most 500 characters. When set, the video plays this script's TTS instead of its own audio; when omitted, the video plays its own audio track. */
  replacementScript?: InputMaybe<Scalars['String']['input']>;
};

/** Input for generating a signed URL for livestream room product FAQ custom video upload. */
export type LivestreamRoomProductFaqCustomVideoUploadInput = {
  /** Name of the video file to be uploaded. */
  fileName: Scalars['String']['input'];
  /** Livestream room product FAQ ID. */
  id: Scalars['ID']['input'];
  /** MIME type of the video file. */
  mimeType: LivestreamRoomFaqVideoSupportedMimeType;
};

/** Bulk delete input for livestream room product FAQs. */
export type LivestreamRoomProductFaqDeleteBulkInput = {
  ids: Array<Scalars['ID']['input']>;
};

/** Livestream room product FAQ type. */
export type LivestreamRoomProductFaqGql = {
  __typename?: 'LivestreamRoomProductFaqGql';
  /** The spoken text of the generated answer audio, one entry per tts_sentence row in sentence order. replacedText is null when no pronunciation rule applied to that sentence — display text falls back to text rather than an empty line. Empty until ttsGenerationId's audio completes, and always empty when the answer audio was uploaded rather than generated. */
  answerSentences: Array<TtsSentenceClipOutput>;
  createdAt: Scalars['DateTime']['output'];
  /** Derived from whether customVideoReplacementScript is set (REPLACEMENT_TEXT when present, ORIGINAL when absent); null when no custom video is attached. */
  customVideoAudioMode?: Maybe<FaqCustomVideoAudioMode>;
  /** Advisory only: whether this product's scene currently has a free compositor video layer for a custom video — a BACKGROUND_VIDEO and a CLOSE_UP each occupy one of at most two. False does not block attaching a custom video; the worker's runtime check is final. */
  customVideoHasAdvisoryCapacity: Scalars['Boolean']['output'];
  /** True when customVideoReplacementScript or the room's voice/speed/pitch/emotion has changed since customVideoTtsGenerationId's audio was generated. Always false when no custom video is attached or its audio has never been generated. */
  customVideoIsStale: Scalars['Boolean']['output'];
  customVideoReplacementScript?: Maybe<Scalars['String']['output']>;
  /** Signed download URL for the attached custom video, or null when none is attached. */
  customVideoSignedUrl?: Maybe<Scalars['Url']['output']>;
  /** TTS generation ID for the custom video's replacement script audio, when generated. Poll status/signed URL via Query.ttsInfo(ttsId) or Query.ttsInfos(ttsIds, contentType: FAQ_CUSTOM_VIDEO_SCRIPT). */
  customVideoTtsGenerationId?: Maybe<Scalars['ID']['output']>;
  /** Null means hand-written; non-null (e.g. "product-highlights:42") means this FAQ was drafted by Generate FAQ and is safe to regenerate. There is no mutation that sets this — only the generator. */
  generationKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** True when voiceReplyText or the room's voice/speed/pitch/emotion has changed since ttsGenerationId's audio was generated. Always false when the answer audio was uploaded rather than generated. */
  isStale: Scalars['Boolean']['output'];
  productId: Scalars['ID']['output'];
  switchProductId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use the custom-video asset metadata (customVideoAudioMode, customVideoSignedUrl). */
  switchVideoUrl?: Maybe<Scalars['String']['output']>;
  /** Posted to chat -- independent of voiceReplyText. */
  textReply?: Maybe<Scalars['String']['output']>;
  triggerWords: Array<Scalars['String']['output']>;
  /** TTS generation ID for this FAQ's answer audio, when generated rather than uploaded. Mutually exclusive with voiceReplyUrl. Poll status/signed URL via Query.ttsInfo(ttsId) or Query.ttsInfos(ttsIds, contentType: ROOM_PRODUCT_FAQ). */
  ttsGenerationId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  voiceReplySignedUrl?: Maybe<Scalars['Url']['output']>;
  /** TTS source text -- what ttsGenerationId's audio is generated from. Independent of textReply. */
  voiceReplyText?: Maybe<Scalars['String']['output']>;
  /** Uploaded voice reply URL. Mutually exclusive with ttsGenerationId — set only when the audio was uploaded rather than generated. */
  voiceReplyUrl?: Maybe<Scalars['String']['output']>;
};

/** Output type for a livestream room product FAQ. */
export type LivestreamRoomProductFaqOutput = {
  __typename?: 'LivestreamRoomProductFaqOutput';
  /** Livestream room product FAQ ID. */
  id: Scalars['ID']['output'];
  livestreamRoomProductFaq?: Maybe<LivestreamRoomProductFaqGql>;
};

/** Input for reassigning a product FAQ to a different product. */
export type LivestreamRoomProductFaqReassignInput = {
  id: Scalars['ID']['input'];
  toProductId: Scalars['ID']['input'];
};

/** Input for moving a product FAQ to the unmatched section. */
export type LivestreamRoomProductFaqSendToUnmatchedInput = {
  id: Scalars['ID']['input'];
};

/** Input for generating or regenerating a livestream room product FAQ's answer audio. */
export type LivestreamRoomProductFaqTtsGenerateInput = {
  /** Livestream room product FAQ ID. */
  id: Scalars['ID']['input'];
};

/** Update input for a livestream room product FAQ. */
export type LivestreamRoomProductFaqUpdateInput = {
  id: Scalars['ID']['input'];
  switchProductId?: InputMaybe<Scalars['ID']['input']>;
  textReply?: InputMaybe<Scalars['String']['input']>;
  triggerWords: Array<Scalars['String']['input']>;
  voiceReplyText?: InputMaybe<Scalars['String']['input']>;
};

/** Input for removing the voice reply audio of a livestream room product FAQ. */
export type LivestreamRoomProductFaqVoiceRemoveInput = {
  /** Livestream room product FAQ ID. */
  id: Scalars['ID']['input'];
};

/** Input for generating a signed URL for livestream room product FAQ voice reply audio upload. */
export type LivestreamRoomProductFaqVoiceUploadInput = {
  /** Name of the audio file to be uploaded. */
  fileName: Scalars['String']['input'];
  /** Livestream room product FAQ ID. */
  id: Scalars['ID']['input'];
  /** MIME type of the audio file. */
  mimeType: LivestreamRoomFaqAudioSupportedMimeType;
};

/** Input for saving the voice reply URL of a livestream room product FAQ after audio upload. */
export type LivestreamRoomProductFaqVoiceUrlUpdateInput = {
  /** Livestream room product FAQ ID. */
  id: Scalars['ID']['input'];
  /** GCS URL of the uploaded audio file (gs:// format). */
  voiceReplyUrl: Scalars['String']['input'];
};

/** Livestream room product type. */
export type LivestreamRoomProductGql = {
  __typename?: 'LivestreamRoomProductGql';
  avatarId?: Maybe<Scalars['ID']['output']>;
  /** Trained avatar look fronting this product, by training-video id. Always one of the avatar's `subVideos`; a `mainVideo` id only on products pinned before the main video stopped being selectable. */
  avatarTrainingVideoId?: Maybe<Scalars['ID']['output']>;
  /** Role of the assigned look (MAIN/SUB), from the training video; null when no avatar is assigned. */
  avatarType?: Maybe<TrainingVideoRole>;
  /** Short-lived signed GCS URL of the product's assigned look's video; null when no look is assigned. */
  avatarVideoSignedUrl?: Maybe<Scalars['Url']['output']>;
  /** Whether a close-up video can currently be set on this product's paragraphs. False when the product's foreground decoration videos (VIDEO layers above the avatar) already fill the foreground video quota (2), leaving no slot for the playing close-up. Independent of how many paragraphs already carry a close-up — only one plays at a time. Drives the Close-up Video button state so clients need no per-product decoration queries. */
  canAddCloseupVideo: Scalars['Boolean']['output'];
  coverSignedUrl?: Maybe<Scalars['Url']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Short-lived signed GCS URL of the product's saved decoration preview image; null when no preview has been saved (the client then falls back to the avatar thumbnail). */
  decorationPreviewUrl?: Maybe<Scalars['Url']['output']>;
  faqs: Array<LivestreamRoomProductFaqGql>;
  id: Scalars['ID']['output'];
  /** Lip-sync mode of the assigned look (ORIGINAL/UNIVERSAL); null when no avatar is assigned. */
  lipSyncMode?: Maybe<LipSyncMode>;
  llmProductKnowledge?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  paragraphs: Array<LivestreamRoomProductParagraphGql>;
  productCoverUrl?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  roomId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Product page link, used to ground FAQ generation; null when not set. */
  url?: Maybe<Scalars['Url']['output']>;
};

/** Input for updating LLM product knowledge on a room product. */
export type LivestreamRoomProductLlmKnowledgeUpdateInput = {
  /** Product knowledge text for LLM prompts. Null clears the field. */
  llmProductKnowledge?: InputMaybe<Scalars['String']['input']>;
  /** ID of the room product. */
  roomProductId: Scalars['ID']['input'];
};

/** Output type for a livestream room product. */
export type LivestreamRoomProductOutput = {
  __typename?: 'LivestreamRoomProductOutput';
  /** Livestream room product ID. */
  id: Scalars['ID']['output'];
  livestreamRoomProduct?: Maybe<LivestreamRoomProductGql>;
};

/** Input for deleting the audio of a livestream room product paragraph. */
export type LivestreamRoomProductParagraphAudioDeleteInput = {
  /** Livestream room product paragraph ID. */
  id: Scalars['ID']['input'];
};

/** Create input for a livestream room product paragraph. */
export type LivestreamRoomProductParagraphCreateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  livestreamRoomProductId: Scalars['ID']['input'];
};

/** Bulk delete input for livestream room product paragraphs. */
export type LivestreamRoomProductParagraphDeleteBulkInput = {
  ids: Array<Scalars['ID']['input']>;
};

/** Livestream room product paragraph type. */
export type LivestreamRoomProductParagraphGql = {
  __typename?: 'LivestreamRoomProductParagraphGql';
  audioUrl?: Maybe<Scalars['String']['output']>;
  closeupVideoUrl?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Output type for a livestream room product paragraph. */
export type LivestreamRoomProductParagraphOutput = {
  __typename?: 'LivestreamRoomProductParagraphOutput';
  /** Livestream room product paragraph ID. */
  id: Scalars['ID']['output'];
  livestreamRoomProductParagraph?: Maybe<LivestreamRoomProductParagraphGql>;
};

/** Input for reordering livestream room product paragraphs. */
export type LivestreamRoomProductParagraphReorderInput = {
  /** The ID of the livestream room product. */
  livestreamRoomProductId: Scalars['ID']['input'];
  /** Ordered list of paragraph IDs representing the desired order. */
  livestreamRoomProductParagraphIds: Array<Scalars['String']['input']>;
};

/** Update input for a livestream room product paragraph. */
export type LivestreamRoomProductParagraphUpdateInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** Input for deleting the closeup video of a livestream room product paragraph. */
export type LivestreamRoomProductParagraphVideoDeleteInput = {
  /** Optional GCS object key of a merged-layers preview image (from livestreamRoomDecorationPreviewUpload) rendered without this close-up, persisted to the product atomically with the deletion. When omitted/null the product's stored preview is CLEARED — this mutation changes the canvas, so the previous preview no longer matches (unlike livestreamRoomDecorationSave, where omitting keeps it). */
  decorationPreviewGcsObjectKey?: InputMaybe<Scalars['String']['input']>;
  /** Livestream room product paragraph ID. */
  id: Scalars['ID']['input'];
};

/** Supported MIME types for livestream room product paragraph video uploads. */
export const LivestreamRoomProductParagraphVideoSupportedMimeType = {
  /** video/mp4 (.mp4) */
  VIDEO_MP4: 'VIDEO_MP4'
} as const;

export type LivestreamRoomProductParagraphVideoSupportedMimeType = typeof LivestreamRoomProductParagraphVideoSupportedMimeType[keyof typeof LivestreamRoomProductParagraphVideoSupportedMimeType];
/** Input for generating a signed URL for livestream room product paragraph video upload. */
export type LivestreamRoomProductParagraphVideoUploadInput = {
  /** Name of the video file to be uploaded. */
  fileName: Scalars['String']['input'];
  /** Livestream room product paragraph ID. */
  id: Scalars['ID']['input'];
  /** MIME type of the video file. */
  mimeType: LivestreamRoomProductParagraphVideoSupportedMimeType;
};

/** Output containing the signed URL for livestream room product paragraph video upload. */
export type LivestreamRoomProductParagraphVideoUploadOutput = {
  __typename?: 'LivestreamRoomProductParagraphVideoUploadOutput';
  /** GCS URL to store in the database after the upload completes. */
  closeupVideoUrl: Scalars['String']['output'];
  /** Signed URL for uploading the video file. */
  signedUrl: Scalars['Url']['output'];
};

/** Input for saving the closeup video URL of a livestream room product paragraph. */
export type LivestreamRoomProductParagraphVideoUrlUpdateInput = {
  /** GCS URL of the uploaded closeup video file (gs:// format). */
  closeupVideoUrl: Scalars['String']['input'];
  /** Optional GCS object key of a merged-layers preview image (from livestreamRoomDecorationPreviewUpload) rendered to include this close-up, persisted to the product atomically with the video change. When omitted/null the product's stored preview is CLEARED — this mutation changes the canvas, so the previous preview no longer matches (unlike livestreamRoomDecorationSave, where omitting keeps it). */
  decorationPreviewGcsObjectKey?: InputMaybe<Scalars['String']['input']>;
  /** Livestream room product paragraph ID. */
  id: Scalars['ID']['input'];
};

/** Input for reordering livestream room products. */
export type LivestreamRoomProductReorderInput = {
  /** The ID of the livestream room. */
  livestreamRoomId: Scalars['ID']['input'];
  /** Ordered list of product IDs. order_index is assigned by position in this list. Products absent from the list keep their current order_index. */
  livestreamRoomProductIds: Array<Scalars['String']['input']>;
};

/** Replace input for a livestream room product slot. */
export type LivestreamRoomProductReplaceInput = {
  /** The room product slot to replace (LivestreamRoomProductGql.id). It keeps its id, and with it its scripts, FAQs, decorations, avatar and position in the room. */
  id: Scalars['ID']['input'];
  /** The replacement product's name. Required and non-blank. */
  name: Scalars['String']['input'];
  /** The replacement's cover: the platform's own image URL, or the `gs://` key returned by livestreamRoomProductCoverUrlUpload. Absolute: null or blank clears the stored cover. */
  productCoverUrl?: InputMaybe<Scalars['String']['input']>;
  /** The replacement's external catalogue id — the platform's product id, or momo's goodsCode. Absolute: null or blank makes the slot a blank product and clears the stored id. */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** The replacement's product page link, used to ground FAQ generation. Absolute: null clears the stored url. */
  url?: InputMaybe<Scalars['Url']['input']>;
};

/** Input for selecting an avatar for one or all products in a room. */
export type LivestreamRoomProductSelectAvatarInput = {
  /** The avatar to apply. If null, the avatar is cleared. */
  avatarId?: InputMaybe<Scalars['ID']['input']>;
  /** The product to update. If null, all products in the room are updated. */
  productId?: InputMaybe<Scalars['ID']['input']>;
  /** The room containing the products. */
  roomId: Scalars['ID']['input'];
};

/** Update input for a livestream room product. */
export type LivestreamRoomProductUpdateInput = {
  /** Trained avatar look to front this product, by training-video id (AvatarVideo.id). Required together with lipSyncMode while an avatar is assigned; omit both when no avatar. Must be one of the avatar's `subVideos` — the main video is not selectable, though a product already pinned to it may re-send that id. */
  avatarTrainingVideoId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  /** Lip-sync mode for the chosen look. Required together with avatarTrainingVideoId while an avatar is assigned. Must form a trained (look, mode) pair for the avatar. */
  lipSyncMode?: InputMaybe<LipSyncMode>;
  name: Scalars['String']['input'];
  /** Product page link, used to ground FAQ generation. Null clears it. */
  url?: InputMaybe<Scalars['Url']['input']>;
};

/** Input for updating a livestream room's Q&A scripts master switch. STAFF/ADMIN only; rooms in LIVE or PROVISIONING reject with FAILED_PRECONDITION. */
export type LivestreamRoomQaScriptsEnabledUpdateInput = {
  /** Whether Q&A opening/closing scripts play at all, for both kinds together. */
  enabled: Scalars['Boolean']['input'];
  /** The ID of the livestream room to update. */
  id: Scalars['ID']['input'];
};

/** Payload returned after updating a livestream room's Q&A scripts master switch. */
export type LivestreamRoomQaScriptsEnabledUpdatePayload = {
  __typename?: 'LivestreamRoomQaScriptsEnabledUpdatePayload';
  /** Livestream room ID. */
  id: Scalars['ID']['output'];
  livestreamRoom?: Maybe<LivestreamRoomGql>;
};

/** Input to select a scheduled Rakuten livestream for a live room */
export type LivestreamRoomRakutenLivestreamSelectInput = {
  /** The live room ID */
  id: Scalars['String']['input'];
  /** The Rakuten livestream ID to select */
  rakutenLiveId: Scalars['String']['input'];
};

/** Input for updating room-level reply trigger frequency. */
export type LivestreamRoomReplyFrequencyUpdateInput = {
  /** The ID of the livestream room to update. */
  id: Scalars['ID']['input'];
  /** Text reply max trigger frequency in minutes (0 = every comment). */
  textReplyMaxTrigger: Scalars['Int']['input'];
  /** Voice reply max trigger frequency in minutes (0 = every comment). */
  voiceReplyMaxTrigger: Scalars['Int']['input'];
};

/** Update input for livestream room reply timing. */
export type LivestreamRoomReplyTimingUpdateInput = {
  /** The ID of the livestream room to update. */
  id: Scalars['ID']['input'];
  /** The reply timing type. */
  replyTimingType: ReplyTimingType;
};

/** Input for updating the response strategy settings of a livestream room. */
export type LivestreamRoomResponseStrategyUpdateInput = {
  /** AI reply conversion mode. Null = no change. */
  conversionReplyMode?: InputMaybe<ConversionReplyMode>;
  /** Sliding window in minutes for duplicate-comment suppression. Null = no change. */
  duplicateMemoryWindowMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the livestream room to update. */
  id: Scalars['ID']['input'];
  /** Fallback strategy when conversion rate is below threshold. Null = no change. */
  lowConversionStrategy?: InputMaybe<LowConversionStrategy>;
};

/** Payload returned after updating a livestream room's response strategy. */
export type LivestreamRoomResponseStrategyUpdatePayload = {
  __typename?: 'LivestreamRoomResponseStrategyUpdatePayload';
  /** Livestream room ID. */
  id: Scalars['ID']['output'];
  livestreamRoom?: Maybe<LivestreamRoomGql>;
};

/** Shop account info for a livestream room. */
export type LivestreamRoomShopInfoOutput = {
  __typename?: 'LivestreamRoomShopInfoOutput';
  /** URL of the account avatar. Null for Rakuten rooms. */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** False when Meta does not offer Facebook Featured Links in the room's seller region, so manual products cannot be pinned there. Null when featured links never apply: non-Facebook rooms, Facebook USER connections, or the feature turned off. */
  facebookFeaturedLinksAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Facebook connection type. Non-null only for Facebook rooms: 'USER' for personal user accounts, 'PAGE' for Facebook pages. */
  facebookTargetType?: Maybe<FacebookTargetType>;
  /** The ID of the livestream room. */
  id: Scalars['ID']['output'];
  /** Earliest date by which the operator must re-authorize. Null for TikTok, Rakuten, and Facebook Page rooms. */
  reAuthorizationDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** Account display name. For TikTok: account username. For Rakuten: shop name. */
  userName: Scalars['String']['output'];
};

/** Product-set query result for a Shopee room. */
export type LivestreamRoomShopeeProductSetsOutput = {
  __typename?: 'LivestreamRoomShopeeProductSetsOutput';
  /** Saved product sets in the operator's preferred order. */
  sets: Array<ShopeeProductSetOutput>;
  /** True when the room is in Shopee Seller Center session mode and supports product sets. False for OAuth Shopee rooms and non-Shopee rooms. */
  supported: Scalars['Boolean']['output'];
};

/** Input for replacing a room's full product-set list. */
export type LivestreamRoomShopeeProductSetsSaveInput = {
  /** Livestream room ID. */
  livestreamRoomId: Scalars['ID']['input'];
  /** Ordered list of sets to attach (max 20; all setIds must be unique numeric strings). */
  sets: Array<ShopeeProductSetInput>;
};

/** Sort field for livestream rooms. */
export const LivestreamRoomSortField = {
  CREATED_AT: 'CREATED_AT',
  NAME: 'NAME',
  UPDATED_AT: 'UPDATED_AT'
} as const;

export type LivestreamRoomSortField = typeof LivestreamRoomSortField[keyof typeof LivestreamRoomSortField];
/** Sort input for livestream rooms. */
export type LivestreamRoomSortInput = {
  /** Default is descending. */
  direction?: InputMaybe<SortDirection>;
  /** Default is CREATED_AT. */
  field?: InputMaybe<LivestreamRoomSortField>;
};

export const LivestreamRoomStatus = {
  COMPLETED: 'COMPLETED',
  COMPOSED: 'COMPOSED',
  COMPOSING: 'COMPOSING',
  FAILED: 'FAILED',
  LIVE: 'LIVE',
  LIVE_ERROR: 'LIVE_ERROR',
  PENDING: 'PENDING',
  PROVISIONING: 'PROVISIONING',
  READY_FOR_LIVE: 'READY_FOR_LIVE'
} as const;

export type LivestreamRoomStatus = typeof LivestreamRoomStatus[keyof typeof LivestreamRoomStatus];
/** Input for assigning an unmatched FAQ to a product. */
export type LivestreamRoomUnmatchedFaqAssignToProductInput = {
  id: Scalars['ID']['input'];
  toProductId: Scalars['ID']['input'];
};

/** Bulk create input for livestream room unmatched FAQs. All items belong to the same room and are processed atomically. */
export type LivestreamRoomUnmatchedFaqBulkCreateInput = {
  items: Array<LivestreamRoomUnmatchedFaqBulkCreateItemInput>;
  livestreamRoomId: Scalars['ID']['input'];
};

/** Single item input for bulk create of livestream room unmatched FAQs. */
export type LivestreamRoomUnmatchedFaqBulkCreateItemInput = {
  switchProductId?: InputMaybe<Scalars['ID']['input']>;
  switchVideoUrl?: InputMaybe<Scalars['String']['input']>;
  textReply?: InputMaybe<Scalars['String']['input']>;
  triggerWords: Array<Scalars['String']['input']>;
  voiceReplyText?: InputMaybe<Scalars['String']['input']>;
  voiceReplyUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Create input for a livestream room unmatched FAQ. */
export type LivestreamRoomUnmatchedFaqCreateInput = {
  livestreamRoomId: Scalars['ID']['input'];
  switchProductId?: InputMaybe<Scalars['ID']['input']>;
  switchVideoUrl?: InputMaybe<Scalars['String']['input']>;
  textReply?: InputMaybe<Scalars['String']['input']>;
  triggerWords: Array<Scalars['String']['input']>;
  voiceReplyText?: InputMaybe<Scalars['String']['input']>;
  voiceReplyUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Bulk delete input for livestream room unmatched FAQs. */
export type LivestreamRoomUnmatchedFaqDeleteBulkInput = {
  ids: Array<Scalars['ID']['input']>;
};

/** Livestream room unmatched FAQ type. */
export type LivestreamRoomUnmatchedFaqGql = {
  __typename?: 'LivestreamRoomUnmatchedFaqGql';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  roomId: Scalars['ID']['output'];
  switchProductId?: Maybe<Scalars['ID']['output']>;
  switchVideoUrl?: Maybe<Scalars['String']['output']>;
  /** Posted to chat -- independent of voiceReplyText. */
  textReply?: Maybe<Scalars['String']['output']>;
  triggerWords: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  voiceReplySignedUrl?: Maybe<Scalars['Url']['output']>;
  /** TTS source text -- independent of textReply. */
  voiceReplyText?: Maybe<Scalars['String']['output']>;
  voiceReplyUrl?: Maybe<Scalars['String']['output']>;
};

/** Output type for a livestream room unmatched FAQ. */
export type LivestreamRoomUnmatchedFaqOutput = {
  __typename?: 'LivestreamRoomUnmatchedFaqOutput';
  /** Livestream room unmatched FAQ ID. */
  id: Scalars['ID']['output'];
  livestreamRoomUnmatchedFaq?: Maybe<LivestreamRoomUnmatchedFaqGql>;
};

/** Update input for a livestream room unmatched FAQ. */
export type LivestreamRoomUnmatchedFaqUpdateInput = {
  id: Scalars['ID']['input'];
  textReply?: InputMaybe<Scalars['String']['input']>;
  triggerWords: Array<Scalars['String']['input']>;
  voiceReplyText?: InputMaybe<Scalars['String']['input']>;
};

/** Input for removing the voice reply audio of a livestream room unmatched FAQ. */
export type LivestreamRoomUnmatchedFaqVoiceRemoveInput = {
  /** Livestream room unmatched FAQ ID. */
  id: Scalars['ID']['input'];
};

/** Input for saving the voice reply URL of a livestream room unmatched FAQ after audio upload. */
export type LivestreamRoomUnmatchedFaqVoiceUrlUpdateInput = {
  /** Livestream room unmatched FAQ ID. */
  id: Scalars['ID']['input'];
  /** GCS URL of the uploaded audio file (gs:// format). */
  voiceReplyUrl: Scalars['String']['input'];
};

/** Update input for a livestream room. */
export type LivestreamRoomUpdateInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Room voice settings — the one voice/speed/pitch/emotion reused by Q&A scripts, atmosphere, closing scripts, FAQ audio and LLM voice replies. Its own table, not part of LLM config. */
export type LivestreamRoomVoiceConfigGql = {
  __typename?: 'LivestreamRoomVoiceConfigGql';
  id: Scalars['ID']['output'];
  roomId: Scalars['ID']['output'];
  voiceClone?: Maybe<TtsVoiceClone>;
  voiceCloneId?: Maybe<Scalars['ID']['output']>;
  voiceEmotion?: Maybe<TtsEmotion>;
  voicePitch: Scalars['Int']['output'];
  voiceSpeed: Scalars['Float']['output'];
};

/** Input for updating a livestream room's voice settings — the one voice/speed/pitch/emotion shared by Q&A scripts, atmosphere, closing scripts and FAQ audio. */
export type LivestreamRoomVoiceSettingsUpdateInput = {
  /** ID of the livestream room. */
  roomId: Scalars['ID']['input'];
  /** ID of the voice clone to use. Null clears it. */
  voiceCloneId?: InputMaybe<Scalars['ID']['input']>;
  /** TTS emotion override. Null clears it. */
  voiceEmotion?: InputMaybe<TtsEmotion>;
  /** TTS pitch in semitones (−12 to +12). Null keeps existing value. */
  voicePitch?: InputMaybe<Scalars['Int']['input']>;
  /** TTS speed multiplier (0.5–2.0). Null keeps existing value. */
  voiceSpeed?: InputMaybe<Scalars['Float']['input']>;
};

export type LivestreamSessionOutput = {
  __typename?: 'LivestreamSessionOutput';
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  platformConfig?: Maybe<LivestreamSessionPlatformConfigOutput>;
  scheduledEndTime?: Maybe<Scalars['DateTime']['output']>;
  scheduledStartTime?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  state: Scalars['String']['output'];
};

export type LivestreamSessionPlatformConfigOutput = BytePlus | Custom | Facebook | Shopee | Tiktok;

/** Input for saving platform configuration for a livestream session. Provide shopeeConfig for Shopee rooms, tiktokConfig for TikTok rooms, facebookConfig for Facebook rooms, or customConfig for CUSTOM rooms. */
export type LivestreamSessionSavePlatformConfigInput = {
  customConfig?: InputMaybe<CustomSessionConfigInput>;
  facebookConfig?: InputMaybe<FacebookSessionConfigInput>;
  livestreamRoomId: Scalars['String']['input'];
  shopeeConfig?: InputMaybe<ShopeeSessionConfigInput>;
  tiktokConfig?: InputMaybe<TiktokSessionConfigInput>;
};

export type LivestreamSessionWorkerNodeOutput = {
  __typename?: 'LivestreamSessionWorkerNodeOutput';
  draining: Scalars['Boolean']['output'];
  grpcAddr: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** How many livestreams this node declares it is willing to run at once. Recorded only — scheduling does not enforce it yet. */
  maxConcurrentStreams: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workerId: Scalars['String']['output'];
};

export type LogilessMerchant = {
  __typename?: 'LogilessMerchant';
  id: Scalars['ID']['output'];
};

export type LogilessStore = {
  __typename?: 'LogilessStore';
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export const LoginErrorCode = {
  EMAIL_ALREADY_EXIST: 'EMAIL_ALREADY_EXIST',
  INCORRECT_USERNAME_OR_PASSWORD: 'INCORRECT_USERNAME_OR_PASSWORD',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  INVALID_ARGUMENT: 'INVALID_ARGUMENT',
  LOGIN_REJECTED: 'LOGIN_REJECTED',
  OTP_NOT_RECEIVED: 'OTP_NOT_RECEIVED',
  SHOP_CONNECTED_TO_DIFFERENT_STORE: 'SHOP_CONNECTED_TO_DIFFERENT_STORE',
  SHOP_URL_MAY_NOT_MATCH: 'SHOP_URL_MAY_NOT_MATCH',
  TIMEOUT: 'TIMEOUT'
} as const;

export type LoginErrorCode = typeof LoginErrorCode[keyof typeof LoginErrorCode];
export type LogisticChannel = {
  __typename?: 'LogisticChannel';
  chargeCODFee: Scalars['Boolean']['output'];
  created: Scalars['Time']['output'];
  externalStoreId?: Maybe<Scalars['ID']['output']>;
  externalStoreName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  merchantId?: Maybe<Scalars['String']['output']>;
  preferredDeliveryDateTime: Scalars['Boolean']['output'];
  provider: Provider;
  saleChannelId?: Maybe<Scalars['Long']['output']>;
  status?: Maybe<LogisticChannelStatus>;
  validateAddress: Scalars['Boolean']['output'];
  verified: Scalars['Boolean']['output'];
  warehouseId?: Maybe<Scalars['ID']['output']>;
  warehouseName: Scalars['String']['output'];
  wmsType: WmsType;
};

export type LogisticChannelRequestForm = {
  __typename?: 'LogisticChannelRequestForm';
  accountId: Scalars['Long']['output'];
  created: Scalars['Time']['output'];
  id: Scalars['Long']['output'];
  message?: Maybe<Scalars['String']['output']>;
  saleChannelId: Scalars['Long']['output'];
  status: ChannelFormStatus;
  updated: Scalars['Time']['output'];
};

export const LogisticChannelStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  PENDING: 'PENDING'
} as const;

export type LogisticChannelStatus = typeof LogisticChannelStatus[keyof typeof LogisticChannelStatus];
export const LogisticShippingRateConditionType = {
  BASED_ON_ORDER_ITEM_WEIGHT: 'BASED_ON_ORDER_ITEM_WEIGHT',
  BASED_ON_ORDER_PRICE: 'BASED_ON_ORDER_PRICE',
  NO_CONDITION: 'NO_CONDITION'
} as const;

export type LogisticShippingRateConditionType = typeof LogisticShippingRateConditionType[keyof typeof LogisticShippingRateConditionType];
export type LogisticsChannelDetails = {
  __typename?: 'LogisticsChannelDetails';
  logilessStore: LogilessStore;
  merchantId: Scalars['Long']['output'];
  warehouseId: Scalars['String']['output'];
};

export type LogisticsChannelDetailsForAdd = {
  __typename?: 'LogisticsChannelDetailsForAdd';
  existingLogisticsChannelDetails?: Maybe<LogisticsChannelDetails>;
  selectableSaleChannels: Array<SaleChannel>;
};

export type LogisticsChannelDetailsForMerchant = {
  __typename?: 'LogisticsChannelDetailsForMerchant';
  selectableLogilessStore: Array<LogilessStore>;
  selectableWarehouses: Array<AnyXWarehouse>;
};

export type LogisticsInput = {
  courierService: CourierService;
  deliveryNote: Scalars['String']['input'];
  /** yyyy-MM-dd */
  preferredDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  preferredDeliveryTime?: InputMaybe<PreferredDeliveryTime>;
  temperature: OrderTemperature;
};

export type LogisticsUpdateInput = {
  courierService: CourierService;
  deliveryNote: Scalars['String']['input'];
  preferredDeliveryDate?: InputMaybe<Scalars['LocalDate']['input']>;
  preferredDeliveryTime: PreferredDeliveryTime;
  temperature: OrderTemperature;
};

export const LowConversionStrategy = {
  IGNORE: 'IGNORE',
  TEXT_REPLY: 'TEXT_REPLY',
  VOICE_REPLY: 'VOICE_REPLY'
} as const;

export type LowConversionStrategy = typeof LowConversionStrategy[keyof typeof LowConversionStrategy];
export type Mts_Invalid_Token = {
  __typename?: 'MTS_INVALID_TOKEN';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type Mts_Token_Missing_Scope = {
  __typename?: 'MTS_TOKEN_MISSING_SCOPE';
  scopes: Array<Scalars['String']['output']>;
};

export type Mts_Unknown = {
  __typename?: 'MTS_UNKNOWN';
  message: Scalars['String']['output'];
};

export type Mts_Working = {
  __typename?: 'MTS_WORKING';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type ManualAssign = {
  __typename?: 'ManualAssign';
  assignee: ChatAssignee;
};

export type ManualIntegrationOrderCsvInput = {
  channel: SupportedManualChannelForManualIntegrationCsv;
  fileUri: Scalars['String']['input'];
  saleChannelId?: InputMaybe<Scalars['Long']['input']>;
  storeId: Scalars['Long']['input'];
};

export type ManualIntegrationProductCsvInput = {
  channel: SupportedManualChannelForManualIntegrationCsv;
  fileUri: Scalars['String']['input'];
  saleChannelId?: InputMaybe<Scalars['Long']['input']>;
  storeId: Scalars['Long']['input'];
};

export const ManualOrderUploadType = {
  PER_ORDER: 'PER_ORDER',
  PER_PRODUCT: 'PER_PRODUCT'
} as const;

export type ManualOrderUploadType = typeof ManualOrderUploadType[keyof typeof ManualOrderUploadType];
export type ManualSetProductCsvUploadInput = {
  fileUri: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type ManualSetProductCsvUploadPayload = {
  __typename?: 'ManualSetProductCsvUploadPayload';
  ok: Scalars['Boolean']['output'];
};

export type ManualSingleProductCsvUploadInput = {
  fileUri: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type ManualSingleProductCsvUploadPayload = {
  __typename?: 'ManualSingleProductCsvUploadPayload';
  ok: Scalars['Boolean']['output'];
};

export type ManualUnassign = {
  __typename?: 'ManualUnassign';
  assignee: ChatAssignee;
};

export type ManualUpdateProductCsvUploadInput = {
  fileUri: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type ManualUpdateProductCsvUploadPayload = {
  __typename?: 'ManualUpdateProductCsvUploadPayload';
  ok: Scalars['Boolean']['output'];
};

/** Manual channel and other manual channels */
export type ManualsSpecificData = {
  __typename?: 'ManualsSpecificData';
  editable: Scalars['Boolean']['output'];
};

export type MarginSettingInput = {
  adSetMappingCampaignId: Scalars['Long']['input'];
  marginPercentage: Scalars['BigDecimal']['input'];
};

export type MarkDraftSentRequest = {
  chatId: Scalars['String']['input'];
  draftId: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  sentText?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceCalendarEventChartPayload = {
  __typename?: 'MarketplaceCalendarEventChartPayload';
  dimensionValue: Scalars['String']['output'];
  events: Array<MarketplaceCalendarEventPayload>;
};

export type MarketplaceCalendarEventPayload = {
  __typename?: 'MarketplaceCalendarEventPayload';
  createdAt: Scalars['ZonedDatetime']['output'];
  endDate: Scalars['ZonedDatetime']['output'];
  id: Scalars['Long']['output'];
  masterDataStoreId?: Maybe<Scalars['Long']['output']>;
  saleChannelCountry?: Maybe<Scalars['String']['output']>;
  saleChannelType: SaleChannelType;
  startDate: Scalars['ZonedDatetime']['output'];
  title: Scalars['String']['output'];
};

export type MarketplaceCalendarEventPayloadList = {
  __typename?: 'MarketplaceCalendarEventPayloadList';
  items: Array<MarketplaceCalendarEventPayload>;
  meta: ReportListMeta;
};

export type MarketplaceCalendarEventQueryInput = {
  endDate?: InputMaybe<Scalars['ZonedDatetime']['input']>;
  masterDataStoreId?: InputMaybe<Scalars['Long']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  saleChannelTypes?: InputMaybe<Array<SaleChannelType>>;
  sortBy?: InputMaybe<MarketplaceCalendarEventSortByInput>;
  startDate?: InputMaybe<Scalars['ZonedDatetime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export const MarketplaceCalendarEventSortByField = {
  CREATED_AT: 'CREATED_AT'
} as const;

export type MarketplaceCalendarEventSortByField = typeof MarketplaceCalendarEventSortByField[keyof typeof MarketplaceCalendarEventSortByField];
export type MarketplaceCalendarEventSortByInput = {
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  field: MarketplaceCalendarEventSortByField;
};

export type MarketplaceCalendarRevenueSummaryPayload = {
  __typename?: 'MarketplaceCalendarRevenueSummaryPayload';
  actual: MarketplaceCalendarSummaryActualRevenuePayload;
  forecast: MarketplaceCalendarSummaryForecastRevenuePayload;
};

export type MarketplaceCalendarSummaryActualRevenuePayload = {
  __typename?: 'MarketplaceCalendarSummaryActualRevenuePayload';
  currency: ReportSupportedCurrency;
  diffValue: Scalars['BigDecimal']['output'];
  value: Scalars['BigDecimal']['output'];
};

export const MarketplaceCalendarSummaryDimension = {
  MONTH: 'MONTH',
  WEEK: 'WEEK'
} as const;

export type MarketplaceCalendarSummaryDimension = typeof MarketplaceCalendarSummaryDimension[keyof typeof MarketplaceCalendarSummaryDimension];
export type MarketplaceCalendarSummaryForecastRevenuePayload = {
  __typename?: 'MarketplaceCalendarSummaryForecastRevenuePayload';
  currency: ReportSupportedCurrency;
  diffValue: Scalars['BigDecimal']['output'];
  value: Scalars['BigDecimal']['output'];
};

export type MarketplaceCalendarSummaryQueryInput = {
  dimension: MarketplaceCalendarSummaryDimension;
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  saleChannelTypes?: InputMaybe<Array<SaleChannelType>>;
  startDate: Scalars['ZonedDatetime']['input'];
};

export const MarketplaceSaleChannelType = {
  AmazonSellerCentral: 'AmazonSellerCentral',
  AuPayMarket: 'AuPayMarket',
  FacebookShop: 'FacebookShop',
  Lazada: 'Lazada',
  Magaseek: 'Magaseek',
  MakeshopByGmo: 'MakeshopByGmo',
  Manual: 'Manual',
  Momo: 'Momo',
  Qoo10: 'Qoo10',
  Rakuten: 'Rakuten',
  RakutenFashion: 'RakutenFashion',
  Shopee: 'Shopee',
  Shopify: 'Shopify',
  Shoplist: 'Shoplist',
  Stores: 'Stores',
  SuperDelivery: 'SuperDelivery',
  TikTok: 'TikTok',
  Tokopedia: 'Tokopedia',
  Yahoo: 'Yahoo',
  Zozotown: 'Zozotown'
} as const;

export type MarketplaceSaleChannelType = typeof MarketplaceSaleChannelType[keyof typeof MarketplaceSaleChannelType];
/** A person's matching between a MOMO room's products and the goods of a momo live. */
export type MatchMomoProductInput = {
  /** More lives to queue next to momoConnectionId in the same call. Each must list the same goodsCodes in the same order as momoConnectionId, and none may overlap another live of the queue. Omit for none. */
  additionalMomoConnectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Room products to delete because no goods item corresponds to them. */
  deleteProductIds: Array<Scalars['ID']['input']>;
  /** The MOMO livestream room; it must be editable (not composing, provisioning or live). */
  livestreamRoomId: Scalars['ID']['input'];
  /** Exactly one entry per goods item momo currently lists. */
  matches: Array<MomoProductMatchInput>;
  /** The live the matches refer to — a live of the room's queue, or a candidate to connect / switch to. */
  momoConnectionId: Scalars['ID']['input'];
};

/** What matchMomoProduct did to the room, in counts. */
export type MatchMomoProductOutput = {
  __typename?: 'MatchMomoProductOutput';
  /** True when the live was not in the room's queue before this call (the room switched to it). */
  connectionChanged: Scalars['Boolean']['output'];
  /** Products created for goods matched to nothing (name = goodsName, product_id = goodsCode). */
  created: Scalars['Int']['output'];
  /** Products deleted with their scripts, FAQs and decorations. */
  deleted: Scalars['Int']['output'];
  /** Products matched to the goods they already carried (renamed or not). */
  kept: Scalars['Int']['output'];
  /** The matched room. */
  livestreamRoomId: Scalars['ID']['output'];
  /** The live the matches were applied for; it is in the room's queue after this call. */
  momoConnectionId: Scalars['ID']['output'];
  /** Lives from additionalMomoConnectionIds newly added to the room's queue by this call. */
  queued: Scalars['Int']['output'];
  /** Products whose product_id was changed to the goodsCode they were matched to. */
  relinked: Scalars['Int']['output'];
  /** Products whose name was rewritten to momo's goodsName (momo owns a connected room's catalogue, so its name always wins). Overlaps relinked and kept. */
  renamed: Scalars['Int']['output'];
  /** Products in the room afterwards. */
  total: Scalars['Int']['output'];
};

export type MdAccount = {
  __typename?: 'MdAccount';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  countryId: Scalars['String']['output'];
  createdAt: Scalars['ZonedDatetime']['output'];
  hubspotCustomerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  netsuiteVendorId?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  phoneNumberCountryId: Scalars['String']['output'];
  product: MdAccountProduct;
  provinceId?: Maybe<Scalars['String']['output']>;
  status: MdAccountStatus;
  updatedAt: Scalars['ZonedDatetime']['output'];
  websiteUrl?: Maybe<Scalars['URL']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type MdAccountFilterInput = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MdAccountStatus>;
};

export const MdAccountProduct = {
  ANYCHAT: 'ANYCHAT',
  ANYLOGI: 'ANYLOGI',
  ANYX: 'ANYX'
} as const;

export type MdAccountProduct = typeof MdAccountProduct[keyof typeof MdAccountProduct];
export const MdAccountSortByFieldEnum = {
  CITY: 'CITY',
  COMPANY_NAME: 'COMPANY_NAME',
  COUNTRY_ID: 'COUNTRY_ID',
  CREATED_AT: 'CREATED_AT',
  HUBSPOT_CUSTOMER_ID: 'HUBSPOT_CUSTOMER_ID',
  ID: 'ID',
  NAME: 'NAME',
  NETSUITE_VENDOR_ID: 'NETSUITE_VENDOR_ID',
  PHONE_NUMBER: 'PHONE_NUMBER',
  PROVINCE_ID: 'PROVINCE_ID',
  UPDATED_AT: 'UPDATED_AT',
  WEBSITE_URL: 'WEBSITE_URL',
  ZIPCODE: 'ZIPCODE'
} as const;

export type MdAccountSortByFieldEnum = typeof MdAccountSortByFieldEnum[keyof typeof MdAccountSortByFieldEnum];
export type MdAccountSortByInput = {
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  field: MdAccountSortByFieldEnum;
};

export const MdAccountStatus = {
  ACTIVE: 'ACTIVE',
  DEACTIVATED: 'DEACTIVATED'
} as const;

export type MdAccountStatus = typeof MdAccountStatus[keyof typeof MdAccountStatus];
export type MdAccounts = ListMeta & {
  __typename?: 'MdAccounts';
  items: Array<MdAccount>;
  length: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export const MdAnyXModuleEnum = {
  ANALYTICS: 'ANALYTICS',
  ANYLIVE_AI_LIVESTREAM: 'ANYLIVE_AI_LIVESTREAM',
  ANYLIVE_AI_REPLY_SETTINGS: 'ANYLIVE_AI_REPLY_SETTINGS',
  ANYLIVE_BRAND: 'ANYLIVE_BRAND',
  ANYLIVE_INTEGRATIONS: 'ANYLIVE_INTEGRATIONS',
  ANYLIVE_LIVE_ASSETS: 'ANYLIVE_LIVE_ASSETS',
  ANYLIVE_LIVE_STREAMS_ANALYTICS: 'ANYLIVE_LIVE_STREAMS_ANALYTICS',
  ANYLIVE_REGIONAL: 'ANYLIVE_REGIONAL',
  ANYLIVE_SPEECH_SETTINGS: 'ANYLIVE_SPEECH_SETTINGS',
  ANYLIVE_VOICE_CLONE: 'ANYLIVE_VOICE_CLONE',
  CRM: 'CRM',
  DATASOURCES: 'DATASOURCES',
  INVENTORIES: 'INVENTORIES',
  ORDERS: 'ORDERS',
  PRODUCTS: 'PRODUCTS',
  PRODUCT_REVIEW_ANALYTICS: 'PRODUCT_REVIEW_ANALYTICS',
  SHIPPING_LABELS: 'SHIPPING_LABELS',
  WORKFLOW: 'WORKFLOW'
} as const;

export type MdAnyXModuleEnum = typeof MdAnyXModuleEnum[keyof typeof MdAnyXModuleEnum];
export type MdCountry = {
  __typename?: 'MdCountry';
  currencyId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isdCode: Scalars['String']['output'];
  languageId: Scalars['String']['output'];
  lname: Scalars['String']['output'];
  name: Scalars['String']['output'];
  timezone: MdTimezone;
  timezoneId: Scalars['String']['output'];
};

export const MdCountryEnum = {
  AD: 'AD',
  AE: 'AE',
  AF: 'AF',
  AG: 'AG',
  AI: 'AI',
  AL: 'AL',
  AM: 'AM',
  AO: 'AO',
  AQ: 'AQ',
  AR: 'AR',
  AS: 'AS',
  AT: 'AT',
  AU: 'AU',
  AW: 'AW',
  AX: 'AX',
  AZ: 'AZ',
  BA: 'BA',
  BB: 'BB',
  BD: 'BD',
  BE: 'BE',
  BF: 'BF',
  BG: 'BG',
  BH: 'BH',
  BI: 'BI',
  BJ: 'BJ',
  BL: 'BL',
  BM: 'BM',
  BN: 'BN',
  BO: 'BO',
  BQ: 'BQ',
  BR: 'BR',
  BS: 'BS',
  BT: 'BT',
  BV: 'BV',
  BW: 'BW',
  BY: 'BY',
  BZ: 'BZ',
  CA: 'CA',
  CC: 'CC',
  CD: 'CD',
  CF: 'CF',
  CG: 'CG',
  CH: 'CH',
  CI: 'CI',
  CK: 'CK',
  CL: 'CL',
  CM: 'CM',
  CN: 'CN',
  CO: 'CO',
  CR: 'CR',
  CU: 'CU',
  CV: 'CV',
  CW: 'CW',
  CX: 'CX',
  CY: 'CY',
  CZ: 'CZ',
  DE: 'DE',
  DJ: 'DJ',
  DK: 'DK',
  DM: 'DM',
  DO: 'DO',
  DZ: 'DZ',
  EC: 'EC',
  EE: 'EE',
  EG: 'EG',
  EH: 'EH',
  ER: 'ER',
  ES: 'ES',
  ET: 'ET',
  FI: 'FI',
  FJ: 'FJ',
  FK: 'FK',
  FM: 'FM',
  FO: 'FO',
  FR: 'FR',
  GA: 'GA',
  GB: 'GB',
  GD: 'GD',
  GE: 'GE',
  GF: 'GF',
  GG: 'GG',
  GH: 'GH',
  GI: 'GI',
  GL: 'GL',
  GM: 'GM',
  GN: 'GN',
  GP: 'GP',
  GQ: 'GQ',
  GR: 'GR',
  GS: 'GS',
  GT: 'GT',
  GU: 'GU',
  GW: 'GW',
  GY: 'GY',
  HK: 'HK',
  HM: 'HM',
  HN: 'HN',
  HR: 'HR',
  HT: 'HT',
  HU: 'HU',
  ID: 'ID',
  IE: 'IE',
  IL: 'IL',
  IM: 'IM',
  IN: 'IN',
  IO: 'IO',
  IQ: 'IQ',
  IR: 'IR',
  IS: 'IS',
  IT: 'IT',
  JE: 'JE',
  JM: 'JM',
  JO: 'JO',
  JP: 'JP',
  KE: 'KE',
  KG: 'KG',
  KH: 'KH',
  KI: 'KI',
  KM: 'KM',
  KN: 'KN',
  KP: 'KP',
  KR: 'KR',
  KW: 'KW',
  KY: 'KY',
  KZ: 'KZ',
  LA: 'LA',
  LB: 'LB',
  LC: 'LC',
  LI: 'LI',
  LK: 'LK',
  LR: 'LR',
  LS: 'LS',
  LT: 'LT',
  LU: 'LU',
  LV: 'LV',
  LY: 'LY',
  MA: 'MA',
  MC: 'MC',
  MD: 'MD',
  ME: 'ME',
  MF: 'MF',
  MG: 'MG',
  MH: 'MH',
  MK: 'MK',
  ML: 'ML',
  MM: 'MM',
  MN: 'MN',
  MO: 'MO',
  MP: 'MP',
  MQ: 'MQ',
  MR: 'MR',
  MS: 'MS',
  MT: 'MT',
  MU: 'MU',
  MV: 'MV',
  MW: 'MW',
  MX: 'MX',
  MY: 'MY',
  MZ: 'MZ',
  NA: 'NA',
  NC: 'NC',
  NE: 'NE',
  NF: 'NF',
  NG: 'NG',
  NI: 'NI',
  NL: 'NL',
  NO: 'NO',
  NP: 'NP',
  NR: 'NR',
  NU: 'NU',
  NZ: 'NZ',
  OM: 'OM',
  PA: 'PA',
  PE: 'PE',
  PF: 'PF',
  PG: 'PG',
  PH: 'PH',
  PK: 'PK',
  PL: 'PL',
  PM: 'PM',
  PN: 'PN',
  PR: 'PR',
  PS: 'PS',
  PT: 'PT',
  PW: 'PW',
  PY: 'PY',
  QA: 'QA',
  RE: 'RE',
  RO: 'RO',
  RS: 'RS',
  RU: 'RU',
  RW: 'RW',
  SA: 'SA',
  SB: 'SB',
  SC: 'SC',
  SD: 'SD',
  SE: 'SE',
  SG: 'SG',
  SH: 'SH',
  SI: 'SI',
  SJ: 'SJ',
  SK: 'SK',
  SL: 'SL',
  SM: 'SM',
  SN: 'SN',
  SO: 'SO',
  SR: 'SR',
  SS: 'SS',
  ST: 'ST',
  SV: 'SV',
  SX: 'SX',
  SY: 'SY',
  SZ: 'SZ',
  TC: 'TC',
  TD: 'TD',
  TF: 'TF',
  TG: 'TG',
  TH: 'TH',
  TJ: 'TJ',
  TK: 'TK',
  TL: 'TL',
  TM: 'TM',
  TN: 'TN',
  TO: 'TO',
  TR: 'TR',
  TT: 'TT',
  TV: 'TV',
  TW: 'TW',
  TZ: 'TZ',
  UA: 'UA',
  UG: 'UG',
  UM: 'UM',
  US: 'US',
  UY: 'UY',
  UZ: 'UZ',
  VA: 'VA',
  VC: 'VC',
  VE: 'VE',
  VG: 'VG',
  VI: 'VI',
  VN: 'VN',
  VU: 'VU',
  WF: 'WF',
  WS: 'WS',
  YE: 'YE',
  YT: 'YT',
  ZA: 'ZA',
  ZM: 'ZM',
  ZW: 'ZW'
} as const;

export type MdCountryEnum = typeof MdCountryEnum[keyof typeof MdCountryEnum];
export type MdCreateAccountInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['String']['input'];
  hubspotCustomerId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  netsuiteVendorId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  phoneNumberCountryId: Scalars['String']['input'];
  product: MdAccountProduct;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  status: MdAccountStatus;
  websiteUrl: Scalars['URL']['input'];
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type MdCreateStoreInput = {
  accountId: Scalars['Long']['input'];
  name: Scalars['String']['input'];
};

export type MdCreateUserInput = {
  accessAllStores: Scalars['Boolean']['input'];
  accountIds: Array<Scalars['Long']['input']>;
  availableModules?: InputMaybe<Array<MdAnyXModuleEnum>>;
  canManageUsers: Scalars['Boolean']['input'];
  /** ISO 4217 currency code */
  currency: Currency;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  language?: InputMaybe<UserLanguage>;
  languageId?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  role: MdUserRole;
  sendPasswordResetEmail: Scalars['Boolean']['input'];
  storeIds: Array<Scalars['Long']['input']>;
  timezoneId: Scalars['String']['input'];
};

export type MdProvince = {
  __typename?: 'MdProvince';
  country: MdCountry;
  countryId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lname: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MdProvinceFilterInput = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type MdSendVerificationEmailDetailPayload = {
  __typename?: 'MdSendVerificationEmailDetailPayload';
  status: SendVerificationEmailStatus;
  user?: Maybe<MdUser>;
  userId: Scalars['Long']['output'];
};

export type MdSendVerificationEmailInput = {
  ids: Array<Scalars['Long']['input']>;
};

export type MdSendVerificationEmailPayload = {
  __typename?: 'MdSendVerificationEmailPayload';
  details: Array<MdSendVerificationEmailDetailPayload>;
  ok: Scalars['Boolean']['output'];
};

export type MdStore = {
  __typename?: 'MdStore';
  account?: Maybe<MdAccount>;
  accountId: Scalars['Long']['output'];
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  category: MdStoreCategory;
  channels: Array<SaleChannel>;
  cityName?: Maybe<Scalars['String']['output']>;
  country: MdCountry;
  countryId: Scalars['String']['output'];
  createdAt: Scalars['ZonedDatetime']['output'];
  createdBy?: Maybe<MdUser>;
  createdById?: Maybe<Scalars['Long']['output']>;
  crmStore?: Maybe<AnyChatStore>;
  defaultCourierType?: Maybe<CourierType>;
  id: Scalars['Long']['output'];
  inventoryChannels: Array<InventoryChannel>;
  isInventoryChannelsSupported: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  phoneNumberCountry: MdCountry;
  phoneNumberCountryId: Scalars['String']['output'];
  province: MdProvince;
  provinceId?: Maybe<Scalars['String']['output']>;
  shopeeAffiliateAuthorizations: Array<ShopeeAffiliateAuthorization>;
  storeSetting: StoreSetting;
  updatedAt: Scalars['ZonedDatetime']['output'];
  zipcode?: Maybe<Scalars['String']['output']>;
};

export const MdStoreCategory = {
  AUTOMOTIVE_TOOLS: 'AUTOMOTIVE_TOOLS',
  BABY_KIDS_TOYS: 'BABY_KIDS_TOYS',
  BEAUTY_PERSONAL_CARE: 'BEAUTY_PERSONAL_CARE',
  DIGITAL_PRODUCTS_SERVICES: 'DIGITAL_PRODUCTS_SERVICES',
  ECO_FRIENDLY_SUSTAINABLE_PRODUCTS: 'ECO_FRIENDLY_SUSTAINABLE_PRODUCTS',
  ELECTRONICS_GADGETS: 'ELECTRONICS_GADGETS',
  FASHION_APPAREL: 'FASHION_APPAREL',
  FOOD_BEVERAGE: 'FOOD_BEVERAGE',
  HEALTH_WELLNESS: 'HEALTH_WELLNESS',
  HOME_LIVING: 'HOME_LIVING',
  LIFESTYLE_HOBBIES: 'LIFESTYLE_HOBBIES',
  PERSONALIZED_CUSTOM_PRODUCTS: 'PERSONALIZED_CUSTOM_PRODUCTS',
  PET_SUPPLIES: 'PET_SUPPLIES',
  SPORTS_OUTDOOR: 'SPORTS_OUTDOOR',
  UNKNOWN: 'UNKNOWN'
} as const;

export type MdStoreCategory = typeof MdStoreCategory[keyof typeof MdStoreCategory];
export type MdStoreFilterInput = {
  accountIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  storeIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export const MdStoreSortByFieldEnum = {
  ACCOUNT_NAME: 'ACCOUNT_NAME',
  CREATED_AT: 'CREATED_AT',
  ID: 'ID',
  NAME: 'NAME',
  UPDATED_AT: 'UPDATED_AT'
} as const;

export type MdStoreSortByFieldEnum = typeof MdStoreSortByFieldEnum[keyof typeof MdStoreSortByFieldEnum];
export type MdStoreSortByInput = {
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  field: MdStoreSortByFieldEnum;
};

export type MdStores = ListMeta & {
  __typename?: 'MdStores';
  items: Array<MdStore>;
  length: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MdTimezone = {
  __typename?: 'MdTimezone';
  createdAt: Scalars['ZonedDatetime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  offset: Scalars['String']['output'];
  updatedAt: Scalars['ZonedDatetime']['output'];
};

export type MdUpdateAccountInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['String']['input'];
  hubspotCustomerId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Long']['input'];
  name: Scalars['String']['input'];
  netsuiteVendorId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  phoneNumberCountryId: Scalars['String']['input'];
  product: MdAccountProduct;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  status: MdAccountStatus;
  websiteUrl: Scalars['URL']['input'];
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type MdUpdateStoreInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<MdStoreCategory>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['String']['input'];
  id: Scalars['Long']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  phoneNumberCountryId: Scalars['String']['input'];
  provinceId?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type MdUpdateUserInput = {
  accessAllStores: Scalars['Boolean']['input'];
  accountIds: Array<Scalars['Long']['input']>;
  availableModules?: InputMaybe<Array<MdAnyXModuleEnum>>;
  canManageUsers: Scalars['Boolean']['input'];
  /** ISO 4217 currency code */
  currency: Currency;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['Long']['input'];
  language?: InputMaybe<UserLanguage>;
  languageId?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  storeIds: Array<Scalars['Long']['input']>;
  timezoneId: Scalars['String']['input'];
};

export type MdUser = {
  __typename?: 'MdUser';
  accessAllStores: Scalars['Boolean']['output'];
  accountIds: Array<Scalars['Long']['output']>;
  accounts: Array<MdAccount>;
  auth0UserId?: Maybe<Scalars['String']['output']>;
  availableModules: Array<MdAnyXModuleEnum>;
  canManageUsers: Scalars['Boolean']['output'];
  country?: Maybe<MdCountry>;
  countryId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ZonedDatetime']['output'];
  currency: Currency;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  language: UserLanguage;
  languageId: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  role: MdUserRole;
  status: MdUserStatus;
  storeIds: Array<Scalars['Long']['output']>;
  stores: Array<MdStore>;
  timezone?: Maybe<MdTimezone>;
  timezoneId: Scalars['String']['output'];
  updatedAt: Scalars['ZonedDatetime']['output'];
};

export type MdUserFilterInput = {
  accountId?: InputMaybe<Scalars['Long']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<MdUserRole>;
  status?: InputMaybe<MdUserStatus>;
  storeIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export const MdUserRole = {
  ADMIN: 'ADMIN',
  MERCHANT: 'MERCHANT',
  STAFF: 'STAFF'
} as const;

export type MdUserRole = typeof MdUserRole[keyof typeof MdUserRole];
export const MdUserSortByFieldEnum = {
  CREATED_AT: 'CREATED_AT',
  EMAIL: 'EMAIL',
  FIRST_NAME: 'FIRST_NAME',
  ID: 'ID',
  LAST_NAME: 'LAST_NAME',
  UPDATED_AT: 'UPDATED_AT'
} as const;

export type MdUserSortByFieldEnum = typeof MdUserSortByFieldEnum[keyof typeof MdUserSortByFieldEnum];
export type MdUserSortByInput = {
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  field: MdUserSortByFieldEnum;
};

export const MdUserStatus = {
  ACTIVE: 'ACTIVE',
  DEACTIVATED: 'DEACTIVATED',
  PENDING: 'PENDING'
} as const;

export type MdUserStatus = typeof MdUserStatus[keyof typeof MdUserStatus];
export type MdUsers = ListMeta & {
  __typename?: 'MdUsers';
  items: Array<MdUser>;
  length: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MergeAnyTagInfluencersRequest = {
  chatId: Scalars['String']['input'];
  /** The influencer to keep, and then to sync to the chat's customer */
  keepInfluencerId: Scalars['Long']['input'];
  /** 1..4 duplicates of keepInfluencerId. AnyTag deletes them in the merge. */
  mergeInfluencerIds: Array<Scalars['Long']['input']>;
};

export type MergeProductVariantV3Input = {
  sourceProductCodes: Array<Scalars['String']['input']>;
  storeId: Scalars['Long']['input'];
  targetProductCode: Scalars['String']['input'];
};

export type MergeProductVariantV3Output = {
  __typename?: 'MergeProductVariantV3Output';
  ok: Scalars['Boolean']['output'];
};

export type MessageAuthor = AiAuthor | AutoAuthor | BasicUser;

export type MessageSearchMatchHighlight = {
  __typename?: 'MessageSearchMatchHighlight';
  length: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  word: Scalars['String']['output'];
};

export type MessageSearchResultItem = {
  __typename?: 'MessageSearchResultItem';
  channel: ChatType;
  chatId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  highlights: Array<MessageSearchMatchHighlight>;
  matchedMessageId: Scalars['String']['output'];
  matchedMessageSnippet: Scalars['String']['output'];
  matchedMessageTimestamp: Scalars['UnixTimestamp']['output'];
};

export type MessageSendFailedEvent = {
  __typename?: 'MessageSendFailedEvent';
  content: FailedMessageContent;
  platform: ChatType;
};

export const MessageState = {
  FAIL: 'FAIL',
  SENDING: 'SENDING',
  SENT: 'SENT',
  WAIT_FOR_DISCARD: 'WAIT_FOR_DISCARD'
} as const;

export type MessageState = typeof MessageState[keyof typeof MessageState];
export const MessageVariable = {
  CUSTOMER_EMAIL: 'CUSTOMER_EMAIL',
  DISPLAY_NAME: 'DISPLAY_NAME',
  ORDER_AT: 'ORDER_AT',
  ORDER_NUMBER: 'ORDER_NUMBER',
  ORDER_STATUS_URL: 'ORDER_STATUS_URL',
  ORDER_TOTAL_PRICE: 'ORDER_TOTAL_PRICE',
  ORDER_TRACKING_NUMBER: 'ORDER_TRACKING_NUMBER',
  ORDER_TRACKING_URL: 'ORDER_TRACKING_URL'
} as const;

export type MessageVariable = typeof MessageVariable[keyof typeof MessageVariable];
export type MessengerBotAutoMessage = MessengerMessage & {
  __typename?: 'MessengerBotAutoMessage';
  content: MessengerMessageContent;
  messageId: Scalars['String']['output'];
  reactions: Array<MessengerReaction>;
};

export type MessengerBotAutoMessageDeleted = MessengerMessage & {
  __typename?: 'MessengerBotAutoMessageDeleted';
  messageId: Scalars['String']['output'];
  reactions: Array<MessengerReaction>;
};

export type MessengerBotMessage = MessengerMessage & {
  __typename?: 'MessengerBotMessage';
  author: BasicUser;
  content: MessengerMessageContent;
  messageId: Scalars['String']['output'];
  messageState: MessageState;
  reactions: Array<MessengerReaction>;
};

export type MessengerBotMessageDeleted = MessengerMessage & {
  __typename?: 'MessengerBotMessageDeleted';
  author: BasicUser;
  messageId: Scalars['String']['output'];
  reactions: Array<MessengerReaction>;
};

export type MessengerBotReaction = {
  __typename?: 'MessengerBotReaction';
  sign: MessengerReactionSign;
};

export type MessengerBroadcastMessage = {
  __typename?: 'MessengerBroadcastMessage';
  content: MessengerContent;
  createdAt: Scalars['OffsetDateTime']['output'];
  deliveredAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  deliveryTiming: DeliveryTiming;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['Url']['output']>;
  name: Scalars['String']['output'];
  recipient: MessengerBroadcastRecipient;
  statistics?: Maybe<MessengerBroadcastStatistics>;
  status: BroadcastStatus;
};

export type MessengerBroadcastMessageCreateRequestInput = {
  deliveryTiming: DeliveryTimingItemInput;
  messengerContent: MessengerContentInput;
  recipient: MessengerRecipientItemInput;
  storeId: Scalars['Long']['input'];
  title: Scalars['String']['input'];
};

export type MessengerBroadcastMessageCreateResponse = {
  __typename?: 'MessengerBroadcastMessageCreateResponse';
  messageId: Scalars['String']['output'];
};

export type MessengerBroadcastMessageUpdateRequestInput = {
  deliveryTiming: DeliveryTimingItemInput;
  messengerBroadcastId: Scalars['String']['input'];
  messengerContent: MessengerContentInput;
  recipient: MessengerRecipientItemInput;
  title: Scalars['String']['input'];
};

export type MessengerBroadcastMessageUpdateResponse = {
  __typename?: 'MessengerBroadcastMessageUpdateResponse';
  messageId: Scalars['String']['output'];
};

export type MessengerBroadcastMessages = {
  __typename?: 'MessengerBroadcastMessages';
  messages: Array<MessengerBroadcastMessage>;
  total: Scalars['Int']['output'];
};

export type MessengerBroadcastRecipient = All | CustomerTagName;

export type MessengerBroadcastStatisticSummaries = {
  __typename?: 'MessengerBroadcastStatisticSummaries';
  compareStatistics?: Maybe<MessengerBroadcastStatistics>;
  diffStatistics?: Maybe<MessengerBroadcastStatistics>;
  sumStatistics: MessengerBroadcastStatistics;
};

export type MessengerBroadcastStatistics = {
  __typename?: 'MessengerBroadcastStatistics';
  deliveredCount: Scalars['Int']['output'];
  openCount: Scalars['Int']['output'];
  openRate: Scalars['Float']['output'];
  reactionCount: Scalars['Int']['output'];
  reactionRate: Scalars['Float']['output'];
};

export type MessengerChatEvent = CommonChatEvent | MessengerMessageEvent;

export type MessengerChatEvents = {
  __typename?: 'MessengerChatEvents';
  chatEvents: Array<MessengerChatEvent>;
  chatId: Scalars['String']['output'];
  lastCheckedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  newerCursor?: Maybe<Scalars['String']['output']>;
  olderCursor?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

export type MessengerChatPlatformDetail = {
  __typename?: 'MessengerChatPlatformDetail';
  isOptIn: Scalars['Boolean']['output'];
};

export type MessengerContent = MessengerTemplateContent | MessengerTextContent;

export type MessengerContentInput = {
  contentType: MessengerMessageType;
  template?: InputMaybe<MessengerTemplateContentInput>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type MessengerEmoji = {
  __typename?: 'MessengerEmoji';
  code: Scalars['String']['output'];
};

export type MessengerImage = {
  __typename?: 'MessengerImage';
  originalUrl: Scalars['Url']['output'];
  previewUrl: Scalars['Url']['output'];
};

export type MessengerImageCommentContent = {
  __typename?: 'MessengerImageCommentContent';
  image: MessengerImage;
};

export type MessengerImageMessageContent = {
  __typename?: 'MessengerImageMessageContent';
  images: Array<MessengerImage>;
};

export type MessengerMessage = {
  messageId: Scalars['String']['output'];
  reactions: Array<MessengerReaction>;
};

export type MessengerMessageContent = MessengerImageCommentContent | MessengerImageMessageContent | MessengerOptInContent | MessengerOptOutContent | MessengerPostOnPageContent | MessengerRequestOptInContent | MessengerResumeOptInContent | MessengerTextCommentContent | MessengerTextMessageContent | MessengerUnsupportedContent | MessengerVideoMessageContent;

export type MessengerMessageEvent = {
  __typename?: 'MessengerMessageEvent';
  id: Scalars['String']['output'];
  message: MessengerMessage;
  replyTo?: Maybe<MessengerReplyTo>;
  timestamp: Scalars['UnixTimestamp']['output'];
};

export const MessengerMessageType = {
  PLAIN_TEXT: 'PLAIN_TEXT',
  TEMPLATE_CARD: 'TEMPLATE_CARD'
} as const;

export type MessengerMessageType = typeof MessengerMessageType[keyof typeof MessengerMessageType];
export type MessengerNotSupportChatPlugInWithAnonymousUserFacebookError = {
  __typename?: 'MessengerNotSupportChatPlugInWithAnonymousUserFacebookError';
  message: Scalars['String']['output'];
};

export type MessengerOptInContent = {
  __typename?: 'MessengerOptInContent';
  buttonText: OptInCallToActionText;
  title: Scalars['String']['output'];
};

export type MessengerOptInMessage = {
  __typename?: 'MessengerOptInMessage';
  buttonText: OptInCallToActionText;
  enabled: Scalars['Boolean']['output'];
  imageUrl?: Maybe<Scalars['Url']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['OffsetDateTime']['output'];
};

export type MessengerOptOutContent = {
  __typename?: 'MessengerOptOutContent';
  title: Scalars['String']['output'];
};

export type MessengerPostOnPageContent = {
  __typename?: 'MessengerPostOnPageContent';
  images: Array<MessengerImage>;
  text?: Maybe<Scalars['String']['output']>;
  video?: Maybe<MessengerVideo>;
};

export type MessengerReaction = MessengerBotReaction | MessengerUserReaction;

export type MessengerReactionSign = MessengerEmoji | MessengerSign;

export type MessengerRecipientItemInput = {
  customerTagName?: InputMaybe<Scalars['String']['input']>;
  type: MessengerRecipientType;
};

export const MessengerRecipientType = {
  ALL: 'ALL',
  WITH_CUSTOMER_TAGS: 'WITH_CUSTOMER_TAGS'
} as const;

export type MessengerRecipientType = typeof MessengerRecipientType[keyof typeof MessengerRecipientType];
export type MessengerReplyTo = MessengerReplyToMessage;

export type MessengerReplyToInputInput = {
  messageId?: InputMaybe<Scalars['String']['input']>;
};

export type MessengerReplyToMessage = {
  __typename?: 'MessengerReplyToMessage';
  message: MessengerMessage;
};

export type MessengerRequestOptInContent = {
  __typename?: 'MessengerRequestOptInContent';
  buttonText: OptInCallToActionText;
  imageUrl?: Maybe<Scalars['Url']['output']>;
  title: Scalars['String']['output'];
};

export type MessengerResumeOptInContent = {
  __typename?: 'MessengerResumeOptInContent';
  title: Scalars['String']['output'];
};

export type MessengerSendImageMessageRequest = {
  chatId: Scalars['String']['input'];
  originalUrl: Scalars['Url']['input'];
  previewUrl: Scalars['Url']['input'];
  replyTo?: InputMaybe<MessengerReplyToInputInput>;
};

export type MessengerSendTextMessageRequest = {
  chatId: Scalars['String']['input'];
  replyTo?: InputMaybe<MessengerReplyToInputInput>;
  text: Scalars['String']['input'];
};

export type MessengerSign = {
  __typename?: 'MessengerSign';
  name: Scalars['String']['output'];
};

export type MessengerStoreChat = StoreChat & {
  __typename?: 'MessengerStoreChat';
  createdAt: Scalars['OffsetDateTime']['output'];
  facebookPagePicture?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isPrimaryReceiver: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
  tokenStatusV2: MetaTokenStatus;
  type: ChatType;
};

export type MessengerTargetInput = {
  type: MessengerTargetType;
};

export const MessengerTargetType = {
  BROADCAST_MESSAGE: 'BROADCAST_MESSAGE',
  CHAT_MESSAGE: 'CHAT_MESSAGE',
  OPT_IN_MESSAGE: 'OPT_IN_MESSAGE'
} as const;

export type MessengerTargetType = typeof MessengerTargetType[keyof typeof MessengerTargetType];
export type MessengerTemplateCard = {
  __typename?: 'MessengerTemplateCard';
  buttons: Array<MessengerTemplateCardButton>;
  description?: Maybe<Scalars['String']['output']>;
  imageUrl: Scalars['Url']['output'];
  title: Scalars['String']['output'];
};

export type MessengerTemplateCardButton = {
  __typename?: 'MessengerTemplateCardButton';
  buttonUrl: Scalars['Url']['output'];
  title: Scalars['String']['output'];
};

export type MessengerTemplateCardButtonInput = {
  buttonUrl: Scalars['Url']['input'];
  title: Scalars['String']['input'];
};

export type MessengerTemplateCardInput = {
  buttons: Array<MessengerTemplateCardButtonInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Scalars['Url']['input'];
  title: Scalars['String']['input'];
};

export type MessengerTemplateContent = {
  __typename?: 'MessengerTemplateContent';
  cards: Array<MessengerTemplateCard>;
};

export type MessengerTemplateContentInput = {
  cards: Array<MessengerTemplateCardInput>;
};

export type MessengerTextCommentContent = {
  __typename?: 'MessengerTextCommentContent';
  text: Scalars['String']['output'];
};

export type MessengerTextContent = {
  __typename?: 'MessengerTextContent';
  text: Scalars['String']['output'];
};

export type MessengerTextMessageContent = {
  __typename?: 'MessengerTextMessageContent';
  text: Scalars['String']['output'];
};

export type MessengerUnsupportedContent = {
  __typename?: 'MessengerUnsupportedContent';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type MessengerUserMessage = MessengerMessage & {
  __typename?: 'MessengerUserMessage';
  content: MessengerMessageContent;
  messageId: Scalars['String']['output'];
  reactions: Array<MessengerReaction>;
};

export type MessengerUserMessageDeleted = MessengerMessage & {
  __typename?: 'MessengerUserMessageDeleted';
  messageId: Scalars['String']['output'];
  reactions: Array<MessengerReaction>;
};

export type MessengerUserReaction = {
  __typename?: 'MessengerUserReaction';
  sign: MessengerReactionSign;
};

export type MessengerVideo = {
  __typename?: 'MessengerVideo';
  originalUrl: Scalars['Url']['output'];
  previewUrl: Scalars['Url']['output'];
};

export type MessengerVideoMessageContent = {
  __typename?: 'MessengerVideoMessageContent';
  video: MessengerVideo;
};

export const MetaMessagingPlatform = {
  INSTAGRAM: 'INSTAGRAM',
  MESSENGER: 'MESSENGER'
} as const;

export type MetaMessagingPlatform = typeof MetaMessagingPlatform[keyof typeof MetaMessagingPlatform];
export type MetaTokenStatus = Mts_Invalid_Token | Mts_Token_Missing_Scope | Mts_Unknown | Mts_Working;

export const MetafieldValueFormat = {
  JSON: 'JSON',
  TEXT: 'TEXT'
} as const;

export type MetafieldValueFormat = typeof MetafieldValueFormat[keyof typeof MetafieldValueFormat];
export const MimeType = {
  APPLICATION_PDF: 'APPLICATION_PDF',
  AUDIO_AAC: 'AUDIO_AAC',
  AUDIO_FLAC: 'AUDIO_FLAC',
  AUDIO_M4A: 'AUDIO_M4A',
  AUDIO_MP3: 'AUDIO_MP3',
  AUDIO_MP4: 'AUDIO_MP4',
  AUDIO_MPEG: 'AUDIO_MPEG',
  AUDIO_MPGA: 'AUDIO_MPGA',
  AUDIO_OPUS: 'AUDIO_OPUS',
  AUDIO_PCM: 'AUDIO_PCM',
  AUDIO_WAV: 'AUDIO_WAV',
  AUDIO_WEBM: 'AUDIO_WEBM',
  IMAGE_JPEG: 'IMAGE_JPEG',
  IMAGE_PNG: 'IMAGE_PNG',
  IMAGE_WEBP: 'IMAGE_WEBP',
  TEXT_PLAIN: 'TEXT_PLAIN',
  VIDEO_3GPP: 'VIDEO_3GPP',
  VIDEO_FLV: 'VIDEO_FLV',
  VIDEO_MP4: 'VIDEO_MP4',
  VIDEO_MPEG: 'VIDEO_MPEG',
  VIDEO_MPEGS: 'VIDEO_MPEGS',
  VIDEO_MPG: 'VIDEO_MPG',
  VIDEO_QUICKTIME: 'VIDEO_QUICKTIME',
  VIDEO_WEBM: 'VIDEO_WEBM',
  VIDEO_WMV: 'VIDEO_WMV'
} as const;

export type MimeType = typeof MimeType[keyof typeof MimeType];
/** Whether the room goes live for a queued momo live by itself. */
export const MomoAutoStart = {
  DISABLED: 'DISABLED',
  ENABLED: 'ENABLED'
} as const;

export type MomoAutoStart = typeof MomoAutoStart[keyof typeof MomoAutoStart];
/** Why Auto Start will not fire for a queued momo live. */
export const MomoAutoStartDisabledReason = {
  /** momo cancelled the live. */
  CANCELLED: 'CANCELLED',
  /** It starts less than 15 minutes after the previous live ends (exactly 15 minutes is fine); start it by hand. */
  GAP_TOO_SHORT: 'GAP_TOO_SHORT',
  /** Inside the 15-minute lock and no longer armable: connected or composed too late, or a scheduled start already failed. */
  LOCKED: 'LOCKED',
  /** The room is warming up for it or streaming to it, started by hand. */
  MANUAL: 'MANUAL',
  /** The room is not composed; composing it before the live's 15-minute lock re-enables Auto Start. */
  NOT_COMPOSED: 'NOT_COMPOSED',
  /** A previous live failed mid-stream and the room is in error; composing it again before the live's 15-minute lock re-enables Auto Start. */
  ROOM_ERROR: 'ROOM_ERROR'
} as const;

export type MomoAutoStartDisabledReason = typeof MomoAutoStartDisabledReason[keyof typeof MomoAutoStartDisabledReason];
/** momo's current show for a live, compared with a MOMO livestream room: the schedule (already persisted when it changed) and the goods matched by goodsCode against the room's products. */
export type MomoConnectionCheckOutput = {
  __typename?: 'MomoConnectionCheckOutput';
  /** The checked live, carrying momo's current schedule. */
  connection: MomoConnectionOutput;
  /** momo's goods, in momo's presentation order, duplicates by goodsCode dropped. */
  goods: Array<MomoGoodsOutput>;
  /** Lives that cannot share the room with `goods` because momo lists other goodsCodes, or the same ones in another order. Filled in two cases: the lives given as additionalMomoConnectionIds whose goods differ (the connect dialog's pre-check), and — when `connection` is in the room's queue and productsChanged — every other open live of the queue whose goods differ from momo's new list. Empty when nothing differs or nothing was compared. */
  goodsMismatchedConnectionIds: Array<Scalars['ID']['output']>;
  /** True when `connection` is in this room's queue (not necessarily its current live). */
  isCurrent: Scalars['Boolean']['output'];
  /** Pairs already matched by goodsCode == product_id (first product per code), in momo's order. */
  matches: Array<MomoProductMatchOutput>;
  /** The start we held before this check; null unless scheduleChanged. */
  previousStartAt?: Maybe<Scalars['DateTime']['output']>;
  /** The end we held before this check; null unless scheduleChanged. */
  previousStopAt?: Maybe<Scalars['DateTime']['output']>;
  /** True when any room product has no goods item or any goods item has no room product. */
  productsChanged: Scalars['Boolean']['output'];
  /** True when momo's startAt or stopAt differed from what we held; the connection now carries momo's. */
  scheduleChanged: Scalars['Boolean']['output'];
  /** Goods codes with no room product, in momo's order. */
  unmatchedGoodsCodes: Array<Scalars['String']['output']>;
  /** Room products (ids) with no goods item, in room order — including products without a product_id. */
  unmatchedProductIds: Array<Scalars['ID']['output']>;
};

/** momo lives for a livestream room. A room may hold a queue of lives, streamed one after another in startAt order (`queue`); `current` is the next live to stream, else the last one, and comes first in `connections`, followed by the lives the room could connect, queue or switch to — carrying the room store's vendor code (`storeEntpCode`), not cancelled, not finished (a live already in its window is still listed), not connected to any room. Lives already in the queue are listed whatever their vendor code. `connected` is true while the queue holds any live; an unconnected room has `current` null, an empty `queue` and lists only the lives it can connect to. */
export type MomoConnectionList = {
  __typename?: 'MomoConnectionList';
  /** True when the room's queue holds any momo live. */
  connected: Scalars['Boolean']['output'];
  /** The current live first, then the lives the room could connect, queue or switch to. */
  connections: Array<MomoConnectionOutput>;
  /** The room's current live — the first queued live that is not cancelled and has not reached its scheduled stop, else the last queued live — or null when the queue is empty. Also the first element of `connections`. */
  current?: Maybe<MomoConnectionOutput>;
  /** The room's queue in startAt order: every live that has not finished, plus the one the room is streaming to or warming up for. Finished lives stay connected but are not listed. Empty for an unconnected room. */
  queue: Array<MomoQueueEntryOutput>;
  /** The momo vendor code (entpCode) of the room's store: the Brand UID on Momo set on the store's MOMO sales channel in AnyX Store Details, read on every call. Candidate lives are the ones carrying the store's code (should the store have several MOMO channels with a code, any of them, and this field is the oldest channel's), and only a live whose code AnyX resolves to this store can be connected. Null when the store has no code set, in which case no live can be connected until one is set in AnyX. */
  storeEntpCode?: Maybe<Scalars['String']['output']>;
};

/** A momo AI-live session synced from momo. It is bound to at most one livestream room; a room may hold a queue of lives. */
export type MomoConnectionOutput = {
  __typename?: 'MomoConnectionOutput';
  /** True when momo cancelled this live after syncing it. A room keeps it in its queue until it is removed with `momoConnectionQueueRemove` or `unsetMomoConnection`; a cancelled live can no longer go live or be connected. */
  cancelled: Scalars['Boolean']['output'];
  /** momo enterprise (vendor) code the live belongs to. A room can connect it only when the code is the Brand UID on Momo of the room's store in AnyX. */
  entpCode: Scalars['String']['output'];
  /** Momo connection ID. */
  id: Scalars['ID']['output'];
  /** momo's liveId for this live session. */
  liveId: Scalars['String']['output'];
  /** The livestream room this live is connected to; null while it is free. */
  livestreamRoomId?: Maybe<Scalars['ID']['output']>;
  /** Phone number momo registered the live under, digits only. Informational: lives are matched on entpCode, not on the phone. */
  phone: Scalars['String']['output'];
  /** Scheduled start of the live. */
  startAt: Scalars['DateTime']['output'];
  /** Scheduled end of the live. */
  stopAt: Scalars['DateTime']['output'];
};

/** Queue more momo lives on a MOMO livestream room that is already connected. */
export type MomoConnectionQueueAddInput = {
  /** The MOMO livestream room; it must already have a live that has not finished. */
  livestreamRoomId: Scalars['ID']['input'];
  /** The lives to queue, taken from `momoConnection`. Lives already in this room's queue are ignored, so a retry is harmless. */
  momoConnectionIds: Array<Scalars['ID']['input']>;
};

/** A MOMO room's queue after a queue mutation. */
export type MomoConnectionQueueOutput = {
  __typename?: 'MomoConnectionQueueOutput';
  /** The queue, in startAt order — the same entries as `MomoConnectionList.queue`. */
  entries: Array<MomoQueueEntryOutput>;
};

/** Remove one momo live from a MOMO livestream room's queue. */
export type MomoConnectionQueueRemoveInput = {
  /** The MOMO livestream room. */
  livestreamRoomId: Scalars['ID']['input'];
  /** The queued live to remove. */
  momoConnectionId: Scalars['ID']['input'];
};

/** One goods item of a momo live, as momo currently lists it. */
export type MomoGoodsOutput = {
  __typename?: 'MomoGoodsOutput';
  /** momo's goods code — the key products are matched on (`product_id` of a room product). */
  goodsCode: Scalars['String']['output'];
  /** momo's goods name; may be blank. */
  goodsName: Scalars['String']['output'];
};

/** One goods item of the momo live and the room product it maps to. */
export type MomoProductMatchInput = {
  /** momo's goods code, taken from checkMomoConnection.goods. */
  goodsCode: Scalars['String']['input'];
  /** An existing room product, or null to create one for this goods item. */
  livestreamRoomProductId?: InputMaybe<Scalars['ID']['input']>;
};

/** A goods item and the room product that already carries its goodsCode. */
export type MomoProductMatchOutput = {
  __typename?: 'MomoProductMatchOutput';
  /** momo's goods code. */
  goodsCode: Scalars['String']['output'];
  /** The room product whose `product_id` is this goodsCode. */
  livestreamRoomProductId: Scalars['ID']['output'];
};

/** One momo live of a MOMO room's queue, as the queue drawer shows it. A room streams its queued lives one after another, in startAt order, each with its own Auto Start / Auto End. */
export type MomoQueueEntryOutput = {
  __typename?: 'MomoQueueEntryOutput';
  /** Whether the room will go live for this live by itself at its startAt. */
  autoStart: MomoAutoStart;
  /** Why Auto Start will not fire; null exactly when autoStart is ENABLED. */
  autoStartDisabledReason?: Maybe<MomoAutoStartDisabledReason>;
  /** The queued live. */
  connection: MomoConnectionOutput;
  /** True for the room's current live (`MomoConnectionList.current`): the next live to stream, else the last. */
  current: Scalars['Boolean']['output'];
  /** Where the live stands in its lifecycle. */
  phase: MomoQueuePhase;
  /** 1-based position among the listed lives that are not cancelled; null for a cancelled one. */
  position?: Maybe<Scalars['Int']['output']>;
  /** True when momoConnectionQueueRemove would accept this live now. */
  removable: Scalars['Boolean']['output'];
  /** The 15-minute lock (startAt − 15 min): an open live can be removed until then, never after. Null for a cancelled live, which can be removed at any time. */
  removableUntil?: Maybe<Scalars['DateTime']['output']>;
};

/** Where a queued momo live stands. */
export const MomoQueuePhase = {
  /** momo cancelled it; it stays listed until it is removed. */
  CANCELLED: 'CANCELLED',
  /** The room is streaming to it. */
  ON_AIR: 'ON_AIR',
  /** Inside its 15-minute lock, or the room is warming up or waiting for it. */
  PREPARING: 'PREPARING',
  /** Before its 15-minute lock. */
  UPCOMING: 'UPCOMING'
} as const;

export type MomoQueuePhase = typeof MomoQueuePhase[keyof typeof MomoQueuePhase];
export type MomoSaleChannelData = {
  __typename?: 'MomoSaleChannelData';
  /** MOMO merchant UID (entpCode); null until set */
  entpCode?: Maybe<Scalars['String']['output']>;
};

export type MomoSaleChannelEntpCodeSetInput = {
  /** MOMO merchant UID; surrounding whitespace is trimmed, null or blank clears the code */
  entpCode?: InputMaybe<Scalars['String']['input']>;
  storeId: Scalars['Long']['input'];
};

export type Money = {
  __typename?: 'Money';
  amount: Scalars['BigDecimal']['output'];
  currency: CurrencyCode;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Creates a new AI Agent session and adds a message interaction. */
  AIAgentSessionCreate: AiAgentSessionOutput;
  /** Deletes an AI Agent session. */
  AIAgentSessionDelete: AiAgentSessionOutput;
  /** Regenerates the latest AI response in an AI Agent session by deleting the last AI interaction. */
  AIAgentSessionRegenerate: AiAgentSessionOutput;
  /** Appends a message to an existing AI Agent session. */
  AIAgentSessionUpdate: AiAgentSessionOutput;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * add automation flow
   *
   * Code|Error
   * ---|---
   * 400| `INVALID_AUTOMATION_TRIGGER`.
   * 404| `USER_NOT_FOUND`.
   */
  AddAutomationFlow?: Maybe<AutomationFlow>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * add customer tag.
   * returns a list of created tags
   */
  AddCustomerTags?: Maybe<Array<CustomerTag>>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * addWorkflow.
   * bodyJSON may have LINE_unit_message_content(serialized string).
   * after get content, pass to AnyChat Service.
   * Code|Error
   * ---|---
   * 400| `INITIAL_FLOW_BLOCK_NOT_FOUND`.
   * 400| `INVALID_ACTION`.
   * 400| `INVALID_LINE_SEND_MESSAGE_ACTION`.
   * 400| `INVALID_CONDITION_FOR_ORDER`.
   * 400| `INVALID_CONJUNCTION_FOR_NUMBER`.
   * 400| `INVALID_CONJUNCTION_FOR_ENUM`.
   * 400| `INVALID_FLOW_BLOCK`.
   * 400| `INVALID_CONDITION_FOR_LINE_MESSAGE`.
   * 400| `INVALID_CONJUNCTION_VALUE`.
   * 404| `STORE_NOT_FOUND`.
   */
  AddWorkflow?: Maybe<Workflow>;
  /**
   * [ADMIN, STAFF]
   * get store.
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   */
  AnyChatStoreCrmConfigUpdate?: Maybe<AnyChatOkResponse>;
  /** Creates scraper integration credentials. */
  AnyliveCredentialCreate: AnyliveCredentialOutput;
  /** Deletes scraper integration credentials and associated firestore data. */
  AnyliveCredentialDelete: Scalars['Boolean']['output'];
  /** Activates or deactivates scraper integration credentials in Firestore. */
  AnyliveCredentialSetEnabled: Scalars['Boolean']['output'];
  /** Enables or disables live control for a scraper integration credential. */
  AnyliveCredentialSetLivestreamEnabled: Scalars['Boolean']['output'];
  /** Updates scraper integration credentials. */
  AnyliveCredentialUpdate: AnyliveCredentialOutput;
  /** Updates scraper integration fields that do not require a re-login (e.g. AI live calendar URL). Only applies to credentials whose status is DONE. Does not call the universal-login service. */
  AnyliveCredentialUpdateNonLoginFields: AnyliveCredentialOutput;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * apply the draft greeting message, swapping it in as the active greeting
   */
  ApplyGreetingMessageDraft?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * activate AI for chat.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  ChatActivateAI?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * add user to assignee list.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  ChatAddUserToAssigneeList?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * deactivate AI for chat.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  ChatDeactivateAI?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * remove user from assignee list.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  ChatRemoveUserFromAssigneeList?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * resolve chat
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  ChatResolve?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * set chat muted status for notifications.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  ChatSetMuted?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * update status like email.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  ChatStateUpdate?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * unresolve chat.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  ChatUnresolve?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * connect store to Lazada
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   */
  ConnectLazada?: Maybe<ConnectLazadaResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * connect store to Shopee for ShopAccount and MainAccount
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   * 3005| `MISSING_PARAM_FOR_TYPE`
   * 2033| `SHOPEE_TEMP_CONNECTION_NOT_FOUND`
   * 3112| `SHOPEE_CONNECTION_ALREADY_EXIST_FOR_STORE`
   * 3113| `SHOPEE_SHOP_ALREADY_CONNECT_TO_OTHER_STORE`
   * 3115| `INVALID_SHOPEE_SHOP_ID`
   */
  ConnectShopeeChat?: Maybe<ConnectShopeeChatResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * connect (re-connect) store to TikTokShop
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   * 3120| `TIKTOK_SHOP_ALREADY_CONNECTED`
   * 3121| `TIKTOK_SHOP_NOT_EXIST_IN_REGION`
   * 3122| `TIKTOK_SHOP_REGION_MISMATCH`
   */
  ConnectTikTokShop?: Maybe<ConnectTikTokShopResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * connect to facebook with support multiple platform connection
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   */
  ConnectToFacebookV2?: Maybe<ConnectToFacebookResponseV2>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * create whatsapp connection
   *
   * Code|SubCode|Error
   * ---|---|---
   * 401|1002| `NOT_ALLOW_ACTION`.
   * 404|2005| `STORE_NOT_FOUND`.
   */
  ConnectToWhatsApp?: Maybe<ConnectToWhatsAppResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * Create a customer note for a customer group.
   * Only one of messagingChannel or saleChannel may be set.
   * Code|Error
   * ---|---
   * 404| `CUSTOMER_NOT_FOUND`.
   * 400| `BAD_REQUEST`.
   */
  CustomerNoteV3Create?: Maybe<CustomerNote>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * Soft-delete a customer note.
   */
  CustomerNoteV3Delete?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * Update the text of a customer note.
   */
  CustomerNoteV3Update?: Maybe<CustomerNote>;
  DHLCreateCourier: CourierAccountDetails;
  DHLUpdateCourier: CourierAccountDetails;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * delete customer tags.
   *
   * Errors
   * 3017 - INVALID_TAG - returns when try to delete Staff
   */
  DeleteCustomerTags?: Maybe<CustomerTagDeleteResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * Permanently delete a failed outgoing message by its FOM_* internal ID.
   * Accepts FOM_* IDs from the failed_outgoing_message table.
   * Returns true on success.
   *
   * Code|Error
   * ---|---
   * 400| `NOT_ALLOW_OPERATION_FOR_STATE` — message belongs to a different account.
   * 404| `NOT_FOUND` — message not found.
   */
  DeleteFailedMessage?: Maybe<Scalars['Boolean']['output']>;
  /** delete workflow */
  DeleteWorkflow?: Maybe<WorkflowStatusOk>;
  /** duplicate workflow */
  DuplicateWorkflow?: Maybe<Workflow>;
  FedExAddressValidation: FedExAddressValidationDetails;
  FedExCreateCourier: CourierAccountDetails;
  FedExGeneratePinCode: StatusOk;
  FedExUpdateCourier: CourierAccountDetails;
  GenerateAssetUploadUrlV2?: Maybe<AssetUploadUrl>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * Generate 2–3 fact-free reply draft candidates for the specified chat.
   * Supported languages: Japanese and English only.
   * If the customer's language is not supported, returns unsupportedLanguage=true with an empty candidates list.
   */
  GenerateDraftReply?: Maybe<GenerateDraftReplyResult>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * generate tracking url
   *
   * Code|Error
   * ---|---
   * 7011| `MARKETING_SERVICE_EXCEPTION` returns when cannot create offer
   * 7012| `URL_SHORTENING_SERVICE_EXCEPTION` returns when cannot shorten url
   */
  GenerateTrackingUrl?: Maybe<Array<TrackingUrl>>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send text message.
   * ChatEvent response may be empty when message was successfully sent but failed to get the event.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  InstagramChatImageMessageSend?: Maybe<InstagramChatEvent>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send text message.
   * ChatEvent response may be empty when message was successfully sent but failed to get the event.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  InstagramChatTextMessageSend?: Maybe<InstagramChatEvent>;
  /** [ADMIN, STAFF, MERCHANT] Resend an Instagram direct failed message by internal ID. Note: marks the record as resolved without replaying the message to Instagram — actual message replay is not yet implemented. */
  InstagramMessageResend?: Maybe<InstagramChatEvent>;
  JapanPostCreateCourier: CourierAccountDetails;
  JapanPostUpdateCourier: CourierAccountDetails;
  /**
   * [All user can use this API]
   *
   * do LINE login, and fetch user data.
   *
   * Errors
   * AUTHORIZATION_REQUEST_INCORRECT
   */
  LINELogin?: Maybe<LineLoginResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send image message.
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  LazadaChatImageMessageSend?: Maybe<LazadaChatEvent>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send product message.
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  LazadaChatProductMessageSend?: Maybe<LazadaChatEvent>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send text message.
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  LazadaChatTextMessageSend?: Maybe<LazadaChatEvent>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send video message.
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  LazadaChatVideoMessageSend?: Maybe<LazadaChatEvent>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send text message.
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  LazadaChatVoucherMessageSend?: Maybe<LazadaChatEvent>;
  /** [ADMIN, STAFF, MERCHANT] Resend a Lazada direct failed message by internal ID. Note: not yet implemented — returns an error. */
  LazadaMessageResend?: Maybe<LazadaChatEvent>;
  /**
   * [All user can use this API]
   *
   * Verify LINE user by idToken and connect to influencer by influencer id
   *
   * Errors
   * INCORRECT_ID_TOKEN
   */
  LiffConnectInfluencer?: Maybe<LiffInfluencerConnectResponse>;
  /**
   * [ALL]
   * verify LIFF idToken, and return related info.
   *
   * Errors
   * INCORRECT_ID_TOKEN
   */
  LiffIdTokenValidate?: Maybe<LiffIdTokenValidateResponse>;
  /**
   * [ALL]
   * inquiry.
   *
   * Errors
   * INCORRECT_ID_TOKEN
   */
  LiffInquirySend?: Maybe<OkResponse>;
  /**
   * [ALL]
   * connect.
   *
   * SubCode|Error
   * ------|-----
   * 3117|SHOPIFY_CUSTOMER_UNIDENTIFIED
   * 3118|SHOPIFY_CUSTOMER_DISABLED
   * 3019|INCORRECT_ID_TOKEN
   * 7008|SHOPIFY_EXCEPTION
   * 2006|CUSTOMER_NOT_FOUND
   * 2002|ACCOUNT_NOT_FOUND
   * 2027|SHOPIFY_CHANNEL_NOT_FOUND
   * 2007|CHAT_NOT_FOUND
   * 3127|SHOPIFY_ALREADY_CONNECTED
   */
  LiffShopifyConnect?: Maybe<OkResponse>;
  /**
   * [ALL]
   * customer create.
   *
   * SubCode|Error
   * ------|-----
   * 3116|SHOPIFY_CUSTOMER_ALREADY_EXISTS
   * 3119|SHOPIFY_CUSTOMER_INVALID_INPUT
   * 3019|INCORRECT_ID_TOKEN
   * 7008|SHOPIFY_EXCEPTION
   * 2006|CUSTOMER_NOT_FOUND
   * 2007|CHAT_NOT_FOUND
   * 3127|SHOPIFY_ALREADY_CONNECTED
   */
  LiffShopifyCustomerCreate?: Maybe<OkResponse>;
  /**
   * [ALL]
   * connect.
   *
   * SubCode|Error
   * ------|-----
   * 3117|SHOPIFY_CUSTOMER_UNIDENTIFIED
   * 2006|CUSTOMER_NOT_FOUND
   * 2002|ACCOUNT_NOT_FOUND
   * 2027|SHOPIFY_CHANNEL_NOT_FOUND
   * 2007|CHAT_NOT_FOUND
   * 3127|SHOPIFY_ALREADY_CONNECTED
   */
  LiffShopifyRedirectConnect?: Maybe<OkResponse>;
  /**
   * [ALL]
   * connect.
   *
   * SubCode|Error
   * ------|-----
   * 3117|SHOPIFY_CUSTOMER_UNIDENTIFIED
   * 2006|CUSTOMER_NOT_FOUND
   * 2002|ACCOUNT_NOT_FOUND
   * 2027|SHOPIFY_CHANNEL_NOT_FOUND
   * 2007|CHAT_NOT_FOUND
   * 3127|SHOPIFY_ALREADY_CONNECTED
   */
  LiffShopifyRedirectConnectV2?: Maybe<OkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send broadcast message
   *
   * Code|Error
   * ---|---
   * 404| `BROADCAST_MESSAGE_NOT_FOUND`.
   */
  LineBroadCastMessageSend?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * unschedule broadcast message will change status from schedule to draft
   *
   * Code|Error
   * ---|---
   * 404| `BROADCAST_MESSAGE_NOT_FOUND`.
   */
  LineBroadCastMessageUnschedule?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * create broadcast message
   *
   *  originalUrls is ignored when trackingEnabled is false
   *
   * Code|Error
   * ---|---
   * 400| `BAD_REQUEST`.
   */
  LineBroadcastMessageCreate?: Maybe<LineBroadcastMessageCreateResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * update broadcast message
   *
   *  originalUrls is ignored when trackingEnabled is false
   *
   * Code|Error
   * ---|---
   * 404| `BROADCAST_MESSAGE_NOT_FOUND`.
   * 400| `BAD_REQUEST`.
   */
  LineBroadcastMessageUpdate?: Maybe<LineBroadcastMessageUpdateResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send LINE chat message with support for multiple message types.
   * ChatEvent response may be empty when message was successfully sent but failed to get the event.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  LineChatMessageSend?: Maybe<LineChatEvent>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * Resend a failed LINE message (scheduled or direct) by its internal message ID.
   * The backend determines the message type from the ID prefix (LSM_ or FOM_).
   * For scheduled messages (LSM_ prefix), the message is replayed to LINE.
   * For direct failed messages (FOM_ prefix), the record is marked as resolved
   * without replaying — actual direct LINE message replay is not yet implemented.
   *
   * Code|Error
   * ---|---
   * 400| `NOT_ALLOW_OPERATION_FOR_STATE` — message is not in a resendable status.
   * 404| `NOT_FOUND` — message not found.
   */
  LineMessageResend?: Maybe<LineChatEvent>;
  LineRichMenuCreateDraft?: Maybe<LineRichMenuCreateDraftResponse>;
  LineRichMenuSubmit?: Maybe<LineRichMenuSubmitResponse>;
  LineRichMenuUpdate?: Maybe<LineRichMenuUpdateResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * schedule a new LINE message.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  LineScheduledMessageCreate?: Maybe<LineScheduledMessage>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * delete a scheduled LINE message.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  LineScheduledMessageDelete?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * immediately send a scheduled LINE message.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  LineScheduledMessageImmediateSend?: Maybe<LineChatEvent>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * update a scheduled LINE message.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  LineScheduledMessageUpdate?: Maybe<LineScheduledMessage>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * Record telemetry when an operator sends a message that originated from a draft reply.
   */
  MarkDraftSent?: Maybe<AnyChatOkResponse>;
  /** Create an account */
  MdCreateAccount: MdAccount;
  /** Create a store */
  MdCreateStore: MdStore;
  /** Create a user */
  MdCreateUser: MdUser;
  /** Delete a store */
  MdDeleteStore: Scalars['Long']['output'];
  /** Delete a user */
  MdDeleteUser: Scalars['Long']['output'];
  /** Delete users */
  MdDeleteUsers: Array<Scalars['Long']['output']>;
  MdSendVerificationEmail: MdSendVerificationEmailPayload;
  /** Update an account */
  MdUpdateAccount: MdAccount;
  /** Update a store */
  MdUpdateStore: MdStore;
  /** Update a user */
  MdUpdateUser: MdUser;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * Merge duplicate AnyTag influencers (the same person) into the one to keep, before syncing it
   * to the chat's customer. AnyTag deletes the duplicates and moves their social accounts and
   * campaign history to the kept influencer. Can't be undone: show AnyTagInfluencerMergePreview
   * first. Duplicates are merged one at a time; if one fails, those before it stay merged.
   * Influencers linked to an AnyChat customer can't be merged away.
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   * 404| `INFLUENCER_NOT_FOUND`.
   * 400| `NOT_INFLUENCER_MODE_ACCOUNT`.
   * 400| `INVALID_INFLUENCER_MERGE`.
   * 400| `INFLUENCER_MERGE_LINKED`.
   * 400| `CUSTOMER_ALREADY_LINKED_TO_INFLUENCER`.
   * 400| `INFLUENCER_ALREADY_LINKED_TO_OTHER_CUSTOMER`.
   */
  MergeAnyTagInfluencers?: Maybe<AnyTagInfluencerMergeResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send broadcast message
   *  `CompleteSendingMessengerBroadcastSuccess` indicates all process of sending is success.
   *  `StartSendingMessengerBroadcastSuccess` indicates passed validation and start sending.
   *  `FailToStartSendingMessengerBroadcastTooManyUnavailableCustomer` indicates fail validation
   *  regarding to available ratio consider last marketing message.
   *
   * Code|SubCode|Error
   * ---|----|-----
   * 404|2018| `BROADCAST_MESSAGE_NOT_FOUND`.
   * 400|3000| `BAD_REQUEST`.
   * 400|3110| `MESSENGER_BROADCAST_ZERO_RECIPIENT`.
   * 400|3111| `MESSENGER_BROADCAST_INVALID_OPERATION`
   */
  MessengerBroadCastMessageSend?: Maybe<SendMessengerBroadcastResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * unschedule broadcast message will change status from schedule to draft
   *
   * Code|Error
   * ---|---
   * 404| `BROADCAST_MESSAGE_NOT_FOUND`.
   * 400| `BAD_REQUEST`.
   */
  MessengerBroadCastMessageUnschedule?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * create broadcast message
   * Opt-in is required to perform this
   *
   * Code|SubCode|Error
   * ---|----|-----
   * 400|3108|`MESSENGER_BROADCAST_REQUIRED_OPT_IN`
   */
  MessengerBroadcastMessageCreate?: Maybe<MessengerBroadcastMessageCreateResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * update broadcast message
   *
   * Code|Error
   * ---|---
   * 404| `BROADCAST_MESSAGE_NOT_FOUND`.
   * 400| `BAD_REQUEST`.
   */
  MessengerBroadcastMessageUpdate?: Maybe<MessengerBroadcastMessageUpdateResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send text message.
   * ChatEvent response may be empty when message was successfully sent but failed to get the event.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  MessengerChatImageMessageSend?: Maybe<MessengerChatEvent>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send text message.
   * ChatEvent response may be empty when message was successfully sent but failed to get the event.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  MessengerChatTextMessageSend?: Maybe<MessengerChatEvent>;
  /** [ADMIN, STAFF, MERCHANT] Resend a Messenger direct failed message by internal ID. Note: marks the record as resolved without replaying the message to Messenger — actual message replay is not yet implemented. */
  MessengerMessageResend?: Maybe<MessengerChatEvent>;
  /** Deletes multiple pronunciation dictionaries and all their rules. */
  PronunciationDictionaryBatchDelete: Array<PronunciationDictionaryOutput>;
  /** Creates a pronunciation dictionary for a voice clone. */
  PronunciationDictionaryCreate: PronunciationDictionaryOutput;
  /** Deletes a pronunciation dictionary and all its rules. */
  PronunciationDictionaryDelete: PronunciationDictionaryOutput;
  /** Generates test TTS audio for a dictionary's voice, applying its active pronunciation rules via the vendor pronunciation API. Returns a ttsId to poll via ttsInfo. */
  PronunciationDictionaryGenerateTestTts: TtsGenerationOutput;
  /** Updates a pronunciation dictionary (status). */
  PronunciationDictionarySave: PronunciationDictionaryOutput;
  /** Deletes multiple pronunciation rules. */
  PronunciationRuleBatchDelete: Array<PronunciationDictionaryOutput>;
  /** Deletes a pronunciation rule. */
  PronunciationRuleDelete: PronunciationDictionaryOutput;
  /** Creates or updates a pronunciation rule. */
  PronunciationRuleSave: PronunciationDictionaryOutput;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * update facebook connection (refresh token)
   *
   * Code|SubCode|Error
   * ---|---|---
   * 401|1002| `NOT_ALLOW_ACTION`.
   * 404|2005| `STORE_NOT_FOUND`.
   */
  RefreshFacebookTokenConnection?: Maybe<RefreshFacebookTokenResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * When isRefreshTokenSuccess is false, use this Mutation to reauthorize the connection.
   *
   * Code|Error
   * ---|---
   * 2032| `SHOPEE_CONNECTION_NOT_FOUND`.
   * 3114| `NO_PERMISSION_GIVEN_FOR_SHOPEE_SHOP`.
   */
  RefreshShopeeChatConnection?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * Re-generate a single draft reply candidate in its tone (A/B/C), optionally applying a
   * free-text operator instruction. When the instruction is empty, re-generates using the tone
   * definition only. Returns the updated candidate (same id and index, new text).
   */
  RegenerateDraftReply?: Maybe<DraftCandidateGql>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * add greeting message for a store
   */
  SaveGreetingMessage?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * save the draft greeting message for a store without changing the active greeting
   */
  SaveGreetingMessageDraft?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * create and update opt-in message of the store.
   *
   * after enable message will send when system received any message from customer and
   *  the customer still haven't got requested for opt-in we will send opt-in message.
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   */
  SaveMessengerOptInMessage?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * Record telemetry when an operator selects a draft reply candidate.
   */
  SelectDraftReply?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * set customer tags to be
   *
   * Code|Error
   * ---|---
   * 400| `BAD_REQUEST`.
   */
  SetChatCustomerTags?: Maybe<Array<CustomerTag>>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send image message.
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  ShopeeChatImageMessageSend?: Maybe<ShopeeChatEvent>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send product message.
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  ShopeeChatProductMessageSend?: Maybe<ShopeeChatEvent>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send text message.
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  ShopeeChatTextMessageSend?: Maybe<ShopeeChatEvent>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send video message.
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  ShopeeChatVideoMessageSend?: Maybe<ShopeeChatEvent>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send voucher message.
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  ShopeeChatVoucherMessageSend?: Maybe<ShopeeChatEvent>;
  /** [ADMIN, STAFF, MERCHANT] Resend a Shopee direct failed message by internal ID. Note: not yet implemented — returns an error. */
  ShopeeMessageResend?: Maybe<ShopeeChatEvent>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * connect shopify channel.
   *
   * Code|Error
   * ---|---
   * 400| `INVALID_REDIRECTED_URL`
   */
  StoreChannelShopifyConnect?: Maybe<StoreChannelShopifyConnectResponse>;
  StoreChannelShopifyConnectAdmin?: Maybe<StoreChannelShopifyConnectResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * generate shopify connect url.
   *
   * Code|Error
   * ---|---
   * 400| `INVALID_SHOPIFY_DOMAIN`
   * 404| `STORE_NOT_FOUND`.
   */
  StoreChannelShopifyOauthUrlGenerate?: Maybe<StoreChannelShopifyOauthUrlGenerateResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * register line chat.
   *
   * Code|Error
   * ---|---
   * 400| `INVALID_LINE_KEY_ID`
   */
  StoreChatLineConnectV2?: Maybe<StoreChatLineConnectResponseV2>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * update line conecction
   *
   * Code|Error
   * ---|---
   * 400|3002|`INVALID_URL`
   */
  StoreChatLineConnectionUpdate?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * register line chat.
   *
   * Code|Error
   * ---|---
   */
  StoreChatLinePublicKeyGenerateV2?: Maybe<StoreChatLinePublicKeyGenerateResponseV2>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * add template plain messages of the storeChat.
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   */
  StoreChatTemplatePlainMessageAdd?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * create template plain message category.
   *
   * Code|Error
   * ---|---
   * 400| `BAD_REQUEST` if name is empty.
   * 400| `ALREADY_EXISTS` if category name already exists.
   * 404| `STORE_NOT_FOUND`.
   */
  StoreChatTemplatePlainMessageCategoryCreate?: Maybe<TemplatePlainMessageCategory>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * delete template plain message category.
   *
   * Code|Error
   * ---|---
   * 400| `NOT_ALLOW_OPERATION_FOR_STATE` if category is 'General'.
   * 404| `STORE_NOT_FOUND`.
   * 404| `NOT_FOUND` if category does not exist.
   */
  StoreChatTemplatePlainMessageCategoryDelete?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * move template plain message category to a new position.
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   */
  StoreChatTemplatePlainMessageCategoryMove?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * update template plain message category.
   *
   * Code|Error
   * ---|---
   * 400| `BAD_REQUEST` if name is empty.
   * 400| `ALREADY_EXISTS` if category name already exists.
   * 400| `NOT_ALLOW_OPERATION_FOR_STATE` if category is 'General'.
   * 404| `STORE_NOT_FOUND`.
   * 404| `NOT_FOUND` if category does not exist.
   */
  StoreChatTemplatePlainMessageCategoryUpdate?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * delete template plain messages of the storeChat.
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   */
  StoreChatTemplatePlainMessageDelete?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * move template plain message to a new position, optionally changing its category.
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   * 404| `NOT_FOUND`.
   */
  StoreChatTemplatePlainMessageMove?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * update template plain messages of the storeChat.
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   */
  StoreChatTemplatePlainMessageUpdate?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * Link (sync) an AnyTag influencer to the chat's customer, the same way the LIFF connect page does.
   * A customer can be linked to one influencer, and an influencer to one customer.
   * Linking the influencer the customer is already linked to succeeds without changes.
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   * 404| `INFLUENCER_NOT_FOUND`.
   * 400| `NOT_INFLUENCER_MODE_ACCOUNT`.
   * 400| `CUSTOMER_ALREADY_LINKED_TO_INFLUENCER`.
   * 400| `INFLUENCER_ALREADY_LINKED_TO_OTHER_CUSTOMER`.
   */
  SyncAnyTagInfluencer?: Maybe<SyncAnyTagInfluencerResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * test send the draft greeting message to the store's Staff-tagged LINE customers
   */
  TestSendGreetingMessageDraft?: Maybe<AnyChatOkResponse>;
  /** ToggleEnableWorkflow */
  ToggleEnableWorkflow?: Maybe<WorkflowStatusOk>;
  /** Cancels multiple in-progress TTS generations. */
  TtsCancelBulk: TtsCancelBulkOutput;
  /** Creates a new TTS voice clone for the authenticated user. */
  TtsVoiceCloneCreate: TtsVoiceCloneOutput;
  /** Deletes multiple TTS voice clones for the authenticated user. */
  TtsVoiceCloneDeleteBulk: TtsVoiceCloneDeleteBulkOutput;
  /** Renames a TTS voice clone for the authenticated user. */
  TtsVoiceCloneRename: TtsVoiceCloneOutput;
  UPSAddAccountNumber: CourierAccountDetails;
  UPSInstallation: UpsPath;
  UPSOpenAccount: CourierAccountDetails;
  UPSRegisterCustomer: StatusOk;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * update automation flow
   *
   * Code|Error
   * ---|---
   * 400| `USER_NOT_FOUND`.
   */
  UpdateAutomationFlow?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * update customer information
   *
   * birthday should be "YYYY-MM-DD"
   *
   * Code|Error
   * ---|---
   * 404| `CUSTOMER_NOT_FOUND`.
   */
  UpdateCustomer?: Maybe<Customer>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * update customer tag by id.
   * returns updated customer tag
   *
   * Erros
   * 3018 - ALREADY_EXISTS - returns when mergeIntoExistingTag is false
   */
  UpdateCustomerTag?: Maybe<CustomerTag>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * update customer information V2
   *
   * Supports updating email and phone number.
   * Returns either the updated Customer or a ConflictError if the email/phone is already in use.
   *
   * birthday should be "YYYY-MM-DD"
   *
   * Code|Error
   * ---|---
   * 404| `CUSTOMER_NOT_FOUND`.
   */
  UpdateCustomerV2?: Maybe<UpdateCustomerResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * update whatsapp optIn Setting
   *
   * Code|SubCode|Error
   * ---|---|---
   * 401|1002| `NOT_ALLOW_ACTION`.
   * 404|2005| `STORE_NOT_FOUND`.
   * 404|2029| `WHATSAPP_CONNECTION_NOT_FOUND`.
   */
  UpdateWhatsAppOptInSetting?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * updateWorkflow
   * bodyJSON may have LINE_unit_message_ID, LINE_unit_message_content(serialized string).
   * after get content, pass to AnyChat Service.
   * Code|Error
   * ---|---
   * 400| `INITIAL_FLOW_BLOCK_NOT_FOUND`.
   * 400| `INVALID_ACTION`.
   * 400| `INVALID_LINE_SEND_MESSAGE_ACTION`.
   * 400| `INVALID_CONDITION_FOR_ORDER`.
   * 400| `INVALID_CONJUNCTION_FOR_NUMBER`.
   * 400| `INVALID_CONJUNCTION_FOR_ENUM`.
   * 400| `INVALID_FLOW_BLOCK`.
   * 400| `INVALID_CONDITION_FOR_LINE_MESSAGE`.
   * 400| `INVALID_CONJUNCTION_VALUE`.
   * 404| `WORKFLOW_NOT_FOUND`.
   */
  UpdateWorkflow?: Maybe<Workflow>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * create broadcast message
   * 400|3123|`WHATSAPP_BROADCAST_CONTENT_VALIDATION_FAIL`
   * 400|3124|`WHATSAPP_BROADCAST_REQUIRED_OPT_IN`
   * 400|3125|`WHATSAPP_BROADCAST_CARDS_SAME_AMOUNT_BUTTONS_FAIL`
   */
  WhatsAppBroadcastCreate?: Maybe<Scalars['String']['output']>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * update broadcast message
   * return error if broadcast status is not allowed to update
   * Code|SubCode|Error
   * ---|----|-----
   * 400|3022|`NOT_ALLOW_OPERATION_FOR_STATE`
   * 404|2018|`BROADCAST_MESSAGES_NOT_FOUND`
   */
  WhatsAppBroadcastToDraft?: Maybe<AnyChatOkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * update broadcast message
   * return error if broadcast status is not allowed to update
   * Code|SubCode|Error
   * ---|----|-----
   * 400|3124|`WHATSAPP_BROADCAST_REQUIRED_OPT_IN`
   * 400|3123|`WHATSAPP_BROADCAST_CONTENT_VALIDATION_FAIL`
   * 400|3125|`WHATSAPP_BROADCAST_CARDS_SAME_AMOUNT_BUTTONS_FAIL`
   * 400|3022|`NOT_ALLOW_OPERATION_FOR_STATE`
   * 400|3005|`MISSING_PARAM_FOR_TYPE`
   * 404|2018|`BROADCAST_MESSAGES_NOT_FOUND`
   */
  WhatsAppBroadcastUpdate?: Maybe<WhatsAppBroadcastUpdateResult>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send image message.
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  WhatsAppChatImageMessageSend?: Maybe<WhatsAppChatEvent>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * send text message.
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  WhatsAppChatTextMessageSend?: Maybe<WhatsAppChatEvent>;
  /** [ADMIN, STAFF, MERCHANT] Resend a WhatsApp direct failed message by internal ID. Note: not yet implemented — returns an error. */
  WhatsAppMessageResend?: Maybe<WhatsAppChatEvent>;
  addShipperAddress: ShipperAddress;
  /**
   * Archive product variants.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`, `VALIDATION_ERROR`
   * ▸ SubErrorReasons: `ALREADY_ARCHIVED(productCode: String)`, `CANNOT_ARCHIVE_VARIANT_WITH_ACTIVE_INBOUND(productCode: String)`, `CANNOT_ARCHIVE_VARIANT_WITH_ACTIVE_ORDER_LOGISTIC_FULFILLMENT(productCode: String)`, `CANNOT_ARCHIVE_VARIANT_WITH_SET_PRODUCT(productCode: String, setProductCodes: List)`, `CANNOT_ARCHIVE_VARIANT_WITH_WAREHOUSE_INVENTORY(productCode: String)`
   */
  archiveProductVariants: ArchiveProductVariantsOutput;
  cancelInbound: StatusOk;
  cancelInbounds: BulkOperationResponse;
  /** Read momo's current show for a live and compare it with this room. Without momoConnectionId the room's current live is checked (ROOM_NOT_BOUND when there is none); with it, a live of the room's queue, or a candidate live the room could connect or switch to is previewed (same rules as setMomoConnection: not cancelled, not finished, not connected elsewhere, carrying the vendor code of the room's store in AnyX). goodsMismatchedConnectionIds lists the additionalMomoConnectionIds (checked under the same rules, nothing connected) whose goods differ from this live's, and — when this live is queued and productsChanged — the other open queued lives whose goods differ from momo's new list. momo's startAt/stopAt are written onto the connection when they differ from what we hold (scheduleChanged). goods is momo's current list; matches are the room products already matched by goodsCode; unmatchedProductIds / unmatchedGoodsCodes are what a person has to resolve with matchMomoProduct. FAILED_PRECONDITION when the room is not a MOMO room, the live was cancelled or has finished, or momo rejects the live (MOMO_API_ERROR); UPSTREAM_UNAVAILABLE when momo cannot be reached. */
  checkMomoConnection: MomoConnectionCheckOutput;
  /** Creates a comment analysis report for the given livestreams. */
  commentAnalysisReportCreate: CommentAnalysisReportOutput;
  /** Exports comment history as a Google Sheet. The export is generated asynchronously — poll the reportId on the ReportExport type for status and URL. */
  commentHistoryExport: ExportResponse;
  /** Clears feedback on a comment reply record. */
  commentReplyRecordClearFeedback: Scalars['Boolean']['output'];
  /** Toggles feedback on a comment reply record. If the same feedback value is submitted again, it is cleared (toggle). Pass THUMBS_UP to set or clear thumbs-up; THUMBS_DOWN to set or clear thumbs-down. */
  commentReplyRecordFeedback: Scalars['Boolean']['output'];
  /**
   * confirm a valid Japan order address.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INTERNAL_ERROR`, `INVALID_HOUSE_NUMBER`, `INVALID_REQUEST`, `TRY_AGAIN_LATER`, `UNAUTHORIZED`
   */
  confirmValidJapanAddress: ConfirmValidJapanOrderAddressPayload;
  connectChannelToWarehouse: StatusOk;
  /**
   * Connect to Rakuten using licenseKey and serviceSecret.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INVALID_CREDENTIAL`, `STORE_ALREADY_CONNECTED`, `STORE_NOT_FOUND`, `UNAUTHORIZED`
   */
  connectRakuten: RakutenConnectPayload;
  createAnylogiSupplierUser: Id;
  /** Creates a closing script. */
  createClosingScript: AnyLiveClosingScript;
  createCourierSettings: StatusOk;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Create a datasource.
   *         Please provide `setting` object with the following fields
   *         GA4:
   *         - `account`
   *         - `property`
   *         - `accountName`
   *         - `propertyName`
   *         Facebook ads:
   *         - `account`
   *         - `accountName`
   *         GoogleAds:
   *         - `customerId`
   *         - `account`
   *         - `customerName`
   *         - `accountName`
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   *         |`INVALID_INPUT`|Invalid arguments
   */
  createDatasource: DatasourcePayload;
  /** Creates a fallback template. */
  createFallbackTemplate: AnyLiveFallbackTemplate;
  createInbound?: Maybe<InboundIds>;
  createLogisticChannelRequestForm?: Maybe<StatusOk>;
  createLogisticShopifyCarrierServiceCondition: ShopifyCarrierServiceCondition;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Create marketplace calendar event.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   *         |`INVALID_INPUT`|Invalid arguments
   */
  createMarketplaceCalendarEvent: MarketplaceCalendarEventPayload;
  /** Creates a sensitive word. */
  createSensitiveWord: AnyLiveSensitiveWord;
  createShipping: Shipping;
  createShopifyCarrierService: StatusOk;
  createSupplier: Id;
  createWarehouse: Id;
  /** Start a background regeneration of the Brand View AI Insights panel (issue #182). Returns immediately with status PROCESSING — poll dashboardBrandAiInsight until it becomes DONE or FAILED. */
  dashboardBrandAiInsightRefresh: DashboardBrandAiInsightOutput;
  /** Start a background regeneration of the Regional View AI Insights panel (issue #182). Returns immediately with status PROCESSING — poll dashboardRegionalAiInsight until it becomes DONE or FAILED. */
  dashboardRegionalAiInsightRefresh: DashboardRegionalAiInsightOutput;
  /** Force-regenerate the §2.3(c) Script Optimization Insights and overwrite the cache. */
  dashboardScriptInsightRefresh: DashboardScriptInsightOutput;
  deleteAnylogiSupplierUsers: BulkOperationResponse;
  deleteChannelFromWarehouse: StatusOk;
  /** Deletes a closing script by id. */
  deleteClosingScript: Scalars['Boolean']['output'];
  deleteCourierAccount: StatusOk;
  deleteCrossBorderBasicAuth: StatusOk;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Delete a datasource.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   */
  deleteDatasource: Scalars['Long']['output'];
  /** Deletes a fallback template by id. */
  deleteFallbackTemplate: Scalars['Boolean']['output'];
  deleteLogisticShopifyCarrierServiceCondition: StatusOk;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Delete marketplace calendar event.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   *         |`INVALID_INPUT`|Invalid arguments
   */
  deleteMarketplaceCalendarEvent: Scalars['Long']['output'];
  /** Delete a report export by ID. Only the owner can delete their own report exports. */
  deleteReportExport: Scalars['Boolean']['output'];
  /**
   * ▸ Requires: `ADMIN`
   * ▸ Throws: `ANY_LOGI_ACTIVE`, `NOT_FOUND`, `SHOPIFY_ERROR`, `UNAUTHORIZED`
   */
  deleteSaleChannel: DeleteSaleChannelPayload;
  /** Deletes a sensitive word by id. */
  deleteSensitiveWord: Scalars['Boolean']['output'];
  deleteShopifyCarrierService: StatusOk;
  deleteWarehouse: StatusOk;
  deleteWarehouses: BulkOperationResponse;
  deliverySlip: Path;
  /**
   * Disable inventory sync for product variants.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   */
  disableProductVariantsInventorySync: DisableInventorySyncOutput;
  disconnectChannelFromWarehouse: StatusOk;
  disconnectStoreFromWms: StatusOk;
  editShipperAddress: ShipperAddress;
  /**
   * Enable inventory sync for product variants.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   */
  enableProductVariantsInventorySync: EnableInventorySyncOutput;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Exchange Facebook OAuth code to long-lived token.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`       |Unauthorized request
   *         |`FORBIDDEN`           |This operation is prohibited
   *         |`FACEBOOK_OAUTH_ERROR`|Facebook OAuth has error
   */
  facebookExchangeCode: FacebookExchangeCodePayload;
  /** Upload file */
  fileUpload: FileUploadPayload;
  /** Creates a new general FAQ for a live asset version. */
  generalFaqCreate: GeneralFaq;
  /** Deletes a general FAQ. */
  generalFaqDelete: Scalars['Boolean']['output'];
  /** Regenerates a single FAQ using only the knowledgebase. */
  generalFaqRegenerate: FaqRegenerateOutput;
  /** Updates an existing general FAQ. */
  generalFaqUpdate: Scalars['Boolean']['output'];
  /** Kick off async generation of a brand monthly report as a Google Slides deck in the requesting user's Google Drive, for the given store and month (YYYY-MM). The export is generated asynchronously — the returned reportId appears in the export download panel; query the ReportExport type by that id for status and the Slides URL. */
  generateBrandMonthlyReport: ExportResponse;
  generateCrossBorderBasicAuth: CrossBorderBasicAuth;
  generateLogilessOAuthURL?: Maybe<Path>;
  /** Kick off async generation of a Store weekly report as a Google Sheet in the requesting user's Google Drive, for the given store and month (YYYY-MM). One tab per platform with data (TikTok/Shopee), each a weekly AI-vs-Human KPI pivot. The export is generated asynchronously — the returned reportId appears in the export download panel; query the ReportExport type by that id for status and the Sheet URL. */
  generateStoreWeeklyReport: ExportResponse;
  generateUploadUrl: Path;
  googleAuthUrlGenerate: Scalars['Url']['output'];
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Exchange Google OAuth code to token.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`     |Unauthorized request
   *         |`FORBIDDEN`         |This operation is prohibited
   *         |`GOOGLE_OAUTH_ERROR`|Google OAuth has error
   */
  googleExchangeCode: GoogleExchangeCodePayload;
  /** Creates a host. */
  hostCreate: HostOutput;
  /** Updates a host. */
  hostUpdate: HostOutput;
  /** Imports selected general FAQs from a live asset version into a live room. The asset answer fills the replies the room's FAQ reply mode needs; duplicate or unusable FAQs are skipped and reported. */
  importLiveAssetGeneralFaqsAsRoomFaqs: ImportLiveAssetGeneralFaqsResult;
  /** Imports selected product FAQs from a live asset version into a live room. FAQs whose product cannot be matched are saved to the unmatched section. The asset answer fills the replies the room's FAQ reply mode needs; duplicate or unusable FAQs are skipped and reported. */
  importLiveAssetProductFaqsAsRoomFaqs: ImportLiveAssetProductFaqsResult;
  /** Imports live asset script content paragraphs into a livestream room product. */
  importLiveAssetScriptContentAsParagraphs: Array<LivestreamRoomProductParagraphOutput>;
  invoiceSlip: InvoiceSlip;
  /**
   * Trigger listing sync.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_SUPPORTED`, `SALE_CHANNEL_INACTIVE`, `SALE_CHANNEL_NOT_FOUND`, `UNAUTHORIZED`
   */
  listingTriggerSync: Scalars['Long']['output'];
  /** Clears all TTS generation IDs from live asset content for a given live asset version. */
  liveAssetContentClearTts: Scalars['Boolean']['output'];
  /** Creates a new live asset content. */
  liveAssetContentCreate: LiveAssetContentOutput;
  /** Reorders live asset content and deletes content not in the provided list. */
  liveAssetContentReorder: Scalars['Boolean']['output'];
  /** Updates the content of a live asset section. */
  liveAssetContentUpdate: Scalars['Boolean']['output'];
  /** Creates a live asset. */
  liveAssetCreate: LiveAssetVersionOutput;
  /** Deletes multiple live assets. */
  liveAssetDeleteBulk: Array<LiveAssetOutput>;
  /** Duplicates multiple live assets. */
  liveAssetDuplicateBulk: Array<LiveAssetOutput>;
  /** Clears all TTS generation IDs from FAQ content (general and product FAQs) for a given live asset version. */
  liveAssetFaqContentClearTts: Scalars['Boolean']['output'];
  /** Submits general FAQ generation for asynchronous processing. Generates FAQ based on knowledge base. */
  liveAssetGeneralFaqGenerationSubmit: LiveAssetVersionOutput;
  /** Submits live asset generation for asynchronous processing. Fetches all required data from the database based on the provided live asset version ID. */
  liveAssetGenerationSubmit: LiveAssetVersionOutput;
  /** Updates live knowledge settings (knowledgeBase and type fields) of a live asset version. */
  liveAssetLiveKnowledgeUpdate: LiveAssetVersionOutput;
  /** Creates a new product associated with a live asset version. */
  liveAssetProductCreate: LiveAssetProductOutput;
  /** Deletes a product by its ID. */
  liveAssetProductDelete: Scalars['Boolean']['output'];
  /** Submits product FAQ generation for asynchronous processing. Generates FAQ based on products and knowledge base. */
  liveAssetProductFaqGenerationSubmit: LiveAssetVersionOutput;
  /** Sets the order of a live asset version's products. The input must list every product of the version exactly once. */
  liveAssetProductReorder: Scalars['Boolean']['output'];
  /** Updates an existing product. */
  liveAssetProductUpdate: LiveAssetProductOutput;
  /** Updates all script content for a live asset version. This replaces all existing script content. */
  liveAssetScriptUpdate: LiveAssetVersionOutput;
  /** Updates a live asset. */
  liveAssetUpdate: LiveAssetOutput;
  /** Deletes live asset versions. */
  liveAssetVersionDeleteBulk: Array<LiveAssetVersionOutput>;
  /** Duplicate a live asset version. */
  liveAssetVersionDuplicate: LiveAssetVersionOutput;
  /** Duplicates multiple live asset versions. */
  liveAssetVersionDuplicateBulk: Array<LiveAssetVersionOutput>;
  /** Updates a live asset version. */
  liveAssetVersionUpdate: LiveAssetVersionOutput;
  /** Updates only the TTS settings (defaultVoiceId and defaultTtsSpeed) of a live asset version. */
  liveAssetVersionUpdateTtsSettings: LiveAssetVersionOutput;
  /** Updates only the version name of a live asset version. */
  liveAssetVersionUpdateVersionName: LiveAssetVersionOutput;
  /** Updates a livestream. */
  liveStreamUpdate: LiveStreamOutput;
  /** Creates a livestream avatar. */
  livestreamAvatarCreate: LivestreamAvatarOutput;
  /** Renames one sub-video (look) of a READY avatar; the main video cannot be renamed. */
  livestreamAvatarSubVideoRename: LivestreamAvatarOutput;
  /** Updates a livestream avatar. */
  livestreamAvatarUpdate: LivestreamAvatarOutput;
  /** Toggles and re-intervals one atmosphere timer (WELCOME or TIMED). */
  livestreamRoomAtmosphereGroupUpdate: LivestreamRoomAtmosphereGroupUpdatePayload;
  /** Adds a new atmosphere script to a livestream room. */
  livestreamRoomAtmosphereScriptAdd: LivestreamRoomAtmosphereScriptMutationPayload;
  /** Permanently deletes an atmosphere script. */
  livestreamRoomAtmosphereScriptDelete: LivestreamRoomAtmosphereScriptDeletePayload;
  /** Triggers asynchronous TTS generation for an atmosphere script using the room's voice clone, speed, pitch, and emotion. Safe to call again to regenerate — a prior in-flight generation for the same script is cancelled first. Poll status/signed URL via Query.ttsInfo(ttsId: atmosphereScript.ttsGenerationId). */
  livestreamRoomAtmosphereScriptGenerateTts: LivestreamRoomAtmosphereScriptGenerateTtsPayload;
  /** Updates the text of an atmosphere script. Any existing generated audio stays playable but reads as stale until the operator explicitly regenerates it. */
  livestreamRoomAtmosphereScriptUpdate: LivestreamRoomAtmosphereScriptMutationPayload;
  /** Removes the voice reply audio of an atmosphere script from storage and clears its URL. */
  livestreamRoomAtmosphereScriptVoiceRemove: LivestreamRoomAtmosphereScriptMutationPayload;
  /** Updates the voice reply URL of an atmosphere script after audio upload completes. */
  livestreamRoomAtmosphereScriptVoiceUrlUpdate: LivestreamRoomAtmosphereScriptMutationPayload;
  /** Updates the comment-switch cooldowns of a livestream room. STAFF/ADMIN only; rejects rooms in LIVE or PROVISIONING with FAILED_PRECONDITION. Range [0, 1440] minutes inclusive; 0 = no limit. Changes take effect after restarting the stream. */
  livestreamRoomCommentSwitchCooldownsUpdate: LivestreamRoomCommentSwitchCooldownsUpdatePayload;
  /** Triggers composition of a livestream room. */
  livestreamRoomCompose: LivestreamRoomOutput;
  /** Creates a livestream room. */
  livestreamRoomCreate: LivestreamRoomOutput;
  /** Creates a livestream room decoration video/image. */
  livestreamRoomDecorationCreate: LivestreamRoomDecorationOutput;
  /** Deletes multiple livestream room decorations. */
  livestreamRoomDecorationDeleteBulk: Array<LivestreamRoomDecorationOutput>;
  /**
   * Replaces the room's whole decoration group and re-projects it onto every product.
   *
   * Bulk-replace, exactly like livestreamRoomDecorationSave: the list IS the group. Position in the list is z-order (index 0 = bottom). An empty list clears the group, which removes those layers from every scene.
   *
   * ## Where the group lands in each scene
   * Group layers sink to the BOTTOM of each half of a scene's stack — below the scene's own layers above the avatar, and below them again underneath it. The room set is the stage, the scene's layers are the content, and content is never hidden by the stage. A group AVATAR item is the marker that splits the two halves; without one, nothing goes behind the avatar.
   *
   * ## What it does to a scene's own layers
   * Nothing, with one exception. Every one of a scene's own layers is carried through, renumbered — a scene decorated before the group existed keeps everything it had. The exception is the background: when the group carries one, the scene's own BACKGROUND_* layer is dropped, and that placement is NOT recoverable (the uploaded file stays in storage and can be re-picked by hand). Those scenes come back in backgroundReplacedProductIds.
   *
   * ## All-or-nothing
   * Every product's merged stack is validated before anything is written, and the whole call runs in one transaction. A scene that would breach the per-scene limits fails the call with a violation naming that scene ("Scene 3 (Blue Hoodie): ..."), and nothing is written to any product. The realistic failure is a group VIDEO landing on a scene that already has paragraph close-ups: that scene has only one foreground video slot.
   *
   * ## Assets
   * An element may reference a room-scoped decoration (livestreamRoomDecorationCreate with no livestreamRoomProductId) or one owned by a product of this room — the latter is server-side copied into a room-scoped asset so that deleting the product can never take the group down with it. The original row is left untouched, so remove the operator's source layer yourself if it should stop appearing twice.
   *
   * Does NOT delete decoration assets orphaned by the save. Collect the orphaned ids and call livestreamRoomDecorationDeleteBulk AFTER this succeeds — never before, or a rejected save strands a live reference. livestreamRoomDecorationDeleteBulk refuses an asset the group still references, for the same reason.
   */
  livestreamRoomDecorationGroupSave: LivestreamRoomDecorationGroupSaveOutput;
  /**
   * Saves all decoration overlays for a product's livestream canvas. This is a bulk-replace operation: all existing overlay metadata for the product is deleted and replaced with the provided list.
   *
   * ## Behavior
   * - Position in the items list determines z-index (index 0 = bottom layer, last = top layer).
   * - Returns true on success.
   *
   * ## Overlay Types & Required Fields
   * Each item must specify a type and the corresponding source ID:
   * - IMAGE: requires decorationId (from livestreamRoomDecorationCreate) of an IMAGE record owned by the product
   * - VIDEO: requires decorationId (from livestreamRoomDecorationCreate) of a VIDEO record owned by the product
   * - AVATAR: requires avatarId (the avatar assigned to the product)
   * - CLOSE_UP: requires paragraphId (a product paragraph with a closeup video); at most one layer per paragraph
   *
   * ## Limits (per product, enforced on save)
   * The avatar rendering pipeline accepts a bounded set of materials per product, so the layer list is validated:
   * - At most one AVATAR layer. The single IMAGE/VIDEO layer below it becomes the scene background;
   *   a second layer below the avatar is rejected.
   * - Foreground videos (VIDEO layers above the avatar) are limited to 2. Paragraph close-up videos need one
   *   of those slots at play time (only one close-up plays at a time), so while any paragraph of the product
   *   has a close-up video at most 1 foreground decoration video is allowed. Allowed combos
   *   (foreground videos + paragraphs with close-up): 2+0, 1+N, 0+N. Close-ups are detected from the
   *   paragraphs' stored closeup videos, not from the CLOSE_UP items in this list.
   * - Foreground images (IMAGE layers above the avatar) are limited to 30.
   * The per-product `livestreamRoom.products.canAddCloseupVideo` flag exposes the close-up slot availability.
   *
   * ## Metadata (JSON string)
   * Positioning only — x, y, width, height. Any other key (e.g. legacy opacity or chroma-key fields) is silently ignored.
   * All nullable (FE uses defaults when null):
   * - x (int): horizontal position in pixels (can be negative)
   * - y (int): vertical position in pixels (can be negative)
   * - width (int >= 0): width in pixels
   * - height (int >= 0): height in pixels
   *
   * Example metadata: {"x":0,"y":0,"width":1920,"height":1080}
   *
   * ## Typical Workflow
   * 1. Upload images/videos via livestreamRoomDecorationUpload + livestreamRoomDecorationCreate
   * 2. Select avatar via livestreamRoomProductSelectAvatar (auto-creates AVATAR overlay)
   * 3. Set closeup videos via livestreamRoomProductParagraphVideoUrlUpdate (auto-creates CLOSE_UP overlay)
   * 4. Query all overlays via livestreamRoomDecorations
   * 5. FE adjusts positions/metadata, then calls this mutation to persist
   */
  livestreamRoomDecorationSave: Scalars['Boolean']['output'];
  /** Deletes a livestream room. */
  livestreamRoomDelete: LivestreamRoomOutput;
  /** Bulk duplicates livestream rooms. */
  livestreamRoomDuplicateBulk: Array<LivestreamRoomOutput>;
  /** Updates the FAQ confidence threshold of a livestream room. STAFF/ADMIN only; rejects rooms in LIVE or PROVISIONING with FAILED_PRECONDITION. Range [0.0, 1.0] inclusive; NaN and ±Infinity are rejected. */
  livestreamRoomFaqConfidenceUpdate: LivestreamRoomFaqConfidenceUpdatePayload;
  /** Drafts one Global FAQ from the room's knowledge base and one FAQ per room product from its selling points, keyed so a regenerate never touches a hand-written FAQ. Async — enqueues and returns; poll faqGenerationStatus and watch for generated rows to appear. */
  livestreamRoomFaqGenerate: LivestreamRoomOutput;
  /** Updates a livestream room's FAQ Reply Mode — whether every Global FAQ and Product FAQ answer is spoken, posted as text, or both. STAFF/ADMIN only; rejects rooms in LIVE or PROVISIONING with FAILED_PRECONDITION. A separate setting from the LLM Reply Mode. */
  livestreamRoomFaqReplyModeUpdate: LivestreamRoomFaqReplyModeUpdatePayload;
  /** Creates multiple livestream room general FAQs in a single atomic operation. */
  livestreamRoomGeneralFaqBulkCreate: Array<LivestreamRoomGeneralFaqOutput>;
  /** Creates a livestream room general FAQ. Only trigger words are required, so a row can be created before its audio is uploaded; the replies the room's FAQ reply mode needs are enforced on update. */
  livestreamRoomGeneralFaqCreate: LivestreamRoomGeneralFaqOutput;
  /** Removes the custom-video comment action of a general FAQ from storage and clears its metadata. */
  livestreamRoomGeneralFaqCustomVideoRemove: LivestreamRoomGeneralFaqOutput;
  /** Generates or regenerates the audio of a general FAQ's custom-video replacement script, using the room's voice/speed/pitch/emotion and pronunciation rules. Rejected when the custom video is not in REPLACEMENT_TEXT mode (no replacement script). Distinct from livestreamRoomGeneralFaqTtsGenerate, which generates the FAQ's own answer audio. Safe to call again to regenerate — a prior in-flight generation for the same custom video is cancelled first. */
  livestreamRoomGeneralFaqCustomVideoTtsGenerate: LivestreamRoomGeneralFaqOutput;
  /** Attaches or replaces the custom-video comment action of a general FAQ after upload completes. */
  livestreamRoomGeneralFaqCustomVideoUpdate: LivestreamRoomGeneralFaqOutput;
  /** Deletes multiple livestream room general FAQs. */
  livestreamRoomGeneralFaqDeleteBulk: Array<LivestreamRoomGeneralFaqOutput>;
  /** Generates or regenerates the answer audio of a general FAQ from its answer text, using the room's voice/speed/pitch/emotion and pronunciation rules. Clears any uploaded voiceReplyUrl — the two audio sources are mutually exclusive. Safe to call again to regenerate — a prior in-flight generation for the same FAQ is cancelled first. */
  livestreamRoomGeneralFaqTtsGenerate: LivestreamRoomGeneralFaqOutput;
  /** Updates a livestream room general FAQ. */
  livestreamRoomGeneralFaqUpdate: LivestreamRoomGeneralFaqOutput;
  /** Removes the voice reply audio of a general FAQ from storage and clears its URL. */
  livestreamRoomGeneralFaqVoiceRemove: LivestreamRoomGeneralFaqOutput;
  /** Updates the voice reply URL of a general FAQ after audio upload completes. */
  livestreamRoomGeneralFaqVoiceUrlUpdate: LivestreamRoomGeneralFaqOutput;
  /** Updates a livestream room knowledge base. */
  livestreamRoomKnowledgeBaseUpdate: LivestreamRoomOutput;
  /** Sets a legacy livestream room's language exactly once, on a room in the caller's stores; rejects rooms in LIVE or PROVISIONING with FAILED_PRECONDITION, a room whose language is already set with FAILED_PRECONDITION, and a language with no completed voice clone with FAILED_PRECONDITION. Not an editor — a room's language can never be changed once set. */
  livestreamRoomLanguageSet: LivestreamRoomLanguageSetPayload;
  /** Creates or updates the LLM Reply configuration for a livestream room. */
  livestreamRoomLlmConfigUpsert: LivestreamRoomLlmConfigGql;
  /** Updates the LLM Reply master switch of a livestream room — whether the LLM Reply pipeline runs at all, distinct from the LLM Reply Mode which only decides how an answer already generated is delivered. STAFF/ADMIN only; rejects rooms in LIVE or PROVISIONING with FAILED_PRECONDITION. Changes take effect after restarting the stream. */
  livestreamRoomLlmReplyEnabledUpdate: LivestreamRoomLlmReplyEnabledUpdatePayload;
  /** Updates a livestream room's LLM Reply Mode — whether every generated LLM answer is spoken, posted as text, or both. STAFF/ADMIN only; rejects rooms in LIVE or PROVISIONING with FAILED_PRECONDITION. A separate setting from the FAQ Reply Mode. */
  livestreamRoomLlmReplyModeUpdate: LivestreamRoomLlmReplyModeUpdatePayload;
  /** Creates a livestream room product. FAILED_PRECONDITION (PLATFORM_MANAGED_PRODUCTS) for a momo room that is connected to a live — its products come from that live; an unconnected momo room takes hand-made products. */
  livestreamRoomProductCreate: LivestreamRoomProductOutput;
  /** Deletes multiple livestream room products of one room, with their paragraphs, FAQs and decorations. FAILED_PRECONDITION (PLATFORM_MANAGED_PRODUCTS) for a momo room that is connected to a live — its products come from that live; an unconnected momo room's products can be deleted by hand. */
  livestreamRoomProductDeleteBulk: Array<LivestreamRoomProductOutput>;
  /** Creates multiple livestream room product FAQs in a single atomic operation. */
  livestreamRoomProductFaqBulkCreate: Array<LivestreamRoomProductFaqOutput>;
  /** Creates a livestream room product FAQ. Only trigger words are required, so a row can be created before its audio is uploaded; the replies the room's FAQ reply mode needs are enforced on update. */
  livestreamRoomProductFaqCreate: LivestreamRoomProductFaqOutput;
  /** Removes the custom-video comment action of a product FAQ from storage and clears its metadata. */
  livestreamRoomProductFaqCustomVideoRemove: LivestreamRoomProductFaqOutput;
  /** Generates or regenerates the audio of a product FAQ's custom-video replacement script, using the room's voice/speed/pitch/emotion and pronunciation rules. Rejected when the custom video is not in REPLACEMENT_TEXT mode (no replacement script). Distinct from livestreamRoomProductFaqTtsGenerate, which generates the FAQ's own answer audio. Safe to call again to regenerate — a prior in-flight generation for the same custom video is cancelled first. */
  livestreamRoomProductFaqCustomVideoTtsGenerate: LivestreamRoomProductFaqOutput;
  /** Attaches or replaces the custom-video comment action of a product FAQ after upload completes. */
  livestreamRoomProductFaqCustomVideoUpdate: LivestreamRoomProductFaqOutput;
  /** Deletes multiple livestream room product FAQs. */
  livestreamRoomProductFaqDeleteBulk: Array<LivestreamRoomProductFaqOutput>;
  /** Reassigns a product FAQ to a different product. */
  livestreamRoomProductFaqReassign: LivestreamRoomProductFaqOutput;
  /** Moves a product FAQ to the unmatched section. */
  livestreamRoomProductFaqSendToUnmatched: LivestreamRoomProductFaqOutput;
  /** Generates or regenerates the answer audio of a product FAQ from its answer text, using the room's voice/speed/pitch/emotion and pronunciation rules. Clears any uploaded voiceReplyUrl — the two audio sources are mutually exclusive. Safe to call again to regenerate — a prior in-flight generation for the same FAQ is cancelled first. */
  livestreamRoomProductFaqTtsGenerate: LivestreamRoomProductFaqOutput;
  /** Updates a livestream room product FAQ. */
  livestreamRoomProductFaqUpdate: LivestreamRoomProductFaqOutput;
  /** Removes the voice reply audio of a product FAQ from storage and clears its URL. */
  livestreamRoomProductFaqVoiceRemove: LivestreamRoomProductFaqOutput;
  /** Updates the voice reply URL of a product FAQ after audio upload completes. */
  livestreamRoomProductFaqVoiceUrlUpdate: LivestreamRoomProductFaqOutput;
  /** Updates the LLM product knowledge for a single room product. */
  livestreamRoomProductLlmKnowledgeUpdate: LivestreamRoomProductOutput;
  /** Deletes the audio of a livestream room product paragraph. */
  livestreamRoomProductParagraphAudioDelete: LivestreamRoomProductParagraphOutput;
  /** Creates a livestream room product paragraph. */
  livestreamRoomProductParagraphCreate: LivestreamRoomProductParagraphOutput;
  /** Deletes multiple livestream room product paragraphs. */
  livestreamRoomProductParagraphDeleteBulk: Array<LivestreamRoomProductParagraphOutput>;
  /** Reorders livestream room product paragraphs by assigning order_index based on position in the list. */
  livestreamRoomProductParagraphReorder: Scalars['Boolean']['output'];
  /** Updates a livestream room product paragraph. */
  livestreamRoomProductParagraphUpdate: LivestreamRoomProductParagraphOutput;
  /** Deletes the closeup video of a livestream room product paragraph. Also updates the product's stored decoration preview in the same transaction: pass decorationPreviewGcsObjectKey to persist a freshly rendered composite; omit it and the stored preview is cleared, since the previous image no longer matches the canvas. */
  livestreamRoomProductParagraphVideoDelete: LivestreamRoomProductParagraphOutput;
  /** Saves the closeup video URL for a livestream room product paragraph after upload. Fails with FAILED_PRECONDITION when the product's 2 foreground video slots are already filled by foreground decoration videos — the playing close-up needs one slot, so close-ups require at most 1 foreground decoration video on the product. The number of paragraphs with close-ups is not limited (only one plays at a time); see livestreamRoom.products.canAddCloseupVideo. Also updates the product's stored decoration preview in the same transaction: pass decorationPreviewGcsObjectKey to persist a freshly rendered composite; omit it and the stored preview is cleared, since the previous image no longer matches the canvas. */
  livestreamRoomProductParagraphVideoUrlUpdate: LivestreamRoomProductParagraphOutput;
  /** Reorders livestream room products by assigning order_index based on the provided list position. Does not delete absent products. */
  livestreamRoomProductReorder: Scalars['Boolean']['output'];
  /** Replaces which catalogue product occupies one room product slot: writes `name`, `productId`, `productCoverUrl` and `url` onto the existing row and leaves everything else as it was — scripts, FAQs, decorations, avatar, look, lip-sync mode, order and product knowledge. `productId`, `productCoverUrl` and `url` are absolute, so null clears them; with no `productId` the slot becomes a blank product. Resets a COMPOSED/COMPLETED room to PENDING like any other product edit. FAILED_PRECONDITION (PLATFORM_MANAGED_PRODUCTS) for a momo room that is connected to a live — its products come from that live. */
  livestreamRoomProductReplace: LivestreamRoomProductOutput;
  /** Applies an avatar to a specific product or all products in a room. */
  livestreamRoomProductSelectAvatar: Array<LivestreamRoomProductOutput>;
  /** Updates a livestream room product. */
  livestreamRoomProductUpdate: LivestreamRoomProductOutput;
  /** Updates the Q&A scripts master switch of a livestream room. STAFF/ADMIN only; rejects rooms in LIVE or PROVISIONING with FAILED_PRECONDITION. Changes take effect after restarting the stream. */
  livestreamRoomQaScriptsEnabledUpdate: LivestreamRoomQaScriptsEnabledUpdatePayload;
  /** Select a scheduled Rakuten livestream for a live room */
  livestreamRoomRakutenLivestreamSelect: LivestreamRoomOutput;
  /** Updates the reply trigger frequency of a livestream room. */
  livestreamRoomReplyFrequencyUpdate: LivestreamRoomOutput;
  /** Updates the reply timing of a livestream room. */
  livestreamRoomReplyTimingUpdate: LivestreamRoomOutput;
  /** Updates the response strategy settings (conversion mode, duplicate window, low-conversion fallback) of a livestream room. */
  livestreamRoomResponseStrategyUpdate: LivestreamRoomResponseStrategyUpdatePayload;
  /** Replaces the room's full product-set list. Raises FAILED_PRECONDITION (SHOPEE_PRODUCT_SETS_UNSUPPORTED) when the room is not in Shopee Seller Center session mode. Raises INVALID_ARGUMENT when any setId is not a numeric string, when more than 20 sets are provided, or when set IDs are not unique. */
  livestreamRoomShopeeProductSetsSave: Array<ShopeeProductSetOutput>;
  /** Assigns an unmatched FAQ to a product, removing it from the unmatched section. */
  livestreamRoomUnmatchedFaqAssignToProduct: LivestreamRoomUnmatchedFaqOutput;
  /** Creates multiple livestream room unmatched FAQs in a single atomic operation. */
  livestreamRoomUnmatchedFaqBulkCreate: Array<LivestreamRoomUnmatchedFaqOutput>;
  /** Creates a livestream room unmatched FAQ. */
  livestreamRoomUnmatchedFaqCreate: LivestreamRoomUnmatchedFaqOutput;
  /** Deletes multiple livestream room unmatched FAQs. */
  livestreamRoomUnmatchedFaqDeleteBulk: Array<LivestreamRoomUnmatchedFaqOutput>;
  /** Updates a livestream room unmatched FAQ. */
  livestreamRoomUnmatchedFaqUpdate: LivestreamRoomUnmatchedFaqOutput;
  /** Removes the voice reply audio of an unmatched FAQ from storage and clears its URL. */
  livestreamRoomUnmatchedFaqVoiceRemove: LivestreamRoomUnmatchedFaqOutput;
  /** Updates the voice reply URL of an unmatched FAQ after audio upload completes. */
  livestreamRoomUnmatchedFaqVoiceUrlUpdate: LivestreamRoomUnmatchedFaqOutput;
  /** Updates a livestream room. */
  livestreamRoomUpdate: LivestreamRoomOutput;
  /** Updates a livestream room's voice settings (voice clone, speed, pitch, emotion) — the one voice shared by Q&A scripts, atmosphere, closing scripts and FAQ audio. */
  livestreamRoomVoiceSettingsUpdate: LivestreamRoomVoiceConfigGql;
  /** Saves platform configuration for a livestream session. For Shopee rooms, provide shopeeConfig. For TikTok rooms, provide tiktokConfig. Rakuten, BytePlus and momo rooms take no platform config — call livestreamSessionStart directly. */
  livestreamSessionSavePlatformConfig: LivestreamSessionOutput;
  /** Set or clear the scheduled end time for a live stream session. Pass null for scheduledEndTime to remove an existing scheduled end. */
  livestreamSessionScheduleEnd: Scalars['Boolean']['output'];
  /** Schedules the room's current session to go live by itself, or clears an existing schedule (pass null for scheduledStartTime). momo rooms only — the room must be connected to a momo live, and scheduledStartTime must be exactly that live's startAt (any other value is refused as SCHEDULED_START_TIME_MISMATCH: reload and try again). The room must be composed (COMPOSED or COMPLETED) with a READY current session. Once scheduled, the room prepares itself 14 minutes before the start time and streams at the start time; from 15 minutes before the start the schedule is locked and can neither be changed nor cleared (SCHEDULED_START_LOCKED) — stop the livestream to cancel it. Since 2026-09-16 a composed momo room connected to a live is scheduled automatically (on compose, connect and every momo schedule sync) and the FE shows the schedule as a read-only status instead of calling this. The mutation is deliberately kept: it is the hand-set scheduled-start API that a configurable scheduled start for the other platforms will build on in a later stage, and it applies the same rules. Read the current value back as livestreamRoom.activeSession.scheduledStartTime. */
  livestreamSessionScheduleStart: Scalars['Boolean']['output'];
  /** Starts a prepared control-panel livestream and returns the room's current session ID. Asynchronous: success means the start was accepted and asset warm-up has begun — the room turns PROVISIONING now and LIVE once warming completes (watch the room status). For momo rooms the warm-up callback uploads the room's product scripts to momo and streams to the push URL momo returns; the start fails fast (FAILED_PRECONDITION) when the room is not connected to a momo live, or when that live was cancelled or has already ended. A momo start is accepted at any time before the live's stopAt, however far ahead of its startAt — momo hides the room from viewers until then. */
  livestreamSessionStart: Scalars['ID']['output'];
  /** Stops a control-panel livestream. */
  livestreamSessionStop: Scalars['Boolean']['output'];
  /** Pins a different product on a live session: queues a switch that takes effect at the next clip boundary (same mechanism an FAQ- or comment-triggered switch uses). RUNNING sessions only — FAILED_PRECONDITION otherwise. roomProductId must belong to this session's room. */
  livestreamSessionSwitchProduct: Scalars['Boolean']['output'];
  /** Returns the best available worker node for scheduling. */
  livestreamSessionWorkerNodeSchedulerAssign: LivestreamSessionWorkerNodeOutput;
  logilessOAuth: StatusOk;
  /** Apply a person's matching between this room's products and the goods of a momo live, in one transaction: goods matched to an existing product keep that product, with its product_id set to the goodsCode when it differs ('relinked') and its name always set to momo's goodsName ('renamed' when it differed — momo owns a connected room's catalogue, so an operator's edit does not survive a match), goods matched to nothing get a new product (name = goodsName, product_id = goodsCode, inheriting the room's avatar, look and lip-sync mode, appended at the end), and every product listed in deleteProductIds is deleted with its scripts, FAQs and decorations. Every room product must be either matched once or deleted, and matches must name exactly momo's current goods (INVALID_ARGUMENT otherwise — reload with checkMomoConnection). When momoConnectionId is not in the room's queue, the room switches to it in the same transaction: every live it held is released, except those named again in additionalMomoConnectionIds. When it is in the queue, the queue stays and every other open queued live must list the same goods in the same order (INVALID_ARGUMENT on field `queue`, GOODS_MISMATCH, naming each one that does not — remove them first). additionalMomoConnectionIds queue more lives in the same call (INVALID_ARGUMENT on that field for GOODS_MISMATCH / OVERLAP). A product added or deleted resets a COMPOSED/COMPLETED room to PENDING; a relink, a rename or a pure reconnect leaves the status alone. FAILED_PRECONDITION: NOT_MOMO_ROOM, ROOM_NOT_EDITABLE, LIVE_CANCELLED, LIVE_ALREADY_FINISHED, CONNECTION_ALREADY_BOUND / ENTP_CODE_MISMATCH (candidate or additional live), MOMO_API_ERROR; UPSTREAM_UNAVAILABLE when momo cannot be reached. */
  matchMomoProduct: MatchMomoProductOutput;
  /** Queue more momo lives on a MOMO room that already has a live that has not finished (ROOM_NOT_BOUND otherwise), in any room status — a live room included. Lives already in the room's queue are ignored. Each new live must pass the setMomoConnection gates (CONNECTION_ALREADY_BOUND, LIVE_CANCELLED, LIVE_ALREADY_FINISHED, ENTP_CODE_MISMATCH; the first failing live fails the whole call), list the same goods in the same order as the room's current live and overlap no queued live (INVALID_ARGUMENT on momoConnectionIds: GOODS_MISMATCH / OVERLAP). Nothing is written on any failure. Answers the queue afterwards. */
  momoConnectionQueueAdd: MomoConnectionQueueOutput;
  /** Remove one momo live from a MOMO room's queue, in any room status. A cancelled or finished live can be removed at any time, an open one until 15 minutes before its startAt (QUEUE_ENTRY_LOCKED after that), and never the live the room is warming up for or streaming to (QUEUE_ENTRY_IN_USE). CONNECTION_NOT_IN_QUEUE when the live is not in this room's queue. The room's Auto Start moves on to the next live. Answers the queue afterwards. */
  momoConnectionQueueRemove: MomoConnectionQueueOutput;
  /**
   * Sets or clears (null/blank) the MOMO entpCode of the store's MOMO sale channel, creating the channel on first use. Independent of the MOMO CSV upload flows, which keep reusing the same channel.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `DUPLICATE_MOMO_ENTP_CODE`, `STORE_NOT_ACCESSIBLE`, `UNAUTHORIZED`
   */
  momoSaleChannelEntpCodeSet: Scalars['Long']['output'];
  /**
   * Cancel a marketplace order.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INTERNAL_ERROR`, `INVALID_REQUEST`, `NON_CANCELABLE`, `TRY_AGAIN_LATER`, `UNAUTHORIZED`
   */
  orderCancel: CancelOrderPayload;
  /**
   * ignore address validation error for order.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INTERNAL_ERROR`, `INVALID_REQUEST`, `TRY_AGAIN_LATER`, `UNAUTHORIZED`
   */
  orderIgnoreAddressValidationError: OrderIgnoreAddressValidationErrorPayload;
  /**
   * Create a marketplace order.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INTERNAL_ERROR`, `INVALID_REQUEST`, `ORDER_ALREADY_EXIST`, `STORE_NOT_FOUND`, `TRY_AGAIN_LATER`, `UNAUTHORIZED`, `VALIDATION_ERROR`
   * ▸ SubErrorReasons: `INVALID_CUSTOMER_EMAIL_FORMAT()`, `NOT_ALLOWED_PAYMENT_METHOD_COD()`, `QUANTITY_EXCEEDED()`
   */
  orderManualCreate: Scalars['Long']['output'];
  /**
   * Update the manual order. without logistics.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INVALID_REQUEST`, `NOT_FOUND`, `UNAUTHORIZED`, `VALIDATION_ERROR`
   * ▸ SubErrorReasons: `INVALID_CUSTOMER_EMAIL_FORMAT()`, `NOT_ALLOWED_PAYMENT_METHOD_COD()`, `QUANTITY_EXCEEDED()`
   */
  orderManualUpdateV2: Scalars['Long']['output'];
  /**
   * Update a marketplace order. with logistics.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INTERNAL_ERROR`, `INVALID_REQUEST`, `NOT_FOUND`, `TRY_AGAIN_LATER`, `UNAUTHORIZED`, `VALIDATION_ERROR`
   * ▸ SubErrorReasons: `INVALID_CUSTOMER_EMAIL_FORMAT()`, `NOT_ALLOWED_PAYMENT_METHOD_COD()`, `QUANTITY_EXCEEDED()`
   */
  orderManualUpdateWithLogi: Scalars['Long']['output'];
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `DUPLICATED_PRODUCT_CODE`, `INVALID_HS_CODE`, `INVALID_REQUEST`, `UNAUTHORIZED`, `VALIDATION_ERROR`
   * ▸ SubErrorReasons: `CANNOT_ASSIGN_SET_VARIANTS_TO_SET_CHILD(productVariantId: long)`, `CANNOT_BECOME_SET_VARIANT_SINCE_ITS_USED_AS_SET_CHILD(productVariantId: long)`, `PRODUCT_VARIANT_IN_USE_INBOUND(productVariantId: long)`, `PRODUCT_VARIANT_IN_USE_INVENTORY(productVariantId: long)`, `PRODUCT_VARIANT_IN_USE_ORDER(productVariantId: long)`, `PRODUCT_VARIANT_SET_CANNOT_CONTAIN_ITSELF(productVariantId: long)`
   */
  productCreateV2: Scalars['Long']['output'];
  /** Creates a new product FAQ. */
  productFaqCreate: ProductFaq;
  /** Deletes a product FAQ. */
  productFaqDelete: Scalars['Boolean']['output'];
  /** Updates an existing product FAQ. */
  productFaqUpdate: Scalars['Boolean']['output'];
  /**
   *     Update a marketplace product with variants
   *     ValidationError can have sub errors in "extensions.errors" field
   *     .
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   * ▸ SubErrorReasons: `CANNOT_ASSIGN_SET_VARIANTS_TO_SET_CHILD(productVariantId: long)`, `CANNOT_BECOME_SET_VARIANT_SINCE_ITS_USED_AS_SET_CHILD(productVariantId: long)`, `PRODUCT_VARIANT_IN_USE_INBOUND(productVariantId: long)`, `PRODUCT_VARIANT_IN_USE_INVENTORY(productVariantId: long)`, `PRODUCT_VARIANT_IN_USE_ORDER(productVariantId: long)`, `PRODUCT_VARIANT_SET_CANNOT_CONTAIN_ITSELF(productVariantId: long)`
   */
  productUpdateWithMultiVariants: Scalars['Long']['output'];
  /**
   *     Update a marketplace product with single variant
   *     ValidationError can have sub errors in "extensions.errors" field
   *     .
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INVALID_HS_CODE`, `INVALID_REQUEST`, `NOT_FOUND`, `UNAUTHORIZED`, `VALIDATION_ERROR`
   * ▸ SubErrorReasons: `CANNOT_ASSIGN_SET_VARIANTS_TO_SET_CHILD(productVariantId: long)`, `CANNOT_BECOME_SET_VARIANT_SINCE_ITS_USED_AS_SET_CHILD(productVariantId: long)`, `PRODUCT_VARIANT_IN_USE_INBOUND(productVariantId: long)`, `PRODUCT_VARIANT_IN_USE_INVENTORY(productVariantId: long)`, `PRODUCT_VARIANT_IN_USE_ORDER(productVariantId: long)`, `PRODUCT_VARIANT_SET_CANNOT_CONTAIN_ITSELF(productVariantId: long)`
   */
  productUpdateWithSingleVariant: Scalars['Long']['output'];
  /**
   *     Update a marketplace product variant.
   *     this will be used for variant detail page like this (https://app.any-x.com/product/210456/654998)
   *     ValidationError can have sub errors in "extensions.errors" field
   *     .
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INVALID_HS_CODE`, `INVALID_REQUEST`, `NOT_FOUND`, `UNAUTHORIZED`, `VALIDATION_ERROR`
   * ▸ SubErrorReasons: `CANNOT_ASSIGN_SET_VARIANTS_TO_SET_CHILD(productVariantId: long)`, `CANNOT_BECOME_SET_VARIANT_SINCE_ITS_USED_AS_SET_CHILD(productVariantId: long)`, `PRODUCT_VARIANT_IN_USE_INBOUND(productVariantId: long)`, `PRODUCT_VARIANT_IN_USE_INVENTORY(productVariantId: long)`, `PRODUCT_VARIANT_IN_USE_ORDER(productVariantId: long)`, `PRODUCT_VARIANT_SET_CANNOT_CONTAIN_ITSELF(productVariantId: long)`
   */
  productVariantUpdateV3: Scalars['Long']['output'];
  /**
   * Merge marketplace product variants into one.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `IN_USE`, `MIXED_PRODUCT_VARIANT_TYPE`, `NOT_FOUND`, `UNAUTHORIZED`
   */
  productVariantsMergeV3: MergeProductVariantV3Output;
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INVALID_CREDENTIAL`, `SALE_CHANNEL_ALREADY_EXISTS`, `STORE_NOT_FOUND`, `UNAUTHORIZED`
   */
  qoo10SaleChannelCreate: Scalars['Long']['output'];
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INVALID_CREDENTIAL`, `SALE_CHANNEL_NOT_FOUND`, `STORE_ALREADY_CONNECTED`, `STORE_NOT_FOUND`, `UNAUTHORIZED`
   */
  qoo10SaleChannelReconnect: Scalars['Long']['output'];
  /**
   * Reconnect to Rakuten using licenseKey.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INVALID_CREDENTIAL`, `SALE_CHANNEL_NOT_FOUND`, `STORE_NOT_FOUND`, `UNAUTHORIZED`
   */
  reconnectRakuten: RakutenReconnectPayload;
  /**
   *             Sale channel file upload.
   *             VALIDATION_ERROR has SubErrorReasons in "extensions.errors" field.
   *         .
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `ANOTHER_FILE_UPLOAD_IN_PROGRESS`, `SALE_CHANNEL_NOT_FOUND`, `STORE_NOT_FOUND`, `UNAUTHORIZED`, `UNKNOWN_IMPORT_TYPE`, `VALIDATION_ERROR`
   * ▸ SubErrorReasons: `COLUMN_COUNT_MISS_MATCH(lineNumbers: List)`, `EMPTY_DATA()`, `EMPTY_REQUIRED_FIELD(lineNumbers: List, columnName: String)`, `FILE_NOT_FOUND_OR_TOO_LARGE()`, `HEADER_MISS_MATCH(columnNames: List)`, `INVALID_FORMAT(lineNumbers: List, columnName: String)`, `MISSING_COLUMNS(columnNames: List)`, `PHONE_NUMBER_AND_COUNTRY_NOT_MATCH(lineNumbers: List)`
   */
  registerFileUploadV3: RegisterFileUploadPayload;
  /**
   * Trigger a task for uploading manual integration orders by CSV.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `ANOTHER_FILE_UPLOAD_IN_PROGRESS`, `INVALID_REQUEST`, `UNAUTHORIZED`, `VALIDATION_ERROR`
   * ▸ SubErrorReasons: `BODY_COLUMN_COUNT_MISMATCH(indexes: List)`, `DOES_NOT_MATCH_WITHIN_ORDER(columnName: String, indexes: List)`, `DUPLICATE_SELLER_SKUCODE_WITHIN_ORDER(orderIds: List)`, `EMPTY_DATA()`, `EMPTY_REQUIRED_FIELD(columnName: String, indexes: List)`, `FILE_NOT_FOUND_OR_TOO_LARGE()`, `HEADER_COLUMN_COUNT_MISMATCH()`, `HEADER_MISMATCH(columnNames: List)`, `INVALID_FORMAT(columnName: String, indexes: List)`, `INVALID_PAYMENT_METHOD(columnName: String, indexes: List)`, `INVALID_ZIP_CODE(columnName: String, indexes: List)`, `ORDER_IDS_ALREADY_EXIST(orderIds: List)`, `SELLER_SKUCODES_DOES_NOT_EXIST(sellerSkuCodes: List)`
   */
  registerManualIntegrationOrderCsvUpload: RegisterManualIntegrationOrderCsvPayload;
  /**
   * Trigger a task for uploading manual integration products by CSV.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `ANOTHER_FILE_UPLOAD_IN_PROGRESS`, `INVALID_REQUEST`, `UNAUTHORIZED`, `VALIDATION_ERROR`
   * ▸ SubErrorReasons: `BODY_COLUMN_COUNT_MISMATCH(indexes: List)`, `DOESNT_MATCH_WITHIN_PRODUCT(indexes: List, columnName: String)`, `DUPLICATE_PRODUCT_CODE(productCodes: List)`, `DUPLICATE_VARIANT_NAME(variantNames: List)`, `EMPTY_DATA()`, `EMPTY_REQUIRED_FIELD(indexes: List, columnName: String)`, `EMPTY_VARIANT_NAME_WHEN_GROUPING(indexes: List)`, `FILE_NOT_FOUND_OR_TOO_LARGE()`, `HEADER_COLUMN_COUNT_MISMATCH()`, `HEADER_MISMATCH(columnNames: List)`, `INVALID_FORMAT(indexes: List, columnName: String)`
   */
  registerManualIntegrationProductCsvUpload: RegisterManualIntegrationProductCsvPayload;
  /**
   * Creates a task to import MANUAL orders via CSV.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `ANOTHER_FILE_UPLOAD_IN_PROGRESS`, `UNAUTHORIZED`, `VALIDATION_ERROR`
   * ▸ SubErrorReasons: `BODY_COLUMN_COUNT_MISMATCH(indexes: List)`, `DOES_NOT_MATCH_WITHIN_ORDER(columnName: String, indexes: List)`, `DUPLICATE_ORDER_ID(orderIds: List)`, `DUPLICATE_PRODUCT_CODE_WITHIN_ORDER(orderIds: List)`, `EMPTY_DATA()`, `EMPTY_REQUIRED_FIELD(columnName: String, indexes: List)`, `FILE_NOT_FOUND_OR_TOO_LARGE()`, `HEADER_COLUMN_COUNT_MISMATCH(indexes: List)`, `HEADER_MISMATCH(columnNames: List)`, `INVALID_COURIER_SERVICE_FOR_PAYMENT_METHOD(courierService: String, paymentMethod: String, index: int)`, `INVALID_FORMAT(columnName: String, indexes: List)`, `INVALID_LENGTH_FOR_PRODUCT_AND_PRICES(indexes: List)`, `INVALID_LENGTH_FOR_PRODUCT_AND_QUANTITIES(indexes: List)`, `INVALID_PAYMENT_METHOD(columnName: String, indexes: List)`, `INVALID_ZIP_CODE(columnName: String, indexes: List)`, `NOT_ALLOWED_PAYMENT_METHOD_COD(orderIds: List)`, `PRODUCT_CODE_DOES_NOT_EXIST(productCodes: List)`, `QUANTITY_EXCEEDED(columnName: String, indexes: List)`
   */
  registerManualOrderCsvUploadV2: RegisterManualOrderCsvUploadPayload;
  /**
   * Trigger a task for uploading set products by CSV.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `ANOTHER_FILE_UPLOAD_IN_PROGRESS`, `UNAUTHORIZED`, `VALIDATION_ERROR`
   * ▸ SubErrorReasons: `BODY_COLUMN_COUNT_MISMATCH(indexes: List)`, `CHILD_PRODUCTS_ALREADY_SET_PRODUCT(productCodes: List)`, `CHILD_PRODUCTS_NOT_FOUND(productCodes: List)`, `DOESNT_MATCH_WITHIN_SET(indexes: List, columnName: String)`, `DUPLICATE_CHILD_PRODUCT_CODES_WITHIN_SET(productCodes: List)`, `DUPLICATE_PRODUCT_CODE(productCodes: List)`, `EMPTY_DATA()`, `EMPTY_REQUIRED_FIELD(indexes: List, columnName: String)`, `FILE_NOT_FOUND_OR_TOO_LARGE()`, `HEADER_COLUMN_COUNT_MISMATCH()`, `HEADER_MISMATCH(columnNames: List)`, `INVALID_CHILD_PRODUCT_QUANTITY(productCodes: List)`, `INVALID_FORMAT(indexes: List, columnName: String)`, `INVALID_SUPPLIERS(supplierIds: List)`, `PRODUCT_CODE_EXISTS(productCodes: List)`
   */
  registerManualSetProductCsvUpload: ManualSetProductCsvUploadPayload;
  /**
   * Trigger a task for uploading single products by CSV.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `ANOTHER_FILE_UPLOAD_IN_PROGRESS`, `UNAUTHORIZED`, `VALIDATION_ERROR`
   * ▸ SubErrorReasons: `BODY_COLUMN_COUNT_MISMATCH(indexes: List)`, `DOESNT_MATCH_WITHIN_PRODUCT(indexes: List, columnName: String)`, `DUPLICATE_PRODUCT_CODE(productCodes: List)`, `DUPLICATE_VARIANT_NAME(variantNames: List)`, `EMPTY_DATA()`, `EMPTY_REQUIRED_FIELD(indexes: List, columnName: String)`, `EMPTY_VARIANT_NAME_WHEN_GROUPING(indexes: List)`, `FILE_NOT_FOUND_OR_TOO_LARGE()`, `HEADER_COLUMN_COUNT_MISMATCH()`, `HEADER_MISMATCH(columnNames: List)`, `INVALID_FORMAT(indexes: List, columnName: String)`, `INVALID_SUPPLIERS(supplierIds: List)`, `PRODUCT_CODE_EXISTS(productCodes: List)`
   */
  registerManualSingleProductCsvUpload: ManualSingleProductCsvUploadPayload;
  /**
   * Trigger a task for uploading update products by CSV.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `ANOTHER_FILE_UPLOAD_IN_PROGRESS`, `INVALID_REQUEST`, `UNAUTHORIZED`, `VALIDATION_ERROR`
   * ▸ SubErrorReasons: `BODY_COLUMN_COUNT_MISMATCH(indexes: List)`, `DOES_NOT_MATCH_WITHIN_PRODUCT(indexes: List, columnName: String)`, `DUPLICATE_PRODUCT_CODE(productCodes: List)`, `DUPLICATE_WAREHOUSE_CODES(warehouseCodes: List)`, `EMPTY_DATA()`, `EMPTY_REQUIRED_FIELD(indexes: List, columnName: String)`, `FILE_NOT_FOUND_OR_TOO_LARGE()`, `HEADER_COLUMN_COUNT_MISMATCH()`, `HEADER_MISMATCH(columnNames: List)`, `INVALID_COURIER_SERVICES(courierServices: List)`, `INVALID_FORMAT(indexes: List, columnName: String)`, `INVALID_PRODUCT_CODES(productCodes: List)`, `INVALID_SUPPLIER_IDS(supplierIds: List)`, `INVALID_WAREHOUSE_CODES(warehouseCodes: List)`, `PRODUCT_CODE_CANNOT_CHANGE(productCodes: List)`, `PRODUCT_CODE_EXISTS(productCodes: List)`, `PRODUCT_ID_DOES_NOT_MATCH(productIds: List)`, `PRODUCT_VARIANT_NOT_FOUND(variantIds: List)`, `WAREHOUSE_CODE_CANNOT_CHANGE(warehouseCodes: List)`, `WAREHOUSE_CODE_EXISTS(warehouseCodes: List)`
   */
  registerManualUpdateProductCsvUpload: ManualUpdateProductCsvUploadPayload;
  reinviteAnylogiSupplierUsers: BulkOperationResponse;
  /** Rolls back a closing script to a target revision. */
  rollbackClosingScript: AnyLiveClosingScript;
  /** Rolls a fallback template back to a past revision's content. */
  rollbackFallbackTemplate: AnyLiveFallbackTemplate;
  /** Rolls a sensitive word back to a past revision's content. */
  rollbackSensitiveWord: AnyLiveSensitiveWord;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Save ad cost campaign mapping
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   *         |`INVALID_INPUT`|Invalid arguments
   */
  saveAdCostCampaignMapping: AdCostCampaignMappingSavePayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Save adset mapping
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   *         |`INVALID_INPUT`|Invalid arguments
   */
  saveAdSetMapping: AdSetMappingSavePayload;
  /** Save DDI product status */
  saveDdiProductStatus: OperationResultPayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Create cost index for a sale channel.
   *
   *         Shopify:
   *         - creditCardFeePercentage (%)
   *
   *         Amazon:
   *         - referralFeeSoldPercentage (%)
   *
   *         Rakuten:
   *         - rakutenSystemFeePercentage (%)
   *         - rakutenPayFeePercentage (%)
   *
   *         Shopee, Lazada:
   *         - commissionFeePercentage (%)
   *         - transactionFeePercentage (%)
   *
   *         TikTok:
   *         - commissionFeePercentage (%)
   *         - flatFee: 100.1
   *
   *         Yahoo:
   *         - resourceBurdenRatioPercentage (%)
   *         - transactionFeePercentage (%)
   *
   *         ZOZOTOWN:
   *         - commissionFeePercentage (%)
   *
   *         Tokopedia:
   *         - commissionFeePercentage (%)
   *         - freeShippingFeeAdjustmentPercentage (%)
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`INVALID_INPUT`|Invalid arguments
   */
  saveSaleChannelCostIndex: SaleChannelCostIndexPayload;
  /**
   * Clears all TTS generation IDs from script content for a given script version.
   * @deprecated Use liveAssetContentClearTts instead, replace with liveAssetContentClearTts
   */
  scriptContentClearTts: Scalars['Boolean']['output'];
  /**
   * Creates a new script content.
   * @deprecated Use liveAssetContentCreate instead, replace with liveAssetContentCreate
   */
  scriptContentCreate: ScriptContentOutput;
  /**
   * Reorders script content and deletes content not in the provided list.
   * @deprecated Use liveAssetContentReorder instead, replace with liveAssetContentReorder
   */
  scriptContentReorder: Scalars['Boolean']['output'];
  /**
   * Updates the content of a script section.
   * @deprecated Use liveAssetContentUpdate instead, replace with liveAssetContentUpdate
   */
  scriptContentUpdate: Scalars['Boolean']['output'];
  /**
   * Creates a script.
   * @deprecated Use liveAssetCreate instead, replace with liveAssetCreate
   */
  scriptCreate: ScriptVersionOutput;
  /**
   * Deletes multiple scripts.
   * @deprecated Use liveAssetDeleteBulk instead, replace with liveAssetDeleteBulk
   */
  scriptDeleteBulk: Array<ScriptOutput>;
  /**
   * Duplicates multiple scripts.
   * @deprecated Use liveAssetDuplicateBulk instead, replace with liveAssetDuplicateBulk
   */
  scriptDuplicateBulk: Array<ScriptOutput>;
  /**
   * Submits script generation for asynchronous processing.
   * @deprecated Use liveAssetGenerationSubmit instead, replace with liveAssetGenerationSubmit
   */
  scriptGenerationSubmit: ScriptVersionOutput;
  /**
   * Updates a script.
   * @deprecated Use liveAssetUpdate instead, replace with liveAssetUpdate
   */
  scriptUpdate: ScriptOutput;
  /**
   * Deletes a script version.
   * @deprecated Use liveAssetVersionDeleteBulk instead, replace with liveAssetVersionDeleteBulk
   */
  scriptVersionDeleteBulk: Array<ScriptVersionOutput>;
  /**
   * Duplicate a script version.
   * @deprecated Use liveAssetVersionDuplicate instead, replace with liveAssetVersionDuplicate
   */
  scriptVersionDuplicate: ScriptVersionOutput;
  /**
   * Duplicates multiple script versions.
   * @deprecated Use liveAssetVersionDuplicateBulk instead, replace with liveAssetVersionDuplicateBulk
   */
  scriptVersionDuplicateBulk: Array<ScriptVersionOutput>;
  /**
   * Updates a script version.
   * @deprecated Use liveAssetVersionUpdate instead, replace with liveAssetVersionUpdate
   */
  scriptVersionUpdate: ScriptVersionOutput;
  /**
   * Updates only the version name of a script version.
   * @deprecated Use liveAssetVersionUpdateVersionName instead, replace with liveAssetVersionUpdateVersionName
   */
  scriptVersionUpdateVersionName: ScriptVersionOutput;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Save adset mapping margin
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   *         |`INVALID_INPUT`|Invalid arguments
   */
  setAdSetMappingMargin: AdSetMappingSetMarginPayload;
  setDeclaredUnitPrices: Scalars['Boolean']['output'];
  setLogisticShopifyCarrierServiceCondition: ShopifyCarrierServiceCondition;
  /** Connect a momo live to an empty, unconnected MOMO livestream room and fill the room's products from momo, in momo's order; additionalMomoConnectionIds queue more lives behind it in the same call. Repeating the call for the same room and lives returns the connection unchanged. FAILED_PRECONDITION when the room is not a MOMO room, already has products or is already connected (ROOM_ALREADY_BOUND — queue more lives with momoConnectionQueueAdd), when a live is cancelled, finished, connected to another room or of a vendor code AnyX does not resolve to the room's store (ENTP_CODE_MISMATCH; the first failing live fails the whole call, its momoConnectionId in the metadata), or when momo rejects a live; INVALID_ARGUMENT on additionalMomoConnectionIds when a live's goods differ from momoConnectionId's (GOODS_MISMATCH) or two lives overlap in time (OVERLAP); UPSTREAM_UNAVAILABLE when momo cannot be reached. */
  setMomoConnection: MomoConnectionOutput;
  shipOrder: StatusOk;
  /** Generates multiple FAQs for a single product using product data and knowledgebase, and saves them to the database. */
  singleProductFaqGenerateAll: SingleProductFaqGenerateAllOutput;
  /** Regenerates a single FAQ for a product using only product data (no knowledgebase). */
  singleProductFaqRegenerate: FaqRegenerateOutput;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Start or refresh competitor analysis for a product.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`INVALID_INPUT`|Invalid arguments
   */
  startProductReviewCompetitorAnalysis: ProductReviewCompetitorAnalysisStatusDto;
  /** Validates against the BytePlus API, then saves (upserts) the store-level API keys. */
  storeConnectionByteplusCredentialSave: StorePlatformConnectionGql;
  /** Deletes a store's credential for one platform, or every platform when platform is null. */
  storeConnectionDelete: StoreConnectionDeleteOutput;
  /** Generates a copyable Facebook authorization link for a store (server-side OAuth). For PAGE targets with several manageable pages, the connection becomes ACTION_REQUIRED until storeConnectionFacebookPageSelect completes it. */
  storeConnectionFacebookAuthUrlGenerate: Scalars['Url']['output'];
  /** Completes a pending Facebook PAGE connection by selecting the managed page. */
  storeConnectionFacebookPageSelect: StorePlatformConnectionGql;
  /** Saves (upserts) the store-level Rakuten session (cookie + localStorage). */
  storeConnectionRakutenCookieSave: StorePlatformConnectionGql;
  /** Generates a copyable Shopee authorization link for a store. The link is portable — send it to the client, who completes the authorization in their own browser. One-time use; stays valid until used. */
  storeConnectionShopeeAuthUrlGenerate: Scalars['Url']['output'];
  /** Saves a Shopee Seller Center session harvested by the browser extension after a manual login. Validates before switching: the store's official grant is destroyed only once the probe proves the cookies work. */
  storeConnectionShopeeSessionCookieSave: StorePlatformConnectionGql;
  /** Saves (upserts) the store-level TikTok session cookie. */
  storeConnectionTiktokCookieSave: StorePlatformConnectionGql;
  /**
   * Set the store's default country of origin; pass null to clear it.
   * ▸ Requires: `ADMIN`, `STAFF`
   * ▸ Throws: `UNAUTHORIZED`, `UNSUPPORTED_COUNTRY_OF_ORIGIN`
   */
  storeSettingCountryOfOrigin: StoreSettingCountryOfOriginUpdateOutput;
  /** Manually trigger a full product catalog sync from the sales channel. */
  syncStoreProducts: Scalars['Boolean']['output'];
  /** Runs a test LLM reply for a given viewer comment using the room's saved settings. Staff and Admin only. */
  testLlmReply: Scalars['String']['output'];
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Exchange TikTok OAuth code to token.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`       |Unauthorized request
   *         |`FORBIDDEN`           |This operation is prohibited
   *         |`TIKTOK_OAUTH_ERROR`  |TikTok OAuth has error
   */
  tikTokAdsExchangeCode: TikTokExchangeCodePayload;
  /** Toggles the active flag of a closing script. */
  toggleClosingScriptActive: AnyLiveClosingScript;
  /** Toggles the active flag of a fallback template and returns it. */
  toggleFallbackTemplateActive: AnyLiveFallbackTemplate;
  /** Toggles the active flag of a sensitive word and returns it. */
  toggleSensitiveWordActive: AnyLiveSensitiveWord;
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INVALID_REQUEST`, `SALE_CHANNEL_ALREADY_EXISTS`, `UNAUTHORIZED`
   */
  tokopediaSaleChannelCreate: Scalars['Long']['output'];
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INVALID_REQUEST`, `SALE_CHANNEL_ALREADY_EXISTS`, `UNAUTHORIZED`
   */
  tokopediaSaleChannelLinkTikTok: Scalars['Long']['output'];
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `ACCESS_NOT_PERMITTED`, `SALE_CHANNEL_NOT_FOUND`, `STORE_ALREADY_CONNECTED`, `STORE_NOT_FOUND`, `UNAUTHORIZED`
   */
  tokopediaSaleChannelReconnect: Scalars['Long']['output'];
  /** Adds a new transition script to a livestream room. */
  transitionScriptAdd: TransitionScriptMutationPayload;
  /** Permanently deletes a transition script. */
  transitionScriptDelete: TransitionScriptDeletePayload;
  /** Triggers asynchronous TTS generation for a transition script using the room's voice clone, speed, pitch, and emotion. Safe to call again to regenerate — a prior in-flight generation for the same script is cancelled first. Poll status/signed URL via Query.ttsInfo(ttsId: transitionScript.ttsGenerationId). */
  transitionScriptGenerateTts: TransitionScriptGenerateTtsPayload;
  /** Updates the text of a transition script. Any existing generated audio stays playable but reads as stale until the operator explicitly regenerates it. */
  transitionScriptUpdate: TransitionScriptMutationPayload;
  /** Removes the voice reply audio of a transition script from storage and clears its URL. */
  transitionScriptVoiceRemove: TransitionScriptMutationPayload;
  /** Updates the voice reply URL of a transition script after audio upload completes. */
  transitionScriptVoiceUrlUpdate: TransitionScriptMutationPayload;
  /** Downloads multiple TTS audio files as a zip archive. */
  ttsBatchDownload: TtsBatchDownloadOutput;
  /**
   * Generates TTS voice from FAQ content using a voice clone.
   * @deprecated Use ttsGeneralFaqGenerate or ttsProductFaqGenerate instead
   */
  ttsFaqGenerate: TtsGenerationOutput;
  /**
   * Deprecated: Use ttsGeneralFaqGenerateBulk instead. Generates TTS voice from general FAQ content using a voice clone.
   * @deprecated Use ttsGeneralFaqGenerateBulk instead
   */
  ttsGeneralFaqGenerate: TtsGenerationOutput;
  /** Generates TTS voice for multiple general FAQ contents using a shared voice clone. */
  ttsGeneralFaqGenerateBulk: TtsGenerateBulkOutput;
  /** Generates TTS voice from script content using a voice clone. */
  ttsGenerate: TtsGenerationOutput;
  /** Generates TTS voice for multiple script contents using a shared voice clone. */
  ttsGenerateBulk: TtsGenerateBulkOutput;
  /**
   * Deprecated: Use ttsProductFaqGenerateBulk instead. Generates TTS voice from product FAQ content using a voice clone.
   * @deprecated Use ttsProductFaqGenerateBulk instead
   */
  ttsProductFaqGenerate: TtsGenerationOutput;
  /** Generates TTS voice for multiple product FAQ contents using a shared voice clone. */
  ttsProductFaqGenerateBulk: TtsGenerateBulkOutput;
  /**
   * Unarchive product variants.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `ALREADY_UNARCHIVED`, `NOT_FOUND`, `UNAUTHORIZED`
   */
  unarchiveProductVariants: UnarchiveProductVariantsOutput;
  /** Disconnect every momo live of a MOMO room's queue (remove a single one with momoConnectionQueueRemove) and answer the earliest of them. The room keeps its products, scripts, FAQs and decorations and its status; the lives become connectable again (by this room or another). FAILED_PRECONDITION when the room is not a MOMO room (NOT_MOMO_ROOM), not connected (ROOM_NOT_BOUND) or composing / provisioning / live (ROOM_NOT_EDITABLE); NOT_FOUND when the caller cannot see the room. */
  unsetMomoConnection: MomoConnectionOutput;
  updateAIAutoReplySetting?: Maybe<AnyChatOkResponse>;
  updateAnylogiCrossBorderShippingOrder: StatusOk;
  updateAnylogiSupplierUser: StatusOk;
  /** Updates a closing script. */
  updateClosingScript: AnyLiveClosingScript;
  updateCourierSettings: StatusOk;
  /** Updates a fallback template. */
  updateFallbackTemplate: AnyLiveFallbackTemplate;
  updateInbound: StatusOk;
  updateInboundWarehouseArrivalDate: StatusOk;
  updateLogisticChannel: StatusOk;
  updateLogisticShopifyCarrierServiceCondition: ShopifyCarrierServiceCondition;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Update marketplace calendar event.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   *         |`INVALID_INPUT`|Invalid arguments
   */
  updateMarketplaceCalendarEvent: MarketplaceCalendarEventPayload;
  /** Updates a sensitive word. */
  updateSensitiveWord: AnyLiveSensitiveWord;
  updateSupplier: StatusOk;
  updateWarehouse: StatusOk;
  uploadInboundsWithCsv: StatusOk;
  /** Upload inventory data */
  uploadInventoryFile: UploadInventoryFilePayload;
  voidShipping: Shipping;
  /** Exchange Yahoo Ads auth code to long-lived refresh token */
  yahooAdsExchangeCode: YahooAdsDatasourceTokenPayload;
};


export type MutationAiAgentSessionCreateArgs = {
  input: AiAgentSessionCreateInput;
};


export type MutationAiAgentSessionDeleteArgs = {
  input: AiAgentSessionDeleteInput;
};


export type MutationAiAgentSessionRegenerateArgs = {
  input: AiAgentSessionRegenerateInput;
};


export type MutationAiAgentSessionUpdateArgs = {
  input: AiAgentSessionUpdateInput;
};


export type MutationAddAutomationFlowArgs = {
  input: AddAutomationFlowRequest;
};


export type MutationAddCustomerTagsArgs = {
  input: AddCustomerTagRequest;
};


export type MutationAddWorkflowArgs = {
  body: WorkflowBodyInput;
  schedule?: InputMaybe<WorkflowScheduleInput>;
  storeId: Scalars['Long']['input'];
  testMode?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};


export type MutationAnyChatStoreCrmConfigUpdateArgs = {
  input: AnyChatStoreCrmConfigUpdateRequest;
};


export type MutationAnyliveCredentialCreateArgs = {
  input: AnyliveCredentialCreateInput;
};


export type MutationAnyliveCredentialDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAnyliveCredentialSetEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAnyliveCredentialSetLivestreamEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAnyliveCredentialUpdateArgs = {
  input: AnyliveCredentialUpdateInput;
};


export type MutationAnyliveCredentialUpdateNonLoginFieldsArgs = {
  input: AnyliveCredentialUpdateNonLoginFieldsInput;
};


export type MutationApplyGreetingMessageDraftArgs = {
  input: ApplyGreetingMessageDraftRequest;
};


export type MutationChatActivateAiArgs = {
  input: ChatActivateAiRequest;
};


export type MutationChatAddUserToAssigneeListArgs = {
  input: ChatAddUserToAssigneesRequest;
};


export type MutationChatDeactivateAiArgs = {
  input: ChatDeactivateAiRequest;
};


export type MutationChatRemoveUserFromAssigneeListArgs = {
  input: ChatRemoveUserFromAssigneesRequest;
};


export type MutationChatResolveArgs = {
  input: ChatResolveRequest;
};


export type MutationChatSetMutedArgs = {
  input: ChatSetMutedRequest;
};


export type MutationChatStateUpdateArgs = {
  input: ChatStateUpdateRequest;
};


export type MutationChatUnresolveArgs = {
  input: ChatUnresolveRequest;
};


export type MutationConnectLazadaArgs = {
  input: ConnectLazadaRequest;
};


export type MutationConnectShopeeChatArgs = {
  input: ConnectShopeeChatRequestInput;
};


export type MutationConnectTikTokShopArgs = {
  input: ConnectTikTokShopRequest;
};


export type MutationConnectToFacebookV2Args = {
  input: ConnectToFacebookRequestV2Input;
};


export type MutationConnectToWhatsAppArgs = {
  input: ConnectWhatsAppRequestInput;
};


export type MutationCustomerNoteV3CreateArgs = {
  input: CustomerNoteV3CreateRequest;
};


export type MutationCustomerNoteV3DeleteArgs = {
  input: CustomerNoteV3DeleteRequest;
};


export type MutationCustomerNoteV3UpdateArgs = {
  input: CustomerNoteV3UpdateRequest;
};


export type MutationDhlCreateCourierArgs = {
  input: DhlCreateCourierInput;
};


export type MutationDhlUpdateCourierArgs = {
  input: DhlUpdateCourierInput;
};


export type MutationDeleteCustomerTagsArgs = {
  input: DeleteCustomerTagsRequest;
};


export type MutationDeleteFailedMessageArgs = {
  messageId: Scalars['String']['input'];
};


export type MutationDeleteWorkflowArgs = {
  id: Scalars['String']['input'];
};


export type MutationDuplicateWorkflowArgs = {
  id: Scalars['String']['input'];
};


export type MutationFedExAddressValidationArgs = {
  input: FedExAddressValidationInput;
};


export type MutationFedExCreateCourierArgs = {
  input: FedExCreateCourier;
};


export type MutationFedExGeneratePinCodeArgs = {
  input: FedExGeneratePinCodeInput;
};


export type MutationFedExUpdateCourierArgs = {
  input: FedExUpdateCourier;
};


export type MutationGenerateAssetUploadUrlV2Args = {
  input: GenerateAssetUploadUrlRequest;
};


export type MutationGenerateDraftReplyArgs = {
  input: GenerateDraftReplyRequest;
};


export type MutationGenerateTrackingUrlArgs = {
  input: GenerateTrackingUrlRequest;
};


export type MutationInstagramChatImageMessageSendArgs = {
  input: InstagramSendImageMessageRequest;
};


export type MutationInstagramChatTextMessageSendArgs = {
  input: InstagramSendTextMessageRequest;
};


export type MutationInstagramMessageResendArgs = {
  messageId: Scalars['String']['input'];
};


export type MutationJapanPostCreateCourierArgs = {
  input: JapanPostCreateCourierInput;
};


export type MutationJapanPostUpdateCourierArgs = {
  input: JapanPostUpdateCourierInput;
};


export type MutationLineLoginArgs = {
  input: LineLoginRequest;
};


export type MutationLazadaChatImageMessageSendArgs = {
  input: LazadaSendImageMessageRequestInput;
};


export type MutationLazadaChatProductMessageSendArgs = {
  input: LazadaSendProductMessageRequestInput;
};


export type MutationLazadaChatTextMessageSendArgs = {
  input: LazadaSendTextMessageRequestInput;
};


export type MutationLazadaChatVideoMessageSendArgs = {
  input: LazadaSendVideoMessageRequestInput;
};


export type MutationLazadaChatVoucherMessageSendArgs = {
  input: LazadaSendVoucherMessageRequestInput;
};


export type MutationLazadaMessageResendArgs = {
  messageId: Scalars['String']['input'];
};


export type MutationLiffConnectInfluencerArgs = {
  input: LiffInfluencerConnectRequestInput;
};


export type MutationLiffIdTokenValidateArgs = {
  input: LiffIdTokenValidateRequest;
};


export type MutationLiffInquirySendArgs = {
  input: LiffInquirySendRequest;
};


export type MutationLiffShopifyConnectArgs = {
  input: LiffShopifyConnectRequest;
};


export type MutationLiffShopifyCustomerCreateArgs = {
  input: LiffShopifyCustomerCreateRequest;
};


export type MutationLiffShopifyRedirectConnectArgs = {
  input: LiffShopifyRedirectConnectRequest;
};


export type MutationLiffShopifyRedirectConnectV2Args = {
  input: LiffShopifyRedirectConnectRequestV2;
};


export type MutationLineBroadCastMessageSendArgs = {
  input: SendBroadcastMessageRequestInput;
};


export type MutationLineBroadCastMessageUnscheduleArgs = {
  input: UnscheduleMessageRequestInput;
};


export type MutationLineBroadcastMessageCreateArgs = {
  input: LineBroadcastMessageCreateRequestInput;
};


export type MutationLineBroadcastMessageUpdateArgs = {
  input: LineBroadcastMessageUpdateRequestInput;
};


export type MutationLineChatMessageSendArgs = {
  input: LineChatMessageRequest;
};


export type MutationLineMessageResendArgs = {
  messageId: Scalars['String']['input'];
};


export type MutationLineRichMenuCreateDraftArgs = {
  input: LineRichMenuCreateDraftInput;
};


export type MutationLineRichMenuSubmitArgs = {
  input: LineRichMenuSubmitInput;
};


export type MutationLineRichMenuUpdateArgs = {
  input: LineRichMenuUpdateInput;
};


export type MutationLineScheduledMessageCreateArgs = {
  input: LineScheduledMessageCreateInput;
};


export type MutationLineScheduledMessageDeleteArgs = {
  input: LineScheduledMessageDeleteInput;
};


export type MutationLineScheduledMessageImmediateSendArgs = {
  input: LineScheduledMessageImmediateSendInput;
};


export type MutationLineScheduledMessageUpdateArgs = {
  input: LineScheduledMessageUpdateInput;
};


export type MutationMarkDraftSentArgs = {
  input: MarkDraftSentRequest;
};


export type MutationMdCreateAccountArgs = {
  input: MdCreateAccountInput;
};


export type MutationMdCreateStoreArgs = {
  input: MdCreateStoreInput;
};


export type MutationMdCreateUserArgs = {
  input: MdCreateUserInput;
};


export type MutationMdDeleteStoreArgs = {
  id: Scalars['Long']['input'];
};


export type MutationMdDeleteUserArgs = {
  id: Scalars['Long']['input'];
};


export type MutationMdDeleteUsersArgs = {
  ids: Array<Scalars['Long']['input']>;
};


export type MutationMdSendVerificationEmailArgs = {
  input: MdSendVerificationEmailInput;
};


export type MutationMdUpdateAccountArgs = {
  input: MdUpdateAccountInput;
};


export type MutationMdUpdateStoreArgs = {
  input: MdUpdateStoreInput;
};


export type MutationMdUpdateUserArgs = {
  input: MdUpdateUserInput;
};


export type MutationMergeAnyTagInfluencersArgs = {
  input: MergeAnyTagInfluencersRequest;
};


export type MutationMessengerBroadCastMessageSendArgs = {
  input: SendMessengerBroadcastMessageRequestInput;
};


export type MutationMessengerBroadCastMessageUnscheduleArgs = {
  input: UnscheduleMessengerMessageRequestInput;
};


export type MutationMessengerBroadcastMessageCreateArgs = {
  input: MessengerBroadcastMessageCreateRequestInput;
};


export type MutationMessengerBroadcastMessageUpdateArgs = {
  input: MessengerBroadcastMessageUpdateRequestInput;
};


export type MutationMessengerChatImageMessageSendArgs = {
  input: MessengerSendImageMessageRequest;
};


export type MutationMessengerChatTextMessageSendArgs = {
  input: MessengerSendTextMessageRequest;
};


export type MutationMessengerMessageResendArgs = {
  messageId: Scalars['String']['input'];
};


export type MutationPronunciationDictionaryBatchDeleteArgs = {
  dictionaryIds: Array<Scalars['ID']['input']>;
};


export type MutationPronunciationDictionaryCreateArgs = {
  input: PronunciationDictionaryCreateInput;
};


export type MutationPronunciationDictionaryDeleteArgs = {
  dictionaryId: Scalars['ID']['input'];
};


export type MutationPronunciationDictionaryGenerateTestTtsArgs = {
  input: PronunciationTestTtsGenerateInput;
};


export type MutationPronunciationDictionarySaveArgs = {
  input: PronunciationDictionarySaveInput;
};


export type MutationPronunciationRuleBatchDeleteArgs = {
  ruleIds: Array<Scalars['ID']['input']>;
};


export type MutationPronunciationRuleDeleteArgs = {
  ruleId: Scalars['ID']['input'];
};


export type MutationPronunciationRuleSaveArgs = {
  input: PronunciationRuleSaveInput;
};


export type MutationRefreshFacebookTokenConnectionArgs = {
  input: ConnectToFacebookRequestV2Input;
};


export type MutationRefreshShopeeChatConnectionArgs = {
  input: RefreshShopeeConnectionRequest;
};


export type MutationRegenerateDraftReplyArgs = {
  input: RegenerateDraftReplyRequest;
};


export type MutationSaveGreetingMessageArgs = {
  input: SaveGreetingMessageRequest;
};


export type MutationSaveGreetingMessageDraftArgs = {
  input: SaveGreetingMessageDraftRequest;
};


export type MutationSaveMessengerOptInMessageArgs = {
  input: SaveMessengerOptInMessageRequestInput;
};


export type MutationSelectDraftReplyArgs = {
  input: SelectDraftReplyRequest;
};


export type MutationSetChatCustomerTagsArgs = {
  input: SetCustomerTagsRequest;
};


export type MutationShopeeChatImageMessageSendArgs = {
  input: ShopeeSendImageMessageRequestInput;
};


export type MutationShopeeChatProductMessageSendArgs = {
  input: ShopeeSendProductMessageRequestInput;
};


export type MutationShopeeChatTextMessageSendArgs = {
  input: ShopeeSendTextMessageRequestInput;
};


export type MutationShopeeChatVideoMessageSendArgs = {
  input: ShopeeSendVideoMessageRequestInput;
};


export type MutationShopeeChatVoucherMessageSendArgs = {
  input: ShopeeSendVoucherMessageRequestInput;
};


export type MutationShopeeMessageResendArgs = {
  messageId: Scalars['String']['input'];
};


export type MutationStoreChannelShopifyConnectArgs = {
  input: StoreChannelShopifyConnectRequest;
};


export type MutationStoreChannelShopifyConnectAdminArgs = {
  input: StoreChannelShopifyConnectAdminRequest;
};


export type MutationStoreChannelShopifyOauthUrlGenerateArgs = {
  input: GenerateShopifyOauthUrlRequest;
};


export type MutationStoreChatLineConnectV2Args = {
  input: StoreChatLineConnectRequestV2;
};


export type MutationStoreChatLineConnectionUpdateArgs = {
  input: StoreChatLineConnectionUpdateRequest;
};


export type MutationStoreChatLinePublicKeyGenerateV2Args = {
  input: StoreChatLinePublicKeyGenerateRequestV2;
};


export type MutationStoreChatTemplatePlainMessageAddArgs = {
  input: StoreChatTemplatePlainMessageAddRequest;
};


export type MutationStoreChatTemplatePlainMessageCategoryCreateArgs = {
  input: StoreChatTemplatePlainMessageCategoryCreateRequest;
};


export type MutationStoreChatTemplatePlainMessageCategoryDeleteArgs = {
  input: StoreChatTemplatePlainMessageCategoryDeleteRequest;
};


export type MutationStoreChatTemplatePlainMessageCategoryMoveArgs = {
  input: StoreChatTemplatePlainMessageCategoryMoveRequest;
};


export type MutationStoreChatTemplatePlainMessageCategoryUpdateArgs = {
  input: StoreChatTemplatePlainMessageCategoryUpdateRequest;
};


export type MutationStoreChatTemplatePlainMessageDeleteArgs = {
  input: StoreChatTemplatePlainMessagesDeleteRequest;
};


export type MutationStoreChatTemplatePlainMessageMoveArgs = {
  input: StoreChatTemplatePlainMessageMoveRequest;
};


export type MutationStoreChatTemplatePlainMessageUpdateArgs = {
  input: StoreChatTemplatePlainMessageUpdateRequest;
};


export type MutationSyncAnyTagInfluencerArgs = {
  input: SyncAnyTagInfluencerRequest;
};


export type MutationTestSendGreetingMessageDraftArgs = {
  input: TestSendGreetingMessageDraftRequest;
};


export type MutationToggleEnableWorkflowArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};


export type MutationTtsCancelBulkArgs = {
  input: TtsCancelBulkInput;
};


export type MutationTtsVoiceCloneCreateArgs = {
  input: TtsVoiceCloneCreateInput;
};


export type MutationTtsVoiceCloneDeleteBulkArgs = {
  input: TtsVoiceCloneDeleteBulkInput;
};


export type MutationTtsVoiceCloneRenameArgs = {
  input: TtsVoiceCloneRenameInput;
};


export type MutationUpsAddAccountNumberArgs = {
  accountNumber: Scalars['String']['input'];
  courierId: Scalars['ID']['input'];
};


export type MutationUpsInstallationArgs = {
  accountId: Scalars['String']['input'];
  callbackUrl: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};


export type MutationUpsOpenAccountArgs = {
  input: UpsOpenAccountInput;
};


export type MutationUpsRegisterCustomerArgs = {
  input: UpsRegisterCustomerInput;
};


export type MutationUpdateAutomationFlowArgs = {
  input: UpdateAutomationFlowRequest;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerRequest;
};


export type MutationUpdateCustomerTagArgs = {
  input: UpdateCustomerTagRequest;
};


export type MutationUpdateCustomerV2Args = {
  input: UpdateCustomerRequest;
};


export type MutationUpdateWhatsAppOptInSettingArgs = {
  input: UpdateWhatsAppOptInSettingRequest;
};


export type MutationUpdateWorkflowArgs = {
  body: WorkflowBodyInput;
  id: Scalars['String']['input'];
  schedule?: InputMaybe<WorkflowScheduleInput>;
  testMode?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};


export type MutationWhatsAppBroadcastCreateArgs = {
  input: WhatsAppBroadcastCreateRequestInput;
};


export type MutationWhatsAppBroadcastToDraftArgs = {
  input: WhatsAppBroadcastToDraftRequest;
};


export type MutationWhatsAppBroadcastUpdateArgs = {
  input: WhatsAppBroadcastUpdateRequestInput;
};


export type MutationWhatsAppChatImageMessageSendArgs = {
  input: WhatsAppSendImageMessageRequestInput;
};


export type MutationWhatsAppChatTextMessageSendArgs = {
  input: WhatsAppSendTextMessageRequestInput;
};


export type MutationWhatsAppMessageResendArgs = {
  messageId: Scalars['String']['input'];
};


export type MutationAddShipperAddressArgs = {
  input: ShipperAddressInput;
};


export type MutationArchiveProductVariantsArgs = {
  productVariantIds: Array<Scalars['Long']['input']>;
};


export type MutationCancelInboundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelInboundsArgs = {
  filters: InboundFilters;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectAll?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCheckMomoConnectionArgs = {
  input: CheckMomoConnectionInput;
};


export type MutationCommentAnalysisReportCreateArgs = {
  input: CommentAnalysisReportCreateInput;
};


export type MutationCommentHistoryExportArgs = {
  livePlatform?: InputMaybe<LivePlatform>;
  platformSessionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationCommentReplyRecordClearFeedbackArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCommentReplyRecordFeedbackArgs = {
  feedback: CommentFeedback;
  id: Scalars['ID']['input'];
};


export type MutationConfirmValidJapanAddressArgs = {
  input: ConfirmValidJapanOrderAddressInput;
};


export type MutationConnectChannelToWarehouseArgs = {
  externalStoreId: Scalars['ID']['input'];
  merchantId: Scalars['String']['input'];
  saleChannelId: Scalars['Long']['input'];
  storeId: Scalars['Long']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type MutationConnectRakutenArgs = {
  licenseKey: Scalars['String']['input'];
  serviceSecret: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};


export type MutationCreateAnylogiSupplierUserArgs = {
  currency: AnylogiCurrencyInput;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  language: Language;
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  role: AnylogiUserRoles;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  supplierId: Scalars['ID']['input'];
  timezone: AnylogiTimezone;
};


export type MutationCreateClosingScriptArgs = {
  input: AnyLiveClosingScriptCreateInput;
};


export type MutationCreateCourierSettingsArgs = {
  input: CourierSettingsInput;
};


export type MutationCreateDatasourceArgs = {
  input: CreateDatasourceInput;
};


export type MutationCreateFallbackTemplateArgs = {
  input: AnyLiveCreateFallbackTemplateInput;
};


export type MutationCreateInboundArgs = {
  comment: Scalars['String']['input'];
  inboundDate: Scalars['Time']['input'];
  products: Array<InboundSku>;
  storeId: Scalars['Long']['input'];
  supplierId: Scalars['ID']['input'];
  warehouseArrivalDate?: InputMaybe<Scalars['Time']['input']>;
};


export type MutationCreateLogisticChannelRequestFormArgs = {
  input: InputCreateLogisticChannelRequestForm;
};


export type MutationCreateLogisticShopifyCarrierServiceConditionArgs = {
  input: ShopifyCarrierServiceConditionInput;
};


export type MutationCreateMarketplaceCalendarEventArgs = {
  input: CreateMarketplaceCalendarEventInput;
};


export type MutationCreateSensitiveWordArgs = {
  input: AnyLiveCreateSensitiveWordInput;
};


export type MutationCreateShippingArgs = {
  crossBorderCourierProvider: CrossBorderCourierProvider;
  input: ShippingInput;
  serviceCode: ServiceCodeInput;
};


export type MutationCreateShopifyCarrierServiceArgs = {
  saleChannelId: Scalars['Long']['input'];
};


export type MutationCreateSupplierArgs = {
  accountId: Scalars['Long']['input'];
  addressFirst?: InputMaybe<Scalars['String']['input']>;
  addressSecond?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<PhoneNumberInput>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateWarehouseArgs = {
  addressFirst: Scalars['String']['input'];
  addressSecond?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Country>;
  deliveryDestination: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: PhoneNumberInput;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  vendor: Wms;
  wmsWarehouseId: Scalars['String']['input'];
};


export type MutationDashboardBrandAiInsightRefreshArgs = {
  filter: DashboardBrandFilterInput;
};


export type MutationDashboardRegionalAiInsightRefreshArgs = {
  filter: DashboardFilterInput;
};


export type MutationDashboardScriptInsightRefreshArgs = {
  filter: DashboardStoreFilterInput;
  sessionId: Scalars['String']['input'];
};


export type MutationDeleteAnylogiSupplierUsersArgs = {
  filters?: InputMaybe<AnylogiUserFilters>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectAll?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteChannelFromWarehouseArgs = {
  saleChannelId: Scalars['Long']['input'];
};


export type MutationDeleteClosingScriptArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCourierAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCrossBorderBasicAuthArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDatasourceArgs = {
  id: Scalars['Long']['input'];
};


export type MutationDeleteFallbackTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLogisticShopifyCarrierServiceConditionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMarketplaceCalendarEventArgs = {
  input: DeleteMarketplaceCalendarEventInput;
};


export type MutationDeleteReportExportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSaleChannelArgs = {
  input: DeleteSaleChannelInput;
};


export type MutationDeleteSensitiveWordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteShopifyCarrierServiceArgs = {
  saleChannelId: Scalars['Long']['input'];
};


export type MutationDeleteWarehouseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWarehousesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationDeliverySlipArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationDisableProductVariantsInventorySyncArgs = {
  input: BulkInventorySyncInput;
};


export type MutationDisconnectChannelFromWarehouseArgs = {
  saleChannelId: Scalars['Long']['input'];
};


export type MutationDisconnectStoreFromWmsArgs = {
  storeId: Scalars['Long']['input'];
};


export type MutationEditShipperAddressArgs = {
  id: Scalars['ID']['input'];
  input: ShipperAddressInput;
};


export type MutationEnableProductVariantsInventorySyncArgs = {
  input: BulkInventorySyncInput;
};


export type MutationFacebookExchangeCodeArgs = {
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
};


export type MutationFileUploadArgs = {
  fileName: Scalars['String']['input'];
};


export type MutationGeneralFaqCreateArgs = {
  input: GeneralFaqCreateInput;
};


export type MutationGeneralFaqDeleteArgs = {
  input: GeneralFaqDeleteInput;
};


export type MutationGeneralFaqRegenerateArgs = {
  input: GeneralFaqRegenerateInput;
};


export type MutationGeneralFaqUpdateArgs = {
  input: GeneralFaqUpdateInput;
};


export type MutationGenerateBrandMonthlyReportArgs = {
  month: Scalars['String']['input'];
  storeId: Scalars['ID']['input'];
};


export type MutationGenerateCrossBorderBasicAuthArgs = {
  accountId: Scalars['ID']['input'];
};


export type MutationGenerateLogilessOAuthUrlArgs = {
  merchantId: Scalars['ID']['input'];
};


export type MutationGenerateStoreWeeklyReportArgs = {
  month: Scalars['String']['input'];
  storeId: Scalars['ID']['input'];
};


export type MutationGenerateUploadUrlArgs = {
  filename: Scalars['String']['input'];
  filetype: FileType;
  resource: Resource;
  storeId?: InputMaybe<Scalars['Long']['input']>;
};


export type MutationGoogleAuthUrlGenerateArgs = {
  redirectUri: Scalars['Url']['input'];
};


export type MutationGoogleExchangeCodeArgs = {
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  type: GoogleLoginUrlType;
};


export type MutationHostCreateArgs = {
  input: HostCreateInput;
};


export type MutationHostUpdateArgs = {
  input: HostUpdateInput;
};


export type MutationImportLiveAssetGeneralFaqsAsRoomFaqsArgs = {
  input: ImportLiveAssetGeneralFaqsInput;
};


export type MutationImportLiveAssetProductFaqsAsRoomFaqsArgs = {
  input: ImportLiveAssetProductFaqsInput;
};


export type MutationImportLiveAssetScriptContentAsParagraphsArgs = {
  input: ImportLiveAssetScriptContentInput;
};


export type MutationInvoiceSlipArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationListingTriggerSyncArgs = {
  input: ListingTriggerSyncInput;
};


export type MutationLiveAssetContentClearTtsArgs = {
  input: LiveAssetContentClearTtsInput;
};


export type MutationLiveAssetContentCreateArgs = {
  input: LiveAssetContentCreateInput;
};


export type MutationLiveAssetContentReorderArgs = {
  input: LiveAssetContentReorderInput;
};


export type MutationLiveAssetContentUpdateArgs = {
  input: LiveAssetContentUpdateInput;
};


export type MutationLiveAssetCreateArgs = {
  input: LiveAssetCreateInput;
};


export type MutationLiveAssetDeleteBulkArgs = {
  input: LiveAssetDeleteBulkInput;
};


export type MutationLiveAssetDuplicateBulkArgs = {
  input: LiveAssetDuplicateBulkInput;
};


export type MutationLiveAssetFaqContentClearTtsArgs = {
  input: LiveAssetFaqContentClearTtsInput;
};


export type MutationLiveAssetGeneralFaqGenerationSubmitArgs = {
  input: GeneralFaqGenerationSubmitInput;
};


export type MutationLiveAssetGenerationSubmitArgs = {
  input: LiveAssetGenerationSubmitInput;
};


export type MutationLiveAssetLiveKnowledgeUpdateArgs = {
  input: LiveAssetLiveKnowledgeUpdateInput;
};


export type MutationLiveAssetProductCreateArgs = {
  input: LiveAssetProductCreateInput;
};


export type MutationLiveAssetProductDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLiveAssetProductFaqGenerationSubmitArgs = {
  input: ProductFaqGenerationSubmitInput;
};


export type MutationLiveAssetProductReorderArgs = {
  input: LiveAssetProductReorderInput;
};


export type MutationLiveAssetProductUpdateArgs = {
  input: LiveAssetProductUpdateInput;
};


export type MutationLiveAssetScriptUpdateArgs = {
  input: LiveAssetScriptUpdateInput;
};


export type MutationLiveAssetUpdateArgs = {
  input: LiveAssetUpdateInput;
};


export type MutationLiveAssetVersionDeleteBulkArgs = {
  input: LiveAssetVersionDeleteBulkInput;
};


export type MutationLiveAssetVersionDuplicateArgs = {
  input: LiveAssetVersionDuplicateInput;
};


export type MutationLiveAssetVersionDuplicateBulkArgs = {
  input: LiveAssetVersionDuplicateBulkInput;
};


export type MutationLiveAssetVersionUpdateArgs = {
  input: LiveAssetVersionUpdateInput;
};


export type MutationLiveAssetVersionUpdateTtsSettingsArgs = {
  input: LiveAssetVersionUpdateTtsSettingsInput;
};


export type MutationLiveAssetVersionUpdateVersionNameArgs = {
  input: LiveAssetVersionUpdateVersionNameInput;
};


export type MutationLiveStreamUpdateArgs = {
  input: LiveStreamUpdateInput;
};


export type MutationLivestreamAvatarCreateArgs = {
  input: LivestreamAvatarCreateInput;
};


export type MutationLivestreamAvatarSubVideoRenameArgs = {
  input: LivestreamAvatarSubVideoRenameInput;
};


export type MutationLivestreamAvatarUpdateArgs = {
  input: LivestreamAvatarUpdateInput;
};


export type MutationLivestreamRoomAtmosphereGroupUpdateArgs = {
  input: LivestreamRoomAtmosphereGroupUpdateInput;
};


export type MutationLivestreamRoomAtmosphereScriptAddArgs = {
  input: LivestreamRoomAtmosphereScriptAddInput;
};


export type MutationLivestreamRoomAtmosphereScriptDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLivestreamRoomAtmosphereScriptGenerateTtsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLivestreamRoomAtmosphereScriptUpdateArgs = {
  input: LivestreamRoomAtmosphereScriptUpdateInput;
};


export type MutationLivestreamRoomAtmosphereScriptVoiceRemoveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLivestreamRoomAtmosphereScriptVoiceUrlUpdateArgs = {
  input: LivestreamRoomAtmosphereScriptVoiceUrlUpdateInput;
};


export type MutationLivestreamRoomCommentSwitchCooldownsUpdateArgs = {
  input: LivestreamRoomCommentSwitchCooldownsUpdateInput;
};


export type MutationLivestreamRoomComposeArgs = {
  input: LivestreamRoomComposeInput;
};


export type MutationLivestreamRoomCreateArgs = {
  input: LivestreamRoomCreateInput;
};


export type MutationLivestreamRoomDecorationCreateArgs = {
  input: LivestreamRoomDecorationCreateInput;
};


export type MutationLivestreamRoomDecorationDeleteBulkArgs = {
  input: LivestreamRoomDecorationDeleteBulkInput;
};


export type MutationLivestreamRoomDecorationGroupSaveArgs = {
  input: LivestreamRoomDecorationGroupSaveInput;
};


export type MutationLivestreamRoomDecorationSaveArgs = {
  input: LivestreamRoomDecorationSaveInput;
};


export type MutationLivestreamRoomDeleteArgs = {
  input: LivestreamRoomDeleteInput;
};


export type MutationLivestreamRoomDuplicateBulkArgs = {
  input: LivestreamRoomDuplicateBulkInput;
};


export type MutationLivestreamRoomFaqConfidenceUpdateArgs = {
  input: LivestreamRoomFaqConfidenceUpdateInput;
};


export type MutationLivestreamRoomFaqGenerateArgs = {
  roomId: Scalars['ID']['input'];
};


export type MutationLivestreamRoomFaqReplyModeUpdateArgs = {
  input: LivestreamRoomFaqReplyModeUpdateInput;
};


export type MutationLivestreamRoomGeneralFaqBulkCreateArgs = {
  input: LivestreamRoomGeneralFaqBulkCreateInput;
};


export type MutationLivestreamRoomGeneralFaqCreateArgs = {
  input: LivestreamRoomGeneralFaqCreateInput;
};


export type MutationLivestreamRoomGeneralFaqCustomVideoRemoveArgs = {
  input: LivestreamRoomGeneralFaqCustomVideoRemoveInput;
};


export type MutationLivestreamRoomGeneralFaqCustomVideoTtsGenerateArgs = {
  input: LivestreamRoomGeneralFaqCustomVideoTtsGenerateInput;
};


export type MutationLivestreamRoomGeneralFaqCustomVideoUpdateArgs = {
  input: LivestreamRoomGeneralFaqCustomVideoUpdateInput;
};


export type MutationLivestreamRoomGeneralFaqDeleteBulkArgs = {
  input: LivestreamRoomGeneralFaqDeleteBulkInput;
};


export type MutationLivestreamRoomGeneralFaqTtsGenerateArgs = {
  input: LivestreamRoomGeneralFaqTtsGenerateInput;
};


export type MutationLivestreamRoomGeneralFaqUpdateArgs = {
  input: LivestreamRoomGeneralFaqUpdateInput;
};


export type MutationLivestreamRoomGeneralFaqVoiceRemoveArgs = {
  input: LivestreamRoomGeneralFaqVoiceRemoveInput;
};


export type MutationLivestreamRoomGeneralFaqVoiceUrlUpdateArgs = {
  input: LivestreamRoomGeneralFaqVoiceUrlUpdateInput;
};


export type MutationLivestreamRoomKnowledgeBaseUpdateArgs = {
  input: LivestreamRoomKnowledgeBaseUpdateInput;
};


export type MutationLivestreamRoomLanguageSetArgs = {
  input: LivestreamRoomLanguageSetInput;
};


export type MutationLivestreamRoomLlmConfigUpsertArgs = {
  input: LivestreamRoomLlmConfigUpsertInput;
};


export type MutationLivestreamRoomLlmReplyEnabledUpdateArgs = {
  input: LivestreamRoomLlmReplyEnabledUpdateInput;
};


export type MutationLivestreamRoomLlmReplyModeUpdateArgs = {
  input: LivestreamRoomLlmReplyModeUpdateInput;
};


export type MutationLivestreamRoomProductCreateArgs = {
  input: LivestreamRoomProductCreateInput;
};


export type MutationLivestreamRoomProductDeleteBulkArgs = {
  input: LivestreamRoomProductDeleteBulkInput;
};


export type MutationLivestreamRoomProductFaqBulkCreateArgs = {
  input: LivestreamRoomProductFaqBulkCreateInput;
};


export type MutationLivestreamRoomProductFaqCreateArgs = {
  input: LivestreamRoomProductFaqCreateInput;
};


export type MutationLivestreamRoomProductFaqCustomVideoRemoveArgs = {
  input: LivestreamRoomProductFaqCustomVideoRemoveInput;
};


export type MutationLivestreamRoomProductFaqCustomVideoTtsGenerateArgs = {
  input: LivestreamRoomProductFaqCustomVideoTtsGenerateInput;
};


export type MutationLivestreamRoomProductFaqCustomVideoUpdateArgs = {
  input: LivestreamRoomProductFaqCustomVideoUpdateInput;
};


export type MutationLivestreamRoomProductFaqDeleteBulkArgs = {
  input: LivestreamRoomProductFaqDeleteBulkInput;
};


export type MutationLivestreamRoomProductFaqReassignArgs = {
  input: LivestreamRoomProductFaqReassignInput;
};


export type MutationLivestreamRoomProductFaqSendToUnmatchedArgs = {
  input: LivestreamRoomProductFaqSendToUnmatchedInput;
};


export type MutationLivestreamRoomProductFaqTtsGenerateArgs = {
  input: LivestreamRoomProductFaqTtsGenerateInput;
};


export type MutationLivestreamRoomProductFaqUpdateArgs = {
  input: LivestreamRoomProductFaqUpdateInput;
};


export type MutationLivestreamRoomProductFaqVoiceRemoveArgs = {
  input: LivestreamRoomProductFaqVoiceRemoveInput;
};


export type MutationLivestreamRoomProductFaqVoiceUrlUpdateArgs = {
  input: LivestreamRoomProductFaqVoiceUrlUpdateInput;
};


export type MutationLivestreamRoomProductLlmKnowledgeUpdateArgs = {
  input: LivestreamRoomProductLlmKnowledgeUpdateInput;
};


export type MutationLivestreamRoomProductParagraphAudioDeleteArgs = {
  input: LivestreamRoomProductParagraphAudioDeleteInput;
};


export type MutationLivestreamRoomProductParagraphCreateArgs = {
  input: LivestreamRoomProductParagraphCreateInput;
};


export type MutationLivestreamRoomProductParagraphDeleteBulkArgs = {
  input: LivestreamRoomProductParagraphDeleteBulkInput;
};


export type MutationLivestreamRoomProductParagraphReorderArgs = {
  input: LivestreamRoomProductParagraphReorderInput;
};


export type MutationLivestreamRoomProductParagraphUpdateArgs = {
  input: LivestreamRoomProductParagraphUpdateInput;
};


export type MutationLivestreamRoomProductParagraphVideoDeleteArgs = {
  input: LivestreamRoomProductParagraphVideoDeleteInput;
};


export type MutationLivestreamRoomProductParagraphVideoUrlUpdateArgs = {
  input: LivestreamRoomProductParagraphVideoUrlUpdateInput;
};


export type MutationLivestreamRoomProductReorderArgs = {
  input: LivestreamRoomProductReorderInput;
};


export type MutationLivestreamRoomProductReplaceArgs = {
  input: LivestreamRoomProductReplaceInput;
};


export type MutationLivestreamRoomProductSelectAvatarArgs = {
  input: LivestreamRoomProductSelectAvatarInput;
};


export type MutationLivestreamRoomProductUpdateArgs = {
  input: LivestreamRoomProductUpdateInput;
};


export type MutationLivestreamRoomQaScriptsEnabledUpdateArgs = {
  input: LivestreamRoomQaScriptsEnabledUpdateInput;
};


export type MutationLivestreamRoomRakutenLivestreamSelectArgs = {
  input: LivestreamRoomRakutenLivestreamSelectInput;
};


export type MutationLivestreamRoomReplyFrequencyUpdateArgs = {
  input: LivestreamRoomReplyFrequencyUpdateInput;
};


export type MutationLivestreamRoomReplyTimingUpdateArgs = {
  input: LivestreamRoomReplyTimingUpdateInput;
};


export type MutationLivestreamRoomResponseStrategyUpdateArgs = {
  input: LivestreamRoomResponseStrategyUpdateInput;
};


export type MutationLivestreamRoomShopeeProductSetsSaveArgs = {
  input: LivestreamRoomShopeeProductSetsSaveInput;
};


export type MutationLivestreamRoomUnmatchedFaqAssignToProductArgs = {
  input: LivestreamRoomUnmatchedFaqAssignToProductInput;
};


export type MutationLivestreamRoomUnmatchedFaqBulkCreateArgs = {
  input: LivestreamRoomUnmatchedFaqBulkCreateInput;
};


export type MutationLivestreamRoomUnmatchedFaqCreateArgs = {
  input: LivestreamRoomUnmatchedFaqCreateInput;
};


export type MutationLivestreamRoomUnmatchedFaqDeleteBulkArgs = {
  input: LivestreamRoomUnmatchedFaqDeleteBulkInput;
};


export type MutationLivestreamRoomUnmatchedFaqUpdateArgs = {
  input: LivestreamRoomUnmatchedFaqUpdateInput;
};


export type MutationLivestreamRoomUnmatchedFaqVoiceRemoveArgs = {
  input: LivestreamRoomUnmatchedFaqVoiceRemoveInput;
};


export type MutationLivestreamRoomUnmatchedFaqVoiceUrlUpdateArgs = {
  input: LivestreamRoomUnmatchedFaqVoiceUrlUpdateInput;
};


export type MutationLivestreamRoomUpdateArgs = {
  input: LivestreamRoomUpdateInput;
};


export type MutationLivestreamRoomVoiceSettingsUpdateArgs = {
  input: LivestreamRoomVoiceSettingsUpdateInput;
};


export type MutationLivestreamSessionSavePlatformConfigArgs = {
  input: LivestreamSessionSavePlatformConfigInput;
};


export type MutationLivestreamSessionScheduleEndArgs = {
  id: Scalars['String']['input'];
  scheduledEndTime?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLivestreamSessionScheduleStartArgs = {
  id: Scalars['String']['input'];
  scheduledStartTime?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLivestreamSessionStartArgs = {
  bytePlusEventId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationLivestreamSessionStopArgs = {
  id: Scalars['String']['input'];
};


export type MutationLivestreamSessionSwitchProductArgs = {
  id: Scalars['String']['input'];
  roomProductId: Scalars['String']['input'];
};


export type MutationLogilessOAuthArgs = {
  code: Scalars['String']['input'];
  merchantId: Scalars['ID']['input'];
};


export type MutationMatchMomoProductArgs = {
  input: MatchMomoProductInput;
};


export type MutationMomoConnectionQueueAddArgs = {
  input: MomoConnectionQueueAddInput;
};


export type MutationMomoConnectionQueueRemoveArgs = {
  input: MomoConnectionQueueRemoveInput;
};


export type MutationMomoSaleChannelEntpCodeSetArgs = {
  input: MomoSaleChannelEntpCodeSetInput;
};


export type MutationOrderCancelArgs = {
  input: CancelOrderInput;
};


export type MutationOrderIgnoreAddressValidationErrorArgs = {
  orderId: Scalars['Long']['input'];
};


export type MutationOrderManualCreateArgs = {
  input: CreateManualOrderInput;
};


export type MutationOrderManualUpdateV2Args = {
  input: UpdateManualOrderV2Input;
};


export type MutationOrderManualUpdateWithLogiArgs = {
  input: UpdateManualOrderWithLogiInput;
};


export type MutationProductCreateV2Args = {
  input: CreateProductV2Input;
};


export type MutationProductFaqCreateArgs = {
  input: ProductFaqCreateInput;
};


export type MutationProductFaqDeleteArgs = {
  input: ProductFaqDeleteInput;
};


export type MutationProductFaqUpdateArgs = {
  input: ProductFaqUpdateInput;
};


export type MutationProductUpdateWithMultiVariantsArgs = {
  input: UpdateProductWithMultiVariantsInput;
};


export type MutationProductUpdateWithSingleVariantArgs = {
  input: UpdateProductWithSingleVariantInput;
};


export type MutationProductVariantUpdateV3Args = {
  input: UpdateProductVariantV3Input;
};


export type MutationProductVariantsMergeV3Args = {
  input: MergeProductVariantV3Input;
};


export type MutationQoo10SaleChannelCreateArgs = {
  input: Qoo10SaleChannelCreateInput;
};


export type MutationQoo10SaleChannelReconnectArgs = {
  input: Qoo10SaleChannelReconnectInput;
};


export type MutationReconnectRakutenArgs = {
  licenseKey: Scalars['String']['input'];
  saleChannelId: Scalars['Long']['input'];
};


export type MutationRegisterFileUploadV3Args = {
  input: FileUploadInputV2Input;
};


export type MutationRegisterManualIntegrationOrderCsvUploadArgs = {
  input: ManualIntegrationOrderCsvInput;
};


export type MutationRegisterManualIntegrationProductCsvUploadArgs = {
  input: ManualIntegrationProductCsvInput;
};


export type MutationRegisterManualOrderCsvUploadV2Args = {
  fileUri: Scalars['String']['input'];
  manualOrderUploadType: ManualOrderUploadType;
  storeId: Scalars['Long']['input'];
};


export type MutationRegisterManualSetProductCsvUploadArgs = {
  input: ManualSetProductCsvUploadInput;
};


export type MutationRegisterManualSingleProductCsvUploadArgs = {
  input: ManualSingleProductCsvUploadInput;
};


export type MutationRegisterManualUpdateProductCsvUploadArgs = {
  input: ManualUpdateProductCsvUploadInput;
};


export type MutationReinviteAnylogiSupplierUsersArgs = {
  filters?: InputMaybe<AnylogiUserFilters>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectAll?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRollbackClosingScriptArgs = {
  revisionNumber: Scalars['Int']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationRollbackFallbackTemplateArgs = {
  revisionNumber: Scalars['Int']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationRollbackSensitiveWordArgs = {
  revisionNumber: Scalars['Int']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationSaveAdCostCampaignMappingArgs = {
  input: AdCostCampaignMappingSaveInput;
};


export type MutationSaveAdSetMappingArgs = {
  input: AdSetMappingSaveInput;
};


export type MutationSaveDdiProductStatusArgs = {
  input: SaveDdiProductStatusListInput;
};


export type MutationSaveSaleChannelCostIndexArgs = {
  input: SaleChannelSaveInput;
};


export type MutationScriptContentClearTtsArgs = {
  input: ScriptContentClearTtsInput;
};


export type MutationScriptContentCreateArgs = {
  input: ScriptContentCreateInput;
};


export type MutationScriptContentReorderArgs = {
  input: ScriptContentReorderInput;
};


export type MutationScriptContentUpdateArgs = {
  input: ScriptContentUpdateInput;
};


export type MutationScriptCreateArgs = {
  input: ScriptCreateInput;
};


export type MutationScriptDeleteBulkArgs = {
  input: ScriptDeleteBulkInput;
};


export type MutationScriptDuplicateBulkArgs = {
  input: ScriptDuplicateBulkInput;
};


export type MutationScriptGenerationSubmitArgs = {
  input: ScriptGenerationSubmitInput;
};


export type MutationScriptUpdateArgs = {
  input: ScriptUpdateInput;
};


export type MutationScriptVersionDeleteBulkArgs = {
  input: ScriptVersionDeleteBulkInput;
};


export type MutationScriptVersionDuplicateArgs = {
  input: ScriptVersionDuplicateInput;
};


export type MutationScriptVersionDuplicateBulkArgs = {
  input: ScriptVersionDuplicateBulkInput;
};


export type MutationScriptVersionUpdateArgs = {
  input: ScriptVersionUpdateInput;
};


export type MutationScriptVersionUpdateVersionNameArgs = {
  input: ScriptVersionUpdateVersionNameInput;
};


export type MutationSetAdSetMappingMarginArgs = {
  input: AdSetMappingSetMarginInput;
};


export type MutationSetDeclaredUnitPricesArgs = {
  declaredUnitPrices: Array<DeclaredUnitPriceInput>;
  orderId: Scalars['ID']['input'];
};


export type MutationSetLogisticShopifyCarrierServiceConditionArgs = {
  active: Scalars['Boolean']['input'];
  input?: InputMaybe<ShopifyCarrierServiceConditionInput>;
  saleChannelId: Scalars['Long']['input'];
};


export type MutationSetMomoConnectionArgs = {
  input: SetMomoConnectionInput;
};


export type MutationShipOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationSingleProductFaqGenerateAllArgs = {
  input: SingleProductFaqGenerateAllInput;
};


export type MutationSingleProductFaqRegenerateArgs = {
  input: SingleProductFaqRegenerateInput;
};


export type MutationStartProductReviewCompetitorAnalysisArgs = {
  input: ProductReviewCompetitorAnalysisRequestInput;
};


export type MutationStoreConnectionByteplusCredentialSaveArgs = {
  input: StoreConnectionByteplusCredentialSaveInput;
};


export type MutationStoreConnectionDeleteArgs = {
  input: StoreConnectionDeleteInput;
};


export type MutationStoreConnectionFacebookAuthUrlGenerateArgs = {
  input: StoreConnectionFacebookAuthUrlGenerateInput;
};


export type MutationStoreConnectionFacebookPageSelectArgs = {
  input: StoreConnectionFacebookPageSelectInput;
};


export type MutationStoreConnectionRakutenCookieSaveArgs = {
  input: StoreConnectionRakutenCookieSaveInput;
};


export type MutationStoreConnectionShopeeAuthUrlGenerateArgs = {
  input: StoreConnectionShopeeAuthUrlGenerateInput;
};


export type MutationStoreConnectionShopeeSessionCookieSaveArgs = {
  input: StoreConnectionShopeeSessionCookieSaveInput;
};


export type MutationStoreConnectionTiktokCookieSaveArgs = {
  input: StoreConnectionTiktokCookieSaveInput;
};


export type MutationStoreSettingCountryOfOriginArgs = {
  countryOfOrigin?: InputMaybe<Scalars['String']['input']>;
  storeId: Scalars['Long']['input'];
};


export type MutationSyncStoreProductsArgs = {
  anyxStoreId: Scalars['String']['input'];
  salesChannel: SalesChannelType;
};


export type MutationTestLlmReplyArgs = {
  roomId: Scalars['ID']['input'];
  viewerComment: Scalars['String']['input'];
};


export type MutationTikTokAdsExchangeCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationToggleClosingScriptActiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleFallbackTemplateActiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleSensitiveWordActiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTokopediaSaleChannelCreateArgs = {
  input: TokopediaSaleChannelCreateInput;
};


export type MutationTokopediaSaleChannelLinkTikTokArgs = {
  input: TokopediaSaleChannelLinkTikTokInput;
};


export type MutationTokopediaSaleChannelReconnectArgs = {
  input: TokopediaSaleChannelReconnectInput;
};


export type MutationTransitionScriptAddArgs = {
  input: TransitionScriptAddInput;
};


export type MutationTransitionScriptDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTransitionScriptGenerateTtsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTransitionScriptUpdateArgs = {
  input: TransitionScriptUpdateInput;
};


export type MutationTransitionScriptVoiceRemoveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTransitionScriptVoiceUrlUpdateArgs = {
  input: TransitionScriptVoiceUrlUpdateInput;
};


export type MutationTtsBatchDownloadArgs = {
  input: TtsBatchDownloadInput;
};


export type MutationTtsFaqGenerateArgs = {
  input: TtsFaqGenerationInput;
};


export type MutationTtsGeneralFaqGenerateArgs = {
  input: TtsGeneralFaqGenerationInput;
};


export type MutationTtsGeneralFaqGenerateBulkArgs = {
  input: TtsGeneralFaqGenerateBulkInput;
};


export type MutationTtsGenerateArgs = {
  input: TtsGenerationInput;
};


export type MutationTtsGenerateBulkArgs = {
  input: TtsGenerateBulkInput;
};


export type MutationTtsProductFaqGenerateArgs = {
  input: TtsProductFaqGenerationInput;
};


export type MutationTtsProductFaqGenerateBulkArgs = {
  input: TtsProductFaqGenerateBulkInput;
};


export type MutationUnarchiveProductVariantsArgs = {
  productVariantIds: Array<Scalars['Long']['input']>;
};


export type MutationUnsetMomoConnectionArgs = {
  input: UnsetMomoConnectionInput;
};


export type MutationUpdateAiAutoReplySettingArgs = {
  input: UpdateAiAutoReplySettingInput;
};


export type MutationUpdateAnylogiCrossBorderShippingOrderArgs = {
  input?: InputMaybe<AnylogiUpdateCrossBorderShippingOrderInput>;
};


export type MutationUpdateAnylogiSupplierUserArgs = {
  currency: AnylogiCurrencyInput;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  language: Language;
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  timezone: AnylogiTimezone;
};


export type MutationUpdateClosingScriptArgs = {
  id: Scalars['ID']['input'];
  input: AnyLiveClosingScriptUpdateInput;
};


export type MutationUpdateCourierSettingsArgs = {
  input: CourierSettingsInput;
};


export type MutationUpdateFallbackTemplateArgs = {
  input: AnyLiveUpdateFallbackTemplateInput;
};


export type MutationUpdateInboundArgs = {
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  inboundDate: Scalars['Time']['input'];
  products: Array<InboundSku>;
  supplierId: Scalars['ID']['input'];
  warehouseArrivalDate?: InputMaybe<Scalars['Time']['input']>;
};


export type MutationUpdateInboundWarehouseArrivalDateArgs = {
  id: Scalars['ID']['input'];
  warehouseArrivalDate?: InputMaybe<Scalars['Time']['input']>;
};


export type MutationUpdateLogisticChannelArgs = {
  chargeCODFee: Scalars['Boolean']['input'];
  preferredDeliveryDateTime?: InputMaybe<Scalars['Boolean']['input']>;
  saleChannelId: Scalars['Long']['input'];
  validateAddress: Scalars['Boolean']['input'];
  verified: Scalars['Boolean']['input'];
};


export type MutationUpdateLogisticShopifyCarrierServiceConditionArgs = {
  id: Scalars['ID']['input'];
  input: ShopifyCarrierServiceConditionInput;
};


export type MutationUpdateMarketplaceCalendarEventArgs = {
  input: UpdateMarketplaceCalendarEventInput;
};


export type MutationUpdateSensitiveWordArgs = {
  input: AnyLiveUpdateSensitiveWordInput;
};


export type MutationUpdateSupplierArgs = {
  addressFirst?: InputMaybe<Scalars['String']['input']>;
  addressSecond?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<PhoneNumberInput>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateWarehouseArgs = {
  addressFirst: Scalars['String']['input'];
  addressSecond?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Country>;
  deliveryDestination: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  phoneNumber: PhoneNumberInput;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUploadInboundsWithCsvArgs = {
  csvUrl: Scalars['String']['input'];
  storeId?: InputMaybe<Scalars['Long']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUploadInventoryFileArgs = {
  input: InventoryUploadInput;
};


export type MutationVoidShippingArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationYahooAdsExchangeCodeArgs = {
  input: YahooAdsExchangeCodeInput;
};

export type MuteChat = {
  __typename?: 'MuteChat';
  isAuto: Scalars['Boolean']['output'];
};

export type Name = {
  __typename?: 'Name';
  first: Scalars['String']['output'];
  last: Scalars['String']['output'];
};

export type NameInput = {
  first: Scalars['String']['input'];
  last: Scalars['String']['input'];
};

export type NoInstagramAccountConnectToFacebookError = {
  __typename?: 'NoInstagramAccountConnectToFacebookError';
  message: Scalars['String']['output'];
};

export type NoInstagramAccountRefreshTokenError = {
  __typename?: 'NoInstagramAccountRefreshTokenError';
  message: Scalars['String']['output'];
};

export type NumericValueWithDiffPayload = {
  __typename?: 'NumericValueWithDiffPayload';
  diff: Scalars['BigDecimal']['output'];
  diffPercentage: Scalars['BigDecimal']['output'];
  value: Scalars['BigDecimal']['output'];
};

export type OkResponse = {
  __typename?: 'OkResponse';
  ok: Scalars['Boolean']['output'];
};

export type Onboarding = {
  __typename?: 'Onboarding';
  hasConnectedSaleChannel: Scalars['Boolean']['output'];
  hasInputUnitCost: Scalars['Boolean']['output'];
  hasRegisteredOrder: Scalars['Boolean']['output'];
  hasShopifyChannel: Scalars['Boolean']['output'];
  inactiveSaleChannelCount: Scalars['Int']['output'];
  storeId: Scalars['Long']['output'];
};

export type OnboardingInput = {
  storeId: Scalars['Long']['input'];
};

export type OngoingCount = {
  __typename?: 'OngoingCount';
  ongoingCount: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type OperationResultPayload = {
  __typename?: 'OperationResultPayload';
  success: Scalars['Boolean']['output'];
};

export type OptInActivityV4 = CustomerActivityV4 & {
  __typename?: 'OptInActivityV4';
  chatType: ChatType;
  id: Scalars['String']['output'];
  optInOperation: OptInOperation;
  timestamp: Scalars['UnixTimestamp']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export const OptInCallToActionText = {
  ALLOW: 'ALLOW',
  GET: 'GET',
  GET_UPDATES: 'GET_UPDATES',
  OPT_IN: 'OPT_IN',
  SIGN_UP: 'SIGN_UP'
} as const;

export type OptInCallToActionText = typeof OptInCallToActionText[keyof typeof OptInCallToActionText];
export const OptInOperation = {
  OPTED_OUT: 'OPTED_OUT',
  OPT_IN_ACCEPTED: 'OPT_IN_ACCEPTED',
  REQUEST_SENT: 'REQUEST_SENT'
} as const;

export type OptInOperation = typeof OptInOperation[keyof typeof OptInOperation];
export type OrderAddress = {
  __typename?: 'OrderAddress';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  cityName: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  name: Name;
  phoneNumber: Scalars['String']['output'];
  phoneNumberCountry: Scalars['String']['output'];
  province: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type OrderAddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  name: NameInput;
  phoneNumber: Scalars['String']['input'];
  phoneNumberCountry: Scalars['String']['input'];
  province?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

/** if orderIds exist, fetch orders by orderIds. otherwise fetch all orders by filter */
export type OrderCsvExportV2Input = {
  exportType: OrderExportType;
  filter?: InputMaybe<OrderListFilterInput>;
  orderIds: Array<Scalars['Long']['input']>;
};

export type OrderCsvExportV3Output = {
  __typename?: 'OrderCSVExportV3Output';
  documentId: Scalars['Long']['output'];
};

export const OrderCheckoutCurrency = {
  AED: 'AED',
  AFN: 'AFN',
  ALL: 'ALL',
  AMD: 'AMD',
  ANG: 'ANG',
  AOA: 'AOA',
  ARS: 'ARS',
  AUD: 'AUD',
  AWG: 'AWG',
  AZN: 'AZN',
  BAM: 'BAM',
  BBD: 'BBD',
  BDT: 'BDT',
  BGN: 'BGN',
  BHD: 'BHD',
  BIF: 'BIF',
  BMD: 'BMD',
  BND: 'BND',
  BOB: 'BOB',
  BRL: 'BRL',
  BSD: 'BSD',
  BTN: 'BTN',
  BWP: 'BWP',
  BYN: 'BYN',
  BZD: 'BZD',
  CAD: 'CAD',
  CDF: 'CDF',
  CHF: 'CHF',
  CLP: 'CLP',
  CNY: 'CNY',
  COP: 'COP',
  CRC: 'CRC',
  CVE: 'CVE',
  CZK: 'CZK',
  DJF: 'DJF',
  DKK: 'DKK',
  DOP: 'DOP',
  DZD: 'DZD',
  EGP: 'EGP',
  ERN: 'ERN',
  ETB: 'ETB',
  EUR: 'EUR',
  FJD: 'FJD',
  FKP: 'FKP',
  GBP: 'GBP',
  GEL: 'GEL',
  GHS: 'GHS',
  GIP: 'GIP',
  GMD: 'GMD',
  GNF: 'GNF',
  GTQ: 'GTQ',
  GYD: 'GYD',
  HKD: 'HKD',
  HNL: 'HNL',
  HRK: 'HRK',
  HTG: 'HTG',
  HUF: 'HUF',
  IDR: 'IDR',
  ILS: 'ILS',
  INR: 'INR',
  IQD: 'IQD',
  IRR: 'IRR',
  ISK: 'ISK',
  JEP: 'JEP',
  JMD: 'JMD',
  JOD: 'JOD',
  JPY: 'JPY',
  KES: 'KES',
  KGS: 'KGS',
  KHR: 'KHR',
  KID: 'KID',
  KMF: 'KMF',
  KRW: 'KRW',
  KWD: 'KWD',
  KYD: 'KYD',
  KZT: 'KZT',
  LAK: 'LAK',
  LBP: 'LBP',
  LKR: 'LKR',
  LRD: 'LRD',
  LSL: 'LSL',
  LTL: 'LTL',
  LVL: 'LVL',
  LYD: 'LYD',
  MAD: 'MAD',
  MDL: 'MDL',
  MGA: 'MGA',
  MKD: 'MKD',
  MMK: 'MMK',
  MNT: 'MNT',
  MOP: 'MOP',
  MRU: 'MRU',
  MUR: 'MUR',
  MVR: 'MVR',
  MWK: 'MWK',
  MXN: 'MXN',
  MYR: 'MYR',
  MZN: 'MZN',
  NAD: 'NAD',
  NGN: 'NGN',
  NIO: 'NIO',
  NOK: 'NOK',
  NPR: 'NPR',
  NZD: 'NZD',
  OMR: 'OMR',
  PAB: 'PAB',
  PEN: 'PEN',
  PGK: 'PGK',
  PHP: 'PHP',
  PKR: 'PKR',
  PLN: 'PLN',
  PYG: 'PYG',
  QAR: 'QAR',
  RON: 'RON',
  RSD: 'RSD',
  RUB: 'RUB',
  RWF: 'RWF',
  SAR: 'SAR',
  SBD: 'SBD',
  SCR: 'SCR',
  SDG: 'SDG',
  SEK: 'SEK',
  SGD: 'SGD',
  SHP: 'SHP',
  SLL: 'SLL',
  SOS: 'SOS',
  SRD: 'SRD',
  SSP: 'SSP',
  STN: 'STN',
  SYP: 'SYP',
  SZL: 'SZL',
  THB: 'THB',
  TJS: 'TJS',
  TMT: 'TMT',
  TND: 'TND',
  TOP: 'TOP',
  TRY: 'TRY',
  TTD: 'TTD',
  TWD: 'TWD',
  TZS: 'TZS',
  UAH: 'UAH',
  UGX: 'UGX',
  USD: 'USD',
  UYU: 'UYU',
  UZS: 'UZS',
  VED: 'VED',
  VES: 'VES',
  VND: 'VND',
  VUV: 'VUV',
  WST: 'WST',
  XAF: 'XAF',
  XCD: 'XCD',
  XOF: 'XOF',
  XPF: 'XPF',
  YER: 'YER',
  ZAR: 'ZAR',
  ZMW: 'ZMW'
} as const;

export type OrderCheckoutCurrency = typeof OrderCheckoutCurrency[keyof typeof OrderCheckoutCurrency];
export type OrderCustomerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name: NameInput;
  phoneNumber: Scalars['String']['input'];
  phoneNumberCountry: ShopifySupportedCountry;
};

export const OrderDateFilterTypeV2 = {
  CREATED: 'CREATED',
  SHIPPED: 'SHIPPED'
} as const;

export type OrderDateFilterTypeV2 = typeof OrderDateFilterTypeV2[keyof typeof OrderDateFilterTypeV2];
export type OrderDateRangeInput = {
  endAt: Scalars['LocalDate']['input'];
  startAt: Scalars['LocalDate']['input'];
  type: OrderDateFilterTypeV2;
};

export type OrderDetail = {
  __typename?: 'OrderDetail';
  billingAddress?: Maybe<OrderAddress>;
  cancelledDate?: Maybe<Scalars['OffsetDateTime']['output']>;
  createdDate: Scalars['OffsetDateTime']['output'];
  currency: Scalars['String']['output'];
  customer?: Maybe<ReadOrderCustomer>;
  deliveryStatus: DeliveryStatus;
  discount?: Maybe<Scalars['BigDecimal']['output']>;
  /** we support only for Sino store now. */
  hasAwb: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  note: Scalars['String']['output'];
  orderLogistics?: Maybe<OrderLogistics>;
  orderProducts: Array<OrderProduct>;
  paymentMethod: PaymentMethodV2;
  saleChannel: SaleChannel;
  saleChannelSpecific?: Maybe<SaleChannelSpecificData>;
  sellerChannelOrderId: Scalars['String']['output'];
  shipping?: Maybe<Scalars['BigDecimal']['output']>;
  shippingAddress?: Maybe<OrderAddress>;
  shippingDate?: Maybe<Scalars['OffsetDateTime']['output']>;
  subtotal?: Maybe<Scalars['BigDecimal']['output']>;
  total?: Maybe<Scalars['BigDecimal']['output']>;
  totalTax?: Maybe<Scalars['BigDecimal']['output']>;
};

export const OrderExportType = {
  PER_ORDER: 'PER_ORDER',
  PER_PRODUCT: 'PER_PRODUCT'
} as const;

export type OrderExportType = typeof OrderExportType[keyof typeof OrderExportType];
export type OrderFilters = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  channelProvider?: InputMaybe<ChannelProvider>;
  courierType?: InputMaybe<CrossBorderCourierProvider>;
  created?: InputMaybe<InputDateRange>;
  crossBorderValidationErrors?: InputMaybe<Array<CrossBorderValidationError>>;
  deliveryStatus?: InputMaybe<DeliveryStatus>;
  deliveryStatusIn?: InputMaybe<Array<DeliveryStatus>>;
  deliveryStatusNe?: InputMaybe<Array<DeliveryStatus>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  labelCreated?: InputMaybe<InputDateRange>;
  laterPay?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod?: InputMaybe<AnylogiPaymentMethod>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  shipped?: InputMaybe<InputDateRange>;
  shippingAddressCountryNe?: InputMaybe<Scalars['String']['input']>;
  shippingStatus?: InputMaybe<ShippingStatus>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  trackingStatusIn?: InputMaybe<Array<AnylogiOrderTrackingStatus>>;
  validationStatus?: InputMaybe<Array<ValidationStatus>>;
};

export type OrderIgnoreAddressValidationErrorPayload = {
  __typename?: 'OrderIgnoreAddressValidationErrorPayload';
  ok: Scalars['Boolean']['output'];
};

export type OrderItem = {
  __typename?: 'OrderItem';
  amount: Scalars['Int']['output'];
  costMoney: AnyChatMoney;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  totalCostMoney: AnyChatMoney;
};

export const OrderKeywordFilterTypeV2 = {
  ORDER_ID: 'ORDER_ID',
  PRODUCT: 'PRODUCT',
  TRACKING_NUMBER: 'TRACKING_NUMBER'
} as const;

export type OrderKeywordFilterTypeV2 = typeof OrderKeywordFilterTypeV2[keyof typeof OrderKeywordFilterTypeV2];
export type OrderKeywordFilterV2Input = {
  keyword: Scalars['String']['input'];
  type: OrderKeywordFilterTypeV2;
};

export type OrderListFilterInput = {
  accountId?: InputMaybe<Scalars['Long']['input']>;
  courierService?: InputMaybe<CourierService>;
  deliveryStatus?: InputMaybe<DeliveryStatus>;
  keywordFilterV2?: InputMaybe<OrderKeywordFilterV2Input>;
  /** false means all orders */
  onlyShippingAddressValidationError: Scalars['Boolean']['input'];
  orderDateRange?: InputMaybe<OrderDateRangeInput>;
  paymentMethod?: InputMaybe<PaymentMethodV2>;
  saleChannelType?: InputMaybe<MarketplaceSaleChannelType>;
  storeId?: InputMaybe<Scalars['Long']['input']>;
};

/** Order list view. {start}-{end} / {total}. page {page} of {totalPage} */
export type OrderListView = {
  __typename?: 'OrderListView';
  end: Scalars['Int']['output'];
  items: Array<OrderRecord>;
  page: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPage: Scalars['Int']['output'];
};

export type OrderLogistics = {
  __typename?: 'OrderLogistics';
  anylogiId: Scalars['String']['output'];
  codFee?: Maybe<Scalars['BigDecimal']['output']>;
  courierService: CourierService;
  deliveryNote: Scalars['String']['output'];
  desiredDeliveryDate?: Maybe<Scalars['LocalDate']['output']>;
  desiredDeliveryTime: PreferredDeliveryTime;
  shippingAddressValidationResult: ShippingAddressValidationResult;
  temperature: OrderTemperature;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingURL?: Maybe<Scalars['URL']['output']>;
};

export type OrderLogisticsForList = {
  __typename?: 'OrderLogisticsForList';
  anylogiId: Scalars['String']['output'];
  courierService: CourierService;
  shippingAddressValidationResult: ShippingAddressValidationResult;
  warehouse?: Maybe<AnyXWarehouse>;
};

export const OrderOnboardingStatus = {
  NO_SALE_CHANNEL: 'NO_SALE_CHANNEL',
  ONGOING: 'ONGOING'
} as const;

export type OrderOnboardingStatus = typeof OrderOnboardingStatus[keyof typeof OrderOnboardingStatus];
export type OrderOverview = {
  __typename?: 'OrderOverview';
  all: Scalars['Int']['output'];
  allocating: Scalars['Int']['output'];
  cancelled: Scalars['Int']['output'];
  deliveryStatuses: Array<DeliveryStatus>;
  paying: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  preparing: Scalars['Int']['output'];
  shipped: Scalars['Int']['output'];
  working: Scalars['Int']['output'];
};

export type OrderProduct = {
  __typename?: 'OrderProduct';
  amount: Scalars['BigDecimal']['output'];
  externalId: Scalars['String']['output'];
  fulfillable: Scalars['Boolean']['output'];
  logistics?: Maybe<ReadOrderProductLogistics>;
  media?: Maybe<Scalars['URL']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['BigDecimal']['output'];
  productCode?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  saleChannelSpecificProductData?: Maybe<SaleChannelSpecificProductData>;
  sellerSku?: Maybe<Scalars['String']['output']>;
};

export const OrderProductDeliveryStatus = {
  ALLOCATED: 'ALLOCATED',
  ALLOCATING: 'ALLOCATING',
  CANCELLED: 'CANCELLED',
  UNKNOWN: 'UNKNOWN'
} as const;

export type OrderProductDeliveryStatus = typeof OrderProductDeliveryStatus[keyof typeof OrderProductDeliveryStatus];
export type OrderProductInputV2Input = {
  /** when this OrderProduct is existing, provide the same externalId, if it's new, use null */
  externalId?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['BigDecimal']['input'];
  productCode: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type OrderRecord = {
  __typename?: 'OrderRecord';
  cancelable: Scalars['Boolean']['output'];
  createdAt: Scalars['OffsetDateTime']['output'];
  currency: CurrencyCode;
  customerName?: Maybe<Name>;
  deliveryStatus: DeliveryStatus;
  externalOrderId: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  itemCount: Scalars['Int']['output'];
  /** only for logistics-connected orders */
  logistics?: Maybe<OrderLogisticsForList>;
  media?: Maybe<Scalars['URL']['output']>;
  paymentMethod: PaymentMethodV2;
  saleChannel: SaleChannel;
  saleChannelId: Scalars['Long']['output'];
  shippedAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  total: Scalars['BigDecimal']['output'];
};

export type OrderSource = {
  __typename?: 'OrderSource';
  anyXOrderId?: Maybe<Scalars['Long']['output']>;
  imageUrl?: Maybe<Scalars['Url']['output']>;
  itemCount: Scalars['Int']['output'];
  shopeeOrderSN: Scalars['String']['output'];
};

export const OrderTemperature = {
  KEEP_FROZEN: 'KEEP_FROZEN',
  KEEP_REFRIGERATED: 'KEEP_REFRIGERATED',
  NORMAL: 'NORMAL'
} as const;

export type OrderTemperature = typeof OrderTemperature[keyof typeof OrderTemperature];
export type OrderedActivityV4 = CustomerActivityV4 & {
  __typename?: 'OrderedActivityV4';
  anyXRelativeUrl?: Maybe<Scalars['String']['output']>;
  externalOrderId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  saleChannel: AnyChatSaleChannelType;
  timestamp: Scalars['UnixTimestamp']['output'];
};

export type OtherSticker = {
  __typename?: 'OtherSticker';
  stickerType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PackageType = DhlPackageWrapper | FedExPackageWrapper;

export type PackageTypeInput = {
  dhlPackageType?: InputMaybe<DhlPackageType>;
  fedexPackageType?: InputMaybe<FedExPackageType>;
};

export type PageHaveConnectedToOtherStore = {
  __typename?: 'PageHaveConnectedToOtherStore';
  message: Scalars['String']['output'];
  storeId: Scalars['Long']['output'];
};

export type PageResultAutomationFlow = {
  __typename?: 'PageResultAutomationFlow';
  records: Array<AutomationFlow>;
  total: Scalars['Int']['output'];
};

export type PageResultCustomerActivityV4 = {
  __typename?: 'PageResultCustomerActivityV4';
  records: Array<CustomerActivityV4>;
  total: Scalars['Int']['output'];
};

export type PageResultCustomerChatKeyWordSearchItem = {
  __typename?: 'PageResultCustomerChatKeyWordSearchItem';
  records: Array<CustomerChatKeyWordSearchItem>;
  total: Scalars['Int']['output'];
};

export type PageResultInfluencerCampaign = {
  __typename?: 'PageResultInfluencerCampaign';
  records: Array<InfluencerCampaign>;
  total: Scalars['Int']['output'];
};

export type PageResultLineRichMenuListItem = {
  __typename?: 'PageResultLineRichMenuListItem';
  records: Array<LineRichMenuListItem>;
  total: Scalars['Int']['output'];
};

export type PageResultMessageSearchResultItem = {
  __typename?: 'PageResultMessageSearchResultItem';
  records: Array<MessageSearchResultItem>;
  total: Scalars['Int']['output'];
};

export type Paginated = {
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedList = {
  totalCount: Scalars['Int']['output'];
};

export type Path = {
  __typename?: 'Path';
  url: Scalars['String']['output'];
};

export type PaymentMethodFilterInput = {
  storeId: Scalars['Long']['input'];
};

export const PaymentMethodV2 = {
  CASH_ON_DELIVERY: 'CASH_ON_DELIVERY',
  NON_CASH_ON_DELIVERY: 'NON_CASH_ON_DELIVERY',
  NO_PAYMENT: 'NO_PAYMENT'
} as const;

export type PaymentMethodV2 = typeof PaymentMethodV2[keyof typeof PaymentMethodV2];
export type PaymentMethodsPayload = {
  __typename?: 'PaymentMethodsPayload';
  paymentMethodsV2: Array<PaymentMethodV2>;
};

export const PaymentStatus = {
  CANCELLED: 'CANCELLED',
  PAID: 'PAID',
  PAYING: 'PAYING'
} as const;

export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus];
export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  countryCode: Country;
  number: Scalars['String']['output'];
};

export type PhoneNumberInput = {
  countryCode: Country;
  number: Scalars['String']['input'];
};

export type PlainTextMessage = {
  __typename?: 'PlainTextMessage';
  quotedEvent?: Maybe<QuotedLineChatEvent>;
  richText?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type PlainTextMessageInput = {
  quotedChatEvent?: InputMaybe<QuotedChatEventInput>;
  richText?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export const PreferredDeliveryTime = {
  AFTERNOON: 'AFTERNOON',
  MORNING: 'MORNING',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
  _12_14: '_12_14',
  _14_16: '_14_16',
  _16_18: '_16_18',
  _18_20: '_18_20',
  _18_21: '_18_21',
  _19_21: '_19_21',
  _20_21: '_20_21'
} as const;

export type PreferredDeliveryTime = typeof PreferredDeliveryTime[keyof typeof PreferredDeliveryTime];
export type Product = {
  __typename?: 'Product';
  description: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  media: Array<Scalars['URL']['output']>;
  name: Scalars['String']['output'];
  store: MdStore;
};

export type ProductAdSetMappingInfoPayload = {
  __typename?: 'ProductAdSetMappingInfoPayload';
  media?: Maybe<Scalars['String']['output']>;
  productCode: Scalars['String']['output'];
  productId: Scalars['Long']['output'];
  productName: Scalars['String']['output'];
  productVariantId: Scalars['Long']['output'];
  productVariantName: Scalars['String']['output'];
  saleChannels?: Maybe<Array<ListingInfoPayload>>;
};

export type ProductCsvExportFileResult = {
  __typename?: 'ProductCSVExportFileResult';
  fileUri: Scalars['String']['output'];
};

/** if productIds exist, fetch products by productIds. otherwise fetch all products by filter */
export type ProductCsvExportInput = {
  filter?: InputMaybe<ProductListFilterInput>;
  productIds: Array<Scalars['Long']['input']>;
};

export type ProductCsvExportJobResult = {
  __typename?: 'ProductCSVExportJobResult';
  documentId: Scalars['Long']['output'];
};

export type ProductCsvExportResult = ProductCsvExportFileResult | ProductCsvExportJobResult;

export type ProductCategoryAndPricePayload = {
  __typename?: 'ProductCategoryAndPricePayload';
  category?: Maybe<Array<Scalars['String']['output']>>;
  currency?: Maybe<ReportSupportedCurrency>;
  price?: Maybe<Scalars['BigDecimal']['output']>;
  productUrl?: Maybe<Scalars['String']['output']>;
};

export type ProductChartInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  orderStatus: ReportOrderStatus;
  productId: Scalars['Long']['input'];
  saleChannelType: SaleChannelType;
  startDate: Scalars['ZonedDatetime']['input'];
};

export type ProductChartPayload = {
  __typename?: 'ProductChartPayload';
  advertisingFee: Array<Scalars['Map']['output']>;
  avgOrderValues: Array<Scalars['Map']['output']>;
  cancelAndOrRefund: Array<Scalars['Map']['output']>;
  currency: ReportSupportedCurrency;
  discount: Array<Scalars['Map']['output']>;
  discountRate: Array<Scalars['Map']['output']>;
  grossSales: Array<Scalars['Map']['output']>;
  netSales: Array<Scalars['Map']['output']>;
  orders: Array<Scalars['Map']['output']>;
  revenueViaAds: Array<Scalars['Map']['output']>;
  roas: Array<Scalars['Map']['output']>;
  shippingFee: Array<Scalars['Map']['output']>;
  totalSales: Array<Scalars['Map']['output']>;
  unitSold: Array<Scalars['Map']['output']>;
};

export type ProductDailyReportData = {
  __typename?: 'ProductDailyReportData';
  advertisingFee: Scalars['BigDecimal']['output'];
  avgOrderValues: Scalars['BigDecimal']['output'];
  commissionFee: Scalars['BigDecimal']['output'];
  consumptionRatio?: Maybe<Scalars['BigDecimal']['output']>;
  costRate: Scalars['BigDecimal']['output'];
  date?: Maybe<Scalars['LocalDate']['output']>;
  discount: Scalars['BigDecimal']['output'];
  discountRate: Scalars['BigDecimal']['output'];
  grossProfit: Scalars['BigDecimal']['output'];
  grossProfitRate: Scalars['BigDecimal']['output'];
  inventory?: Maybe<Scalars['Long']['output']>;
  logisticsFee: Scalars['BigDecimal']['output'];
  marginalProfit: Scalars['BigDecimal']['output'];
  marginalProfitRate: Scalars['BigDecimal']['output'];
  merchandiseCost: Scalars['BigDecimal']['output'];
  orders: Scalars['Long']['output'];
  otherCost: Scalars['BigDecimal']['output'];
  predictedInventoryDays?: Maybe<Scalars['Long']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  remaining?: Maybe<Scalars['Long']['output']>;
  revenue: Scalars['BigDecimal']['output'];
  roas: Scalars['BigDecimal']['output'];
  targetInventoryDays?: Maybe<Scalars['Long']['output']>;
};

export type ProductDailyReportPayload = {
  __typename?: 'ProductDailyReportPayload';
  currency: ReportSupportedCurrency;
  data: Array<ProductDailyReportData>;
  page: Scalars['Int']['output'];
  summary: ProductReportSummary;
  total: ProductDailyReportData;
  totalItems: Scalars['Int']['output'];
};

export type ProductDetail = {
  __typename?: 'ProductDetail';
  description: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  media: Array<Scalars['URL']['output']>;
  name: Scalars['String']['output'];
  nameEn?: Maybe<Scalars['String']['output']>;
  /** can exist when the product has only 1 variant */
  singleVariant?: Maybe<ProductVariantSingle>;
  status: ProductVariantStatus;
  store: MdStore;
  variantsV2: Array<ProductVariantV2>;
};

export type ProductDetailedReportInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  orderStatus: ReportOrderStatus;
  productId: Scalars['Long']['input'];
  saleChannelType: SaleChannelType;
  startDate: Scalars['ZonedDatetime']['input'];
};

export type ProductDetailedReportPayload = {
  __typename?: 'ProductDetailedReportPayload';
  advertisingFee: Scalars['BigDecimal']['output'];
  avgOrderValues: Scalars['BigDecimal']['output'];
  cancelAndOrRefund: Scalars['BigDecimal']['output'];
  currency: ReportSupportedCurrency;
  date: Scalars['LocalDate']['output'];
  discount: Scalars['BigDecimal']['output'];
  discountRate: Scalars['BigDecimal']['output'];
  grossSales: Scalars['BigDecimal']['output'];
  netSales: Scalars['BigDecimal']['output'];
  orders: Scalars['Long']['output'];
  revenueViaAds: Scalars['BigDecimal']['output'];
  roas: Scalars['BigDecimal']['output'];
  shippingFee: Scalars['BigDecimal']['output'];
  totalSales: Scalars['BigDecimal']['output'];
  unitSold: Scalars['Long']['output'];
};

export type ProductDetailedReportPayloadList = {
  __typename?: 'ProductDetailedReportPayloadList';
  items: Array<ProductDetailedReportPayload>;
  total: ProductDetailedReportTotalPayload;
};

export type ProductDetailedReportTotalPayload = {
  __typename?: 'ProductDetailedReportTotalPayload';
  advertisingFee: Scalars['BigDecimal']['output'];
  avgOrderValues: Scalars['BigDecimal']['output'];
  cancelAndOrRefund: Scalars['BigDecimal']['output'];
  currency: ReportSupportedCurrency;
  discount: Scalars['BigDecimal']['output'];
  discountRate: Scalars['BigDecimal']['output'];
  grossSales: Scalars['BigDecimal']['output'];
  netSales: Scalars['BigDecimal']['output'];
  orders: Scalars['Long']['output'];
  revenueViaAds: Scalars['BigDecimal']['output'];
  roas: Scalars['BigDecimal']['output'];
  shippingFee: Scalars['BigDecimal']['output'];
  totalSales: Scalars['BigDecimal']['output'];
  unitSold: Scalars['Long']['output'];
};

/** A product-specific FAQ item linked to a product. */
export type ProductFaq = {
  __typename?: 'ProductFaq';
  /** The answer content for this FAQ. */
  answer?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the FAQ. */
  id: Scalars['ID']['output'];
  /** The name/title for this FAQ. */
  name: Scalars['String']['output'];
  /** The product ID this FAQ belongs to. */
  productId: Scalars['ID']['output'];
  /** Trigger words that activate this FAQ. */
  triggerWords?: Maybe<Scalars['String']['output']>;
  /** The TTS generation ID if TTS has been generated. */
  ttsId?: Maybe<Scalars['ID']['output']>;
  /** The TTS speed for this FAQ. */
  ttsSpeed: Scalars['Float']['output'];
};

/** Input for creating a new product FAQ. */
export type ProductFaqCreateInput = {
  /** The answer content for this FAQ. */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** The name/title for this FAQ. */
  name: Scalars['String']['input'];
  /** The product ID to create the FAQ for. */
  productId: Scalars['ID']['input'];
  /** Trigger words that will activate this FAQ. */
  triggerWords?: InputMaybe<Scalars['String']['input']>;
};

/** Input for deleting a product FAQ. */
export type ProductFaqDeleteInput = {
  /** The ID of the product FAQ to delete. */
  id: Scalars['ID']['input'];
};

/** Input for submitting product FAQ generation. Generates FAQ based on products and knowledge base. */
export type ProductFaqGenerationSubmitInput = {
  /** Live asset version ID. */
  liveAssetVersionId: Scalars['String']['input'];
};

/** Input for updating an existing product FAQ. */
export type ProductFaqUpdateInput = {
  /** Updated answer content for this FAQ. */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the product FAQ to update. */
  id: Scalars['ID']['input'];
  /** Updated name/title for this FAQ. */
  name: Scalars['String']['input'];
  /** Updated trigger words that will activate this FAQ. */
  triggerWords?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for product info. */
export type ProductInfoInput = {
  language: ScriptLanguage;
  url: Scalars['Url']['input'];
};

/** Output type for product info. */
export type ProductInfoOutput = {
  __typename?: 'ProductInfoOutput';
  name: Scalars['String']['output'];
  sellingPoint: Scalars['String']['output'];
};

export type ProductInformation = {
  __typename?: 'ProductInformation';
  id: Scalars['Long']['output'];
  media?: Maybe<Scalars['URL']['output']>;
  name: Scalars['String']['output'];
  nameEn?: Maybe<Scalars['String']['output']>;
  store: MdStore;
  variantCount: Scalars['Int']['output'];
};

export type ProductListFilterInput = {
  accountId?: InputMaybe<Scalars['Long']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  saleChannelType?: InputMaybe<MarketplaceSaleChannelType>;
  sortBy?: InputMaybe<ProductListSortInput>;
  status?: InputMaybe<ProductVariantStatus>;
  storeId?: InputMaybe<Scalars['Long']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<ProductType>;
};

export const ProductListSortByField = {
  CREATED_AT: 'CREATED_AT',
  NAME: 'NAME'
} as const;

export type ProductListSortByField = typeof ProductListSortByField[keyof typeof ProductListSortByField];
export type ProductListSortInput = {
  descending: Scalars['Boolean']['input'];
  field: ProductListSortByField;
};

/** Product variant list view. {start}-{end} / {total}. page {page} of {totalPage} */
export type ProductListView = {
  __typename?: 'ProductListView';
  end: Scalars['Int']['output'];
  items: Array<ProductRecord>;
  page: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPage: Scalars['Int']['output'];
};

export type ProductLogisticsInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  courierType?: InputMaybe<CourierService>;
  height_mm?: InputMaybe<Scalars['BigDecimal']['input']>;
  inventorySync: Scalars['Boolean']['input'];
  length_mm?: InputMaybe<Scalars['BigDecimal']['input']>;
  note: Scalars['String']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  sizeCoefficient?: InputMaybe<Scalars['Int']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  width_mm?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export const ProductOnboardingStatus = {
  NO_SALE_CHANNEL: 'NO_SALE_CHANNEL',
  ONGOING: 'ONGOING'
} as const;

export type ProductOnboardingStatus = typeof ProductOnboardingStatus[keyof typeof ProductOnboardingStatus];
export type ProductRatingOverviewPayload = {
  __typename?: 'ProductRatingOverviewPayload';
  averageRating: Scalars['BigDecimal']['output'];
  fiveStarsCount: Scalars['Long']['output'];
  fourStarsCount: Scalars['Long']['output'];
  oneStarCount: Scalars['Long']['output'];
  threeStarsCount: Scalars['Long']['output'];
  totalRatings: Scalars['Long']['output'];
  twoStarsCount: Scalars['Long']['output'];
};

export type ProductRecord = {
  __typename?: 'ProductRecord';
  createdAt: Scalars['OffsetDateTime']['output'];
  id: Scalars['Long']['output'];
  listingVariantSaleChannelIds: Array<Scalars['Long']['output']>;
  listingVariantSaleChannels: Array<SaleChannel>;
  media?: Maybe<Scalars['URL']['output']>;
  name: Scalars['String']['output'];
  store: MdStore;
  variantCount: Scalars['Int']['output'];
  /** can exist when the product has only 1 variant */
  variantProductCode?: Maybe<Scalars['String']['output']>;
  variantProductType: VariantProductType;
  /** can exist when the product has only 1 variant & has AnyLogi sku */
  warehouseCode?: Maybe<Scalars['String']['output']>;
};

export type ProductReportData = {
  __typename?: 'ProductReportData';
  accountName?: Maybe<Scalars['String']['output']>;
  advertisingCost: Scalars['BigDecimal']['output'];
  avgSalesValue: Scalars['BigDecimal']['output'];
  cancelAndOrRefund: Scalars['BigDecimal']['output'];
  commissionFees: Scalars['BigDecimal']['output'];
  daysSalesOfInventory?: Maybe<Scalars['BigDecimal']['output']>;
  discountRate: Scalars['BigDecimal']['output'];
  discounts: Scalars['BigDecimal']['output'];
  grossProfit: Scalars['BigDecimal']['output'];
  grossProfitRate: Scalars['BigDecimal']['output'];
  grossSales: Scalars['BigDecimal']['output'];
  marginalProfit: Scalars['BigDecimal']['output'];
  marginalProfitRate: Scalars['BigDecimal']['output'];
  masterDataAccountId?: Maybe<Scalars['Long']['output']>;
  masterDataStoreId?: Maybe<Scalars['Long']['output']>;
  media?: Maybe<Scalars['String']['output']>;
  merchandiseCost: Scalars['BigDecimal']['output'];
  netSales: Scalars['BigDecimal']['output'];
  productCode?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Long']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  revenue: Scalars['BigDecimal']['output'];
  revenueAdv: Scalars['BigDecimal']['output'];
  revenueGross: Scalars['BigDecimal']['output'];
  roas: Scalars['BigDecimal']['output'];
  shippingFee: Scalars['BigDecimal']['output'];
  storeName?: Maybe<Scalars['String']['output']>;
  totalSales: Scalars['BigDecimal']['output'];
  unitSold?: Maybe<Scalars['Int']['output']>;
  warehouseInventory?: Maybe<Scalars['Int']['output']>;
};

export type ProductReportExportFilterInput = {
  adsMetricsType?: InputMaybe<AdsMetricsType>;
  endDate: Scalars['ZonedDatetime']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  marketplaces: Array<SaleChannelType>;
  masterDataAccountId?: InputMaybe<Scalars['Long']['input']>;
  masterDataAccountIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  masterDataStoreIds: Array<Scalars['Long']['input']>;
  orderStatus: ReportOrderStatus;
  productIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  sortBy?: InputMaybe<ProductReportSortByField>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['ZonedDatetime']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  variants?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductReportFilterInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  marketplaces: Array<SaleChannelType>;
  masterDataAccountId?: InputMaybe<Scalars['Long']['input']>;
  masterDataStoreIds: Array<Scalars['Long']['input']>;
  orderStatus: ReportOrderStatus;
  productIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  startDate: Scalars['ZonedDatetime']['input'];
};

export type ProductReportPaginatedFilterInput = {
  adsMetricsType?: InputMaybe<AdsMetricsType>;
  endDate: Scalars['ZonedDatetime']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  marketplaces: Array<SaleChannelType>;
  masterDataAccountId?: InputMaybe<Scalars['Long']['input']>;
  masterDataAccountIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  masterDataStoreIds: Array<Scalars['Long']['input']>;
  orderStatus: ReportOrderStatus;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  productIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  sortBy?: InputMaybe<ProductReportSortByField>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['ZonedDatetime']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  variants?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductReportPayload = {
  __typename?: 'ProductReportPayload';
  currency: ReportSupportedCurrency;
  items: Array<ProductReportData>;
  meta: ReportListMeta;
};

export const ProductReportSortByField = {
  ADVERTISING_COST: 'ADVERTISING_COST',
  ADVERTISING_REVENUE: 'ADVERTISING_REVENUE',
  AVG_SALES_VALUE: 'AVG_SALES_VALUE',
  COMMISSION_FEE: 'COMMISSION_FEE',
  DAYS_SALES_INVENTORY: 'DAYS_SALES_INVENTORY',
  DISCOUNTS: 'DISCOUNTS',
  DISCOUNTS_RATE: 'DISCOUNTS_RATE',
  GROSS_PROFIT: 'GROSS_PROFIT',
  GROSS_PROFIT_RATE: 'GROSS_PROFIT_RATE',
  GROSS_REVENUE: 'GROSS_REVENUE',
  GROSS_SALES: 'GROSS_SALES',
  MARGINAL_PROFIT: 'MARGINAL_PROFIT',
  MARGINAL_PROFIT_RATE: 'MARGINAL_PROFIT_RATE',
  NET_SALES: 'NET_SALES',
  PRODUCT_NAME: 'PRODUCT_NAME',
  RETURN_CANCEL: 'RETURN_CANCEL',
  REVENUE: 'REVENUE',
  ROAS: 'ROAS',
  SHIPPING_FEE: 'SHIPPING_FEE',
  TOTAL_SALES: 'TOTAL_SALES',
  UNIT_COST: 'UNIT_COST',
  UNIT_SOLD: 'UNIT_SOLD',
  WAREHOUSE_INVENTORY: 'WAREHOUSE_INVENTORY'
} as const;

export type ProductReportSortByField = typeof ProductReportSortByField[keyof typeof ProductReportSortByField];
export type ProductReportSummary = {
  __typename?: 'ProductReportSummary';
  cancelAndOrRefund: ReportCompareData;
  grossProfit: ReportCompareData;
  grossProfitRate: ReportCompareData;
  grossSales: ReportCompareData;
  marginalProfit: ReportCompareData;
  marginalProfitRate: ReportCompareData;
  netSales: ReportCompareData;
  revenue: ReportCompareData;
  totalSales: ReportCompareData;
};

export type ProductReportSummaryPayload = {
  __typename?: 'ProductReportSummaryPayload';
  currency: ReportSupportedCurrency;
  summary: ProductReportSummary;
  total: ProductReportTotalData;
};

export type ProductReportTotalData = {
  __typename?: 'ProductReportTotalData';
  advertisingCost?: Maybe<Scalars['BigDecimal']['output']>;
  avgSalesValue: Scalars['BigDecimal']['output'];
  cancelAndOrRefund: Scalars['BigDecimal']['output'];
  commissionFees: Scalars['BigDecimal']['output'];
  daysSalesOfInventory?: Maybe<Scalars['BigDecimal']['output']>;
  discountRate: Scalars['BigDecimal']['output'];
  discounts: Scalars['BigDecimal']['output'];
  grossProfit: Scalars['BigDecimal']['output'];
  grossProfitRate: Scalars['BigDecimal']['output'];
  grossSales: Scalars['BigDecimal']['output'];
  marginalProfit: Scalars['BigDecimal']['output'];
  marginalProfitRate: Scalars['BigDecimal']['output'];
  merchandiseCost?: Maybe<Scalars['BigDecimal']['output']>;
  netSales: Scalars['BigDecimal']['output'];
  revenue: Scalars['BigDecimal']['output'];
  revenueAdv: Scalars['BigDecimal']['output'];
  revenueGross: Scalars['BigDecimal']['output'];
  roas: Scalars['BigDecimal']['output'];
  shippingFee: Scalars['BigDecimal']['output'];
  totalSales: Scalars['BigDecimal']['output'];
  unitSold?: Maybe<Scalars['Int']['output']>;
  warehouseInventory?: Maybe<Scalars['Int']['output']>;
};

export type ProductReviewAnalysisFilterInput = {
  masterDataStoreId: Scalars['Long']['input'];
  productId: Scalars['Long']['input'];
  saleChannelType: SaleChannelType;
};

export type ProductReviewCompetitorAnalysisPayload = {
  __typename?: 'ProductReviewCompetitorAnalysisPayload';
  data?: Maybe<ProductReviewCompetitorResponsePayload>;
  nextAvailableTime?: Maybe<Scalars['ZonedDatetime']['output']>;
  status: ProductReviewCompetitorAnalysisStatus;
};

export type ProductReviewCompetitorAnalysisRequestInput = {
  masterDataStoreId: Scalars['Long']['input'];
  productId: Scalars['Long']['input'];
  saleChannelType: SaleChannelType;
};

export const ProductReviewCompetitorAnalysisStatus = {
  FAILED: 'FAILED',
  FINISHED: 'FINISHED',
  NOT_ENOUGH_COMPETITORS: 'NOT_ENOUGH_COMPETITORS',
  NOT_ENOUGH_REVIEWS_COMPETITORS: 'NOT_ENOUGH_REVIEWS_COMPETITORS',
  NOT_ENOUGH_REVIEWS_PRODUCT: 'NOT_ENOUGH_REVIEWS_PRODUCT',
  NOT_FOUND: 'NOT_FOUND',
  NOT_STARTED: 'NOT_STARTED',
  NO_DATA: 'NO_DATA',
  PROCESSING: 'PROCESSING'
} as const;

export type ProductReviewCompetitorAnalysisStatus = typeof ProductReviewCompetitorAnalysisStatus[keyof typeof ProductReviewCompetitorAnalysisStatus];
export type ProductReviewCompetitorAnalysisStatusDto = {
  __typename?: 'ProductReviewCompetitorAnalysisStatusDto';
  nextAvailableTime?: Maybe<Scalars['ZonedDatetime']['output']>;
  status: ProductReviewCompetitorAnalysisStatus;
};

export type ProductReviewCompetitorResponsePayload = {
  __typename?: 'ProductReviewCompetitorResponsePayload';
  brand?: Maybe<Scalars['String']['output']>;
  competitors: Array<ProductReviewCompetitorsResponse>;
  criteria: Array<ProductReviewCriteriaResponseDto>;
  currency?: Maybe<ReportSupportedCurrency>;
  discountedPrice?: Maybe<Scalars['BigDecimal']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  masterDataStoreId: Scalars['Long']['output'];
  originalPrice?: Maybe<Scalars['BigDecimal']['output']>;
  productId: Scalars['Long']['output'];
  productUrl?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['BigDecimal']['output']>;
  reviewCount?: Maybe<Scalars['Long']['output']>;
  saleChannelType: SaleChannelType;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProductReviewCompetitorsResponse = {
  __typename?: 'ProductReviewCompetitorsResponse';
  brand?: Maybe<Scalars['String']['output']>;
  criteria: Array<ProductReviewCriteriaResponseDto>;
  currency?: Maybe<ReportSupportedCurrency>;
  discountedPrice?: Maybe<Scalars['BigDecimal']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  originalPrice?: Maybe<Scalars['BigDecimal']['output']>;
  productUrl?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['BigDecimal']['output']>;
  reviewCount?: Maybe<Scalars['Long']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProductReviewCriteriaResponseDto = {
  __typename?: 'ProductReviewCriteriaResponseDto';
  criteria: Scalars['String']['output'];
  negative?: Maybe<Scalars['BigDecimal']['output']>;
  positive?: Maybe<Scalars['BigDecimal']['output']>;
};

export type ProductReviewPayload = {
  __typename?: 'ProductReviewPayload';
  comment: Scalars['String']['output'];
  date: Scalars['LocalDatetime']['output'];
  rating: Scalars['Long']['output'];
};

export type ProductReviewSentimentAnalysisPayload = {
  __typename?: 'ProductReviewSentimentAnalysisPayload';
  data: Array<ProductReviewSentimentResponsePayload>;
};

export type ProductReviewSentimentResponsePayload = {
  __typename?: 'ProductReviewSentimentResponsePayload';
  key: Scalars['String']['output'];
  percentage: Scalars['BigDecimal']['output'];
  reviewIds: Array<Scalars['String']['output']>;
};

export type ProductReviewSummarizationPayload = {
  __typename?: 'ProductReviewSummarizationPayload';
  text: Scalars['String']['output'];
};

export type ProductReviewTopicAnalysisPayload = {
  __typename?: 'ProductReviewTopicAnalysisPayload';
  data: Array<ProductReviewTopicResponsePayload>;
};

export type ProductReviewTopicResponsePayload = {
  __typename?: 'ProductReviewTopicResponsePayload';
  percentage: Scalars['BigDecimal']['output'];
  reviewIds: Array<Scalars['String']['output']>;
  topic: Scalars['String']['output'];
  topicSummary: Scalars['String']['output'];
};

export type ProductReviewsInput = {
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  productId: Scalars['Long']['input'];
  rating?: InputMaybe<Scalars['Long']['input']>;
  reviewIds?: InputMaybe<Array<Scalars['String']['input']>>;
  saleChannelType: SaleChannelType;
};

export type ProductReviewsPayloadList = {
  __typename?: 'ProductReviewsPayloadList';
  meta: ReportListMeta;
  reviews: Array<ProductReviewPayload>;
};

export type ProductSaleChannelsInput = {
  masterDataStoreId: Scalars['Long']['input'];
  productId: Scalars['Long']['input'];
};

export type ProductSaleChannelsPayload = {
  __typename?: 'ProductSaleChannelsPayload';
  saleChannelTypes: Array<SaleChannelType>;
};

export type ProductSalesAnalyticsInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  orderStatus: ReportOrderStatus;
  productId: Scalars['Long']['input'];
  saleChannelType: SaleChannelType;
  startDate: Scalars['ZonedDatetime']['input'];
};

export type ProductSalesAnalyticsPayload = {
  __typename?: 'ProductSalesAnalyticsPayload';
  chart: Array<Scalars['Map']['output']>;
  currency: ReportSupportedCurrency;
  summary: NumericValueWithDiffPayload;
};

export type ProductSummaryInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  orderStatus: ReportOrderStatus;
  productId: Scalars['Long']['input'];
  saleChannelType: SaleChannelType;
  startDate: Scalars['ZonedDatetime']['input'];
};

export type ProductSummaryPayload = {
  __typename?: 'ProductSummaryPayload';
  advertisingFee: NumericValueWithDiffPayload;
  avgOrderValues: NumericValueWithDiffPayload;
  cancelAndOrRefund: NumericValueWithDiffPayload;
  currency: ReportSupportedCurrency;
  discount: NumericValueWithDiffPayload;
  discountRate: NumericValueWithDiffPayload;
  grossSales: NumericValueWithDiffPayload;
  netSales: NumericValueWithDiffPayload;
  orders: NumericValueWithDiffPayload;
  revenueViaAds: NumericValueWithDiffPayload;
  roas: NumericValueWithDiffPayload;
  shippingFee: NumericValueWithDiffPayload;
  totalSales: NumericValueWithDiffPayload;
  unitSold: NumericValueWithDiffPayload;
};

export type ProductTagsFilterInput = {
  masterDataAccountId?: InputMaybe<Scalars['Long']['input']>;
  masterDataStoreIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export const ProductType = {
  SET: 'SET',
  SINGLE: 'SINGLE'
} as const;

export type ProductType = typeof ProductType[keyof typeof ProductType];
export type ProductVariantCsvExportFileResult = {
  __typename?: 'ProductVariantCSVExportFileResult';
  fileUri: Scalars['String']['output'];
};

/** if productVariantIds exist, fetch variants by productVariantIds. otherwise fetch all productVariants by filter */
export type ProductVariantCsvExportInput = {
  filter?: InputMaybe<ProductVariantListFilterInput>;
  productVariantIds: Array<Scalars['Long']['input']>;
};

export type ProductVariantCsvExportJobResult = {
  __typename?: 'ProductVariantCSVExportJobResult';
  documentId: Scalars['Long']['output'];
};

export type ProductVariantCsvExportResult = ProductVariantCsvExportFileResult | ProductVariantCsvExportJobResult;

export type ProductVariantDetail = {
  __typename?: 'ProductVariantDetail';
  countryOfOrigin?: Maybe<ShopifySupportedCountry>;
  hsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  inUseReasons: Array<ProductVariantInUseReason>;
  listingVariants: Array<ListingVariant>;
  /** exist when the store has [Connected] logi connection. */
  logistics?: Maybe<ProductVariantLogistics>;
  media: Array<Scalars['URL']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameEn?: Maybe<Scalars['String']['output']>;
  price: GraphQlMoney;
  productCode: Scalars['String']['output'];
  productInfo: ProductInformation;
  setProductItems: Array<SetProductItem>;
  status: ProductVariantStatus;
  tags: Array<Scalars['String']['output']>;
  unitCost?: Maybe<GraphQlMoney>;
  weightInGrams?: Maybe<Scalars['BigDecimal']['output']>;
};

export type ProductVariantForAddInboundFilterInput = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  storeId: Scalars['Long']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductVariantForAddInboundRecord = {
  __typename?: 'ProductVariantForAddInboundRecord';
  media?: Maybe<Scalars['URL']['output']>;
  productCode: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  productVariantId: Scalars['Long']['output'];
  variantName: Scalars['String']['output'];
  warehouseCode?: Maybe<Scalars['String']['output']>;
};

export type ProductVariantForAddInboundView = {
  __typename?: 'ProductVariantForAddInboundView';
  end: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  productVariants: Array<ProductVariantForAddInboundRecord>;
  start: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPage: Scalars['Int']['output'];
};

export type ProductVariantForMergeFilterInput = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  saleChannelType?: InputMaybe<MarketplaceSaleChannelType>;
  storeId: Scalars['Long']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: ProductType;
};

export type ProductVariantForMergeRecord = {
  __typename?: 'ProductVariantForMergeRecord';
  inUseReasons: Array<ProductVariantInUseReason>;
  media?: Maybe<Scalars['URL']['output']>;
  productCode: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  saleChannelIds: Array<Scalars['Long']['output']>;
  saleChannels: Array<SaleChannel>;
  variantName: Scalars['String']['output'];
};

export type ProductVariantForMergeView = {
  __typename?: 'ProductVariantForMergeView';
  end: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  productVariants: Array<ProductVariantForMergeRecord>;
  start: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPage: Scalars['Int']['output'];
};

export type ProductVariantForOrderAddProductFilterInput = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  storeId: Scalars['Long']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<ProductType>;
};

export type ProductVariantForOrderAddProductInput = {
  filter: ProductVariantForOrderAddProductFilterInput;
  saleChannelId?: InputMaybe<Scalars['Long']['input']>;
};

export type ProductVariantForOrderAddProductRecord = {
  __typename?: 'ProductVariantForOrderAddProductRecord';
  /** available only when logisticsChannel & exist inventory data */
  freeStock?: Maybe<Scalars['Int']['output']>;
  media?: Maybe<Scalars['URL']['output']>;
  priceV2: Money;
  productCode: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  type: ProductType;
  variantName: Scalars['String']['output'];
};

/** Product variant list view for order add/edit product modal. {start}-{end} / {total}. page {page} of {totalPage} */
export type ProductVariantForOrderAddProductView = {
  __typename?: 'ProductVariantForOrderAddProductView';
  end: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  productVariants: Array<ProductVariantForOrderAddProductRecord>;
  start: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPage: Scalars['Int']['output'];
};

export type ProductVariantForSetFilterInput = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  saleChannelType?: InputMaybe<MarketplaceSaleChannelType>;
  storeId: Scalars['Long']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductVariantForSetView = {
  __typename?: 'ProductVariantForSetView';
  end: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  productVariants: Array<ProductVariantForSetViewRecord>;
  start: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPage: Scalars['Int']['output'];
};

export type ProductVariantForSetViewRecord = {
  __typename?: 'ProductVariantForSetViewRecord';
  media?: Maybe<Scalars['URL']['output']>;
  productCode: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  productVariantId: Scalars['Long']['output'];
  saleChannelIds: Array<Scalars['Long']['output']>;
  saleChannels: Array<SaleChannel>;
  variantName: Scalars['String']['output'];
};

export const ProductVariantInUseReason = {
  ProductVariantHasLogisticsInbound: 'ProductVariantHasLogisticsInbound',
  ProductVariantHasLogisticsInventory: 'ProductVariantHasLogisticsInventory',
  ProductVariantHasLogisticsOrder: 'ProductVariantHasLogisticsOrder',
  ProductVariantIsPartOfASet: 'ProductVariantIsPartOfASet'
} as const;

export type ProductVariantInUseReason = typeof ProductVariantInUseReason[keyof typeof ProductVariantInUseReason];
export type ProductVariantListFilterInput = {
  accountId?: InputMaybe<Scalars['Long']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  saleChannelType?: InputMaybe<MarketplaceSaleChannelType>;
  sortBy?: InputMaybe<ProductVariantListSortInput>;
  status?: InputMaybe<ProductVariantStatus>;
  storeId?: InputMaybe<Scalars['Long']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<ProductType>;
};

export const ProductVariantListSortByField = {
  CREATED_AT: 'CREATED_AT',
  NAME: 'NAME'
} as const;

export type ProductVariantListSortByField = typeof ProductVariantListSortByField[keyof typeof ProductVariantListSortByField];
export type ProductVariantListSortInput = {
  descending: Scalars['Boolean']['input'];
  field: ProductVariantListSortByField;
};

/** Product variant list view. {start}-{end} / {total}. page {page} of {totalPage} */
export type ProductVariantListView = {
  __typename?: 'ProductVariantListView';
  end: Scalars['Int']['output'];
  items: Array<ProductVariantRecord>;
  page: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPage: Scalars['Int']['output'];
};

export type ProductVariantLogistics = {
  __typename?: 'ProductVariantLogistics';
  color?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  defaultCourier?: Maybe<CourierService>;
  height_mm?: Maybe<Scalars['BigDecimal']['output']>;
  inventorySync: Scalars['Boolean']['output'];
  length_mm?: Maybe<Scalars['BigDecimal']['output']>;
  note: Scalars['String']['output'];
  size?: Maybe<Scalars['String']['output']>;
  sizeCoefficient?: Maybe<Scalars['Int']['output']>;
  supplier?: Maybe<AnyXSupplier>;
  warehouseCode: Scalars['String']['output'];
  width_mm?: Maybe<Scalars['BigDecimal']['output']>;
};

export type ProductVariantRecord = {
  __typename?: 'ProductVariantRecord';
  createdAt: Scalars['OffsetDateTime']['output'];
  hasSiblings: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  listingVariantSaleChannelIds: Array<Scalars['Long']['output']>;
  listingVariantSaleChannels: Array<SaleChannel>;
  media?: Maybe<Scalars['URL']['output']>;
  name: Scalars['String']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productId: Scalars['Long']['output'];
  productType: ProductType;
  status: ProductVariantStatus;
  warehouseCode?: Maybe<Scalars['String']['output']>;
};

export type ProductVariantReportData = {
  __typename?: 'ProductVariantReportData';
  accountName?: Maybe<Scalars['String']['output']>;
  advertisingCost: Scalars['BigDecimal']['output'];
  avgSalesValue: Scalars['BigDecimal']['output'];
  cancelAndOrRefund: Scalars['BigDecimal']['output'];
  commissionFees: Scalars['BigDecimal']['output'];
  daysSalesOfInventory?: Maybe<Scalars['BigDecimal']['output']>;
  discountRate: Scalars['BigDecimal']['output'];
  discounts: Scalars['BigDecimal']['output'];
  grossProfit: Scalars['BigDecimal']['output'];
  grossProfitRate: Scalars['BigDecimal']['output'];
  grossSales: Scalars['BigDecimal']['output'];
  marginalProfit: Scalars['BigDecimal']['output'];
  marginalProfitRate: Scalars['BigDecimal']['output'];
  masterDataAccountId?: Maybe<Scalars['Long']['output']>;
  masterDataStoreId?: Maybe<Scalars['Long']['output']>;
  media?: Maybe<Scalars['String']['output']>;
  merchandiseCost: Scalars['BigDecimal']['output'];
  netSales: Scalars['BigDecimal']['output'];
  productCode?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Long']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productVariantId?: Maybe<Scalars['Long']['output']>;
  revenue: Scalars['BigDecimal']['output'];
  revenueAdv: Scalars['BigDecimal']['output'];
  revenueGross: Scalars['BigDecimal']['output'];
  roas: Scalars['BigDecimal']['output'];
  shippingFee: Scalars['BigDecimal']['output'];
  storeName?: Maybe<Scalars['String']['output']>;
  totalSales: Scalars['BigDecimal']['output'];
  unitSold?: Maybe<Scalars['Int']['output']>;
  variantName?: Maybe<Scalars['String']['output']>;
  variantStatus?: Maybe<ProductVariantStatus>;
  warehouseInventory?: Maybe<Scalars['Int']['output']>;
};

export type ProductVariantReportExportFilterInput = {
  adsMetricsType?: InputMaybe<AdsMetricsType>;
  endDate: Scalars['ZonedDatetime']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  marketplaces: Array<SaleChannelType>;
  masterDataAccountId?: InputMaybe<Scalars['Long']['input']>;
  masterDataAccountIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  masterDataStoreIds: Array<Scalars['Long']['input']>;
  orderStatus: ReportOrderStatus;
  productIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  productVariantIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  sortBy?: InputMaybe<VariantReportSortByField>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['ZonedDatetime']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  variants?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductVariantSetItemInput = {
  productVariantId: Scalars['Long']['input'];
  quantity: Scalars['Int']['input'];
};

export type ProductVariantSingle = {
  __typename?: 'ProductVariantSingle';
  countryOfOrigin?: Maybe<ShopifySupportedCountry>;
  hsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  inUseReasons: Array<ProductVariantInUseReason>;
  listingVariants: Array<ListingVariant>;
  /** exist when the store has [Connected] logi connection. */
  logistics?: Maybe<ProductVariantLogistics>;
  media: Array<Scalars['URL']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameEn?: Maybe<Scalars['String']['output']>;
  price: GraphQlMoney;
  productCode: Scalars['String']['output'];
  productId: Scalars['Long']['output'];
  setProductItems: Array<SetProductItem>;
  status: ProductVariantStatus;
  tags: Array<Scalars['String']['output']>;
  unitCost?: Maybe<GraphQlMoney>;
  weightInGrams?: Maybe<Scalars['BigDecimal']['output']>;
};

export const ProductVariantStatus = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED'
} as const;

export type ProductVariantStatus = typeof ProductVariantStatus[keyof typeof ProductVariantStatus];
export type ProductVariantV2 = {
  __typename?: 'ProductVariantV2';
  id: Scalars['Long']['output'];
  media?: Maybe<Scalars['URL']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price: Money;
  product: Product;
  productCode: Scalars['String']['output'];
  productId: Scalars['Long']['output'];
  status: ProductVariantStatus;
  unitCost?: Maybe<Money>;
};

export type ProfileUpdatedActivityV4 = CustomerActivityV4 & {
  __typename?: 'ProfileUpdatedActivityV4';
  fields: Array<CustomerActivityV4UpdatedField>;
  id: Scalars['String']['output'];
  timestamp: Scalars['UnixTimestamp']['output'];
  user: BasicUser;
};

/** Pronunciation dictionary bound to a cloned voice. */
export type PronunciationDictionary = {
  __typename?: 'PronunciationDictionary';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  language: TtsAudioLanguage;
  /** Last time this dictionary or any of its rules changed: the later of the dictionary's own updated_at and the latest rule's updated_at. Resolved lazily; batched per request. */
  lastUpdatedAt: Scalars['DateTime']['output'];
  status: PronunciationStatus;
  /** Total number of pronunciation rules in this dictionary (all statuses). Resolved lazily; batched per request. */
  totalRules: Scalars['Int']['output'];
  /** The TTS generation ID of the latest test TTS for this dictionary, if any. Poll via ttsInfo. */
  ttsId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  voiceCloneId: Scalars['ID']['output'];
  voiceName: Scalars['String']['output'];
};

/** Input for creating a pronunciation dictionary. */
export type PronunciationDictionaryCreateInput = {
  voiceCloneId: Scalars['ID']['input'];
};

/** Filter input for pronunciation dictionaries. */
export type PronunciationDictionaryFilterInput = {
  createdAt?: InputMaybe<DateTimeRangeInput>;
  language?: InputMaybe<TtsAudioLanguage>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PronunciationStatus>;
};

/** Paginated list of pronunciation dictionaries. */
export type PronunciationDictionaryList = {
  __typename?: 'PronunciationDictionaryList';
  items: Array<PronunciationDictionary>;
  totalCount: Scalars['Int']['output'];
};

/** Result of a pronunciation dictionary or rule mutation. */
export type PronunciationDictionaryOutput = {
  __typename?: 'PronunciationDictionaryOutput';
  id: Scalars['ID']['output'];
};

/** Input for updating a pronunciation dictionary. */
export type PronunciationDictionarySaveInput = {
  dictionaryId: Scalars['ID']['input'];
  status: PronunciationStatus;
};

/** System-wide summary counts for the pronunciation dictionary page header. These are global and ignore list filters. */
export type PronunciationDictionarySummary = {
  __typename?: 'PronunciationDictionarySummary';
  /** Rules whose own status is Active AND whose dictionary is Active — the rules applied at TTS time. */
  totalActiveRules: Scalars['Int']['output'];
  /** Voice clones that have no pronunciation dictionary configured (1:1 voice→dictionary). */
  voicesNotConfigured: Scalars['Int']['output'];
};

/** A pronunciation rule within a dictionary. */
export type PronunciationRule = {
  __typename?: 'PronunciationRule';
  createdAt: Scalars['DateTime']['output'];
  dictionaryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  originalText: Scalars['String']['output'];
  replacementText: Scalars['String']['output'];
  status: PronunciationStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** Filter input for pronunciation rules. */
export type PronunciationRuleFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PronunciationStatus>;
};

/** Paginated list of pronunciation rules. */
export type PronunciationRuleList = {
  __typename?: 'PronunciationRuleList';
  items: Array<PronunciationRule>;
  totalCount: Scalars['Int']['output'];
};

/** Input for creating or updating a pronunciation rule. */
export type PronunciationRuleSaveInput = {
  dictionaryId: Scalars['ID']['input'];
  originalText: Scalars['String']['input'];
  replacementText: Scalars['String']['input'];
  ruleId?: InputMaybe<Scalars['ID']['input']>;
  status: PronunciationStatus;
};

export const PronunciationStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
} as const;

export type PronunciationStatus = typeof PronunciationStatus[keyof typeof PronunciationStatus];
/** Input for generating test TTS audio for a pronunciation dictionary. */
export type PronunciationTestTtsGenerateInput = {
  dictionaryId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export const Provider = {
  MANUAL: 'MANUAL',
  QOO10: 'QOO10',
  RAKUTEN: 'RAKUTEN',
  SHOPEE: 'SHOPEE',
  SHOPIFY: 'SHOPIFY'
} as const;

export type Provider = typeof Provider[keyof typeof Provider];
export type PublicUploadFilePayload = {
  __typename?: 'PublicUploadFilePayload';
  fileName: Scalars['String']['output'];
  /** this is public URL. it's same as signedUrl without query parameters. */
  fileUrl: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export const Qoo10Marketplace = {
  CN: 'CN',
  HK: 'HK',
  ID: 'ID',
  JP: 'JP',
  KR: 'KR',
  MY: 'MY',
  SG: 'SG'
} as const;

export type Qoo10Marketplace = typeof Qoo10Marketplace[keyof typeof Qoo10Marketplace];
export type Qoo10SaleChannelCreateInput = {
  marketplace: Qoo10Marketplace;
  password: Scalars['String']['input'];
  sellerApiKey: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
  userId: Scalars['String']['input'];
};

export type Qoo10SaleChannelData = {
  __typename?: 'Qoo10SaleChannelData';
  marketplace: Qoo10Marketplace;
  sellerUserId: Scalars['String']['output'];
};

export type Qoo10SaleChannelReconnectInput = {
  password: Scalars['String']['input'];
  saleChannelId: Scalars['Long']['input'];
};

export type Query = {
  __typename?: 'Query';
  /** Returns a AI Agent session by ID. */
  AIAgentSession?: Maybe<AiAgentSession>;
  /** Generates a signed URL for uploading a file to Google Cloud Storage */
  AIAgentSessionUpload: AiAgentSessionUploadOutput;
  /** Returns paginated AI Agent sessions for the authenticated user, sorted by start time in descending order. */
  AIAgentSessions: AiAgentSessionList;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get All Campaigns.
   * Code|Error
   * ---|---
   */
  AllInfluencerCampaigns?: Maybe<PageResultInfluencerCampaign>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * search sale channel products.
   *
   * Code|Error
   * ---|---
   * 2009| `CRM_ACCOUNT_NOT_FOUND`
   */
  AnyChatSaleChannelProducts?: Maybe<Array<SaleChannelProduct>>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get store.
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   */
  AnyChatStore?: Maybe<AnyChatStore>;
  /** Returns a list of error codes. */
  AnyLiveErrors: Array<AnyLiveErrorCode>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * Preview of MergeAnyTagInfluencers: what AnyTag would move from each duplicate to the kept
   * influencer, and its warnings. Writes nothing.
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   * 404| `INFLUENCER_NOT_FOUND`.
   * 400| `NOT_INFLUENCER_MODE_ACCOUNT`.
   * 400| `INVALID_INFLUENCER_MERGE`.
   * 400| `INFLUENCER_MERGE_LINKED`.
   * 400| `CUSTOMER_ALREADY_LINKED_TO_INFLUENCER`.
   * 400| `INFLUENCER_ALREADY_LINKED_TO_OTHER_CUSTOMER`.
   */
  AnyTagInfluencerMergePreview?: Maybe<AnyTagInfluencerMergeResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * Search every AnyTag influencer, linked to AnyChat or not, by handle or name.
   * Handle matches come first. Influencer-mode accounts only.
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   * 400| `NOT_INFLUENCER_MODE_ACCOUNT`.
   */
  AnyTagInfluencers?: Maybe<AnyTagInfluencersResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get automation flow by id
   */
  AutomationFlow?: Maybe<AutomationFlow>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * list all automation flow
   *
   * Code|Error
   * ---|---
   * 400| `USER_NOT_FOUND`.
   */
  AutomationFlows?: Maybe<PageResultAutomationFlow>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get chat.
   *
   * Code|Error
   * ---|---
   */
  Chat?: Maybe<Chat>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get chat user detail.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  ChatCustomerDetailV2?: Maybe<ChatCustomerDetail>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * Get list of active Shopee vouchers for a store
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND` - Store not found
   * 404| `SHOPEE_CONNECTION_NOT_FOUND` - Shopee connection not found for store
   */
  ChatShopeeVouchers?: Maybe<GetChatShopeeVouchers>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get chat user detail.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  ChatState?: Maybe<ChatState>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get all chats.
   *
   * Code|Error
   * ---|---
   */
  Chats?: Maybe<Chats>;
  CurrentLineRichMenu?: Maybe<LineRichMenu>;
  Customer?: Maybe<Customer>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get Customer activities.
   * if customer is an influencer, pagination is ignored and all data is returned
   * Code|Error
   * ---|---
   * 404| `Customer_NOT_FOUND`.
   */
  CustomerActivitiesV4?: Maybe<PageResultCustomerActivityV4>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * fetch customer chat by keyword
   */
  CustomerChatByKeyword?: Maybe<PageResultCustomerChatKeyWordSearchItem>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * Get customer notes for a customer group.
   * Supports cursor-based pagination, keyword search, and channel filters.
   * Code|Error
   * ---|---
   * 404| `CUSTOMER_NOT_FOUND`.
   */
  CustomerNotesV3?: Maybe<Array<CustomerNote>>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get customer orders.
   */
  CustomerOrdersV2?: Maybe<Array<CustomerOrder>>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get customer tag by id.
   */
  CustomerTag?: Maybe<CustomerTag>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get customer tags default order will be by frequently used.
   */
  CustomerTags?: Maybe<CustomerTags>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get customers.
   */
  CustomersV2?: Maybe<Customers>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * converts serialized content back to messages
   */
  DecodeDraftUnitMessageContent?: Maybe<DraftUnitMessage>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * generates serialized content for unit message
   */
  GenerateDraftUnitMessageContent?: Maybe<Scalars['String']['output']>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * generate redirect url which will open customer a page they can authorize shop access to our app.
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   */
  GenerateShopeeChatAuthorizationLink?: Maybe<GenerateShopeeChatAuthorizationLinkResponse>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * Fetch a single draft reply candidate by chatId and draftId.
   * Used by the frontend to prefill the message input box when following a
   * Slack notification link that contains a ?draftId= query parameter.
   */
  GetDraftReplyCandidate?: Maybe<DraftCandidateGql>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get Influencer Campaigns.
   * Code|Error
   * ---|---
   * 404| `Customer_NOT_FOUND`.
   * 400| `CUSTOMER_IS_NOT_AN_INFLUENCER`
   */
  InfluencerCampaigns?: Maybe<Array<CampaignHistory>>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get Campaigns by ids.
   * Code|Error
   * ---|---
   */
  InfluencerCampaignsByIds?: Maybe<Array<InfluencerCampaign>>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get Influencer Categories.
   * Code|Error
   * ---|---
   */
  InfluencerCategories?: Maybe<Array<InfluencerCategory>>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get Influencer Category by ids.
   * Code|Error
   * ---|---
   */
  InfluencerCategoriesByIds?: Maybe<Array<InfluencerCategory>>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get chat history for Instagram.
   *
   * default limit = 20
   * There will be update in exist chat message so newerCursor
   * will return from till the latest message
   *
   * Fetch Consisting of two part
   *
   * 1. Fetch Scrolling should be fetch using oldest direction and using cursor in response for next fetching
   * 2. Polling latest by using newerCursor
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  InstagramChatEventsV2?: Maybe<InstagramChatEvents>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get chat history for shopee.
   *
   * default limit = 20
   * There won't be any updated of status in existing chat message so
   * fetching will consist of only two parts
   *
   * 1. Fetch Scrolling should be fetch using oldest direction and using cursor in response for next fetching
   * 2. Polling latest by using newerCursor
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  LazadaChatEventsV2?: Maybe<LazadaChatEvents>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get lazada vouchers
   */
  LazadaVouchers?: Maybe<LazadaVouchers>;
  LineBroadcastEstimateRecipients?: Maybe<EstimateRecipient>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get broadcast message by id
   *
   * Code|Error
   * ---|---
   * 404| `BROADCAST_MESSAGE_NOT_FOUND`.
   */
  LineBroadcastMessage?: Maybe<LineBroadcastMessage>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get list of the broadcast message
   */
  LineBroadcastMessages?: Maybe<LineBroadcastMessages>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get broadcast message summaries
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   */
  LineBroadcastStatisticSummaries?: Maybe<LineBroadcastStatisticSummaries>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get chat history for line.
   *
   * olderThan/newerThan will be event id.
   * if both are null, system will return latest events.
   * if olderThan has value, system will return events which older than the message.
   * if newerThan has value, system will return events which newer than the message.
   * if both are exist, system will ignore newerThan value.
   *
   * system will return around 20 events, but it may change.
   *
   * TextMessageEvent.username will be null if sender is bot.
   * TextMessageEvent.username will be user's name if sender is chat user.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  LineChatEvents?: Maybe<LineChatEvents>;
  LineRichMenu?: Maybe<LineRichMenu>;
  LineRichMenus?: Maybe<PageResultLineRichMenuListItem>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * list scheduled messages for a conversation.
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  LineScheduledMessages?: Maybe<Array<LineScheduledMessage>>;
  /** Get an account */
  MdAccount: MdAccount;
  /** Get a list of accounts */
  MdAccounts: MdAccounts;
  /** Get a list of countries */
  MdCountries: Array<MdCountry>;
  /** Get a list of countries used by accounts */
  MdCountriesUsedByAccounts: Array<MdCountry>;
  /** Get a country */
  MdCountry: MdCountry;
  MdCountryEnum: Array<MdCountryEnum>;
  /** Get a list of provinces */
  MdProvinces: Array<MdProvince>;
  MdSelf: MdUser;
  /** Get a store */
  MdStore: MdStore;
  /** Get a list of stores */
  MdStores: MdStores;
  /** Get a timezone */
  MdTimezone: MdTimezone;
  /** Get a list of timezones */
  MdTimezones: Array<MdTimezone>;
  /** Get a user */
  MdUser: MdUser;
  /** Get a user by Slack user id */
  MdUserBySlackId: MdUser;
  /** Get a list of users */
  MdUsers: MdUsers;
  /**
   *  [ADMIN, STAFF, MERCHANT]
   *
   * Return all available MessageVariable
   */
  MessageVariables: Array<MessageVariable>;
  MessengerBroadcastEstimateRecipients?: Maybe<EstimateRecipient>;
  MessengerBroadcastMessage?: Maybe<MessengerBroadcastMessage>;
  MessengerBroadcastMessages?: Maybe<MessengerBroadcastMessages>;
  MessengerBroadcastStatisticSummaries?: Maybe<MessengerBroadcastStatisticSummaries>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get chat history for Messenger.
   *
   * default limit = 20
   * There will be update in exist chat message so newerCursor
   * will return from till the latest message
   *
   * Fetch Consisting of two part
   *
   * 1. Fetch Scrolling should be fetch using oldest direction and using cursor in response for next fetching
   * 2. Polling latest by using newerCursor
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  MessengerChatEventsV2?: Maybe<MessengerChatEvents>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get message quota info.
   */
  QuotaInfos?: Maybe<QuotaInfos>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * Search message content across conversations in the current store.
   * Results are sorted by newest matched message descending.
   */
  SearchMessageContent?: Maybe<PageResultMessageSearchResultItem>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get chat history for shopee.
   *
   * default limit = 20
   * There won't be any updated of status in existing chat message so
   * fetching will consist of only two parts
   *
   * 1. Fetch Scrolling should be fetch using oldest direction and using cursor in response for next fetching
   * 2. Polling latest by using newerCursor
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  ShopeeChatEventsV2?: Maybe<ShopeeChatEvents>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get template plain message categories of the storeChat.
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   */
  StoreChatTemplatePlainMessageCategories?: Maybe<TemplatePlainMessageCategories>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get template plain messages of the storeChat.
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   */
  StoreChatTemplatePlainMessages?: Maybe<TemplatePlainMessages>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get greeting message by storeId
   */
  StoreGreetingMessage?: Maybe<GreetingMessage>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get the draft greeting message by storeId, if one is being prepared
   */
  StoreGreetingMessageDraft?: Maybe<GreetingMessage>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get optin message of the store.
   *
   * after enable message will send when system received any message from customer and
   *  the customer still haven't got requested for opt-in we will send opt-in message.
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   */
  StoreMessengerOptInMessage?: Maybe<MessengerOptInMessage>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get unit message by id
   */
  UnitMessage?: Maybe<UnitMessage>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get unit message by id
   */
  UnitMessages?: Maybe<Array<UnitMessage>>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * estimate recipient count
   * Code|SubCode|Error
   *
   * ---|---|---
   * 400|3005|`MISSING_PARAM_FOR_TYPE`
   */
  WhatsAppBroadcastEstimateRecipients?: Maybe<EstimateRecipient>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get broadcast message by id
   *
   * Code|SubCode|Error
   * ---|---|---
   * 404|2018| `BROADCAST_MESSAGE_NOT_FOUND`.
   */
  WhatsAppBroadcastMessage?: Maybe<WhatsAppBroadcastMessage>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get broadcast message order by created time in decreasing order
   *
   * Code|SubCode|Error
   * ---|---|---
   * 404|2018| `BROADCAST_MESSAGE_NOT_FOUND`.
   */
  WhatsAppBroadcastMessages?: Maybe<WhatsAppBroadcastMessages>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get whatsapp broadcast message statistic summary between input range
   * Code|SubCode|Error
   *
   * ---|---|---
   * 404|2018| `BROADCAST_MESSAGE_NOT_FOUND`.
   */
  WhatsAppBroadcastStatisticSummaries?: Maybe<WhatsAppBroadcastStatisticSummaries>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * get chat history for shopee.
   *
   * default limit = 20
   * There won't be any updated of status in existing chat message so
   * fetching will consist of only two parts
   *
   * 1. Fetch Scrolling should be fetch using oldest direction and using cursor in response for next fetching
   * 2. Polling latest by using newerCursor
   *
   * Code|Error
   * ---|---
   * 404| `CHAT_NOT_FOUND`.
   */
  WhatsAppChatEventsV2?: Maybe<WhatsAppChatEvents>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *
   * Code|Error
   * ---|---
   * 404| `WORKFLOW_NOT_FOUND`.
   */
  Workflow?: Maybe<Workflow>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *
   * Code|Error
   * ---|---
   * 404| `WORKFLOW_NOT_FOUND`.
   */
  WorkflowAuditLogs?: Maybe<WorkflowAuditLogs>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   * fetch Workflows
   *
   * Code|Error
   * ---|---
   * 404| `STORE_NOT_FOUND`.
   */
  Workflows?: Maybe<Workflows>;
  /** Get detailed ad campaign report */
  adCampaignDetailedReport: AdCampaignDetailedReportPayloadList;
  /** Get ads chart */
  adChart: AdChartPayload;
  /** Get detailed ad report */
  adDetailedReport: AdDetailedReportPayloadList;
  /** Get detailed ad group report */
  adGroupDetailedReport: AdGroupDetailedReportPayloadList;
  /** Get ads overview */
  adOverviewReport: AdOverviewReportPayloadList;
  /** Get ads summary */
  adSummary: AdSummaryPayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         List of ads cost by campaign preview data.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   */
  adsCostByCampaignCSVPreview: AdsCostByCampaignCsvPayloadList;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Ads cost range data by product variant distributed daily
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   */
  adsCostRangeByProductDailyCSVPreview: AdsCostRangePerProductDailyCsvPayloadList;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Ads cost range data by product distributed daily
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   */
  adsCostRangeProductLevelDailyCSVPreview: AdsCostRangeProductLevelDailyCsvPayloadList;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         List of ads cost by variant preview data.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   */
  adsCostZozotownCSVPreview: AdsCostZozotownCsvPayloadList;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         List of datasource.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   */
  allDatasources: DatasourcePayloadList;
  amazonSalesChart: AmazonSalesChartPayload;
  amazonSalesDetailedReport: AmazonSalesDetailedReportPayloadList;
  amazonSalesSummary: AmazonSalesSummaryPayload;
  /**
   * Get an Amazon Seller Central Login URL.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `UNAUTHORIZED`
   */
  amazonSellerCentralLoginUrlV2: Scalars['String']['output'];
  /** Returns an integration credential. */
  anyliveIntegrationCredential?: Maybe<AnyliveIntegrationCredential>;
  /** Returns a list of integration credentials. */
  anyliveIntegrationCredentials: AnyliveIntegrationCredentialList;
  anylogiOrder: AnylogiOrder;
  anylogiOrders: AnylogiOrdersPaginated;
  /**
   * Get AWB file downloadable link. only for Sino.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   */
  awbFile: Scalars['String']['output'];
  /** Returns a short-lived signed download URL for the AnyLive browser extension archive of the current environment. The archive lives in a private bucket, so this URL is the only way to fetch it; treat it as single-use and request a new one per download. */
  browserExtensionDownloadUrl: Scalars['String']['output'];
  /** Returns unique campaign types from all livestreams. */
  campaignTypes: Array<Scalars['String']['output']>;
  /** Returns a closing script by id. */
  closingScript?: Maybe<AnyLiveClosingScript>;
  /** Returns a specific revision of a closing script by revision number. */
  closingScriptRevision?: Maybe<AnyLiveClosingScriptRevision>;
  /** Returns all revisions of a closing script, newest-first. */
  closingScriptRevisions: Array<AnyLiveClosingScriptRevision>;
  /** Returns a paginated list of closing scripts. */
  closingScripts: AnyLiveClosingScriptList;
  /** Returns paginated comments within a specific platform session. */
  commentHistoryComments: CommentReplyRecordList;
  /** Returns a paginated list of comment reply sessions (one entry per unique platform session). */
  commentHistorySessions: SessionSummaryList;
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `STORE_NOT_FOUND`, `UNAUTHORIZED`
   */
  courierServiceDetailV2: CourierServiceDetail;
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `UNAUTHORIZED`
   */
  courierServiceList: Array<CourierService>;
  /** Returns a summary of control-panel metrics. */
  cpMetricsSummary: CpMetricsSummaryOutput;
  /** Country codes the caller may view on the regional dashboard. ADMIN gets all operating countries; other STAFF get the countries of their assigned stores. FORBIDDEN for MERCHANT. */
  dashboardAccessibleCountries: Array<Scalars['String']['output']>;
  /** Brand View AI Insights panel (issue #182). Returns the cached insight when the underlying data is unchanged, otherwise generates one. Scoped to the caller's assigned stores. */
  dashboardBrandAiInsight: DashboardBrandAiInsightOutput;
  /** AI-vs-Human comparison aggregate for one brand + date range (item 9), for the All-hosts view: one row per host bucket (AI / Human) with Live Hours, GMV (USD + local), GMV/hour, Avg View Duration, and viewer-weighted Conversion. Spans both hosts (filter.hostType ignored). Available to all roles; scoped to the caller's assigned stores. */
  dashboardBrandAiVsHuman: Array<DashboardAiVsHumanOutput>;
  /** Conversion funnel totals for a single brand (§1.8): Viewers → Product Clicks → Add to Cart → Items Sold. Available to all roles; results are scoped to the caller's assigned stores. */
  dashboardBrandConversionFunnel: DashboardConversionFunnelOutput;
  /** Brand Health Radar (§1.10): 5 dimension scores for a brand vs market average (benchmark = 50). Available to all roles; results are scoped to the caller's assigned stores. */
  dashboardBrandHealthRadar: DashboardBrandHealthRadarOutput;
  /** Hourly GMV & CVR trend for a brand (§1.11): 24 rows (hour 0–23), averaged across the date range, or no rows when no platform in scope reports per-livestream data (see dashboardScopeCapabilities). Available to all roles; results are scoped to the caller's assigned stores. */
  dashboardBrandHourly: Array<DashboardBrandHourlyRowOutput>;
  /** Brand KPI table (F-13): paginated brand metrics with PoP %. Available to all roles; results are scoped to the caller's assigned stores. */
  dashboardBrandKpi: DashboardBrandKpiListOutput;
  /** Best-Selling Top 5 products for one brand + date range (§1.13), ranked by units sold, then GMV, then product name. Scope the brand with filter.storeId. Available to all roles; scoped to the caller's assigned stores. */
  dashboardBrandProducts: Array<DashboardBrandProductOutput>;
  /** Brand Health Radar scores (F-5): 5-dimension scores for every brand in scope, returned all at once. Scores are in range [0, 100]; market average baseline = 50. FORBIDDEN for MERCHANT role. */
  dashboardBrandRadar: Array<DashboardBrandRadarEntryOutput>;
  /** All sessions for one brand + date range (Brand View Diagnosis §1.12 + Sessions List §1.14). Unpaginated — the client paginates, sorts, and computes top/bottom-5 diagnosis. Scope the brand with filter.storeId. Available to all roles; scoped to the caller's assigned stores. */
  dashboardBrandSessions: Array<DashboardBrandSessionOutput>;
  /** Brand View KPI cards (§1.6): 11 single-store metrics, each with PoP %. Available to all roles; scoped to the caller's assigned stores. */
  dashboardBrandSummary: DashboardBrandSummaryOutput;
  /** Brand View Live Efficiency Trend (§1.7): AI + Human GMV and GMV/h by time bucket. hostType in the filter is IGNORED — always returns both AI and Human. Available to all roles; scoped to the caller's assigned stores. */
  dashboardBrandTrend: Array<DashboardTrendRowOutput>;
  /** Conversion funnel aggregate totals (F-9): Viewers → Product Clicks → Add to Cart → Items Sold. FORBIDDEN for MERCHANT role. */
  dashboardConversionFunnel: DashboardConversionFunnelOutput;
  /** GMV Share Donut chart data (F-7). Country=All → grouped by country. Country=specific → top 5 brands + Others. FORBIDDEN for MERCHANT role. */
  dashboardGmvShare: DashboardGmvShareOutput;
  /** Platform Performance Comparison (F-8): TikTok vs Shopee metrics. NOTE: filter.platform is ignored — both platforms are always returned. FORBIDDEN for MERCHANT role. */
  dashboardPlatformComparison: DashboardPlatformComparisonOutput;
  /** Regional View AI Insights panel (issue #182, PRD §3). Returns the cached panel for this exact filter combination, generating it on first view. Restricted to ADMIN and STAFF. */
  dashboardRegionalAiInsight: DashboardRegionalAiInsightOutput;
  /** Regional overview banner metrics (total GMV, active brands, units sold, PoP %). FORBIDDEN for MERCHANT role. */
  dashboardRegionalOverview: DashboardOverviewOutput;
  /** Which kinds of data the stores in scope have at all (anylive#397): sessionData says whether any platform in scope reports per-livestream data. Scope = the stores the caller may see under the filter (country, platform), narrowed to storeId when given. Available to all roles. */
  dashboardScopeCapabilities: DashboardScopeCapabilitiesOutput;
  /** Brand View Script Optimization Insights (§2.3(c)). Returns cached cards when the session's segment data is unchanged, otherwise generates them. Empty cards => no segment data. */
  dashboardScriptInsight: DashboardScriptInsightOutput;
  /** Server-paginated comment list for a single session (Comments tab, §2.7). Uses filter.pageNumber/pageSize. Available to all roles; scoped to assigned stores. */
  dashboardSessionComments: DashboardSessionCommentsOutput;
  /** Full detail for a single live session by ID. Available to all roles; access is scoped to the caller's assigned stores. */
  dashboardSessionDetail?: Maybe<DashboardSessionDetailOutput>;
  /** Paginated list of live sessions. Available to all roles; results are scoped to the caller's assigned stores. */
  dashboardSessionList: DashboardSessionListOutput;
  /** All products for a single session (Product List tab, §2.6). Unpaginated; client sorts/searches/paginates. Available to all roles; scoped to assigned stores. */
  dashboardSessionProducts: Array<DashboardSessionProductOutput>;
  /** Script category performance table for one session (§2.3(a)). One row per phase+category, sorted by USD GMV descending, full list — take the top/bottom slice client-side. Shares its aggregation with dashboardScriptInsight, so the two always agree. */
  dashboardSessionScriptCategories: Array<DashboardScriptCategoryOutput>;
  /** 5-minute segments for a single session (§2.4 chart / §2.5 detail table). */
  dashboardSessionSegments: Array<DashboardSessionSegmentOutput>;
  /** TikTok traffic sources for a single session (Traffic Source tab, §2.8). Empty for Shopee sessions. Available to all roles; scoped to assigned stores. */
  dashboardSessionTraffic: Array<DashboardSessionTrafficOutput>;
  /** List of stores for the Store Nav Row and the Brand Dashboard store picker (AC1-AC4). The list is NOT filtered by date — it is the caller's accessible set under the non-date filters — but each item carries hasDataInRange for the filter's dateRange. Available to all roles; results are scoped to the caller's assigned stores. */
  dashboardStoreList: DashboardStoreListOutput;
  /** Top-3 brand highlight cards (F-2): best GMV, best units, best efficiency. FORBIDDEN for MERCHANT role. */
  dashboardTopBrands: DashboardTopBrandsOutput;
  /** Traffic vs Conversion matrix (§1.9): one bubble per session (X=viewers, Y=cvr, size=gmv) for a brand. Available to all roles; results are scoped to the caller's assigned stores. */
  dashboardTrafficMatrix: DashboardTrafficMatrixOutput;
  /** GMV & Efficiency Trend time series (F-4): grouped bar + dual-line chart data. hostType in filter is IGNORED — always returns both AI and Human data. FORBIDDEN for MERCHANT role. */
  dashboardTrend: Array<DashboardTrendRowOutput>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Get a datasource.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   */
  datasource?: Maybe<DatasourcePayload>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Get a datasource token.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   */
  datasourceToken?: Maybe<DatasourceTokenPayload>;
  /** Get DDI sale channel analytics chart */
  ddiAnalyticsChart: DdiAnalyticsChartPayload;
  /** Get DDI sale channel analytics detailed report */
  ddiAnalyticsDetailedReport: DdiAnalyticsDetailedReportPayloadList;
  /** Export DDI sale channel analytics detailed report */
  ddiAnalyticsReportExport: ReportDocumentResult;
  /** Get DDI sale channel analytics summary */
  ddiAnalyticsSummary: DdiAnalyticsSummaryPayload;
  /** data for the home page chart widget */
  ddiHomeReportChart: DdiHomeReportChartPayload;
  /** data for the home page pie chart widget */
  ddiHomeReportPieChart: DdiHomeReportPieChartPayload;
  /** data for the home page summary widget */
  ddiHomeReportSummary: DdiHomeReportSummaryPayload;
  /** data for the home top products widget */
  ddiHomeReportTopProducts: DdiHomeReportTopProductsPayload;
  ddiInventoryReportPeopleInCharge: DdiPersonInChargePayloadList;
  /** DDI inventory stock value report, daily tab */
  ddiInventoryStockValueDailyReport: DdiInventoryStockValueDailyReportPayloadList;
  /** DDI inventory stock value report, variants tab */
  ddiInventoryStockValueProductReport: DdiInventoryStockValueProductReportPayloadList;
  /** DDI inventory tracker report, the all stores view one */
  ddiInventoryTrackerReport: DdiInventoryTrackerReportPayload;
  ddiInventoryTrackerReportStores: DdiInventoryTrackerReportStores;
  /** Get DDI product analytics detailed report */
  ddiProductAnalyticsDetailedReport: DdiProductAnalyticsDetailedReportPayloadList;
  /** Export DDI product analytics detailed report */
  ddiProductAnalyticsReportExport: ReportDocumentResult;
  /** Get DDI product analytics summary */
  ddiProductAnalyticsSummary: DdiProductAnalyticsSummaryPayload;
  /** get DDI product status per warehouse, along with other relevant information */
  ddiProductStatus: DdiProductStatusPayloadList;
  /**
   * Get export result from productCSVExport/productVariantCSVExport/orderCSVExport.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   */
  document: DocumentPayload;
  /** How many Closing Scripts are eligible for this room's automatic end (Common ∪ this room's store, active, matching the room's language) — the count only, never a script name or id, since one is chosen at compose time, not at configuration time. 0 for a room with no language set (legacy rows). */
  eligibleClosingScriptCountForRoom: Scalars['Int']['output'];
  /** Issue #322: Returns the voice clones eligible for a room's Voice Clone dropdown — completed (status = DONE) voice clones whose language matches the room's fixed-at-creation language. Empty for a room with no language set (legacy rows). */
  eligibleVoiceClonesForRoom: TtsVoiceCloneList;
  /** Export ad campaign report */
  exportAdCampaignReport: ReportDocumentResult;
  /** Export ad group report */
  exportAdGroupReport: ReportDocumentResult;
  /** Export ad overview report */
  exportAdOverviewReport: ReportDocumentResult;
  /** Export ad report */
  exportAdReport: ReportDocumentResult;
  /** export DDI inventory stock value report, daily tab */
  exportDdiInventoryStockValueDailyReport: ReportDocumentResult;
  /** export DDI inventory stock value report, variants tab */
  exportDdiInventoryStockValueProductReport: ReportDocumentResult;
  /** Export keyword report */
  exportKeywordReport: ReportDocumentResult;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         export product report.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  exportProductReport: ReportDocumentResult;
  /** Export sale channel report. */
  exportSaleChannelReport: ReportDocumentResult;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         export variant report.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  exportVariantReport: ReportDocumentResult;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Get Facebook Ads accounts.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`     |Unauthorized request
   *         |`FORBIDDEN`         |This operation is prohibited
   *         |`FACEBOOK_API_ERROR`|Facebook API has error
   */
  facebookAdsAccounts: FacebookAdsAdAccountPayloadList;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Get a Facebook Login URL.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  facebookLoginUrl: Scalars['String']['output'];
  /** Returns a fallback template by id. */
  fallbackTemplate?: Maybe<AnyLiveFallbackTemplate>;
  /** Returns a specific revision of a fallback template by revision number. */
  fallbackTemplateRevision?: Maybe<AnyLiveFallbackTemplateRevision>;
  /** Returns all revisions of a fallback template, newest-first. */
  fallbackTemplateRevisions: Array<AnyLiveFallbackTemplateRevision>;
  /** Returns a paginated list of fallback templates. */
  fallbackTemplates: AnyLiveFallbackTemplateList;
  /**
   * Get file upload histories.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `PAGE_SIZE_LIMIT_ERROR`, `SALE_CHANNEL_NOT_FOUND`, `UNAUTHORIZED`
   */
  fileUploadHistoriesV2: FileUploadHistoriesPayloadV2;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Query for for ad cost campaign mapping info for edit page
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   */
  getAdCostCampaignMapping: AdCostCampaignMappingInfoPayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Get ad cost campaign mappings list
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   */
  getAdCostCampaignMappings: AdCostCampaignMappingListPayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Get ad set mapping campaign detail
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   */
  getAdSetMappingCampaign: AdSetMappingCampaignPayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Get ad set mapping campaign list
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   */
  getAdSetMappingCampaigns: AdSetMappingCampaignsListPayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Query for for ad set mapping group info for edit page
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   */
  getAdSetMappingGroup: AdSetMappingGroupInfoPayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Query for for ad set mapping products
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   */
  getAdSetMappingGroupProducts: AdSetMappingGroupProductsListPayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Get ad set mapping group list
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   */
  getAdSetMappingGroups: AdSetMappingGroupListPayload;
  getAnylogiUser: AnylogiUserDetailed;
  getAnylogiUsers: AnylogiUsersPaginated;
  getCourierAccount: CourierAccountDetails;
  getCourierAccountList: CourierAccountDetailsListResponse;
  getCourierAccountsSupported: Array<CourierAccountSupported>;
  getCourierSettings?: Maybe<CourierSettings>;
  getCourierSettingsList: GetCourierSettingsListResponse;
  getCrossBorderBasicAuth?: Maybe<CrossBorderBasicAuth>;
  getCsvExportJobResult: CsvExportJobResult;
  getCsvUploadTemplate: CsvTemplate;
  getInbound: InboundDetailed;
  getInboundPdf: Document;
  getInboundPdfs: Document;
  getInbounds: InboundsPaginated;
  getInboundsOverview: InboundOverview;
  getLogilessMerchants?: Maybe<Array<LogilessMerchant>>;
  getLogisticChannelRequestForm?: Maybe<Array<LogisticChannelRequestForm>>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Products for ads mapping
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   */
  getProductsForAdsMapping: AdsMappingProductsListPayload;
  getShipperAddress: ShipperAddress;
  getShipperAddresses: ShipperAddressesListResponse;
  getShippingRate: Array<ShippingRateDetails>;
  getShippingRates: GetShippingRateResponse;
  getStoreSetting?: Maybe<AiAutoReplyStoreSetting>;
  getSupplier: SupplierDetailed;
  getSuppliers: SuppliersPaginated;
  /**
   * get valid japan order addresses.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INVALID_REQUEST`, `UNAUTHORIZED`
   */
  getValidJapanAddresses: ValidJapanOrderAddressPayload;
  getWarehouse: WarehouseDetailed;
  getWarehouses: WarehousesPaginated;
  getWarehousesList?: Maybe<Array<Warehouse>>;
  getWmsStores: Array<WmsName>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Get Google Ads client accounts. This query will not return manager accounts
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`     |Unauthorized request
   *         |`FORBIDDEN`         |This operation is prohibited
   *         |`GOOGLE_OAUTH_ERROR`|Google OAuth has error
   *         |`GOOGLE_API_ERROR`  |Google API has error
   */
  googleAdsClientAccounts: GoogleAdsAccountPayloadList;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Get Google Ads Customers.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`     |Unauthorized request
   *         |`FORBIDDEN`         |This operation is prohibited
   *         |`GOOGLE_OAUTH_ERROR`|Google OAuth has error
   *         |`GOOGLE_API_ERROR`  |Google API has error
   */
  googleAdsCustomers: GoogleAdsCustomerPayloadList;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Get Google Analytics 4 Accounts.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`     |Unauthorized request
   *         |`FORBIDDEN`         |This operation is prohibited
   *         |`GOOGLE_OAUTH_ERROR`|Google OAuth has error
   *         |`GOOGLE_API_ERROR`  |Google API has error
   */
  googleAnalytics4Accounts: GoogleAnalytics4AccountSummaries;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Get a Google Login URL.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  googleLoginUrl: Scalars['String']['output'];
  hasAdvertisingConnection: Scalars['Boolean']['output'];
  hasAnalyticsReport: Scalars['Boolean']['output'];
  hasConnectedSaleChannel: Scalars['Boolean']['output'];
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `UNAUTHORIZED`
   */
  hasLogisticsChannel: HasLogisticsChannel;
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `UNAUTHORIZED`
   */
  hasLogisticsChannelBySaleChannelId: HasLogisticsChannel;
  /** Returns a host. */
  host?: Maybe<Host>;
  /** Returns a list of hosts. */
  hosts: HostList;
  /**
   * Upload imports file.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INVALID_FILE_NAME`, `UNAUTHORIZED`
   */
  importsFileUpload: UploadFilePayload;
  inactiveIntegrationCount: Scalars['Int']['output'];
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `UNAUTHORIZED`
   */
  inboundDetail: InboundDetail;
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `UNAUTHORIZED`
   */
  inboundListView: InboundListView;
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `UNAUTHORIZED`
   */
  inboundOverview: AnyXInboundOverview;
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INVALID`, `UNAUTHORIZED`
   */
  inventoryExportCsv: InventoryExportCsvResult;
  inventoryFileUploadHistory: InventoryFileUploadHistoryPayload;
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INVALID`, `UNAUTHORIZED`
   */
  inventoryListView: InventoryListView;
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INVALID`, `UNAUTHORIZED`
   */
  inventoryOverview: InventoryOverviewOutput;
  /** Get keywords chart */
  keywordChart: AdChartPayload;
  /** Get detailed keyword report */
  keywordDetailedReport: KeywordDetailedReportPayloadList;
  /** Get keywords summary */
  keywordSummary: AdSummaryPayload;
  /**
   * Get a Lazada Login URL.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `UNAUTHORIZED`
   */
  lazadaLoginUrlV2: Scalars['String']['output'];
  lazadaSalesChart: LazadaSalesChartPayload;
  lazadaSalesDetailedReport: LazadaSalesDetailedReportPayloadList;
  lazadaSalesSummary: LazadaSalesSummaryPayload;
  /** Returns a live asset. */
  liveAsset?: Maybe<LiveAsset>;
  /** Generates a live asset profile. */
  liveAssetDetailsGenerate: LiveAssetDetails;
  /** Generates a live asset. */
  liveAssetGenerate: GeneratedLiveAsset;
  /** Returns a live asset version. */
  liveAssetVersion?: Maybe<LiveAssetVersion>;
  /** Exports a live asset version to Google Sheets with report ID for async tracking. */
  liveAssetVersionExport: ExportResponse;
  /** Exports FAQ data for a live asset version to Google Sheets with report ID for async tracking. */
  liveAssetVersionFaqExport: ExportResponse;
  /** Returns a list of live asset versions. */
  liveAssetVersions: LiveAssetVersionList;
  /** Exports multiple live asset versions to Google Sheets with report ID for async tracking. */
  liveAssetVersionsExport: ExportResponse;
  /** Returns a list of live assets. */
  liveAssets: LiveAssetList;
  /** Export live assets to Google Sheets with report ID for async tracking. */
  liveAssetsExport: ExportResponse;
  /** Export livestream data to Google Sheets with report ID for async tracking. */
  liveStreamsExportV2: ExportResponse;
  /** Returns a livestream. */
  livestream?: Maybe<LiveStream>;
  /** Returns a livestream avatar. */
  livestreamAvatar?: Maybe<LivestreamAvatarGql>;
  /** Returns a green-screen segmentation preview as inline base64 (never a vendor/OSS URL). */
  livestreamAvatarGreenScreenPreview: LivestreamAvatarGreenScreenPreviewOutput;
  /** Generates a presigned OSS upload URL for a green-screen preview still image. */
  livestreamAvatarGreenScreenPreviewUploadUrl: LivestreamAvatarGreenScreenPreviewUploadOutput;
  /** Generates presigned OSS upload URLs for avatar training videos (one per file). */
  livestreamAvatarTrainingUploadUrls: Array<LivestreamAvatarTrainingUploadUrlOutput>;
  /**
   * Generates a GCS signed URL for uploading a livestream avatar training video.
   * @deprecated Use livestreamAvatarTrainingUploadUrls; avatar training videos now upload to OSS.
   */
  livestreamAvatarVideoUpload: LivestreamAvatarVideoUploadOutput;
  /** Returns all livestream avatars. */
  livestreamAvatars: Array<LivestreamAvatarGql>;
  /** Feature flags of a sales channel's live platform (see LivestreamPlatformFeaturesOutput). Read when entering a live room; a flag is false when the platform cannot support the feature at all. */
  livestreamPlatformFeatures: LivestreamPlatformFeaturesOutput;
  /** Returns a livestream room. */
  livestreamRoom?: Maybe<LivestreamRoomGql>;
  /** Generates a signed URL for downloading the voice reply audio for an atmosphere script. */
  livestreamRoomAtmosphereScriptVoiceSignedUrl?: Maybe<Scalars['Url']['output']>;
  /** Generates a signed URL for uploading an audio file for an atmosphere script's voice reply. */
  livestreamRoomAtmosphereScriptVoiceUpload: LivestreamRoomFaqVoiceUploadOutput;
  /** Get list of BytePlus livestream events for a live room */
  livestreamRoomBytePlusEvents: BytePlusEventListOutput;
  /** Get list of products for the specified BytePlus event. */
  livestreamRoomBytePlusProducts: BytePlusProductListOutput;
  /**
   * Returns the room's decoration group, sorted by ascending orderIndex (first = bottom layer).
   *
   * The group is the set of layers that appear on EVERY scene of the room, locked and in the same position — the room's stage, which each scene's own layers are drawn on top of. One group per room.
   *
   * - AVATAR is a position marker only: no decorationId, no metadata, no signedFileUrl. It records which group elements sit behind the digital human and which in front of it. Each scene still resolves its own avatar and its own pinned look.
   * - CLOSE_UP can never be a member: a close-up belongs to a single paragraph.
   * - An empty list means the room has no room-level decorations, which is every room until one is applied.
   *
   * Projected copies of these elements appear in livestreamRoomDecorations for each product, carrying groupItemId. Those are locked per scene: edit them through livestreamRoomDecorationGroupSave, never livestreamRoomDecorationSave.
   */
  livestreamRoomDecorationGroup: Array<LivestreamRoomDecorationGroupItemGql>;
  /** Generates a signed URL for uploading a decoration preview image (jpg) for a product, plus the object key (previewGcsObjectKey) to pass back on livestreamRoomDecorationSave. */
  livestreamRoomDecorationPreviewUpload: LivestreamRoomDecorationPreviewUploadOutput;
  /** Generates a signed URL for uploading a decoration file for a livestream room. */
  livestreamRoomDecorationUpload: LivestreamRoomDecorationUploadOutput;
  /**
   * Returns all decoration overlay layers for a product's livestream canvas, sorted by ascending orderIndex (first = bottom layer).
   *
   * Each overlay has one of 4 types:
   * - IMAGE: An uploaded image. signedFileUrl comes from the decoration file. Name is the original file name.
   * - VIDEO: An uploaded video. signedFileUrl comes from the decoration file. Name is the original file name.
   * - AVATAR: The digital human assigned to this product. signedFileUrl is a signed GCS URL of the selected look's thumbnail (the product's pinned look, or the main video's as fallback). Name is "Digital Human". Auto-created when livestreamRoomProductSelectAvatar is called.
   * - CLOSE_UP: A close-up video from a product paragraph. signedFileUrl comes from the paragraph's closeup_video_url. Name is the paragraph content. Auto-created when livestreamRoomProductParagraphVideoUrlUpdate is called.
   *
   * The metadata field is a JSON string containing positioning properties only: x, y, width, height.
   */
  livestreamRoomDecorations: Array<LivestreamRoomDecorationGql>;
  /** Returns a livestream room general FAQ. */
  livestreamRoomGeneralFaq?: Maybe<LivestreamRoomGeneralFaqGql>;
  /** Generates a signed URL for uploading an .mp4 file for a general FAQ's custom video comment action. */
  livestreamRoomGeneralFaqCustomVideoUpload: LivestreamRoomFaqCustomVideoUploadOutput;
  /** Generates a signed URL for downloading the voice reply audio for a general FAQ. */
  livestreamRoomGeneralFaqVoiceSignedUrl?: Maybe<Scalars['Url']['output']>;
  /** Generates a signed URL for uploading an audio file for a general FAQ voice reply. */
  livestreamRoomGeneralFaqVoiceUpload: LivestreamRoomFaqVoiceUploadOutput;
  /** Returns a livestream room product. */
  livestreamRoomProduct?: Maybe<LivestreamRoomProductGql>;
  /** Generates a signed URL for uploading a cover image for a livestream room product. */
  livestreamRoomProductCoverUrlUpload: LivestreamRoomProductCoverUrlUploadOutput;
  /** Returns a livestream room product FAQ. */
  livestreamRoomProductFaq?: Maybe<LivestreamRoomProductFaqGql>;
  /** Generates a signed URL for uploading an .mp4 file for a product FAQ's custom video comment action. */
  livestreamRoomProductFaqCustomVideoUpload: LivestreamRoomFaqCustomVideoUploadOutput;
  /** Generates a signed URL for downloading the voice reply audio for a product FAQ. */
  livestreamRoomProductFaqVoiceSignedUrl?: Maybe<Scalars['Url']['output']>;
  /** Generates a signed URL for uploading an audio file for a product FAQ voice reply. */
  livestreamRoomProductFaqVoiceUpload: LivestreamRoomFaqVoiceUploadOutput;
  /** Returns a livestream room product paragraph. */
  livestreamRoomProductParagraph?: Maybe<LivestreamRoomProductParagraphGql>;
  /** Generates a signed URL for downloading an audio file for a livestream room product paragraph. */
  livestreamRoomProductParagraphAudioSignedUrl?: Maybe<Scalars['Url']['output']>;
  /** Generates a signed URL for downloading a closeup video file for a livestream room product paragraph. */
  livestreamRoomProductParagraphVideoSignedUrl?: Maybe<Scalars['Url']['output']>;
  /** Generates a signed URL for uploading a closeup video file for a livestream room product paragraph. Fails with FAILED_PRECONDITION when the product's 2 foreground video slots are already filled by foreground decoration videos (close-ups require at most 1 foreground decoration video; the number of paragraphs with close-ups is not limited) — the same check livestreamRoomProductParagraphVideoUrlUpdate enforces on save. */
  livestreamRoomProductParagraphVideoUpload: LivestreamRoomProductParagraphVideoUploadOutput;
  /** Get products from the selected Rakuten livestream */
  livestreamRoomRakutenProducts: RakutenLivestreamProductListOutput;
  /** Get list of scheduled Rakuten livestreams for a live room */
  livestreamRoomRakutenSchedules: RakutenScheduledLivestreamListOutput;
  /** Fetches shop account info using the stored credentials for a livestream room. */
  livestreamRoomShopInfo: LivestreamRoomShopInfoOutput;
  /** Returns the room's saved Shopee product-set snapshot and whether the room supports product sets. `supported` is true only for SHOPEE rooms whose store holds a Seller Center session credential. Sets are returned even when `supported` is false so the operator can view and remove them. */
  livestreamRoomShopeeProductSets: LivestreamRoomShopeeProductSetsOutput;
  /** Generates a signed URL for downloading the voice reply audio for an unmatched FAQ. */
  livestreamRoomUnmatchedFaqVoiceSignedUrl?: Maybe<Scalars['Url']['output']>;
  /** Returns a list of livestream rooms. */
  livestreamRooms: LivestreamRoomList;
  /** Returns a specific control-panel worker node by ID. */
  livestreamSessionWorkerNode: LivestreamSessionWorkerNodeOutput;
  /** Returns all control-panel worker nodes. */
  livestreamSessionWorkerNodes: Array<LivestreamSessionWorkerNodeOutput>;
  /** Returns recent control-panel livestreams. */
  livestreamSessions: Array<LivestreamSessionOutput>;
  /** Get Shopee comments by live stream ID */
  livestreamShopeeComments: ShopeeCommentList;
  /** Get Shopee products by live stream ID */
  livestreamShopeeProducts: ShopeeProductList;
  /** Get Shopee live stats by live stream ID */
  livestreamShopeeStats: ShopeeLiveStatList;
  /** Get Shopee trends by live stream ID */
  livestreamShopeeTrends: ShopeeTrendList;
  /** Get TikTok comments by live stream ID */
  livestreamTikTokComments: TikTokCommentList;
  /** Get TikTok products by live stream ID */
  livestreamTikTokProducts: TikTokProductList;
  /** Get TikTok live stream statistics by live stream ID or store ID */
  livestreamTikTokStats: TikTokLiveStatList;
  /** Get TikTok total traffic source data by live stream ID or store ID */
  livestreamTikTokTotalTrafficSources: TikTokTotalTrafficSourceList;
  /** Get TikTok traffic source by timestamp gvm data */
  livestreamTikTokTrafficSourceByTimestampGvm: TikTokTrafficSourceByTimestampGmvList;
  /** Get TikTok traffic source by timestamp impression data */
  livestreamTikTokTrafficSourceByTimestampImpressions: TikTokTrafficSourceByTimestampValueList;
  /** Get TikTok traffic source by timestamp view data */
  livestreamTikTokTrafficSourceByTimestampViews: TikTokTrafficSourceByTimestampValueList;
  /** Get TikTok trends by live stream ID */
  livestreamTikTokTrends: TikTokTrendList;
  /** Returns a list of livestreams. */
  livestreams: LiveStreamList;
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `UNAUTHORIZED`
   */
  logisticsChannelDetailsForAdd: LogisticsChannelDetailsForAdd;
  /**
   * ▸ Requires: `ADMIN`, `STAFF`
   * ▸ Throws: `UNAUTHORIZED`
   */
  logisticsChannelDetailsForMerchant: LogisticsChannelDetailsForMerchant;
  /**
   * Get sale channels for manual order creation.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   */
  manualSaleChannelsByStoreId: Array<SaleChannelForManualOrder>;
  /** Get list of marketplace events */
  marketplaceCalendarEvents: MarketplaceCalendarEventPayloadList;
  /** Get summary for the selected time period, about sales and targets */
  marketplaceCalendarSummary: MarketplaceCalendarRevenueSummaryPayload;
  /** momo lives for a MOMO livestream room: the live it is connected to, then the lives it can still connect or switch to — those whose entpCode is the momo vendor code set on the room's store in AnyX (`storeEntpCode`), not cancelled, not finished, not connected to another room. NOT_FOUND when the room does not exist for the caller, FAILED_PRECONDITION when it is not a MOMO room. */
  momoConnection: MomoConnectionList;
  /**
   * Onboarding information.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `UNAUTHORIZED`
   */
  onboarding: Onboarding;
  /**
   * A marketplace order.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   */
  order: OrderDetail;
  /**
   * Export Order CSV.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   */
  orderCSVExportV3: OrderCsvExportV3Output;
  /**
   * Upload CSV for order.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INVALID_FILE_NAME`, `UNAUTHORIZED`
   */
  orderCSVUpload: UploadFilePayload;
  /**
   * List of marketplace Orders.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   */
  orderListView: OrderListView;
  /**
   * store order onboarding status for order list page.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `STORE_NOT_FOUND`, `UNAUTHORIZED`
   */
  orderOnboarding: OrderOnboardingStatus;
  /**
   * Order overview.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   */
  orderOverviewV2: OrderOverview;
  /**
   * AnyX Order payment methods.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `STORE_NOT_FOUND`, `UNAUTHORIZED`
   */
  paymentMethodsV2: PaymentMethodsPayload;
  /**
   * Export ProductVariant CSV by ProductFilter.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   */
  productCSVExport: ProductCsvExportResult;
  /**
   * Upload CSV for product.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INVALID_FILE_NAME`, `UNAUTHORIZED`
   */
  productCSVUpload: UploadFilePayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get product category and original price.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`INVALID_INPUT`|Invalid arguments
   *         |`NOT_FOUND`|Product not found
   * @deprecated Use productDetailsForReviewAnalysis
   */
  productCategoryAndPrice: ProductCategoryAndPricePayload;
  /** Product chart */
  productChart: ProductChartPayload;
  /**
   * A marketplace productDetail.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   */
  productDetail: ProductDetail;
  /** Detailed product report */
  productDetailedReport: ProductDetailedReportPayloadList;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get product category, original price, product url and other details for review analysis.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`INVALID_INPUT`|Invalid arguments
   *         |`NOT_FOUND`|Product not found
   */
  productDetailsForReviewAnalysis: ProductCategoryAndPricePayload;
  /** Returns a product info by URL and language. */
  productInfo: ProductInfoOutput;
  /**
   * List of marketplace products.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `PAGE_SIZE_LIMIT_ERROR`, `UNAUTHORIZED`
   */
  productListView: ProductListView;
  /**
   * Upload media for product.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `INVALID_FILE_NAME`, `UNAUTHORIZED`
   */
  productMediaUpload: PublicUploadFilePayload;
  /**
   * store product onboarding status for product list page.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `STORE_NOT_FOUND`, `UNAUTHORIZED`
   */
  productOnboarding: ProductOnboardingStatus;
  /** Product rating summary */
  productRatingOverview: ProductRatingOverviewPayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get competitor analysis for a product.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`INVALID_INPUT`|Invalid arguments
   */
  productReviewCompetitorAnalysis: ProductReviewCompetitorAnalysisPayload;
  /** Product review sentiment analysis */
  productReviewSentimentAnalysis: ProductReviewSentimentAnalysisPayload;
  /** Product review summarization */
  productReviewSummarization: ProductReviewSummarizationPayload;
  /** Product review topic analysis */
  productReviewTopicAnalysis: ProductReviewTopicAnalysisPayload;
  /** Product review comments */
  productReviews: ProductReviewsPayloadList;
  /** Sale channel types available for the product */
  productSaleChannels: ProductSaleChannelsPayload;
  /** Product sales analytics */
  productSalesAnalytics: ProductSalesAnalyticsPayload;
  /** Product summary */
  productSummary: ProductSummaryPayload;
  /**
   * Get product variant by id.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   */
  productVariant: ProductVariantDetail;
  /**
   * Export ProductVariant CSV by VariantFilter.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   */
  productVariantCSVExport: ProductVariantCsvExportResult;
  /**
   * List of marketplace product variants; Order Add/Edit -> Add Products.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   */
  productVariantForOrderAddProductV2: ProductVariantForOrderAddProductView;
  /**
   * List of marketplace product variants; Products -> Variant View.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `PAGE_SIZE_LIMIT_ERROR`, `UNAUTHORIZED`
   */
  productVariantListView: ProductVariantListView;
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   */
  productVariantsForAddInbound: ProductVariantForAddInboundView;
  /**
   * List of marketplace product variants; Product Merge.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `PAGE_SIZE_LIMIT_ERROR`, `UNAUTHORIZED`
   */
  productVariantsForProductMerge: ProductVariantForMergeView;
  /**
   * List of marketplace product variants; Product Set.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `PAGE_SIZE_LIMIT_ERROR`, `UNAUTHORIZED`
   */
  productVariantsForProductSet: ProductVariantForSetView;
  /** List pronunciation dictionaries with pagination and filtering. */
  pronunciationDictionaries: PronunciationDictionaryList;
  /** Get pronunciation dictionaries by their dictionary IDs. Returns one entry per matched id (missing ids are omitted). */
  pronunciationDictionariesByIds: Array<PronunciationDictionary>;
  /** Get a pronunciation dictionary by voice clone ID. */
  pronunciationDictionary?: Maybe<PronunciationDictionary>;
  /** System-wide summary counts for the pronunciation dictionary page header (total active runtime rules + voices not configured). Global — ignores list filters. */
  pronunciationDictionarySummary: PronunciationDictionarySummary;
  /** List pronunciation rules for a dictionary with pagination and filtering. */
  pronunciationRules: PronunciationRuleList;
  rakutenSalesReportChart: RakutenSalesReportChartPayload;
  rakutenSalesReportSummary: RakutenSalesReportSummaryPayload;
  rakutenSalesReportTable: RakutenSalesReportTablePayloadList;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get product report.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  reportByProduct: ProductReportPayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get product daily report.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  reportByProductDaily: ProductDailyReportPayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get product report.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  reportByProductSummary: ProductReportSummaryPayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get variant report.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  reportByVariant: VariantReportPayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get variant daily report.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  reportByVariantDaily: VariantDailyReportPayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Get a document.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`        |Unauthorized request
   *         |`FORBIDDEN`            |This operation is prohibited
   *         |`REPORT_EXPORT_FAILED` |The report export task failed (e.g. GCS write error)
   */
  reportDocument: ReportDocumentPayload;
  /** Returns a single report export by ID. */
  reportExport?: Maybe<ReportExport>;
  /** Returns a list of report exports for the authenticated user. */
  reportExports: ReportExportList;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get home daily report.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  reportHomeDaily: HomeDailyReportView;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get home pie chart report order by sale channel revenue
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  reportHomeSaleChannelRevenue: HomeSaleChannelRevenueReportView;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get home summary report.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  reportHomeSummary: HomeSummaryReportView;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get home top 5 products report.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  reportHomeTop5Products: HomeTop5ProductsReportView;
  /**
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   */
  saleChannel: SaleChannel;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get sale channel cost index.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  saleChannelCostIndex?: Maybe<SaleChannelCostIndexQueryPayload>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get sale channel cost indexes.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  saleChannelCostIndexes: SaleChannelCostIndexPayloadList;
  /** get sale channel currencies */
  saleChannelCurrency: ReportSupportedCurrency;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get sale channel plan.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  saleChannelPlan: Array<SaleChannelPlan>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get sale channel plan.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  saleChannelPlanV2: Array<SaleChannelPlanPayload>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get data for chart.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  saleChannelReportChart: SaleChannelReportChartPayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get summary for top chart and table in sale channel report.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  saleChannelReportSummary: ReportSummaryPayload;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         get data in table and chart.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  saleChannelReportTable: SaleChannelReportPayload;
  /**
   * List of sale channel sync summaries. Pending syncs will always be shown.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `UNAUTHORIZED`
   */
  saleChannelSyncs: SaleChannelSyncSummaryList;
  /** Returns the last sync timestamp for each sales channel and the most recent overall. */
  scraperSyncStatus: ScraperSyncStatus;
  /**
   * Returns a script.
   * @deprecated Use liveAsset instead, replace with liveAsset
   */
  script?: Maybe<LiveAsset>;
  /**
   * Generates a script profile.
   * @deprecated Use liveAssetDetailsGenerate instead, replace with liveAssetDetailsGenerate
   */
  scriptDetailsGenerate: ScriptDetails;
  /**
   * Generates a script.
   * @deprecated Use liveAssetGenerate instead, replace with liveAssetGenerate
   */
  scriptGenerate: GeneratedScript;
  /**
   * Returns a script version.
   * @deprecated Use liveAssetVersion instead, replace with liveAssetVersion
   */
  scriptVersion?: Maybe<ScriptVersion>;
  /**
   * Exports a script version to Google Sheets with report ID for async tracking.
   * @deprecated Use liveAssetVersionExportV2 instead, replace with liveAssetVersionExportV2
   */
  scriptVersionExportV2: ExportResponse;
  /**
   * Returns a list of script versions.
   * @deprecated Use liveAssetVersions instead, replace with liveAssetVersions
   */
  scriptVersions: ScriptVersionList;
  /**
   * Exports multiple script versions to Google Sheets with report ID for async tracking.
   * @deprecated Use liveAssetVersionsExportV2 instead, replace with liveAssetVersionsExportV2
   */
  scriptVersionsExportV2: ExportResponse;
  /**
   * Returns a list of scripts.
   * @deprecated Use liveAssets instead, replace with liveAssets
   */
  scripts: ScriptList;
  /**
   * Export scripts to Google Sheets with report ID for async tracking.
   * @deprecated Use liveAssetsExportV2 instead, replace with liveAssetsExportV2
   */
  scriptsExportV2: ExportResponse;
  /** Returns a sensitive word by id. */
  sensitiveWord?: Maybe<AnyLiveSensitiveWord>;
  /** Returns a specific revision of a sensitive word by revision number. */
  sensitiveWordRevision?: Maybe<AnyLiveSensitiveWordRevision>;
  /** Returns all revisions of a sensitive word, newest-first. */
  sensitiveWordRevisions: Array<AnyLiveSensitiveWordRevision>;
  /** Returns a paginated list of sensitive words. */
  sensitiveWords: AnyLiveSensitiveWordList;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         List of sessions preview data.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   *         |`FORBIDDEN`    |This operation is prohibited
   */
  sessionsCSVPreview: SessionsCsvPayloadList;
  settingGuide: SettingGuide;
  /**
   * Get a Shopee Affiliate (AMS) authorization URL..
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `UNAUTHORIZED`
   */
  shopeeAffiliateLoginUrl: Scalars['String']['output'];
  /** Export Shopee data for all stat to Google Sheets with 3 tabs (Trends, Products, Comments) and report ID for async tracking. */
  shopeeAllStatExportV2: ExportResponse;
  /** Export Shopee comment data to Google Sheets with report ID for async tracking. */
  shopeeCommentsExportV2: ExportResponse;
  /** Returns the Shopee connection details for a store, or null if not connected. */
  shopeeConnection?: Maybe<ShopeeConnectionGql>;
  /** Export Shopee live stat data to Google Sheets with report ID for async tracking. */
  shopeeLiveStatExportV2: ExportResponse;
  /** Generates a signed URL for uploading a Shopee live stream cover image to GCS. Upload the image via HTTP PUT to signedUrl, then use the returned gcsUri as coverImageUrl when creating the session. */
  shopeeLiveStreamCoverImageUpload: ShopeeLiveStreamCoverImageUploadOutput;
  /**
   * Get a Shopee Login URL..
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `UNAUTHORIZED`
   */
  shopeeLoginUrlV2: Scalars['String']['output'];
  /** Returns a page of product-set candidates from the store's Seller Center session, for use in the product-set picker panel. Requires the room to be in Shopee session mode; raises FAILED_PRECONDITION (SHOPEE_PRODUCT_SETS_UNSUPPORTED) otherwise. */
  shopeeProductSetCandidates: ShopeeProductSetCandidatesOutput;
  /** Returns the items inside one product set, read live from the store's Seller Center session. Requires the room to be in Shopee session mode; raises FAILED_PRECONDITION (SHOPEE_PRODUCT_SETS_UNSUPPORTED) otherwise. */
  shopeeProductSetItems: ShopeeProductSetItemsOutput;
  /** Export Shopee product data to Google Sheets with report ID for async tracking. */
  shopeeProductsExportV2: ExportResponse;
  shopeeSalesChart: ShopeeSalesChartPayload;
  shopeeSalesDetailedReport: ShopeeSalesDetailedReportPayloadList;
  shopeeSalesSummary: ShopeeSalesSummaryPayload;
  /** Export Shopee trend data to Google Sheets with report ID for async tracking. */
  shopeeTrendsExportV2: ExportResponse;
  /**
   * Get a Shopify permission prompt URL.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `UNAUTHORIZED`
   */
  shopifyLoginUrlV2: Scalars['String']['output'];
  shopifySalesReportChart: ShopifySalesReportChartPayload;
  shopifySalesReportSummary: ShopifySalesReportSummaryPayload;
  shopifySalesReportTable: ShopifySalesReportTablePayloadList;
  /** Pages manageable by the store's connected Facebook user — for completing a PAGE connection that is awaiting page selection. */
  storeConnectionFacebookPages: Array<FacebookPageOutput>;
  /** Decides which UI branch the operator sees for Shopee cookie-connect: reuse an existing healthy credential, prefill a known login whose OTP was unreachable, start a fresh manual login, collect a credential first, or wait for an in-flight attempt. */
  storeConnectionShopeeSessionRoute: ShopeeSessionConnectRouteOutput;
  /** Live-validates one store's platform credential with a read-only platform API call. INVALID marks the connection ACTION_REQUIRED until it is re-connected; INCONCLUSIVE (platform unreachable) records nothing. */
  storeConnectionValidate: StoreConnectionValidateOutput;
  /** Returns stores that have at least one platform credential, with their status on every platform. Non-admin callers only see their own stores. */
  storeConnections: StoreConnectionList;
  /** List the catalogues a store's synced products belong to. Empty for channels without catalogues. */
  storeProductCatalogs: Array<StoreProductCatalog>;
  /** List or search products from a connected sales channel catalog. */
  storeProducts: StoreProductList;
  /**
   * Get list of stores with channel filter. pageNumber starts from 1.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `PAGE_SIZE_LIMIT_ERROR`, `UNAUTHORIZED`
   */
  storesWithChannel: StoreList;
  /**
   * Product tags V2.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `NOT_FOUND`, `UNAUTHORIZED`
   */
  tagsV2: Array<Scalars['String']['output']>;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Get TikTok Ads accounts.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`     |Unauthorized request
   *         |`FORBIDDEN`         |This operation is prohibited
   *         |`TIKTOK_API_ERROR`  |TikTok API has error
   */
  tikTokAdsAdAccounts: TikTokAdsAdAccountPayloadList;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Get a TikTok Ads Login URL.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  tikTokAdsLoginUrl: Scalars['String']['output'];
  /** Export TikTok data for all stat to Google Sheets with 4 tabs (Trends, Products, Traffic Source, Comments) and report ID for async tracking. */
  tikTokAllStatExportV2: ExportResponse;
  /** Export TikTok comment data to Google Sheets with report ID for async tracking. */
  tikTokCommentsExportV2: ExportResponse;
  /** Export TikTok live stat data to Google Sheets with report ID for async tracking. */
  tikTokLiveStatsExportV2: ExportResponse;
  /**
   * Get TikTok Shop Login URL.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `UNAUTHORIZED`
   */
  tikTokLoginUrlV2: Scalars['String']['output'];
  /** Export TikTok product data to Google Sheets with report ID for async tracking. */
  tikTokProductsExportV2: ExportResponse;
  tikTokSalesReportChart: TikTokSalesReportChartPayload;
  tikTokSalesReportDetailedReport: TikTokSalesReportDetailedReportPayloadList;
  tikTokSalesReportSummary: TikTokSalesReportSummaryPayload;
  /** Export TikTok total traffic source data to Google Sheets with report ID for async tracking. */
  tikTokTotalTrafficSourceExportV2: ExportResponse;
  /** Export TikTok trend data to Google Sheets with report ID for async tracking. */
  tikTokTrendsExportV2: ExportResponse;
  tokopediaSalesChart: TokopediaSalesChartPayload;
  tokopediaSalesDetailedReport: TokopediaSalesDetailedReportPayloadList;
  tokopediaSalesSummary: TokopediaSalesSummaryPayload;
  /** Generates a signed URL for downloading the voice reply audio for a transition script. */
  transitionScriptVoiceSignedUrl?: Maybe<Scalars['Url']['output']>;
  /** Generates a signed URL for uploading an audio file for a transition script's voice reply. */
  transitionScriptVoiceUpload: LivestreamRoomFaqVoiceUploadOutput;
  /** Returns the durable gs:// URL of a TTS generation's audio, for attaching to a FAQ voice reply. */
  ttsAudioGcsUrl?: Maybe<Scalars['String']['output']>;
  /** Returns TTS information including status and signed URL for the specified TTS ID. */
  ttsInfo?: Maybe<TtsInfoOutput>;
  /** Returns TTS information for multiple TTS IDs. */
  ttsInfos: Array<TtsInfoOutput>;
  /** Returns TTS language configurations. */
  ttsLanguageConfigs: Array<TtsLanguageConfig>;
  /** Generates a signed URL on-demand for TTS audio file */
  ttsSignedUrl?: Maybe<Scalars['Url']['output']>;
  /** Returns a single TTS voice clone by ID for the authenticated user. */
  ttsVoiceClone?: Maybe<TtsVoiceClone>;
  /** Returns a paginated list of TTS voice clones for the authenticated user. */
  ttsVoiceClones: TtsVoiceCloneList;
  /** Generates a signed URL for uploading a TTS voice file to Google Cloud Storage */
  ttsVoiceUpload: TtsVoiceUploadOutput;
  /**
   * [ADMIN, STAFF, MERCHANT]
   *         Get list of variant names to use in report filters.
   *
   *         |Error|Description
   *         |-----|-----------
   *         |`UN_AUTHORIZED`|Unauthorized request
   */
  variantValues: VariantValuesPayloadList;
  /** Generates a signed URL on-demand for voice clone preview audio */
  voiceCloneSignedUrl?: Maybe<Scalars['Url']['output']>;
  /** Get Yahoo available ad accounts */
  yahooAdsAccounts: YahooAdsAccountsPayload;
  /** Get Yahoo Ads login URL */
  yahooAdsLoginUrl: YahooAdsLoginUrlPayload;
  /**
   * Get a Yahoo Login URL.
   * ▸ Requires: `ADMIN`, `STAFF`, `MERCHANT`
   * ▸ Throws: `UNAUTHORIZED`
   */
  yahooLoginUrl: Scalars['String']['output'];
  yahooSalesReportChart: YahooSalesReportChartPayload;
  yahooSalesReportSummary: YahooSalesReportSummaryPayload;
  yahooSalesReportTable: YahooSalesReportTablePayloadList;
};


export type QueryAiAgentSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAiAgentSessionUploadArgs = {
  input: AiAgentSessionUploadInput;
};


export type QueryAiAgentSessionsArgs = {
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryAllInfluencerCampaignsArgs = {
  input: GetInfluencerCampaignsRequest;
};


export type QueryAnyChatSaleChannelProductsArgs = {
  input: GetAnyChatSaleChannelProductsRequest;
};


export type QueryAnyChatStoreArgs = {
  input: AnyChatGetStoreRequest;
};


export type QueryAnyTagInfluencerMergePreviewArgs = {
  input: MergeAnyTagInfluencersRequest;
};


export type QueryAnyTagInfluencersArgs = {
  input: AnyTagInfluencersRequest;
};


export type QueryAutomationFlowArgs = {
  input: GetAutomationFlowRequest;
};


export type QueryAutomationFlowsArgs = {
  input: GetAutomationFlowsRequest;
};


export type QueryChatArgs = {
  input: GetChatRequest;
};


export type QueryChatCustomerDetailV2Args = {
  input: GetChatCustomerDetailRequest;
};


export type QueryChatShopeeVouchersArgs = {
  input: ShopeeGetVouchersRequestInput;
};


export type QueryChatStateArgs = {
  input: GetChatStateRequest;
};


export type QueryChatsArgs = {
  input: GetChatsRequest;
};


export type QueryCurrentLineRichMenuArgs = {
  input: CurrentLineRichMenuInput;
};


export type QueryCustomerArgs = {
  input: CustomerIdInput;
};


export type QueryCustomerActivitiesV4Args = {
  input: GetCustomerActivitiesRequestV4;
};


export type QueryCustomerChatByKeywordArgs = {
  input: FetchCustomerChatByKeywordRequestInput;
};


export type QueryCustomerNotesV3Args = {
  input: CustomerNotesV3Request;
};


export type QueryCustomerOrdersV2Args = {
  input: GetCustomerOrderV2Request;
};


export type QueryCustomerTagArgs = {
  input: GetCustomerTagRequest;
};


export type QueryCustomerTagsArgs = {
  input: GetCustomerTagsRequest;
};


export type QueryCustomersV2Args = {
  input: GetCustomersV2Request;
};


export type QueryDecodeDraftUnitMessageContentArgs = {
  input: DecodeDraftUnitMessageContentRequest;
};


export type QueryGenerateDraftUnitMessageContentArgs = {
  input: GenerateDraftUnitMessageContentRequest;
};


export type QueryGenerateShopeeChatAuthorizationLinkArgs = {
  input: GenerateShopeeChatAuthorizationLinkRequest;
};


export type QueryGetDraftReplyCandidateArgs = {
  input: GetDraftReplyCandidateRequest;
};


export type QueryInfluencerCampaignsArgs = {
  input: CustomerIdInput;
};


export type QueryInfluencerCampaignsByIdsArgs = {
  input: GetInfluencerCampaignByIdsRequest;
};


export type QueryInfluencerCategoriesByIdsArgs = {
  input: GetInfluencerCategoriesByIdsRequest;
};


export type QueryInstagramChatEventsV2Args = {
  input: GetInstagramChatEventsRequestV2;
};


export type QueryLazadaChatEventsV2Args = {
  input: GetLazadaChatMessagesRequestV2Input;
};


export type QueryLazadaVouchersArgs = {
  input: GetLazadaVouchersRequest;
};


export type QueryLineBroadcastEstimateRecipientsArgs = {
  input: GetEstimateRecipientRequestInput;
};


export type QueryLineBroadcastMessageArgs = {
  input: GetSingleLineBroadcastMessageRequestInput;
};


export type QueryLineBroadcastMessagesArgs = {
  input: GetLineBroadcastMessagesRequestInput;
};


export type QueryLineBroadcastStatisticSummariesArgs = {
  input: GetLineBroadcastMessageStatSummaryRequestInput;
};


export type QueryLineChatEventsArgs = {
  input: GetLineChatEventsRequest;
};


export type QueryLineRichMenuArgs = {
  input: Scalars['String']['input'];
};


export type QueryLineRichMenusArgs = {
  input: LineRichMenusInput;
};


export type QueryLineScheduledMessagesArgs = {
  input: GetLineScheduledMessageInput;
};


export type QueryMdAccountArgs = {
  id: Scalars['Long']['input'];
};


export type QueryMdAccountsArgs = {
  filter?: InputMaybe<MdAccountFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortBy?: InputMaybe<MdAccountSortByInput>;
};


export type QueryMdCountriesUsedByAccountsArgs = {
  filter?: InputMaybe<MdAccountFilterInput>;
};


export type QueryMdCountryArgs = {
  id: Scalars['String']['input'];
};


export type QueryMdProvincesArgs = {
  filter?: InputMaybe<MdProvinceFilterInput>;
};


export type QueryMdStoreArgs = {
  id: Scalars['Long']['input'];
};


export type QueryMdStoresArgs = {
  filter?: InputMaybe<MdStoreFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortBy?: InputMaybe<MdStoreSortByInput>;
};


export type QueryMdTimezoneArgs = {
  id: Scalars['String']['input'];
};


export type QueryMdUserArgs = {
  id: Scalars['Long']['input'];
};


export type QueryMdUserBySlackIdArgs = {
  slackUserId: Scalars['String']['input'];
};


export type QueryMdUsersArgs = {
  filter?: InputMaybe<MdUserFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortBy?: InputMaybe<MdUserSortByInput>;
};


export type QueryMessengerBroadcastEstimateRecipientsArgs = {
  input: GetMessengerEstimateRecipientRequestInput;
};


export type QueryMessengerBroadcastMessageArgs = {
  input: GetSingleMessengerBroadcastMessageRequestInput;
};


export type QueryMessengerBroadcastMessagesArgs = {
  input: GetMessengerBroadcastMessagesRequestInput;
};


export type QueryMessengerBroadcastStatisticSummariesArgs = {
  input: GetMessengerBroadcastMessageStatSummaryRequestInput;
};


export type QueryMessengerChatEventsV2Args = {
  input: GetMessengerChatEventsRequestV2;
};


export type QueryQuotaInfosArgs = {
  input: GetMessageQuotaInfoRequestInput;
};


export type QuerySearchMessageContentArgs = {
  input: SearchMessageContentRequest;
};


export type QueryShopeeChatEventsV2Args = {
  input: GetShopeeChatMessagesRequestV2;
};


export type QueryStoreChatTemplatePlainMessageCategoriesArgs = {
  input: StoreChatTemplatePlainMessageCategoriesRequest;
};


export type QueryStoreChatTemplatePlainMessagesArgs = {
  input: StoreChatTemplatePlainMessagesRequest;
};


export type QueryStoreGreetingMessageArgs = {
  input: GetStoreGreetingMessageRequest;
};


export type QueryStoreGreetingMessageDraftArgs = {
  input: GetStoreGreetingMessageRequest;
};


export type QueryStoreMessengerOptInMessageArgs = {
  input: GetStoreMessengerOptInMessageRequestInput;
};


export type QueryUnitMessageArgs = {
  input: FetchUnitMessageRequest;
};


export type QueryUnitMessagesArgs = {
  input: FetchUnitMessagesRequest;
};


export type QueryWhatsAppBroadcastEstimateRecipientsArgs = {
  input: GetWhatsAppEstimateRecipientRequest;
};


export type QueryWhatsAppBroadcastMessageArgs = {
  input: GetSingleWhatsAppBroadcastMessageRequest;
};


export type QueryWhatsAppBroadcastMessagesArgs = {
  input: GetWhatsAppBroadcastMessagesRequest;
};


export type QueryWhatsAppBroadcastStatisticSummariesArgs = {
  input: GetWhatsAppBroadcastMessageStatSummaryRequest;
};


export type QueryWhatsAppChatEventsV2Args = {
  input: GetWhatsAppChatMessagesRequestV2Input;
};


export type QueryWorkflowArgs = {
  id: Scalars['String']['input'];
};


export type QueryWorkflowAuditLogsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  workflowId: Scalars['String']['input'];
};


export type QueryWorkflowsArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  storeId: Scalars['Long']['input'];
};


export type QueryAdCampaignDetailedReportArgs = {
  input: AdCampaignDetailedReportInput;
};


export type QueryAdChartArgs = {
  input: AdChartInput;
};


export type QueryAdDetailedReportArgs = {
  input: AdDetailedReportInput;
};


export type QueryAdGroupDetailedReportArgs = {
  input: AdGroupDetailedReportInput;
};


export type QueryAdOverviewReportArgs = {
  input: AdOverviewReportInput;
};


export type QueryAdSummaryArgs = {
  input: AdSummaryInput;
};


export type QueryAdsCostByCampaignCsvPreviewArgs = {
  ascending: Scalars['Boolean']['input'];
  filter: AdsCostCsvFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryAdsCostRangeByProductDailyCsvPreviewArgs = {
  ascending: Scalars['Boolean']['input'];
  filter: AdsCostRangePerProductDailyCsvFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryAdsCostRangeProductLevelDailyCsvPreviewArgs = {
  ascending: Scalars['Boolean']['input'];
  filter: AdsCostRangeProductLevelDailyCsvFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryAdsCostZozotownCsvPreviewArgs = {
  ascending: Scalars['Boolean']['input'];
  filter: AdsCostCsvFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryAllDatasourcesArgs = {
  filter?: InputMaybe<DatasourceFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortBy?: InputMaybe<DatasourceSortByInput>;
};


export type QueryAmazonSalesChartArgs = {
  input: AmazonSalesChartInput;
};


export type QueryAmazonSalesDetailedReportArgs = {
  input: AmazonSalesDetailedReportInput;
};


export type QueryAmazonSalesSummaryArgs = {
  input: AmazonSalesSummaryInput;
};


export type QueryAmazonSellerCentralLoginUrlV2Args = {
  input: AmazonSellerCentralLoginUrlV2Input;
};


export type QueryAnyliveIntegrationCredentialArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAnyliveIntegrationCredentialsArgs = {
  filter: AnyliveIntegrationCredentialFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: AnyliveIntegrationCredentialSortInput;
};


export type QueryAnylogiOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAnylogiOrdersArgs = {
  filters: OrderFilters;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAwbFileArgs = {
  orderId: Scalars['Long']['input'];
};


export type QueryClosingScriptArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClosingScriptRevisionArgs = {
  revisionNumber: Scalars['Int']['input'];
  templateId: Scalars['ID']['input'];
};


export type QueryClosingScriptRevisionsArgs = {
  templateId: Scalars['ID']['input'];
};


export type QueryClosingScriptsArgs = {
  filter?: InputMaybe<AnyLiveClosingScriptFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryCommentHistoryCommentsArgs = {
  filter: CommentListFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  platformSessionId: Scalars['String']['input'];
};


export type QueryCommentHistorySessionsArgs = {
  filter: SessionListFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryCourierServiceDetailV2Args = {
  courierService: CourierService;
  storeId: Scalars['Long']['input'];
};


export type QueryCourierServiceListArgs = {
  paymentMethodV2?: InputMaybe<PaymentMethodV2>;
  storeId: Scalars['Long']['input'];
};


export type QueryDashboardBrandAiInsightArgs = {
  filter: DashboardBrandFilterInput;
};


export type QueryDashboardBrandAiVsHumanArgs = {
  filter: DashboardBrandFilterInput;
};


export type QueryDashboardBrandConversionFunnelArgs = {
  filter: DashboardBrandFilterInput;
};


export type QueryDashboardBrandHealthRadarArgs = {
  filter: DashboardBrandFilterInput;
};


export type QueryDashboardBrandHourlyArgs = {
  filter: DashboardBrandFilterInput;
};


export type QueryDashboardBrandKpiArgs = {
  filter: DashboardBrandFilterInput;
};


export type QueryDashboardBrandProductsArgs = {
  filter: DashboardBrandFilterInput;
};


export type QueryDashboardBrandRadarArgs = {
  filter: DashboardFilterInput;
};


export type QueryDashboardBrandSessionsArgs = {
  filter: DashboardBrandFilterInput;
};


export type QueryDashboardBrandSummaryArgs = {
  filter: DashboardBrandFilterInput;
};


export type QueryDashboardBrandTrendArgs = {
  filter: DashboardBrandFilterInput;
  granularity: DashboardGranularityInput;
};


export type QueryDashboardConversionFunnelArgs = {
  filter: DashboardFilterInput;
};


export type QueryDashboardGmvShareArgs = {
  filter: DashboardFilterInput;
};


export type QueryDashboardPlatformComparisonArgs = {
  filter: DashboardFilterInput;
};


export type QueryDashboardRegionalAiInsightArgs = {
  filter: DashboardFilterInput;
};


export type QueryDashboardRegionalOverviewArgs = {
  filter: DashboardFilterInput;
};


export type QueryDashboardScopeCapabilitiesArgs = {
  filter: DashboardFilterInput;
  storeId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDashboardScriptInsightArgs = {
  filter: DashboardStoreFilterInput;
  sessionId: Scalars['String']['input'];
};


export type QueryDashboardSessionCommentsArgs = {
  filter: DashboardStoreFilterInput;
  sessionId: Scalars['String']['input'];
};


export type QueryDashboardSessionDetailArgs = {
  filter: DashboardStoreFilterInput;
  sessionId: Scalars['String']['input'];
};


export type QueryDashboardSessionListArgs = {
  filter: DashboardSessionFilterInput;
};


export type QueryDashboardSessionProductsArgs = {
  filter: DashboardStoreFilterInput;
  sessionId: Scalars['String']['input'];
};


export type QueryDashboardSessionScriptCategoriesArgs = {
  filter: DashboardStoreFilterInput;
  sessionId: Scalars['String']['input'];
};


export type QueryDashboardSessionSegmentsArgs = {
  filter: DashboardStoreFilterInput;
  sessionId: Scalars['String']['input'];
};


export type QueryDashboardSessionTrafficArgs = {
  filter: DashboardStoreFilterInput;
  sessionId: Scalars['String']['input'];
};


export type QueryDashboardStoreListArgs = {
  filter: DashboardFilterInput;
};


export type QueryDashboardTopBrandsArgs = {
  filter: DashboardFilterInput;
};


export type QueryDashboardTrafficMatrixArgs = {
  filter: DashboardBrandFilterInput;
  limit: TrafficMatrixLimit;
};


export type QueryDashboardTrendArgs = {
  filter: DashboardFilterInput;
  granularity: DashboardGranularityInput;
};


export type QueryDatasourceArgs = {
  id: Scalars['Long']['input'];
};


export type QueryDatasourceTokenArgs = {
  id: Scalars['Long']['input'];
};


export type QueryDdiAnalyticsChartArgs = {
  input: DdiAnalyticsChartInput;
};


export type QueryDdiAnalyticsDetailedReportArgs = {
  input: DdiAnalyticsDetailedReportInput;
};


export type QueryDdiAnalyticsReportExportArgs = {
  input: DdiAnalyticsReportExportInput;
};


export type QueryDdiAnalyticsSummaryArgs = {
  input: DdiAnalyticsSummaryInput;
};


export type QueryDdiHomeReportChartArgs = {
  input: DdiHomeReportInput;
};


export type QueryDdiHomeReportPieChartArgs = {
  input: DdiHomeReportInput;
};


export type QueryDdiHomeReportSummaryArgs = {
  input: DdiHomeReportInput;
};


export type QueryDdiHomeReportTopProductsArgs = {
  input: DdiHomeReportInput;
};


export type QueryDdiInventoryStockValueDailyReportArgs = {
  input: DdiInventoryStockValueDailyReportInput;
};


export type QueryDdiInventoryStockValueProductReportArgs = {
  input: DdiInventoryStockValueProductReportInput;
};


export type QueryDdiInventoryTrackerReportArgs = {
  input: DdiInventoryTrackerReportInput;
};


export type QueryDdiProductAnalyticsDetailedReportArgs = {
  input: DdiProductAnalyticsDetailedReportInput;
};


export type QueryDdiProductAnalyticsReportExportArgs = {
  input: DdiProductAnalyticsReportExportInput;
};


export type QueryDdiProductAnalyticsSummaryArgs = {
  input: DdiProductAnalyticsSummaryInput;
};


export type QueryDdiProductStatusArgs = {
  input: DdiProductStatusInput;
};


export type QueryDocumentArgs = {
  documentId: Scalars['Long']['input'];
};


export type QueryEligibleClosingScriptCountForRoomArgs = {
  roomId: Scalars['ID']['input'];
};


export type QueryEligibleVoiceClonesForRoomArgs = {
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  roomId: Scalars['ID']['input'];
};


export type QueryExportAdCampaignReportArgs = {
  input: AdCampaignDetailedReportInput;
};


export type QueryExportAdGroupReportArgs = {
  input: AdGroupDetailedReportInput;
};


export type QueryExportAdOverviewReportArgs = {
  input: AdOverviewReportInput;
};


export type QueryExportAdReportArgs = {
  input: AdDetailedReportInput;
};


export type QueryExportDdiInventoryStockValueDailyReportArgs = {
  input: DdiInventoryStockValueDailyReportExportInput;
};


export type QueryExportDdiInventoryStockValueProductReportArgs = {
  input: DdiInventoryStockValueProductReportExportInput;
};


export type QueryExportKeywordReportArgs = {
  input: KeywordDetailedReportInput;
};


export type QueryExportProductReportArgs = {
  filter: ProductReportExportFilterInput;
};


export type QueryExportSaleChannelReportArgs = {
  filter: SaleChannelReportTableFilterInput;
};


export type QueryExportVariantReportArgs = {
  filter: ProductVariantReportExportFilterInput;
};


export type QueryFacebookAdsAccountsArgs = {
  datasourceTokenId: Scalars['Long']['input'];
};


export type QueryFacebookLoginUrlArgs = {
  redirectUri: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFallbackTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFallbackTemplateRevisionArgs = {
  revisionNumber: Scalars['Int']['input'];
  templateId: Scalars['ID']['input'];
};


export type QueryFallbackTemplateRevisionsArgs = {
  templateId: Scalars['ID']['input'];
};


export type QueryFallbackTemplatesArgs = {
  filter?: InputMaybe<AnyLiveFallbackTemplateFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryFileUploadHistoriesV2Args = {
  input: FileUploadHistoriesInput;
};


export type QueryGetAdCostCampaignMappingArgs = {
  adCostCampaignMappingId: Scalars['Long']['input'];
};


export type QueryGetAdCostCampaignMappingsArgs = {
  filter: AdCostCampaignMappingListFilterInput;
};


export type QueryGetAdSetMappingCampaignArgs = {
  adSetMappingCampaignId: Scalars['Long']['input'];
  masterDataStoreId: Scalars['Long']['input'];
};


export type QueryGetAdSetMappingCampaignsArgs = {
  filter: AdSetMappingCampaignListFilterInput;
};


export type QueryGetAdSetMappingGroupArgs = {
  adSetMappingGroupId: Scalars['Long']['input'];
};


export type QueryGetAdSetMappingGroupProductsArgs = {
  filter: AdSetMappingProductListFilterInput;
};


export type QueryGetAdSetMappingGroupsArgs = {
  filter: AdSetMappingGroupListFilterInput;
};


export type QueryGetAnylogiUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAnylogiUsersArgs = {
  filters: AnylogiUserFilters;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCourierAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCourierAccountListArgs = {
  filters: GetCourierAccountListInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryGetCourierSettingsArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryGetCourierSettingsListArgs = {
  filter?: InputMaybe<CourierSettingsFilterInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryGetCrossBorderBasicAuthArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryGetCsvExportJobResultArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryGetCsvUploadTemplateArgs = {
  language: Language;
  operation?: InputMaybe<CsvImportOperation>;
  resource: Resource;
};


export type QueryGetInboundArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetInboundPdfArgs = {
  id: Scalars['ID']['input'];
  language: Language;
};


export type QueryGetInboundPdfsArgs = {
  ids: Array<Scalars['ID']['input']>;
  language: Language;
};


export type QueryGetInboundsArgs = {
  filters: InboundFilters;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetInboundsOverviewArgs = {
  filters: InboundFilters;
};


export type QueryGetLogilessMerchantsArgs = {
  filters: FilterMerchants;
};


export type QueryGetProductsForAdsMappingArgs = {
  filter: AdsMappingProductListFilterInput;
};


export type QueryGetShipperAddressArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetShipperAddressesArgs = {
  accountId: Scalars['ID']['input'];
  filter: GetShipperAddressFilter;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryGetShippingRateArgs = {
  input: ShippingInput;
};


export type QueryGetShippingRatesArgs = {
  input: ShippingInput;
};


export type QueryGetStoreSettingArgs = {
  input: FetchAiAutoReplyStoreSettingInput;
};


export type QueryGetSupplierArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSuppliersArgs = {
  filters: SupplierFilters;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetValidJapanAddressesArgs = {
  orderId: Scalars['Long']['input'];
};


export type QueryGetWarehouseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWarehousesArgs = {
  filters: WarehouseFilters;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetWarehousesListArgs = {
  filters: WarehouseFilters;
};


export type QueryGetWmsStoresArgs = {
  associationKey: Scalars['String']['input'];
  storeId?: InputMaybe<Scalars['Long']['input']>;
  vendor: Wms;
};


export type QueryGoogleAdsClientAccountsArgs = {
  customerId: Scalars['String']['input'];
  datasourceTokenId: Scalars['Long']['input'];
};


export type QueryGoogleAdsCustomersArgs = {
  datasourceTokenId: Scalars['Long']['input'];
};


export type QueryGoogleAnalytics4AccountsArgs = {
  datasourceTokenId: Scalars['Long']['input'];
};


export type QueryGoogleLoginUrlArgs = {
  redirectUri: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  type: GoogleLoginUrlType;
};


export type QueryHasAdvertisingConnectionArgs = {
  input: OnboardingInput;
};


export type QueryHasAnalyticsReportArgs = {
  input: OnboardingInput;
};


export type QueryHasConnectedSaleChannelArgs = {
  input: OnboardingInput;
};


export type QueryHasLogisticsChannelArgs = {
  storeId?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryHasLogisticsChannelBySaleChannelIdArgs = {
  saleChannelId: Scalars['Long']['input'];
};


export type QueryHostArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHostsArgs = {
  filter: HostFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: HostSortInput;
};


export type QueryImportsFileUploadArgs = {
  fileName: Scalars['String']['input'];
};


export type QueryInactiveIntegrationCountArgs = {
  input: OnboardingInput;
};


export type QueryInboundDetailArgs = {
  inboundId: Scalars['String']['input'];
};


export type QueryInboundListViewArgs = {
  input: InboundListViewInput;
};


export type QueryInboundOverviewArgs = {
  input: InboundOverviewInput;
};


export type QueryInventoryExportCsvArgs = {
  input: InventoryExportCsvInput;
};


export type QueryInventoryFileUploadHistoryArgs = {
  input: InventoryFileUploadHistoryInput;
};


export type QueryInventoryListViewArgs = {
  input: InventoryListQueryInput;
};


export type QueryInventoryOverviewArgs = {
  input: InventoryOverviewQueryInput;
};


export type QueryKeywordChartArgs = {
  input: KeywordChartInput;
};


export type QueryKeywordDetailedReportArgs = {
  input: KeywordDetailedReportInput;
};


export type QueryKeywordSummaryArgs = {
  input: KeywordSummaryInput;
};


export type QueryLazadaLoginUrlV2Args = {
  input: LazadaLoginUrlV2Input;
};


export type QueryLazadaSalesChartArgs = {
  input: LazadaSalesChartInput;
};


export type QueryLazadaSalesDetailedReportArgs = {
  input: LazadaSalesDetailedReportInput;
};


export type QueryLazadaSalesSummaryArgs = {
  input: LazadaSalesSummaryInput;
};


export type QueryLiveAssetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLiveAssetDetailsGenerateArgs = {
  input: LiveAssetDetailsGenerateInput;
};


export type QueryLiveAssetGenerateArgs = {
  input: LiveAssetGenerateInput;
};


export type QueryLiveAssetVersionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLiveAssetVersionExportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLiveAssetVersionFaqExportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLiveAssetVersionsArgs = {
  filter: LiveAssetVersionFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: LiveAssetVersionSortInput;
};


export type QueryLiveAssetVersionsExportArgs = {
  filter: LiveAssetVersionExportFilterInput;
};


export type QueryLiveAssetsArgs = {
  filter: LiveAssetFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: LiveAssetSortInput;
};


export type QueryLiveAssetsExportArgs = {
  filter: LiveAssetExportFilterInput;
};


export type QueryLiveStreamsExportV2Args = {
  filter: LiveStreamExportFilterInput;
};


export type QueryLivestreamArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLivestreamAvatarArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLivestreamAvatarGreenScreenPreviewArgs = {
  input: LivestreamAvatarGreenScreenPreviewInput;
};


export type QueryLivestreamAvatarGreenScreenPreviewUploadUrlArgs = {
  input: LivestreamAvatarGreenScreenPreviewUploadInput;
};


export type QueryLivestreamAvatarTrainingUploadUrlsArgs = {
  input: LivestreamAvatarTrainingUploadUrlsInput;
};


export type QueryLivestreamAvatarVideoUploadArgs = {
  input: LivestreamAvatarVideoUploadInput;
};


export type QueryLivestreamPlatformFeaturesArgs = {
  salesChannelType: SalesChannelType;
};


export type QueryLivestreamRoomArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLivestreamRoomAtmosphereScriptVoiceSignedUrlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLivestreamRoomAtmosphereScriptVoiceUploadArgs = {
  input: LivestreamRoomAtmosphereScriptVoiceUploadInput;
};


export type QueryLivestreamRoomBytePlusEventsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLivestreamRoomBytePlusProductsArgs = {
  eventId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type QueryLivestreamRoomDecorationGroupArgs = {
  livestreamRoomId: Scalars['ID']['input'];
};


export type QueryLivestreamRoomDecorationPreviewUploadArgs = {
  input: LivestreamRoomDecorationPreviewUploadInput;
};


export type QueryLivestreamRoomDecorationUploadArgs = {
  input: LivestreamRoomDecorationUploadInput;
};


export type QueryLivestreamRoomDecorationsArgs = {
  livestreamRoomProductId: Scalars['ID']['input'];
};


export type QueryLivestreamRoomGeneralFaqArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLivestreamRoomGeneralFaqCustomVideoUploadArgs = {
  input: LivestreamRoomGeneralFaqCustomVideoUploadInput;
};


export type QueryLivestreamRoomGeneralFaqVoiceSignedUrlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLivestreamRoomGeneralFaqVoiceUploadArgs = {
  input: LivestreamRoomGeneralFaqVoiceUploadInput;
};


export type QueryLivestreamRoomProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLivestreamRoomProductCoverUrlUploadArgs = {
  input: LivestreamRoomProductCoverUrlUploadInput;
};


export type QueryLivestreamRoomProductFaqArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLivestreamRoomProductFaqCustomVideoUploadArgs = {
  input: LivestreamRoomProductFaqCustomVideoUploadInput;
};


export type QueryLivestreamRoomProductFaqVoiceSignedUrlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLivestreamRoomProductFaqVoiceUploadArgs = {
  input: LivestreamRoomProductFaqVoiceUploadInput;
};


export type QueryLivestreamRoomProductParagraphArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLivestreamRoomProductParagraphAudioSignedUrlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLivestreamRoomProductParagraphVideoSignedUrlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLivestreamRoomProductParagraphVideoUploadArgs = {
  input: LivestreamRoomProductParagraphVideoUploadInput;
};


export type QueryLivestreamRoomRakutenProductsArgs = {
  id: Scalars['String']['input'];
};


export type QueryLivestreamRoomRakutenSchedulesArgs = {
  id: Scalars['String']['input'];
};


export type QueryLivestreamRoomShopInfoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLivestreamRoomShopeeProductSetsArgs = {
  livestreamRoomId: Scalars['ID']['input'];
};


export type QueryLivestreamRoomUnmatchedFaqVoiceSignedUrlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLivestreamRoomsArgs = {
  filter: LivestreamRoomFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: LivestreamRoomSortInput;
};


export type QueryLivestreamSessionWorkerNodeArgs = {
  id: Scalars['String']['input'];
};


export type QueryLivestreamShopeeCommentsArgs = {
  filter: ShopeeCommentFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: ShopeeCommentSortInput;
};


export type QueryLivestreamShopeeProductsArgs = {
  filter: ShopeeProductFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: ShopeeProductSortInput;
};


export type QueryLivestreamShopeeStatsArgs = {
  filter: ShopeeLiveStatFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: ShopeeLiveStatSortInput;
};


export type QueryLivestreamShopeeTrendsArgs = {
  filter: ShopeeTrendFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: ShopeeTrendSortInput;
};


export type QueryLivestreamTikTokCommentsArgs = {
  filter: TikTokCommentFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: TikTokCommentSortInput;
};


export type QueryLivestreamTikTokProductsArgs = {
  filter: TikTokProductFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: TikTokProductSortInput;
};


export type QueryLivestreamTikTokStatsArgs = {
  filter: TikTokLiveStatFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: TikTokLiveStatSortInput;
};


export type QueryLivestreamTikTokTotalTrafficSourcesArgs = {
  filter: TikTokTotalTrafficSourceFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: TikTokTotalTrafficSourceSortInput;
};


export type QueryLivestreamTikTokTrafficSourceByTimestampGvmArgs = {
  filter: TikTokTrafficSourceByTimestampGmvFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: TikTokTrafficSourceByTimestampGmvSortInput;
};


export type QueryLivestreamTikTokTrafficSourceByTimestampImpressionsArgs = {
  filter: TikTokTrafficSourceByTimestampValueFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: TikTokTrafficSourceByTimestampValueSortInput;
};


export type QueryLivestreamTikTokTrafficSourceByTimestampViewsArgs = {
  filter: TikTokTrafficSourceByTimestampValueFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: TikTokTrafficSourceByTimestampValueSortInput;
};


export type QueryLivestreamTikTokTrendsArgs = {
  filter: TikTokTrendFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: TikTokTrendSortInput;
};


export type QueryLivestreamsArgs = {
  filter: LiveStreamFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: LiveStreamSortInput;
};


export type QueryLogisticsChannelDetailsForAddArgs = {
  storeId: Scalars['Long']['input'];
};


export type QueryLogisticsChannelDetailsForMerchantArgs = {
  merchantId: Scalars['Long']['input'];
};


export type QueryManualSaleChannelsByStoreIdArgs = {
  storeId: Scalars['Long']['input'];
};


export type QueryMarketplaceCalendarEventsArgs = {
  input: MarketplaceCalendarEventQueryInput;
};


export type QueryMarketplaceCalendarSummaryArgs = {
  input: MarketplaceCalendarSummaryQueryInput;
};


export type QueryMomoConnectionArgs = {
  livestreamRoomId: Scalars['ID']['input'];
};


export type QueryOnboardingArgs = {
  storeId: Scalars['Long']['input'];
};


export type QueryOrderArgs = {
  id: Scalars['Long']['input'];
};


export type QueryOrderCsvExportV3Args = {
  input: OrderCsvExportV2Input;
};


export type QueryOrderCsvUploadArgs = {
  fileName: Scalars['String']['input'];
};


export type QueryOrderListViewArgs = {
  filter: OrderListFilterInput;
  pageNumber: Scalars['Int']['input'];
};


export type QueryOrderOnboardingArgs = {
  storeId: Scalars['Long']['input'];
};


export type QueryOrderOverviewV2Args = {
  filter: OrderListFilterInput;
};


export type QueryPaymentMethodsV2Args = {
  filter: PaymentMethodFilterInput;
};


export type QueryProductCsvExportArgs = {
  input: ProductCsvExportInput;
};


export type QueryProductCsvUploadArgs = {
  fileName: Scalars['String']['input'];
};


export type QueryProductCategoryAndPriceArgs = {
  input: ProductReviewAnalysisFilterInput;
};


export type QueryProductChartArgs = {
  input: ProductChartInput;
};


export type QueryProductDetailArgs = {
  id: Scalars['Long']['input'];
};


export type QueryProductDetailedReportArgs = {
  input: ProductDetailedReportInput;
};


export type QueryProductDetailsForReviewAnalysisArgs = {
  input: ProductReviewAnalysisFilterInput;
};


export type QueryProductInfoArgs = {
  input: ProductInfoInput;
};


export type QueryProductListViewArgs = {
  filter: ProductListFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryProductMediaUploadArgs = {
  fileName: Scalars['String']['input'];
};


export type QueryProductOnboardingArgs = {
  storeId: Scalars['Long']['input'];
};


export type QueryProductRatingOverviewArgs = {
  input: ProductReviewAnalysisFilterInput;
};


export type QueryProductReviewCompetitorAnalysisArgs = {
  input: ProductReviewCompetitorAnalysisRequestInput;
};


export type QueryProductReviewSentimentAnalysisArgs = {
  input: ProductReviewAnalysisFilterInput;
};


export type QueryProductReviewSummarizationArgs = {
  input: ProductReviewAnalysisFilterInput;
};


export type QueryProductReviewTopicAnalysisArgs = {
  input: ProductReviewAnalysisFilterInput;
};


export type QueryProductReviewsArgs = {
  input: ProductReviewsInput;
};


export type QueryProductSaleChannelsArgs = {
  input: ProductSaleChannelsInput;
};


export type QueryProductSalesAnalyticsArgs = {
  input: ProductSalesAnalyticsInput;
};


export type QueryProductSummaryArgs = {
  input: ProductSummaryInput;
};


export type QueryProductVariantArgs = {
  id: Scalars['Long']['input'];
};


export type QueryProductVariantCsvExportArgs = {
  input: ProductVariantCsvExportInput;
};


export type QueryProductVariantForOrderAddProductV2Args = {
  input: ProductVariantForOrderAddProductInput;
  pageNumber: Scalars['Int']['input'];
};


export type QueryProductVariantListViewArgs = {
  filter: ProductVariantListFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryProductVariantsForAddInboundArgs = {
  filter: ProductVariantForAddInboundFilterInput;
  pageNumber: Scalars['Int']['input'];
};


export type QueryProductVariantsForProductMergeArgs = {
  filter: ProductVariantForMergeFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryProductVariantsForProductSetArgs = {
  filter: ProductVariantForSetFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryPronunciationDictionariesArgs = {
  filter?: InputMaybe<PronunciationDictionaryFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryPronunciationDictionariesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryPronunciationDictionaryArgs = {
  voiceCloneId: Scalars['ID']['input'];
};


export type QueryPronunciationRulesArgs = {
  dictionaryId: Scalars['ID']['input'];
  filter?: InputMaybe<PronunciationRuleFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryRakutenSalesReportChartArgs = {
  input: RakutenSalesReportChartInput;
};


export type QueryRakutenSalesReportSummaryArgs = {
  input: RakutenSalesReportSummaryInput;
};


export type QueryRakutenSalesReportTableArgs = {
  input: RakutenSalesReportTableInput;
};


export type QueryReportByProductArgs = {
  filter: ProductReportPaginatedFilterInput;
};


export type QueryReportByProductDailyArgs = {
  filter: ProductReportFilterInput;
};


export type QueryReportByProductSummaryArgs = {
  filter: VariantReportFilterInput;
};


export type QueryReportByVariantArgs = {
  filter: VariantReportPaginatedFilterInput;
};


export type QueryReportByVariantDailyArgs = {
  filter: VariantReportFilterInput;
};


export type QueryReportDocumentArgs = {
  id: Scalars['Long']['input'];
};


export type QueryReportExportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportExportsArgs = {
  filter?: InputMaybe<ReportExportFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryReportHomeDailyArgs = {
  filter: HomeReportFilterInput;
  metric: HomeDailyReportMetric;
};


export type QueryReportHomeSaleChannelRevenueArgs = {
  filter: HomeReportFilterInput;
};


export type QueryReportHomeSummaryArgs = {
  filter: HomeReportFilterInput;
};


export type QueryReportHomeTop5ProductsArgs = {
  filter: HomeReportFilterInput;
};


export type QuerySaleChannelArgs = {
  id: Scalars['Long']['input'];
};


export type QuerySaleChannelCostIndexArgs = {
  saleChannelId: Scalars['Long']['input'];
};


export type QuerySaleChannelCostIndexesArgs = {
  filter?: InputMaybe<SaleChannelCostIndexFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortBy?: InputMaybe<SaleChannelCostIndexSortByInput>;
};


export type QuerySaleChannelCurrencyArgs = {
  saleChannelType: SaleChannelType;
};


export type QuerySaleChannelPlanArgs = {
  type: SaleChannelType;
};


export type QuerySaleChannelPlanV2Args = {
  type: SaleChannelType;
};


export type QuerySaleChannelReportChartArgs = {
  filter: SaleChannelReportTableFilterInput;
};


export type QuerySaleChannelReportSummaryArgs = {
  filter: SaleChannelReportSummaryFilterInput;
};


export type QuerySaleChannelReportTableArgs = {
  filter: SaleChannelReportTableFilterInput;
};


export type QuerySaleChannelSyncsArgs = {
  after: Scalars['OffsetDateTime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
};


export type QueryScriptArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScriptDetailsGenerateArgs = {
  input: ScriptDetailsGenerateInput;
};


export type QueryScriptGenerateArgs = {
  input: ScriptGenerateInput;
};


export type QueryScriptVersionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScriptVersionExportV2Args = {
  id: Scalars['ID']['input'];
};


export type QueryScriptVersionsArgs = {
  filter: ScriptVersionFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: ScriptVersionSortInput;
};


export type QueryScriptVersionsExportV2Args = {
  filter: ScriptVersionExportFilterInput;
};


export type QueryScriptsArgs = {
  filter: ScriptFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: ScriptSortInput;
};


export type QueryScriptsExportV2Args = {
  filter: ScriptExportFilterInput;
};


export type QuerySensitiveWordArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySensitiveWordRevisionArgs = {
  revisionNumber: Scalars['Int']['input'];
  templateId: Scalars['ID']['input'];
};


export type QuerySensitiveWordRevisionsArgs = {
  templateId: Scalars['ID']['input'];
};


export type QuerySensitiveWordsArgs = {
  filter?: InputMaybe<AnyLiveSensitiveWordFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QuerySessionsCsvPreviewArgs = {
  ascending: Scalars['Boolean']['input'];
  filter: SessionsCsvFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QuerySettingGuideArgs = {
  input: OnboardingInput;
};


export type QueryShopeeAffiliateLoginUrlArgs = {
  input: ShopeeAffiliateLoginUrlInput;
};


export type QueryShopeeAllStatExportV2Args = {
  filter: ShopeeAllStatExportFilterInput;
};


export type QueryShopeeCommentsExportV2Args = {
  filter: ShopeeCommentsExportFilterInput;
};


export type QueryShopeeConnectionArgs = {
  anyxStoreId: Scalars['String']['input'];
};


export type QueryShopeeLiveStatExportV2Args = {
  filter: ShopeeLiveStatExportFilterInput;
};


export type QueryShopeeLiveStreamCoverImageUploadArgs = {
  input: ShopeeLiveStreamCoverImageUploadInput;
};


export type QueryShopeeLoginUrlV2Args = {
  input: ShopeeLoginUrlV2Input;
};


export type QueryShopeeProductSetCandidatesArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  livestreamRoomId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryShopeeProductSetItemsArgs = {
  livestreamRoomId: Scalars['ID']['input'];
  setId: Scalars['ID']['input'];
};


export type QueryShopeeProductsExportV2Args = {
  filter: ShopeeProductsExportFilterInput;
};


export type QueryShopeeSalesChartArgs = {
  input: ShopeeSalesChartInput;
};


export type QueryShopeeSalesDetailedReportArgs = {
  input: ShopeeSalesDetailedReportInput;
};


export type QueryShopeeSalesSummaryArgs = {
  input: ShopeeSalesSummaryInput;
};


export type QueryShopeeTrendsExportV2Args = {
  filter: ShopeeTrendsExportFilterInput;
};


export type QueryShopifyLoginUrlV2Args = {
  input: ShopifyLoginUrlV2Input;
};


export type QueryShopifySalesReportChartArgs = {
  input: ShopifySalesReportChartInput;
};


export type QueryShopifySalesReportSummaryArgs = {
  input: ShopifySalesReportSummaryInput;
};


export type QueryShopifySalesReportTableArgs = {
  input: ShopifySalesReportTableInput;
};


export type QueryStoreConnectionFacebookPagesArgs = {
  anyxStoreId: Scalars['ID']['input'];
};


export type QueryStoreConnectionShopeeSessionRouteArgs = {
  anyxStoreId: Scalars['ID']['input'];
};


export type QueryStoreConnectionValidateArgs = {
  anyxStoreId: Scalars['ID']['input'];
  platform: SalesChannelType;
};


export type QueryStoreConnectionsArgs = {
  filter: StoreConnectionFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort: StoreConnectionSortInput;
};


export type QueryStoreProductCatalogsArgs = {
  anyxStoreId: Scalars['String']['input'];
  salesChannel: SalesChannelType;
};


export type QueryStoreProductsArgs = {
  anyxStoreId: Scalars['String']['input'];
  catalogId?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  livestreamRoomId?: InputMaybe<Scalars['ID']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  salesChannel: SalesChannelType;
};


export type QueryStoresWithChannelArgs = {
  filter?: InputMaybe<StoreWithChanelFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryTagsV2Args = {
  filter?: InputMaybe<ProductTagsFilterInput>;
};


export type QueryTikTokAdsAdAccountsArgs = {
  datasourceTokenId: Scalars['Long']['input'];
};


export type QueryTikTokAdsLoginUrlArgs = {
  redirectUri: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTikTokAllStatExportV2Args = {
  filter: TikTokAllStatExportFilterInput;
};


export type QueryTikTokCommentsExportV2Args = {
  filter: TikTokCommentsExportFilterInput;
};


export type QueryTikTokLiveStatsExportV2Args = {
  filter: TikTokLiveStatsExportFilterInput;
};


export type QueryTikTokLoginUrlV2Args = {
  input: TikTokLoginUrlV2Input;
};


export type QueryTikTokProductsExportV2Args = {
  filter: TikTokProductsExportFilterInput;
};


export type QueryTikTokSalesReportChartArgs = {
  input: TikTokSalesReportChartInput;
};


export type QueryTikTokSalesReportDetailedReportArgs = {
  input: TikTokSalesReportDetailedReportInput;
};


export type QueryTikTokSalesReportSummaryArgs = {
  input: TikTokSalesReportSummaryInput;
};


export type QueryTikTokTotalTrafficSourceExportV2Args = {
  filter: TikTokTotalTrafficSourceExportFilterInput;
};


export type QueryTikTokTrendsExportV2Args = {
  filter: TikTokTrendsExportFilterInput;
};


export type QueryTokopediaSalesChartArgs = {
  input: TokopediaSalesChartInput;
};


export type QueryTokopediaSalesDetailedReportArgs = {
  input: TokopediaSalesDetailedReportInput;
};


export type QueryTokopediaSalesSummaryArgs = {
  input: TokopediaSalesSummaryInput;
};


export type QueryTransitionScriptVoiceSignedUrlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransitionScriptVoiceUploadArgs = {
  input: TransitionScriptVoiceUploadInput;
};


export type QueryTtsAudioGcsUrlArgs = {
  ttsId: Scalars['ID']['input'];
};


export type QueryTtsInfoArgs = {
  ttsId: Scalars['ID']['input'];
};


export type QueryTtsInfosArgs = {
  contentType: TtsContentType;
  ttsIds: Array<Scalars['ID']['input']>;
};


export type QueryTtsSignedUrlArgs = {
  ttsId: Scalars['ID']['input'];
};


export type QueryTtsVoiceCloneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTtsVoiceClonesArgs = {
  filter: TtsVoiceCloneFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryTtsVoiceUploadArgs = {
  input: TtsVoiceUploadInput;
};


export type QueryVariantValuesArgs = {
  input: VariantValuesInput;
};


export type QueryVoiceCloneSignedUrlArgs = {
  voiceCloneId: Scalars['ID']['input'];
};


export type QueryYahooAdsAccountsArgs = {
  input: YahooAdsAccountsInput;
};


export type QueryYahooAdsLoginUrlArgs = {
  input: YahooAdsLoginUrlInput;
};


export type QueryYahooLoginUrlArgs = {
  input: YahooLoginUrlInput;
};


export type QueryYahooSalesReportChartArgs = {
  input: YahooSalesReportChartInput;
};


export type QueryYahooSalesReportSummaryArgs = {
  input: YahooSalesReportSummaryInput;
};


export type QueryYahooSalesReportTableArgs = {
  input: YahooSalesReportTableInput;
};

export type QuotaInfos = {
  __typename?: 'QuotaInfos';
  line: LineMessageQuotaInfo;
};

export type QuotedChatEventInput = {
  eventId: Scalars['String']['input'];
  messageNumber: Scalars['Int']['input'];
};

export type QuotedLineChatEvent = {
  __typename?: 'QuotedLineChatEvent';
  id: Scalars['String']['output'];
  message: LinePlatformEventContent;
  messageNumber: Scalars['Int']['output'];
};

export type RakutenConnectPayload = {
  __typename?: 'RakutenConnectPayload';
  ok: Scalars['Boolean']['output'];
  unavailableAPI?: Maybe<Array<Scalars['String']['output']>>;
};

export type RakutenFileUploadInput = {
  /** start from gs://~~~ */
  fileUri: Scalars['String']['input'];
  saleChannelId: Scalars['Long']['input'];
  type: RakutenFileUploadType;
};

export const RakutenFileUploadType = {
  AD_COST_COUPON_ADVANCED: 'AD_COST_COUPON_ADVANCED',
  AD_COST_RPP: 'AD_COST_RPP',
  SESSION: 'SESSION'
} as const;

export type RakutenFileUploadType = typeof RakutenFileUploadType[keyof typeof RakutenFileUploadType];
/** List of Rakuten livestream products */
export type RakutenLivestreamProductListOutput = {
  __typename?: 'RakutenLivestreamProductListOutput';
  /** List of products available in the livestream */
  items: Array<RakutenLivestreamProductOutput>;
};

/** A single Rakuten livestream product */
export type RakutenLivestreamProductOutput = {
  __typename?: 'RakutenLivestreamProductOutput';
  /** Unique identifier for the product */
  id: Scalars['Long']['output'];
  /** URL to the product image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Rakuten item ID */
  itemId: Scalars['String']['output'];
  /** URL to the product on Rakuten */
  itemUrl?: Maybe<Scalars['String']['output']>;
  /** Product name */
  name: Scalars['String']['output'];
};

export type RakutenReconnectPayload = {
  __typename?: 'RakutenReconnectPayload';
  ok: Scalars['Boolean']['output'];
  unavailableAPI?: Maybe<Array<Scalars['String']['output']>>;
};

export type RakutenSaleChannelData = {
  __typename?: 'RakutenSaleChannelData';
  shopUrl: Scalars['String']['output'];
};

export type RakutenSalesReportChartInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type RakutenSalesReportChartPayload = {
  __typename?: 'RakutenSalesReportChartPayload';
  conversionRate: Array<Scalars['Map']['output']>;
  currency: ReportSupportedCurrency;
  orderCount: Array<Scalars['Map']['output']>;
  sessions: Array<Scalars['Map']['output']>;
  totalSales: Array<Scalars['Map']['output']>;
};

export type RakutenSalesReportSummaryInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type RakutenSalesReportSummaryPayload = {
  __typename?: 'RakutenSalesReportSummaryPayload';
  conversionRate: NumericValueWithDiffPayload;
  currency: ReportSupportedCurrency;
  orderCount: NumericValueWithDiffPayload;
  sessions: NumericValueWithDiffPayload;
  totalSales: NumericValueWithDiffPayload;
};

export type RakutenSalesReportTableInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type RakutenSalesReportTablePayload = {
  __typename?: 'RakutenSalesReportTablePayload';
  conversionRate: Scalars['BigDecimal']['output'];
  currency: ReportSupportedCurrency;
  date: Scalars['LocalDate']['output'];
  orderCount: Scalars['Int']['output'];
  sessions: Scalars['Int']['output'];
  totalSales: Scalars['BigDecimal']['output'];
};

export type RakutenSalesReportTablePayloadList = {
  __typename?: 'RakutenSalesReportTablePayloadList';
  items: Array<RakutenSalesReportTablePayload>;
  meta: ReportListMeta;
  total: RakutenSalesReportTotalPayload;
};

export type RakutenSalesReportTotalPayload = {
  __typename?: 'RakutenSalesReportTotalPayload';
  conversionRate: Scalars['BigDecimal']['output'];
  orderCount: Scalars['Int']['output'];
  sessions: Scalars['Int']['output'];
  totalSales: Scalars['BigDecimal']['output'];
};

/** Paginated list of scheduled Rakuten livestreams */
export type RakutenScheduledLivestreamListOutput = {
  __typename?: 'RakutenScheduledLivestreamListOutput';
  /** List of scheduled livestreams */
  items: Array<RakutenScheduledLivestreamOutput>;
  /** Current page number (1-indexed) */
  pageNumber: Scalars['Int']['output'];
  /** Page size */
  pageSize: Scalars['Int']['output'];
  /** Total number of livestreams available */
  total: Scalars['Int']['output'];
};

/** A single Rakuten scheduled livestream */
export type RakutenScheduledLivestreamOutput = {
  __typename?: 'RakutenScheduledLivestreamOutput';
  /** Description of the livestream */
  description?: Maybe<Scalars['String']['output']>;
  /** End time in format YYYY-MM-DD HH:mm:ss */
  endTime: Scalars['String']['output'];
  /** Unique identifier for the livestream */
  id: Scalars['Long']['output'];
  /** Duration of the livestream in seconds */
  liveDuration: Scalars['Int']['output'];
  /** Start time in format YYYY-MM-DD HH:mm:ss */
  startTime: Scalars['String']['output'];
  /** Status code (1=SCHEDULED, 2=LIVE, 3=FINISHED) */
  status: Scalars['Int']['output'];
  /** Human-readable status label (e.g., '予定中', 'ライブ中') */
  statusLabel: Scalars['String']['output'];
  /** URL to the thumbnail image */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Title of the livestream */
  title: Scalars['String']['output'];
};

export type RatedShipmentAlert = {
  __typename?: 'RatedShipmentAlert';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type ReactionSign = Emoji | InstagramSign;

export type ReadOrderCustomer = {
  __typename?: 'ReadOrderCustomer';
  email?: Maybe<Scalars['String']['output']>;
  name: Name;
  phoneNumber: Scalars['String']['output'];
  phoneNumberCountry?: Maybe<ShopifySupportedCountry>;
};

export type ReadOrderProductLogistics = {
  __typename?: 'ReadOrderProductLogistics';
  deliveryStatus?: Maybe<OrderProductDeliveryStatus>;
  unknown: Scalars['Boolean']['output'];
};

export type Recipient = All | Condition | CustomerTagNames | InfluencerCondition;

export type RecipientItemInput = {
  conditions?: InputMaybe<BroadcastConditionWrapperInput>;
  influencerConditions?: InputMaybe<BroadcastInfluencerConditionWrapperInput>;
  type: RecipientType;
};

export const RecipientType = {
  ALL: 'ALL',
  CONDITIONS: 'CONDITIONS',
  INFLUENCER_CONDITIONS: 'INFLUENCER_CONDITIONS'
} as const;

export type RecipientType = typeof RecipientType[keyof typeof RecipientType];
export type RefreshFacebookTokenResponse = NoInstagramAccountRefreshTokenError | RefreshFacebookTokenResponseSuccess | UnknownErrorRefreshTokenError | WrongPageSelectedRefreshTokenError;

export type RefreshFacebookTokenResponseSuccess = {
  __typename?: 'RefreshFacebookTokenResponseSuccess';
  connectionId: Scalars['String']['output'];
};

export type RefreshShopeeConnectionRequest = {
  code: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type RegenerateDraftReplyRequest = {
  chatId: Scalars['String']['input'];
  draftId: Scalars['String']['input'];
  instruction?: InputMaybe<Scalars['String']['input']>;
};

export type Region = {
  __typename?: 'Region';
  id: Scalars['ID']['output'];
  language: Language;
  localName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  provinceId: Scalars['String']['output'];
};

export type RegisterFileUploadPayload = {
  __typename?: 'RegisterFileUploadPayload';
  fileUploadId: Scalars['String']['output'];
};

export type RegisterManualIntegrationOrderCsvPayload = {
  __typename?: 'RegisterManualIntegrationOrderCsvPayload';
  fileUploadId: Scalars['String']['output'];
};

export type RegisterManualIntegrationProductCsvPayload = {
  __typename?: 'RegisterManualIntegrationProductCsvPayload';
  fileUploadId: Scalars['String']['output'];
};

export type RegisterManualOrderCsvUploadPayload = {
  __typename?: 'RegisterManualOrderCsvUploadPayload';
  ok: Scalars['Boolean']['output'];
};

export type RemoveUserFromAssigneeList = {
  __typename?: 'RemoveUserFromAssigneeList';
  user: BasicUser;
};

export type ReopenChat = {
  __typename?: 'ReopenChat';
  isAuto: Scalars['Boolean']['output'];
};

export type RepliedFromLazada = {
  __typename?: 'RepliedFromLazada';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export const ReplyMode = {
  TEXT: 'TEXT',
  VOICE: 'VOICE'
} as const;

export type ReplyMode = typeof ReplyMode[keyof typeof ReplyMode];
export const ReplyTimingType = {
  IMMEDIATELY: 'IMMEDIATELY',
  ONLY_AT_PAUSE: 'ONLY_AT_PAUSE'
} as const;

export type ReplyTimingType = typeof ReplyTimingType[keyof typeof ReplyTimingType];
export type ReplyTo = ReplyToMessage | ReplyToStory;

export type ReplyToInputInput = {
  messageId?: InputMaybe<Scalars['String']['input']>;
};

export type ReplyToMessage = {
  __typename?: 'ReplyToMessage';
  message: InstagramMessage;
};

export type ReplyToStory = {
  __typename?: 'ReplyToStory';
  story: Story;
};

export const ReplyType = {
  GENERAL_QA: 'GENERAL_QA',
  GENERAL_QA_SWITCH_PRODUCT: 'GENERAL_QA_SWITCH_PRODUCT',
  LLM_FALLBACK: 'LLM_FALLBACK',
  NO_REPLY: 'NO_REPLY',
  PRODUCT_QA: 'PRODUCT_QA',
  PRODUCT_QA_SWITCH_PRODUCT: 'PRODUCT_QA_SWITCH_PRODUCT'
} as const;

export type ReplyType = typeof ReplyType[keyof typeof ReplyType];
export const ReportChartTab = {
  CHANNEL: 'CHANNEL',
  STORE: 'STORE'
} as const;

export type ReportChartTab = typeof ReportChartTab[keyof typeof ReportChartTab];
export type ReportCompareData = {
  __typename?: 'ReportCompareData';
  current?: Maybe<Scalars['BigDecimal']['output']>;
  diff?: Maybe<Scalars['BigDecimal']['output']>;
  isPercentage: Scalars['Boolean']['output'];
  percentage?: Maybe<Scalars['BigDecimal']['output']>;
};

export const ReportDimensions = {
  CHANNELS: 'CHANNELS',
  DAY: 'DAY',
  DOW: 'DOW',
  MONTH: 'MONTH',
  WEEK: 'WEEK'
} as const;

export type ReportDimensions = typeof ReportDimensions[keyof typeof ReportDimensions];
export type ReportDocumentPayload = {
  __typename?: 'ReportDocumentPayload';
  createdAt: Scalars['ZonedDatetime']['output'];
  doneAt?: Maybe<Scalars['ZonedDatetime']['output']>;
  id: Scalars['Long']['output'];
  status: ReportDocumentStatus;
  type: ReportDocumentType;
  url?: Maybe<Scalars['URL']['output']>;
};

export type ReportDocumentResult = {
  __typename?: 'ReportDocumentResult';
  documentId: Scalars['Long']['output'];
  ok: Scalars['Boolean']['output'];
};

export const ReportDocumentStatus = {
  FAIL: 'FAIL',
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS'
} as const;

export type ReportDocumentStatus = typeof ReportDocumentStatus[keyof typeof ReportDocumentStatus];
export const ReportDocumentType = {
  AD_CAMPAIGN_CSV: 'AD_CAMPAIGN_CSV',
  AD_CSV: 'AD_CSV',
  AD_GROUP_CSV: 'AD_GROUP_CSV',
  AD_OVERVIEW_CSV: 'AD_OVERVIEW_CSV',
  DDI_ANALYTICS_CSV: 'DDI_ANALYTICS_CSV',
  DDI_INVENTORY_DAILY_CSV: 'DDI_INVENTORY_DAILY_CSV',
  DDI_INVENTORY_PRODUCT_CSV: 'DDI_INVENTORY_PRODUCT_CSV',
  DDI_PRODUCT_ANALYTICS_CSV: 'DDI_PRODUCT_ANALYTICS_CSV',
  KEYWORD_CSV: 'KEYWORD_CSV',
  PRODUCT_CSV: 'PRODUCT_CSV',
  SALES_CHANNEL_CSV: 'SALES_CHANNEL_CSV',
  VARIANT_CSV: 'VARIANT_CSV'
} as const;

export type ReportDocumentType = typeof ReportDocumentType[keyof typeof ReportDocumentType];
/** Report export type. */
export type ReportExport = {
  __typename?: 'ReportExport';
  createdAt: Scalars['DateTime']['output'];
  /** Present only when status is FAILED. Drives the client's recovery UX: GOOGLE_TOKEN_INVALID / GOOGLE_INSUFFICIENT_PERMISSION prompt a Google reconnect; UNKNOWN shows a generic failure. Null while PROCESSING / DONE. */
  failureReason?: Maybe<ReportExportFailureReason>;
  id: Scalars['ID']['output'];
  reportName: Scalars['String']['output'];
  status: ReportExportStatus;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** A stable reason code recorded when an export ends FAILED. GOOGLE_TOKEN_INVALID and GOOGLE_INSUFFICIENT_PERMISSION are recoverable by reconnecting the user's Google account; UNKNOWN covers any other failure. */
export const ReportExportFailureReason = {
  GOOGLE_INSUFFICIENT_PERMISSION: 'GOOGLE_INSUFFICIENT_PERMISSION',
  GOOGLE_TOKEN_INVALID: 'GOOGLE_TOKEN_INVALID',
  UNKNOWN: 'UNKNOWN'
} as const;

export type ReportExportFailureReason = typeof ReportExportFailureReason[keyof typeof ReportExportFailureReason];
/** Filter input for report exports. */
export type ReportExportFilterInput = {
  status?: InputMaybe<ReportExportStatus>;
};

/** Report export list type. */
export type ReportExportList = PaginatedList & {
  __typename?: 'ReportExportList';
  items: Array<ReportExport>;
  totalCount: Scalars['Int']['output'];
};

/** Report export status enum. */
export const ReportExportStatus = {
  DONE: 'DONE',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING'
} as const;

export type ReportExportStatus = typeof ReportExportStatus[keyof typeof ReportExportStatus];
export type ReportListKvData = {
  __typename?: 'ReportListKVData';
  key: Scalars['String']['output'];
  value: Scalars['BigDecimal']['output'];
};

export type ReportListMeta = {
  __typename?: 'ReportListMeta';
  /** Length in this query */
  length: Scalars['Int']['output'];
  /** Page size */
  limit: Scalars['Int']['output'];
  /** Start position of this query */
  start: Scalars['Int']['output'];
  /** Total length of items including other pages */
  total: Scalars['Int']['output'];
};

export const ReportOrderStatus = {
  ORDERED: 'ORDERED',
  SHIPPED: 'SHIPPED'
} as const;

export type ReportOrderStatus = typeof ReportOrderStatus[keyof typeof ReportOrderStatus];
export type ReportSummaryComparisonData = {
  __typename?: 'ReportSummaryComparisonData';
  avgOrderValues: ReportCompareData;
  cancelAndOrRefund: ReportCompareData;
  cvr?: Maybe<ReportCompareData>;
  grossProfit?: Maybe<ReportCompareData>;
  grossProfitRate?: Maybe<ReportCompareData>;
  grossSales: ReportCompareData;
  marginalProfit?: Maybe<ReportCompareData>;
  marginalProfitRate?: Maybe<ReportCompareData>;
  netSales: ReportCompareData;
  orders: ReportCompareData;
  revenue: ReportCompareData;
  roas?: Maybe<ReportCompareData>;
  sessions?: Maybe<ReportCompareData>;
  totalSales: ReportCompareData;
};

export type ReportSummaryPayload = {
  __typename?: 'ReportSummaryPayload';
  comparisonSummary: ReportSummaryComparisonData;
  currency: ReportSupportedCurrency;
  tableSummary: SaleChannelReportSummaryData;
};

/** ISO 4217 currency code */
export const ReportSupportedCurrency = {
  /** United Arab Emirates dirham */
  AED: 'AED',
  /** Australian dollar */
  AUD: 'AUD',
  /** Bahraini Dinar */
  BHD: 'BHD',
  /** Brazilian real */
  BRL: 'BRL',
  /** Canadian dollar */
  CAD: 'CAD',
  /** Chinese yuan (Renminbi) */
  CNY: 'CNY',
  /** Egyptian Pound */
  EGP: 'EGP',
  /** Euro */
  EUR: 'EUR',
  /** United Kingdom Pound sterling */
  GBP: 'GBP',
  /** Hong Kong dollar */
  HKD: 'HKD',
  /** Indonesian rupiah */
  IDR: 'IDR',
  /** Indian rupee */
  INR: 'INR',
  /** Jordanian Dinar */
  JOD: 'JOD',
  /** Japanese yen */
  JPY: 'JPY',
  /** Cambodian riel */
  KHR: 'KHR',
  /** South Korean won */
  KRW: 'KRW',
  /** Kuwaiti dinar */
  KWD: 'KWD',
  /** Myanmar kyat */
  MMK: 'MMK',
  /** Mexican peso */
  MXN: 'MXN',
  /** Malaysian ringgit */
  MYR: 'MYR',
  /** Omani Rial */
  OMR: 'OMR',
  /** Philippine peso */
  PHP: 'PHP',
  /** Pakistani Rupee */
  PKR: 'PKR',
  /** Polish Zloty */
  PLN: 'PLN',
  /** Qatari Riyal */
  QAR: 'QAR',
  /** Saudi riyal */
  SAR: 'SAR',
  /** Swedish krona */
  SEK: 'SEK',
  /** Singapore dollar */
  SGD: 'SGD',
  /** Thai baht */
  THB: 'THB',
  /** Turkish lira */
  TRY: 'TRY',
  /** New Taiwan dollar */
  TWD: 'TWD',
  /** United States dollar */
  USD: 'USD',
  /** Vietnamese dong */
  VND: 'VND'
} as const;

export type ReportSupportedCurrency = typeof ReportSupportedCurrency[keyof typeof ReportSupportedCurrency];
export const ReportTab = {
  ALL: 'ALL',
  MARKETPLACE: 'MARKETPLACE',
  STORE: 'STORE'
} as const;

export type ReportTab = typeof ReportTab[keyof typeof ReportTab];
export const Resource = {
  COURIER: 'COURIER',
  INBOUND: 'INBOUND',
  ORDER: 'ORDER',
  SKU: 'SKU'
} as const;

export type Resource = typeof Resource[keyof typeof Resource];
/** RGB color. */
export type RgbInput = {
  b: Scalars['Int']['input'];
  g: Scalars['Int']['input'];
  r: Scalars['Int']['input'];
};

export type RichMessage = {
  __typename?: 'RichMessage';
  imageUrl: Scalars['String']['output'];
  urlAction?: Maybe<LineUrlAction>;
};

export type RichMessageInput = {
  imageUrl: Scalars['String']['input'];
  urlAction?: InputMaybe<LineMessageUrlInput>;
};

export const RoomReplyMode = {
  TEXT: 'TEXT',
  VOICE: 'VOICE',
  VOICE_AND_TEXT: 'VOICE_AND_TEXT'
} as const;

export type RoomReplyMode = typeof RoomReplyMode[keyof typeof RoomReplyMode];
export type SaleChannel = {
  __typename?: 'SaleChannel';
  costIndex?: Maybe<SaleChannelCostIndexQueryPayload>;
  data: SaleChannelData;
  fileUploadStatus: FileUploadStatus;
  id: Scalars['Long']['output'];
  isActive: Scalars['Boolean']['output'];
  isManualChannel: Scalars['Boolean']['output'];
  logisticChannel?: Maybe<LogisticChannel>;
  logisticChannelFormStatus?: Maybe<ChannelFormStatus>;
  logisticChannelShopifyCarrierService?: Maybe<ShopifyCarrierService>;
  logisticChannelShopifyCarrierServiceCondition?: Maybe<ShopifyCarrierServiceCondition>;
  store: MdStore;
  type: MarketplaceSaleChannelType;
};

export type SaleChannelCostIndexFilterInput = {
  masterDataStoreId?: InputMaybe<Scalars['Long']['input']>;
};

export type SaleChannelCostIndexPayload = {
  __typename?: 'SaleChannelCostIndexPayload';
  ok: Scalars['Boolean']['output'];
};

export type SaleChannelCostIndexPayloadList = {
  __typename?: 'SaleChannelCostIndexPayloadList';
  items: Array<SaleChannelCostIndexQueryPayload>;
  meta: ReportListMeta;
};

export type SaleChannelCostIndexQueryPayload = {
  __typename?: 'SaleChannelCostIndexQueryPayload';
  commissionFeePercentage?: Maybe<Scalars['BigDecimal']['output']>;
  creditCardFeePercentage?: Maybe<Scalars['BigDecimal']['output']>;
  currency?: Maybe<ReportSupportedCurrency>;
  flatFee?: Maybe<Scalars['BigDecimal']['output']>;
  freeShippingFeeAdjustmentPercentage?: Maybe<Scalars['BigDecimal']['output']>;
  masterDataStoreId?: Maybe<Scalars['Long']['output']>;
  plan?: Maybe<SaleChannelPlanType>;
  rakutenPayFeePercentage?: Maybe<Scalars['BigDecimal']['output']>;
  rakutenSystemFeePercentage?: Maybe<Scalars['BigDecimal']['output']>;
  referralFeeSoldPercentage?: Maybe<Scalars['BigDecimal']['output']>;
  resourceBurdenRatioPercentage?: Maybe<Scalars['BigDecimal']['output']>;
  saleChannelId: Scalars['Long']['output'];
  taxRatePercentage?: Maybe<Scalars['BigDecimal']['output']>;
  transactionFeePercentage?: Maybe<Scalars['BigDecimal']['output']>;
};

export const SaleChannelCostIndexSortByField = {
  CREATED_AT: 'CREATED_AT',
  SALE_CHANNEL_ID: 'SALE_CHANNEL_ID',
  UPDATED_AT: 'UPDATED_AT'
} as const;

export type SaleChannelCostIndexSortByField = typeof SaleChannelCostIndexSortByField[keyof typeof SaleChannelCostIndexSortByField];
export type SaleChannelCostIndexSortByInput = {
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  field: SaleChannelCostIndexSortByField;
};

export type SaleChannelData = AmazonSaleChannelData | EmptySaleChannelData | LazadaSaleChannelData | MomoSaleChannelData | Qoo10SaleChannelData | RakutenSaleChannelData | ShopeeSaleChannelData | ShopifySaleChannelData | TikTokSaleChannelData | TokopediaSaleChannelData | YahooSaleChannelData;

export type SaleChannelForManualOrder = {
  __typename?: 'SaleChannelForManualOrder';
  hasAnyLogiConnection: Scalars['Boolean']['output'];
  /** null when Manual channel is not yet created */
  saleChannelId?: Maybe<Scalars['Long']['output']>;
  saleChannelType: MarketplaceSaleChannelType;
};

export type SaleChannelPlan = {
  __typename?: 'SaleChannelPlan';
  description: Scalars['String']['output'];
  price: Scalars['String']['output'];
  value: SaleChannelPlanType;
};

export type SaleChannelPlanPayload = {
  __typename?: 'SaleChannelPlanPayload';
  amount: Scalars['BigDecimal']['output'];
  currency: ReportSupportedCurrency;
  price: Scalars['String']['output'];
  unit: SaleChannelPlanUnit;
  value: SaleChannelPlanType;
};

export const SaleChannelPlanType = {
  AmazonIndividual: 'AmazonIndividual',
  AmazonProfessional: 'AmazonProfessional',
  RakutenGanbare: 'RakutenGanbare',
  RakutenMegaShop: 'RakutenMegaShop',
  RakutenStandard: 'RakutenStandard',
  Shopify: 'Shopify',
  ShopifyAdvanced: 'ShopifyAdvanced',
  ShopifyBasic: 'ShopifyBasic',
  ShopifyPlus: 'ShopifyPlus'
} as const;

export type SaleChannelPlanType = typeof SaleChannelPlanType[keyof typeof SaleChannelPlanType];
export const SaleChannelPlanUnit = {
  MONTH: 'MONTH',
  UNIT_SOLD: 'UNIT_SOLD'
} as const;

export type SaleChannelPlanUnit = typeof SaleChannelPlanUnit[keyof typeof SaleChannelPlanUnit];
export type SaleChannelProduct = {
  __typename?: 'SaleChannelProduct';
  availableStock?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['Url']['output']>;
  name: Scalars['String']['output'];
  saleChannelType: AnyChatSaleChannelType;
};

export type SaleChannelReportChartData = {
  __typename?: 'SaleChannelReportChartData';
  advertisingCost: Scalars['BigDecimal']['output'];
  advertisingRevenue: Scalars['BigDecimal']['output'];
  avgOrderValues: Scalars['BigDecimal']['output'];
  cancelAndOrRefund: Scalars['BigDecimal']['output'];
  channel?: Maybe<SaleChannelType>;
  commissionFee: Scalars['BigDecimal']['output'];
  cvr?: Maybe<Scalars['BigDecimal']['output']>;
  dailySales?: Maybe<Scalars['BigDecimal']['output']>;
  day?: Maybe<Scalars['LocalDate']['output']>;
  discountRate: Scalars['BigDecimal']['output'];
  discounts: Scalars['BigDecimal']['output'];
  dow?: Maybe<Scalars['Int']['output']>;
  grossProfit: Scalars['BigDecimal']['output'];
  grossProfitRate: Scalars['BigDecimal']['output'];
  grossRevenue: Scalars['BigDecimal']['output'];
  grossSales: Scalars['BigDecimal']['output'];
  marginalProfit: Scalars['BigDecimal']['output'];
  marginalProfitRate: Scalars['BigDecimal']['output'];
  marketplaceCalendarEvents?: Maybe<Array<MarketplaceCalendarEventPayload>>;
  masterDataStoreId?: Maybe<Scalars['Long']['output']>;
  merchandiseCost: Scalars['BigDecimal']['output'];
  netSales: Scalars['BigDecimal']['output'];
  orders: Scalars['Long']['output'];
  revenue: Scalars['BigDecimal']['output'];
  roas: Scalars['BigDecimal']['output'];
  sessions: Scalars['Long']['output'];
  shippingFee: Scalars['BigDecimal']['output'];
  storeName?: Maybe<Scalars['String']['output']>;
  totalSales: Scalars['BigDecimal']['output'];
  yearMonth?: Maybe<Scalars['YearMonth']['output']>;
  yearWeek?: Maybe<Scalars['LocalDate']['output']>;
};

export type SaleChannelReportChartPayload = {
  __typename?: 'SaleChannelReportChartPayload';
  channels: Array<SaleChannelType>;
  currency: ReportSupportedCurrency;
  list: Array<SaleChannelReportChartData>;
  stores: Array<SaleChannelReportChartStore>;
  totalItems: Scalars['Int']['output'];
};

export type SaleChannelReportChartStore = {
  __typename?: 'SaleChannelReportChartStore';
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type SaleChannelReportPayload = {
  __typename?: 'SaleChannelReportPayload';
  currency: ReportSupportedCurrency;
  list: Array<SaleChannelReportTableData>;
  totalItems: Scalars['Int']['output'];
};

export const SaleChannelReportSortByField = {
  ADVERTISING_COST: 'ADVERTISING_COST',
  ADVERTISING_REVENUE: 'ADVERTISING_REVENUE',
  AVG_ORDER_VALUES: 'AVG_ORDER_VALUES',
  COMMISSION_FEE: 'COMMISSION_FEE',
  CVR: 'CVR',
  DISCOUNTS: 'DISCOUNTS',
  DISCOUNTS_RATE: 'DISCOUNTS_RATE',
  GROSS_PROFIT: 'GROSS_PROFIT',
  GROSS_PROFIT_RATE: 'GROSS_PROFIT_RATE',
  GROSS_REVENUE: 'GROSS_REVENUE',
  GROSS_SALES: 'GROSS_SALES',
  MARGINAL_PROFIT: 'MARGINAL_PROFIT',
  MARGINAL_PROFIT_RATE: 'MARGINAL_PROFIT_RATE',
  METRIC: 'METRIC',
  NET_SALES: 'NET_SALES',
  ORDERS: 'ORDERS',
  RETURN_CANCEL: 'RETURN_CANCEL',
  REVENUE: 'REVENUE',
  ROAS: 'ROAS',
  SESSIONS: 'SESSIONS',
  SHIPPING_FEE: 'SHIPPING_FEE',
  TOTAL_SALES: 'TOTAL_SALES',
  UNIT_COST: 'UNIT_COST'
} as const;

export type SaleChannelReportSortByField = typeof SaleChannelReportSortByField[keyof typeof SaleChannelReportSortByField];
export type SaleChannelReportSummaryData = {
  __typename?: 'SaleChannelReportSummaryData';
  advertisingCost?: Maybe<Scalars['BigDecimal']['output']>;
  advertisingRevenue?: Maybe<Scalars['BigDecimal']['output']>;
  avgOrderValues: Scalars['BigDecimal']['output'];
  cancelAndOrRefund: Scalars['BigDecimal']['output'];
  commissionFee?: Maybe<Scalars['BigDecimal']['output']>;
  cvr?: Maybe<Scalars['BigDecimal']['output']>;
  discountRate: Scalars['BigDecimal']['output'];
  discounts: Scalars['BigDecimal']['output'];
  grossProfit: Scalars['BigDecimal']['output'];
  grossProfitRate?: Maybe<Scalars['BigDecimal']['output']>;
  grossRevenue: Scalars['BigDecimal']['output'];
  grossSales: Scalars['BigDecimal']['output'];
  marginalProfit: Scalars['BigDecimal']['output'];
  marginalProfitRate?: Maybe<Scalars['BigDecimal']['output']>;
  merchandiseCost?: Maybe<Scalars['BigDecimal']['output']>;
  netSales: Scalars['BigDecimal']['output'];
  orders: Scalars['Long']['output'];
  revenue: Scalars['BigDecimal']['output'];
  roas?: Maybe<Scalars['BigDecimal']['output']>;
  sessions?: Maybe<Scalars['Long']['output']>;
  shippingFee: Scalars['BigDecimal']['output'];
  totalSales: Scalars['BigDecimal']['output'];
};

export type SaleChannelReportSummaryFilterInput = {
  adsMetricsType?: InputMaybe<AdsMetricsType>;
  endDate: Scalars['ZonedDatetime']['input'];
  marketplaces: Array<SaleChannelType>;
  masterDataAccountId?: InputMaybe<Scalars['Long']['input']>;
  masterDataAccountIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  masterDataStoreIds: Array<Scalars['Long']['input']>;
  orderStatus: ReportOrderStatus;
  sortBy?: InputMaybe<SaleChannelReportSortByField>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['ZonedDatetime']['input'];
  tab: ReportTab;
};

export type SaleChannelReportTableData = {
  __typename?: 'SaleChannelReportTableData';
  advertisingCost?: Maybe<Scalars['BigDecimal']['output']>;
  advertisingRevenue?: Maybe<Scalars['BigDecimal']['output']>;
  avgOrderValues: Scalars['BigDecimal']['output'];
  cancelAndOrRefund: Scalars['BigDecimal']['output'];
  commissionFee?: Maybe<Scalars['BigDecimal']['output']>;
  cvr?: Maybe<Scalars['BigDecimal']['output']>;
  discountRate: Scalars['BigDecimal']['output'];
  discounts: Scalars['BigDecimal']['output'];
  grossProfit: Scalars['BigDecimal']['output'];
  grossProfitRate?: Maybe<Scalars['BigDecimal']['output']>;
  grossRevenue: Scalars['BigDecimal']['output'];
  grossSales: Scalars['BigDecimal']['output'];
  marginalProfit: Scalars['BigDecimal']['output'];
  marginalProfitRate?: Maybe<Scalars['BigDecimal']['output']>;
  merchandiseCost?: Maybe<Scalars['BigDecimal']['output']>;
  metric: Scalars['String']['output'];
  netSales: Scalars['BigDecimal']['output'];
  orders: Scalars['Long']['output'];
  revenue: Scalars['BigDecimal']['output'];
  roas?: Maybe<Scalars['BigDecimal']['output']>;
  sessions?: Maybe<Scalars['Long']['output']>;
  shippingFee: Scalars['BigDecimal']['output'];
  totalSales: Scalars['BigDecimal']['output'];
};

export type SaleChannelReportTableFilterInput = {
  adsMetricsType?: InputMaybe<AdsMetricsType>;
  chartTab?: InputMaybe<ReportChartTab>;
  dimensions: ReportDimensions;
  endDate: Scalars['ZonedDatetime']['input'];
  marketplaces: Array<SaleChannelType>;
  masterDataAccountId?: InputMaybe<Scalars['Long']['input']>;
  masterDataAccountIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  masterDataStoreIds: Array<Scalars['Long']['input']>;
  orderStatus: ReportOrderStatus;
  sortBy?: InputMaybe<SaleChannelReportSortByField>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['ZonedDatetime']['input'];
  tab: ReportTab;
};

export type SaleChannelSaveInput = {
  commissionFeePercentage?: InputMaybe<Scalars['BigDecimal']['input']>;
  creditCardFeePercentage?: InputMaybe<Scalars['BigDecimal']['input']>;
  flatFee?: InputMaybe<Scalars['BigDecimal']['input']>;
  freeShippingFeeAdjustmentPercentage?: InputMaybe<Scalars['BigDecimal']['input']>;
  masterDataStoreId: Scalars['Long']['input'];
  plan?: InputMaybe<SaleChannelPlanType>;
  rakutenPayFeePercentage?: InputMaybe<Scalars['BigDecimal']['input']>;
  rakutenSystemFeePercentage?: InputMaybe<Scalars['BigDecimal']['input']>;
  referralFeeSoldPercentage?: InputMaybe<Scalars['BigDecimal']['input']>;
  resourceBurdenRatioPercentage?: InputMaybe<Scalars['BigDecimal']['input']>;
  saleChannelId: Scalars['Long']['input'];
  saleChannelType: SaleChannelType;
  taxRatePercentage: Scalars['BigDecimal']['input'];
  transactionFeePercentage?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type SaleChannelSpecificData = LazadaSpecificData | ManualsSpecificData | ShopifySpecificData;

export type SaleChannelSpecificProductData = ShopifySpecificProductData;

export const SaleChannelSyncStatus = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS'
} as const;

export type SaleChannelSyncStatus = typeof SaleChannelSyncStatus[keyof typeof SaleChannelSyncStatus];
export type SaleChannelSyncSummary = {
  __typename?: 'SaleChannelSyncSummary';
  action: Action;
  errors?: Maybe<Array<Scalars['Map']['output']>>;
  saleChannelTypes: Array<MarketplaceSaleChannelType>;
  status: SaleChannelSyncStatus;
};

export type SaleChannelSyncSummaryList = {
  __typename?: 'SaleChannelSyncSummaryList';
  saleChannelSyncs: Array<SaleChannelSyncSummary>;
};

export const SaleChannelType = {
  AmazonSellerCentral: 'AmazonSellerCentral',
  AuPayMarket: 'AuPayMarket',
  FacebookShop: 'FacebookShop',
  Lazada: 'Lazada',
  Magaseek: 'Magaseek',
  MakeshopByGmo: 'MakeshopByGmo',
  Manual: 'Manual',
  Momo: 'Momo',
  Qoo10: 'Qoo10',
  Rakuten: 'Rakuten',
  RakutenFashion: 'RakutenFashion',
  Shopee: 'Shopee',
  Shopify: 'Shopify',
  Shoplist: 'Shoplist',
  Stores: 'Stores',
  SuperDelivery: 'SuperDelivery',
  TikTok: 'TikTok',
  Tokopedia: 'Tokopedia',
  Yahoo: 'Yahoo',
  Zozotown: 'Zozotown'
} as const;

export type SaleChannelType = typeof SaleChannelType[keyof typeof SaleChannelType];
export const SalesChannelType = {
  BYTEPLUS: 'BYTEPLUS',
  CUSTOM: 'CUSTOM',
  FACEBOOK: 'FACEBOOK',
  MOMO: 'MOMO',
  RAKUTEN: 'RAKUTEN',
  SHOPEE: 'SHOPEE',
  TIKTOK: 'TIKTOK'
} as const;

export type SalesChannelType = typeof SalesChannelType[keyof typeof SalesChannelType];
export type SaveDdiProductStatusInput = {
  isListed: Scalars['Boolean']['input'];
  productVariantId: Scalars['Long']['input'];
  warehouseData: Array<SaveDdiProductWarehouseStatusInput>;
};

export type SaveDdiProductStatusListInput = {
  masterDataStoreId: Scalars['Long']['input'];
  products: Array<SaveDdiProductStatusInput>;
};

export type SaveDdiProductWarehouseStatusInput = {
  isActive: Scalars['Boolean']['input'];
  warehouse: DdiWarehouse;
};

export type SaveGreetingMessageDraftRequest = {
  messageItems: Array<LineMessageItemInput>;
  storeId: Scalars['Long']['input'];
};

export type SaveGreetingMessageRequest = {
  enable: Scalars['Boolean']['input'];
  messageItems: Array<LineMessageItemInput>;
  storeId: Scalars['Long']['input'];
};

export type SaveMessengerOptInMessageRequestInput = {
  /**
   * Text that appears on call to action button
   * ALLOW – set optin message button text to “Allow messages”
   * GET – set optin message button text to “Get messages”
   * GET_UPDATES – set optin message button text to “Get updates”, this is also default if notification_messages_cta_text is not set
   * OPT_IN – set optin message button text to “Opt in to messages”
   * SIGN_UP – set optin message button text to “Sign up for messages”
   */
  buttonText: OptInCallToActionText;
  enabled: Scalars['Boolean']['input'];
  imageUrl?: InputMaybe<Scalars['Url']['input']>;
  storeId: Scalars['Long']['input'];
  title: Scalars['String']['input'];
};

export type Schedule = {
  __typename?: 'Schedule';
  datetime: Scalars['OffsetDateTime']['output'];
};

export const ScraperIntegrationStatus = {
  DONE: 'DONE',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING'
} as const;

export type ScraperIntegrationStatus = typeof ScraperIntegrationStatus[keyof typeof ScraperIntegrationStatus];
/** Scraper sync status for each sales channel. */
export type ScraperSyncStatus = {
  __typename?: 'ScraperSyncStatus';
  /** Most recent sync timestamp across all channels. */
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  /** Last sync timestamp for Shopee. */
  shopeeLastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  /** Last sync timestamp for TikTok. */
  tiktokLastSyncAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Script type. */
export type Script = {
  __typename?: 'Script';
  commentsPerHour: Scalars['BigDecimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  gmvPerHour: AnyLiveMoney;
  id: Scalars['ID']['output'];
  itemsSoldPerHour: Scalars['BigDecimal']['output'];
  language: ScriptLanguage;
  name: Scalars['String']['output'];
  ordersConfirmedPerHour: Scalars['BigDecimal']['output'];
  ordersCreatedPerHour: Scalars['BigDecimal']['output'];
  store?: Maybe<MdStore>;
  storeId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versions: Array<ScriptVersion>;
  viewsPerHour: Scalars['BigDecimal']['output'];
};

/** Input for clearing all TTS IDs from script content. */
export type ScriptContentClearTtsInput = {
  /** Script version ID to clear TTS IDs for. */
  scriptVersionId: Scalars['ID']['input'];
};

/** Input for creating script content. */
export type ScriptContentCreateInput = {
  /** Content for the script section. */
  content: Scalars['String']['input'];
  /** Script version ID to associate the content with. */
  scriptVersionId: Scalars['ID']['input'];
  /** Title for the script section. */
  title: Scalars['String']['input'];
  /** TTS speed for the script section (1.0 = normal speed, range: 0.5 to 2.0). */
  ttsSpeed?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** Output type for a script content. */
export type ScriptContentOutput = {
  __typename?: 'ScriptContentOutput';
  /** Script content ID. */
  id: Scalars['ID']['output'];
};

/** Input for reordering script content. */
export type ScriptContentReorderInput = {
  /** Ordered list of script content IDs. Content not in this list will be deleted. */
  scriptContentIds: Array<Scalars['String']['input']>;
  /** Script version ID. */
  scriptVersionId: Scalars['ID']['input'];
};

/** Input for updating script content. */
export type ScriptContentUpdateInput = {
  /** New content for the script section. */
  content: Scalars['String']['input'];
  /** Script content ID to update. */
  id: Scalars['String']['input'];
  /** New title for the script section. */
  title: Scalars['String']['input'];
  /** TTS emotion override for the script section (happy, sad, angry, fearful, disgusted, surprised, neutral). Null leaves the existing value unchanged. */
  ttsEmotion?: InputMaybe<Scalars['String']['input']>;
  /** TTS pitch override for the script section (0 = normal pitch, range: -12 to 12). Null leaves the existing value unchanged. */
  ttsPitch?: InputMaybe<Scalars['Int']['input']>;
  /** TTS speed for the script section (1.0 = normal speed, range: 0.5 to 2.0). */
  ttsSpeed?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** Create input for a script. */
export type ScriptCreateInput = {
  language: ScriptLanguage;
  name: Scalars['String']['input'];
  storeId: Scalars['ID']['input'];
};

/** Delete bulk input for multiple scripts. */
export type ScriptDeleteBulkInput = {
  ids: Array<Scalars['ID']['input']>;
};

/** Script profile type. */
export type ScriptDetails = {
  __typename?: 'ScriptDetails';
  brandBackground: Scalars['String']['output'];
  brandVoiceGuidelines: Scalars['String']['output'];
  liveObjective: Scalars['String']['output'];
  liveStructure: Scalars['String']['output'];
  liveStyle: Scalars['String']['output'];
  liveTimeSlot: Scalars['String']['output'];
};

/** Input for generating a script profile. */
export type ScriptDetailsGenerateInput = {
  language: ScriptLanguage;
  products: Array<AnyLiveProductCreateInput>;
};

/** Duplicate bulk input for multiple scripts. */
export type ScriptDuplicateBulkInput = {
  ids: Array<Scalars['ID']['input']>;
  option: ScriptDuplicateOption;
};

/** Options for script duplication. */
export const ScriptDuplicateOption = {
  ALL_VERSIONS: 'ALL_VERSIONS',
  ONLY_LATEST_VERSION: 'ONLY_LATEST_VERSION'
} as const;

export type ScriptDuplicateOption = typeof ScriptDuplicateOption[keyof typeof ScriptDuplicateOption];
/** Filter input for script export operations. */
export type ScriptExportFilterInput = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  commentsPerHour?: InputMaybe<BigDecimalRangeInput>;
  createdAt?: InputMaybe<DateTimeRangeInput>;
  gmvPerHour?: InputMaybe<BigDecimalRangeInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemsSoldPerHour?: InputMaybe<BigDecimalRangeInput>;
  languages?: InputMaybe<Array<ScriptLanguage>>;
  ordersConfirmedPerHour?: InputMaybe<BigDecimalRangeInput>;
  ordersCreatedPerHour?: InputMaybe<BigDecimalRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  viewsPerHour?: InputMaybe<BigDecimalRangeInput>;
};

/** Filter input for scripts. */
export type ScriptFilterInput = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  commentsPerHour?: InputMaybe<BigDecimalRangeInput>;
  createdAt?: InputMaybe<DateTimeRangeInput>;
  gmvPerHour?: InputMaybe<BigDecimalRangeInput>;
  itemsSoldPerHour?: InputMaybe<BigDecimalRangeInput>;
  languages?: InputMaybe<Array<ScriptLanguage>>;
  ordersConfirmedPerHour?: InputMaybe<BigDecimalRangeInput>;
  ordersCreatedPerHour?: InputMaybe<BigDecimalRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  viewsPerHour?: InputMaybe<BigDecimalRangeInput>;
};

/** Input for generating a script. */
export type ScriptGenerateInput = {
  brandBackground?: InputMaybe<Scalars['String']['input']>;
  brandVoiceGuidelines?: InputMaybe<Scalars['String']['input']>;
  language: ScriptLanguage;
  liveObjective?: InputMaybe<Scalars['String']['input']>;
  liveStructure?: InputMaybe<Scalars['String']['input']>;
  liveStyle?: InputMaybe<Scalars['String']['input']>;
  liveTimeSlot?: InputMaybe<Scalars['String']['input']>;
  products: Array<AnyLiveProductCreateInput>;
};

/** Script generation status. Deprecated: Use LiveAssetScriptGenerationStatus instead. */
export const ScriptGenerationStatus = {
  DONE: 'DONE',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING'
} as const;

export type ScriptGenerationStatus = typeof ScriptGenerationStatus[keyof typeof ScriptGenerationStatus];
/** Input for submitting script generation. */
export type ScriptGenerationSubmitInput = {
  /** Brand background. */
  brandBackground?: InputMaybe<Scalars['String']['input']>;
  /** Brand voice guidelines. */
  brandVoiceGuidelines?: InputMaybe<Scalars['String']['input']>;
  /** Language for the script. */
  language: ScriptLanguage;
  /** Live objective. */
  liveObjective?: InputMaybe<Scalars['String']['input']>;
  /** Live structure. */
  liveStructure?: InputMaybe<Scalars['String']['input']>;
  /** Live style. */
  liveStyle?: InputMaybe<Scalars['String']['input']>;
  /** Live time slot. */
  liveTimeSlot?: InputMaybe<Scalars['String']['input']>;
  /** Products to include in the script. */
  products: Array<AnyLiveProductCreateInput>;
  /** Script version ID to generate script for. */
  scriptVersionId: Scalars['String']['input'];
};

/** A single Script Optimization Insight card. */
export type ScriptInsightCardOutput = {
  __typename?: 'ScriptInsightCardOutput';
  /** Number of 5-min segments this category appeared in. */
  appearances: Scalars['Int']['output'];
  /** Script category name (exact). */
  category: Scalars['String']['output'];
  /** Category GMV in USD. */
  gmv: Scalars['Float']['output'];
  /** Same GMV in the session's own currency (raw pre-FX, not converted from `gmv`). Display this with the session's `currency`. Null only for cards cached before this field existed — fall back to `gmv` in USD there, never to zero. */
  gmvLocal?: Maybe<Scalars['Float']['output']>;
  /** Category GMV as a percentage of the session header GMV (dashboard_session_list.gmv_usd). Does not sum to 100% — unlabelled/uncategorized GMV is the shortfall. */
  gmvPct: Scalars['Float']['output'];
  /** 2-3 sentence LLM insight. */
  insight: Scalars['String']['output'];
  /** Parent script phase (null when the model emitted no phase). */
  phase?: Maybe<Scalars['String']['output']>;
  /** "increase" (scale up) or "reduce". */
  type: Scalars['String']['output'];
};

/** Supported language for AnyLive script. */
export const ScriptLanguage = {
  EN_US: 'EN_US',
  FIL_PH: 'FIL_PH',
  HI_IN: 'HI_IN',
  ID_ID: 'ID_ID',
  JA_JP: 'JA_JP',
  MS_MY: 'MS_MY',
  TH_TH: 'TH_TH',
  VI_VN: 'VI_VN',
  ZH_CN: 'ZH_CN',
  ZH_TW: 'ZH_TW'
} as const;

export type ScriptLanguage = typeof ScriptLanguage[keyof typeof ScriptLanguage];
/** Script list type. */
export type ScriptList = PaginatedList & {
  __typename?: 'ScriptList';
  items: Array<Script>;
  totalCount: Scalars['Int']['output'];
};

/** Output type for a script. */
export type ScriptOutput = {
  __typename?: 'ScriptOutput';
  /** Script ID. */
  id: Scalars['ID']['output'];
  /** @deprecated Use liveAsset instead, replace with liveAsset */
  script?: Maybe<LiveAsset>;
};

/** Script section type. Deprecated: Use LiveAssetScriptSection instead. */
export type ScriptSection = {
  __typename?: 'ScriptSection';
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  orderIndex: Scalars['Int']['output'];
  scriptVersionId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  /** TTS emotion override for this script section (null means inherit global default). */
  ttsEmotion?: Maybe<Scalars['String']['output']>;
  ttsId?: Maybe<Scalars['ID']['output']>;
  /** TTS playback speed (1.0 = normal, 0.5 = half speed, 2.0 = double speed). */
  ttsSpeed: Scalars['BigDecimal']['output'];
};

/** Create input for script section. */
export type ScriptSectionInput = {
  content: Scalars['String']['input'];
  title: Scalars['String']['input'];
  /** Optional TTS generation ID to associate with this script section. */
  ttsId?: InputMaybe<Scalars['ID']['input']>;
};

/** Sort field for scripts. */
export const ScriptSortField = {
  COMMENTS_PER_HOUR: 'COMMENTS_PER_HOUR',
  CREATED_AT: 'CREATED_AT',
  GMV_PER_HOUR: 'GMV_PER_HOUR',
  ID: 'ID',
  ITEMS_SOLD_PER_HOUR: 'ITEMS_SOLD_PER_HOUR',
  NAME: 'NAME',
  ORDERS_CONFIRMED_PER_HOUR: 'ORDERS_CONFIRMED_PER_HOUR',
  ORDERS_CREATED_PER_HOUR: 'ORDERS_CREATED_PER_HOUR',
  UPDATED_AT: 'UPDATED_AT',
  VIEWS_PER_HOUR: 'VIEWS_PER_HOUR'
} as const;

export type ScriptSortField = typeof ScriptSortField[keyof typeof ScriptSortField];
/** Sort input for scripts. */
export type ScriptSortInput = {
  /** Default is descending. */
  direction?: InputMaybe<SortDirection>;
  /** Default is ID. */
  field?: InputMaybe<ScriptSortField>;
};

/** Update input for a script. */
export type ScriptUpdateInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Script version. Deprecated: Use LiveAssetVersion instead. */
export type ScriptVersion = {
  __typename?: 'ScriptVersion';
  brandBackground?: Maybe<Scalars['String']['output']>;
  brandVoiceGuidelines?: Maybe<Scalars['String']['output']>;
  commentsPerHour: Scalars['BigDecimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultTtsPitch: Scalars['Int']['output'];
  defaultTtsSpeed: Scalars['BigDecimal']['output'];
  defaultVoiceId?: Maybe<Scalars['ID']['output']>;
  /** General FAQ content. Only fetched when explicitly requested. */
  generalFaqs: Array<GeneralFaq>;
  /** Generated script content. Only fetched when explicitly requested. */
  generatedScript: Array<ScriptSection>;
  gmvPerHour: AnyLiveMoney;
  hostIdentity?: Maybe<Scalars['String']['output']>;
  hostIdentityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemsSoldPerHour: Scalars['BigDecimal']['output'];
  knowledgeBase?: Maybe<Scalars['String']['output']>;
  latestLiveStream?: Maybe<LiveStream>;
  liveObjective?: Maybe<Scalars['String']['output']>;
  liveObjectiveType?: Maybe<Scalars['String']['output']>;
  liveStructure?: Maybe<Scalars['String']['output']>;
  liveStyle?: Maybe<Scalars['String']['output']>;
  liveTimeSlot?: Maybe<Scalars['String']['output']>;
  liveTimeSlotType?: Maybe<Scalars['String']['output']>;
  ordersConfirmedPerHour: Scalars['BigDecimal']['output'];
  ordersCreatedPerHour: Scalars['BigDecimal']['output'];
  products: Array<AnyLiveProduct>;
  /** @deprecated Use liveAsset instead, replace with liveAsset */
  script: LiveAsset;
  scriptGenerationStatus?: Maybe<ScriptGenerationStatus>;
  scriptId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versionName: Scalars['String']['output'];
  viewsPerHour: Scalars['BigDecimal']['output'];
};

/** Delete bulk input for multi script versions. */
export type ScriptVersionDeleteBulkInput = {
  /** List of script version IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Duplicate bulk input for multiple script versions. */
export type ScriptVersionDuplicateBulkInput = {
  /** List of script version IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Duplicate input for a script version. */
export type ScriptVersionDuplicateInput = {
  /** Script version ID */
  id: Scalars['ID']['input'];
  versionName: Scalars['String']['input'];
};

/** Filter input for script version export operations. */
export type ScriptVersionExportFilterInput = {
  commentsPerHour?: InputMaybe<BigDecimalRangeInput>;
  createdAt?: InputMaybe<DateTimeRangeInput>;
  gmvPerHour?: InputMaybe<BigDecimalRangeInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemsSoldPerHour?: InputMaybe<BigDecimalRangeInput>;
  ordersConfirmedPerHour?: InputMaybe<BigDecimalRangeInput>;
  ordersCreatedPerHour?: InputMaybe<BigDecimalRangeInput>;
  scriptId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  viewsPerHour?: InputMaybe<BigDecimalRangeInput>;
};

/** Filter input for scriptVersions. */
export type ScriptVersionFilterInput = {
  commentsPerHour?: InputMaybe<BigDecimalRangeInput>;
  createdAt?: InputMaybe<DateTimeRangeInput>;
  gmvPerHour?: InputMaybe<BigDecimalRangeInput>;
  itemsSoldPerHour?: InputMaybe<BigDecimalRangeInput>;
  ordersConfirmedPerHour?: InputMaybe<BigDecimalRangeInput>;
  ordersCreatedPerHour?: InputMaybe<BigDecimalRangeInput>;
  scriptId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  viewsPerHour?: InputMaybe<BigDecimalRangeInput>;
};

/** Script version list type. Deprecated: Use LiveAssetVersionList instead. */
export type ScriptVersionList = PaginatedList & {
  __typename?: 'ScriptVersionList';
  items: Array<ScriptVersion>;
  totalCount: Scalars['Int']['output'];
};

/** Output type for a script version. */
export type ScriptVersionOutput = {
  __typename?: 'ScriptVersionOutput';
  /** Script version ID. */
  id: Scalars['ID']['output'];
  /** @deprecated Use liveAssetVersion instead, replace with liveAssetVersion */
  scriptVersion?: Maybe<ScriptVersion>;
};

/** Sort field for script versions. */
export const ScriptVersionSortField = {
  COMMENTS_PER_HOUR: 'COMMENTS_PER_HOUR',
  CREATED_AT: 'CREATED_AT',
  GMV_PER_HOUR: 'GMV_PER_HOUR',
  ID: 'ID',
  ITEMS_SOLD_PER_HOUR: 'ITEMS_SOLD_PER_HOUR',
  ORDERS_CONFIRMED_PER_HOUR: 'ORDERS_CONFIRMED_PER_HOUR',
  ORDERS_CREATED_PER_HOUR: 'ORDERS_CREATED_PER_HOUR',
  UPDATED_AT: 'UPDATED_AT',
  VERSION_NAME: 'VERSION_NAME',
  VIEWS_PER_HOUR: 'VIEWS_PER_HOUR'
} as const;

export type ScriptVersionSortField = typeof ScriptVersionSortField[keyof typeof ScriptVersionSortField];
/** Sort input for script versions. */
export type ScriptVersionSortInput = {
  /** Default is descending. */
  direction?: InputMaybe<SortDirection>;
  /** Default is ID. */
  field?: InputMaybe<ScriptVersionSortField>;
};

/** Update input for a script version. */
export type ScriptVersionUpdateInput = {
  brandBackground?: InputMaybe<Scalars['String']['input']>;
  brandVoiceGuidelines?: InputMaybe<Scalars['String']['input']>;
  /** Default TTS speed for the script version (1.0 = normal speed, range: 0.5 to 2.0). */
  defaultTtsSpeed?: InputMaybe<Scalars['BigDecimal']['input']>;
  defaultVoiceId?: InputMaybe<Scalars['ID']['input']>;
  /** Script sections. This field is deprecated - use scriptContentUpdate endpoint to update script content. */
  generatedScript?: InputMaybe<Array<ScriptSectionInput>>;
  hostIdentity?: InputMaybe<Scalars['String']['input']>;
  hostIdentityType?: InputMaybe<HostIdentityType>;
  id: Scalars['ID']['input'];
  knowledgeBase?: InputMaybe<Scalars['String']['input']>;
  liveObjective?: InputMaybe<Scalars['String']['input']>;
  liveObjectiveType?: InputMaybe<LiveObjectiveType>;
  liveStructure?: InputMaybe<Scalars['String']['input']>;
  liveStyle?: InputMaybe<Scalars['String']['input']>;
  liveTimeSlot?: InputMaybe<Scalars['String']['input']>;
  liveTimeSlotType?: InputMaybe<LiveTimeSlotType>;
  products: Array<AnyLiveProductCreateInput>;
  versionName: Scalars['String']['input'];
};

/** Input for updating a script version's version name. */
export type ScriptVersionUpdateVersionNameInput = {
  id: Scalars['ID']['input'];
  versionName: Scalars['String']['input'];
};

export type SearchMessageContentRequest = {
  keywords: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  storeId: Scalars['Long']['input'];
};

export type SelectDraftReplyRequest = {
  chatId: Scalars['String']['input'];
  draftId: Scalars['String']['input'];
};

export type SendBroadcastMessageRequestInput = {
  isTest: Scalars['Boolean']['input'];
  lineBroadcastMessageId: Scalars['String']['input'];
};

export type SendMessengerBroadcastMessageRequestInput = {
  isTest: Scalars['Boolean']['input'];
  messengerBroadcastId: Scalars['String']['input'];
};

export type SendMessengerBroadcastResponse = CompleteSendingMessengerBroadcastSuccess | FailToStartSendingMessengerBroadcastTooManyUnavailableCustomer | StartSendingMessengerBroadcastSuccess;

export const SendVerificationEmailStatus = {
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
} as const;

export type SendVerificationEmailStatus = typeof SendVerificationEmailStatus[keyof typeof SendVerificationEmailStatus];
export const SenderType = {
  AI: 'AI',
  HUMAN: 'HUMAN'
} as const;

export type SenderType = typeof SenderType[keyof typeof SenderType];
export type ServiceCodeInput = {
  dhlServiceCode?: InputMaybe<DhlServiceCode>;
  fedExServiceCode?: InputMaybe<FedExServiceCode>;
  japanPostServiceCode?: InputMaybe<JapanPostServiceCode>;
  upsServiceCode?: InputMaybe<UpsServiceCode>;
};

/** Filter input for session list. */
export type SessionListFilterInput = {
  livePlatform?: InputMaybe<LivePlatform>;
  search?: InputMaybe<Scalars['String']['input']>;
  startTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
};

/** One lip-synced preview video for a product in a composed session (feature 029). */
export type SessionPreviewVideoOutput = {
  __typename?: 'SessionPreviewVideoOutput';
  /** Playback duration of the preview video in milliseconds. */
  durationMs: Scalars['Long']['output'];
  /** Livestream room product this preview belongs to. */
  productId: Scalars['ID']['output'];
  /** Short-lived signed GCS URL to stream the preview video (AnyMind-controlled storage only, never a vendor/gs:// URL); null when the URL could not be generated. */
  videoSignedUrl?: Maybe<Scalars['String']['output']>;
};

/** Session-level summary of comment reply activity. */
export type SessionSummaryGql = {
  __typename?: 'SessionSummaryGql';
  anyliveRoomId: Scalars['ID']['output'];
  anyliveRoomName: Scalars['String']['output'];
  livePlatform: LivePlatform;
  markedThumbsDown: Scalars['Int']['output'];
  markedThumbsUp: Scalars['Int']['output'];
  platformRoomName: Scalars['String']['output'];
  platformSessionId: Scalars['String']['output'];
  /** Product switch replies. */
  productSwitches: Scalars['Int']['output'];
  sessionStartTime: Scalars['DateTime']['output'];
  /** Text replies (replyMode=TEXT and replyType≠NO_REPLY). */
  textReplies: Scalars['Int']['output'];
  /** Total comment records for this session. */
  totalComments: Scalars['Int']['output'];
  /** Voice replies (replyMode=VOICE and replyType≠NO_REPLY). */
  voiceReplies: Scalars['Int']['output'];
};

/** A paginated list of session summaries. */
export type SessionSummaryList = PaginatedList & {
  __typename?: 'SessionSummaryList';
  items: Array<SessionSummaryGql>;
  totalCount: Scalars['Int']['output'];
};

export type SessionsCsvFilterInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  saleChannelId?: InputMaybe<Scalars['Long']['input']>;
  startDate: Scalars['ZonedDatetime']['input'];
};

export type SessionsCsvPayload = {
  __typename?: 'SessionsCSVPayload';
  date: Scalars['LocalDate']['output'];
  sessions: Scalars['Long']['output'];
};

export type SessionsCsvPayloadList = {
  __typename?: 'SessionsCSVPayloadList';
  items: Array<SessionsCsvPayload>;
  meta: ReportListMeta;
};

export type SetCustomerTagsRequest = {
  customerId: Scalars['String']['input'];
  customerTagNames: Array<Scalars['String']['input']>;
};

/** Connect a momo live — and optionally more lives queued behind it — to a livestream room. */
export type SetMomoConnectionInput = {
  /** More lives to queue behind momoConnectionId in the same call. Each must list the same goodsCodes in the same order as momoConnectionId, and no two may overlap in time. Omit for none. */
  additionalMomoConnectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The MOMO livestream room to connect; it must not have products yet. */
  livestreamRoomId: Scalars['ID']['input'];
  /** The momo connection (live) to connect, taken from `momoConnection`. */
  momoConnectionId: Scalars['ID']['input'];
};

export type SetProductItem = {
  __typename?: 'SetProductItem';
  productVariantId: Scalars['Long']['output'];
  quantity: Scalars['Int']['output'];
  variantV2: ProductVariantV2;
};

export type SettingGuide = {
  __typename?: 'SettingGuide';
  hasConnectedDatasourceChannel: Scalars['Boolean']['output'];
  hasInputUnitCost: Scalars['Boolean']['output'];
  hasSaleChannelCostIndex: Scalars['Boolean']['output'];
  hasShopifyChannel: Scalars['Boolean']['output'];
};

export type ShipperAddress = {
  __typename?: 'ShipperAddress';
  accountId: Scalars['ID']['output'];
  addressFirst: Scalars['String']['output'];
  addressSecond?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  country: Country;
  default: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  personInCharge: Scalars['String']['output'];
  phone: PhoneNumber;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Region>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type ShipperAddressInput = {
  accountId: Scalars['ID']['input'];
  addressFirst: Scalars['String']['input'];
  addressSecond?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country: Country;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  personInCharge: Scalars['String']['input'];
  phone: PhoneNumberInput;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type Shipping = {
  __typename?: 'Shipping';
  boxSizes?: Maybe<Array<ShippingBoxSize>>;
  deliveryDutyPaid: Scalars['Boolean']['output'];
  insurance?: Maybe<AnylogiMoney>;
  orderID: Scalars['ID']['output'];
  shipmentCategory: Category;
  shipperAddressID: Scalars['String']['output'];
  signatureOption: Scalars['Boolean']['output'];
  status: ShippingStatus;
  trackingURL: Scalars['String']['output'];
};

export const ShippingAddressValidationResult = {
  IGNORABLE: 'IGNORABLE',
  INVALID_SHIPPING_ADDRESS: 'INVALID_SHIPPING_ADDRESS',
  INVALID_SHIPPING_ADDRESS_COUNTRY_CODE: 'INVALID_SHIPPING_ADDRESS_COUNTRY_CODE',
  INVALID_SHIPPING_ADDRESS_HOUSE_NUMBER: 'INVALID_SHIPPING_ADDRESS_HOUSE_NUMBER'
} as const;

export type ShippingAddressValidationResult = typeof ShippingAddressValidationResult[keyof typeof ShippingAddressValidationResult];
export type ShippingBoxSize = {
  __typename?: 'ShippingBoxSize';
  depth: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  packageType?: Maybe<PackageType>;
  quantity: Scalars['Int']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
  width: Scalars['Int']['output'];
};

export type ShippingBoxSizeInput = {
  depth: Scalars['Int']['input'];
  height: Scalars['Int']['input'];
  packageType?: InputMaybe<PackageTypeInput>;
  quantity: Scalars['Int']['input'];
  weight?: InputMaybe<Scalars['Int']['input']>;
  width: Scalars['Int']['input'];
};

export type ShippingInput = {
  boxSizes: Array<ShippingBoxSizeInput>;
  category: Category;
  deliveryDutyPaid: Scalars['Boolean']['input'];
  insurance?: InputMaybe<AnylogiMoneyInput>;
  orderId: Scalars['ID']['input'];
  shipperAddressId: Scalars['ID']['input'];
  signatureOption: Scalars['Boolean']['input'];
};

export type ShippingRateDetail = {
  __typename?: 'ShippingRateDetail';
  crossBorderCourierProvider: CrossBorderCourierProvider;
  estimateDeliveryDate?: Maybe<DateRangeResponse>;
  ratedShipmentAlert?: Maybe<Array<RatedShipmentAlert>>;
  serviceCode?: Maybe<CrossBorderServiceCode>;
  totalCharge: AnylogiMoney;
};

export type ShippingRateDetails = {
  __typename?: 'ShippingRateDetails';
  crossBorderCourierProvider: CrossBorderCourierProvider;
  estimateDeliveryDate?: Maybe<DateRangeResponse>;
  ratedShipmentAlert?: Maybe<RatedShipmentAlert>;
  serviceCode?: Maybe<CrossBorderServiceCode>;
  totalCharge: AnylogiMoney;
};

export const ShippingStatus = {
  CANCELLED: 'CANCELLED',
  SHIPPING: 'SHIPPING',
  WAITING: 'WAITING'
} as const;

export type ShippingStatus = typeof ShippingStatus[keyof typeof ShippingStatus];
export type Shopee = {
  __typename?: 'Shopee';
  coverImageDisplayUrl?: Maybe<Scalars['String']['output']>;
  coverImageUrl: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isTest: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type ShopeeAiMessage = ShopeeMessage & {
  __typename?: 'ShopeeAIMessage';
  content: ShopeeMessageContent;
  messageId: Scalars['String']['output'];
};

export const ShopeeAccountType = {
  AGENT_ACCOUNT: 'AGENT_ACCOUNT',
  SUBACCOUNT: 'SUBACCOUNT'
} as const;

export type ShopeeAccountType = typeof ShopeeAccountType[keyof typeof ShopeeAccountType];
/** A store's authorization of the AnyX Affiliate Shopee app, used for affiliate (AMS) reporting. */
export type ShopeeAffiliateAuthorization = {
  __typename?: 'ShopeeAffiliateAuthorization';
  data: ShopeeSaleChannelData;
  id: Scalars['Long']['output'];
  isActive: Scalars['Boolean']['output'];
};

export type ShopeeAffiliateLoginUrlInput = {
  redirectUri: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

/** Filter input for Shopee all stat export operations */
export type ShopeeAllStatExportFilterInput = {
  /** Account IDs */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  atc?: InputMaybe<IntRangeInput>;
  auctionRound?: InputMaybe<IntRangeInput>;
  avgViewDuration?: InputMaybe<IntRangeInput>;
  coinsClaimed?: InputMaybe<IntRangeInput>;
  coinsRound?: InputMaybe<IntRangeInput>;
  comments?: InputMaybe<IntRangeInput>;
  confirmedABS?: InputMaybe<BigDecimalRangeInput>;
  confirmedBuyers?: InputMaybe<IntRangeInput>;
  confirmedGPM?: InputMaybe<BigDecimalRangeInput>;
  confirmedOrders?: InputMaybe<IntRangeInput>;
  confirmedSales?: InputMaybe<BigDecimalRangeInput>;
  currencyCode?: InputMaybe<Currency>;
  duration?: InputMaybe<IntRangeInput>;
  engagedViewers?: InputMaybe<IntRangeInput>;
  followersGrowth?: InputMaybe<IntRangeInput>;
  /** Host type */
  hostType?: InputMaybe<HostType>;
  /** Live stat IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemConfirmedOrders?: InputMaybe<IntRangeInput>;
  itemPlacedOrders?: InputMaybe<IntRangeInput>;
  likes?: InputMaybe<IntRangeInput>;
  /** Live stream IDs (live_stream.id) to scope the export to — this is the id the dashboard exposes as sessionId, and is NOT the same as `ids`, which filters the stat row's own primary key */
  liveStreamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paidOrders?: InputMaybe<IntRangeInput>;
  paidSales?: InputMaybe<BigDecimalRangeInput>;
  peakViewers?: InputMaybe<IntRangeInput>;
  placedABS?: InputMaybe<BigDecimalRangeInput>;
  placedBuyers?: InputMaybe<IntRangeInput>;
  placedGPM?: InputMaybe<BigDecimalRangeInput>;
  placedOrders?: InputMaybe<IntRangeInput>;
  placedSales?: InputMaybe<BigDecimalRangeInput>;
  productClicks?: InputMaybe<IntRangeInput>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  salesPerBuyer?: InputMaybe<BigDecimalRangeInput>;
  salesPerOrder?: InputMaybe<BigDecimalRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  shares?: InputMaybe<IntRangeInput>;
  startTimestamp?: InputMaybe<DateTimeRangeInput>;
  status?: InputMaybe<Scalars['Int']['input']>;
  /** Store IDs */
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeClaimed?: InputMaybe<IntRangeInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  userClaimed?: InputMaybe<IntRangeInput>;
  viewers?: InputMaybe<IntRangeInput>;
  views?: InputMaybe<IntRangeInput>;
};

export const ShopeeAuthMode = {
  OAUTH: 'OAUTH',
  SESSION: 'SESSION'
} as const;

export type ShopeeAuthMode = typeof ShopeeAuthMode[keyof typeof ShopeeAuthMode];
export type ShopeeChatEvent = CommonChatEvent | ShopeeMessageEvent;

export type ShopeeChatEvents = {
  __typename?: 'ShopeeChatEvents';
  chatEvents: Array<ShopeeChatEvent>;
  chatId: Scalars['String']['output'];
  newerCursor?: Maybe<Scalars['String']['output']>;
  olderCursor?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

export type ShopeeChatPlatformDetail = {
  __typename?: 'ShopeeChatPlatformDetail';
  shopeeChatType: ShopeeChatType;
};

export const ShopeeChatType = {
  AFFILIATE: 'AFFILIATE',
  BUYER: 'BUYER'
} as const;

export type ShopeeChatType = typeof ShopeeChatType[keyof typeof ShopeeChatType];
/** Shopee comment data for a live stream. */
export type ShopeeComment = {
  __typename?: 'ShopeeComment';
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Shopee comment ID */
  id: Scalars['ID']['output'];
  liveStreamId: Scalars['ID']['output'];
  /** Returns the associated livestream. */
  livestream?: Maybe<LiveStream>;
  messageId: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  roomId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

/** Filter input for livestream Shopee comments. */
export type ShopeeCommentFilterInput = {
  /** LiveStream ID */
  liveStreamId: Scalars['ID']['input'];
  timestamp?: InputMaybe<DateTimeRangeInput>;
};

/** List of Shopee comment data. */
export type ShopeeCommentList = PaginatedList & {
  __typename?: 'ShopeeCommentList';
  items: Array<ShopeeComment>;
  totalCount: Scalars['Int']['output'];
};

/** Sort field for Shopee comments. */
export const ShopeeCommentSortField = {
  COMMENT: 'COMMENT',
  CREATED_AT: 'CREATED_AT',
  ID: 'ID',
  MESSAGE_ID: 'MESSAGE_ID',
  NICKNAME: 'NICKNAME',
  ROOM_ID: 'ROOM_ID',
  TIMESTAMP: 'TIMESTAMP',
  USERNAME: 'USERNAME',
  USER_ID: 'USER_ID'
} as const;

export type ShopeeCommentSortField = typeof ShopeeCommentSortField[keyof typeof ShopeeCommentSortField];
/** Sort input for Shopee comments. */
export type ShopeeCommentSortInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<ShopeeCommentSortField>;
};

/** Filter input for Shopee comments export operations. */
export type ShopeeCommentsExportFilterInput = {
  /** LiveStream ID */
  liveStreamId: Scalars['ID']['input'];
  timestamp?: InputMaybe<DateTimeRangeInput>;
};

/** Shopee connection details for a store. */
export type ShopeeConnectionGql = {
  __typename?: 'ShopeeConnectionGql';
  anyxStoreId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Earliest date by which the operator must manually re-authorize. Equals min(shopeeAuthExpiresAt, shopAccessTokenExpiresAt + 30 days, userAccessTokenExpiresAt + 30 days). */
  reAuthorizationDeadline: Scalars['DateTime']['output'];
  region: Scalars['String']['output'];
  shopName: Scalars['String']['output'];
  shopeeAuthExpiresAt: Scalars['DateTime']['output'];
  shopeeShopId: Scalars['Long']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShopeeContinueShopSelectionItem = {
  __typename?: 'ShopeeContinueShopSelectionItem';
  displayName: Scalars['String']['output'];
  shopId: Scalars['Long']['output'];
};

export type ShopeeFaqBotMessage = ShopeeMessage & {
  __typename?: 'ShopeeFAQBotMessage';
  content: ShopeeMessageContent;
  messageId: Scalars['String']['output'];
};

/**
 * MSG_TYPE_TEXT,
 * MSG_TYPE_FAQ_TYPE_CHOICE,
 * MSG_TYPE_FAQ_CATEGORY_CHOICE,
 * MSG_TYPE_FAQ_FEEDBACK,
 * MSG_TYPE_FAQ_TYPE_BOT_REQUEST_TEXT_MESSAGE,
 * MSG_TYPE_LIVE_AGENT_PROMPT
 *
 * will be normal text message
 */
export type ShopeeFaqBundleContent = {
  __typename?: 'ShopeeFAQBundleContent';
  messages: Array<ShopeeMessageEvent>;
};

/**
 * MSG_TYPE_NEW_FAQ, MSG_TYPE_FAQ_CATEGORY_LIST, MSG_TYPE_QUESTION_LIST
 * use when showing list for customer to select
 */
export type ShopeeFaqChoices = {
  __typename?: 'ShopeeFAQChoices';
  choices: Array<ShopeeText>;
  title: ShopeeText;
};

/**
 * MSG_TYPE_FAQ_FEEDBACK_PROMPT
 * shop automatically send message to customer to ask for feedback (Was this answer helpful Yes/No)
 */
export type ShopeeFaqFeedbackPrompt = {
  __typename?: 'ShopeeFAQFeedbackPrompt';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type ShopeeFileUploadInput = {
  /** start from gs://~~~ */
  fileUri: Scalars['String']['input'];
  saleChannelId: Scalars['Long']['input'];
  type: ShopeeFileUploadType;
};

export const ShopeeFileUploadType = {
  AD_COST_ADS: 'AD_COST_ADS',
  SESSION: 'SESSION'
} as const;

export type ShopeeFileUploadType = typeof ShopeeFileUploadType[keyof typeof ShopeeFileUploadType];
export type ShopeeGetVouchersRequestInput = {
  storeId: Scalars['Long']['input'];
};

/** One shop the harvested Seller Center session can reach. */
export type ShopeeHarvestedShopInput = {
  shopId: Scalars['Long']['input'];
  username: Scalars['String']['input'];
};

export type ShopeeImageMessageContent = {
  __typename?: 'ShopeeImageMessageContent';
  previewUrl: Scalars['Url']['output'];
  url: Scalars['Url']['output'];
};

/**
 * Shopee's image_with_text message: a single image plus the buyer's caption.
 * `text` may be empty.
 */
export type ShopeeImageWithTextMessageContent = {
  __typename?: 'ShopeeImageWithTextMessageContent';
  previewUrl: Scalars['Url']['output'];
  text: Scalars['String']['output'];
  url: Scalars['Url']['output'];
};

export type ShopeeItemListMessageContent = {
  __typename?: 'ShopeeItemListMessageContent';
  items: Array<ShopeeItemMessageContent>;
};

export type ShopeeItemMessageContent = {
  __typename?: 'ShopeeItemMessageContent';
  externalLink: Scalars['Url']['output'];
  isShopItem: Scalars['Boolean']['output'];
  itemImageUrl?: Maybe<Scalars['Url']['output']>;
  itemUrlPath?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Shopee live stat data. */
export type ShopeeLiveStat = {
  __typename?: 'ShopeeLiveStat';
  atc: Scalars['Long']['output'];
  auctionRound: Scalars['Long']['output'];
  avgViewDuration: Scalars['Duration']['output'];
  coinsClaimed: Scalars['Long']['output'];
  coinsRound: Scalars['Long']['output'];
  commentRate: Scalars['BigDecimal']['output'];
  comments: Scalars['Long']['output'];
  confirmedABS: AnyLiveMoney;
  confirmedBuyers: Scalars['Long']['output'];
  confirmedCOR: Scalars['BigDecimal']['output'];
  confirmedGPM: AnyLiveMoney;
  confirmedOrders: Scalars['Long']['output'];
  confirmedSales: AnyLiveMoney;
  conversionRate: Scalars['BigDecimal']['output'];
  coverImage: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  ctr: Scalars['BigDecimal']['output'];
  currencyCode: Currency;
  currencySymbol: Scalars['String']['output'];
  duration: Scalars['Duration']['output'];
  engagedViewers: Scalars['Long']['output'];
  followersGrowth: Scalars['Long']['output'];
  id: Scalars['ID']['output'];
  /** True while Shopee may still revise this session's numbers (ongoing, or ended within 48h). */
  isProvisional: Scalars['Boolean']['output'];
  itemConfirmedOrders: Scalars['Long']['output'];
  itemPlacedOrders: Scalars['Long']['output'];
  likes: Scalars['Long']['output'];
  liveCoverClicksRate: Scalars['BigDecimal']['output'];
  /** LiveStream ID */
  liveStreamId: Scalars['ID']['output'];
  /** Returns the associated livestream. */
  livestream?: Maybe<LiveStream>;
  livestreamName: Scalars['String']['output'];
  livestreamStartedAt: Scalars['DateTime']['output'];
  paidOrders: Scalars['Long']['output'];
  paidSales: AnyLiveMoney;
  peakViewers: Scalars['Long']['output'];
  placedABS: AnyLiveMoney;
  placedBuyers: Scalars['Long']['output'];
  placedCOR: Scalars['BigDecimal']['output'];
  placedGPM: AnyLiveMoney;
  placedOrders: Scalars['Long']['output'];
  placedSales: AnyLiveMoney;
  productClickRate: Scalars['BigDecimal']['output'];
  productClicks: Scalars['Long']['output'];
  roomId: Scalars['String']['output'];
  salesPerBuyer: AnyLiveMoney;
  salesPerOrder: AnyLiveMoney;
  shares: Scalars['Long']['output'];
  startTimestamp: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  streamingPriceSets: Array<Scalars['Long']['output']>;
  timeClaimed: Scalars['Long']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userClaimed: Scalars['Long']['output'];
  viewers: Scalars['Long']['output'];
  views: Scalars['Long']['output'];
};

/** Filter input for Shopee live stat export operations. */
export type ShopeeLiveStatExportFilterInput = {
  /** Account IDs */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  atc?: InputMaybe<IntRangeInput>;
  auctionRound?: InputMaybe<IntRangeInput>;
  avgViewDuration?: InputMaybe<IntRangeInput>;
  coinsClaimed?: InputMaybe<IntRangeInput>;
  coinsRound?: InputMaybe<IntRangeInput>;
  comments?: InputMaybe<IntRangeInput>;
  confirmedABS?: InputMaybe<BigDecimalRangeInput>;
  confirmedBuyers?: InputMaybe<IntRangeInput>;
  confirmedGPM?: InputMaybe<BigDecimalRangeInput>;
  confirmedOrders?: InputMaybe<IntRangeInput>;
  confirmedSales?: InputMaybe<BigDecimalRangeInput>;
  currencyCode?: InputMaybe<Currency>;
  duration?: InputMaybe<IntRangeInput>;
  engagedViewers?: InputMaybe<IntRangeInput>;
  followersGrowth?: InputMaybe<IntRangeInput>;
  /** Host type */
  hostType?: InputMaybe<HostType>;
  /** Live stat IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemConfirmedOrders?: InputMaybe<IntRangeInput>;
  itemPlacedOrders?: InputMaybe<IntRangeInput>;
  likes?: InputMaybe<IntRangeInput>;
  /** Live stream IDs (live_stream.id) to scope the export to — this is the id the dashboard exposes as sessionId, and is NOT the same as `ids`, which filters the stat row's own primary key */
  liveStreamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paidOrders?: InputMaybe<IntRangeInput>;
  paidSales?: InputMaybe<BigDecimalRangeInput>;
  peakViewers?: InputMaybe<IntRangeInput>;
  placedABS?: InputMaybe<BigDecimalRangeInput>;
  placedBuyers?: InputMaybe<IntRangeInput>;
  placedGPM?: InputMaybe<BigDecimalRangeInput>;
  placedOrders?: InputMaybe<IntRangeInput>;
  placedSales?: InputMaybe<BigDecimalRangeInput>;
  productClicks?: InputMaybe<IntRangeInput>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  salesPerBuyer?: InputMaybe<BigDecimalRangeInput>;
  salesPerOrder?: InputMaybe<BigDecimalRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  shares?: InputMaybe<IntRangeInput>;
  startTimestamp?: InputMaybe<DateTimeRangeInput>;
  status?: InputMaybe<Scalars['Int']['input']>;
  /** Store IDs */
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeClaimed?: InputMaybe<IntRangeInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  userClaimed?: InputMaybe<IntRangeInput>;
  viewers?: InputMaybe<IntRangeInput>;
  views?: InputMaybe<IntRangeInput>;
};

/** Filter input for livestreamShopeeStats. */
export type ShopeeLiveStatFilterInput = {
  /** Account IDs */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  atc?: InputMaybe<IntRangeInput>;
  auctionRound?: InputMaybe<IntRangeInput>;
  avgViewDuration?: InputMaybe<IntRangeInput>;
  coinsClaimed?: InputMaybe<IntRangeInput>;
  coinsRound?: InputMaybe<IntRangeInput>;
  commentRate?: InputMaybe<BigDecimalRangeInput>;
  comments?: InputMaybe<IntRangeInput>;
  confirmedABS?: InputMaybe<BigDecimalRangeInput>;
  confirmedBuyers?: InputMaybe<IntRangeInput>;
  confirmedCOR?: InputMaybe<BigDecimalRangeInput>;
  confirmedGPM?: InputMaybe<BigDecimalRangeInput>;
  confirmedOrders?: InputMaybe<IntRangeInput>;
  confirmedSales?: InputMaybe<BigDecimalRangeInput>;
  conversionRate?: InputMaybe<BigDecimalRangeInput>;
  ctr?: InputMaybe<BigDecimalRangeInput>;
  currencyCode?: InputMaybe<Currency>;
  duration?: InputMaybe<IntRangeInput>;
  engagedViewers?: InputMaybe<IntRangeInput>;
  followersGrowth?: InputMaybe<IntRangeInput>;
  /** Host type */
  hostType?: InputMaybe<HostType>;
  itemConfirmedOrders?: InputMaybe<IntRangeInput>;
  itemPlacedOrders?: InputMaybe<IntRangeInput>;
  likes?: InputMaybe<IntRangeInput>;
  liveCoverClicksRate?: InputMaybe<BigDecimalRangeInput>;
  /** LiveStream ID */
  liveStreamId?: InputMaybe<Scalars['ID']['input']>;
  paidOrders?: InputMaybe<IntRangeInput>;
  paidSales?: InputMaybe<BigDecimalRangeInput>;
  peakViewers?: InputMaybe<IntRangeInput>;
  placedABS?: InputMaybe<BigDecimalRangeInput>;
  placedBuyers?: InputMaybe<IntRangeInput>;
  placedCOR?: InputMaybe<BigDecimalRangeInput>;
  placedGPM?: InputMaybe<BigDecimalRangeInput>;
  placedOrders?: InputMaybe<IntRangeInput>;
  placedSales?: InputMaybe<BigDecimalRangeInput>;
  productClickRate?: InputMaybe<BigDecimalRangeInput>;
  productClicks?: InputMaybe<IntRangeInput>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  salesPerBuyer?: InputMaybe<BigDecimalRangeInput>;
  salesPerOrder?: InputMaybe<BigDecimalRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  shares?: InputMaybe<IntRangeInput>;
  startTimestamp?: InputMaybe<DateTimeRangeInput>;
  status?: InputMaybe<Scalars['Long']['input']>;
  /** Store IDs */
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeClaimed?: InputMaybe<IntRangeInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  userClaimed?: InputMaybe<IntRangeInput>;
  viewers?: InputMaybe<IntRangeInput>;
  views?: InputMaybe<IntRangeInput>;
};

/** List of Shopee live stat data. */
export type ShopeeLiveStatList = PaginatedList & {
  __typename?: 'ShopeeLiveStatList';
  items: Array<ShopeeLiveStat>;
  totalCount: Scalars['Int']['output'];
};

export const ShopeeLiveStatSortField = {
  ATC: 'ATC',
  AUCTION_ROUND: 'AUCTION_ROUND',
  AVG_VIEW_DURATION: 'AVG_VIEW_DURATION',
  COINS_CLAIMED: 'COINS_CLAIMED',
  COINS_ROUND: 'COINS_ROUND',
  COMMENTS: 'COMMENTS',
  COMMENT_RATE: 'COMMENT_RATE',
  CONFIRMED_ABS: 'CONFIRMED_ABS',
  CONFIRMED_BUYERS: 'CONFIRMED_BUYERS',
  CONFIRMED_COR: 'CONFIRMED_COR',
  CONFIRMED_GPM: 'CONFIRMED_GPM',
  CONFIRMED_ORDERS: 'CONFIRMED_ORDERS',
  CONFIRMED_SALES: 'CONFIRMED_SALES',
  CONVERSION_RATE: 'CONVERSION_RATE',
  CREATED_AT: 'CREATED_AT',
  CTR: 'CTR',
  DURATION: 'DURATION',
  ENGAGED_VIEWERS: 'ENGAGED_VIEWERS',
  FOLLOWERS_GROWTH: 'FOLLOWERS_GROWTH',
  HOST_TYPE: 'HOST_TYPE',
  ID: 'ID',
  ITEM_CONFIRMED_ORDERS: 'ITEM_CONFIRMED_ORDERS',
  ITEM_PLACED_ORDERS: 'ITEM_PLACED_ORDERS',
  LIKES: 'LIKES',
  LIVE_COVER_CLICKS_RATE: 'LIVE_COVER_CLICKS_RATE',
  PAID_ORDERS: 'PAID_ORDERS',
  PAID_SALES: 'PAID_SALES',
  PEAK_VIEWERS: 'PEAK_VIEWERS',
  PLACED_ABS: 'PLACED_ABS',
  PLACED_BUYERS: 'PLACED_BUYERS',
  PLACED_COR: 'PLACED_COR',
  PLACED_GPM: 'PLACED_GPM',
  PLACED_ORDERS: 'PLACED_ORDERS',
  PLACED_SALES: 'PLACED_SALES',
  PRODUCT_CLICKS: 'PRODUCT_CLICKS',
  PRODUCT_CLICK_RATE: 'PRODUCT_CLICK_RATE',
  ROOM_ID: 'ROOM_ID',
  SALES_PER_BUYER: 'SALES_PER_BUYER',
  SALES_PER_ORDER: 'SALES_PER_ORDER',
  SHARES: 'SHARES',
  START_TIMESTAMP: 'START_TIMESTAMP',
  STATUS: 'STATUS',
  TIME_CLAIMED: 'TIME_CLAIMED',
  TITLE: 'TITLE',
  UPDATED_AT: 'UPDATED_AT',
  USER_CLAIMED: 'USER_CLAIMED',
  VIEWERS: 'VIEWERS',
  VIEWS: 'VIEWS'
} as const;

export type ShopeeLiveStatSortField = typeof ShopeeLiveStatSortField[keyof typeof ShopeeLiveStatSortField];
/** Sort input for livestreamShopeeStats. */
export type ShopeeLiveStatSortInput = {
  /** Sort direction */
  direction: SortDirection;
  /** Field to sort by */
  field: ShopeeLiveStatSortField;
};

/** Supported MIME types for Shopee live stream cover image uploads. */
export const ShopeeLiveStreamCoverImageMimeType = {
  IMAGE_JPEG: 'IMAGE_JPEG',
  IMAGE_PNG: 'IMAGE_PNG'
} as const;

export type ShopeeLiveStreamCoverImageMimeType = typeof ShopeeLiveStreamCoverImageMimeType[keyof typeof ShopeeLiveStreamCoverImageMimeType];
/** Input for generating a signed URL for Shopee live stream cover image upload. */
export type ShopeeLiveStreamCoverImageUploadInput = {
  /** Name of the file to be uploaded. */
  fileName: Scalars['String']['input'];
  /** MIME type of the image. */
  mimeType: ShopeeLiveStreamCoverImageMimeType;
  /** Livestream room ID. */
  roomId: Scalars['String']['input'];
};

/** Output containing the upload URL and GCS URI for Shopee live stream cover image upload. */
export type ShopeeLiveStreamCoverImageUploadOutput = {
  __typename?: 'ShopeeLiveStreamCoverImageUploadOutput';
  /** Permanent GCS URI (gs://bucket/path). Pass this as coverImageUrl when creating or updating the live session. */
  gcsUri: Scalars['String']['output'];
  /** GCS signed PUT URL valid for 5 minutes. Use this URL to upload the image via HTTP PUT. */
  signedUrl: Scalars['Url']['output'];
};

export type ShopeeLoginUrlV2Input = {
  redirectUri: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export const ShopeeMarketplace = {
  ID: 'ID',
  MY: 'MY',
  PH: 'PH',
  SG: 'SG',
  TH: 'TH',
  TW: 'TW',
  VN: 'VN'
} as const;

export type ShopeeMarketplace = typeof ShopeeMarketplace[keyof typeof ShopeeMarketplace];
export type ShopeeMessage = {
  content: ShopeeMessageContent;
  messageId: Scalars['String']['output'];
};

export type ShopeeMessageContent = ShopeeFaqBundleContent | ShopeeFaqChoices | ShopeeFaqFeedbackPrompt | ShopeeImageMessageContent | ShopeeImageWithTextMessageContent | ShopeeItemListMessageContent | ShopeeItemMessageContent | ShopeeOrderMessageContent | ShopeeStickerMessageContent | ShopeeTextMessageContent | ShopeeTextMessageContentV2 | ShopeeUnsupportedMessageContent | ShopeeVideoMessageContent | ShopeeVoucherMessageContent;

export type ShopeeMessageEvent = {
  __typename?: 'ShopeeMessageEvent';
  id: Scalars['String']['output'];
  message: ShopeeMessage;
  timestamp: Scalars['UnixTimestamp']['output'];
};

export type ShopeeMessageSource = ItemSource | OrderSource;

export type ShopeeNormalText = {
  __typename?: 'ShopeeNormalText';
  text: Scalars['String']['output'];
};

export type ShopeeOrderMessageContent = {
  __typename?: 'ShopeeOrderMessageContent';
  anyXOrderId?: Maybe<Scalars['Long']['output']>;
  isShopOrder: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  orderImageUrl?: Maybe<Scalars['Url']['output']>;
  shopeeOrderSN: Scalars['String']['output'];
};

export const ShopeeOrderType = {
  ORDERED: 'ORDERED',
  PAID: 'PAID'
} as const;

export type ShopeeOrderType = typeof ShopeeOrderType[keyof typeof ShopeeOrderType];
/** Shopee product data for a live stream. */
export type ShopeeProduct = {
  __typename?: 'ShopeeProduct';
  affiliateItemSold?: Maybe<Scalars['Long']['output']>;
  affiliateOrders?: Maybe<Scalars['Long']['output']>;
  affiliateSales?: Maybe<AnyLiveMoney>;
  atc: Scalars['Long']['output'];
  clickRate: Scalars['BigDecimal']['output'];
  clicks: Scalars['Long']['output'];
  confirmedCORate: Scalars['BigDecimal']['output'];
  confirmedItemSold: Scalars['Long']['output'];
  confirmedOrders: Scalars['Long']['output'];
  confirmedSales: AnyLiveMoney;
  conversionRate: Scalars['BigDecimal']['output'];
  coverImage: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currencyCode: Currency;
  currencySymbol: Scalars['String']['output'];
  grassDate?: Maybe<Scalars['String']['output']>;
  /** Shopee product ID */
  id: Scalars['ID']['output'];
  itemId: Scalars['String']['output'];
  liveStreamId: Scalars['ID']['output'];
  /** Returns the associated livestream. */
  livestream?: Maybe<LiveStream>;
  maxPrice: AnyLiveMoney;
  minPrice: AnyLiveMoney;
  paidOrders: Scalars['Long']['output'];
  paidSales: AnyLiveMoney;
  placedCORate: Scalars['BigDecimal']['output'];
  placedItemSold: Scalars['Long']['output'];
  placedOrders: Scalars['Long']['output'];
  placedSales: AnyLiveMoney;
  roomId: Scalars['String']['output'];
  shopId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewers: Scalars['Long']['output'];
};

/** Filter input for livestreamShopeeProducts. */
export type ShopeeProductFilterInput = {
  atc?: InputMaybe<BigDecimalRangeInput>;
  clickRate?: InputMaybe<BigDecimalRangeInput>;
  clicks?: InputMaybe<BigDecimalRangeInput>;
  confirmedOrders?: InputMaybe<BigDecimalRangeInput>;
  conversionRate?: InputMaybe<BigDecimalRangeInput>;
  currencyCode?: InputMaybe<Currency>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  /** LiveStream ID */
  liveStreamId: Scalars['ID']['input'];
  maxPrice?: InputMaybe<BigDecimalRangeInput>;
  minPrice?: InputMaybe<BigDecimalRangeInput>;
  paidOrders?: InputMaybe<BigDecimalRangeInput>;
  paidSales?: InputMaybe<BigDecimalRangeInput>;
  placedOrders?: InputMaybe<BigDecimalRangeInput>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shopId?: InputMaybe<Scalars['String']['input']>;
  viewers?: InputMaybe<BigDecimalRangeInput>;
};

/** List of Shopee product data. */
export type ShopeeProductList = PaginatedList & {
  __typename?: 'ShopeeProductList';
  items: Array<ShopeeProduct>;
  totalCount: Scalars['Int']['output'];
};

/** A paginated page of product-set candidates from the store's Seller Center session. */
export type ShopeeProductSetCandidatesOutput = {
  __typename?: 'ShopeeProductSetCandidatesOutput';
  /** True when a next page is available. */
  hasMore: Scalars['Boolean']['output'];
  /** Shopee's own max_set cap — the room may hold at most this many sets. */
  maxSet: Scalars['Int']['output'];
  /** Shopee's own max_set_size cap — each set may hold at most this many items. */
  maxSetSize: Scalars['Int']['output'];
  /** Sets on this page. */
  sets: Array<ShopeeProductSetOutput>;
  /** Total number of sets in the store (unpaged). */
  total: Scalars['Int']['output'];
};

/** A single Shopee product set to save with a room. */
export type ShopeeProductSetInput = {
  /** Cover image URL; null when the set has none. */
  coverUrl?: InputMaybe<Scalars['String']['input']>;
  /** Number of items in the set at the time of snapshot. */
  itemCount: Scalars['Int']['input'];
  /** Display name of the product set. */
  name: Scalars['String']['input'];
  /** Shopee product set ID — must be a numeric string. */
  setId: Scalars['ID']['input'];
};

/** One item inside a Shopee product set, read live from the store's Seller Center session. */
export type ShopeeProductSetItemOutput = {
  __typename?: 'ShopeeProductSetItemOutput';
  /** ISO currency code of the prices. */
  currency: Scalars['String']['output'];
  /** Image URL; null when Shopee sent none. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Deleted from the shop — Shopee refuses it at go-live. */
  isDeleted: Scalars['Boolean']['output'];
  /** Out of stock — still accepted at go-live. */
  isOutOfStock: Scalars['Boolean']['output'];
  /** Banned by Shopee — refused at go-live. */
  isProhibited: Scalars['Boolean']['output'];
  /** Unlisted by the seller — refused at go-live. */
  isUnlisted: Scalars['Boolean']['output'];
  /** Shopee item ID — the same id a live product stores as productId. */
  itemId: Scalars['ID']['output'];
  /** Item name as Shopee shows it. */
  name: Scalars['String']['output'];
  /** Highest variant price, as Shopee's decimal string; equals priceMin without variants. */
  priceMax: Scalars['String']['output'];
  /** Lowest variant price, as Shopee's decimal string. */
  priceMin: Scalars['String']['output'];
  /** Stock Shopee displays for the item. */
  stock: Scalars['Int']['output'];
};

/** The items inside one Shopee product set. */
export type ShopeeProductSetItemsOutput = {
  __typename?: 'ShopeeProductSetItemsOutput';
  /** The set's items in Shopee's order. */
  items: Array<ShopeeProductSetItemOutput>;
  /** The set's current name in Seller Center. */
  name: Scalars['String']['output'];
  /** Shopee's item count; larger than items.length only if Shopee ever pages this list. */
  total: Scalars['Int']['output'];
};

/** A Shopee product-set snapshot attached to a session-mode room. */
export type ShopeeProductSetOutput = {
  __typename?: 'ShopeeProductSetOutput';
  /** Cover image URL; null when the set has none. */
  coverUrl?: Maybe<Scalars['String']['output']>;
  /** Number of items in the set at the time of snapshot. */
  itemCount: Scalars['Int']['output'];
  /** Display name of the product set. */
  name: Scalars['String']['output'];
  /** Shopee product set ID (numeric string). */
  setId: Scalars['ID']['output'];
};

/** Sort field for Shopee products. */
export const ShopeeProductSortFieldGql = {
  AFFILIATE_ITEM_SOLD: 'AFFILIATE_ITEM_SOLD',
  AFFILIATE_ORDERS: 'AFFILIATE_ORDERS',
  AFFILIATE_SALES: 'AFFILIATE_SALES',
  ATC: 'ATC',
  CLICKS: 'CLICKS',
  CLICK_RATE: 'CLICK_RATE',
  CONFIRMED_CO_RATE: 'CONFIRMED_CO_RATE',
  CONFIRMED_ITEM_SOLD: 'CONFIRMED_ITEM_SOLD',
  CONFIRMED_ORDERS: 'CONFIRMED_ORDERS',
  CONFIRMED_SALES: 'CONFIRMED_SALES',
  CONVERSION_RATE: 'CONVERSION_RATE',
  CREATED_AT: 'CREATED_AT',
  ID: 'ID',
  ITEM_ID: 'ITEM_ID',
  MAX_PRICE: 'MAX_PRICE',
  MIN_PRICE: 'MIN_PRICE',
  PAID_ORDERS: 'PAID_ORDERS',
  PAID_SALES: 'PAID_SALES',
  PLACED_CO_RATE: 'PLACED_CO_RATE',
  PLACED_ITEM_SOLD: 'PLACED_ITEM_SOLD',
  PLACED_ORDERS: 'PLACED_ORDERS',
  PLACED_SALES: 'PLACED_SALES',
  ROOM_ID: 'ROOM_ID',
  SHOP_ID: 'SHOP_ID',
  TITLE: 'TITLE',
  UPDATED_AT: 'UPDATED_AT',
  VIEWERS: 'VIEWERS'
} as const;

export type ShopeeProductSortFieldGql = typeof ShopeeProductSortFieldGql[keyof typeof ShopeeProductSortFieldGql];
/** Sort input for Shopee products. */
export type ShopeeProductSortInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<ShopeeProductSortFieldGql>;
};

/** Filter input for Shopee products export operations. */
export type ShopeeProductsExportFilterInput = {
  atc?: InputMaybe<IntRangeInput>;
  clickRate?: InputMaybe<BigDecimalRangeInput>;
  clicks?: InputMaybe<IntRangeInput>;
  confirmedOrders?: InputMaybe<IntRangeInput>;
  conversionRate?: InputMaybe<BigDecimalRangeInput>;
  currencyCode?: InputMaybe<Currency>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  livestreamID: Scalars['ID']['input'];
  maxPrice?: InputMaybe<BigDecimalRangeInput>;
  minPrice?: InputMaybe<BigDecimalRangeInput>;
  paidOrders?: InputMaybe<IntRangeInput>;
  paidSales?: InputMaybe<BigDecimalRangeInput>;
  placedOrders?: InputMaybe<IntRangeInput>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shopId?: InputMaybe<Scalars['String']['input']>;
  viewers?: InputMaybe<IntRangeInput>;
};

export type ShopeeSaleChannelData = {
  __typename?: 'ShopeeSaleChannelData';
  expiresAt: Scalars['OffsetDateTime']['output'];
  marketplace: ShopeeMarketplace;
  shopId: Scalars['Long']['output'];
  showReconnectButton: Scalars['Boolean']['output'];
};

export type ShopeeSalesChartInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  orderType?: InputMaybe<ShopeeOrderType>;
  startDate: Scalars['ZonedDatetime']['input'];
};

export type ShopeeSalesChartPayload = {
  __typename?: 'ShopeeSalesChartPayload';
  currency: ReportSupportedCurrency;
  orders: Array<Scalars['Map']['output']>;
  sales: Array<Scalars['Map']['output']>;
  salesPerOrder: Array<Scalars['Map']['output']>;
  visitors: Array<Scalars['Map']['output']>;
};

export type ShopeeSalesDetailedReportInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  orderType?: InputMaybe<ShopeeOrderType>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type ShopeeSalesDetailedReportPayload = {
  __typename?: 'ShopeeSalesDetailedReportPayload';
  currency: ReportSupportedCurrency;
  date: Scalars['LocalDate']['output'];
  orders: Scalars['Long']['output'];
  sales: Scalars['BigDecimal']['output'];
  salesPerOrder: Scalars['BigDecimal']['output'];
  visitors: Scalars['Long']['output'];
};

export type ShopeeSalesDetailedReportPayloadList = {
  __typename?: 'ShopeeSalesDetailedReportPayloadList';
  items: Array<ShopeeSalesDetailedReportPayload>;
  meta: ReportListMeta;
  total: ShopeeSalesDetailedReportTotalPayload;
};

export type ShopeeSalesDetailedReportTotalPayload = {
  __typename?: 'ShopeeSalesDetailedReportTotalPayload';
  currency: ReportSupportedCurrency;
  orders: Scalars['Long']['output'];
  sales: Scalars['BigDecimal']['output'];
  salesPerOrder: Scalars['BigDecimal']['output'];
  visitors: Scalars['Long']['output'];
};

export type ShopeeSalesSummaryInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  orderType?: InputMaybe<ShopeeOrderType>;
  startDate: Scalars['ZonedDatetime']['input'];
};

export type ShopeeSalesSummaryPayload = {
  __typename?: 'ShopeeSalesSummaryPayload';
  currency: ReportSupportedCurrency;
  orders: NumericValueWithDiffPayload;
  sales: NumericValueWithDiffPayload;
  salesPerOrder: NumericValueWithDiffPayload;
  visitors: NumericValueWithDiffPayload;
};

export type ShopeeSendImageMessageRequestInput = {
  chatId: Scalars['String']['input'];
  url: Scalars['Url']['input'];
};

export type ShopeeSendProductMessageRequestInput = {
  chatId: Scalars['String']['input'];
  productId: Scalars['Long']['input'];
};

export type ShopeeSendTextMessageRequestInput = {
  chatId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type ShopeeSendVideoMessageRequestInput = {
  chatId: Scalars['String']['input'];
  videoUrl: Scalars['Url']['input'];
};

export type ShopeeSendVoucherMessageRequestInput = {
  chatId: Scalars['String']['input'];
  voucherCode: Scalars['String']['input'];
  voucherId: Scalars['Long']['input'];
};

/** Shopee-specific configuration for a livestream session. */
export type ShopeeSessionConfigInput = {
  coverImageUrl: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isTest: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export const ShopeeSessionConnectRoute = {
  BLOCKED_IN_PROGRESS: 'BLOCKED_IN_PROGRESS',
  CONFIRM_EXISTING: 'CONFIRM_EXISTING',
  CREDENTIAL_REQUIRED: 'CREDENTIAL_REQUIRED',
  MANUAL_FRESH: 'MANUAL_FRESH',
  MANUAL_PREFILLED: 'MANUAL_PREFILLED'
} as const;

export type ShopeeSessionConnectRoute = typeof ShopeeSessionConnectRoute[keyof typeof ShopeeSessionConnectRoute];
/** Route decision for the Shopee cookie-connect flow — which UI branch the operator should see. */
export type ShopeeSessionConnectRouteOutput = {
  __typename?: 'ShopeeSessionConnectRouteOutput';
  /** The region of the store's Seller Center session; null when it has none. */
  currentRegion?: Maybe<AnyLiveRegion>;
  /** The Shopee shop this store points at today; null when it has no Shopee connection yet. */
  currentShopId?: Maybe<Scalars['Long']['output']>;
  /** Display label for currentShopId — the stored Seller Center sub-account name. */
  currentShopLabel?: Maybe<Scalars['String']['output']>;
  /** CONFIRM_EXISTING: a healthy credential exists; offer to reuse it. MANUAL_PREFILLED: the login is known but the OTP was unreachable; prefill the sub-account. MANUAL_FRESH: the stored credential is suspect; ask the operator to log in from scratch. CREDENTIAL_REQUIRED: no credential on file yet; collect one before connecting. BLOCKED_IN_PROGRESS: an automated login is already running; wait for it to finish. */
  route: ShopeeSessionConnectRoute;
  /** The Shopee store name associated with the credential, when available. */
  storeName?: Maybe<Scalars['String']['output']>;
  /** The Shopee sub-account login name to prefill, when the route is CONFIRM_EXISTING or MANUAL_PREFILLED. */
  subaccount?: Maybe<Scalars['String']['output']>;
};

/** One Seller Center cookie as the browser extension captured it. domain and path are required: the scraper rebuilds the session from them, and a bare name/value pair cannot authenticate. */
export type ShopeeSessionCookieInput = {
  /** Cookie domain, e.g. ".shopee.vn". */
  domain: Scalars['String']['input'];
  httpOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Cookie path, e.g. "/". */
  path: Scalars['String']['input'];
  /** Raw SameSite attribute, e.g. "Lax". Omit when the browser reported none. */
  sameSite?: InputMaybe<Scalars['String']['input']>;
  secure?: InputMaybe<Scalars['Boolean']['input']>;
  value: Scalars['String']['input'];
};

export type ShopeeStickerMessageContent = {
  __typename?: 'ShopeeStickerMessageContent';
  imageUrl: Scalars['Url']['output'];
};

export type ShopeeStoreCsMessage = ShopeeMessage & {
  __typename?: 'ShopeeStoreCSMessage';
  author: BasicUser;
  content: ShopeeMessageContent;
  messageId: Scalars['String']['output'];
  messageState: MessageState;
};

export type ShopeeStoreChat = StoreChat & {
  __typename?: 'ShopeeStoreChat';
  connectionExpiryTime: Scalars['OffsetDateTime']['output'];
  createdAt: Scalars['OffsetDateTime']['output'];
  id: Scalars['String']['output'];
  isAIReplyEnable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  shopId: Scalars['Long']['output'];
  tokenUpdatedSuccessfully: Scalars['Boolean']['output'];
  type: ChatType;
};

export type ShopeeTargetInput = {
  type: ShopeeTargetType;
};

export const ShopeeTargetType = {
  CHAT_MESSAGE: 'CHAT_MESSAGE',
  CHAT_VIDEO_MESSAGE: 'CHAT_VIDEO_MESSAGE'
} as const;

export type ShopeeTargetType = typeof ShopeeTargetType[keyof typeof ShopeeTargetType];
export type ShopeeText = ShopeeNormalText | ShopeeTranslatedText;

/** We be migrated to ShopeeTextMessageContentV2 soon */
export type ShopeeTextMessageContent = {
  __typename?: 'ShopeeTextMessageContent';
  text: Scalars['String']['output'];
};

/**
 * MSG_TYPE_LIVE_AGENT_PROMPT has translation
 * MSG_TYPE_FAQ_TYPE_CHOICE has translation
 * use when showing list for customer to select
 */
export type ShopeeTextMessageContentV2 = {
  __typename?: 'ShopeeTextMessageContentV2';
  text: ShopeeText;
};

export type ShopeeTextTranslation = {
  __typename?: 'ShopeeTextTranslation';
  lang: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type ShopeeTranslatedText = {
  __typename?: 'ShopeeTranslatedText';
  translations: Array<ShopeeTextTranslation>;
};

/** Shopee trend data. */
export type ShopeeTrend = {
  __typename?: 'ShopeeTrend';
  atc: Scalars['Long']['output'];
  ccu: Scalars['Long']['output'];
  comment: Scalars['Long']['output'];
  confirmedOrders: Scalars['Long']['output'];
  confirmedSales: AnyLiveMoney;
  createdAt: Scalars['DateTime']['output'];
  currencyCode: Currency;
  currencySymbol: Scalars['String']['output'];
  engagedCcu: Scalars['Long']['output'];
  id: Scalars['ID']['output'];
  likes: Scalars['Long']['output'];
  /** LiveStream ID */
  liveStreamId: Scalars['ID']['output'];
  /** Returns the associated livestream. */
  livestream?: Maybe<LiveStream>;
  livestreamName: Scalars['String']['output'];
  placedOrders: Scalars['Long']['output'];
  placedSales: AnyLiveMoney;
  roomId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewers: Scalars['Long']['output'];
  views: Scalars['Long']['output'];
};

/** Filter input for livestreamShopeeTrends. */
export type ShopeeTrendFilterInput = {
  atc?: InputMaybe<IntRangeInput>;
  ccu?: InputMaybe<IntRangeInput>;
  comment?: InputMaybe<IntRangeInput>;
  confirmedOrders?: InputMaybe<IntRangeInput>;
  confirmedSales?: InputMaybe<BigDecimalRangeInput>;
  currencyCode?: InputMaybe<Currency>;
  engagedCcu?: InputMaybe<IntRangeInput>;
  likes?: InputMaybe<IntRangeInput>;
  /** LiveStream ID */
  liveStreamId: Scalars['ID']['input'];
  placedOrders?: InputMaybe<IntRangeInput>;
  placedSales?: InputMaybe<BigDecimalRangeInput>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<DateTimeRangeInput>;
  viewers?: InputMaybe<IntRangeInput>;
  views?: InputMaybe<IntRangeInput>;
};

/** List of Shopee trend data. */
export type ShopeeTrendList = PaginatedList & {
  __typename?: 'ShopeeTrendList';
  items: Array<ShopeeTrend>;
  totalCount: Scalars['Int']['output'];
};

export const ShopeeTrendSortField = {
  ATC: 'ATC',
  CCU: 'CCU',
  COMMENT: 'COMMENT',
  CONFIRMED_ORDERS: 'CONFIRMED_ORDERS',
  CONFIRMED_SALES: 'CONFIRMED_SALES',
  CREATED_AT: 'CREATED_AT',
  ENGAGED_CCU: 'ENGAGED_CCU',
  ID: 'ID',
  LIKES: 'LIKES',
  PLACED_ORDERS: 'PLACED_ORDERS',
  PLACED_SALES: 'PLACED_SALES',
  TIMESTAMP: 'TIMESTAMP',
  UPDATED_AT: 'UPDATED_AT',
  VIEWERS: 'VIEWERS',
  VIEWS: 'VIEWS'
} as const;

export type ShopeeTrendSortField = typeof ShopeeTrendSortField[keyof typeof ShopeeTrendSortField];
/** Sort input for livestreamShopeeTrends. */
export type ShopeeTrendSortInput = {
  /** Sort direction */
  direction: SortDirection;
  /** Field to sort by */
  field: ShopeeTrendSortField;
};

/** Filter input for Shopee trends export operations. */
export type ShopeeTrendsExportFilterInput = {
  atc?: InputMaybe<IntRangeInput>;
  ccu?: InputMaybe<IntRangeInput>;
  comment?: InputMaybe<IntRangeInput>;
  confirmedOrders?: InputMaybe<IntRangeInput>;
  confirmedSales?: InputMaybe<BigDecimalRangeInput>;
  currencyCode?: InputMaybe<Currency>;
  engagedCcu?: InputMaybe<IntRangeInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  likes?: InputMaybe<IntRangeInput>;
  livestreamID: Scalars['ID']['input'];
  placedOrders?: InputMaybe<IntRangeInput>;
  placedSales?: InputMaybe<BigDecimalRangeInput>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<DateTimeRangeInput>;
  viewers?: InputMaybe<IntRangeInput>;
  views?: InputMaybe<IntRangeInput>;
};

/**
 * A message AnyChat cannot decode: an unrecognized Shopee message type or a
 * payload that failed deserialization. Surfaced so the agent can see that the
 * customer sent something and open the conversation in Shopee, rather than the
 * message being silently absent.
 */
export type ShopeeUnsupportedMessageContent = {
  __typename?: 'ShopeeUnsupportedMessageContent';
  messageType: Scalars['String']['output'];
};

export type ShopeeUserMessage = ShopeeMessage & {
  __typename?: 'ShopeeUserMessage';
  content: ShopeeMessageContent;
  messageId: Scalars['String']['output'];
  source?: Maybe<ShopeeMessageSource>;
};

export type ShopeeVideoMessageContent = {
  __typename?: 'ShopeeVideoMessageContent';
  previewUrl: Scalars['Url']['output'];
  videoUrl: Scalars['Url']['output'];
};

export type ShopeeVoucherMessageContent = {
  __typename?: 'ShopeeVoucherMessageContent';
  voucher: ChatShopeeVoucher;
};

export const ShopeeVoucherStatus = {
  DELETED: 'DELETED',
  EXPIRED: 'EXPIRED',
  ONGOING: 'ONGOING',
  UPCOMING: 'UPCOMING'
} as const;

export type ShopeeVoucherStatus = typeof ShopeeVoucherStatus[keyof typeof ShopeeVoucherStatus];
export type ShopifyCarrierService = {
  __typename?: 'ShopifyCarrierService';
  active: Scalars['Boolean']['output'];
  adminGraphqlApiId: Scalars['String']['output'];
  callbackUrl: Scalars['String']['output'];
  carrierServiceType: Scalars['String']['output'];
  channelId: Scalars['ID']['output'];
  format: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  serviceDiscovery: Scalars['Boolean']['output'];
};

export type ShopifyCarrierServiceCondition = {
  __typename?: 'ShopifyCarrierServiceCondition';
  condition: LogisticShippingRateConditionType;
  created: Scalars['Time']['output'];
  dutyDisplayOption: DutyDisplayOption;
  id: Scalars['ID']['output'];
  maximumPrice?: Maybe<AnylogiMoney>;
  maximumWeight?: Maybe<Scalars['Float']['output']>;
  minimumPrice?: Maybe<AnylogiMoney>;
  minimumWeight?: Maybe<Scalars['Float']['output']>;
  updated: Scalars['Time']['output'];
};

export type ShopifyCarrierServiceConditionInput = {
  condition: LogisticShippingRateConditionType;
  dutyDisplayOption?: InputMaybe<DutyDisplayOption>;
  maximumPrice?: InputMaybe<AnylogiMoneyInput>;
  maximumWeight?: InputMaybe<Scalars['Float']['input']>;
  minimumPrice?: InputMaybe<AnylogiMoneyInput>;
  minimumWeight?: InputMaybe<Scalars['Float']['input']>;
  saleChannelId: Scalars['Long']['input'];
};

export type ShopifyCustomer = {
  __typename?: 'ShopifyCustomer';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type ShopifyLoginUrlV2Input = {
  redirectUri: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
  storeName: Scalars['String']['input'];
};

export type ShopifySaleChannelData = {
  __typename?: 'ShopifySaleChannelData';
  domain: Scalars['String']['output'];
};

export type ShopifySalesReportChartInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type ShopifySalesReportChartPayload = {
  __typename?: 'ShopifySalesReportChartPayload';
  currency: ReportSupportedCurrency;
  discounts: Array<Scalars['Map']['output']>;
  grossSales: Array<Scalars['Map']['output']>;
  netSales: Array<Scalars['Map']['output']>;
  orderCount: Array<Scalars['Map']['output']>;
  returns: Array<Scalars['Map']['output']>;
  shipping: Array<Scalars['Map']['output']>;
  taxes: Array<Scalars['Map']['output']>;
  totalSales: Array<Scalars['Map']['output']>;
};

export type ShopifySalesReportSummaryInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type ShopifySalesReportSummaryPayload = {
  __typename?: 'ShopifySalesReportSummaryPayload';
  currency: ReportSupportedCurrency;
  discounts: NumericValueWithDiffPayload;
  grossSales: NumericValueWithDiffPayload;
  netSales: NumericValueWithDiffPayload;
  orderCount: NumericValueWithDiffPayload;
  returns: NumericValueWithDiffPayload;
  shipping: NumericValueWithDiffPayload;
  taxes: NumericValueWithDiffPayload;
  totalSales: NumericValueWithDiffPayload;
};

export type ShopifySalesReportTableInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type ShopifySalesReportTablePayload = {
  __typename?: 'ShopifySalesReportTablePayload';
  currency: ReportSupportedCurrency;
  date: Scalars['LocalDate']['output'];
  discounts: Scalars['BigDecimal']['output'];
  grossSales: Scalars['BigDecimal']['output'];
  netSales: Scalars['BigDecimal']['output'];
  orderCount: Scalars['Long']['output'];
  returns: Scalars['BigDecimal']['output'];
  shipping: Scalars['BigDecimal']['output'];
  taxes: Scalars['BigDecimal']['output'];
  totalSales: Scalars['BigDecimal']['output'];
};

export type ShopifySalesReportTablePayloadList = {
  __typename?: 'ShopifySalesReportTablePayloadList';
  items: Array<ShopifySalesReportTablePayload>;
  meta: ReportListMeta;
  total: ShopifySalesReportTotalPayload;
};

export type ShopifySalesReportTotalPayload = {
  __typename?: 'ShopifySalesReportTotalPayload';
  currency: ReportSupportedCurrency;
  discounts: Scalars['BigDecimal']['output'];
  grossSales: Scalars['BigDecimal']['output'];
  netSales: Scalars['BigDecimal']['output'];
  orderCount: Scalars['Long']['output'];
  returns: Scalars['BigDecimal']['output'];
  shipping: Scalars['BigDecimal']['output'];
  taxes: Scalars['BigDecimal']['output'];
  totalSales: Scalars['BigDecimal']['output'];
};

export type ShopifySpecificData = {
  __typename?: 'ShopifySpecificData';
  currency?: Maybe<OrderCheckoutCurrency>;
  discount?: Maybe<Scalars['BigDecimal']['output']>;
  isShowCheckoutCurrency: Scalars['Boolean']['output'];
  orderUrl: Scalars['URL']['output'];
  shipping?: Maybe<Scalars['BigDecimal']['output']>;
  subtotal?: Maybe<Scalars['BigDecimal']['output']>;
  tags: Array<Scalars['String']['output']>;
  total?: Maybe<Scalars['BigDecimal']['output']>;
  totalTax?: Maybe<Scalars['BigDecimal']['output']>;
};

export type ShopifySpecificProductData = {
  __typename?: 'ShopifySpecificProductData';
  amount: Scalars['BigDecimal']['output'];
  price: Scalars['BigDecimal']['output'];
};

export const ShopifySupportedCountry = {
  AC: 'AC',
  AD: 'AD',
  AE: 'AE',
  AF: 'AF',
  AG: 'AG',
  AI: 'AI',
  AL: 'AL',
  AM: 'AM',
  AO: 'AO',
  AR: 'AR',
  AT: 'AT',
  AU: 'AU',
  AW: 'AW',
  AX: 'AX',
  AZ: 'AZ',
  BA: 'BA',
  BB: 'BB',
  BD: 'BD',
  BE: 'BE',
  BF: 'BF',
  BG: 'BG',
  BH: 'BH',
  BI: 'BI',
  BJ: 'BJ',
  BL: 'BL',
  BM: 'BM',
  BN: 'BN',
  BO: 'BO',
  BQ: 'BQ',
  BR: 'BR',
  BS: 'BS',
  BT: 'BT',
  BW: 'BW',
  BY: 'BY',
  BZ: 'BZ',
  CA: 'CA',
  CC: 'CC',
  CD: 'CD',
  CF: 'CF',
  CG: 'CG',
  CH: 'CH',
  CI: 'CI',
  CK: 'CK',
  CL: 'CL',
  CM: 'CM',
  CN: 'CN',
  CO: 'CO',
  CR: 'CR',
  CV: 'CV',
  CW: 'CW',
  CX: 'CX',
  CY: 'CY',
  CZ: 'CZ',
  DE: 'DE',
  DJ: 'DJ',
  DK: 'DK',
  DM: 'DM',
  DO: 'DO',
  DZ: 'DZ',
  EC: 'EC',
  EE: 'EE',
  EG: 'EG',
  EH: 'EH',
  ER: 'ER',
  ES: 'ES',
  ET: 'ET',
  FI: 'FI',
  FJ: 'FJ',
  FK: 'FK',
  FO: 'FO',
  FR: 'FR',
  GA: 'GA',
  GB: 'GB',
  GD: 'GD',
  GE: 'GE',
  GF: 'GF',
  GG: 'GG',
  GH: 'GH',
  GI: 'GI',
  GL: 'GL',
  GM: 'GM',
  GN: 'GN',
  GP: 'GP',
  GQ: 'GQ',
  GR: 'GR',
  GS: 'GS',
  GT: 'GT',
  GW: 'GW',
  GY: 'GY',
  HK: 'HK',
  HN: 'HN',
  HR: 'HR',
  HT: 'HT',
  HU: 'HU',
  ID: 'ID',
  IE: 'IE',
  IL: 'IL',
  IM: 'IM',
  IN: 'IN',
  IO: 'IO',
  IQ: 'IQ',
  IR: 'IR',
  IS: 'IS',
  IT: 'IT',
  JE: 'JE',
  JM: 'JM',
  JO: 'JO',
  JP: 'JP',
  KE: 'KE',
  KG: 'KG',
  KH: 'KH',
  KI: 'KI',
  KM: 'KM',
  KN: 'KN',
  KR: 'KR',
  KW: 'KW',
  KY: 'KY',
  KZ: 'KZ',
  LA: 'LA',
  LB: 'LB',
  LC: 'LC',
  LI: 'LI',
  LK: 'LK',
  LR: 'LR',
  LS: 'LS',
  LT: 'LT',
  LU: 'LU',
  LV: 'LV',
  LY: 'LY',
  MA: 'MA',
  MC: 'MC',
  MD: 'MD',
  ME: 'ME',
  MF: 'MF',
  MG: 'MG',
  MH: 'MH',
  MK: 'MK',
  ML: 'ML',
  MM: 'MM',
  MN: 'MN',
  MO: 'MO',
  MQ: 'MQ',
  MR: 'MR',
  MS: 'MS',
  MT: 'MT',
  MU: 'MU',
  MV: 'MV',
  MW: 'MW',
  MX: 'MX',
  MY: 'MY',
  MZ: 'MZ',
  NA: 'NA',
  NC: 'NC',
  NE: 'NE',
  NF: 'NF',
  NG: 'NG',
  NI: 'NI',
  NL: 'NL',
  NO: 'NO',
  NP: 'NP',
  NR: 'NR',
  NU: 'NU',
  NZ: 'NZ',
  OM: 'OM',
  PA: 'PA',
  PE: 'PE',
  PF: 'PF',
  PG: 'PG',
  PH: 'PH',
  PK: 'PK',
  PL: 'PL',
  PM: 'PM',
  PN: 'PN',
  PS: 'PS',
  PT: 'PT',
  PY: 'PY',
  QA: 'QA',
  RE: 'RE',
  RO: 'RO',
  RS: 'RS',
  RU: 'RU',
  RW: 'RW',
  SA: 'SA',
  SB: 'SB',
  SC: 'SC',
  SD: 'SD',
  SE: 'SE',
  SG: 'SG',
  SH: 'SH',
  SI: 'SI',
  SJ: 'SJ',
  SK: 'SK',
  SL: 'SL',
  SM: 'SM',
  SN: 'SN',
  SO: 'SO',
  SR: 'SR',
  SS: 'SS',
  ST: 'ST',
  SV: 'SV',
  SX: 'SX',
  SZ: 'SZ',
  TC: 'TC',
  TD: 'TD',
  TF: 'TF',
  TG: 'TG',
  TH: 'TH',
  TJ: 'TJ',
  TK: 'TK',
  TL: 'TL',
  TM: 'TM',
  TN: 'TN',
  TO: 'TO',
  TR: 'TR',
  TT: 'TT',
  TV: 'TV',
  TW: 'TW',
  TZ: 'TZ',
  UA: 'UA',
  UG: 'UG',
  UM: 'UM',
  US: 'US',
  UY: 'UY',
  UZ: 'UZ',
  VA: 'VA',
  VC: 'VC',
  VE: 'VE',
  VG: 'VG',
  VN: 'VN',
  VU: 'VU',
  WF: 'WF',
  WS: 'WS',
  XK: 'XK',
  YE: 'YE',
  YT: 'YT',
  ZA: 'ZA',
  ZM: 'ZM',
  ZW: 'ZW'
} as const;

export type ShopifySupportedCountry = typeof ShopifySupportedCountry[keyof typeof ShopifySupportedCountry];
export type SingleImageMessage = {
  __typename?: 'SingleImageMessage';
  originalUrl: Scalars['String']['output'];
  previewUrl: Scalars['String']['output'];
};

export type SingleImageMessageInput = {
  originalUrl: Scalars['String']['input'];
  previewUrl: Scalars['String']['input'];
};

/** Input type for generating all FAQs for a single product. */
export type SingleProductFaqGenerateAllInput = {
  /** The product ID to generate FAQs for. */
  productId: Scalars['ID']['input'];
};

/** Output type for generating all FAQs for a single product. */
export type SingleProductFaqGenerateAllOutput = {
  __typename?: 'SingleProductFaqGenerateAllOutput';
  /** List of generated FAQ items. */
  faqs: Array<SingleProductFaqItemOutput>;
};

/** A single FAQ item generated for a product. */
export type SingleProductFaqItemOutput = {
  __typename?: 'SingleProductFaqItemOutput';
  /** The generated answer for the FAQ. */
  answer?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the FAQ. */
  id: Scalars['String']['output'];
  /** The generated question for the FAQ. */
  question: Scalars['String']['output'];
  /** Comma-separated trigger words for the FAQ. */
  triggerWords?: Maybe<Scalars['String']['output']>;
};

/** Input type for regenerating a single FAQ for a product. */
export type SingleProductFaqRegenerateInput = {
  /** The product FAQ ID to regenerate. */
  productFaqId: Scalars['ID']['input'];
};

export const SocialMediaType = {
  INSTAGRAM: 'INSTAGRAM',
  TIKTOK: 'TIKTOK'
} as const;

export type SocialMediaType = typeof SocialMediaType[keyof typeof SocialMediaType];
/** Sort direction. ASC for ascending order, DESC for descending order. */
export const SortDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];
export const SpecialServiceType = {
  ETD_SIGNATURE_IMAGE_IS_NOT_SUPPORTED: 'ETD_SIGNATURE_IMAGE_IS_NOT_SUPPORTED',
  ETD_SIGNATURE_IMAGE_IS_NOT_UPLOADED: 'ETD_SIGNATURE_IMAGE_IS_NOT_UPLOADED'
} as const;

export type SpecialServiceType = typeof SpecialServiceType[keyof typeof SpecialServiceType];
export type SpecificChatPlatformDetail = InstagramChatPlatformDetail | LazadaChatPlatformDetail | LineChatPlatformDetail | MessengerChatPlatformDetail | ShopeeChatPlatformDetail | TikTokShopChatPlatformDetail | WhatsAppChatPlatformDetail;

export type StartSendingMessengerBroadcastSuccess = {
  __typename?: 'StartSendingMessengerBroadcastSuccess';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type StaticSticker = {
  __typename?: 'StaticSticker';
  url: Scalars['String']['output'];
};

export type StatusOk = {
  __typename?: 'StatusOk';
  ok: Scalars['Boolean']['output'];
};

export const StockType = {
  ALLOCATING: 'ALLOCATING',
  ARRIVING: 'ARRIVING',
  DAMAGED: 'DAMAGED',
  FREE: 'FREE',
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  PREPARING: 'PREPARING',
  WAREHOUSING: 'WAREHOUSING'
} as const;

export type StockType = typeof StockType[keyof typeof StockType];
export type StoreChannelShopifyConnectAdminRequest = {
  accessToken: Scalars['String']['input'];
  storeDomain: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type StoreChannelShopifyConnectRequest = {
  redirectedUrl: Scalars['String']['input'];
};

export type StoreChannelShopifyConnectResponse = {
  __typename?: 'StoreChannelShopifyConnectResponse';
  storeChannelId: Scalars['String']['output'];
  storeId: Scalars['Long']['output'];
};

export type StoreChannelShopifyOauthUrlGenerateResponse = {
  __typename?: 'StoreChannelShopifyOauthUrlGenerateResponse';
  oauthUrl: Scalars['String']['output'];
};

export type StoreChat = {
  createdAt: Scalars['OffsetDateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: ChatType;
};

export type StoreChatLineConnectRequestV2 = {
  channelId: Scalars['String']['input'];
  channelSecret: Scalars['String']['input'];
  keyId: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type StoreChatLineConnectResponseV2 = {
  __typename?: 'StoreChatLineConnectResponseV2';
  storeId: Scalars['Long']['output'];
};

export type StoreChatLineConnectionUpdateRequest = {
  liffUrl: Scalars['Url']['input'];
  storeId: Scalars['Long']['input'];
};

export type StoreChatLinePublicKeyGenerateRequestV2 = {
  storeId: Scalars['Long']['input'];
};

export type StoreChatLinePublicKeyGenerateResponseV2 = {
  __typename?: 'StoreChatLinePublicKeyGenerateResponseV2';
  publicKeyJson: Scalars['String']['output'];
};

export type StoreChatTemplatePlainMessageAddRequest = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  plainText: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
  title: Scalars['String']['input'];
};

export type StoreChatTemplatePlainMessageCategoriesRequest = {
  storeId: Scalars['Long']['input'];
};

export type StoreChatTemplatePlainMessageCategoryCreateRequest = {
  name: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type StoreChatTemplatePlainMessageCategoryDeleteRequest = {
  id: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type StoreChatTemplatePlainMessageCategoryMoveRequest = {
  afterId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type StoreChatTemplatePlainMessageCategoryUpdateRequest = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type StoreChatTemplatePlainMessageMoveRequest = {
  afterId?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type StoreChatTemplatePlainMessageUpdateRequest = {
  id: Scalars['String']['input'];
  plainText: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
  title: Scalars['String']['input'];
};

export type StoreChatTemplatePlainMessagesDeleteRequest = {
  ids: Array<Scalars['String']['input']>;
  storeId: Scalars['Long']['input'];
};

export type StoreChatTemplatePlainMessagesRequest = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  storeId: Scalars['Long']['input'];
};

/** Input for saving store-level BytePlus API credentials. */
export type StoreConnectionByteplusCredentialSaveInput = {
  accessKey: Scalars['String']['input'];
  anyxStoreId: Scalars['ID']['input'];
  secretKey: Scalars['String']['input'];
};

/** Input for deleting a store's platform credential(s). */
export type StoreConnectionDeleteInput = {
  anyxStoreId: Scalars['ID']['input'];
  /** The platform to disconnect. Null deletes ALL credentials of the store. */
  platform?: InputMaybe<SalesChannelType>;
};

/** Result of a store connection deletion. */
export type StoreConnectionDeleteOutput = {
  __typename?: 'StoreConnectionDeleteOutput';
  anyxStoreId: Scalars['ID']['output'];
  /** The platforms whose credentials were actually removed. */
  deletedPlatforms: Array<SalesChannelType>;
};

/** Input for generating a copyable Facebook authorization link for a store. */
export type StoreConnectionFacebookAuthUrlGenerateInput = {
  /** The AnyX store ID the authorization will bind to. */
  anyxStoreId: Scalars['ID']['input'];
  /** Whether the stream target is the user's profile or a managed page. */
  targetType: FacebookTargetType;
};

/** Input for completing a pending Facebook PAGE connection by choosing the page. */
export type StoreConnectionFacebookPageSelectInput = {
  anyxStoreId: Scalars['ID']['input'];
  pageId: Scalars['String']['input'];
};

/** Filter input for store connections. */
export type StoreConnectionFilterInput = {
  /** Restrict to stores of these AnyX account IDs. */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Restrict to stores connected to ANY of these platforms. */
  platforms?: InputMaybe<Array<SalesChannelType>>;
  /** Search by store name. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to these AnyX store IDs. */
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Store connection list type. */
export type StoreConnectionList = PaginatedList & {
  __typename?: 'StoreConnectionList';
  items: Array<StoreConnectionsItemGql>;
  totalCount: Scalars['Int']['output'];
};

/** Input for saving a store-level Rakuten session (cookie + localStorage). */
export type StoreConnectionRakutenCookieSaveInput = {
  anyxStoreId: Scalars['ID']['input'];
  /** Cookie string captured by the browser extension. */
  cookie: Scalars['String']['input'];
  /** localStorage JSON blob captured by the browser extension. */
  localStorage: Scalars['String']['input'];
};

/** Input for generating a copyable Shopee authorization link for a store. */
export type StoreConnectionShopeeAuthUrlGenerateInput = {
  /** The AnyX store ID the authorization will bind to. */
  anyxStoreId: Scalars['ID']['input'];
};

/** Input for saving a hand-harvested Shopee Seller Center session against a store. */
export type StoreConnectionShopeeSessionCookieSaveInput = {
  anyxStoreId: Scalars['ID']['input'];
  /** Set true to move an already-connected store to the shop named by shopeeShopId, in the region named by region. Omit or send null to keep the default re-verification behaviour. The harvested session must still be able to reach that shop; a session that cannot is refused exactly as on a re-verification. Ignored for a store with no connection yet. */
  changeShop?: InputMaybe<Scalars['Boolean']['input']>;
  /** The full cookie set captured by the browser extension, attributes included. */
  cookies: Array<ShopeeSessionCookieInput>;
  /** Ignored; identity is derived from the harvest. Removed once the new frontend is deployed. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Region the cookies were harvested from. Must match the stored connection's region, unless changeShop is true, in which case the store moves to this region. */
  region: AnyLiveRegion;
  /** Shopee shop id for a store being connected for the first time. Ignored when the store already holds a Shopee connection, which resolves its own shop id. */
  shopeeShopId?: InputMaybe<Scalars['Long']['input']>;
  /** Every shop the harvested session can reach. Omit or send null to indicate an older extension build that cannot report the shop list — the shop guard is skipped in that case. When present and non-empty, the list is checked to confirm the session can reach this store's shop. */
  shops?: InputMaybe<Array<ShopeeHarvestedShopInput>>;
  /** Ignored; the store name is derived from the AnyX store. Removed once the new frontend is deployed. */
  storeName?: InputMaybe<Scalars['String']['input']>;
};

/** Sort field for store connections. */
export const StoreConnectionSortField = {
  STORE_ID: 'STORE_ID',
  UPDATED_AT: 'UPDATED_AT'
} as const;

export type StoreConnectionSortField = typeof StoreConnectionSortField[keyof typeof StoreConnectionSortField];
/** Sort input for store connections. */
export type StoreConnectionSortInput = {
  /** Default is descending. */
  direction?: InputMaybe<SortDirection>;
  /** Default is UPDATED_AT (latest credential activity). */
  field?: InputMaybe<StoreConnectionSortField>;
};

export const StoreConnectionStatus = {
  ACTION_REQUIRED: 'ACTION_REQUIRED',
  CONNECTED: 'CONNECTED',
  EXPIRED: 'EXPIRED',
  NOT_CONNECTED: 'NOT_CONNECTED'
} as const;

export type StoreConnectionStatus = typeof StoreConnectionStatus[keyof typeof StoreConnectionStatus];
/** Input for saving a store-level TikTok session cookie. */
export type StoreConnectionTiktokCookieSaveInput = {
  anyxStoreId: Scalars['ID']['input'];
  /** Cookie string captured by the browser extension. */
  cookie: Scalars['String']['input'];
};

/** Result of live-validating one store's platform credential. */
export type StoreConnectionValidateOutput = {
  __typename?: 'StoreConnectionValidateOutput';
  anyxStoreId: Scalars['ID']['output'];
  /** Post-validation connection state, as the storeConnections list would report it. */
  connection: StorePlatformConnectionGql;
  /** VALID: platform accepted the credential. INVALID: platform rejected it — the connection is now ACTION_REQUIRED until re-connected. INCONCLUSIVE: platform unreachable or ambiguous, nothing recorded. NOT_CONNECTED: no credential stored. */
  result: StoreConnectionValidationResult;
};

export const StoreConnectionValidationResult = {
  INCONCLUSIVE: 'INCONCLUSIVE',
  INVALID: 'INVALID',
  NOT_CONNECTED: 'NOT_CONNECTED',
  VALID: 'VALID'
} as const;

export type StoreConnectionValidationResult = typeof StoreConnectionValidationResult[keyof typeof StoreConnectionValidationResult];
/** One store row in Authorization Management, with its status on every platform. */
export type StoreConnectionsItemGql = {
  __typename?: 'StoreConnectionsItemGql';
  accountId?: Maybe<Scalars['ID']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  anyxStoreId: Scalars['ID']['output'];
  /** Always all five platforms; missing credentials appear as NOT_CONNECTED. */
  connections: Array<StorePlatformConnectionGql>;
  /** Federated store entity (account-master resolves its fields). */
  store?: Maybe<MdStore>;
  /** Store name resolved from account-master (null if the lookup failed). */
  storeName?: Maybe<Scalars['String']['output']>;
};

export type StoreList = {
  __typename?: 'StoreList';
  items: Array<MdStore>;
  length: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** A store's connection state on one platform. Credentials themselves are never exposed. */
export type StorePlatformConnectionGql = {
  __typename?: 'StorePlatformConnectionGql';
  /** Best-known deadline: Shopee re-authorization deadline, Facebook user-token expiry. Null for NEVER_EXPIRES / UNKNOWN credentials. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Null when NOT_CONNECTED. */
  expiryType?: Maybe<CredentialExpiryType>;
  /** When a live validation probe (storeConnectionValidate) last proved this credential dead. Non-null forces status ACTION_REQUIRED; cleared by re-connecting or a passing probe. */
  invalidatedAt?: Maybe<Scalars['DateTime']['output']>;
  platform: SalesChannelType;
  /** Which of Shopee's two authorization modes a connected store runs on. Null on every other platform and on a Shopee store with no credential. Read this rather than inferring the mode from expiryType: a session credential carries a stamped deadline of its own, so EXPIRES no longer implies an official grant. */
  shopeeAuthMode?: Maybe<ShopeeAuthMode>;
  status: StoreConnectionStatus;
  /** Display name on the platform: Shopee shop name, Facebook page/user name. */
  targetName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A product from a connected sales channel catalog. */
export type StoreProduct = {
  __typename?: 'StoreProduct';
  /** False when the sales channel refuses this product in a live (TIKTOK only); null when unknown. */
  canAddToLive?: Maybe<Scalars['Boolean']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  /** Product ID from the external marketplace. */
  externalId: Scalars['String']['output'];
  /** URL of the primary product image. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  maxPrice?: Maybe<Scalars['BigDecimal']['output']>;
  minPrice?: Maybe<Scalars['BigDecimal']['output']>;
  name: Scalars['String']['output'];
  /** The sales channel's own formatted price, e.g. "819.000₫" (TIKTOK only). */
  priceLabel?: Maybe<Scalars['String']['output']>;
  salesChannel: SalesChannelType;
  /** When this product was last synced from the sales channel. */
  syncedAt: Scalars['DateTime']['output'];
};

/** A catalogue within a sales channel that groups a store's products (FACEBOOK only). */
export type StoreProductCatalog = {
  __typename?: 'StoreProductCatalog';
  /** Catalogue ID from the external sales channel. */
  catalogId: Scalars['String']['output'];
  catalogName?: Maybe<Scalars['String']['output']>;
};

/** Paginated list of store products. */
export type StoreProductList = {
  __typename?: 'StoreProductList';
  items: Array<StoreProduct>;
  /** When the store's catalogue was last synced from the sales channel. Null when it has never been synced, or for channels fetched live (TIKTOK). */
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type StoreSaleChannel = {
  __typename?: 'StoreSaleChannel';
  id: Scalars['String']['output'];
  type: AnyChatSaleChannelType;
};

/** Settings for a store. A null field means the store has no value set for it. */
export type StoreSetting = {
  __typename?: 'StoreSetting';
  /** Default country of origin applied to the store's products; null when unset */
  countryOfOrigin?: Maybe<ShopifySupportedCountry>;
};

export type StoreSettingCountryOfOriginUpdateOutput = {
  __typename?: 'StoreSettingCountryOfOriginUpdateOutput';
  ok: Scalars['Boolean']['output'];
};

export type StoreWithChanelFilterInput = {
  channelType?: InputMaybe<MarketplaceSaleChannelType>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  masterDataAccountId?: InputMaybe<Scalars['Long']['input']>;
};

export type Story = {
  __typename?: 'Story';
  contentType?: Maybe<Scalars['String']['output']>;
  originalUrl: Scalars['Url']['output'];
};

export type StoryMentionContent = {
  __typename?: 'StoryMentionContent';
  story: Story;
};

/** An additional look (variant) training video, uploaded to BOTH stores. */
export type SubTrainingVideoInput = {
  /** Video duration in seconds; must be at least 60 (1 minute). */
  durationSeconds: Scalars['Int']['input'];
  /** GCS object key (gcsObjectKey) returned by livestreamAvatarTrainingUploadUrls. */
  gcsObjectKey: Scalars['String']['input'];
  /** Green-screen settings for THIS video. Send them only for green-screen footage; OMIT for real-scene footage — no background keying is then applied (omitting does NOT mean defaults). Sending them for real-scene footage keys out every green pixel in the frame. */
  greenScreen?: InputMaybe<GreenScreenParamsInput>;
  /** Variant name; unique per submission. */
  name: Scalars['String']['input'];
  /** OSS object key (ossObjectKey) returned by livestreamAvatarTrainingUploadUrls. */
  ossObjectKey: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Continues an existing AI agent session and streams responses. */
  AIAgentSessionContinue: AiAgentMessageOutput;
  /** [ADMIN, STAFF, MERCHANT] */
  LineChatEventSub?: Maybe<LineChatEvent>;
};


export type SubscriptionAiAgentSessionContinueArgs = {
  input: AiAgentSessionInput;
};


export type SubscriptionLineChatEventSubArgs = {
  input: GetLineChatEventSubRequest;
};

export type Supplier = {
  __typename?: 'Supplier';
  country?: Maybe<Country>;
  created: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  mdAccount?: Maybe<MdAccount>;
  name: Scalars['String']['output'];
  users: Scalars['Int']['output'];
};

export type SupplierDetailed = {
  __typename?: 'SupplierDetailed';
  addressFirst?: Maybe<Scalars['String']['output']>;
  addressSecond?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  id: Scalars['ID']['output'];
  mdAccount?: Maybe<MdAccount>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<PhoneNumber>;
  postalCode?: Maybe<Scalars['String']['output']>;
  provinceId?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
};

export type SupplierFilters = {
  accountId?: InputMaybe<Scalars['Long']['input']>;
  country?: InputMaybe<Country>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type SuppliersPaginated = Paginated & {
  __typename?: 'SuppliersPaginated';
  page: Scalars['Int']['output'];
  records: Array<Supplier>;
  total: Scalars['Int']['output'];
};

export const SupportedManualChannelForManualIntegrationCsv = {
  AU_PAY_MARKET: 'AU_PAY_MARKET',
  FACEBOOK_SHOP: 'FACEBOOK_SHOP',
  MAGASEEK: 'MAGASEEK',
  MAKESHOP_BY_GMO: 'MAKESHOP_BY_GMO',
  MOMO: 'MOMO',
  RAKUTEN_FASHION: 'RAKUTEN_FASHION',
  SHOPLIST: 'SHOPLIST',
  STORES: 'STORES',
  SUPER_DELIVERY: 'SUPER_DELIVERY'
} as const;

export type SupportedManualChannelForManualIntegrationCsv = typeof SupportedManualChannelForManualIntegrationCsv[keyof typeof SupportedManualChannelForManualIntegrationCsv];
export type SyncAnyTagInfluencerRequest = {
  chatId: Scalars['String']['input'];
  influencerId: Scalars['Long']['input'];
};

export type SyncAnyTagInfluencerResponse = {
  __typename?: 'SyncAnyTagInfluencerResponse';
  chatId: Scalars['String']['output'];
  influencerId: Scalars['Long']['output'];
};

export type SystemAutoAssignAi = {
  __typename?: 'SystemAutoAssignAI';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type SystemAutoUnassignAi = {
  __typename?: 'SystemAutoUnassignAI';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type TagFilterInput = {
  tagName: Scalars['String']['input'];
  tagSource: CrmType;
};

export const Temperature = {
  KEEP_FROZEN: 'KEEP_FROZEN',
  KEEP_REFRIGERATED: 'KEEP_REFRIGERATED',
  NORMAL: 'NORMAL'
} as const;

export type Temperature = typeof Temperature[keyof typeof Temperature];
export type TemplatePlainMessage = {
  __typename?: 'TemplatePlainMessage';
  categoryId: Scalars['String']['output'];
  createdAt: Scalars['UnixTimestamp']['output'];
  id: Scalars['String']['output'];
  plainText: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TemplatePlainMessageCategories = {
  __typename?: 'TemplatePlainMessageCategories';
  categories: Array<TemplatePlainMessageCategory>;
};

export type TemplatePlainMessageCategory = {
  __typename?: 'TemplatePlainMessageCategory';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TemplatePlainMessages = {
  __typename?: 'TemplatePlainMessages';
  messages: Array<TemplatePlainMessage>;
  total: Scalars['Int']['output'];
};

export type TestSendGreetingMessageDraftRequest = {
  chatId: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type TextComponent = {
  __typename?: 'TextComponent';
  align?: Maybe<HorizontalAlignment>;
  fontSize: FontSize;
  richText?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  weighted: Scalars['Boolean']['output'];
};

export type TextComponentInput = {
  align?: InputMaybe<HorizontalAlignment>;
  fontSize: FontSize;
  richText?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  weighted: Scalars['Boolean']['input'];
};

export type TextLiveCommentContent = {
  __typename?: 'TextLiveCommentContent';
  text: Scalars['String']['output'];
};

export type TextMessageContent = {
  __typename?: 'TextMessageContent';
  text: Scalars['String']['output'];
};

export type TikTokAdsAdAccountPayload = {
  __typename?: 'TikTokAdsAdAccountPayload';
  advertiserId: Scalars['String']['output'];
  advertiserName: Scalars['String']['output'];
};

export type TikTokAdsAdAccountPayloadList = {
  __typename?: 'TikTokAdsAdAccountPayloadList';
  items: Array<TikTokAdsAdAccountPayload>;
  meta: ReportListMeta;
};

/** Filter input for TikTok all stat export operations */
export type TikTokAllStatExportFilterInput = {
  /** Account IDs */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Average unit price range filter */
  avgUnitPrice?: InputMaybe<BigDecimalRangeInput>;
  /** Buyers count range filter */
  buyersCnt?: InputMaybe<BigDecimalRangeInput>;
  /** Conversion rate range filter */
  coRate?: InputMaybe<BigDecimalRangeInput>;
  /** Creator filter */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** Creator ID filter */
  creatorId?: InputMaybe<Scalars['String']['input']>;
  /** Creator type filter */
  creatorType?: InputMaybe<Scalars['Long']['input']>;
  /** Currency code filter */
  currencyCode?: InputMaybe<Currency>;
  /** Duration range filter */
  duration?: InputMaybe<BigDecimalRangeInput>;
  /** End date range filter */
  endDate?: InputMaybe<DateTimeRangeInput>;
  /** End timestamp range filter */
  endTimestamp?: InputMaybe<DateTimeRangeInput>;
  /** Host type */
  hostType?: InputMaybe<HostType>;
  /** List of record IDs to export */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Items sold count range filter */
  itemsSoldCnt?: InputMaybe<BigDecimalRangeInput>;
  /** Live influenced revenue range filter */
  liveInfluencedRevenue?: InputMaybe<BigDecimalRangeInput>;
  /** Live name filter */
  liveName?: InputMaybe<Scalars['String']['input']>;
  /** Live stream IDs (live_stream.id) to scope the export to — this is the id the dashboard exposes as sessionId, and is NOT the same as `ids`, which filters the stat row's own primary key */
  liveStreamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Local average watch duration range filter */
  localAvgWatchDuration?: InputMaybe<BigDecimalRangeInput>;
  /** Local comments count range filter */
  localCommentsCnt?: InputMaybe<BigDecimalRangeInput>;
  /** Local CTR rate range filter */
  localCtrRate?: InputMaybe<BigDecimalRangeInput>;
  /** Local likes count range filter */
  localLikesCnt?: InputMaybe<BigDecimalRangeInput>;
  /** Local new followers count range filter */
  localNewFollowersCnt?: InputMaybe<BigDecimalRangeInput>;
  /** Local shares count range filter */
  localSharesCnt?: InputMaybe<BigDecimalRangeInput>;
  /** Local viewers count range filter */
  localViewersCnt?: InputMaybe<BigDecimalRangeInput>;
  /** Local views count range filter */
  localViewsCnt?: InputMaybe<BigDecimalRangeInput>;
  /** Nickname filter */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** Orders created count range filter */
  ordersCreatedCnt?: InputMaybe<BigDecimalRangeInput>;
  /** Orders paid count range filter */
  ordersPaidCnt?: InputMaybe<BigDecimalRangeInput>;
  /** Product clicks count range filter */
  productClicksCnt?: InputMaybe<BigDecimalRangeInput>;
  /** Product views count range filter */
  productViewsCnt?: InputMaybe<BigDecimalRangeInput>;
  /** Products count range filter */
  productsCnt?: InputMaybe<BigDecimalRangeInput>;
  /** Products with sales count range filter */
  productsWithSalesCnt?: InputMaybe<BigDecimalRangeInput>;
  /** Revenue range filter */
  revenue?: InputMaybe<BigDecimalRangeInput>;
  /** Room ID filter */
  roomId?: InputMaybe<Scalars['String']['input']>;
  /** Search term */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Shop ID filter */
  shopId?: InputMaybe<Scalars['String']['input']>;
  /** Start date range filter */
  startDate?: InputMaybe<DateTimeRangeInput>;
  /** Start timestamp range filter */
  startTimestamp?: InputMaybe<DateTimeRangeInput>;
  /** Store IDs */
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** TikTok comment data for a live stream. */
export type TikTokComment = {
  __typename?: 'TikTokComment';
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** TikTok comment ID */
  id: Scalars['ID']['output'];
  liveStreamId: Scalars['ID']['output'];
  /** Returns the associated livestream. */
  livestream?: Maybe<LiveStream>;
  messageId: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  roomId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

/** Filter input for livestreamTikTokComments. */
export type TikTokCommentFilterInput = {
  /** LiveStream ID */
  liveStreamId: Scalars['ID']['input'];
  timestamp?: InputMaybe<DateTimeRangeInput>;
};

/** List of TikTok comment data. */
export type TikTokCommentList = PaginatedList & {
  __typename?: 'TikTokCommentList';
  items: Array<TikTokComment>;
  totalCount: Scalars['Int']['output'];
};

/** Sort field for TikTok comments. */
export const TikTokCommentSortField = {
  COMMENT: 'COMMENT',
  CREATED_AT: 'CREATED_AT',
  ID: 'ID',
  MESSAGE_ID: 'MESSAGE_ID',
  NICKNAME: 'NICKNAME',
  ROOM_ID: 'ROOM_ID',
  TIMESTAMP: 'TIMESTAMP',
  USERNAME: 'USERNAME',
  USER_ID: 'USER_ID'
} as const;

export type TikTokCommentSortField = typeof TikTokCommentSortField[keyof typeof TikTokCommentSortField];
/** Sort input for TikTok comments. */
export type TikTokCommentSortInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<TikTokCommentSortField>;
};

/** Filter input for TikTok comments export operations. */
export type TikTokCommentsExportFilterInput = {
  /** LiveStream ID */
  liveStreamId: Scalars['ID']['input'];
  timestamp?: InputMaybe<DateTimeRangeInput>;
};

export type TikTokExchangeCodePayload = {
  __typename?: 'TikTokExchangeCodePayload';
  datasourceTokenId: Scalars['Long']['output'];
};

export type TikTokFileUploadInput = {
  /** start from gs://~~~ */
  fileUri: Scalars['String']['input'];
  saleChannelId: Scalars['Long']['input'];
  type: TikTokFileUploadType;
};

export const TikTokFileUploadType = {
  SESSION: 'SESSION'
} as const;

export type TikTokFileUploadType = typeof TikTokFileUploadType[keyof typeof TikTokFileUploadType];
/** TikTok live stream statistics */
export type TikTokLiveStat = {
  __typename?: 'TikTokLiveStat';
  /** Average unit price */
  avgUnitPrice: AnyLiveMoney;
  /** Average unit price delimited */
  avgUnitPriceDelimited: Scalars['String']['output'];
  /** Buyers count */
  buyersCnt: Scalars['Long']['output'];
  /** Conversion rate */
  coRate: Scalars['BigDecimal']['output'];
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Creator name */
  creator: Scalars['String']['output'];
  /** Creator ID */
  creatorId: Scalars['String']['output'];
  /** Creator type */
  creatorType: Scalars['Long']['output'];
  /** Currency code */
  currencyCode: Scalars['String']['output'];
  /** Currency symbol */
  currencySymbol: Scalars['String']['output'];
  /** Duration in seconds */
  duration: Scalars['Duration']['output'];
  /** End date */
  endDate: Scalars['Date']['output'];
  /** End timestamp */
  endTimestamp: Scalars['DateTime']['output'];
  /** ID */
  id: Scalars['ID']['output'];
  /** Items sold count */
  itemsSoldCnt: Scalars['Long']['output'];
  /** Live influenced revenue */
  liveInfluencedRevenue?: Maybe<AnyLiveMoney>;
  /** Live influenced revenue delimited */
  liveInfluencedRevenueDelimited?: Maybe<Scalars['String']['output']>;
  /** Live stream name */
  liveName: Scalars['String']['output'];
  /** Live stream ID */
  liveStreamId: Scalars['ID']['output'];
  /** Returns the associated livestream. */
  livestream?: Maybe<LiveStream>;
  /** Local average watch duration */
  localAvgWatchDuration: Scalars['Duration']['output'];
  /** Local comments count */
  localCommentsCnt: Scalars['Long']['output'];
  /** Local CTR rate */
  localCtrRate: Scalars['BigDecimal']['output'];
  /** Local likes count */
  localLikesCnt: Scalars['Long']['output'];
  /** Local new followers count */
  localNewFollowersCnt: Scalars['Long']['output'];
  /** Local shares count */
  localSharesCnt: Scalars['Long']['output'];
  /** Local viewers count */
  localViewersCnt: Scalars['Long']['output'];
  /** Local views count */
  localViewsCnt: Scalars['Long']['output'];
  /** Creator nickname */
  nickname: Scalars['String']['output'];
  /** Orders created count */
  ordersCreatedCnt: Scalars['Long']['output'];
  /** Orders paid count */
  ordersPaidCnt: Scalars['Long']['output'];
  /** Product clicks count */
  productClicksCnt: Scalars['Long']['output'];
  /** Product views count */
  productViewsCnt: Scalars['Long']['output'];
  /** Products count */
  productsCnt: Scalars['Long']['output'];
  /** Products with sales count */
  productsWithSalesCnt: Scalars['Long']['output'];
  /** Revenue */
  revenue: AnyLiveMoney;
  /** Revenue delimited */
  revenueDelimited: Scalars['String']['output'];
  /** Room ID */
  roomId: Scalars['String']['output'];
  /** Shop ID */
  shopId: Scalars['String']['output'];
  /** Start date */
  startDate: Scalars['Date']['output'];
  /** Start timestamp */
  startTimestamp: Scalars['DateTime']['output'];
  /** Updated at */
  updatedAt: Scalars['DateTime']['output'];
};

/** Filter input for livestreamTikTokStats. */
export type TikTokLiveStatFilterInput = {
  /** Account IDs */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  avgUnitPrice?: InputMaybe<BigDecimalRangeInput>;
  buyersCnt?: InputMaybe<BigDecimalRangeInput>;
  coRate?: InputMaybe<BigDecimalRangeInput>;
  creator?: InputMaybe<Scalars['String']['input']>;
  creatorId?: InputMaybe<Scalars['String']['input']>;
  creatorType?: InputMaybe<Scalars['Long']['input']>;
  currencyCode?: InputMaybe<Currency>;
  duration?: InputMaybe<BigDecimalRangeInput>;
  endDate?: InputMaybe<DateTimeRangeInput>;
  endTimestamp?: InputMaybe<DateTimeRangeInput>;
  /** Host type */
  hostType?: InputMaybe<HostType>;
  itemsSoldCnt?: InputMaybe<BigDecimalRangeInput>;
  liveInfluencedRevenue?: InputMaybe<BigDecimalRangeInput>;
  liveName?: InputMaybe<Scalars['String']['input']>;
  /** LiveStream ID */
  liveStreamId?: InputMaybe<Scalars['ID']['input']>;
  localAvgWatchDuration?: InputMaybe<BigDecimalRangeInput>;
  localCommentsCnt?: InputMaybe<BigDecimalRangeInput>;
  localCtrRate?: InputMaybe<BigDecimalRangeInput>;
  localLikesCnt?: InputMaybe<BigDecimalRangeInput>;
  localNewFollowersCnt?: InputMaybe<BigDecimalRangeInput>;
  localSharesCnt?: InputMaybe<BigDecimalRangeInput>;
  localViewersCnt?: InputMaybe<BigDecimalRangeInput>;
  localViewsCnt?: InputMaybe<BigDecimalRangeInput>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  ordersCreatedCnt?: InputMaybe<BigDecimalRangeInput>;
  ordersPaidCnt?: InputMaybe<BigDecimalRangeInput>;
  productClicksCnt?: InputMaybe<BigDecimalRangeInput>;
  productViewsCnt?: InputMaybe<BigDecimalRangeInput>;
  productsCnt?: InputMaybe<BigDecimalRangeInput>;
  productsWithSalesCnt?: InputMaybe<BigDecimalRangeInput>;
  revenue?: InputMaybe<BigDecimalRangeInput>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shopId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<DateTimeRangeInput>;
  startTimestamp?: InputMaybe<DateTimeRangeInput>;
  /** Store IDs */
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** TikTok live stream statistics list */
export type TikTokLiveStatList = {
  __typename?: 'TikTokLiveStatList';
  /** Items */
  items: Array<TikTokLiveStat>;
  /** Total count */
  totalCount: Scalars['Int']['output'];
};

/** Sort field for TikTok live stream statistics. */
export const TikTokLiveStatSortField = {
  AVG_UNIT_PRICE: 'AVG_UNIT_PRICE',
  BUYERS_CNT: 'BUYERS_CNT',
  CO_RATE: 'CO_RATE',
  CREATED_AT: 'CREATED_AT',
  CREATOR: 'CREATOR',
  DURATION: 'DURATION',
  END_TIMESTAMP: 'END_TIMESTAMP',
  ID: 'ID',
  ITEMS_SOLD_CNT: 'ITEMS_SOLD_CNT',
  LIVE_INFLUENCED_REVENUE: 'LIVE_INFLUENCED_REVENUE',
  LIVE_NAME: 'LIVE_NAME',
  LOCAL_AVG_WATCH_DURATION: 'LOCAL_AVG_WATCH_DURATION',
  LOCAL_COMMENTS_CNT: 'LOCAL_COMMENTS_CNT',
  LOCAL_CTR_RATE: 'LOCAL_CTR_RATE',
  LOCAL_LIKES_CNT: 'LOCAL_LIKES_CNT',
  LOCAL_NEW_FOLLOWERS_CNT: 'LOCAL_NEW_FOLLOWERS_CNT',
  LOCAL_SHARES_CNT: 'LOCAL_SHARES_CNT',
  LOCAL_VIEWERS_CNT: 'LOCAL_VIEWERS_CNT',
  LOCAL_VIEWS_CNT: 'LOCAL_VIEWS_CNT',
  NICKNAME: 'NICKNAME',
  ORDERS_CREATED_CNT: 'ORDERS_CREATED_CNT',
  ORDERS_PAID_CNT: 'ORDERS_PAID_CNT',
  PRODUCTS_CNT: 'PRODUCTS_CNT',
  PRODUCTS_WITH_SALES_CNT: 'PRODUCTS_WITH_SALES_CNT',
  PRODUCT_CLICKS_CNT: 'PRODUCT_CLICKS_CNT',
  PRODUCT_VIEWS_CNT: 'PRODUCT_VIEWS_CNT',
  REVENUE: 'REVENUE',
  ROOM_ID: 'ROOM_ID',
  START_TIMESTAMP: 'START_TIMESTAMP',
  UPDATED_AT: 'UPDATED_AT'
} as const;

export type TikTokLiveStatSortField = typeof TikTokLiveStatSortField[keyof typeof TikTokLiveStatSortField];
/** Sort input for TikTok live stream statistics. */
export type TikTokLiveStatSortInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<TikTokLiveStatSortField>;
};

/** Filter input for TikTok live stats export operations. */
export type TikTokLiveStatsExportFilterInput = {
  /** Account IDs */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  avgUnitPrice?: InputMaybe<BigDecimalRangeInput>;
  buyersCnt?: InputMaybe<BigDecimalRangeInput>;
  coRate?: InputMaybe<BigDecimalRangeInput>;
  creator?: InputMaybe<Scalars['String']['input']>;
  creatorId?: InputMaybe<Scalars['String']['input']>;
  creatorType?: InputMaybe<Scalars['Long']['input']>;
  currencyCode?: InputMaybe<Currency>;
  duration?: InputMaybe<BigDecimalRangeInput>;
  endDate?: InputMaybe<DateTimeRangeInput>;
  endTimestamp?: InputMaybe<DateTimeRangeInput>;
  /** Host type */
  hostType?: InputMaybe<HostType>;
  /** List of record IDs to export */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemsSoldCnt?: InputMaybe<BigDecimalRangeInput>;
  liveInfluencedRevenue?: InputMaybe<BigDecimalRangeInput>;
  liveName?: InputMaybe<Scalars['String']['input']>;
  /** Live stream IDs (live_stream.id) to scope the export to — this is the id the dashboard exposes as sessionId, and is NOT the same as `ids`, which filters the stat row's own primary key */
  liveStreamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  localAvgWatchDuration?: InputMaybe<BigDecimalRangeInput>;
  localCommentsCnt?: InputMaybe<BigDecimalRangeInput>;
  localCtrRate?: InputMaybe<BigDecimalRangeInput>;
  localLikesCnt?: InputMaybe<BigDecimalRangeInput>;
  localNewFollowersCnt?: InputMaybe<BigDecimalRangeInput>;
  localSharesCnt?: InputMaybe<BigDecimalRangeInput>;
  localViewersCnt?: InputMaybe<BigDecimalRangeInput>;
  localViewsCnt?: InputMaybe<BigDecimalRangeInput>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  ordersCreatedCnt?: InputMaybe<BigDecimalRangeInput>;
  ordersPaidCnt?: InputMaybe<BigDecimalRangeInput>;
  productClicksCnt?: InputMaybe<BigDecimalRangeInput>;
  productViewsCnt?: InputMaybe<BigDecimalRangeInput>;
  productsCnt?: InputMaybe<BigDecimalRangeInput>;
  productsWithSalesCnt?: InputMaybe<BigDecimalRangeInput>;
  revenue?: InputMaybe<BigDecimalRangeInput>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shopId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<DateTimeRangeInput>;
  startTimestamp?: InputMaybe<DateTimeRangeInput>;
  /** Store IDs */
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TikTokLoginUrlV2Input = {
  redirectUri: Scalars['String']['input'];
  region: TikTokRegion;
  storeId: Scalars['Long']['input'];
};

/** TikTok product data for a live stream. */
export type TikTokProduct = {
  __typename?: 'TikTokProduct';
  addShopCartCnt: Scalars['Long']['output'];
  clickOrderRate: Scalars['BigDecimal']['output'];
  clickOrderRateMain: Scalars['BigDecimal']['output'];
  clickThroughRate: Scalars['BigDecimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdOrderCnt: Scalars['Long']['output'];
  currencyCode: Currency;
  currencySymbol: Scalars['String']['output'];
  directGmv: AnyLiveMoney;
  directGmvDelimited: Scalars['String']['output'];
  directSales: Scalars['Long']['output'];
  /** TikTok product ID */
  id: Scalars['ID']['output'];
  inventoryLeftCnt: Scalars['Long']['output'];
  isLive: Scalars['Boolean']['output'];
  isPinned: Scalars['Boolean']['output'];
  liveStreamId: Scalars['ID']['output'];
  /** Returns the associated livestream. */
  livestream?: Maybe<LiveStream>;
  mainAov: AnyLiveMoney;
  mainAovDelimited: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paidMainOrderCnt: Scalars['Long']['output'];
  paidOrderCnt: Scalars['Long']['output'];
  paidUserCnt: Scalars['Long']['output'];
  paymentSuccessRate: Scalars['BigDecimal']['output'];
  platformType: Scalars['Long']['output'];
  productId: Scalars['String']['output'];
  productImpressions: Scalars['Long']['output'];
  roomId: Scalars['String']['output'];
  sellableCountry: Scalars['String']['output'];
  shopId: Scalars['String']['output'];
  source: Scalars['String']['output'];
  tags: Array<Scalars['Long']['output']>;
  totalClickCnt: Scalars['Long']['output'];
  updatedAt: Scalars['DateTime']['output'];
  watchGpm: AnyLiveMoney;
  watchGpmDelimited: Scalars['String']['output'];
};

/** Filter input for livestreamTikTokProducts. */
export type TikTokProductFilterInput = {
  clickThroughRate?: InputMaybe<BigDecimalRangeInput>;
  createdOrderCnt?: InputMaybe<BigDecimalRangeInput>;
  currencyCode?: InputMaybe<Currency>;
  directGmv?: InputMaybe<BigDecimalRangeInput>;
  inventoryLeftCnt?: InputMaybe<BigDecimalRangeInput>;
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** LiveStream ID */
  liveStreamId: Scalars['ID']['input'];
  paidOrderCnt?: InputMaybe<BigDecimalRangeInput>;
  paymentSuccessRate?: InputMaybe<BigDecimalRangeInput>;
  platformType?: InputMaybe<Scalars['Long']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productImpressions?: InputMaybe<BigDecimalRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sellableCountry?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['Long']['input']>>;
};

/** List of TikTok product data. */
export type TikTokProductList = PaginatedList & {
  __typename?: 'TikTokProductList';
  items: Array<TikTokProduct>;
  totalCount: Scalars['Int']['output'];
};

/** Sort field for TikTok products. */
export const TikTokProductSortField = {
  ADD_TO_CART_CNT: 'ADD_TO_CART_CNT',
  AVG_PRICE_MAIN_ORDERS: 'AVG_PRICE_MAIN_ORDERS',
  CLICK_THROUGH_RATE: 'CLICK_THROUGH_RATE',
  CREATED_AT: 'CREATED_AT',
  CREATED_ORDER_CNT: 'CREATED_ORDER_CNT',
  CTOR_MAIN_ORDERS: 'CTOR_MAIN_ORDERS',
  CTOR_SKU_ORDERS: 'CTOR_SKU_ORDERS',
  DIRECT_GMV: 'DIRECT_GMV',
  ID: 'ID',
  INVENTORY_LEFT_CNT: 'INVENTORY_LEFT_CNT',
  IS_LIVE: 'IS_LIVE',
  IS_PINNED: 'IS_PINNED',
  MAIN_ORDERS: 'MAIN_ORDERS',
  NAME: 'NAME',
  PAID_ORDER_CNT: 'PAID_ORDER_CNT',
  PAYMENT_SUCCESS_RATE: 'PAYMENT_SUCCESS_RATE',
  PLATFORM_TYPE: 'PLATFORM_TYPE',
  PRODUCT_CLICKS: 'PRODUCT_CLICKS',
  PRODUCT_ID: 'PRODUCT_ID',
  PRODUCT_IMPRESSIONS: 'PRODUCT_IMPRESSIONS',
  SELLABLE_COUNTRY: 'SELLABLE_COUNTRY',
  SOURCE: 'SOURCE',
  UPDATED_AT: 'UPDATED_AT',
  WATCH_GPM: 'WATCH_GPM'
} as const;

export type TikTokProductSortField = typeof TikTokProductSortField[keyof typeof TikTokProductSortField];
/** Sort input for TikTok products. */
export type TikTokProductSortInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<TikTokProductSortField>;
};

/** Filter input for TikTok products export operations. */
export type TikTokProductsExportFilterInput = {
  clickThroughRate?: InputMaybe<BigDecimalRangeInput>;
  createdOrderCnt?: InputMaybe<BigDecimalRangeInput>;
  currencyCode?: InputMaybe<Currency>;
  directGmv?: InputMaybe<BigDecimalRangeInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  inventoryLeftCnt?: InputMaybe<BigDecimalRangeInput>;
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  livestreamID: Scalars['ID']['input'];
  paidOrderCnt?: InputMaybe<BigDecimalRangeInput>;
  paymentSuccessRate?: InputMaybe<BigDecimalRangeInput>;
  platformType?: InputMaybe<Scalars['Long']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productImpressions?: InputMaybe<BigDecimalRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sellableCountry?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export const TikTokRegion = {
  GB: 'GB',
  ID: 'ID',
  JP: 'JP',
  MY: 'MY',
  PH: 'PH',
  SG: 'SG',
  TH: 'TH',
  VN: 'VN'
} as const;

export type TikTokRegion = typeof TikTokRegion[keyof typeof TikTokRegion];
export type TikTokSaleChannelData = {
  __typename?: 'TikTokSaleChannelData';
  marketplace: TikTokRegion;
  shopId: Scalars['String']['output'];
};

export type TikTokSalesReportChartInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type TikTokSalesReportChartPayload = {
  __typename?: 'TikTokSalesReportChartPayload';
  currency: ReportSupportedCurrency;
  itemsOrdered: Array<Scalars['Map']['output']>;
  sales: Array<Scalars['Map']['output']>;
  unitsOrdered: Array<Scalars['Map']['output']>;
};

export type TikTokSalesReportDetailedReportInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type TikTokSalesReportDetailedReportPayload = {
  __typename?: 'TikTokSalesReportDetailedReportPayload';
  currency: ReportSupportedCurrency;
  date: Scalars['LocalDate']['output'];
  itemsOrdered: Scalars['Long']['output'];
  sales: Scalars['BigDecimal']['output'];
  unitsOrdered: Scalars['Long']['output'];
};

export type TikTokSalesReportDetailedReportPayloadList = {
  __typename?: 'TikTokSalesReportDetailedReportPayloadList';
  items: Array<TikTokSalesReportDetailedReportPayload>;
  meta: ReportListMeta;
  total: TikTokSalesReportDetailedReportTotalPayload;
};

export type TikTokSalesReportDetailedReportTotalPayload = {
  __typename?: 'TikTokSalesReportDetailedReportTotalPayload';
  currency: ReportSupportedCurrency;
  itemsOrdered: Scalars['Long']['output'];
  sales: Scalars['BigDecimal']['output'];
  unitsOrdered: Scalars['Long']['output'];
};

export type TikTokSalesReportSummaryInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type TikTokSalesReportSummaryPayload = {
  __typename?: 'TikTokSalesReportSummaryPayload';
  currency: ReportSupportedCurrency;
  itemsOrdered: NumericValueWithDiffPayload;
  sales: NumericValueWithDiffPayload;
  unitsOrdered: NumericValueWithDiffPayload;
};

export type TikTokShopChatPlatformDetail = {
  __typename?: 'TikTokShopChatPlatformDetail';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type TikTokShopStoreChat = StoreChat & {
  __typename?: 'TikTokShopStoreChat';
  createdAt: Scalars['OffsetDateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tokenUpdatedSuccessfully: Scalars['Boolean']['output'];
  type: ChatType;
};

/** TikTok total traffic source data. */
export type TikTokTotalTrafficSource = {
  __typename?: 'TikTokTotalTrafficSource';
  createdAt: Scalars['DateTime']['output'];
  ctorSkuOrders: Scalars['BigDecimal']['output'];
  enterRoomRate: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  impressions: Scalars['Long']['output'];
  liveGmvAmount: Scalars['BigDecimal']['output'];
  liveGmvDelimited: Scalars['String']['output'];
  liveStreamId: Scalars['ID']['output'];
  /** Returns the associated livestream. */
  livestream?: Maybe<LiveStream>;
  productClickRate: Scalars['BigDecimal']['output'];
  roomId: Scalars['String']['output'];
  shopId: Scalars['String']['output'];
  showGpmAmount: Scalars['BigDecimal']['output'];
  showGpmDelimited: Scalars['String']['output'];
  sourceName: TrafficSourceChannel;
  updatedAt: Scalars['DateTime']['output'];
  views: Scalars['Long']['output'];
};

/** Export filter input for TikTok total traffic source. */
export type TikTokTotalTrafficSourceExportFilterInput = {
  createdAt?: InputMaybe<DateTimeRangeInput>;
  ctorSkuOrders?: InputMaybe<BigDecimalRangeInput>;
  enterRoomRate?: InputMaybe<BigDecimalRangeInput>;
  /** List of record IDs to export */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  impressions?: InputMaybe<BigDecimalRangeInput>;
  liveGmvAmount?: InputMaybe<BigDecimalRangeInput>;
  /** LiveStream ID */
  liveStreamId: Scalars['ID']['input'];
  productClickRate?: InputMaybe<BigDecimalRangeInput>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shopId?: InputMaybe<Scalars['String']['input']>;
  showGpmAmount?: InputMaybe<BigDecimalRangeInput>;
  sourceNames?: InputMaybe<Array<TrafficSourceChannel>>;
  /** Store IDs */
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  views?: InputMaybe<BigDecimalRangeInput>;
};

/** Filter input for TikTok total traffic source queries. */
export type TikTokTotalTrafficSourceFilterInput = {
  createdAt?: InputMaybe<DateTimeRangeInput>;
  ctorSkuOrders?: InputMaybe<BigDecimalRangeInput>;
  enterRoomRate?: InputMaybe<BigDecimalRangeInput>;
  impressions?: InputMaybe<BigDecimalRangeInput>;
  liveGmvAmount?: InputMaybe<BigDecimalRangeInput>;
  /** LiveStream ID */
  liveStreamId?: InputMaybe<Scalars['ID']['input']>;
  productClickRate?: InputMaybe<BigDecimalRangeInput>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shopId?: InputMaybe<Scalars['String']['input']>;
  showGpmAmount?: InputMaybe<BigDecimalRangeInput>;
  sourceNames?: InputMaybe<Array<TrafficSourceChannel>>;
  /** Store IDs */
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  views?: InputMaybe<BigDecimalRangeInput>;
};

/** TikTok total traffic source list. */
export type TikTokTotalTrafficSourceList = {
  __typename?: 'TikTokTotalTrafficSourceList';
  items: Array<TikTokTotalTrafficSource>;
  totalCount: Scalars['Int']['output'];
};

/** Sort field for TikTok total traffic source queries. */
export const TikTokTotalTrafficSourceSortField = {
  CREATED_AT: 'CREATED_AT',
  CTOR_SKU_ORDERS: 'CTOR_SKU_ORDERS',
  ENTER_ROOM_RATE: 'ENTER_ROOM_RATE',
  ID: 'ID',
  IMPRESSIONS: 'IMPRESSIONS',
  LIVE_GMV_AMOUNT: 'LIVE_GMV_AMOUNT',
  LIVE_STREAM_ID: 'LIVE_STREAM_ID',
  PRODUCT_CLICK_RATE: 'PRODUCT_CLICK_RATE',
  ROOM_ID: 'ROOM_ID',
  SHOP_ID: 'SHOP_ID',
  SHOW_GPM_AMOUNT: 'SHOW_GPM_AMOUNT',
  SOURCE_NAME: 'SOURCE_NAME',
  UPDATED_AT: 'UPDATED_AT',
  VIEWS: 'VIEWS'
} as const;

export type TikTokTotalTrafficSourceSortField = typeof TikTokTotalTrafficSourceSortField[keyof typeof TikTokTotalTrafficSourceSortField];
/** Sort input for TikTok total traffic source queries. */
export type TikTokTotalTrafficSourceSortInput = {
  /** Default is descending. */
  direction?: InputMaybe<SortDirection>;
  /** Default is ID. */
  field?: InputMaybe<TikTokTotalTrafficSourceSortField>;
};

/** TikTok traffic source by timestamp gmv data. */
export type TikTokTrafficSourceByTimestampGmv = {
  __typename?: 'TikTokTrafficSourceByTimestampGmv';
  /** Amount */
  amount: Scalars['BigDecimal']['output'];
  /** Amount delimited */
  amountDelimited: Scalars['String']['output'];
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** ID */
  id: Scalars['ID']['output'];
  /** Live stream ID */
  liveStreamId: Scalars['ID']['output'];
  /** Returns the associated livestream. */
  livestream?: Maybe<LiveStream>;
  /** Room ID */
  roomId: Scalars['String']['output'];
  /** Shop ID */
  shopId: Scalars['String']['output'];
  /** Timestamp */
  timestamp: Scalars['DateTime']['output'];
  /** Traffic source channel */
  trafficSourceChannel: TrafficSourceChannel;
  /** Updated at */
  updatedAt: Scalars['DateTime']['output'];
};

/** Filter input for TikTok traffic source by timestamp gmv queries. */
export type TikTokTrafficSourceByTimestampGmvFilterInput = {
  amount?: InputMaybe<BigDecimalRangeInput>;
  createdAt?: InputMaybe<DateTimeRangeInput>;
  /** LiveStream ID */
  liveStreamId?: InputMaybe<Scalars['ID']['input']>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shopId?: InputMaybe<Scalars['String']['input']>;
  /** Store IDs */
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timestamp?: InputMaybe<DateTimeRangeInput>;
  trafficSourceChannels?: InputMaybe<Array<TrafficSourceChannel>>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
};

/** List of TikTok traffic source by timestamp gmv data. */
export type TikTokTrafficSourceByTimestampGmvList = PaginatedList & {
  __typename?: 'TikTokTrafficSourceByTimestampGmvList';
  items: Array<TikTokTrafficSourceByTimestampGmv>;
  totalCount: Scalars['Int']['output'];
};

/** Sort field for TikTok traffic source by timestamp gmv queries. */
export const TikTokTrafficSourceByTimestampGmvSortField = {
  AMOUNT: 'AMOUNT',
  CREATED_AT: 'CREATED_AT',
  ID: 'ID',
  LIVE_STREAM_ID: 'LIVE_STREAM_ID',
  ROOM_ID: 'ROOM_ID',
  SHOP_ID: 'SHOP_ID',
  TIMESTAMP: 'TIMESTAMP',
  TRAFFIC_SOURCE_CHANNEL: 'TRAFFIC_SOURCE_CHANNEL',
  UPDATED_AT: 'UPDATED_AT'
} as const;

export type TikTokTrafficSourceByTimestampGmvSortField = typeof TikTokTrafficSourceByTimestampGmvSortField[keyof typeof TikTokTrafficSourceByTimestampGmvSortField];
/** Sort input for TikTok traffic source by timestamp gmv queries. */
export type TikTokTrafficSourceByTimestampGmvSortInput = {
  /** Default is descending. */
  direction?: InputMaybe<SortDirection>;
  /** Default is ID. */
  field?: InputMaybe<TikTokTrafficSourceByTimestampGmvSortField>;
};

/** TikTok traffic source by timestamp value data. */
export type TikTokTrafficSourceByTimestampValue = {
  __typename?: 'TikTokTrafficSourceByTimestampValue';
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Data type (views or impressions) */
  dataType: Scalars['String']['output'];
  /** ID */
  id: Scalars['ID']['output'];
  /** Live stream ID */
  liveStreamId: Scalars['ID']['output'];
  /** Returns the associated livestream. */
  livestream?: Maybe<LiveStream>;
  /** Room ID */
  roomId: Scalars['String']['output'];
  /** Shop ID */
  shopId: Scalars['String']['output'];
  /** Timestamp */
  timestamp: Scalars['DateTime']['output'];
  /** Traffic source channel */
  trafficSourceChannel: TrafficSourceChannel;
  /** Updated at */
  updatedAt: Scalars['DateTime']['output'];
  /** Value */
  value: Scalars['String']['output'];
};

/** Filter input for TikTok traffic source by timestamp value queries. */
export type TikTokTrafficSourceByTimestampValueFilterInput = {
  createdAt?: InputMaybe<DateTimeRangeInput>;
  /** Data type (views or impressions) */
  dataType?: InputMaybe<Scalars['String']['input']>;
  /** LiveStream ID */
  liveStreamId?: InputMaybe<Scalars['ID']['input']>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shopId?: InputMaybe<Scalars['String']['input']>;
  /** Store IDs */
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timestamp?: InputMaybe<DateTimeRangeInput>;
  trafficSourceChannels?: InputMaybe<Array<TrafficSourceChannel>>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** List of TikTok traffic source by timestamp value data. */
export type TikTokTrafficSourceByTimestampValueList = PaginatedList & {
  __typename?: 'TikTokTrafficSourceByTimestampValueList';
  items: Array<TikTokTrafficSourceByTimestampValue>;
  totalCount: Scalars['Int']['output'];
};

/** Sort field for TikTok traffic source by timestamp value queries. */
export const TikTokTrafficSourceByTimestampValueSortField = {
  CREATED_AT: 'CREATED_AT',
  DATA_TYPE: 'DATA_TYPE',
  ID: 'ID',
  LIVE_STREAM_ID: 'LIVE_STREAM_ID',
  ROOM_ID: 'ROOM_ID',
  SHOP_ID: 'SHOP_ID',
  TIMESTAMP: 'TIMESTAMP',
  TRAFFIC_SOURCE_CHANNEL: 'TRAFFIC_SOURCE_CHANNEL',
  UPDATED_AT: 'UPDATED_AT',
  VALUE: 'VALUE'
} as const;

export type TikTokTrafficSourceByTimestampValueSortField = typeof TikTokTrafficSourceByTimestampValueSortField[keyof typeof TikTokTrafficSourceByTimestampValueSortField];
/** Sort input for TikTok traffic source by timestamp value queries. */
export type TikTokTrafficSourceByTimestampValueSortInput = {
  /** Default is descending. */
  direction?: InputMaybe<SortDirection>;
  /** Default is ID. */
  field?: InputMaybe<TikTokTrafficSourceByTimestampValueSortField>;
};

/** TikTok trend data for a live stream. */
export type TikTokTrend = {
  __typename?: 'TikTokTrend';
  adsCost: Scalars['BigDecimal']['output'];
  adsCostDelimited: Scalars['String']['output'];
  adsGmv: AnyLiveMoney;
  adsGmvDelimited: Scalars['String']['output'];
  adsRoas: Scalars['BigDecimal']['output'];
  avgPriceMainOrders: AnyLiveMoney;
  avgPriceMainOrdersDelimited: Scalars['String']['output'];
  comments: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdSkuOrders: Scalars['Int']['output'];
  ctorMainOrders: Scalars['BigDecimal']['output'];
  ctorSkuOrders: Scalars['BigDecimal']['output'];
  ctr: Scalars['BigDecimal']['output'];
  currencyCode: Currency;
  currencySymbol: Scalars['String']['output'];
  customers: Scalars['Int']['output'];
  directGmv: AnyLiveMoney;
  directGmvDelimited: Scalars['String']['output'];
  enterRoomRate: Scalars['BigDecimal']['output'];
  /** TikTok trend ID */
  id: Scalars['ID']['output'];
  impressions: Scalars['Int']['output'];
  itemSold: Scalars['Int']['output'];
  likes: Scalars['Int']['output'];
  liveStreamId: Scalars['ID']['output'];
  /** Returns the associated livestream. */
  livestream?: Maybe<LiveStream>;
  mainOrders: Scalars['Int']['output'];
  newFollowers: Scalars['Int']['output'];
  paymentRate: Scalars['BigDecimal']['output'];
  productClickRate: Scalars['BigDecimal']['output'];
  productClicks: Scalars['Int']['output'];
  productImpressions: Scalars['Int']['output'];
  roomId: Scalars['String']['output'];
  shares: Scalars['Int']['output'];
  shopId: Scalars['String']['output'];
  showGpm: AnyLiveMoney;
  showGpmDelimited: Scalars['String']['output'];
  skuOrders: Scalars['Int']['output'];
  timestamp: Scalars['DateTime']['output'];
  /** Transcription categories for this trend */
  transcriptionCategory?: Maybe<Array<Scalars['String']['output']>>;
  /** Transcription key points for this trend */
  transcriptionKeypoints?: Maybe<Array<Scalars['String']['output']>>;
  /** Transcription text for this trend */
  transcriptionText?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  viewers: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
  watchGpm: AnyLiveMoney;
  watchGpmDelimited: Scalars['String']['output'];
};

/** Filter input for livestreamTikTokTrends. */
export type TikTokTrendFilterInput = {
  adsGmv?: InputMaybe<BigDecimalRangeInput>;
  avgPriceMainOrders?: InputMaybe<BigDecimalRangeInput>;
  comments?: InputMaybe<BigDecimalRangeInput>;
  createdSkuOrders?: InputMaybe<BigDecimalRangeInput>;
  ctorMainOrders?: InputMaybe<BigDecimalRangeInput>;
  ctorSkuOrders?: InputMaybe<BigDecimalRangeInput>;
  ctr?: InputMaybe<BigDecimalRangeInput>;
  currencyCode?: InputMaybe<Currency>;
  directGmv?: InputMaybe<BigDecimalRangeInput>;
  enterRoomRate?: InputMaybe<BigDecimalRangeInput>;
  impressions?: InputMaybe<BigDecimalRangeInput>;
  itemSold?: InputMaybe<BigDecimalRangeInput>;
  /** LiveStream ID */
  liveStreamId: Scalars['ID']['input'];
  mainOrders?: InputMaybe<BigDecimalRangeInput>;
  newFollowers?: InputMaybe<BigDecimalRangeInput>;
  paymentRate?: InputMaybe<BigDecimalRangeInput>;
  productClickRate?: InputMaybe<BigDecimalRangeInput>;
  productClicks?: InputMaybe<BigDecimalRangeInput>;
  productImpressions?: InputMaybe<BigDecimalRangeInput>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shopId?: InputMaybe<Scalars['String']['input']>;
  showGpm?: InputMaybe<BigDecimalRangeInput>;
  timestamp?: InputMaybe<DateTimeRangeInput>;
  watchGpm?: InputMaybe<BigDecimalRangeInput>;
};

/** List of TikTok trend data. */
export type TikTokTrendList = PaginatedList & {
  __typename?: 'TikTokTrendList';
  items: Array<TikTokTrend>;
  totalCount: Scalars['Int']['output'];
};

/** Sort field for TikTok trends. */
export const TikTokTrendSortField = {
  ADS_GMV: 'ADS_GMV',
  AVG_PRICE_MAIN_ORDERS: 'AVG_PRICE_MAIN_ORDERS',
  COMMENTS: 'COMMENTS',
  CREATED_SKU_ORDERS: 'CREATED_SKU_ORDERS',
  CTOR_MAIN_ORDERS: 'CTOR_MAIN_ORDERS',
  CTOR_SKU_ORDERS: 'CTOR_SKU_ORDERS',
  CTR: 'CTR',
  CUSTOMERS: 'CUSTOMERS',
  DIRECT_GMV: 'DIRECT_GMV',
  ENTER_ROOM_RATE: 'ENTER_ROOM_RATE',
  ID: 'ID',
  IMPRESSIONS: 'IMPRESSIONS',
  ITEM_SOLD: 'ITEM_SOLD',
  LIKES: 'LIKES',
  MAIN_ORDERS: 'MAIN_ORDERS',
  NEW_FOLLOWERS: 'NEW_FOLLOWERS',
  PAYMENT_RATE: 'PAYMENT_RATE',
  PRODUCT_CLICKS: 'PRODUCT_CLICKS',
  PRODUCT_CLICK_RATE: 'PRODUCT_CLICK_RATE',
  PRODUCT_IMPRESSIONS: 'PRODUCT_IMPRESSIONS',
  ROOM_ID: 'ROOM_ID',
  SHARES: 'SHARES',
  SHOP_ID: 'SHOP_ID',
  SHOW_GPM: 'SHOW_GPM',
  SKU_ORDERS: 'SKU_ORDERS',
  TIMESTAMP: 'TIMESTAMP',
  UPDATED_AT: 'UPDATED_AT',
  VIEWS: 'VIEWS',
  WATCH_GPM: 'WATCH_GPM'
} as const;

export type TikTokTrendSortField = typeof TikTokTrendSortField[keyof typeof TikTokTrendSortField];
/** Sort input for TikTok trends. */
export type TikTokTrendSortInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<TikTokTrendSortField>;
};

/** Filter input for TikTok trends export operations. */
export type TikTokTrendsExportFilterInput = {
  adsGmv?: InputMaybe<BigDecimalRangeInput>;
  avgPriceMainOrders?: InputMaybe<BigDecimalRangeInput>;
  comments?: InputMaybe<BigDecimalRangeInput>;
  createdSkuOrders?: InputMaybe<BigDecimalRangeInput>;
  ctorMainOrders?: InputMaybe<BigDecimalRangeInput>;
  ctorSkuOrders?: InputMaybe<BigDecimalRangeInput>;
  ctr?: InputMaybe<BigDecimalRangeInput>;
  currencyCode?: InputMaybe<Currency>;
  directGmv?: InputMaybe<BigDecimalRangeInput>;
  enterRoomRate?: InputMaybe<BigDecimalRangeInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  impressions?: InputMaybe<BigDecimalRangeInput>;
  itemSold?: InputMaybe<BigDecimalRangeInput>;
  livestreamID: Scalars['ID']['input'];
  mainOrders?: InputMaybe<BigDecimalRangeInput>;
  newFollowers?: InputMaybe<BigDecimalRangeInput>;
  paymentRate?: InputMaybe<BigDecimalRangeInput>;
  productClickRate?: InputMaybe<BigDecimalRangeInput>;
  productClicks?: InputMaybe<BigDecimalRangeInput>;
  productImpressions?: InputMaybe<BigDecimalRangeInput>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shopId?: InputMaybe<Scalars['String']['input']>;
  showGpm?: InputMaybe<BigDecimalRangeInput>;
  timestamp?: InputMaybe<DateTimeRangeInput>;
  watchGpm?: InputMaybe<BigDecimalRangeInput>;
};

export type Tiktok = {
  __typename?: 'Tiktok';
  title: Scalars['String']['output'];
  topic: Scalars['String']['output'];
};

export const TiktokLiveTopicGql = {
  BEAUTY_AND_FASHION: 'BEAUTY_AND_FASHION',
  CHAT_AND_INTERVIEW: 'CHAT_AND_INTERVIEW',
  DANCE: 'DANCE',
  EDUCATION: 'EDUCATION',
  FITNESS_AND_SPORTS: 'FITNESS_AND_SPORTS',
  FOOD: 'FOOD',
  GAMING: 'GAMING',
  MUSIC: 'MUSIC',
  NEWS_AND_EVENT: 'NEWS_AND_EVENT',
  SHOPPING: 'SHOPPING'
} as const;

export type TiktokLiveTopicGql = typeof TiktokLiveTopicGql[keyof typeof TiktokLiveTopicGql];
/** TikTok-specific configuration for a livestream session. */
export type TiktokSessionConfigInput = {
  title: Scalars['String']['input'];
  topic: TiktokLiveTopicGql;
};

export type TimeInput = {
  hour: Scalars['Int']['input'];
  minute: Scalars['Int']['input'];
};

export type TokopediaFileUploadInput = {
  /** start from gs://~~~ */
  fileUri: Scalars['String']['input'];
  saleChannelId: Scalars['Long']['input'];
  type: TokopediaFileUploadType;
};

export const TokopediaFileUploadType = {
  AD_COST_ADS: 'AD_COST_ADS',
  INVENTORY_REPORT: 'INVENTORY_REPORT',
  SALES_REPORT: 'SALES_REPORT',
  SESSION: 'SESSION'
} as const;

export type TokopediaFileUploadType = typeof TokopediaFileUploadType[keyof typeof TokopediaFileUploadType];
export type TokopediaSaleChannelCreateInput = {
  domain: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type TokopediaSaleChannelData = {
  __typename?: 'TokopediaSaleChannelData';
  domain?: Maybe<Scalars['String']['output']>;
  isPending: Scalars['Boolean']['output'];
  linkedTikTokSaleChannelId?: Maybe<Scalars['Long']['output']>;
  tikTokShopId?: Maybe<Scalars['String']['output']>;
};

export type TokopediaSaleChannelLinkTikTokInput = {
  storeId: Scalars['Long']['input'];
  tiktokSaleChannelId: Scalars['Long']['input'];
};

export type TokopediaSaleChannelReconnectInput = {
  saleChannelId: Scalars['Long']['input'];
};

export type TokopediaSalesChartInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type TokopediaSalesChartPayload = {
  __typename?: 'TokopediaSalesChartPayload';
  currency: ReportSupportedCurrency;
  orders: Array<Scalars['Map']['output']>;
  sales: Array<Scalars['Map']['output']>;
};

export type TokopediaSalesDetailedReportInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type TokopediaSalesDetailedReportPayload = {
  __typename?: 'TokopediaSalesDetailedReportPayload';
  currency: ReportSupportedCurrency;
  date: Scalars['LocalDate']['output'];
  orders: Scalars['Long']['output'];
  sales: Scalars['BigDecimal']['output'];
};

export type TokopediaSalesDetailedReportPayloadList = {
  __typename?: 'TokopediaSalesDetailedReportPayloadList';
  items: Array<TokopediaSalesDetailedReportPayload>;
  meta: ReportListMeta;
  total: TokopediaSalesDetailedReportTotalPayload;
};

export type TokopediaSalesDetailedReportTotalPayload = {
  __typename?: 'TokopediaSalesDetailedReportTotalPayload';
  currency: ReportSupportedCurrency;
  orders: Scalars['Long']['output'];
  sales: Scalars['BigDecimal']['output'];
};

export type TokopediaSalesSummaryInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type TokopediaSalesSummaryPayload = {
  __typename?: 'TokopediaSalesSummaryPayload';
  currency: ReportSupportedCurrency;
  orders: NumericValueWithDiffPayload;
  sales: NumericValueWithDiffPayload;
};

export type TrackingUrl = {
  __typename?: 'TrackingUrl';
  originalUrl: Scalars['Url']['output'];
  shortUrl?: Maybe<Scalars['Url']['output']>;
  trackingUrl: Scalars['Url']['output'];
};

/** Top-N selector for the traffic matrix. */
export const TrafficMatrixLimit = {
  ALL: 'ALL',
  TOP10: 'TOP10'
} as const;

export type TrafficMatrixLimit = typeof TrafficMatrixLimit[keyof typeof TrafficMatrixLimit];
export const TrafficSourceChannel = {
  FOLLOWING: 'FOLLOWING',
  FOLLOWING_LIVE_PREVIEW: 'FOLLOWING_LIVE_PREVIEW',
  FOLLOWING_LIVE_PROFILE_PHOTO: 'FOLLOWING_LIVE_PROFILE_PHOTO',
  FOLLOWING_TOP_ROW_PROFILE: 'FOLLOWING_TOP_ROW_PROFILE',
  FOR_YOU_FEED: 'FOR_YOU_FEED',
  FOR_YOU_FEED_LIVE_PREVIEW: 'FOR_YOU_FEED_LIVE_PREVIEW',
  FOR_YOU_FEED_LIVE_SWIPE: 'FOR_YOU_FEED_LIVE_SWIPE',
  FOR_YOU_FEED_OTHERS_VIDEO_PROFILES: 'FOR_YOU_FEED_OTHERS_VIDEO_PROFILES',
  FOR_YOU_FEED_VIDEO_PROFILE_TAPS: 'FOR_YOU_FEED_VIDEO_PROFILE_TAPS',
  INBOX: 'INBOX',
  LIVE_FEED: 'LIVE_FEED',
  OTHER_CHANNELS: 'OTHER_CHANNELS',
  SEARCH: 'SEARCH',
  SHOP_TAB: 'SHOP_TAB',
  SHOP_TAB_LIVE_PREVIEW: 'SHOP_TAB_LIVE_PREVIEW',
  SHOP_TAB_LIVE_SWIPE: 'SHOP_TAB_LIVE_SWIPE',
  TRAFFIC_SOURCE_CHANNEL_UNSPECIFIED: 'TRAFFIC_SOURCE_CHANNEL_UNSPECIFIED'
} as const;

export type TrafficSourceChannel = typeof TrafficSourceChannel[keyof typeof TrafficSourceChannel];
/** The main training video, uploaded to BOTH stores via livestreamAvatarTrainingUploadUrls. */
export type TrainingVideoInput = {
  /** Video duration in seconds; must be at least 180 (3 minutes). */
  durationSeconds: Scalars['Int']['input'];
  /** GCS object key (gcsObjectKey) returned by livestreamAvatarTrainingUploadUrls. */
  gcsObjectKey: Scalars['String']['input'];
  /** Green-screen settings for THIS video. Send them only for green-screen footage; OMIT for real-scene footage — no background keying is then applied (omitting does NOT mean defaults). Sending them for real-scene footage keys out every green pixel in the frame. */
  greenScreen?: InputMaybe<GreenScreenParamsInput>;
  /** OSS object key (ossObjectKey) returned by livestreamAvatarTrainingUploadUrls. */
  ossObjectKey: Scalars['String']['input'];
};

export const TrainingVideoRole = {
  MAIN: 'MAIN',
  SUB: 'SUB'
} as const;

export type TrainingVideoRole = typeof TrainingVideoRole[keyof typeof TrainingVideoRole];
/** A room's Q&A opening/closing transition scripts, with counts per kind. */
export type TransitionQaScriptList = {
  __typename?: 'TransitionQaScriptList';
  /** Number of CLOSING scripts. */
  closingCount: Scalars['Int']['output'];
  items: Array<TransitionScriptGql>;
  /** Number of OPENING scripts. */
  openingCount: Scalars['Int']['output'];
};

/** Input for adding a transition script to a livestream room. */
export type TransitionScriptAddInput = {
  /** Q&A flow position. OPENING phrases are played before the answer body; CLOSING phrases are played after. Fixed at creation — re-targeting a script requires delete + add. */
  kind: TransitionScriptKind;
  /** The ID of the livestream room. */
  roomId: Scalars['ID']['input'];
  /** Script text (max 100 characters). */
  text: Scalars['String']['input'];
};

/** Payload returned after deleting a transition script. */
export type TransitionScriptDeletePayload = {
  __typename?: 'TransitionScriptDeletePayload';
  /** Deleted transition script ID. */
  id: Scalars['ID']['output'];
};

/** Payload returned after triggering TTS generation for a transition script. */
export type TransitionScriptGenerateTtsPayload = {
  __typename?: 'TransitionScriptGenerateTtsPayload';
  /** Transition script ID. */
  id: Scalars['ID']['output'];
  transitionScript: TransitionScriptGql;
};

/** Transition script for inter-product commentary or Q&A flow position in a livestream room. */
export type TransitionScriptGql = {
  __typename?: 'TransitionScriptGql';
  /** Character count of the script text. */
  characterCount: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** True when the script text or the room's voice/speed/pitch/emotion has changed since ttsGenerationId's audio was generated. The existing audio still plays — this only signals that a regenerate is available. */
  isStale: Scalars['Boolean']['output'];
  /** Q&A flow position. OPENING phrases are played before the answer body; CLOSING phrases are played after. */
  kind: TransitionScriptKind;
  roomId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  /** TTS generation ID for this script's most recent audio. Poll status/signed URL/voice via Query.ttsInfo(ttsId) or Query.ttsInfos(ttsIds, contentType: TRANSITION_QA_SCRIPT). */
  ttsGenerationId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['String']['output'];
  /** Signed download URL for the uploaded voice reply audio, or null when none is attached. */
  voiceReplySignedUrl?: Maybe<Scalars['Url']['output']>;
  /** Uploaded audio file URL, if any. Mutually exclusive with ttsGenerationId. */
  voiceReplyUrl?: Maybe<Scalars['String']['output']>;
};

export const TransitionScriptKind = {
  CLOSING: 'CLOSING',
  OPENING: 'OPENING'
} as const;

export type TransitionScriptKind = typeof TransitionScriptKind[keyof typeof TransitionScriptKind];
/** Payload returned after adding or updating a transition script. */
export type TransitionScriptMutationPayload = {
  __typename?: 'TransitionScriptMutationPayload';
  /** Transition script ID. */
  id: Scalars['ID']['output'];
  transitionScript: TransitionScriptGql;
};

/** Input for updating a transition script's text. */
export type TransitionScriptUpdateInput = {
  /** The ID of the transition script to update. */
  id: Scalars['ID']['input'];
  /** New script text (max 100 characters). */
  text: Scalars['String']['input'];
};

/** Input for generating a signed URL for transition script voice reply audio upload. */
export type TransitionScriptVoiceUploadInput = {
  /** Name of the audio file to be uploaded. */
  fileName: Scalars['String']['input'];
  /** Transition script ID. */
  id: Scalars['ID']['input'];
  /** MIME type of the audio file. */
  mimeType: LivestreamRoomFaqAudioSupportedMimeType;
  mimeTypeDomain: MimeType;
};

/** Input for saving the voice reply URL of a transition script after audio upload. */
export type TransitionScriptVoiceUrlUpdateInput = {
  /** Transition script ID. */
  id: Scalars['ID']['input'];
  /** GCS URL of the uploaded audio file (gs:// format). */
  voiceReplyUrl: Scalars['String']['input'];
};

export type TrendChart = {
  __typename?: 'TrendChart';
  data: Array<TrendChartData>;
  total: Scalars['Int']['output'];
};

export type TrendChartData = {
  __typename?: 'TrendChartData';
  date: Scalars['Time']['output'];
  value: Scalars['Int']['output'];
};

/** Supported audio formats for TTS output */
export const TtsAudioFormat = {
  M4A: 'M4A',
  MP3: 'MP3',
  WAV: 'WAV'
} as const;

export type TtsAudioFormat = typeof TtsAudioFormat[keyof typeof TtsAudioFormat];
/** Supported languages for TTS audio */
export const TtsAudioLanguage = {
  AR_SA: 'AR_SA',
  EN_US: 'EN_US',
  FIL_PH: 'FIL_PH',
  HI_IN: 'HI_IN',
  ID_ID: 'ID_ID',
  JA_JP: 'JA_JP',
  MS_MY: 'MS_MY',
  TH_TH: 'TH_TH',
  VI_VN: 'VI_VN',
  ZH_CN: 'ZH_CN',
  ZH_TW: 'ZH_TW',
  ZH_YUE: 'ZH_YUE'
} as const;

export type TtsAudioLanguage = typeof TtsAudioLanguage[keyof typeof TtsAudioLanguage];
/** Input for TTS batch download request */
export type TtsBatchDownloadInput = {
  /** The content type of the TTS generations */
  contentType: TtsContentType;
  /** The TTS generation IDs to download as a zip file */
  ttsGenerationIds: Array<Scalars['ID']['input']>;
};

/** Output for TTS batch download request */
export type TtsBatchDownloadOutput = {
  __typename?: 'TtsBatchDownloadOutput';
  zipUrl: Scalars['Url']['output'];
};

/** Bulk cancel input for TTS generations. */
export type TtsCancelBulkInput = {
  /** The content type of the TTS generations. */
  contentType: TtsContentType;
  /** TTS generation IDs. */
  ids: Array<Scalars['ID']['input']>;
};

/** Output for TTS generation bulk cancel operation. */
export type TtsCancelBulkOutput = {
  __typename?: 'TtsCancelBulkOutput';
  /** IDs of the cancelled TTS generations. */
  ids: Array<Scalars['ID']['output']>;
};

/** Content type for TTS generation authorization */
export const TtsContentType = {
  ATMOSPHERE_SCRIPT: 'ATMOSPHERE_SCRIPT',
  CLOSING_SCRIPT: 'CLOSING_SCRIPT',
  FAQ_CUSTOM_VIDEO_SCRIPT: 'FAQ_CUSTOM_VIDEO_SCRIPT',
  GENERAL_FAQ: 'GENERAL_FAQ',
  PRODUCT_FAQ: 'PRODUCT_FAQ',
  ROOM_GENERAL_FAQ: 'ROOM_GENERAL_FAQ',
  ROOM_PRODUCT_FAQ: 'ROOM_PRODUCT_FAQ',
  SCRIPT: 'SCRIPT',
  TRANSITION_QA_SCRIPT: 'TRANSITION_QA_SCRIPT'
} as const;

export type TtsContentType = typeof TtsContentType[keyof typeof TtsContentType];
export const TtsEmotion = {
  ANGRY: 'ANGRY',
  DISGUSTED: 'DISGUSTED',
  FEARFUL: 'FEARFUL',
  HAPPY: 'HAPPY',
  NEUTRAL: 'NEUTRAL',
  SAD: 'SAD',
  SURPRISED: 'SURPRISED'
} as const;

export type TtsEmotion = typeof TtsEmotion[keyof typeof TtsEmotion];
/** Input for TTS FAQ generation request */
export type TtsFaqGenerationInput = {
  /** The text content to generate TTS for */
  content: Scalars['String']['input'];
  /** The FAQ content ID to update and generate TTS for */
  scriptFaqContentId: Scalars['ID']['input'];
  /** The speed of the voice (0.5 to 2.0, default 1.0 when not specified) */
  speed?: InputMaybe<Scalars['Float']['input']>;
  /** The voice clone ID to use for TTS generation */
  voiceId: Scalars['ID']['input'];
};

/** Input for bulk general FAQ TTS generation request */
export type TtsGeneralFaqGenerateBulkInput = {
  /** List of items to generate TTS for */
  items: Array<TtsGeneralFaqGenerateBulkItemInput>;
  /** The voice clone ID to use for TTS generation */
  voiceId: Scalars['ID']['input'];
};

/** Input for a single item in bulk general FAQ TTS generation */
export type TtsGeneralFaqGenerateBulkItemInput = {
  /** The text content to generate TTS for */
  content: Scalars['String']['input'];
  /** The general FAQ ID to update and generate TTS for */
  generalFaqId: Scalars['ID']['input'];
  /** Voice pitch adjustment (-12 to 12). Only supported for languages with pitch adjustment enabled. */
  pitch?: InputMaybe<Scalars['Int']['input']>;
  /** The speed of the voice (0.5 to 2.0, default 1.0 when not specified) */
  speed?: InputMaybe<Scalars['Float']['input']>;
};

/** Input for TTS generation from general FAQ content */
export type TtsGeneralFaqGenerationInput = {
  /** The text content to generate TTS for */
  content: Scalars['String']['input'];
  /** The general FAQ ID to update and generate TTS for */
  generalFaqId: Scalars['ID']['input'];
  /** The speed of the voice (0.5 to 2.0, default 1.0 when not specified) */
  speed?: InputMaybe<Scalars['Float']['input']>;
  /** The voice clone ID to use for TTS generation */
  voiceId: Scalars['ID']['input'];
};

/** Input for bulk TTS generation request */
export type TtsGenerateBulkInput = {
  /** List of items to generate TTS for */
  items: Array<TtsGenerateBulkItemInput>;
  /** The voice clone ID to use for TTS generation */
  voiceId: Scalars['ID']['input'];
};

/** Input for a single item in bulk TTS generation */
export type TtsGenerateBulkItemInput = {
  /** The text content to generate TTS for */
  content: Scalars['String']['input'];
  /** Voice emotion for MiniMax TTS (happy, sad, angry, fearful, disgusted, surprised, neutral). */
  emotion?: InputMaybe<Scalars['String']['input']>;
  /** Voice pitch adjustment (-12 to 12). Only supported for languages with pitch adjustment enabled. */
  pitch?: InputMaybe<Scalars['Int']['input']>;
  /** The script content ID to update and generate TTS for */
  scriptContentId: Scalars['ID']['input'];
  /** The speed of the voice (0.5 to 2.0, default 1.0 when not specified) */
  speed?: InputMaybe<Scalars['Float']['input']>;
};

/** Output for bulk TTS generation request */
export type TtsGenerateBulkOutput = {
  __typename?: 'TtsGenerateBulkOutput';
  /** List of generated TTS items. */
  items: Array<TtsGenerationOutput>;
};

/** Input for TTS generation request */
export type TtsGenerationInput = {
  /** The text content to generate TTS for */
  content: Scalars['String']['input'];
  /** Voice emotion for MiniMax TTS (happy, sad, angry, fearful, disgusted, surprised, neutral). */
  emotion?: InputMaybe<Scalars['String']['input']>;
  /** Voice pitch adjustment (-12 to 12). Only supported for languages with pitch adjustment enabled. */
  pitch?: InputMaybe<Scalars['Int']['input']>;
  /** The script content ID to update and generate TTS for */
  scriptContentId: Scalars['ID']['input'];
  /** The speed of the voice (0.5 to 2.0, default 1.0 when not specified) */
  speed?: InputMaybe<Scalars['Float']['input']>;
  /** The voice clone ID to use for TTS generation */
  voiceId: Scalars['ID']['input'];
};

/** Output for TTS generation request */
export type TtsGenerationOutput = {
  __typename?: 'TtsGenerationOutput';
  status: TtsStatus;
  ttsId: Scalars['ID']['output'];
};

/** Combined output for TTS status and URL information */
export type TtsInfoOutput = {
  __typename?: 'TtsInfoOutput';
  /** The emotion of the voice (happy, sad, angry, fearful, disgusted, surprised, neutral) */
  emotion?: Maybe<Scalars['String']['output']>;
  /** The TTS generation ID. */
  id: Scalars['ID']['output'];
  /** The pitch adjustment of the voice (-12 to 12) */
  pitch?: Maybe<Scalars['Int']['output']>;
  /** Per-sentence clips, including the text with pronunciation rules applied. Resolved lazily; batched per request. Empty until generation completes. */
  sentences: Array<TtsSentenceClipOutput>;
  signedUrl?: Maybe<Scalars['String']['output']>;
  /** The speed of the voice (0.5 to 2.0) */
  speed?: Maybe<Scalars['Float']['output']>;
  status: TtsStatus;
  voiceId?: Maybe<Scalars['ID']['output']>;
};

/** TTS language configuration. */
export type TtsLanguageConfig = {
  __typename?: 'TtsLanguageConfig';
  consentAudioGuideUrl?: Maybe<Scalars['Url']['output']>;
  language: TtsAudioLanguage;
  maxDurationSecond: Scalars['Int']['output'];
  maxSizeMB: Scalars['Int']['output'];
  maxTtsSpeed: Scalars['BigDecimal']['output'];
  minDurationSecond: Scalars['Int']['output'];
  minTtsSpeed: Scalars['BigDecimal']['output'];
  shouldUploadConsentAudio: Scalars['Boolean']['output'];
  supportedFormat: Array<TtsAudioFormat>;
  voiceEmotionEnabled: Scalars['Boolean']['output'];
  voicePitchAdjustmentEnabled: Scalars['Boolean']['output'];
};

/** Input for bulk product FAQ TTS generation request */
export type TtsProductFaqGenerateBulkInput = {
  /** List of items to generate TTS for */
  items: Array<TtsProductFaqGenerateBulkItemInput>;
  /** The voice clone ID to use for TTS generation */
  voiceId: Scalars['ID']['input'];
};

/** Input for a single item in bulk product FAQ TTS generation */
export type TtsProductFaqGenerateBulkItemInput = {
  /** The text content to generate TTS for */
  content: Scalars['String']['input'];
  /** Voice pitch adjustment (-12 to 12). Only supported for languages with pitch adjustment enabled. */
  pitch?: InputMaybe<Scalars['Int']['input']>;
  /** The product FAQ ID to update and generate TTS for */
  productFaqId: Scalars['ID']['input'];
  /** The speed of the voice (0.5 to 2.0, default 1.0 when not specified) */
  speed?: InputMaybe<Scalars['Float']['input']>;
};

/** Input for TTS generation from product FAQ content */
export type TtsProductFaqGenerationInput = {
  /** The text content to generate TTS for */
  content: Scalars['String']['input'];
  /** The product FAQ ID to update and generate TTS for */
  productFaqId: Scalars['ID']['input'];
  /** The speed of the voice (0.5 to 2.0, default 1.0 when not specified) */
  speed?: InputMaybe<Scalars['Float']['input']>;
  /** The voice clone ID to use for TTS generation */
  voiceId: Scalars['ID']['input'];
};

/** A single sentence clip of a TTS generation. */
export type TtsSentenceClipOutput = {
  __typename?: 'TtsSentenceClipOutput';
  /** The sentence with pronunciation dictionary rules applied. Null when no rules apply. */
  replacedText?: Maybe<Scalars['String']['output']>;
  sentenceIndex: Scalars['Int']['output'];
  /** A signed URL for the per-sentence audio clip. Null when the worker did not provide per-sentence audio. */
  signedAudioUrl?: Maybe<Scalars['String']['output']>;
  /** The original sentence text. */
  text: Scalars['String']['output'];
};

export const TtsStatus = {
  CANCELLED: 'CANCELLED',
  DONE: 'DONE',
  FAILED: 'FAILED',
  NOT_REQUESTED: 'NOT_REQUESTED',
  PROCESSING: 'PROCESSING'
} as const;

export type TtsStatus = typeof TtsStatus[keyof typeof TtsStatus];
/** Supported MIME types for TTS voice file uploads. */
export const TtsSupportedMimeType = {
  /** audio/m4a */
  AUDIO_M4A: 'AUDIO_M4A',
  /** audio/mp3 */
  AUDIO_MP3: 'AUDIO_MP3',
  /** audio/wav */
  AUDIO_WAV: 'AUDIO_WAV'
} as const;

export type TtsSupportedMimeType = typeof TtsSupportedMimeType[keyof typeof TtsSupportedMimeType];
/** TTS voice clone data. */
export type TtsVoiceClone = {
  __typename?: 'TtsVoiceClone';
  createdAt: Scalars['DateTime']['output'];
  /** Error code associated with failed voice clone operations */
  errorCode?: Maybe<VoiceCloneErrorCode>;
  id: Scalars['ID']['output'];
  language: TtsAudioLanguage;
  status: TtsVoiceCloneStatus;
  userId: Scalars['Long']['output'];
  voiceName: Scalars['String']['output'];
};

/** Input for creating a TTS voice clone */
export type TtsVoiceCloneCreateInput = {
  /** Language for the voice */
  language: TtsAudioLanguage;
  /** Name of the voice clone */
  voiceName: Scalars['String']['input'];
  /** URL of the voice sample file */
  voiceUrl: Scalars['String']['input'];
};

/** Bulk Delete Input for TTS voice clone. */
export type TtsVoiceCloneDeleteBulkInput = {
  /** TTS voice clone IDs. */
  ids: Array<Scalars['ID']['input']>;
};

/** Output for TTS voice clone bulk delete operation. */
export type TtsVoiceCloneDeleteBulkOutput = {
  __typename?: 'TtsVoiceCloneDeleteBulkOutput';
  /** IDs of the deleted TTS voice clones. */
  ids: Array<Scalars['ID']['output']>;
};

/** Filter input for TTS voice clones. */
export type TtsVoiceCloneFilterInput = {
  createdAt?: InputMaybe<DateTimeRangeInput>;
  /** When false, returns only voice clones that have no pronunciation dictionary (for the create-dictionary picker); when true, only those that do. Omit to ignore. */
  hasDictionary?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<TtsAudioLanguage>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TtsVoiceCloneStatus>;
};

/** Paginated list of TTS voice clones. */
export type TtsVoiceCloneList = {
  __typename?: 'TtsVoiceCloneList';
  items: Array<TtsVoiceClone>;
  totalCount: Scalars['Int']['output'];
};

/** Output for TTS voice clone operations */
export type TtsVoiceCloneOutput = {
  __typename?: 'TtsVoiceCloneOutput';
  /** ID of the created/updated voice clone */
  id: Scalars['ID']['output'];
};

export type TtsVoiceCloneRenameInput = {
  /** TTS voice clone ID */
  id: Scalars['ID']['input'];
  /** Voice name */
  voiceName: Scalars['String']['input'];
};

/** Status of TTS voice cloning process */
export const TtsVoiceCloneStatus = {
  DONE: 'DONE',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING'
} as const;

export type TtsVoiceCloneStatus = typeof TtsVoiceCloneStatus[keyof typeof TtsVoiceCloneStatus];
/** Input for generating a signed URL for TTS voice file upload */
export type TtsVoiceUploadInput = {
  /** Name of the voice file to be uploaded */
  fileName: Scalars['String']['input'];
  /** MIME type of the voice file (MP3, WAV, or M4A) */
  mimeType: TtsSupportedMimeType;
};

/** Output containing the signed URL for TTS voice file upload */
export type TtsVoiceUploadOutput = {
  __typename?: 'TtsVoiceUploadOutput';
  /** Signed URL for uploading the voice file */
  signedUrl: Scalars['Url']['output'];
};

export type UpsAccountCharacteristicsInput = {
  customerClassification: CustomerClassificationType;
  customerName: CustomerName;
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsAccountDetails = {
  __typename?: 'UPSAccountDetails';
  upsAccountNumber?: Maybe<Scalars['String']['output']>;
};

export type UpsAddress = {
  addressFirst: Scalars['String']['input'];
  addressSecond?: InputMaybe<Scalars['String']['input']>;
  addressType: UpsAddressType;
  city?: InputMaybe<Scalars['String']['input']>;
  country: Country;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
};

export const UpsAddressType = {
  BUSINESS: 'BUSINESS'
} as const;

export type UpsAddressType = typeof UpsAddressType[keyof typeof UpsAddressType];
export type UpsBillingInformation = {
  billingAddress: UpsAddress;
  billingContactName: CustomerName;
  billingEmail: Scalars['String']['input'];
  billingPhone: UpsPhone;
};

export const UpsContactType = {
  BUSINESS: 'BUSINESS'
} as const;

export type UpsContactType = typeof UpsContactType[keyof typeof UpsContactType];
export type UpsOpenAccountInput = {
  accountCharacteristics: UpsAccountCharacteristicsInput;
  address: UpsAddress;
  billingInformation: UpsBillingInformation;
  businessName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
  phone: UpsPhone;
  pickupInformation: UpsPickupInformation;
};

export type UpsPath = {
  __typename?: 'UPSPath';
  courierID: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type UpsPhone = {
  countryCode: Country;
  number: Scalars['String']['input'];
  phoneType?: InputMaybe<UpsPhoneType>;
};

export const UpsPhoneType = {
  BUSINESS: 'BUSINESS'
} as const;

export type UpsPhoneType = typeof UpsPhoneType[keyof typeof UpsPhoneType];
export type UpsPickupInformation = {
  pickupAddress: UpsAddress;
  pickupContactName: CustomerName;
  pickupEmail: Scalars['String']['input'];
  pickupPhone: UpsPhone;
};

export type UpsRegisterCustomerInput = {
  accountId: Scalars['String']['input'];
  address: UpsAddress;
  contact: Contact;
  userIdentity: UserIdentity;
};

export const UpsServiceCode = {
  ECONOMY_MAIL_INNOVATIONS: 'ECONOMY_MAIL_INNOVATIONS',
  EXPEDITED: 'EXPEDITED',
  EXPEDITED_MAIL_INNOVATIONS: 'EXPEDITED_MAIL_INNOVATIONS',
  EXPRESS: 'EXPRESS',
  EXPRESS_PLUS: 'EXPRESS_PLUS',
  FIRST_CLASS_MAIL: 'FIRST_CLASS_MAIL',
  GROUND: 'GROUND',
  MAIL_INNOVATIONS_MI_RETURNS: 'MAIL_INNOVATIONS_MI_RETURNS',
  NEXT_DAY_AIR: 'NEXT_DAY_AIR',
  NEXT_DAY_AIR_SAVER: 'NEXT_DAY_AIR_SAVER',
  PRIORITY_MAIL: 'PRIORITY_MAIL',
  PRIORITY_MAIL_INNOVATIONS: 'PRIORITY_MAIL_INNOVATIONS',
  UPS_ACCESS_POINT_ECONOMY: 'UPS_ACCESS_POINT_ECONOMY',
  UPS_EXPRESS_12_00: 'UPS_EXPRESS_12_00',
  UPS_HEAVY_GOODS: 'UPS_HEAVY_GOODS',
  UPS_NEXT_DAY_AIR_EARLY: 'UPS_NEXT_DAY_AIR_EARLY',
  UPS_SAVER: 'UPS_SAVER',
  UPS_STANDARD: 'UPS_STANDARD',
  UPS_TODAY_DEDICATED_COURIER: 'UPS_TODAY_DEDICATED_COURIER',
  UPS_TODAY_EXPRESS: 'UPS_TODAY_EXPRESS',
  UPS_TODAY_EXPRESS_SAVER: 'UPS_TODAY_EXPRESS_SAVER',
  UPS_TODAY_INTERCITY: 'UPS_TODAY_INTERCITY',
  UPS_TODAY_STANDARD: 'UPS_TODAY_STANDARD',
  UPS_WORLDWIDE_ECONOMY_DDP: 'UPS_WORLDWIDE_ECONOMY_DDP',
  UPS_WORLDWIDE_ECONOMY_DDU: 'UPS_WORLDWIDE_ECONOMY_DDU',
  UPS_WORLDWIDE_EXPRESS_FREIGHT: 'UPS_WORLDWIDE_EXPRESS_FREIGHT',
  UPS_WORLDWIDE_EXPRESS_FREIGHT_MIDDAY: 'UPS_WORLDWIDE_EXPRESS_FREIGHT_MIDDAY',
  _2ND_DAY_AIR: '_2ND_DAY_AIR',
  _2ND_DAY_AIR_AM: '_2ND_DAY_AIR_AM',
  _3_DAY_SELECT: '_3_DAY_SELECT'
} as const;

export type UpsServiceCode = typeof UpsServiceCode[keyof typeof UpsServiceCode];
export type UpsServiceCodeWrapper = {
  __typename?: 'UPSServiceCodeWrapper';
  upsServiceCode?: Maybe<UpsServiceCode>;
};

export type UnarchiveProductVariantsOutput = {
  __typename?: 'UnarchiveProductVariantsOutput';
  ok: Scalars['Boolean']['output'];
};

export type UnitMessage = {
  __typename?: 'UnitMessage';
  content: Array<LineMessage>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UnknownErrorConnectLazadaError = {
  __typename?: 'UnknownErrorConnectLazadaError';
  message: Scalars['String']['output'];
};

export type UnknownErrorConnectToFacebookError = {
  __typename?: 'UnknownErrorConnectToFacebookError';
  message: Scalars['String']['output'];
};

export type UnknownErrorConnectToWhatsAppError = {
  __typename?: 'UnknownErrorConnectToWhatsAppError';
  message: Scalars['String']['output'];
};

export type UnknownErrorRefreshTokenError = {
  __typename?: 'UnknownErrorRefreshTokenError';
  message: Scalars['String']['output'];
};

export type UnmuteChat = {
  __typename?: 'UnmuteChat';
  isAuto: Scalars['Boolean']['output'];
};

export type UnscheduleMessageRequestInput = {
  lineBroadcastMessageId: Scalars['String']['input'];
};

export type UnscheduleMessengerMessageRequestInput = {
  messengerBroadcastId: Scalars['String']['input'];
};

/** Disconnect every momo live a MOMO livestream room holds. */
export type UnsetMomoConnectionInput = {
  /** The connected MOMO livestream room; it must be editable (not composing, provisioning or live). */
  livestreamRoomId: Scalars['ID']['input'];
};

export type UnsupportedContent = {
  __typename?: 'UnsupportedContent';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateAiAutoReplySettingInput = {
  hasAiFooter?: InputMaybe<Scalars['Boolean']['input']>;
  messagingChannel: ChatType;
  storeId: Scalars['Long']['input'];
  systemInstructionId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAutomationFlowRequest = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  replyContents?: InputMaybe<Array<AutomationFlowContentInput>>;
  sendWhen?: InputMaybe<LiveCommentAutoReplyTiming>;
  trigger?: InputMaybe<AutomationFlowTriggerInput>;
};

export type UpdateCustomerRequest = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  height?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerResponse = Customer | CustomerGroupProfileUpdateConflictError;

export type UpdateCustomerTagRequest = {
  customerTagId: Scalars['String']['input'];
  customerTagName: Scalars['String']['input'];
  mergeWithExistingTag: Scalars['Boolean']['input'];
};

export type UpdateManualOrderV2Input = {
  billingAddress: OrderAddressInput;
  customer: OrderCustomerInput;
  customerNote: Scalars['String']['input'];
  deliveryStatus: AnyXDeliveryStatus;
  discount: Scalars['BigDecimal']['input'];
  id: Scalars['Long']['input'];
  orderProductsV2: Array<OrderProductInputV2Input>;
  shipping: Scalars['BigDecimal']['input'];
  shippingAddress: OrderAddressInput;
  totalTax: Scalars['BigDecimal']['input'];
};

export type UpdateManualOrderWithLogiInput = {
  billingAddress: OrderAddressInput;
  customer: OrderCustomerInput;
  customerNote: Scalars['String']['input'];
  discount: Scalars['BigDecimal']['input'];
  id: Scalars['Long']['input'];
  logisticsInput: LogisticsUpdateInput;
  orderProductsV2: Array<OrderProductInputV2Input>;
  shipping: Scalars['BigDecimal']['input'];
  shippingAddress: OrderAddressInput;
  totalTax: Scalars['BigDecimal']['input'];
};

export type UpdateMarketplaceCalendarEventInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  id: Scalars['Long']['input'];
  masterDataStoreId?: InputMaybe<Scalars['Long']['input']>;
  saleChannelCountry?: InputMaybe<Scalars['String']['input']>;
  saleChannelType: SaleChannelType;
  startDate: Scalars['ZonedDatetime']['input'];
  title: Scalars['String']['input'];
};

export type UpdateMultipleProductVariantInput = {
  price?: InputMaybe<GraphQlMoneyInput>;
  /** use it as unique identifier */
  productCode: Scalars['String']['input'];
  unitCost?: InputMaybe<GraphQlMoneyInput>;
};

export type UpdateProductVariantV3Input = {
  countryOfOrigin?: InputMaybe<Scalars['String']['input']>;
  hsCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Long']['input'];
  /** only for logistics connected store */
  logistics?: InputMaybe<ProductLogisticsInput>;
  media: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<GraphQlMoneyInput>;
  setItems: Array<ProductVariantSetItemInput>;
  tags: Array<Scalars['String']['input']>;
  unitCost?: InputMaybe<GraphQlMoneyInput>;
  weightInGrams?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type UpdateProductWithMultiVariantsInput = {
  description: Scalars['String']['input'];
  id: Scalars['Long']['input'];
  media: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  variants: Array<UpdateMultipleProductVariantInput>;
};

export type UpdateProductWithSingleVariantInput = {
  description: Scalars['String']['input'];
  id: Scalars['Long']['input'];
  media: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  variant: UpdateSingleProductVariantInput;
};

export type UpdateSingleProductVariantInput = {
  countryOfOrigin?: InputMaybe<Scalars['String']['input']>;
  hsCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Long']['input'];
  /** only for logistics connected store */
  logistics?: InputMaybe<ProductLogisticsInput>;
  price?: InputMaybe<GraphQlMoneyInput>;
  setItems: Array<ProductVariantSetItemInput>;
  tags: Array<Scalars['String']['input']>;
  unitCost?: InputMaybe<GraphQlMoneyInput>;
  weightInGrams?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type UpdateWhatsAppOptInSettingRequest = {
  optInEnabled: Scalars['Boolean']['input'];
  storeId: Scalars['Long']['input'];
};

export type UploadFilePayload = {
  __typename?: 'UploadFilePayload';
  fileName: Scalars['String']['output'];
  /** URI for identify the file. current format is like gs://anyx-private-storage/XXX/Order Import Template (7).csv */
  fileUri: Scalars['String']['output'];
  /** Use fileURI instead. this is invalid URL format like https://storage.googleapis.com/anyx-private-storage/XXX/Order Import Template (7).csv */
  fileUrl: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type UploadInventoryFilePayload = {
  __typename?: 'UploadInventoryFilePayload';
  uploadId: Scalars['Long']['output'];
};

export type UploadUrl = {
  __typename?: 'UploadURL';
  fileSizeLimitByte: Scalars['Int']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type UrlAction = {
  __typename?: 'UrlAction';
  url: Scalars['String']['output'];
};

export type UrlActionInput = {
  url: Scalars['String']['input'];
};

export type UrlVariableAction = {
  __typename?: 'UrlVariableAction';
  variable: Scalars['String']['output'];
};

export type UrlVariableActionInput = {
  variable: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  name: Scalars['String']['output'];
  userId?: Maybe<Scalars['Long']['output']>;
};

export type UserIdentity = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export const UserLanguage = {
  EN_US: 'EN_US',
  JA_JP: 'JA_JP',
  KO_KR: 'KO_KR',
  ZH_CN: 'ZH_CN'
} as const;

export type UserLanguage = typeof UserLanguage[keyof typeof UserLanguage];
export type UserReaction = {
  __typename?: 'UserReaction';
  sign: ReactionSign;
};

export type ValidJapanOrderAddress = {
  __typename?: 'ValidJapanOrderAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  cityName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEditable: Scalars['Boolean']['output'];
  provinceName: Scalars['String']['output'];
};

export type ValidJapanOrderAddressPayload = {
  __typename?: 'ValidJapanOrderAddressPayload';
  addressList: Array<ValidJapanOrderAddress>;
};

export const ValidationOption = {
  CALL: 'CALL',
  EMAIL: 'EMAIL',
  INVOICE: 'INVOICE',
  SMS: 'SMS'
} as const;

export type ValidationOption = typeof ValidationOption[keyof typeof ValidationOption];
export const ValidationStatus = {
  IGNORED: 'IGNORED',
  INVALID_SHIPPING_ADDRESS_CITY: 'INVALID_SHIPPING_ADDRESS_CITY',
  INVALID_SHIPPING_ADDRESS_COUNTRY_CODE: 'INVALID_SHIPPING_ADDRESS_COUNTRY_CODE',
  INVALID_SHIPPING_ADDRESS_HOUSE_NUMBER: 'INVALID_SHIPPING_ADDRESS_HOUSE_NUMBER',
  INVALID_SHIPPING_ADDRESS_POSTAL_CODE: 'INVALID_SHIPPING_ADDRESS_POSTAL_CODE',
  INVALID_SHIPPING_ADDRESS_PROVINCE: 'INVALID_SHIPPING_ADDRESS_PROVINCE',
  VALID: 'VALID'
} as const;

export type ValidationStatus = typeof ValidationStatus[keyof typeof ValidationStatus];
export type VariantDailyReportData = {
  __typename?: 'VariantDailyReportData';
  advertisingFee: Scalars['BigDecimal']['output'];
  avgOrderValues: Scalars['BigDecimal']['output'];
  commissionFee: Scalars['BigDecimal']['output'];
  consumptionRatio?: Maybe<Scalars['BigDecimal']['output']>;
  costRate: Scalars['BigDecimal']['output'];
  date?: Maybe<Scalars['LocalDate']['output']>;
  discount: Scalars['BigDecimal']['output'];
  discountRate: Scalars['BigDecimal']['output'];
  grossProfit: Scalars['BigDecimal']['output'];
  grossProfitRate: Scalars['BigDecimal']['output'];
  inventory?: Maybe<Scalars['Long']['output']>;
  logisticsFee: Scalars['BigDecimal']['output'];
  marginalProfit: Scalars['BigDecimal']['output'];
  marginalProfitRate: Scalars['BigDecimal']['output'];
  merchandiseCost: Scalars['BigDecimal']['output'];
  orders: Scalars['Long']['output'];
  otherCost: Scalars['BigDecimal']['output'];
  predictedInventoryDays?: Maybe<Scalars['Long']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  remaining?: Maybe<Scalars['Long']['output']>;
  revenue: Scalars['BigDecimal']['output'];
  roas: Scalars['BigDecimal']['output'];
  targetInventoryDays?: Maybe<Scalars['Long']['output']>;
  variantName?: Maybe<Scalars['String']['output']>;
};

export type VariantDailyReportPayload = {
  __typename?: 'VariantDailyReportPayload';
  currency: ReportSupportedCurrency;
  data: Array<VariantDailyReportData>;
  page: Scalars['Int']['output'];
  summary: VariantReportSummary;
  total: VariantDailyReportData;
  totalItems: Scalars['Int']['output'];
};

export const VariantProductType = {
  MIXED: 'MIXED',
  SET: 'SET',
  SINGLE: 'SINGLE'
} as const;

export type VariantProductType = typeof VariantProductType[keyof typeof VariantProductType];
export type VariantReportFilterInput = {
  adsMetricsType?: InputMaybe<AdsMetricsType>;
  endDate: Scalars['ZonedDatetime']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  marketplaces: Array<SaleChannelType>;
  masterDataAccountId?: InputMaybe<Scalars['Long']['input']>;
  masterDataAccountIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  masterDataStoreIds: Array<Scalars['Long']['input']>;
  orderStatus: ReportOrderStatus;
  productIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  productVariantIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  startDate: Scalars['ZonedDatetime']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  variants?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VariantReportPaginatedFilterInput = {
  adsMetricsType?: InputMaybe<AdsMetricsType>;
  endDate: Scalars['ZonedDatetime']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  marketplaces: Array<SaleChannelType>;
  masterDataAccountId?: InputMaybe<Scalars['Long']['input']>;
  masterDataAccountIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  masterDataStoreIds: Array<Scalars['Long']['input']>;
  orderStatus: ReportOrderStatus;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  productIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  productVariantIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  sortBy?: InputMaybe<VariantReportSortByField>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['ZonedDatetime']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  variants?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VariantReportPayload = {
  __typename?: 'VariantReportPayload';
  currency: ReportSupportedCurrency;
  items: Array<ProductVariantReportData>;
  meta: ReportListMeta;
};

export const VariantReportSortByField = {
  ADVERTISING_COST: 'ADVERTISING_COST',
  ADVERTISING_REVENUE: 'ADVERTISING_REVENUE',
  AVG_SALES_VALUE: 'AVG_SALES_VALUE',
  COMMISSION_FEE: 'COMMISSION_FEE',
  DAYS_SALES_INVENTORY: 'DAYS_SALES_INVENTORY',
  DISCOUNTS: 'DISCOUNTS',
  DISCOUNTS_RATE: 'DISCOUNTS_RATE',
  GROSS_PROFIT: 'GROSS_PROFIT',
  GROSS_PROFIT_RATE: 'GROSS_PROFIT_RATE',
  GROSS_REVENUE: 'GROSS_REVENUE',
  GROSS_SALES: 'GROSS_SALES',
  MARGINAL_PROFIT: 'MARGINAL_PROFIT',
  MARGINAL_PROFIT_RATE: 'MARGINAL_PROFIT_RATE',
  NET_SALES: 'NET_SALES',
  PRODUCT: 'PRODUCT',
  PRODUCT_CODE: 'PRODUCT_CODE',
  RETURN_CANCEL: 'RETURN_CANCEL',
  REVENUE: 'REVENUE',
  ROAS: 'ROAS',
  SHIPPING_FEE: 'SHIPPING_FEE',
  TOTAL_SALES: 'TOTAL_SALES',
  UNIT_COST: 'UNIT_COST',
  UNIT_SOLD: 'UNIT_SOLD',
  VARIANT_NAME: 'VARIANT_NAME',
  WAREHOUSE_INVENTORY: 'WAREHOUSE_INVENTORY'
} as const;

export type VariantReportSortByField = typeof VariantReportSortByField[keyof typeof VariantReportSortByField];
export type VariantReportSummary = {
  __typename?: 'VariantReportSummary';
  grossProfit: ReportCompareData;
  grossProfitRate: ReportCompareData;
  marginalProfit: ReportCompareData;
  marginalProfitRate: ReportCompareData;
  otherCost: ReportCompareData;
  revenue: ReportCompareData;
};

export type VariantValuesInput = {
  masterDataAccountId?: InputMaybe<Scalars['Long']['input']>;
  masterDataStoreIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type VariantValuesPayload = {
  __typename?: 'VariantValuesPayload';
  name: Scalars['String']['output'];
};

export type VariantValuesPayloadList = {
  __typename?: 'VariantValuesPayloadList';
  items: Array<VariantValuesPayload>;
  meta: ReportListMeta;
};

export type VideoMessage = {
  __typename?: 'VideoMessage';
  originalUrl: Scalars['String']['output'];
  previewUrl: Scalars['String']['output'];
};

export type VideoMessageContent = {
  __typename?: 'VideoMessageContent';
  originalUrl: Scalars['Url']['output'];
  previewUrl: Scalars['Url']['output'];
};

export type VideoMessageInput = {
  originalUrl: Scalars['String']['input'];
  previewUrl: Scalars['String']['input'];
};

export const VoiceCloneErrorCode = {
  CONSENT_NOT_MATCH: 'CONSENT_NOT_MATCH',
  INCORRECT_CONSENT_AUDIO: 'INCORRECT_CONSENT_AUDIO',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  SUCCESS: 'SUCCESS',
  VOICE_TOO_LONG: 'VOICE_TOO_LONG',
  VOICE_TOO_SHORT: 'VOICE_TOO_SHORT'
} as const;

export type VoiceCloneErrorCode = typeof VoiceCloneErrorCode[keyof typeof VoiceCloneErrorCode];
export const Wms = {
  LOGILESS: 'LOGILESS'
} as const;

export type Wms = typeof Wms[keyof typeof Wms];
export type WmsName = {
  __typename?: 'WMSName';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export const WmsType = {
  LOGILESS: 'LOGILESS'
} as const;

export type WmsType = typeof WmsType[keyof typeof WmsType];
export type Warehouse = {
  __typename?: 'Warehouse';
  country: Country;
  created: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  wms: Wms;
  wmsWarehouseId: Scalars['String']['output'];
};

export type WarehouseDetailed = {
  __typename?: 'WarehouseDetailed';
  addressFirst: Scalars['String']['output'];
  addressSecond?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country: Country;
  deliveryDestination: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phoneNumber: PhoneNumber;
  postalCode?: Maybe<Scalars['String']['output']>;
  provinceId?: Maybe<Scalars['String']['output']>;
  wms: Wms;
  wmsWarehouseId: Scalars['String']['output'];
};

export type WarehouseFilters = {
  country?: InputMaybe<Country>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  wms?: InputMaybe<Wms>;
};

export const WarehouseManagementSystem = {
  ANCHANTO: 'ANCHANTO',
  JUBELIO: 'JUBELIO'
} as const;

export type WarehouseManagementSystem = typeof WarehouseManagementSystem[keyof typeof WarehouseManagementSystem];
export type WarehousesPaginated = Paginated & {
  __typename?: 'WarehousesPaginated';
  page: Scalars['Int']['output'];
  records: Array<Warehouse>;
  total: Scalars['Int']['output'];
};

export type WhatsAppAutoReplyMessage = WhatsAppMessage & {
  __typename?: 'WhatsAppAutoReplyMessage';
  content: WhatsAppMessageAutoContent;
  messageId: Scalars['String']['output'];
};

export type WhatsAppBroadcastActionButton = WhatsAppBroadcastUrlActionButton;

export type WhatsAppBroadcastActionButtonInput = {
  type: WhatsAppBroadcastActionButtonType;
  urlButton?: InputMaybe<WhatsAppBroadcastUrlActionButtonInput>;
};

export const WhatsAppBroadcastActionButtonType = {
  URL_BUTTON: 'URL_BUTTON'
} as const;

export type WhatsAppBroadcastActionButtonType = typeof WhatsAppBroadcastActionButtonType[keyof typeof WhatsAppBroadcastActionButtonType];
export type WhatsAppBroadcastCard = {
  __typename?: 'WhatsAppBroadcastCard';
  buttons: Array<WhatsAppBroadcastActionButton>;
  descriptionText: Scalars['String']['output'];
  image: Scalars['Url']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type WhatsAppBroadcastCardContent = {
  __typename?: 'WhatsAppBroadcastCardContent';
  cards: Array<WhatsAppBroadcastCard>;
  initialMessage: Scalars['String']['output'];
};

export type WhatsAppBroadcastCardContentInput = {
  cards: Array<WhatsAppBroadcastCardInput>;
  initialMessage: Scalars['String']['input'];
};

export type WhatsAppBroadcastCardInput = {
  buttons: Array<WhatsAppBroadcastActionButtonInput>;
  descriptionText: Scalars['String']['input'];
  image: Scalars['Url']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type WhatsAppBroadcastContent = WhatsAppBroadcastCardContent | WhatsAppBroadcastTextContent;

export type WhatsAppBroadcastContentInput = {
  carousel?: InputMaybe<WhatsAppBroadcastCardContentInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  type: WhatsAppBroadcastMessageType;
};

export type WhatsAppBroadcastCreateRequestInput = {
  recipient: WhatsAppRecipientInput;
  schedule: Scalars['OffsetDateTime']['input'];
  storeId: Scalars['Long']['input'];
  title: Scalars['String']['input'];
  whatsappContent: WhatsAppBroadcastContentInput;
};

export type WhatsAppBroadcastMessage = {
  __typename?: 'WhatsAppBroadcastMessage';
  content: WhatsAppBroadcastContent;
  createdAt: Scalars['OffsetDateTime']['output'];
  deliveredAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  deliveryTiming: DeliveryTiming;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['Url']['output']>;
  name: Scalars['String']['output'];
  recipient: WhatsAppBroadcastRecipient;
  statistics?: Maybe<WhatsAppBroadcastStatistics>;
  status: WhatsAppBroadcastStatus;
};

export const WhatsAppBroadcastMessageType = {
  PLAIN_TEXT: 'PLAIN_TEXT',
  TEMPLATE_CARD: 'TEMPLATE_CARD'
} as const;

export type WhatsAppBroadcastMessageType = typeof WhatsAppBroadcastMessageType[keyof typeof WhatsAppBroadcastMessageType];
export type WhatsAppBroadcastMessages = {
  __typename?: 'WhatsAppBroadcastMessages';
  messages: Array<WhatsAppBroadcastMessage>;
  total: Scalars['Int']['output'];
};

export type WhatsAppBroadcastRecipient = All | WhatsAppRecipientCustomerTagName;

export type WhatsAppBroadcastStatisticSummaries = {
  __typename?: 'WhatsAppBroadcastStatisticSummaries';
  compareStatistics?: Maybe<WhatsAppBroadcastStatistics>;
  diffStatistics?: Maybe<WhatsAppBroadcastStatistics>;
  sumStatistics: WhatsAppBroadcastStatistics;
};

export type WhatsAppBroadcastStatistics = {
  __typename?: 'WhatsAppBroadcastStatistics';
  clickCount: Scalars['Int']['output'];
  clickRate: Scalars['Float']['output'];
  deliveredCount: Scalars['Int']['output'];
  openCount: Scalars['Int']['output'];
  openRate: Scalars['Float']['output'];
};

export const WhatsAppBroadcastStatus = {
  APPROVED_DRAFT: 'APPROVED_DRAFT',
  DELIVERED: 'DELIVERED',
  DRAFT: 'DRAFT',
  ERROR: 'ERROR',
  REJECTED: 'REJECTED',
  RESCHEDULE_REQUIRED: 'RESCHEDULE_REQUIRED',
  REVIEWING: 'REVIEWING',
  SCHEDULED: 'SCHEDULED',
  SENDING: 'SENDING'
} as const;

export type WhatsAppBroadcastStatus = typeof WhatsAppBroadcastStatus[keyof typeof WhatsAppBroadcastStatus];
export type WhatsAppBroadcastTextContent = {
  __typename?: 'WhatsAppBroadcastTextContent';
  text: Scalars['String']['output'];
};

export type WhatsAppBroadcastToDraftRequest = {
  broadcastId: Scalars['String']['input'];
};

export const WhatsAppBroadcastUpdateMode = {
  DRY_SUBMIT: 'DRY_SUBMIT',
  SUBMIT: 'SUBMIT',
  UPDATE: 'UPDATE'
} as const;

export type WhatsAppBroadcastUpdateMode = typeof WhatsAppBroadcastUpdateMode[keyof typeof WhatsAppBroadcastUpdateMode];
export type WhatsAppBroadcastUpdateRequestInput = {
  broadcastId: Scalars['String']['input'];
  mode: WhatsAppBroadcastUpdateMode;
  recipient: WhatsAppRecipientInput;
  schedule?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  title: Scalars['String']['input'];
  whatsappContent: WhatsAppBroadcastContentInput;
};

export type WhatsAppBroadcastUpdateResult = {
  __typename?: 'WhatsAppBroadcastUpdateResult';
  broadcast: WhatsAppBroadcastMessage;
  hasChanged: Scalars['Boolean']['output'];
};

export type WhatsAppBroadcastUrlActionButton = {
  __typename?: 'WhatsAppBroadcastUrlActionButton';
  buttonText: Scalars['String']['output'];
  url: Scalars['Url']['output'];
};

export type WhatsAppBroadcastUrlActionButtonInput = {
  buttonText: Scalars['String']['input'];
  url: Scalars['Url']['input'];
};

export type WhatsAppChatEvent = CommonChatEvent | WhatsAppMessageEvent;

export type WhatsAppChatEvents = {
  __typename?: 'WhatsAppChatEvents';
  chatEvents: Array<WhatsAppChatEvent>;
  chatId: Scalars['String']['output'];
  lastCheckedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  newerCursor?: Maybe<Scalars['String']['output']>;
  olderCursor?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

export type WhatsAppChatPlatformDetail = {
  __typename?: 'WhatsAppChatPlatformDetail';
  isOptIn: Scalars['Boolean']['output'];
};

export type WhatsAppImageMessageContent = {
  __typename?: 'WhatsAppImageMessageContent';
  caption?: Maybe<Scalars['String']['output']>;
  url: Scalars['Url']['output'];
};

export type WhatsAppMessage = {
  messageId: Scalars['String']['output'];
};

export type WhatsAppMessageAutoContent = {
  version: Scalars['Int']['output'];
};

export const WhatsAppMessageDeliveryStatus = {
  DELIVERED: 'DELIVERED',
  FAILED: 'FAILED',
  READ: 'READ',
  RECEIVED: 'RECEIVED',
  SENT: 'SENT'
} as const;

export type WhatsAppMessageDeliveryStatus = typeof WhatsAppMessageDeliveryStatus[keyof typeof WhatsAppMessageDeliveryStatus];
export type WhatsAppMessageEvent = {
  __typename?: 'WhatsAppMessageEvent';
  id: Scalars['String']['output'];
  message: WhatsAppMessage;
  replyTo?: Maybe<WhatsAppReplyTo>;
  seqNumber: Scalars['Long']['output'];
  status: WhatsAppMessageDeliveryStatus;
  timestamp: Scalars['UnixTimestamp']['output'];
};

export type WhatsAppMessageReceivedContent = WhatsAppImageMessageContent | WhatsAppOptInMessageContent | WhatsAppOptOutMessageContent | WhatsAppTextMessageContent | WhatsAppUnsupportedContent | WhatsAppVideoMessageContent;

export type WhatsAppMessageSentContent = WhatsAppImageMessageContent | WhatsAppTextMessageContent | WhatsAppVideoMessageContent;

export type WhatsAppOptInMessageContent = {
  __typename?: 'WhatsAppOptInMessageContent';
  text: Scalars['String']['output'];
};

export type WhatsAppOptInRequestMessageContent = WhatsAppMessageAutoContent & {
  __typename?: 'WhatsAppOptInRequestMessageContent';
  version: Scalars['Int']['output'];
};

export type WhatsAppOptOutMessageContent = {
  __typename?: 'WhatsAppOptOutMessageContent';
  text: Scalars['String']['output'];
};

export type WhatsAppPhoneNumber = {
  __typename?: 'WhatsAppPhoneNumber';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  profilePicUrl?: Maybe<Scalars['String']['output']>;
};

export type WhatsAppRecipientCustomerTagName = {
  __typename?: 'WhatsAppRecipientCustomerTagName';
  name: Scalars['String']['output'];
};

export type WhatsAppRecipientInput = {
  customerTagName?: InputMaybe<Scalars['String']['input']>;
  type: WhatsAppRecipientType;
};

export const WhatsAppRecipientType = {
  ALL: 'ALL',
  WITH_CUSTOMER_TAGS: 'WITH_CUSTOMER_TAGS'
} as const;

export type WhatsAppRecipientType = typeof WhatsAppRecipientType[keyof typeof WhatsAppRecipientType];
export type WhatsAppReplyTo = {
  __typename?: 'WhatsAppReplyTo';
  message: WhatsAppMessage;
};

export type WhatsAppReplyToInput = {
  messageId?: InputMaybe<Scalars['String']['input']>;
};

export type WhatsAppSendImageMessageRequestInput = {
  chatId: Scalars['String']['input'];
  replyTo?: InputMaybe<WhatsAppReplyToInput>;
  url: Scalars['String']['input'];
};

export type WhatsAppSendTextMessageRequestInput = {
  chatId: Scalars['String']['input'];
  replyTo?: InputMaybe<WhatsAppReplyToInput>;
  text: Scalars['String']['input'];
};

export type WhatsAppStoreCsMessage = WhatsAppMessage & {
  __typename?: 'WhatsAppStoreCSMessage';
  author: MessageAuthor;
  content: WhatsAppMessageSentContent;
  messageId: Scalars['String']['output'];
  messageState: MessageState;
};

export type WhatsAppStoreChat = StoreChat & {
  __typename?: 'WhatsAppStoreChat';
  businessAccountId: Scalars['String']['output'];
  createdAt: Scalars['OffsetDateTime']['output'];
  id: Scalars['String']['output'];
  isAIReplyEnable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  optInEnabled: Scalars['Boolean']['output'];
  phones: Array<WhatsAppPhoneNumber>;
  type: ChatType;
};

export type WhatsAppTargetInput = {
  type: WhatsAppTargetType;
};

export const WhatsAppTargetType = {
  BROADCAST_MESSAGE: 'BROADCAST_MESSAGE',
  CHAT_MESSAGE: 'CHAT_MESSAGE'
} as const;

export type WhatsAppTargetType = typeof WhatsAppTargetType[keyof typeof WhatsAppTargetType];
export type WhatsAppTextMessageContent = {
  __typename?: 'WhatsAppTextMessageContent';
  text: Scalars['String']['output'];
};

export type WhatsAppUnsupportedContent = {
  __typename?: 'WhatsAppUnsupportedContent';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type WhatsAppUserMessage = WhatsAppMessage & {
  __typename?: 'WhatsAppUserMessage';
  content: WhatsAppMessageReceivedContent;
  messageId: Scalars['String']['output'];
};

export type WhatsAppVideoMessageContent = {
  __typename?: 'WhatsAppVideoMessageContent';
  caption?: Maybe<Scalars['String']['output']>;
  url: Scalars['Url']['output'];
};

export type Workflow = {
  __typename?: 'Workflow';
  body: WorkflowBody;
  createdAt: Scalars['OffsetDateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastActivatedAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  reports: Array<WorkflowReport>;
  schedule?: Maybe<WorkflowSchedule>;
  testMode: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type WorkflowAction = {
  __typename?: 'WorkflowAction';
  delay?: Maybe<DelayAction>;
  id: Scalars['String']['output'];
  lineMessage?: Maybe<LineMessageAction>;
};

export type WorkflowActionInput = {
  delay?: InputMaybe<DelayActionInput>;
  id: Scalars['String']['input'];
  lineMessage?: InputMaybe<LineMessageActionInput>;
};

export type WorkflowAuditLog = {
  __typename?: 'WorkflowAuditLog';
  durationMillis: Scalars['Long']['output'];
  errors: Array<WorkflowAuditLogError>;
  id: Scalars['String']['output'];
  lastExecutedAt: Scalars['OffsetDateTime']['output'];
  startedAt: Scalars['OffsetDateTime']['output'];
  status: WorkflowAuditLogStatus;
};

export type WorkflowAuditLogError = {
  __typename?: 'WorkflowAuditLogError';
  errorLocation: WorkflowAuditLogErrorLocation;
  errorType: WorkflowAuditLogErrorType;
};

export const WorkflowAuditLogErrorLocation = {
  ACTION: 'ACTION',
  CONDITION: 'CONDITION',
  DELAY_ACTION: 'DELAY_ACTION',
  SEND_LINE_MESSAGE_ACTION: 'SEND_LINE_MESSAGE_ACTION'
} as const;

export type WorkflowAuditLogErrorLocation = typeof WorkflowAuditLogErrorLocation[keyof typeof WorkflowAuditLogErrorLocation];
export const WorkflowAuditLogErrorType = {
  ANYCHAT_INTERNAL: 'ANYCHAT_INTERNAL',
  LINE_CONNECTION_ERROR: 'LINE_CONNECTION_ERROR',
  LINE_CUSTOMER_NOT_FOUND: 'LINE_CUSTOMER_NOT_FOUND',
  LINE_MESSAGE_QUOTA_EXCEEDED: 'LINE_MESSAGE_QUOTA_EXCEEDED',
  MISSING_VARIABLES_DATA: 'MISSING_VARIABLES_DATA',
  SHOPIFY_CONNECTION_ERROR: 'SHOPIFY_CONNECTION_ERROR',
  SHOPIFY_CUSTOMER_NOT_FOUND: 'SHOPIFY_CUSTOMER_NOT_FOUND',
  UNEXPECTED: 'UNEXPECTED'
} as const;

export type WorkflowAuditLogErrorType = typeof WorkflowAuditLogErrorType[keyof typeof WorkflowAuditLogErrorType];
export const WorkflowAuditLogStatus = {
  CONFIG_CHANGE: 'CONFIG_CHANGE',
  CONFIG_ERROR: 'CONFIG_ERROR',
  FAILURE: 'FAILURE',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCEED: 'SUCCEED'
} as const;

export type WorkflowAuditLogStatus = typeof WorkflowAuditLogStatus[keyof typeof WorkflowAuditLogStatus];
export type WorkflowAuditLogs = {
  __typename?: 'WorkflowAuditLogs';
  auditLogs: Array<WorkflowAuditLog>;
  total: Scalars['Int']['output'];
};

export type WorkflowBody = {
  __typename?: 'WorkflowBody';
  blocks: Array<FlowBlock>;
  initialFlowBlockId: Scalars['String']['output'];
  type: WorkflowType;
};

export type WorkflowBodyInput = {
  blocks: Array<FlowBlockInput>;
  initialFlowBlockId: Scalars['String']['input'];
  type: WorkflowType;
};

export type WorkflowCondition = {
  __typename?: 'WorkflowCondition';
  id: Scalars['String']['output'];
  operator: ConditionOperator;
  type: ConditionType;
  values: Array<Scalars['String']['output']>;
};

export type WorkflowConditionInput = {
  id: Scalars['String']['input'];
  operator: ConditionOperator;
  type: ConditionType;
  values: Array<Scalars['String']['input']>;
};

export type WorkflowReport = {
  __typename?: 'WorkflowReport';
  clickCount?: Maybe<Scalars['Int']['output']>;
  clickRate?: Maybe<Scalars['Float']['output']>;
  deliveredCount: Scalars['Int']['output'];
  lineUnitMessageID: Scalars['String']['output'];
  lineUnitMessageName: Scalars['String']['output'];
  openRate?: Maybe<Scalars['Float']['output']>;
  openedCount?: Maybe<Scalars['Int']['output']>;
};

export type WorkflowSchedule = {
  __typename?: 'WorkflowSchedule';
  endAt: Scalars['OffsetDateTime']['output'];
  startAt: Scalars['OffsetDateTime']['output'];
};

export type WorkflowScheduleInput = {
  endAt: Scalars['OffsetDateTime']['input'];
  startAt: Scalars['OffsetDateTime']['input'];
};

export type WorkflowStatusOk = {
  __typename?: 'WorkflowStatusOk';
  ok: Scalars['Boolean']['output'];
};

export const WorkflowType = {
  LINE_NEW_FRIEND: 'LINE_NEW_FRIEND',
  LINE_NEW_MESSAGE: 'LINE_NEW_MESSAGE',
  LINE_RICH_MENU_POSTBACK: 'LINE_RICH_MENU_POSTBACK',
  LINE_SHOPIFY_ID_SYNCED: 'LINE_SHOPIFY_ID_SYNCED',
  SHOPIFY_NEW_ORDER: 'SHOPIFY_NEW_ORDER',
  SHOPIFY_ORDER_FULFILLMENT_STATUS_UPDATED: 'SHOPIFY_ORDER_FULFILLMENT_STATUS_UPDATED',
  SHOPIFY_ORDER_PAYMENT_STATUS_UPDATED: 'SHOPIFY_ORDER_PAYMENT_STATUS_UPDATED'
} as const;

export type WorkflowType = typeof WorkflowType[keyof typeof WorkflowType];
export type Workflows = {
  __typename?: 'Workflows';
  total: Scalars['Int']['output'];
  workflows: Array<Workflow>;
};

export type WrongPageSelectedRefreshTokenError = {
  __typename?: 'WrongPageSelectedRefreshTokenError';
  message: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
};

export type YahooAdsAccountPayload = {
  __typename?: 'YahooAdsAccountPayload';
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type YahooAdsAccountsInput = {
  datasourceTokenId: Scalars['Long']['input'];
  datasourceType: DatasourceType;
};

export type YahooAdsAccountsPayload = {
  __typename?: 'YahooAdsAccountsPayload';
  accounts: Array<YahooAdsAccountPayload>;
};

export type YahooAdsDatasourceTokenPayload = {
  __typename?: 'YahooAdsDatasourceTokenPayload';
  datasourceTokenId: Scalars['Long']['output'];
};

export type YahooAdsExchangeCodeInput = {
  code: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};

export type YahooAdsLoginUrlInput = {
  redirectUrl: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type YahooAdsLoginUrlPayload = {
  __typename?: 'YahooAdsLoginUrlPayload';
  loginUrl: Scalars['String']['output'];
};

export type YahooLoginUrlInput = {
  publicKey: Scalars['String']['input'];
  publicKeyExpirationDate: Scalars['OffsetDateTime']['input'];
  publicKeyVersion: Scalars['Int']['input'];
  redirectUri: Scalars['String']['input'];
  sellerId: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
};

export type YahooSaleChannelData = {
  __typename?: 'YahooSaleChannelData';
  refreshTokenExpirationDate: Scalars['OffsetDateTime']['output'];
  sellerId: Scalars['String']['output'];
  showReconnectButton: Scalars['Boolean']['output'];
};

export type YahooSalesReportChartInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type YahooSalesReportChartPayload = {
  __typename?: 'YahooSalesReportChartPayload';
  avgSpendPerCustomer: Array<Scalars['Map']['output']>;
  currency: ReportSupportedCurrency;
  orderCount: Array<Scalars['Map']['output']>;
  totalSales: Array<Scalars['Map']['output']>;
  unitSoldCount: Array<Scalars['Map']['output']>;
};

export type YahooSalesReportSummaryInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type YahooSalesReportSummaryPayload = {
  __typename?: 'YahooSalesReportSummaryPayload';
  avgSpendPerCustomer: NumericValueWithDiffPayload;
  currency: ReportSupportedCurrency;
  orderCount: NumericValueWithDiffPayload;
  totalSales: NumericValueWithDiffPayload;
  unitSoldCount: NumericValueWithDiffPayload;
};

export type YahooSalesReportTableInput = {
  endDate: Scalars['ZonedDatetime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  startDate: Scalars['ZonedDatetime']['input'];
};

export type YahooSalesReportTablePayload = {
  __typename?: 'YahooSalesReportTablePayload';
  avgSpendPerCustomer: Scalars['Int']['output'];
  currency: ReportSupportedCurrency;
  date: Scalars['LocalDate']['output'];
  orderCount: Scalars['Int']['output'];
  totalSales: Scalars['BigDecimal']['output'];
  unitSoldCount: Scalars['Int']['output'];
};

export type YahooSalesReportTablePayloadList = {
  __typename?: 'YahooSalesReportTablePayloadList';
  items: Array<YahooSalesReportTablePayload>;
  meta: ReportListMeta;
  total: YahooSalesReportTotalPayload;
};

export type YahooSalesReportTotalPayload = {
  __typename?: 'YahooSalesReportTotalPayload';
  avgSpendPerCustomer: Scalars['Int']['output'];
  orderCount: Scalars['Int']['output'];
  totalSales: Scalars['BigDecimal']['output'];
  unitSoldCount: Scalars['Int']['output'];
};

export type ZozotownFileUploadInput = {
  /** start from gs://~~~ */
  fileUri: Scalars['String']['input'];
  saleChannelId?: InputMaybe<Scalars['Long']['input']>;
  storeId: Scalars['Long']['input'];
  type: ZozotownFileUploadType;
};

export const ZozotownFileUploadType = {
  AD_COST_ADS: 'AD_COST_ADS',
  ORDERS: 'ORDERS',
  PRODUCTS: 'PRODUCTS'
} as const;

export type ZozotownFileUploadType = typeof ZozotownFileUploadType[keyof typeof ZozotownFileUploadType];
export type GetCourierSettingsListResponse = Paginated & {
  __typename?: 'getCourierSettingsListResponse';
  accountCourierSettings: Array<AccountCourierSettings>;
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GetShipperAddressFilter = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type GetShippingRateResponse = {
  __typename?: 'getShippingRateResponse';
  errors?: Maybe<Array<ShippingRateError>>;
  shippingRates?: Maybe<Array<ShippingRateDetail>>;
};

export type ShipperAddressesListResponse = Paginated & {
  __typename?: 'shipperAddressesListResponse';
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  shipperAddresses: Array<ShipperAddress>;
  total: Scalars['Int']['output'];
};

export type ShippingRateError = {
  __typename?: 'shippingRateError';
  crossBorderCourierProvider: CrossBorderCourierProvider;
  messages?: Maybe<Array<Scalars['String']['output']>>;
};

export type MdUpdateSelfMutationVariables = Exact<{
  input: MdUpdateUserInput;
}>;


export type MdUpdateSelfMutation = { MdUpdateUser: { __typename?: 'MdUser', accessAllStores: boolean, storeIds: Array<string>, accountIds: Array<string>, auth0UserId?: string | null, canManageUsers: boolean, countryId?: string | null, createdAt: string, currency: Currency, email: string, firstName: string, id: string, language: UserLanguage, lastName?: string | null, role: MdUserRole, timezoneId: string, updatedAt: string } };

export type WorkspaceSelectQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<MdStoreFilterInput>;
  sortBy?: InputMaybe<MdStoreSortByInput>;
}>;


export type WorkspaceSelectQuery = { MdStores: { __typename?: 'MdStores', length: number, limit: number, start: number, total: number, items: Array<{ __typename?: 'MdStore', name: string, id: string }> } };

export type GetStoreUnreadCountQueryVariables = Exact<{
  input: AnyChatGetStoreRequest;
}>;


export type GetStoreUnreadCountQuery = { AnyChatStore?: { __typename?: 'AnyChatStore', chatCount: { __typename?: 'OngoingCount', unreadCount: number } } | null };

export type GetInactiveSaleChannelsQueryVariables = Exact<{
  storeId: Scalars['Long']['input'];
}>;


export type GetInactiveSaleChannelsQuery = { onboarding: { __typename?: 'Onboarding', inactiveSaleChannelCount: number } };

export type DdiHomeReportChartQueryVariables = Exact<{
  input: DdiHomeReportInput;
}>;


export type DdiHomeReportChartQuery = { ddiHomeReportChart: { __typename?: 'DdiHomeReportChartPayload', currency: ReportSupportedCurrency, grossSales: Array<Record<string, any>>, netSales: Array<Record<string, any>>, orders: Array<Record<string, any>> } };

export type DdiHomeReportPieChartQueryVariables = Exact<{
  input: DdiHomeReportInput;
}>;


export type DdiHomeReportPieChartQuery = { ddiHomeReportPieChart: { __typename?: 'DdiHomeReportPieChartPayload', currency: ReportSupportedCurrency, grossSales: Array<{ __typename?: 'DdiHomeReportPieChartSectionPayload', saleChannelType: SaleChannelType, value: string }>, netSales: Array<{ __typename?: 'DdiHomeReportPieChartSectionPayload', saleChannelType: SaleChannelType, value: string }>, orders: Array<{ __typename?: 'DdiHomeReportPieChartSectionPayload', saleChannelType: SaleChannelType, value: string }> } };

export type DdiHomeReportProductTableQueryVariables = Exact<{
  input: DdiHomeReportInput;
}>;


export type DdiHomeReportProductTableQuery = { ddiHomeReportTopProducts: { __typename?: 'DdiHomeReportTopProductsPayload', currency: ReportSupportedCurrency, products: Array<{ __typename?: 'DdiHomeReportTopProductPayload', grossSales: string, netSales: string, orders: string, productImageUrl?: string | null, productId?: string | null, productName?: string | null }> } };

export type DdiHomeReportSummaryQueryVariables = Exact<{
  input: DdiHomeReportInput;
}>;


export type DdiHomeReportSummaryQuery = { ddiHomeReportSummary: { __typename?: 'DdiHomeReportSummaryPayload', currency: ReportSupportedCurrency, grossSales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, orders: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, netSales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string } } };

export type HomeReportChartQueryVariables = Exact<{
  filter: SaleChannelReportTableFilterInput;
}>;


export type HomeReportChartQuery = { saleChannelReportChart: { __typename?: 'SaleChannelReportChartPayload', channels: Array<SaleChannelType>, currency: ReportSupportedCurrency, totalItems: number, list: Array<{ __typename?: 'SaleChannelReportChartData', advertisingCost: string, advertisingRevenue: string, avgOrderValues: string, channel?: SaleChannelType | null, commissionFee: string, cvr?: string | null, dailySales?: string | null, day?: any | null, discountRate: string, discounts: string, dow?: number | null, grossProfit: string, grossProfitRate: string, grossSales: string, netSales: string, totalSales: string, cancelAndOrRefund: string, marginalProfit: string, marginalProfitRate: string, masterDataStoreId?: string | null, merchandiseCost: string, orders: string, roas: string, sessions: string, shippingFee: string, storeName?: string | null, yearMonth?: any | null, yearWeek?: any | null, marketplaceCalendarEvents?: Array<{ __typename?: 'MarketplaceCalendarEventPayload', endDate: string, id: string, masterDataStoreId?: string | null, saleChannelCountry?: string | null, saleChannelType: SaleChannelType, startDate: string, title: string }> | null }>, stores: Array<{ __typename?: 'SaleChannelReportChartStore', id: string, name: string }> } };

export type HomeReportPieChartQueryVariables = Exact<{
  filter: HomeReportFilterInput;
}>;


export type HomeReportPieChartQuery = { reportHomeSaleChannelRevenue: { __typename?: 'HomeSaleChannelRevenueReportView', currency: ReportSupportedCurrency, data: Array<{ __typename?: 'HomeReportSaleChannelRevenuePayload', grossSales: string, masterDataStoreId?: string | null, saleChannelType?: SaleChannelType | null, storeName?: string | null }> } };

export type HomeReportProductTableQueryVariables = Exact<{
  filter: HomeReportFilterInput;
}>;


export type HomeReportProductTableQuery = { reportHomeTop5Products: { __typename?: 'HomeTop5ProductsReportView', data: Array<{ __typename?: 'HomeTop5ProductView', currency: ReportSupportedCurrency, grossSales: string, image?: string | null, orderCount: number, productId?: string | null, productName?: string | null }> } };

export type HomeReportSummaryQueryVariables = Exact<{
  filter: SaleChannelReportSummaryFilterInput;
}>;


export type HomeReportSummaryQuery = { saleChannelReportSummary: { __typename?: 'ReportSummaryPayload', currency: ReportSupportedCurrency, comparisonSummary: { __typename?: 'ReportSummaryComparisonData', avgOrderValues: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null }, cvr?: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null } | null, grossProfit?: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null } | null, grossProfitRate?: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null } | null, grossSales: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null }, marginalProfit?: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null } | null, marginalProfitRate?: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null } | null, orders: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null }, roas?: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null } | null, sessions?: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null } | null }, tableSummary: { __typename?: 'SaleChannelReportSummaryData', advertisingCost?: string | null, advertisingRevenue?: string | null, avgOrderValues: string, commissionFee?: string | null, cvr?: string | null, discountRate: string, discounts: string, grossProfit: string, grossProfitRate?: string | null, grossSales: string, netSales: string, totalSales: string, cancelAndOrRefund: string, marginalProfit: string, marginalProfitRate?: string | null, merchandiseCost?: string | null, orders: string, roas?: string | null, sessions?: string | null, shippingFee: string } } };

export type HomeReportTableQueryVariables = Exact<{
  filter: SaleChannelReportTableFilterInput;
}>;


export type HomeReportTableQuery = { saleChannelReportTable: { __typename?: 'SaleChannelReportPayload', currency: ReportSupportedCurrency, totalItems: number, list: Array<{ __typename?: 'SaleChannelReportTableData', advertisingCost?: string | null, advertisingRevenue?: string | null, avgOrderValues: string, commissionFee?: string | null, cvr?: string | null, discountRate: string, discounts: string, grossProfit: string, grossProfitRate?: string | null, grossSales: string, netSales: string, totalSales: string, cancelAndOrRefund: string, marginalProfit: string, marginalProfitRate?: string | null, merchandiseCost?: string | null, metric: string, orders: string, roas?: string | null, sessions?: string | null, shippingFee: string }> } };

export type SettingGuideSaleChannelQueryVariables = Exact<{
  mdStoreId: Scalars['Long']['input'];
}>;


export type SettingGuideSaleChannelQuery = { MdStore: { __typename?: 'MdStore', id: string, channels: Array<{ __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType, costIndex?: { __typename?: 'SaleChannelCostIndexQueryPayload', saleChannelId: string } | null }> } };

export type StoreCategoryQueryVariables = Exact<{
  mdStoreId: Scalars['Long']['input'];
}>;


export type StoreCategoryQuery = { MdStore: { __typename?: 'MdStore', id: string, category: MdStoreCategory } };

export type OnboardingCreateStoreMutationVariables = Exact<{
  input: MdCreateStoreInput;
}>;


export type OnboardingCreateStoreMutation = { MdCreateStore: { __typename?: 'MdStore', id: string, name: string } };

export type MdTimezonesQueryVariables = Exact<{ [key: string]: never; }>;


export type MdTimezonesQuery = { MdTimezones: Array<{ __typename?: 'MdTimezone', updatedAt: string, offset: string, name: string, id: string, createdAt: string }> };

export type GetCsvUploadTemplateQueryVariables = Exact<{
  language: Language;
  resource: Resource;
  operation: CsvImportOperation;
}>;


export type GetCsvUploadTemplateQuery = { getCsvUploadTemplate: { __typename?: 'CsvTemplate', columns: Array<string>, filename: string } };

export type DocumentDetailQueryVariables = Exact<{
  documentId: Scalars['Long']['input'];
}>;


export type DocumentDetailQuery = { document: { __typename?: 'DocumentPayload', id: string, status: DocumentStatus, url?: string | null } };

export type GenerateAnylogiUploadUrlMutationVariables = Exact<{
  filename: Scalars['String']['input'];
  resource: Resource;
  filetype: FileType;
  storeId?: InputMaybe<Scalars['Long']['input']>;
}>;


export type GenerateAnylogiUploadUrlMutation = { generateUploadUrl: { __typename?: 'Path', url: string } };

export type CheckOnboardingQueryVariables = Exact<{
  input: OnboardingInput;
  storeId: Scalars['Long']['input'];
}>;


export type CheckOnboardingQuery = { hasConnectedSaleChannel: boolean, inactiveIntegrationCount: number, hasAdvertisingConnection: boolean, hasAnalyticsReport: boolean, settingGuide: { __typename?: 'SettingGuide', hasShopifyChannel: boolean, hasInputUnitCost: boolean, hasConnectedDatasourceChannel: boolean, hasSaleChannelCostIndex: boolean }, onboarding: { __typename?: 'Onboarding', hasRegisteredOrder: boolean } };

export type SelfDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type SelfDetailsQuery = { MdSelf: { __typename?: 'MdUser', id: string, accountIds: Array<string>, storeIds: Array<string>, firstName: string, lastName?: string | null, language: UserLanguage, currency: Currency, timezoneId: string, role: MdUserRole, email: string, availableModules: Array<MdAnyXModuleEnum>, canManageUsers: boolean, accessAllStores: boolean, accounts: Array<{ __typename?: 'MdAccount', id: string, name: string }> } };

export type InitWorkspaceQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<MdStoreFilterInput>;
  sortBy?: InputMaybe<MdStoreSortByInput>;
}>;


export type InitWorkspaceQuery = { MdStores: { __typename?: 'MdStores', items: Array<{ __typename?: 'MdStore', name: string, id: string, account?: { __typename?: 'MdAccount', id: string, name: string, product: MdAccountProduct } | null, crmStore?: { __typename?: 'AnyChatStore', isCrmEnabled: boolean, chats: Array<{ __typename?: 'InstagramStoreChat', type: ChatType } | { __typename?: 'LazadaStoreChat', type: ChatType } | { __typename?: 'LineStoreChat', type: ChatType } | { __typename?: 'MessengerStoreChat', type: ChatType } | { __typename?: 'ShopeeStoreChat', type: ChatType } | { __typename?: 'TikTokShopStoreChat', type: ChatType } | { __typename?: 'WhatsAppStoreChat', type: ChatType }> } | null }> } };

export type ValidateWorkspaceQueryVariables = Exact<{
  mdStoreId: Scalars['Long']['input'];
}>;


export type ValidateWorkspaceQuery = { MdStore: { __typename?: 'MdStore', name: string, id: string, account?: { __typename?: 'MdAccount', id: string, name: string, product: MdAccountProduct } | null, crmStore?: { __typename?: 'AnyChatStore', isCrmEnabled: boolean, chats: Array<{ __typename?: 'InstagramStoreChat', type: ChatType } | { __typename?: 'LazadaStoreChat', type: ChatType } | { __typename?: 'LineStoreChat', type: ChatType } | { __typename?: 'MessengerStoreChat', type: ChatType } | { __typename?: 'ShopeeStoreChat', type: ChatType } | { __typename?: 'TikTokShopStoreChat', type: ChatType } | { __typename?: 'WhatsAppStoreChat', type: ChatType }> } | null } };

export type WorkspaceDataFragment = { __typename?: 'MdStore', name: string, id: string, account?: { __typename?: 'MdAccount', id: string, name: string, product: MdAccountProduct } | null, crmStore?: { __typename?: 'AnyChatStore', isCrmEnabled: boolean, chats: Array<{ __typename?: 'InstagramStoreChat', type: ChatType } | { __typename?: 'LazadaStoreChat', type: ChatType } | { __typename?: 'LineStoreChat', type: ChatType } | { __typename?: 'MessengerStoreChat', type: ChatType } | { __typename?: 'ShopeeStoreChat', type: ChatType } | { __typename?: 'TikTokShopStoreChat', type: ChatType } | { __typename?: 'WhatsAppStoreChat', type: ChatType }> } | null };

export type CreateAnylogiSupplierUserMutationVariables = Exact<{
  role: AnylogiUserRoles;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  timezone: AnylogiTimezone;
  currency: AnylogiCurrencyInput;
  language: Language;
  password?: InputMaybe<Scalars['String']['input']>;
  supplierId: Scalars['ID']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateAnylogiSupplierUserMutation = { createAnylogiSupplierUser: { __typename?: 'Id', id: string } };

export type DeleteAnylogiSupplierUsersMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type DeleteAnylogiSupplierUsersMutation = { deleteAnylogiSupplierUsers: { __typename?: 'BulkOperationResponse', failed: number, succeeded: number } };

export type ReinviteAnylogiSupplierUsersMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  selectAll?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<AnylogiUserFilters>;
}>;


export type ReinviteAnylogiSupplierUsersMutation = { reinviteAnylogiSupplierUsers: { __typename?: 'BulkOperationResponse', failed: number, succeeded: number } };

export type UpdateAnylogiSupplierUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  timezone: AnylogiTimezone;
  currency: AnylogiCurrencyInput;
  language: Language;
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAnylogiSupplierUserMutation = { updateAnylogiSupplierUser: { __typename?: 'StatusOk', ok: boolean } };

export type GetAnylogiUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAnylogiUserQuery = { getAnylogiUser: { __typename?: 'AnylogiUserDetailed', id: string, email: string, role: AnylogiUserRoles, status: AnylogiUserStatus, firstName: string, lastName: string, created: any, supplier?: { __typename?: 'Supplier', id: string, name: string } | null, preferences?: { __typename?: 'AnylogiUserPreferences', currency: AnylogiCurrency, language: Language, timezone: AnylogiTimezone } | null } };

export type GetAnylogiUsersQueryVariables = Exact<{
  filters: AnylogiUserFilters;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAnylogiUsersQuery = { getAnylogiUsers: { __typename?: 'AnylogiUsersPaginated', total: number, page: number, records: Array<{ __typename?: 'AnylogiUser', id: string, email: string, role: AnylogiUserRoles, status: AnylogiUserStatus, firstName: string, lastName: string, created: any }> } };

export type MdAccountSelectQueryVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type MdAccountSelectQuery = { MdAccount: { __typename?: 'MdAccount', id: string, name: string } };

export type MdAccountsSelectQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<MdAccountFilterInput>;
  sortBy?: InputMaybe<MdAccountSortByInput>;
}>;


export type MdAccountsSelectQuery = { MdAccounts: { __typename?: 'MdAccounts', total: number, start: number, limit: number, length: number, items: Array<{ __typename?: 'MdAccount', name: string, id: string }> } };

export type MdProvincesQueryVariables = Exact<{
  filter?: InputMaybe<MdProvinceFilterInput>;
}>;


export type MdProvincesQuery = { MdProvinces: Array<{ __typename?: 'MdProvince', id: string, countryId: string, name: string, lname: string, country: { __typename?: 'MdCountry', languageId: string } }> };

export type MdStoreSelectQueryVariables = Exact<{
  mdStoreId: Scalars['Long']['input'];
}>;


export type MdStoreSelectQuery = { MdStore: { __typename?: 'MdStore', id: string, name: string } };

export type MdStoresSelectQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<MdStoreFilterInput>;
  sortBy?: InputMaybe<MdStoreSortByInput>;
}>;


export type MdStoresSelectQuery = { MdStores: { __typename?: 'MdStores', length: number, limit: number, start: number, total: number, items: Array<{ __typename?: 'MdStore', id: string, name: string }> } };

export type MdAccountQueryVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type MdAccountQuery = { MdAccount: { __typename?: 'MdAccount', address1?: string | null, address2?: string | null, cityName?: string | null, countryId: string, createdAt: string, hubspotCustomerId?: string | null, id: string, name: string, netsuiteVendorId?: string | null, phoneNumber: string, phoneNumberCountryId: string, product: MdAccountProduct, provinceId?: string | null, status: MdAccountStatus, updatedAt: string, websiteUrl?: string | null, zipcode?: string | null } };

export type AccountCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountCountriesQuery = { MdCountriesUsedByAccounts: Array<{ __typename?: 'MdCountry', id: string }> };

export type HasLogisticsChannelQueryVariables = Exact<{
  storeId?: InputMaybe<Scalars['Long']['input']>;
}>;


export type HasLogisticsChannelQuery = { hasLogisticsChannel: { __typename?: 'HasLogisticsChannel', boolean: boolean } };

export type TextMessageFieldsFragment = { __typename?: 'PlainTextMessage', text: string, richText?: string | null, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null };

export type TextComponentFieldsFragment = { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null };

export type LineUrlActionFields_LineUrlText_Fragment = { __typename?: 'LineUrlText', url: string };

export type LineUrlActionFields_LineUrlVariable_Fragment = { __typename?: 'LineUrlVariable', variable: string };

export type LineUrlActionFieldsFragment = LineUrlActionFields_LineUrlText_Fragment | LineUrlActionFields_LineUrlVariable_Fragment;

export type RichMessageFieldsFragment = { __typename?: 'RichMessage', imageUrl: string, urlAction?: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } | null };

export type ImageMessageFieldsFragment = { __typename?: 'ImageMessage', images: Array<{ __typename?: 'ImageItem', imageUrl: string, label?: string | null, urlAction: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } }> };

export type ButtonMessageFieldsFragment = { __typename?: 'ButtonMessage', cards: Array<{ __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename?: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null }> };

export type SingleImageMessageFieldsFragment = { __typename?: 'SingleImageMessage', originalUrl: string, previewUrl: string };

export type FileMessageFieldsFragment = { __typename?: 'FileMessage', fileUrl: string, card: { __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null } };

export type VideoMessageFieldsFragment = { __typename?: 'VideoMessage', originalUrl: string, previewUrl: string };

export type LineMessageFields_ButtonMessage_Fragment = { __typename?: 'ButtonMessage', cards: Array<{ __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename?: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null }> };

export type LineMessageFields_FileMessage_Fragment = { __typename?: 'FileMessage', fileUrl: string, card: { __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null } };

export type LineMessageFields_ImageMessage_Fragment = { __typename?: 'ImageMessage', images: Array<{ __typename?: 'ImageItem', imageUrl: string, label?: string | null, urlAction: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } }> };

export type LineMessageFields_PlainTextMessage_Fragment = { __typename?: 'PlainTextMessage', text: string, richText?: string | null, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null };

export type LineMessageFields_RichMessage_Fragment = { __typename?: 'RichMessage', imageUrl: string, urlAction?: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } | null };

export type LineMessageFields_SingleImageMessage_Fragment = { __typename?: 'SingleImageMessage', originalUrl: string, previewUrl: string };

export type LineMessageFields_VideoMessage_Fragment = { __typename?: 'VideoMessage', originalUrl: string, previewUrl: string };

export type LineMessageFieldsFragment = LineMessageFields_ButtonMessage_Fragment | LineMessageFields_FileMessage_Fragment | LineMessageFields_ImageMessage_Fragment | LineMessageFields_PlainTextMessage_Fragment | LineMessageFields_RichMessage_Fragment | LineMessageFields_SingleImageMessage_Fragment | LineMessageFields_VideoMessage_Fragment;

export type GetLineUnitMessageQueryVariables = Exact<{
  input: FetchUnitMessageRequest;
}>;


export type GetLineUnitMessageQuery = { UnitMessage?: { __typename?: 'UnitMessage', id: string, name: string, content: Array<{ __typename?: 'ButtonMessage', cards: Array<{ __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename?: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null }> } | { __typename?: 'FileMessage', fileUrl: string, card: { __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null } } | { __typename?: 'ImageMessage', images: Array<{ __typename?: 'ImageItem', imageUrl: string, label?: string | null, urlAction: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } }> } | { __typename?: 'PlainTextMessage', text: string, richText?: string | null, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'RichMessage', imageUrl: string, urlAction?: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } | null } | { __typename?: 'SingleImageMessage', originalUrl: string, previewUrl: string } | { __typename?: 'VideoMessage', originalUrl: string, previewUrl: string }> } | null };

export type DeserializeDraftUnitMessageQueryVariables = Exact<{
  input: DecodeDraftUnitMessageContentRequest;
}>;


export type DeserializeDraftUnitMessageQuery = { DecodeDraftUnitMessageContent?: { __typename?: 'DraftUnitMessage', name: string, content: Array<{ __typename?: 'ButtonMessage', cards: Array<{ __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename?: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null }> } | { __typename?: 'FileMessage', fileUrl: string, card: { __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null } } | { __typename?: 'ImageMessage', images: Array<{ __typename?: 'ImageItem', imageUrl: string, label?: string | null, urlAction: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } }> } | { __typename?: 'PlainTextMessage', text: string, richText?: string | null, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'RichMessage', imageUrl: string, urlAction?: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } | null } | { __typename?: 'SingleImageMessage', originalUrl: string, previewUrl: string } | { __typename?: 'VideoMessage', originalUrl: string, previewUrl: string }> } | null };

export type SerializeDraftUnitMessageQueryVariables = Exact<{
  input: GenerateDraftUnitMessageContentRequest;
}>;


export type SerializeDraftUnitMessageQuery = { GenerateDraftUnitMessageContent?: string | null };

export type GetLineRichMenuSelectorDialogListQueryVariables = Exact<{
  input: LineRichMenusInput;
}>;


export type GetLineRichMenuSelectorDialogListQuery = { LineRichMenus?: { __typename?: 'PageResultLineRichMenuListItem', total: number, records: Array<{ __typename?: 'LineRichMenuListItem', id: string, title: string, imageUrl?: string | null }> } | null };

export type GenerateAssetUploadUrlV2MutationVariables = Exact<{
  input: GenerateAssetUploadUrlRequest;
}>;


export type GenerateAssetUploadUrlV2Mutation = { GenerateAssetUploadUrlV2?: { __typename?: 'AssetUploadUrl', originalUrl: { __typename?: 'UploadURL', url: string } } | null };

export type GenerateTrackingUrlMutationVariables = Exact<{
  input: GenerateTrackingUrlRequest;
}>;


export type GenerateTrackingUrlMutation = { GenerateTrackingUrl?: Array<{ __typename?: 'TrackingUrl', originalUrl: string, trackingUrl: string, shortUrl?: string | null }> | null };

export type GetAllInfluencerCampaignsQueryVariables = Exact<{
  storeId: Scalars['Long']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  status: InfluencerCampaignStatus;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetAllInfluencerCampaignsQuery = { AllInfluencerCampaigns?: { __typename?: 'PageResultInfluencerCampaign', total: number, records: Array<{ __typename?: 'InfluencerCampaign', id: string, campaignType: InfluencerCampaignType, name: string }> } | null };

export type GetSingleAndAllInfluencerCampaignsQueryVariables = Exact<{
  campaignId: Scalars['Long']['input'];
  campaignType: InfluencerCampaignType;
  storeId: Scalars['Long']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  status: InfluencerCampaignStatus;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetSingleAndAllInfluencerCampaignsQuery = { InfluencerCampaignsByIds?: Array<{ __typename?: 'InfluencerCampaign', id: string, campaignType: InfluencerCampaignType, name: string }> | null, AllInfluencerCampaigns?: { __typename?: 'PageResultInfluencerCampaign', total: number, records: Array<{ __typename?: 'InfluencerCampaign', id: string, campaignType: InfluencerCampaignType, name: string }> } | null };

export type GetCustomerListWithTagQueryVariables = Exact<{
  storeId: Scalars['Long']['input'];
  chatTypeFilter: ChatTypeFilter;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  tagFilter?: InputMaybe<TagFilterInput>;
  messagingChannel?: InputMaybe<ChatType>;
  daysSinceLastReceivedMessageWithIn?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCustomerListWithTagQuery = { Chats?: { __typename?: 'Chats', hasNext: boolean, chats: Array<{ __typename?: 'Chat', id: string, userName: string, avatar: string }> } | null };

export type GetInfluencerCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInfluencerCategoriesQuery = { InfluencerCategories?: Array<{ __typename?: 'InfluencerCategory', id: string, name: string }> | null };

export type GetLineRichMenuPostbackOptionsQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type GetLineRichMenuPostbackOptionsQuery = { LineRichMenu?: { __typename?: 'LineRichMenu', id: string, title: string, template: { __typename?: 'LineRichMenuTemplate', id: LineRichMenuTemplateId, actions: Array<{ __typename?: 'LineRichMenuMessageAction' } | { __typename?: 'LineRichMenuPostbackAction', trigger: string } | { __typename?: 'LineRichMenuUriAction' } | null> } } | null };

export type SearchMkpListingV2QueryVariables = Exact<{
  input: GetAnyChatSaleChannelProductsRequest;
}>;


export type SearchMkpListingV2Query = { AnyChatSaleChannelProducts?: Array<{ __typename?: 'SaleChannelProduct', id: string, name: string, saleChannelType: AnyChatSaleChannelType }> | null };

export type CreateSupplierMutationVariables = Exact<{
  name: Scalars['String']['input'];
  accountId: Scalars['Long']['input'];
  provinceId?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country>;
  addressFirst?: InputMaybe<Scalars['String']['input']>;
  addressSecond?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<PhoneNumberInput>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSupplierMutation = { createSupplier: { __typename?: 'Id', id: string } };

export type GetSupplierSelectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSupplierSelectQuery = { getSupplier: { __typename?: 'SupplierDetailed', id: string, name: string } };

export type GetSuppliersSelectQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filters: SupplierFilters;
}>;


export type GetSuppliersSelectQuery = { getSuppliers: { __typename?: 'SuppliersPaginated', total: number, page: number, records: Array<{ __typename?: 'Supplier', id: string, name: string }> } };

export type ProductSetVariantsSelectorTagsQueryVariables = Exact<{
  filter?: InputMaybe<ProductTagsFilterInput>;
}>;


export type ProductSetVariantsSelectorTagsQuery = { tagsV2: Array<string> };

export type ProductSetVariantsVariantSelectorQueryVariables = Exact<{
  filter: ProductVariantForSetFilterInput;
  pageSize: Scalars['Int']['input'];
  pageNumber: Scalars['Int']['input'];
}>;


export type ProductSetVariantsVariantSelectorQuery = { productVariantsForProductSet: { __typename?: 'ProductVariantForSetView', total: number, productVariants: Array<{ __typename?: 'ProductVariantForSetViewRecord', productName: string, variantName: string, productVariantId: string, media?: string | null, productCode: string }> } };

export type ProductTagsInputQueryVariables = Exact<{
  filter?: InputMaybe<ProductTagsFilterInput>;
}>;


export type ProductTagsInputQuery = { tagsV2: Array<string> };

export type ProductTagsSelectQueryVariables = Exact<{
  filter?: InputMaybe<ProductTagsFilterInput>;
}>;


export type ProductTagsSelectQuery = { tagsV2: Array<string> };

export type ProductVariantValuesSelectQueryVariables = Exact<{
  input: VariantValuesInput;
}>;


export type ProductVariantValuesSelectQuery = { variantValues: { __typename?: 'VariantValuesPayloadList', items: Array<{ __typename?: 'VariantValuesPayload', name: string }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type ChannelSyncsQueryVariables = Exact<{
  after: Scalars['OffsetDateTime']['input'];
  masterDataStoreId: Scalars['Long']['input'];
}>;


export type ChannelSyncsQuery = { saleChannelSyncs: { __typename?: 'SaleChannelSyncSummaryList', saleChannelSyncs: Array<{ __typename?: 'SaleChannelSyncSummary', action: Action, saleChannelTypes: Array<MarketplaceSaleChannelType>, status: SaleChannelSyncStatus, errors?: Array<Record<string, any>> | null }> } };

export type ProductMediaUploadQueryVariables = Exact<{
  fileName: Scalars['String']['input'];
}>;


export type ProductMediaUploadQuery = { productMediaUpload: { __typename?: 'PublicUploadFilePayload', fileName: string, signedUrl: string } };

export type MdStoresChannelsQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<MdStoreFilterInput>;
  sortBy?: InputMaybe<MdStoreSortByInput>;
}>;


export type MdStoresChannelsQuery = { MdStores: { __typename?: 'MdStores', items: Array<{ __typename?: 'MdStore', id: string, channels: Array<{ __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType, isManualChannel: boolean, data: { __typename?: 'AmazonSaleChannelData', amazonMarketplace: AmazonSellerCentralMarketplace } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData', lazadaMarketplace: LazadaMarketplace } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData', qoo10Marketplace: Qoo10Marketplace } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData', showReconnectButton: boolean, expiresAt: string, shopeeMarketplace: ShopeeMarketplace } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData', tiktokMarketplace: TikTokRegion } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' } }> }> } };

export type AmazonSalesChartQueryVariables = Exact<{
  input: AmazonSalesChartInput;
}>;


export type AmazonSalesChartQuery = { amazonSalesChart: { __typename?: 'AmazonSalesChartPayload', averageNumberOfUnitsPerOrderItem: Array<Record<string, any>>, currency: ReportSupportedCurrency, itemAverageCost: Array<Record<string, any>>, itemsOrdered: Array<Record<string, any>>, sales: Array<Record<string, any>>, unitAverageCost: Array<Record<string, any>>, unitsOrdered: Array<Record<string, any>> } };

export type AmazonSalesDetailedReportQueryVariables = Exact<{
  input: AmazonSalesDetailedReportInput;
}>;


export type AmazonSalesDetailedReportQuery = { amazonSalesDetailedReport: { __typename?: 'AmazonSalesDetailedReportPayloadList', items: Array<{ __typename?: 'AmazonSalesDetailedReportPayload', averageNumberOfUnitsPerOrderItem: string, currency: ReportSupportedCurrency, date: any, itemAverageCost: string, itemsOrdered: string, sales: string, unitAverageCost: string, unitsOrdered: string }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number }, total: { __typename?: 'AmazonSalesDetailedReportTotalPayload', averageNumberOfUnitsPerOrderItem: string, currency: ReportSupportedCurrency, itemAverageCost: string, itemsOrdered: string, sales: string, unitAverageCost: string, unitsOrdered: string } } };

export type AmazonSalesSummaryQueryVariables = Exact<{
  input: AmazonSalesSummaryInput;
}>;


export type AmazonSalesSummaryQuery = { amazonSalesSummary: { __typename?: 'AmazonSalesSummaryPayload', currency: ReportSupportedCurrency, averageNumberOfUnitsPerOrderItem: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, itemAverageCost: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, itemsOrdered: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, sales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, unitAverageCost: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, unitsOrdered: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string } } };

export type DatasourcesListQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<DatasourceFilterInput>;
  sortBy?: InputMaybe<DatasourceSortByInput>;
}>;


export type DatasourcesListQuery = { allDatasources: { __typename?: 'DatasourcePayloadList', items: Array<{ __typename?: 'DatasourcePayload', masterDataStoreId: string, createdAt: string, id: string, isActive: boolean, setting?: Record<string, any> | null, status: DatasourceStatus, statusDetail?: Record<string, any> | null, tokenId?: string | null, type: DatasourceType, updatedAt: string }>, meta: { __typename?: 'ReportListMeta', total: number } } };

export type LazadaSalesChartQueryVariables = Exact<{
  input: LazadaSalesChartInput;
}>;


export type LazadaSalesChartQuery = { lazadaSalesChart: { __typename?: 'LazadaSalesChartPayload', conversionRate: Array<Record<string, any>>, currency: ReportSupportedCurrency, orders: Array<Record<string, any>>, sales: Array<Record<string, any>>, unitsOrdered: Array<Record<string, any>>, visitors: Array<Record<string, any>> } };

export type LazadaSalesDetailedReportQueryVariables = Exact<{
  input: LazadaSalesDetailedReportInput;
}>;


export type LazadaSalesDetailedReportQuery = { lazadaSalesDetailedReport: { __typename?: 'LazadaSalesDetailedReportPayloadList', items: Array<{ __typename?: 'LazadaSalesDetailedReportPayload', conversionRate: string, currency: ReportSupportedCurrency, date: any, orders: string, sales: string, unitsOrdered: string, visitors: string }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number }, total: { __typename?: 'LazadaSalesDetailedReportTotalPayload', conversionRate: string, currency: ReportSupportedCurrency, orders: string, sales: string, unitsOrdered: string, visitors: string } } };

export type LazadaSalesSummaryQueryVariables = Exact<{
  input: LazadaSalesSummaryInput;
}>;


export type LazadaSalesSummaryQuery = { lazadaSalesSummary: { __typename?: 'LazadaSalesSummaryPayload', currency: ReportSupportedCurrency, conversionRate: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, orders: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, sales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, unitsOrdered: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, visitors: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string } } };

export type RakutenSalesReportChartQueryVariables = Exact<{
  input: RakutenSalesReportChartInput;
}>;


export type RakutenSalesReportChartQuery = { rakutenSalesReportChart: { __typename?: 'RakutenSalesReportChartPayload', conversionRate: Array<Record<string, any>>, currency: ReportSupportedCurrency, orderCount: Array<Record<string, any>>, sessions: Array<Record<string, any>>, totalSales: Array<Record<string, any>> } };

export type RakutenSalesReportSummaryQueryVariables = Exact<{
  input: RakutenSalesReportSummaryInput;
}>;


export type RakutenSalesReportSummaryQuery = { rakutenSalesReportSummary: { __typename?: 'RakutenSalesReportSummaryPayload', currency: ReportSupportedCurrency, conversionRate: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, orderCount: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, sessions: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, totalSales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string } } };

export type RakutenSalesReportTableQueryVariables = Exact<{
  input: RakutenSalesReportTableInput;
}>;


export type RakutenSalesReportTableQuery = { rakutenSalesReportTable: { __typename?: 'RakutenSalesReportTablePayloadList', items: Array<{ __typename?: 'RakutenSalesReportTablePayload', conversionRate: string, currency: ReportSupportedCurrency, date: any, orderCount: number, sessions: number, totalSales: string }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number }, total: { __typename?: 'RakutenSalesReportTotalPayload', conversionRate: string, orderCount: number, sessions: number, totalSales: string } } };

export type ShopeeSalesChartQueryVariables = Exact<{
  input: ShopeeSalesChartInput;
}>;


export type ShopeeSalesChartQuery = { shopeeSalesChart: { __typename?: 'ShopeeSalesChartPayload', currency: ReportSupportedCurrency, orders: Array<Record<string, any>>, sales: Array<Record<string, any>>, salesPerOrder: Array<Record<string, any>>, visitors: Array<Record<string, any>> } };

export type ShopeeSalesDetailedReportQueryVariables = Exact<{
  input: ShopeeSalesDetailedReportInput;
}>;


export type ShopeeSalesDetailedReportQuery = { shopeeSalesDetailedReport: { __typename?: 'ShopeeSalesDetailedReportPayloadList', items: Array<{ __typename?: 'ShopeeSalesDetailedReportPayload', currency: ReportSupportedCurrency, date: any, orders: string, sales: string, salesPerOrder: string, visitors: string }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number }, total: { __typename?: 'ShopeeSalesDetailedReportTotalPayload', currency: ReportSupportedCurrency, orders: string, sales: string, salesPerOrder: string, visitors: string } } };

export type ShopeeSalesSummaryQueryVariables = Exact<{
  input: ShopeeSalesSummaryInput;
}>;


export type ShopeeSalesSummaryQuery = { shopeeSalesSummary: { __typename?: 'ShopeeSalesSummaryPayload', currency: ReportSupportedCurrency, orders: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, sales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, salesPerOrder: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, visitors: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string } } };

export type ShopifySalesReportChartQueryVariables = Exact<{
  input: ShopifySalesReportChartInput;
}>;


export type ShopifySalesReportChartQuery = { shopifySalesReportChart: { __typename?: 'ShopifySalesReportChartPayload', currency: ReportSupportedCurrency, discounts: Array<Record<string, any>>, grossSales: Array<Record<string, any>>, netSales: Array<Record<string, any>>, orderCount: Array<Record<string, any>>, returns: Array<Record<string, any>>, shipping: Array<Record<string, any>>, taxes: Array<Record<string, any>>, totalSales: Array<Record<string, any>> } };

export type ShopifySalesReportSummaryQueryVariables = Exact<{
  input: ShopifySalesReportSummaryInput;
}>;


export type ShopifySalesReportSummaryQuery = { shopifySalesReportSummary: { __typename?: 'ShopifySalesReportSummaryPayload', currency: ReportSupportedCurrency, discounts: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, grossSales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, netSales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, orderCount: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, returns: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, shipping: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, taxes: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, totalSales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string } } };

export type ShopifySalesReportTableQueryVariables = Exact<{
  input: ShopifySalesReportTableInput;
}>;


export type ShopifySalesReportTableQuery = { shopifySalesReportTable: { __typename?: 'ShopifySalesReportTablePayloadList', items: Array<{ __typename?: 'ShopifySalesReportTablePayload', currency: ReportSupportedCurrency, date: any, discounts: string, grossSales: string, netSales: string, orderCount: string, returns: string, shipping: string, taxes: string, totalSales: string }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number }, total: { __typename?: 'ShopifySalesReportTotalPayload', discounts: string, grossSales: string, netSales: string, orderCount: string, returns: string, shipping: string, taxes: string, totalSales: string } } };

export type TikTokSalesReportChartQueryVariables = Exact<{
  input: TikTokSalesReportChartInput;
}>;


export type TikTokSalesReportChartQuery = { tikTokSalesReportChart: { __typename?: 'TikTokSalesReportChartPayload', currency: ReportSupportedCurrency, itemsOrdered: Array<Record<string, any>>, sales: Array<Record<string, any>>, unitsOrdered: Array<Record<string, any>> } };

export type TikTokSalesReportDetailedReportQueryVariables = Exact<{
  input: TikTokSalesReportDetailedReportInput;
}>;


export type TikTokSalesReportDetailedReportQuery = { tikTokSalesReportDetailedReport: { __typename?: 'TikTokSalesReportDetailedReportPayloadList', items: Array<{ __typename?: 'TikTokSalesReportDetailedReportPayload', currency: ReportSupportedCurrency, date: any, itemsOrdered: string, sales: string, unitsOrdered: string }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number }, total: { __typename?: 'TikTokSalesReportDetailedReportTotalPayload', currency: ReportSupportedCurrency, itemsOrdered: string, sales: string, unitsOrdered: string } } };

export type TikTokSalesReportSummaryQueryVariables = Exact<{
  input: TikTokSalesReportSummaryInput;
}>;


export type TikTokSalesReportSummaryQuery = { tikTokSalesReportSummary: { __typename?: 'TikTokSalesReportSummaryPayload', currency: ReportSupportedCurrency, itemsOrdered: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, sales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, unitsOrdered: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string } } };

export type TokopediaSalesChartQueryVariables = Exact<{
  input: TokopediaSalesChartInput;
}>;


export type TokopediaSalesChartQuery = { tokopediaSalesChart: { __typename?: 'TokopediaSalesChartPayload', currency: ReportSupportedCurrency, orders: Array<Record<string, any>>, sales: Array<Record<string, any>> } };

export type TokopediaSalesDetailedReportQueryVariables = Exact<{
  input: TokopediaSalesDetailedReportInput;
}>;


export type TokopediaSalesDetailedReportQuery = { tokopediaSalesDetailedReport: { __typename?: 'TokopediaSalesDetailedReportPayloadList', items: Array<{ __typename?: 'TokopediaSalesDetailedReportPayload', currency: ReportSupportedCurrency, date: any, orders: string, sales: string }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number }, total: { __typename?: 'TokopediaSalesDetailedReportTotalPayload', currency: ReportSupportedCurrency, orders: string, sales: string } } };

export type TokopediaSalesSummaryQueryVariables = Exact<{
  input: TokopediaSalesSummaryInput;
}>;


export type TokopediaSalesSummaryQuery = { tokopediaSalesSummary: { __typename?: 'TokopediaSalesSummaryPayload', currency: ReportSupportedCurrency, orders: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, sales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string } } };

export type YahooSalesReportChartQueryVariables = Exact<{
  input: YahooSalesReportChartInput;
}>;


export type YahooSalesReportChartQuery = { yahooSalesReportChart: { __typename?: 'YahooSalesReportChartPayload', avgSpendPerCustomer: Array<Record<string, any>>, currency: ReportSupportedCurrency, orderCount: Array<Record<string, any>>, totalSales: Array<Record<string, any>>, unitSoldCount: Array<Record<string, any>> } };

export type YahooSalesReportSummaryQueryVariables = Exact<{
  input: YahooSalesReportSummaryInput;
}>;


export type YahooSalesReportSummaryQuery = { yahooSalesReportSummary: { __typename?: 'YahooSalesReportSummaryPayload', currency: ReportSupportedCurrency, avgSpendPerCustomer: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, orderCount: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, totalSales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, unitSoldCount: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string } } };

export type YahooSalesReportTableQueryVariables = Exact<{
  input: YahooSalesReportTableInput;
}>;


export type YahooSalesReportTableQuery = { yahooSalesReportTable: { __typename?: 'YahooSalesReportTablePayloadList', items: Array<{ __typename?: 'YahooSalesReportTablePayload', avgSpendPerCustomer: number, currency: ReportSupportedCurrency, date: any, orderCount: number, totalSales: string, unitSoldCount: number }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number }, total: { __typename?: 'YahooSalesReportTotalPayload', avgSpendPerCustomer: number, orderCount: number, totalSales: string, unitSoldCount: number } } };

export type GetShipperAddressQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetShipperAddressQuery = { getShipperAddress: { __typename?: 'ShipperAddress', id: string, addressFirst: string, addressSecond?: string | null, city?: string | null, companyName?: string | null, country: Country, email: string, accountId: string, personInCharge: string, postalCode?: string | null, websiteUrl?: string | null, default: boolean, region?: { __typename?: 'Region', id: string, localName: string, name: string, language: Language, provinceId: string } | null, phone: { __typename?: 'PhoneNumber', countryCode: Country, number: string } } };

export type GetShipperAddressesQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  filter: GetShipperAddressFilter;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type GetShipperAddressesQuery = { getShipperAddresses: { __typename?: 'shipperAddressesListResponse', page: number, perPage: number, total: number, shipperAddresses: Array<{ __typename?: 'ShipperAddress', id: string, addressFirst: string, addressSecond?: string | null, city?: string | null, companyName?: string | null, country: Country, email: string, accountId: string, personInCharge: string, postalCode?: string | null, default: boolean, websiteUrl?: string | null, region?: { __typename?: 'Region', id: string, localName: string, name: string, language: Language, provinceId: string } | null, phone: { __typename?: 'PhoneNumber', countryCode: Country, number: string } }> } };

export type InfluencerTabQueryQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type InfluencerTabQueryQuery = { Customer?: { __typename?: 'Customer', id: string, email?: string | null, phoneNumber?: string | null, birthDate?: any | null, age?: number | null, gender?: Gender | null, address?: { __typename?: 'CustomerAddress', province?: { __typename?: 'MdProvince', id: string, name: string } | null } | null } | null };

export type GetLazadaVoucherQueryVariables = Exact<{
  input: GetLazadaVouchersRequest;
}>;


export type GetLazadaVoucherQuery = { LazadaVouchers?: { __typename?: 'LazadaVouchers', total: number, vouchers: Array<{ __typename?: 'LazadaVoucher', id: string, currency: string, endDate: string, minSpend: string, name: string, startDate: string, status: LazadaVoucherStatus, type: LazadaVoucherType, discount: { __typename?: 'LazadaVoucherMoneyValueOff', amount: string } | { __typename?: 'LazadaVoucherPercentageDiscountOff', percentage: string } }> } | null };

export type ShopeeVoucherListQueryVariables = Exact<{
  input: ShopeeGetVouchersRequestInput;
}>;


export type ShopeeVoucherListQuery = { ChatShopeeVouchers?: { __typename?: 'GetChatShopeeVouchers', vouchers: Array<{ __typename?: 'ChatShopeeVoucher', currency: string, displayStartTime: string, minBasketPrice?: string | null, name: string, status: ShopeeVoucherStatus, validUntil: string, voucherId: string, voucherCode: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } }> } | null };

export type CustomerPanelQueryQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type CustomerPanelQueryQuery = { Customer?: { __typename?: 'Customer', id: string, name: string, email?: string | null, phoneNumber?: string | null, birthDate?: any | null, age?: number | null, gender?: Gender | null, height?: number | null, weight?: number | null, size?: string | null, address?: { __typename?: 'CustomerAddress', province?: { __typename?: 'MdProvince', id: string, name: string } | null } | null } | null };

export type UpdateCustomerPanelProfileMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  birthday?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  height?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCustomerPanelProfileMutation = { UpdateCustomer?: { __typename?: 'Customer', id: string, birthDate?: any | null, age?: number | null, gender?: Gender | null, height?: number | null, weight?: number | null, size?: string | null } | null };

export type InfluencerContainerQueryQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type InfluencerContainerQueryQuery = { Customer?: { __typename?: 'Customer', id: string, email?: string | null, phoneNumber?: string | null, birthDate?: any | null, age?: number | null, gender?: Gender | null, address?: { __typename?: 'CustomerAddress', province?: { __typename?: 'MdProvince', id: string, name: string } | null } | null } | null };

export type OrderPanelItemFieldsFragment = { __typename?: 'OrderItem', name: string, imageUrl?: string | null, amount: number, costMoney: { __typename?: 'AnyChatMoney', amount: string, currencyCode: string }, totalCostMoney: { __typename?: 'AnyChatMoney', amount: string, currencyCode: string } };

export type OrderPanelQueryQueryVariables = Exact<{
  input: GetCustomerOrderV2Request;
}>;


export type OrderPanelQueryQuery = { CustomerOrdersV2?: Array<{ __typename?: 'CustomerOrder', orderId: string, orderUrl?: string | null, orderedAt: number, status: DeliveryStatus, saleChannelType: AnyChatSaleChannelType, items: Array<{ __typename?: 'OrderItem', name: string, imageUrl?: string | null, amount: number, costMoney: { __typename?: 'AnyChatMoney', amount: string, currencyCode: string }, totalCostMoney: { __typename?: 'AnyChatMoney', amount: string, currencyCode: string } }>, totalPrice: { __typename?: 'AnyChatMoney', currencyCode: string, amount: string } }> | null };

export type AiMessageFailedSendEventFieldsFragment = { __typename: 'AIMessageFailedToSendEvent' };

export type ManualAssignFieldsFragment = { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } };

export type ManualUnassignFieldsFragment = { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } };

export type SystemAutoAssignAiFieldsFragment = { __typename: 'SystemAutoAssignAI' };

export type SystemAutoUnassignAiFieldsFragment = { __typename: 'SystemAutoUnassignAI' };

export type CommonChatEventDataFields_AiMessageFailedToSendEvent_Fragment = { __typename: 'AIMessageFailedToSendEvent' };

export type CommonChatEventDataFields_ActivateAi_Fragment = { __typename?: 'ActivateAI', isAuto: boolean };

export type CommonChatEventDataFields_AddUserToAssigneeList_Fragment = { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } };

export type CommonChatEventDataFields_CloseChat_Fragment = { __typename?: 'CloseChat' };

export type CommonChatEventDataFields_DeactivateAi_Fragment = { __typename?: 'DeactivateAI', isAuto: boolean };

export type CommonChatEventDataFields_ManualAssign_Fragment = { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } };

export type CommonChatEventDataFields_ManualUnassign_Fragment = { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } };

export type CommonChatEventDataFields_MessageSendFailedEvent_Fragment = { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } };

export type CommonChatEventDataFields_MuteChat_Fragment = { __typename?: 'MuteChat' };

export type CommonChatEventDataFields_RemoveUserFromAssigneeList_Fragment = { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } };

export type CommonChatEventDataFields_ReopenChat_Fragment = { __typename?: 'ReopenChat' };

export type CommonChatEventDataFields_SystemAutoAssignAi_Fragment = { __typename: 'SystemAutoAssignAI' };

export type CommonChatEventDataFields_SystemAutoUnassignAi_Fragment = { __typename: 'SystemAutoUnassignAI' };

export type CommonChatEventDataFields_UnmuteChat_Fragment = { __typename?: 'UnmuteChat' };

export type CommonChatEventDataFieldsFragment = CommonChatEventDataFields_AiMessageFailedToSendEvent_Fragment | CommonChatEventDataFields_ActivateAi_Fragment | CommonChatEventDataFields_AddUserToAssigneeList_Fragment | CommonChatEventDataFields_CloseChat_Fragment | CommonChatEventDataFields_DeactivateAi_Fragment | CommonChatEventDataFields_ManualAssign_Fragment | CommonChatEventDataFields_ManualUnassign_Fragment | CommonChatEventDataFields_MessageSendFailedEvent_Fragment | CommonChatEventDataFields_MuteChat_Fragment | CommonChatEventDataFields_RemoveUserFromAssigneeList_Fragment | CommonChatEventDataFields_ReopenChat_Fragment | CommonChatEventDataFields_SystemAutoAssignAi_Fragment | CommonChatEventDataFields_SystemAutoUnassignAi_Fragment | CommonChatEventDataFields_UnmuteChat_Fragment;

export type CommonMessageEventFieldsFragment = { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } };

export type MessengerDetailFieldsFragment = { __typename?: 'MessengerChatPlatformDetail', isOptIn: boolean };

export type WhatsAppDetailFieldsFragment = { __typename?: 'WhatsAppChatPlatformDetail', isOptIn: boolean };

export type PlatformDetailFields_InstagramChatPlatformDetail_Fragment = { __typename?: 'InstagramChatPlatformDetail' };

export type PlatformDetailFields_LazadaChatPlatformDetail_Fragment = { __typename?: 'LazadaChatPlatformDetail' };

export type PlatformDetailFields_LineChatPlatformDetail_Fragment = { __typename?: 'LineChatPlatformDetail' };

export type PlatformDetailFields_MessengerChatPlatformDetail_Fragment = { __typename?: 'MessengerChatPlatformDetail', isOptIn: boolean };

export type PlatformDetailFields_ShopeeChatPlatformDetail_Fragment = { __typename?: 'ShopeeChatPlatformDetail' };

export type PlatformDetailFields_TikTokShopChatPlatformDetail_Fragment = { __typename?: 'TikTokShopChatPlatformDetail' };

export type PlatformDetailFields_WhatsAppChatPlatformDetail_Fragment = { __typename?: 'WhatsAppChatPlatformDetail', isOptIn: boolean };

export type PlatformDetailFieldsFragment = PlatformDetailFields_InstagramChatPlatformDetail_Fragment | PlatformDetailFields_LazadaChatPlatformDetail_Fragment | PlatformDetailFields_LineChatPlatformDetail_Fragment | PlatformDetailFields_MessengerChatPlatformDetail_Fragment | PlatformDetailFields_ShopeeChatPlatformDetail_Fragment | PlatformDetailFields_TikTokShopChatPlatformDetail_Fragment | PlatformDetailFields_WhatsAppChatPlatformDetail_Fragment;

export type ChatAssigneeFields_ChatAiAssignee_Fragment = { __typename: 'ChatAIAssignee' };

export type ChatAssigneeFields_ChatUserAssignee_Fragment = { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } };

export type ChatAssigneeFieldsFragment = ChatAssigneeFields_ChatAiAssignee_Fragment | ChatAssigneeFields_ChatUserAssignee_Fragment;

export type InstagramReactionFields_BotReaction_Fragment = { __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } };

export type InstagramReactionFields_UserReaction_Fragment = { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } };

export type InstagramReactionFieldsFragment = InstagramReactionFields_BotReaction_Fragment | InstagramReactionFields_UserReaction_Fragment;

export type InstagramCommonMessageFields_InstagramBotAutoReplyMessage_Fragment = { __typename?: 'InstagramBotAutoReplyMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> };

export type InstagramCommonMessageFields_InstagramBotAutoReplyMessageDelete_Fragment = { __typename?: 'InstagramBotAutoReplyMessageDelete', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> };

export type InstagramCommonMessageFields_InstagramBotMessage_Fragment = { __typename?: 'InstagramBotMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> };

export type InstagramCommonMessageFields_InstagramBotMessageDeleted_Fragment = { __typename?: 'InstagramBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> };

export type InstagramCommonMessageFields_InstagramUserMessage_Fragment = { __typename?: 'InstagramUserMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> };

export type InstagramCommonMessageFields_InstagramUserMessageDeleted_Fragment = { __typename?: 'InstagramUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> };

export type InstagramCommonMessageFieldsFragment = InstagramCommonMessageFields_InstagramBotAutoReplyMessage_Fragment | InstagramCommonMessageFields_InstagramBotAutoReplyMessageDelete_Fragment | InstagramCommonMessageFields_InstagramBotMessage_Fragment | InstagramCommonMessageFields_InstagramBotMessageDeleted_Fragment | InstagramCommonMessageFields_InstagramUserMessage_Fragment | InstagramCommonMessageFields_InstagramUserMessageDeleted_Fragment;

export type InstagramTextMessageFieldsFragment = { __typename?: 'TextMessageContent', text: string };

export type InstagramVideoMessageFieldsFragment = { __typename?: 'VideoMessageContent', previewUrl: string, originalUrl: string };

export type InstagramImageMessageFieldsFragment = { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string };

export type InstagramStoryMentionFieldsFragment = { __typename?: 'StoryMentionContent', story: { __typename?: 'Story', contentType?: string | null, originalUrl: string } };

export type InstagramLiveCommentFieldsFragment = { __typename?: 'TextLiveCommentContent', text: string };

export type AutomationFlowTriggerFields_AnyContent_Fragment = { __typename: 'AnyContent' };

export type AutomationFlowTriggerFields_ContainsKeyword_Fragment = { __typename?: 'ContainsKeyword', value: string };

export type AutomationFlowTriggerFieldsFragment = AutomationFlowTriggerFields_AnyContent_Fragment | AutomationFlowTriggerFields_ContainsKeyword_Fragment;

export type InstagramBotMessageDeletedFieldsFragment = { __typename?: 'InstagramBotMessageDeleted', messageId: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> };

export type InstagramBotAutoReplyMessageFieldsFragment = { __typename?: 'InstagramBotAutoReplyMessage', messageId: string, autoReplyInfo: { __typename?: 'LiveCommentAutoReplyInfo', id: string, name: string, trigger: { __typename: 'AnyContent' } | { __typename?: 'ContainsKeyword', value: string } } };

export type InstagramBotMessageFieldsFragment = { __typename?: 'InstagramBotMessage', messageState: MessageState, messageId: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent' } | { __typename?: 'TextLiveCommentContent' } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent' }, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> };

export type InstagramUserMessageDeletedFieldsFragment = { __typename?: 'InstagramUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> };

export type InstagramUserMessageFieldsFragment = { __typename?: 'InstagramUserMessage', messageId: string, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent', story: { __typename?: 'Story', contentType?: string | null, originalUrl: string } } | { __typename?: 'TextLiveCommentContent', text: string } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent', previewUrl: string, originalUrl: string }, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> };

export type InstagramMessageFields_InstagramBotAutoReplyMessage_Fragment = { __typename?: 'InstagramBotAutoReplyMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, autoReplyInfo: { __typename?: 'LiveCommentAutoReplyInfo', id: string, name: string, trigger: { __typename: 'AnyContent' } | { __typename?: 'ContainsKeyword', value: string } } };

export type InstagramMessageFields_InstagramBotAutoReplyMessageDelete_Fragment = { __typename?: 'InstagramBotAutoReplyMessageDelete', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> };

export type InstagramMessageFields_InstagramBotMessage_Fragment = { __typename?: 'InstagramBotMessage', messageId: string, messageState: MessageState, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent' } | { __typename?: 'TextLiveCommentContent' } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent' } };

export type InstagramMessageFields_InstagramBotMessageDeleted_Fragment = { __typename?: 'InstagramBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } };

export type InstagramMessageFields_InstagramUserMessage_Fragment = { __typename?: 'InstagramUserMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent', story: { __typename?: 'Story', contentType?: string | null, originalUrl: string } } | { __typename?: 'TextLiveCommentContent', text: string } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent', previewUrl: string, originalUrl: string } };

export type InstagramMessageFields_InstagramUserMessageDeleted_Fragment = { __typename?: 'InstagramUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> };

export type InstagramMessageFieldsFragment = InstagramMessageFields_InstagramBotAutoReplyMessage_Fragment | InstagramMessageFields_InstagramBotAutoReplyMessageDelete_Fragment | InstagramMessageFields_InstagramBotMessage_Fragment | InstagramMessageFields_InstagramBotMessageDeleted_Fragment | InstagramMessageFields_InstagramUserMessage_Fragment | InstagramMessageFields_InstagramUserMessageDeleted_Fragment;

export type InstagramMessageEventFieldsFragment = { __typename?: 'InstagramMessageEvent', id: string, timestamp: number, message: { __typename?: 'InstagramBotAutoReplyMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, autoReplyInfo: { __typename?: 'LiveCommentAutoReplyInfo', id: string, name: string, trigger: { __typename: 'AnyContent' } | { __typename?: 'ContainsKeyword', value: string } } } | { __typename?: 'InstagramBotAutoReplyMessageDelete', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> } | { __typename?: 'InstagramBotMessage', messageId: string, messageState: MessageState, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent' } | { __typename?: 'TextLiveCommentContent' } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent' } } | { __typename?: 'InstagramBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'InstagramUserMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent', story: { __typename?: 'Story', contentType?: string | null, originalUrl: string } } | { __typename?: 'TextLiveCommentContent', text: string } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent', previewUrl: string, originalUrl: string } } | { __typename?: 'InstagramUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> } };

export type InstagramChatEventFields_CommonChatEvent_Fragment = { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } };

export type InstagramChatEventFields_InstagramMessageEvent_Fragment = { __typename?: 'InstagramMessageEvent', id: string, timestamp: number, message: { __typename?: 'InstagramBotAutoReplyMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, autoReplyInfo: { __typename?: 'LiveCommentAutoReplyInfo', id: string, name: string, trigger: { __typename: 'AnyContent' } | { __typename?: 'ContainsKeyword', value: string } } } | { __typename?: 'InstagramBotAutoReplyMessageDelete', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> } | { __typename?: 'InstagramBotMessage', messageId: string, messageState: MessageState, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent' } | { __typename?: 'TextLiveCommentContent' } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent' } } | { __typename?: 'InstagramBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'InstagramUserMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent', story: { __typename?: 'Story', contentType?: string | null, originalUrl: string } } | { __typename?: 'TextLiveCommentContent', text: string } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent', previewUrl: string, originalUrl: string } } | { __typename?: 'InstagramUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> } };

export type InstagramChatEventFieldsFragment = InstagramChatEventFields_CommonChatEvent_Fragment | InstagramChatEventFields_InstagramMessageEvent_Fragment;

export type InstagramChatTextMessageSendMutationVariables = Exact<{
  input: InstagramSendTextMessageRequest;
}>;


export type InstagramChatTextMessageSendMutation = { InstagramChatTextMessageSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'InstagramMessageEvent', id: string, timestamp: number, message: { __typename?: 'InstagramBotAutoReplyMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, autoReplyInfo: { __typename?: 'LiveCommentAutoReplyInfo', id: string, name: string, trigger: { __typename: 'AnyContent' } | { __typename?: 'ContainsKeyword', value: string } } } | { __typename?: 'InstagramBotAutoReplyMessageDelete', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> } | { __typename?: 'InstagramBotMessage', messageId: string, messageState: MessageState, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent' } | { __typename?: 'TextLiveCommentContent' } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent' } } | { __typename?: 'InstagramBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'InstagramUserMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent', story: { __typename?: 'Story', contentType?: string | null, originalUrl: string } } | { __typename?: 'TextLiveCommentContent', text: string } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent', previewUrl: string, originalUrl: string } } | { __typename?: 'InstagramUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> } } | null };

export type InstagramChatImageMessageSendMutationVariables = Exact<{
  input: InstagramSendImageMessageRequest;
}>;


export type InstagramChatImageMessageSendMutation = { InstagramChatImageMessageSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'InstagramMessageEvent', id: string, timestamp: number, message: { __typename?: 'InstagramBotAutoReplyMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, autoReplyInfo: { __typename?: 'LiveCommentAutoReplyInfo', id: string, name: string, trigger: { __typename: 'AnyContent' } | { __typename?: 'ContainsKeyword', value: string } } } | { __typename?: 'InstagramBotAutoReplyMessageDelete', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> } | { __typename?: 'InstagramBotMessage', messageId: string, messageState: MessageState, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent' } | { __typename?: 'TextLiveCommentContent' } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent' } } | { __typename?: 'InstagramBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'InstagramUserMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent', story: { __typename?: 'Story', contentType?: string | null, originalUrl: string } } | { __typename?: 'TextLiveCommentContent', text: string } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent', previewUrl: string, originalUrl: string } } | { __typename?: 'InstagramUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> } } | null };

export type InstagramMessageResendMutationVariables = Exact<{
  messageId: Scalars['String']['input'];
}>;


export type InstagramMessageResendMutation = { InstagramMessageResend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'InstagramMessageEvent', id: string, timestamp: number, message: { __typename?: 'InstagramBotAutoReplyMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, autoReplyInfo: { __typename?: 'LiveCommentAutoReplyInfo', id: string, name: string, trigger: { __typename: 'AnyContent' } | { __typename?: 'ContainsKeyword', value: string } } } | { __typename?: 'InstagramBotAutoReplyMessageDelete', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> } | { __typename?: 'InstagramBotMessage', messageId: string, messageState: MessageState, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent' } | { __typename?: 'TextLiveCommentContent' } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent' } } | { __typename?: 'InstagramBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'InstagramUserMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent', story: { __typename?: 'Story', contentType?: string | null, originalUrl: string } } | { __typename?: 'TextLiveCommentContent', text: string } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent', previewUrl: string, originalUrl: string } } | { __typename?: 'InstagramUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> } } | null };

export type InstagramChatEventsQueryVariables = Exact<{
  chatId: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
  messageId?: InputMaybe<Scalars['String']['input']>;
  olderCursor?: InputMaybe<Scalars['String']['input']>;
  newerCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type InstagramChatEventsQuery = { InstagramChatEventsV2?: { __typename?: 'InstagramChatEvents', chatId: string, newerCursor?: string | null, olderCursor?: string | null, userName: string, chatEvents: Array<{ __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'InstagramMessageEvent', id: string, timestamp: number, message: { __typename?: 'InstagramBotAutoReplyMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, autoReplyInfo: { __typename?: 'LiveCommentAutoReplyInfo', id: string, name: string, trigger: { __typename: 'AnyContent' } | { __typename?: 'ContainsKeyword', value: string } } } | { __typename?: 'InstagramBotAutoReplyMessageDelete', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> } | { __typename?: 'InstagramBotMessage', messageId: string, messageState: MessageState, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent' } | { __typename?: 'TextLiveCommentContent' } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent' } } | { __typename?: 'InstagramBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'InstagramUserMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent', story: { __typename?: 'Story', contentType?: string | null, originalUrl: string } } | { __typename?: 'TextLiveCommentContent', text: string } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent', previewUrl: string, originalUrl: string } } | { __typename?: 'InstagramUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> } }> } | null };

export type LazadaOrderMessageFieldsFragment = { __typename?: 'LazadaOrderMessageContent', id: string, title: string, iconUrl: string, anyxOrderId?: string | null };

export type LazadaItemMessageFieldsFragment = { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null };

export type LazadaTextMessageFieldsFragment = { __typename?: 'LazadaTextMessageContent', text: string };

export type LazadaImageMessageFieldsFragment = { __typename?: 'LazadaImageMessageContent', url: string };

export type LazadaVideoMessageFieldsFragment = { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null };

export type LazadaFaqMessageFieldsFragment = { __typename?: 'LazadaFAQMessageContent', text: string, questions: Array<string> };

export type LazadaEmojiMessageFieldsFragment = { __typename?: 'LazadaEmojiMessageContent', iconUrl: string, text: string };

export type LazadaUserMessageFieldsFragment = { __typename?: 'LazadaUserMessage', messageId: string, content: { __typename?: 'LazadaEmojiMessageContent', iconUrl: string, text: string } | { __typename?: 'LazadaFAQMessageContent' } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent', id: string, title: string, iconUrl: string, anyxOrderId?: string | null } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent' } };

export type LazadaVoucherMessageFieldsFragment = { __typename?: 'LazadaVoucherMessageContent', name: string, type: LazadaVoucherType, status: LazadaVoucherStatus, startDate: string, endDate: string, minSpend: string, currency: string, voucherMessageId: string, discount: { __typename?: 'LazadaVoucherMoneyValueOff', amount: string } | { __typename?: 'LazadaVoucherPercentageDiscountOff', percentage: string, maxValue: string } };

export type LazadaMessageAuthorFields_BasicUser_Fragment = { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string };

export type LazadaMessageAuthorFields_LazadaFaqBot_Fragment = { __typename: 'LazadaFAQBot' };

export type LazadaMessageAuthorFields_RepliedFromLazada_Fragment = { __typename: 'RepliedFromLazada' };

export type LazadaMessageAuthorFieldsFragment = LazadaMessageAuthorFields_BasicUser_Fragment | LazadaMessageAuthorFields_LazadaFaqBot_Fragment | LazadaMessageAuthorFields_RepliedFromLazada_Fragment;

export type LazadaStoreCsMessageFieldsFragment = { __typename?: 'LazadaStoreCSMessage', messageId: string, settingPageUrl?: string | null, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } | { __typename: 'LazadaFAQBot' } | { __typename: 'RepliedFromLazada' }, content: { __typename?: 'LazadaEmojiMessageContent' } | { __typename?: 'LazadaFAQMessageContent', text: string, questions: Array<string> } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent' } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent', name: string, type: LazadaVoucherType, status: LazadaVoucherStatus, startDate: string, endDate: string, minSpend: string, currency: string, voucherMessageId: string, discount: { __typename?: 'LazadaVoucherMoneyValueOff', amount: string } | { __typename?: 'LazadaVoucherPercentageDiscountOff', percentage: string, maxValue: string } } };

export type LazadaMessageFields_LazadaStoreCsMessage_Fragment = { __typename?: 'LazadaStoreCSMessage', messageId: string, settingPageUrl?: string | null, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } | { __typename: 'LazadaFAQBot' } | { __typename: 'RepliedFromLazada' }, content: { __typename?: 'LazadaEmojiMessageContent' } | { __typename?: 'LazadaFAQMessageContent', text: string, questions: Array<string> } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent' } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent', name: string, type: LazadaVoucherType, status: LazadaVoucherStatus, startDate: string, endDate: string, minSpend: string, currency: string, voucherMessageId: string, discount: { __typename?: 'LazadaVoucherMoneyValueOff', amount: string } | { __typename?: 'LazadaVoucherPercentageDiscountOff', percentage: string, maxValue: string } } };

export type LazadaMessageFields_LazadaUserMessage_Fragment = { __typename?: 'LazadaUserMessage', messageId: string, content: { __typename?: 'LazadaEmojiMessageContent', iconUrl: string, text: string } | { __typename?: 'LazadaFAQMessageContent' } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent', id: string, title: string, iconUrl: string, anyxOrderId?: string | null } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent' } };

export type LazadaMessageFieldsFragment = LazadaMessageFields_LazadaStoreCsMessage_Fragment | LazadaMessageFields_LazadaUserMessage_Fragment;

export type LazadaMessageEventFieldsFragment = { __typename?: 'LazadaMessageEvent', id: string, timestamp: number, message: { __typename?: 'LazadaStoreCSMessage', messageId: string, settingPageUrl?: string | null, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } | { __typename: 'LazadaFAQBot' } | { __typename: 'RepliedFromLazada' }, content: { __typename?: 'LazadaEmojiMessageContent' } | { __typename?: 'LazadaFAQMessageContent', text: string, questions: Array<string> } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent' } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent', name: string, type: LazadaVoucherType, status: LazadaVoucherStatus, startDate: string, endDate: string, minSpend: string, currency: string, voucherMessageId: string, discount: { __typename?: 'LazadaVoucherMoneyValueOff', amount: string } | { __typename?: 'LazadaVoucherPercentageDiscountOff', percentage: string, maxValue: string } } } | { __typename?: 'LazadaUserMessage', messageId: string, content: { __typename?: 'LazadaEmojiMessageContent', iconUrl: string, text: string } | { __typename?: 'LazadaFAQMessageContent' } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent', id: string, title: string, iconUrl: string, anyxOrderId?: string | null } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent' } } };

export type LazadaChatEventFields_CommonChatEvent_Fragment = { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } };

export type LazadaChatEventFields_LazadaMessageEvent_Fragment = { __typename?: 'LazadaMessageEvent', id: string, timestamp: number, message: { __typename?: 'LazadaStoreCSMessage', messageId: string, settingPageUrl?: string | null, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } | { __typename: 'LazadaFAQBot' } | { __typename: 'RepliedFromLazada' }, content: { __typename?: 'LazadaEmojiMessageContent' } | { __typename?: 'LazadaFAQMessageContent', text: string, questions: Array<string> } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent' } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent', name: string, type: LazadaVoucherType, status: LazadaVoucherStatus, startDate: string, endDate: string, minSpend: string, currency: string, voucherMessageId: string, discount: { __typename?: 'LazadaVoucherMoneyValueOff', amount: string } | { __typename?: 'LazadaVoucherPercentageDiscountOff', percentage: string, maxValue: string } } } | { __typename?: 'LazadaUserMessage', messageId: string, content: { __typename?: 'LazadaEmojiMessageContent', iconUrl: string, text: string } | { __typename?: 'LazadaFAQMessageContent' } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent', id: string, title: string, iconUrl: string, anyxOrderId?: string | null } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent' } } };

export type LazadaChatEventFieldsFragment = LazadaChatEventFields_CommonChatEvent_Fragment | LazadaChatEventFields_LazadaMessageEvent_Fragment;

export type LazadaChatTextMessageSendMutationVariables = Exact<{
  input: LazadaSendTextMessageRequestInput;
}>;


export type LazadaChatTextMessageSendMutation = { LazadaChatTextMessageSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'LazadaMessageEvent', id: string, timestamp: number, message: { __typename?: 'LazadaStoreCSMessage', messageId: string, settingPageUrl?: string | null, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } | { __typename: 'LazadaFAQBot' } | { __typename: 'RepliedFromLazada' }, content: { __typename?: 'LazadaEmojiMessageContent' } | { __typename?: 'LazadaFAQMessageContent', text: string, questions: Array<string> } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent' } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent', name: string, type: LazadaVoucherType, status: LazadaVoucherStatus, startDate: string, endDate: string, minSpend: string, currency: string, voucherMessageId: string, discount: { __typename?: 'LazadaVoucherMoneyValueOff', amount: string } | { __typename?: 'LazadaVoucherPercentageDiscountOff', percentage: string, maxValue: string } } } | { __typename?: 'LazadaUserMessage', messageId: string, content: { __typename?: 'LazadaEmojiMessageContent', iconUrl: string, text: string } | { __typename?: 'LazadaFAQMessageContent' } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent', id: string, title: string, iconUrl: string, anyxOrderId?: string | null } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent' } } } | null };

export type LazadaChatImageMessageSendMutationVariables = Exact<{
  input: LazadaSendImageMessageRequestInput;
}>;


export type LazadaChatImageMessageSendMutation = { LazadaChatImageMessageSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'LazadaMessageEvent', id: string, timestamp: number, message: { __typename?: 'LazadaStoreCSMessage', messageId: string, settingPageUrl?: string | null, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } | { __typename: 'LazadaFAQBot' } | { __typename: 'RepliedFromLazada' }, content: { __typename?: 'LazadaEmojiMessageContent' } | { __typename?: 'LazadaFAQMessageContent', text: string, questions: Array<string> } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent' } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent', name: string, type: LazadaVoucherType, status: LazadaVoucherStatus, startDate: string, endDate: string, minSpend: string, currency: string, voucherMessageId: string, discount: { __typename?: 'LazadaVoucherMoneyValueOff', amount: string } | { __typename?: 'LazadaVoucherPercentageDiscountOff', percentage: string, maxValue: string } } } | { __typename?: 'LazadaUserMessage', messageId: string, content: { __typename?: 'LazadaEmojiMessageContent', iconUrl: string, text: string } | { __typename?: 'LazadaFAQMessageContent' } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent', id: string, title: string, iconUrl: string, anyxOrderId?: string | null } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent' } } } | null };

export type LazadaChatVoucherMessageSendMutationVariables = Exact<{
  input: LazadaSendVoucherMessageRequestInput;
}>;


export type LazadaChatVoucherMessageSendMutation = { LazadaChatVoucherMessageSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'LazadaMessageEvent', id: string, timestamp: number, message: { __typename?: 'LazadaStoreCSMessage', messageId: string, settingPageUrl?: string | null, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } | { __typename: 'LazadaFAQBot' } | { __typename: 'RepliedFromLazada' }, content: { __typename?: 'LazadaEmojiMessageContent' } | { __typename?: 'LazadaFAQMessageContent', text: string, questions: Array<string> } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent' } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent', name: string, type: LazadaVoucherType, status: LazadaVoucherStatus, startDate: string, endDate: string, minSpend: string, currency: string, voucherMessageId: string, discount: { __typename?: 'LazadaVoucherMoneyValueOff', amount: string } | { __typename?: 'LazadaVoucherPercentageDiscountOff', percentage: string, maxValue: string } } } | { __typename?: 'LazadaUserMessage', messageId: string, content: { __typename?: 'LazadaEmojiMessageContent', iconUrl: string, text: string } | { __typename?: 'LazadaFAQMessageContent' } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent', id: string, title: string, iconUrl: string, anyxOrderId?: string | null } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent' } } } | null };

export type LazadaChatProductMessageSendMutationVariables = Exact<{
  input: LazadaSendProductMessageRequestInput;
}>;


export type LazadaChatProductMessageSendMutation = { LazadaChatProductMessageSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'LazadaMessageEvent', id: string, timestamp: number, message: { __typename?: 'LazadaStoreCSMessage', messageId: string, settingPageUrl?: string | null, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } | { __typename: 'LazadaFAQBot' } | { __typename: 'RepliedFromLazada' }, content: { __typename?: 'LazadaEmojiMessageContent' } | { __typename?: 'LazadaFAQMessageContent', text: string, questions: Array<string> } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent' } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent', name: string, type: LazadaVoucherType, status: LazadaVoucherStatus, startDate: string, endDate: string, minSpend: string, currency: string, voucherMessageId: string, discount: { __typename?: 'LazadaVoucherMoneyValueOff', amount: string } | { __typename?: 'LazadaVoucherPercentageDiscountOff', percentage: string, maxValue: string } } } | { __typename?: 'LazadaUserMessage', messageId: string, content: { __typename?: 'LazadaEmojiMessageContent', iconUrl: string, text: string } | { __typename?: 'LazadaFAQMessageContent' } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent', id: string, title: string, iconUrl: string, anyxOrderId?: string | null } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent' } } } | null };

export type LazadaChatVideoMessageSendMutationVariables = Exact<{
  input: LazadaSendVideoMessageRequestInput;
}>;


export type LazadaChatVideoMessageSendMutation = { LazadaChatVideoMessageSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'LazadaMessageEvent', id: string, timestamp: number, message: { __typename?: 'LazadaStoreCSMessage', messageId: string, settingPageUrl?: string | null, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } | { __typename: 'LazadaFAQBot' } | { __typename: 'RepliedFromLazada' }, content: { __typename?: 'LazadaEmojiMessageContent' } | { __typename?: 'LazadaFAQMessageContent', text: string, questions: Array<string> } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent' } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent', name: string, type: LazadaVoucherType, status: LazadaVoucherStatus, startDate: string, endDate: string, minSpend: string, currency: string, voucherMessageId: string, discount: { __typename?: 'LazadaVoucherMoneyValueOff', amount: string } | { __typename?: 'LazadaVoucherPercentageDiscountOff', percentage: string, maxValue: string } } } | { __typename?: 'LazadaUserMessage', messageId: string, content: { __typename?: 'LazadaEmojiMessageContent', iconUrl: string, text: string } | { __typename?: 'LazadaFAQMessageContent' } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent', id: string, title: string, iconUrl: string, anyxOrderId?: string | null } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent' } } } | null };

export type LazadaMessageResendMutationVariables = Exact<{
  messageId: Scalars['String']['input'];
}>;


export type LazadaMessageResendMutation = { LazadaMessageResend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'LazadaMessageEvent', id: string, timestamp: number, message: { __typename?: 'LazadaStoreCSMessage', messageId: string, settingPageUrl?: string | null, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } | { __typename: 'LazadaFAQBot' } | { __typename: 'RepliedFromLazada' }, content: { __typename?: 'LazadaEmojiMessageContent' } | { __typename?: 'LazadaFAQMessageContent', text: string, questions: Array<string> } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent' } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent', name: string, type: LazadaVoucherType, status: LazadaVoucherStatus, startDate: string, endDate: string, minSpend: string, currency: string, voucherMessageId: string, discount: { __typename?: 'LazadaVoucherMoneyValueOff', amount: string } | { __typename?: 'LazadaVoucherPercentageDiscountOff', percentage: string, maxValue: string } } } | { __typename?: 'LazadaUserMessage', messageId: string, content: { __typename?: 'LazadaEmojiMessageContent', iconUrl: string, text: string } | { __typename?: 'LazadaFAQMessageContent' } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent', id: string, title: string, iconUrl: string, anyxOrderId?: string | null } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent' } } } | null };

export type LazadaChatEventsQueryVariables = Exact<{
  chatId: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
  messageId?: InputMaybe<Scalars['String']['input']>;
  olderCursor?: InputMaybe<Scalars['String']['input']>;
  newerCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type LazadaChatEventsQuery = { LazadaChatEventsV2?: { __typename?: 'LazadaChatEvents', chatId: string, userName: string, newerCursor?: string | null, olderCursor?: string | null, chatEvents: Array<{ __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'LazadaMessageEvent', id: string, timestamp: number, message: { __typename?: 'LazadaStoreCSMessage', messageId: string, settingPageUrl?: string | null, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } | { __typename: 'LazadaFAQBot' } | { __typename: 'RepliedFromLazada' }, content: { __typename?: 'LazadaEmojiMessageContent' } | { __typename?: 'LazadaFAQMessageContent', text: string, questions: Array<string> } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent' } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent', name: string, type: LazadaVoucherType, status: LazadaVoucherStatus, startDate: string, endDate: string, minSpend: string, currency: string, voucherMessageId: string, discount: { __typename?: 'LazadaVoucherMoneyValueOff', amount: string } | { __typename?: 'LazadaVoucherPercentageDiscountOff', percentage: string, maxValue: string } } } | { __typename?: 'LazadaUserMessage', messageId: string, content: { __typename?: 'LazadaEmojiMessageContent', iconUrl: string, text: string } | { __typename?: 'LazadaFAQMessageContent' } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent', id: string, title: string, iconUrl: string, anyxOrderId?: string | null } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent' } } }> } | null };

export type QuotedLineChatPreviewEventFragment = { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } };

export type LineBotTextBubbleEventFragment = { __typename?: 'LineBotTextMessageEvent', text: string, messageState: MessageState, canQuoteReply: boolean, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null };

export type LineBotImageMessageBubbleEventFragment = { __typename?: 'LineBotImageMessageEvent', previewUrl: string, originalUrl: string, canQuoteReply: boolean, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } };

export type LineBotGreetingMessageBubbleEventFragment = { __typename?: 'LineBotGreetingMessageEvent', templateId: string };

export type LineBotUnitMessageBubbleEventFragment = { __typename?: 'LineBotUnitMessageEvent', messagesV2: Array<{ __typename?: 'LineMessageWithQuote', canQuoteReply: boolean, message: { __typename?: 'ButtonMessage', cards: Array<{ __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename?: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null }> } | { __typename?: 'FileMessage', fileUrl: string, card: { __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null } } | { __typename?: 'ImageMessage', images: Array<{ __typename?: 'ImageItem', imageUrl: string, label?: string | null, urlAction: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } }> } | { __typename?: 'PlainTextMessage', text: string, richText?: string | null, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'RichMessage', imageUrl: string, urlAction?: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } | null } | { __typename?: 'SingleImageMessage', originalUrl: string, previewUrl: string } | { __typename?: 'VideoMessage', originalUrl: string, previewUrl: string } }>, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } };

export type LineUserTextBubbleEventFragment = { __typename?: 'LineUserTextMessageEvent', text: string, canQuoteReply: boolean, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null };

export type LineUserUnsentBubbleEventFragment = { __typename: 'LineUserUnsentMessageEvent' };

export type LineUserPostBackBubbleEventFragment = { __typename?: 'LineUserPostbackEvent', displayText: string };

export type LineInquiryBubbleEventFragment = { __typename?: 'LineInquiryEvent', inquiry: string };

export type LineInquiryFinishBubbleEventFragment = { __typename?: 'LineInquiryFinishEvent', author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } };

export type LineMessageTemplateBubbleEventFragment = { __typename?: 'LineMessageTemplateEvent', templateId: string, templateName: string };

export type LineUserImageBubbleEventFragment = { __typename?: 'LineUserImageMessageEvent', imageUrl: string, canQuoteReply: boolean, mediaState: LineMediaState };

export type LineUserVideoBubbleEventFragment = { __typename?: 'LineUserVideoMessageEvent', contentUrl: string, duration: number, canQuoteReply: boolean, mediaState: LineMediaState };

export type LineUserStickerBubbleEventFragment = { __typename?: 'LineUserStickerMessageEvent', canQuoteReply: boolean, stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', stickerType: string, url: string } | { __typename?: 'StaticSticker', url: string }, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null };

export type LineUserFileBubbleEventFragment = { __typename?: 'LineUserFileMessageEvent', contentUrl: string, fileName: string, fileSize?: string | null, format: string, mediaState: LineMediaState };

export type LineInfluencerJoinedCampaignBubbleEventFragment = { __typename?: 'LineInfluencerJoinedCampaignEvent', campaignName: string };

export type LineUserFollowedBubbleEventFragment = { __typename?: 'LineUserFollowedEvent', username: string };

export type LineUserUnFollowedBubbleEventFragment = { __typename?: 'LineUserUnFollowedEvent', username: string };

export type LineSystemFoundFollowerBubbleEventFragment = { __typename?: 'LineSystemFoundFollowerEvent', username: string };

export type LinePlatformBubbleEventFragment = { __typename?: 'LinePlatformEvent', id: string, timestamp: number, message: { __typename?: 'LineBotGreetingMessageEvent', templateId: string } | { __typename?: 'LineBotImageMessageEvent', previewUrl: string, originalUrl: string, canQuoteReply: boolean, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineBotTextMessageEvent', text: string, messageState: MessageState, canQuoteReply: boolean, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineBotUnitMessageEvent', messagesV2: Array<{ __typename?: 'LineMessageWithQuote', canQuoteReply: boolean, message: { __typename?: 'ButtonMessage', cards: Array<{ __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename?: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null }> } | { __typename?: 'FileMessage', fileUrl: string, card: { __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null } } | { __typename?: 'ImageMessage', images: Array<{ __typename?: 'ImageItem', imageUrl: string, label?: string | null, urlAction: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } }> } | { __typename?: 'PlainTextMessage', text: string, richText?: string | null, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'RichMessage', imageUrl: string, urlAction?: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } | null } | { __typename?: 'SingleImageMessage', originalUrl: string, previewUrl: string } | { __typename?: 'VideoMessage', originalUrl: string, previewUrl: string } }>, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineInfluencerJoinedCampaignEvent', campaignName: string } | { __typename?: 'LineInquiryEvent', inquiry: string } | { __typename?: 'LineInquiryFinishEvent', author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineMessageTemplateEvent', templateId: string, templateName: string } | { __typename?: 'LineStateUpdateEvent' } | { __typename?: 'LineSystemFoundFollowerEvent', username: string } | { __typename?: 'LineUserAudioMessageEvent' } | { __typename?: 'LineUserFileMessageEvent', contentUrl: string, fileName: string, fileSize?: string | null, format: string, mediaState: LineMediaState } | { __typename?: 'LineUserFollowedEvent', username: string } | { __typename?: 'LineUserImageMessageEvent', imageUrl: string, canQuoteReply: boolean, mediaState: LineMediaState } | { __typename?: 'LineUserLocationMessageEvent' } | { __typename?: 'LineUserPostbackEvent', displayText: string } | { __typename?: 'LineUserStickerMessageEvent', canQuoteReply: boolean, stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', stickerType: string, url: string } | { __typename?: 'StaticSticker', url: string }, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineUserTextMessageEvent', text: string, canQuoteReply: boolean, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineUserUnFollowedEvent', username: string } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename?: 'LineUserVideoMessageEvent', contentUrl: string, duration: number, canQuoteReply: boolean, mediaState: LineMediaState } };

export type LineChatBubbleEvent_CommonChatEvent_Fragment = { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } };

export type LineChatBubbleEvent_LinePlatformEvent_Fragment = { __typename?: 'LinePlatformEvent', id: string, timestamp: number, message: { __typename?: 'LineBotGreetingMessageEvent', templateId: string } | { __typename?: 'LineBotImageMessageEvent', previewUrl: string, originalUrl: string, canQuoteReply: boolean, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineBotTextMessageEvent', text: string, messageState: MessageState, canQuoteReply: boolean, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineBotUnitMessageEvent', messagesV2: Array<{ __typename?: 'LineMessageWithQuote', canQuoteReply: boolean, message: { __typename?: 'ButtonMessage', cards: Array<{ __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename?: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null }> } | { __typename?: 'FileMessage', fileUrl: string, card: { __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null } } | { __typename?: 'ImageMessage', images: Array<{ __typename?: 'ImageItem', imageUrl: string, label?: string | null, urlAction: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } }> } | { __typename?: 'PlainTextMessage', text: string, richText?: string | null, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'RichMessage', imageUrl: string, urlAction?: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } | null } | { __typename?: 'SingleImageMessage', originalUrl: string, previewUrl: string } | { __typename?: 'VideoMessage', originalUrl: string, previewUrl: string } }>, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineInfluencerJoinedCampaignEvent', campaignName: string } | { __typename?: 'LineInquiryEvent', inquiry: string } | { __typename?: 'LineInquiryFinishEvent', author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineMessageTemplateEvent', templateId: string, templateName: string } | { __typename?: 'LineStateUpdateEvent' } | { __typename?: 'LineSystemFoundFollowerEvent', username: string } | { __typename?: 'LineUserAudioMessageEvent' } | { __typename?: 'LineUserFileMessageEvent', contentUrl: string, fileName: string, fileSize?: string | null, format: string, mediaState: LineMediaState } | { __typename?: 'LineUserFollowedEvent', username: string } | { __typename?: 'LineUserImageMessageEvent', imageUrl: string, canQuoteReply: boolean, mediaState: LineMediaState } | { __typename?: 'LineUserLocationMessageEvent' } | { __typename?: 'LineUserPostbackEvent', displayText: string } | { __typename?: 'LineUserStickerMessageEvent', canQuoteReply: boolean, stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', stickerType: string, url: string } | { __typename?: 'StaticSticker', url: string }, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineUserTextMessageEvent', text: string, canQuoteReply: boolean, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineUserUnFollowedEvent', username: string } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename?: 'LineUserVideoMessageEvent', contentUrl: string, duration: number, canQuoteReply: boolean, mediaState: LineMediaState } };

export type LineChatBubbleEventFragment = LineChatBubbleEvent_CommonChatEvent_Fragment | LineChatBubbleEvent_LinePlatformEvent_Fragment;

export type ReadLineUsedQuotaFragment = { __typename?: 'LineStoreChat', id: string, messageQuota: { __typename?: 'LineMessageQuotaInfo', consumption: number } };

export type LineChatMessageSendMutationVariables = Exact<{
  input: LineChatMessageRequest;
}>;


export type LineChatMessageSendMutation = { LineChatMessageSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'LinePlatformEvent', id: string, timestamp: number, message: { __typename?: 'LineBotGreetingMessageEvent', templateId: string } | { __typename?: 'LineBotImageMessageEvent', previewUrl: string, originalUrl: string, canQuoteReply: boolean, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineBotTextMessageEvent', text: string, messageState: MessageState, canQuoteReply: boolean, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineBotUnitMessageEvent', messagesV2: Array<{ __typename?: 'LineMessageWithQuote', canQuoteReply: boolean, message: { __typename?: 'ButtonMessage', cards: Array<{ __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename?: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null }> } | { __typename?: 'FileMessage', fileUrl: string, card: { __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null } } | { __typename?: 'ImageMessage', images: Array<{ __typename?: 'ImageItem', imageUrl: string, label?: string | null, urlAction: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } }> } | { __typename?: 'PlainTextMessage', text: string, richText?: string | null, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'RichMessage', imageUrl: string, urlAction?: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } | null } | { __typename?: 'SingleImageMessage', originalUrl: string, previewUrl: string } | { __typename?: 'VideoMessage', originalUrl: string, previewUrl: string } }>, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineInfluencerJoinedCampaignEvent', campaignName: string } | { __typename?: 'LineInquiryEvent', inquiry: string } | { __typename?: 'LineInquiryFinishEvent', author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineMessageTemplateEvent', templateId: string, templateName: string } | { __typename?: 'LineStateUpdateEvent' } | { __typename?: 'LineSystemFoundFollowerEvent', username: string } | { __typename?: 'LineUserAudioMessageEvent' } | { __typename?: 'LineUserFileMessageEvent', contentUrl: string, fileName: string, fileSize?: string | null, format: string, mediaState: LineMediaState } | { __typename?: 'LineUserFollowedEvent', username: string } | { __typename?: 'LineUserImageMessageEvent', imageUrl: string, canQuoteReply: boolean, mediaState: LineMediaState } | { __typename?: 'LineUserLocationMessageEvent' } | { __typename?: 'LineUserPostbackEvent', displayText: string } | { __typename?: 'LineUserStickerMessageEvent', canQuoteReply: boolean, stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', stickerType: string, url: string } | { __typename?: 'StaticSticker', url: string }, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineUserTextMessageEvent', text: string, canQuoteReply: boolean, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineUserUnFollowedEvent', username: string } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename?: 'LineUserVideoMessageEvent', contentUrl: string, duration: number, canQuoteReply: boolean, mediaState: LineMediaState } } | null };

export type LineScheduledMessageCreateMutationVariables = Exact<{
  input: LineScheduledMessageCreateInput;
}>;


export type LineScheduledMessageCreateMutation = { LineScheduledMessageCreate?: { __typename?: 'LineScheduledMessage', id: string, scheduledAt: string, status: LineScheduledMessageStatus, createdAt: string, updatedAt: string, messages: Array<{ __typename?: 'ButtonMessage', cards: Array<{ __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename?: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null }> } | { __typename?: 'FileMessage', fileUrl: string, card: { __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null } } | { __typename?: 'ImageMessage', images: Array<{ __typename?: 'ImageItem', imageUrl: string, label?: string | null, urlAction: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } }> } | { __typename?: 'PlainTextMessage', text: string, richText?: string | null, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'RichMessage', imageUrl: string, urlAction?: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } | null } | { __typename?: 'SingleImageMessage', originalUrl: string, previewUrl: string } | { __typename?: 'VideoMessage', originalUrl: string, previewUrl: string }> } | null };

export type LineScheduledMessageUpdateMutationVariables = Exact<{
  input: LineScheduledMessageUpdateInput;
}>;


export type LineScheduledMessageUpdateMutation = { LineScheduledMessageUpdate?: { __typename?: 'LineScheduledMessage', id: string, scheduledAt: string, status: LineScheduledMessageStatus, createdAt: string, updatedAt: string, messages: Array<{ __typename?: 'ButtonMessage', cards: Array<{ __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename?: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null }> } | { __typename?: 'FileMessage', fileUrl: string, card: { __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null } } | { __typename?: 'ImageMessage', images: Array<{ __typename?: 'ImageItem', imageUrl: string, label?: string | null, urlAction: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } }> } | { __typename?: 'PlainTextMessage', text: string, richText?: string | null, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'RichMessage', imageUrl: string, urlAction?: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } | null } | { __typename?: 'SingleImageMessage', originalUrl: string, previewUrl: string } | { __typename?: 'VideoMessage', originalUrl: string, previewUrl: string }> } | null };

export type LineScheduledMessageDeleteMutationVariables = Exact<{
  input: LineScheduledMessageDeleteInput;
}>;


export type LineScheduledMessageDeleteMutation = { LineScheduledMessageDelete?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type LineScheduledMessageImmediateSendMutationVariables = Exact<{
  input: LineScheduledMessageImmediateSendInput;
}>;


export type LineScheduledMessageImmediateSendMutation = { LineScheduledMessageImmediateSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'LinePlatformEvent', id: string, timestamp: number, message: { __typename?: 'LineBotGreetingMessageEvent', templateId: string } | { __typename?: 'LineBotImageMessageEvent', previewUrl: string, originalUrl: string, canQuoteReply: boolean, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineBotTextMessageEvent', text: string, messageState: MessageState, canQuoteReply: boolean, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineBotUnitMessageEvent', messagesV2: Array<{ __typename?: 'LineMessageWithQuote', canQuoteReply: boolean, message: { __typename?: 'ButtonMessage', cards: Array<{ __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename?: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null }> } | { __typename?: 'FileMessage', fileUrl: string, card: { __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null } } | { __typename?: 'ImageMessage', images: Array<{ __typename?: 'ImageItem', imageUrl: string, label?: string | null, urlAction: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } }> } | { __typename?: 'PlainTextMessage', text: string, richText?: string | null, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'RichMessage', imageUrl: string, urlAction?: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } | null } | { __typename?: 'SingleImageMessage', originalUrl: string, previewUrl: string } | { __typename?: 'VideoMessage', originalUrl: string, previewUrl: string } }>, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineInfluencerJoinedCampaignEvent', campaignName: string } | { __typename?: 'LineInquiryEvent', inquiry: string } | { __typename?: 'LineInquiryFinishEvent', author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineMessageTemplateEvent', templateId: string, templateName: string } | { __typename?: 'LineStateUpdateEvent' } | { __typename?: 'LineSystemFoundFollowerEvent', username: string } | { __typename?: 'LineUserAudioMessageEvent' } | { __typename?: 'LineUserFileMessageEvent', contentUrl: string, fileName: string, fileSize?: string | null, format: string, mediaState: LineMediaState } | { __typename?: 'LineUserFollowedEvent', username: string } | { __typename?: 'LineUserImageMessageEvent', imageUrl: string, canQuoteReply: boolean, mediaState: LineMediaState } | { __typename?: 'LineUserLocationMessageEvent' } | { __typename?: 'LineUserPostbackEvent', displayText: string } | { __typename?: 'LineUserStickerMessageEvent', canQuoteReply: boolean, stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', stickerType: string, url: string } | { __typename?: 'StaticSticker', url: string }, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineUserTextMessageEvent', text: string, canQuoteReply: boolean, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineUserUnFollowedEvent', username: string } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename?: 'LineUserVideoMessageEvent', contentUrl: string, duration: number, canQuoteReply: boolean, mediaState: LineMediaState } } | null };

export type LineMessageResendMutationVariables = Exact<{
  messageId: Scalars['String']['input'];
}>;


export type LineMessageResendMutation = { LineMessageResend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'LinePlatformEvent', id: string, timestamp: number, message: { __typename?: 'LineBotGreetingMessageEvent', templateId: string } | { __typename?: 'LineBotImageMessageEvent', previewUrl: string, originalUrl: string, canQuoteReply: boolean, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineBotTextMessageEvent', text: string, messageState: MessageState, canQuoteReply: boolean, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineBotUnitMessageEvent', messagesV2: Array<{ __typename?: 'LineMessageWithQuote', canQuoteReply: boolean, message: { __typename?: 'ButtonMessage', cards: Array<{ __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename?: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null }> } | { __typename?: 'FileMessage', fileUrl: string, card: { __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null } } | { __typename?: 'ImageMessage', images: Array<{ __typename?: 'ImageItem', imageUrl: string, label?: string | null, urlAction: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } }> } | { __typename?: 'PlainTextMessage', text: string, richText?: string | null, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'RichMessage', imageUrl: string, urlAction?: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } | null } | { __typename?: 'SingleImageMessage', originalUrl: string, previewUrl: string } | { __typename?: 'VideoMessage', originalUrl: string, previewUrl: string } }>, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineInfluencerJoinedCampaignEvent', campaignName: string } | { __typename?: 'LineInquiryEvent', inquiry: string } | { __typename?: 'LineInquiryFinishEvent', author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineMessageTemplateEvent', templateId: string, templateName: string } | { __typename?: 'LineStateUpdateEvent' } | { __typename?: 'LineSystemFoundFollowerEvent', username: string } | { __typename?: 'LineUserAudioMessageEvent' } | { __typename?: 'LineUserFileMessageEvent', contentUrl: string, fileName: string, fileSize?: string | null, format: string, mediaState: LineMediaState } | { __typename?: 'LineUserFollowedEvent', username: string } | { __typename?: 'LineUserImageMessageEvent', imageUrl: string, canQuoteReply: boolean, mediaState: LineMediaState } | { __typename?: 'LineUserLocationMessageEvent' } | { __typename?: 'LineUserPostbackEvent', displayText: string } | { __typename?: 'LineUserStickerMessageEvent', canQuoteReply: boolean, stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', stickerType: string, url: string } | { __typename?: 'StaticSticker', url: string }, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineUserTextMessageEvent', text: string, canQuoteReply: boolean, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineUserUnFollowedEvent', username: string } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename?: 'LineUserVideoMessageEvent', contentUrl: string, duration: number, canQuoteReply: boolean, mediaState: LineMediaState } } | null };

export type LineChatEventsQueryVariables = Exact<{
  chatId: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  olderCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type LineChatEventsQuery = { LineChatEvents?: { __typename?: 'LineChatEvents', chatId: string, userName: string, userAvatar?: string | null, lastCheckedAt?: number | null, newerCursor?: string | null, olderCursor?: string | null, chatEvents: Array<{ __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'LinePlatformEvent', id: string, timestamp: number, message: { __typename?: 'LineBotGreetingMessageEvent', templateId: string } | { __typename?: 'LineBotImageMessageEvent', previewUrl: string, originalUrl: string, canQuoteReply: boolean, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineBotTextMessageEvent', text: string, messageState: MessageState, canQuoteReply: boolean, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineBotUnitMessageEvent', messagesV2: Array<{ __typename?: 'LineMessageWithQuote', canQuoteReply: boolean, message: { __typename?: 'ButtonMessage', cards: Array<{ __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename?: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null }> } | { __typename?: 'FileMessage', fileUrl: string, card: { __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null } } | { __typename?: 'ImageMessage', images: Array<{ __typename?: 'ImageItem', imageUrl: string, label?: string | null, urlAction: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } }> } | { __typename?: 'PlainTextMessage', text: string, richText?: string | null, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'RichMessage', imageUrl: string, urlAction?: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } | null } | { __typename?: 'SingleImageMessage', originalUrl: string, previewUrl: string } | { __typename?: 'VideoMessage', originalUrl: string, previewUrl: string } }>, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineInfluencerJoinedCampaignEvent', campaignName: string } | { __typename?: 'LineInquiryEvent', inquiry: string } | { __typename?: 'LineInquiryFinishEvent', author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineMessageTemplateEvent', templateId: string, templateName: string } | { __typename?: 'LineStateUpdateEvent' } | { __typename?: 'LineSystemFoundFollowerEvent', username: string } | { __typename?: 'LineUserAudioMessageEvent' } | { __typename?: 'LineUserFileMessageEvent', contentUrl: string, fileName: string, fileSize?: string | null, format: string, mediaState: LineMediaState } | { __typename?: 'LineUserFollowedEvent', username: string } | { __typename?: 'LineUserImageMessageEvent', imageUrl: string, canQuoteReply: boolean, mediaState: LineMediaState } | { __typename?: 'LineUserLocationMessageEvent' } | { __typename?: 'LineUserPostbackEvent', displayText: string } | { __typename?: 'LineUserStickerMessageEvent', canQuoteReply: boolean, stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', stickerType: string, url: string } | { __typename?: 'StaticSticker', url: string }, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineUserTextMessageEvent', text: string, canQuoteReply: boolean, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineUserUnFollowedEvent', username: string } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename?: 'LineUserVideoMessageEvent', contentUrl: string, duration: number, canQuoteReply: boolean, mediaState: LineMediaState } }> } | null };

export type LineScheduledMessagesQueryVariables = Exact<{
  input: GetLineScheduledMessageInput;
}>;


export type LineScheduledMessagesQuery = { LineScheduledMessages?: Array<{ __typename?: 'LineScheduledMessage', id: string, scheduledAt: string, status: LineScheduledMessageStatus, createdAt: string, updatedAt: string, messages: Array<{ __typename?: 'ButtonMessage', cards: Array<{ __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename?: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null }> } | { __typename?: 'FileMessage', fileUrl: string, card: { __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null } } | { __typename?: 'ImageMessage', images: Array<{ __typename?: 'ImageItem', imageUrl: string, label?: string | null, urlAction: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } }> } | { __typename?: 'PlainTextMessage', text: string, richText?: string | null, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'RichMessage', imageUrl: string, urlAction?: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } | null } | { __typename?: 'SingleImageMessage', originalUrl: string, previewUrl: string } | { __typename?: 'VideoMessage', originalUrl: string, previewUrl: string }> }> | null };

export type SubscribeLineChatsSubscriptionVariables = Exact<{
  input: GetLineChatEventSubRequest;
}>;


export type SubscribeLineChatsSubscription = { LineChatEventSub?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'LinePlatformEvent', id: string, timestamp: number, message: { __typename?: 'LineBotGreetingMessageEvent', templateId: string } | { __typename?: 'LineBotImageMessageEvent', previewUrl: string, originalUrl: string, canQuoteReply: boolean, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineBotTextMessageEvent', text: string, messageState: MessageState, canQuoteReply: boolean, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineBotUnitMessageEvent', messagesV2: Array<{ __typename?: 'LineMessageWithQuote', canQuoteReply: boolean, message: { __typename?: 'ButtonMessage', cards: Array<{ __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename?: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null }> } | { __typename?: 'FileMessage', fileUrl: string, card: { __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null } } | { __typename?: 'ImageMessage', images: Array<{ __typename?: 'ImageItem', imageUrl: string, label?: string | null, urlAction: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } }> } | { __typename?: 'PlainTextMessage', text: string, richText?: string | null, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'RichMessage', imageUrl: string, urlAction?: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } | null } | { __typename?: 'SingleImageMessage', originalUrl: string, previewUrl: string } | { __typename?: 'VideoMessage', originalUrl: string, previewUrl: string } }>, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineInfluencerJoinedCampaignEvent', campaignName: string } | { __typename?: 'LineInquiryEvent', inquiry: string } | { __typename?: 'LineInquiryFinishEvent', author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'LineMessageTemplateEvent', templateId: string, templateName: string } | { __typename?: 'LineStateUpdateEvent' } | { __typename?: 'LineSystemFoundFollowerEvent', username: string } | { __typename?: 'LineUserAudioMessageEvent' } | { __typename?: 'LineUserFileMessageEvent', contentUrl: string, fileName: string, fileSize?: string | null, format: string, mediaState: LineMediaState } | { __typename?: 'LineUserFollowedEvent', username: string } | { __typename?: 'LineUserImageMessageEvent', imageUrl: string, canQuoteReply: boolean, mediaState: LineMediaState } | { __typename?: 'LineUserLocationMessageEvent' } | { __typename?: 'LineUserPostbackEvent', displayText: string } | { __typename?: 'LineUserStickerMessageEvent', canQuoteReply: boolean, stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', stickerType: string, url: string } | { __typename?: 'StaticSticker', url: string }, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineUserTextMessageEvent', text: string, canQuoteReply: boolean, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'LineUserUnFollowedEvent', username: string } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename?: 'LineUserVideoMessageEvent', contentUrl: string, duration: number, canQuoteReply: boolean, mediaState: LineMediaState } } | null };

export type MessengerReactionFields_MessengerBotReaction_Fragment = { __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } };

export type MessengerReactionFields_MessengerUserReaction_Fragment = { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } };

export type MessengerReactionFieldsFragment = MessengerReactionFields_MessengerBotReaction_Fragment | MessengerReactionFields_MessengerUserReaction_Fragment;

export type MessengerCommonMessageFields_MessengerBotAutoMessage_Fragment = { __typename?: 'MessengerBotAutoMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> };

export type MessengerCommonMessageFields_MessengerBotAutoMessageDeleted_Fragment = { __typename?: 'MessengerBotAutoMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> };

export type MessengerCommonMessageFields_MessengerBotMessage_Fragment = { __typename?: 'MessengerBotMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> };

export type MessengerCommonMessageFields_MessengerBotMessageDeleted_Fragment = { __typename?: 'MessengerBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> };

export type MessengerCommonMessageFields_MessengerUserMessage_Fragment = { __typename?: 'MessengerUserMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> };

export type MessengerCommonMessageFields_MessengerUserMessageDeleted_Fragment = { __typename?: 'MessengerUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> };

export type MessengerCommonMessageFieldsFragment = MessengerCommonMessageFields_MessengerBotAutoMessage_Fragment | MessengerCommonMessageFields_MessengerBotAutoMessageDeleted_Fragment | MessengerCommonMessageFields_MessengerBotMessage_Fragment | MessengerCommonMessageFields_MessengerBotMessageDeleted_Fragment | MessengerCommonMessageFields_MessengerUserMessage_Fragment | MessengerCommonMessageFields_MessengerUserMessageDeleted_Fragment;

export type MessengerImageMessageFieldsFragment = { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> };

export type MessengerVideoMessageFieldsFragment = { __typename?: 'MessengerVideoMessageContent', video: { __typename?: 'MessengerVideo', previewUrl: string, originalUrl: string } };

export type MessengerTextMessageFieldsFragment = { __typename?: 'MessengerTextMessageContent', text: string };

export type MessengerOptInContentFieldsFragment = { __typename?: 'MessengerOptInContent', title: string, buttonText: OptInCallToActionText };

export type MessengerOptOutContentFieldsFragment = { __typename?: 'MessengerOptOutContent', title: string };

export type MessengerRequestOptInContentFieldsFragment = { __typename?: 'MessengerRequestOptInContent', title: string, imageUrl?: string | null, buttonText: OptInCallToActionText };

export type MessengerResumeOptInContentFieldsFragment = { __typename?: 'MessengerResumeOptInContent', title: string };

export type MessengerUserMessageFieldsFragment = { __typename?: 'MessengerUserMessage', messageId: string, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent', title: string, buttonText: OptInCallToActionText } | { __typename?: 'MessengerOptOutContent', title: string } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent', title: string } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent', video: { __typename?: 'MessengerVideo', previewUrl: string, originalUrl: string } }, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> };

export type MessengerUserMessageDeletedFieldsFragment = { __typename?: 'MessengerUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> };

export type MessengerBotMessageFieldsFragment = { __typename?: 'MessengerBotMessage', messageState: MessageState, messageId: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' }, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> };

export type MessengerBotMessageDeletedFieldsFragment = { __typename?: 'MessengerBotMessageDeleted', messageId: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> };

export type MessengerBotAutoMessageFieldsFragment = { __typename?: 'MessengerBotAutoMessage', messageId: string, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent' } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent', title: string, imageUrl?: string | null, buttonText: OptInCallToActionText } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent' } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' }, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> };

export type MessengerMessageFields_MessengerBotAutoMessage_Fragment = { __typename?: 'MessengerBotAutoMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent' } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent', title: string, imageUrl?: string | null, buttonText: OptInCallToActionText } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent' } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' } };

export type MessengerMessageFields_MessengerBotAutoMessageDeleted_Fragment = { __typename?: 'MessengerBotAutoMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> };

export type MessengerMessageFields_MessengerBotMessage_Fragment = { __typename?: 'MessengerBotMessage', messageId: string, messageState: MessageState, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' } };

export type MessengerMessageFields_MessengerBotMessageDeleted_Fragment = { __typename?: 'MessengerBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } };

export type MessengerMessageFields_MessengerUserMessage_Fragment = { __typename?: 'MessengerUserMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent', title: string, buttonText: OptInCallToActionText } | { __typename?: 'MessengerOptOutContent', title: string } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent', title: string } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent', video: { __typename?: 'MessengerVideo', previewUrl: string, originalUrl: string } } };

export type MessengerMessageFields_MessengerUserMessageDeleted_Fragment = { __typename?: 'MessengerUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> };

export type MessengerMessageFieldsFragment = MessengerMessageFields_MessengerBotAutoMessage_Fragment | MessengerMessageFields_MessengerBotAutoMessageDeleted_Fragment | MessengerMessageFields_MessengerBotMessage_Fragment | MessengerMessageFields_MessengerBotMessageDeleted_Fragment | MessengerMessageFields_MessengerUserMessage_Fragment | MessengerMessageFields_MessengerUserMessageDeleted_Fragment;

export type MessengerMessageEventFieldsFragment = { __typename?: 'MessengerMessageEvent', id: string, timestamp: number, message: { __typename?: 'MessengerBotAutoMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent' } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent', title: string, imageUrl?: string | null, buttonText: OptInCallToActionText } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent' } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' } } | { __typename?: 'MessengerBotAutoMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> } | { __typename?: 'MessengerBotMessage', messageId: string, messageState: MessageState, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' } } | { __typename?: 'MessengerBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'MessengerUserMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent', title: string, buttonText: OptInCallToActionText } | { __typename?: 'MessengerOptOutContent', title: string } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent', title: string } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent', video: { __typename?: 'MessengerVideo', previewUrl: string, originalUrl: string } } } | { __typename?: 'MessengerUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> } };

export type MessengerChatEventFields_CommonChatEvent_Fragment = { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } };

export type MessengerChatEventFields_MessengerMessageEvent_Fragment = { __typename?: 'MessengerMessageEvent', id: string, timestamp: number, message: { __typename?: 'MessengerBotAutoMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent' } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent', title: string, imageUrl?: string | null, buttonText: OptInCallToActionText } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent' } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' } } | { __typename?: 'MessengerBotAutoMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> } | { __typename?: 'MessengerBotMessage', messageId: string, messageState: MessageState, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' } } | { __typename?: 'MessengerBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'MessengerUserMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent', title: string, buttonText: OptInCallToActionText } | { __typename?: 'MessengerOptOutContent', title: string } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent', title: string } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent', video: { __typename?: 'MessengerVideo', previewUrl: string, originalUrl: string } } } | { __typename?: 'MessengerUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> } };

export type MessengerChatEventFieldsFragment = MessengerChatEventFields_CommonChatEvent_Fragment | MessengerChatEventFields_MessengerMessageEvent_Fragment;

export type MessengerChatTextMessageSendMutationVariables = Exact<{
  input: MessengerSendTextMessageRequest;
}>;


export type MessengerChatTextMessageSendMutation = { MessengerChatTextMessageSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'MessengerMessageEvent', id: string, timestamp: number, message: { __typename?: 'MessengerBotAutoMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent' } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent', title: string, imageUrl?: string | null, buttonText: OptInCallToActionText } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent' } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' } } | { __typename?: 'MessengerBotAutoMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> } | { __typename?: 'MessengerBotMessage', messageId: string, messageState: MessageState, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' } } | { __typename?: 'MessengerBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'MessengerUserMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent', title: string, buttonText: OptInCallToActionText } | { __typename?: 'MessengerOptOutContent', title: string } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent', title: string } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent', video: { __typename?: 'MessengerVideo', previewUrl: string, originalUrl: string } } } | { __typename?: 'MessengerUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> } } | null };

export type MessengerChatImageMessageSendMutationVariables = Exact<{
  input: MessengerSendImageMessageRequest;
}>;


export type MessengerChatImageMessageSendMutation = { MessengerChatImageMessageSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'MessengerMessageEvent', id: string, timestamp: number, message: { __typename?: 'MessengerBotAutoMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent' } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent', title: string, imageUrl?: string | null, buttonText: OptInCallToActionText } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent' } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' } } | { __typename?: 'MessengerBotAutoMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> } | { __typename?: 'MessengerBotMessage', messageId: string, messageState: MessageState, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' } } | { __typename?: 'MessengerBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'MessengerUserMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent', title: string, buttonText: OptInCallToActionText } | { __typename?: 'MessengerOptOutContent', title: string } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent', title: string } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent', video: { __typename?: 'MessengerVideo', previewUrl: string, originalUrl: string } } } | { __typename?: 'MessengerUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> } } | null };

export type MessengerMessageResendMutationVariables = Exact<{
  messageId: Scalars['String']['input'];
}>;


export type MessengerMessageResendMutation = { MessengerMessageResend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'MessengerMessageEvent', id: string, timestamp: number, message: { __typename?: 'MessengerBotAutoMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent' } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent', title: string, imageUrl?: string | null, buttonText: OptInCallToActionText } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent' } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' } } | { __typename?: 'MessengerBotAutoMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> } | { __typename?: 'MessengerBotMessage', messageId: string, messageState: MessageState, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' } } | { __typename?: 'MessengerBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'MessengerUserMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent', title: string, buttonText: OptInCallToActionText } | { __typename?: 'MessengerOptOutContent', title: string } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent', title: string } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent', video: { __typename?: 'MessengerVideo', previewUrl: string, originalUrl: string } } } | { __typename?: 'MessengerUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> } } | null };

export type MessengerChatEventsQueryVariables = Exact<{
  chatId: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
  messageId?: InputMaybe<Scalars['String']['input']>;
  olderCursor?: InputMaybe<Scalars['String']['input']>;
  newerCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type MessengerChatEventsQuery = { MessengerChatEventsV2?: { __typename?: 'MessengerChatEvents', chatId: string, newerCursor?: string | null, olderCursor?: string | null, userName: string, chatEvents: Array<{ __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'MessengerMessageEvent', id: string, timestamp: number, message: { __typename?: 'MessengerBotAutoMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent' } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent', title: string, imageUrl?: string | null, buttonText: OptInCallToActionText } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent' } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' } } | { __typename?: 'MessengerBotAutoMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> } | { __typename?: 'MessengerBotMessage', messageId: string, messageState: MessageState, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' } } | { __typename?: 'MessengerBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'MessengerUserMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent', title: string, buttonText: OptInCallToActionText } | { __typename?: 'MessengerOptOutContent', title: string } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent', title: string } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent', video: { __typename?: 'MessengerVideo', previewUrl: string, originalUrl: string } } } | { __typename?: 'MessengerUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> } }> } | null };

export type ChatResolveMutationVariables = Exact<{
  input: ChatResolveRequest;
}>;


export type ChatResolveMutation = { ChatResolve?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type ChatUnresolveMutationVariables = Exact<{
  input: ChatUnresolveRequest;
}>;


export type ChatUnresolveMutation = { ChatUnresolve?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type ChatAddUserToAssigneeListMutationVariables = Exact<{
  input: ChatAddUserToAssigneesRequest;
}>;


export type ChatAddUserToAssigneeListMutation = { ChatAddUserToAssigneeList?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type ChatRemoveUserFromAssigneeListMutationVariables = Exact<{
  input: ChatRemoveUserFromAssigneesRequest;
}>;


export type ChatRemoveUserFromAssigneeListMutation = { ChatRemoveUserFromAssigneeList?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type ChatActivateAiMutationVariables = Exact<{
  input: ChatActivateAiRequest;
}>;


export type ChatActivateAiMutation = { ChatActivateAI?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type ChatDeactivateAiMutationVariables = Exact<{
  input: ChatDeactivateAiRequest;
}>;


export type ChatDeactivateAiMutation = { ChatDeactivateAI?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type ChatSetMutedMutationVariables = Exact<{
  input: ChatSetMutedRequest;
}>;


export type ChatSetMutedMutation = { ChatSetMuted?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type DeleteFailedMessageMutationVariables = Exact<{
  messageId: Scalars['String']['input'];
}>;


export type DeleteFailedMessageMutation = { DeleteFailedMessage?: boolean | null };

export type GenerateDraftReplyMutationVariables = Exact<{
  input: GenerateDraftReplyRequest;
}>;


export type GenerateDraftReplyMutation = { GenerateDraftReply?: { __typename?: 'GenerateDraftReplyResult', unsupportedLanguage: boolean, candidates: Array<{ __typename?: 'DraftCandidateGQL', id: string, text: string, index: number, tone: string }> } | null };

export type RegenerateDraftReplyMutationVariables = Exact<{
  input: RegenerateDraftReplyRequest;
}>;


export type RegenerateDraftReplyMutation = { RegenerateDraftReply?: { __typename?: 'DraftCandidateGQL', id: string, text: string, index: number, tone: string } | null };

export type SelectDraftReplyMutationVariables = Exact<{
  input: SelectDraftReplyRequest;
}>;


export type SelectDraftReplyMutation = { SelectDraftReply?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type MarkDraftSentMutationVariables = Exact<{
  input: MarkDraftSentRequest;
}>;


export type MarkDraftSentMutation = { MarkDraftSent?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type SyncAnyTagInfluencerMutationVariables = Exact<{
  input: SyncAnyTagInfluencerRequest;
}>;


export type SyncAnyTagInfluencerMutation = { SyncAnyTagInfluencer?: { __typename?: 'SyncAnyTagInfluencerResponse', chatId: string, influencerId: string } | null };

export type MergeAnyTagInfluencersMutationVariables = Exact<{
  input: MergeAnyTagInfluencersRequest;
}>;


export type MergeAnyTagInfluencersMutation = { MergeAnyTagInfluencers?: { __typename?: 'AnyTagInfluencerMergeResponse', results: Array<{ __typename?: 'AnyTagInfluencerMergeResult', fromId: string, toId: string, counts: Array<{ __typename?: 'AnyTagInfluencerMergeCount', group: string, moved: number, skipped: number }>, warnings: Array<{ __typename?: 'AnyTagInfluencerMergeWarning', kind: string, message: string, affectedIds: Array<string> }> }> } | null };

export type ChatListQueryVariables = Exact<{
  storeId: Scalars['Long']['input'];
  chatIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  chatTypeFilter: ChatTypeFilter;
  messagingChannel?: InputMaybe<ChatType>;
  tagFilter?: InputMaybe<TagFilterInput>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type ChatListQuery = { Chats?: { __typename?: 'Chats', totalCount: number, activatedCount: number, assignedToMeCount: number, ongoingCount: number, unreadCount: number, repliedCount: number, mutedCount: number, hasNext: boolean, chats: Array<{ __typename?: 'Chat', id: string, userName: string, avatar: string, type: ChatType, lastMessage: string, lastMessageAt: number, isAIActivated: boolean, checked: boolean, resolved: boolean, muted: boolean, status: CustomerChatStatus, assignees: Array<{ __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }>, customerTags: Array<{ __typename?: 'CustomerTag', name: string }> }> } | null };

export type ActiveChatQueryVariables = Exact<{
  input: GetChatRequest;
}>;


export type ActiveChatQuery = { Chat?: { __typename?: 'Chat', id: string, userName: string, avatar: string, type: ChatType, isAIActivated: boolean, resolved: boolean, muted: boolean, assignees: Array<{ __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }> } | null };

export type ChatAsideHeaderQueryVariables = Exact<{
  chatId: Scalars['String']['input'];
  withInfluencerInfo: Scalars['Boolean']['input'];
}>;


export type ChatAsideHeaderQuery = { Chat?: { __typename?: 'Chat', id: string, resolved: boolean } | null, ChatCustomerDetailV2?: { __typename?: 'ChatCustomerDetail', chatId: string, customerId: string, chatUserName: string, chatAvatar: string, name: string, type: ChatType, orderNum: number, totalSpent: string, startedAt: number, influencerName?: string | null, influencerId?: string | null, influencerLinkStatus: CustomerInfluencerLinkStatus, customerTags: Array<{ __typename?: 'CustomerTag', id: string, name: string, isInfluencerTag: boolean }>, influencerInfo?: { __typename?: 'InfluencerInfo', engagementRate?: string | null, followersCount?: string | null, profileUrl: string, registeredAt: string } | null, chatPlatformDetail: { __typename?: 'InstagramChatPlatformDetail' } | { __typename?: 'LazadaChatPlatformDetail' } | { __typename?: 'LineChatPlatformDetail' } | { __typename?: 'MessengerChatPlatformDetail', isOptIn: boolean } | { __typename?: 'ShopeeChatPlatformDetail' } | { __typename?: 'TikTokShopChatPlatformDetail' } | { __typename?: 'WhatsAppChatPlatformDetail', isOptIn: boolean } } | null };

export type GetCampaignsTabQueryVariables = Exact<{
  input: CustomerIdInput;
}>;


export type GetCampaignsTabQuery = { InfluencerCampaigns?: Array<{ __typename?: 'CampaignHistory', campaignName: string, campaignUrl: string, joinedDatetime: string, thumbnail: string }> | null };

export type FilterChatByKeywordQueryVariables = Exact<{
  keyword: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type FilterChatByKeywordQuery = { CustomerChatByKeyword?: { __typename?: 'PageResultCustomerChatKeyWordSearchItem', total: number, records: Array<{ __typename?: 'CustomerChatKeyWordSearchItem', chatIds: Array<string>, count: number, name: string, username: string, influencerName?: string | null }> } | null, CustomerTags?: { __typename?: 'CustomerTags', total: number, customerTags: Array<{ __typename?: 'CustomerTag', id: string, name: string, isInfluencerTag: boolean, taggedCount: number }> } | null, AnyTagTags?: { __typename?: 'CustomerTags', total: number, customerTags: Array<{ __typename?: 'CustomerTag', id: string, name: string, isInfluencerTag: boolean, taggedCount: number }> } | null };

export type CrmChatProductsPopoverQueryVariables = Exact<{
  input: GetAnyChatSaleChannelProductsRequest;
}>;


export type CrmChatProductsPopoverQuery = { AnyChatSaleChannelProducts?: Array<{ __typename?: 'SaleChannelProduct', id: string, name: string, imageUrl?: string | null, availableStock?: number | null, saleChannelType: AnyChatSaleChannelType }> | null };

export type SearchMessageContentQueryVariables = Exact<{
  storeId: Scalars['Long']['input'];
  keywords: Scalars['String']['input'];
}>;


export type SearchMessageContentQuery = { SearchMessageContent?: { __typename?: 'PageResultMessageSearchResultItem', total: number, records: Array<{ __typename?: 'MessageSearchResultItem', chatId: string, customerName: string, channel: ChatType, matchedMessageId: string, matchedMessageSnippet: string, matchedMessageTimestamp: number, highlights: Array<{ __typename?: 'MessageSearchMatchHighlight', word: string, offset: number, length: number }> }> } | null };

export type GetDraftReplyCandidateQueryVariables = Exact<{
  input: GetDraftReplyCandidateRequest;
}>;


export type GetDraftReplyCandidateQuery = { GetDraftReplyCandidate?: { __typename?: 'DraftCandidateGQL', id: string, text: string, index: number, tone: string } | null };

export type AnyTagInfluencersQueryVariables = Exact<{
  input: AnyTagInfluencersRequest;
}>;


export type AnyTagInfluencersQuery = { AnyTagInfluencers?: { __typename?: 'AnyTagInfluencersResponse', influencers: Array<{ __typename?: 'AnyTagInfluencer', id: string, name: string, avatar: string, followersCount?: number | null, countryName?: string | null, profileUrl: string, linkStatus: AnyTagInfluencerLinkStatus, socialAccounts: Array<{ __typename?: 'AnyTagSocialAccount', platform: string, username: string, followersCount: number }>, linkedChats: Array<{ __typename?: 'AnyTagLinkedChat', storeId: string, chatId: string }> }> } | null };

export type AnyTagInfluencerMergePreviewQueryVariables = Exact<{
  input: MergeAnyTagInfluencersRequest;
}>;


export type AnyTagInfluencerMergePreviewQuery = { AnyTagInfluencerMergePreview?: { __typename?: 'AnyTagInfluencerMergeResponse', results: Array<{ __typename?: 'AnyTagInfluencerMergeResult', fromId: string, toId: string, counts: Array<{ __typename?: 'AnyTagInfluencerMergeCount', group: string, moved: number, skipped: number }>, warnings: Array<{ __typename?: 'AnyTagInfluencerMergeWarning', kind: string, message: string, affectedIds: Array<string> }> }> } | null };

export type ShopeeTextMessageFieldsFragment = { __typename?: 'ShopeeTextMessageContent', text: string };

export type ShopeeTextContentFields_ShopeeNormalText_Fragment = { __typename?: 'ShopeeNormalText', text: string };

export type ShopeeTextContentFields_ShopeeTranslatedText_Fragment = { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> };

export type ShopeeTextContentFieldsFragment = ShopeeTextContentFields_ShopeeNormalText_Fragment | ShopeeTextContentFields_ShopeeTranslatedText_Fragment;

export type ShopeeTextMessageFieldsV2Fragment = { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } };

export type ShopeeImageMessageFieldsFragment = { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string };

export type ShopeeImageWithTextMessageFieldsFragment = { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string };

export type ShopeeUnsupportedMessageFieldsFragment = { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string };

export type ShopeeVideoMessageFieldsFragment = { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string };

export type ShopeeStickerMessageFieldsFragment = { __typename?: 'ShopeeStickerMessageContent', imageUrl: string };

export type ShopeeItemMessageFieldsFragment = { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean };

export type ShopeeOrderMessageFieldsFragment = { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean };

export type ShopeeItemSourceFieldsFragment = { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string };

export type ShopeeOrderSourceFieldsFragment = { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null };

export type ShopeeFaqChoicesFieldsFragment = { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> };

export type ShopeeFaqFeedbackPromptFieldsFragment = { __typename: 'ShopeeFAQFeedbackPrompt' };

export type ShopeeFaqBundleFieldsFragment = { __typename?: 'ShopeeFAQBundleContent', messages: Array<{ __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage' } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } }> };

export type ShopeeStoreCsMessageFieldsFragment = { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } };

export type ShopeeUserMessageFieldsFragment = { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent', messages: Array<{ __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage' } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } }> } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null };

export type ShopeeUserMessageFaqHistoryModalFieldsFragment = { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null };

export type ShopeeFaqBotMessageFieldsFragment = { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } };

export type ShopeeAiMessageFieldsFragment = { __typename?: 'ShopeeAIMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } };

export type ShopeeMessageFields_ShopeeAiMessage_Fragment = { __typename?: 'ShopeeAIMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } };

export type ShopeeMessageFields_ShopeeFaqBotMessage_Fragment = { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } };

export type ShopeeMessageFields_ShopeeStoreCsMessage_Fragment = { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } };

export type ShopeeMessageFields_ShopeeUserMessage_Fragment = { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent', messages: Array<{ __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage' } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } }> } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null };

export type ShopeeMessageFieldsFragment = ShopeeMessageFields_ShopeeAiMessage_Fragment | ShopeeMessageFields_ShopeeFaqBotMessage_Fragment | ShopeeMessageFields_ShopeeStoreCsMessage_Fragment | ShopeeMessageFields_ShopeeUserMessage_Fragment;

export type ShopeeVoucherMessageFieldsFragment = { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } };

export type ShopeeMessageFaqHistoryModalFields_ShopeeAiMessage_Fragment = { __typename?: 'ShopeeAIMessage' };

export type ShopeeMessageFaqHistoryModalFields_ShopeeFaqBotMessage_Fragment = { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } };

export type ShopeeMessageFaqHistoryModalFields_ShopeeStoreCsMessage_Fragment = { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } };

export type ShopeeMessageFaqHistoryModalFields_ShopeeUserMessage_Fragment = { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null };

export type ShopeeMessageFaqHistoryModalFieldsFragment = ShopeeMessageFaqHistoryModalFields_ShopeeAiMessage_Fragment | ShopeeMessageFaqHistoryModalFields_ShopeeFaqBotMessage_Fragment | ShopeeMessageFaqHistoryModalFields_ShopeeStoreCsMessage_Fragment | ShopeeMessageFaqHistoryModalFields_ShopeeUserMessage_Fragment;

export type ShopeeMessageEventFieldsFragment = { __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent', messages: Array<{ __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage' } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } }> } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } };

export type ShopeeChatEventFields_CommonChatEvent_Fragment = { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } };

export type ShopeeChatEventFields_ShopeeMessageEvent_Fragment = { __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent', messages: Array<{ __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage' } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } }> } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } };

export type ShopeeChatEventFieldsFragment = ShopeeChatEventFields_CommonChatEvent_Fragment | ShopeeChatEventFields_ShopeeMessageEvent_Fragment;

export type ShopeeChatTextMessageSendMutationVariables = Exact<{
  input: ShopeeSendTextMessageRequestInput;
}>;


export type ShopeeChatTextMessageSendMutation = { ShopeeChatTextMessageSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent', messages: Array<{ __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage' } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } }> } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } } | null };

export type ShopeeChatImageMessageSendMutationVariables = Exact<{
  input: ShopeeSendImageMessageRequestInput;
}>;


export type ShopeeChatImageMessageSendMutation = { ShopeeChatImageMessageSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent', messages: Array<{ __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage' } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } }> } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } } | null };

export type ShopeeChatProductMessageSendMutationVariables = Exact<{
  input: ShopeeSendProductMessageRequestInput;
}>;


export type ShopeeChatProductMessageSendMutation = { ShopeeChatProductMessageSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent', messages: Array<{ __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage' } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } }> } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } } | null };

export type ShopeeChatVideoMessageSendMutationVariables = Exact<{
  input: ShopeeSendVideoMessageRequestInput;
}>;


export type ShopeeChatVideoMessageSendMutation = { ShopeeChatVideoMessageSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent', messages: Array<{ __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage' } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } }> } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } } | null };

export type ShopeeChatVoucherMessageSendMutationVariables = Exact<{
  input: ShopeeSendVoucherMessageRequestInput;
}>;


export type ShopeeChatVoucherMessageSendMutation = { ShopeeChatVoucherMessageSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent', messages: Array<{ __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage' } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } }> } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } } | null };

export type ShopeeMessageResendMutationVariables = Exact<{
  messageId: Scalars['String']['input'];
}>;


export type ShopeeMessageResendMutation = { ShopeeMessageResend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent', messages: Array<{ __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage' } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } }> } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } } | null };

export type ShopeeChatEventsQueryVariables = Exact<{
  storeId: Scalars['Long']['input'];
  chatId: Scalars['String']['input'];
  messageId?: InputMaybe<Scalars['String']['input']>;
  olderCursor?: InputMaybe<Scalars['String']['input']>;
  newerCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShopeeChatEventsQuery = { ShopeeChatEventsV2?: { __typename?: 'ShopeeChatEvents', chatId: string, newerCursor?: string | null, olderCursor?: string | null, userName: string, chatEvents: Array<{ __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent', messages: Array<{ __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage' } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } }> } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } }> } | null };

export type WhatsAppTextMessageFieldsFragment = { __typename?: 'WhatsAppTextMessageContent', text: string };

export type WhatsAppImageMessageFieldsFragment = { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null };

export type WhatsAppVideoMessageFieldsFragment = { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null };

export type WhatsAppUnsupportedMessageFieldsFragment = { __typename: 'WhatsAppUnsupportedContent' };

export type WhatsAppOptInMessageFieldsFragment = { __typename?: 'WhatsAppOptInMessageContent', text: string };

export type WhatsAppOptOutMessageFieldsFragment = { __typename?: 'WhatsAppOptOutMessageContent', text: string };

export type WhatsAppOptInRequestMessageFieldsFragment = { __typename?: 'WhatsAppOptInRequestMessageContent', version: number };

export type WhatsAppAutoReplyMessageFieldsFragment = { __typename?: 'WhatsAppAutoReplyMessage', messageId: string, content: { __typename?: 'WhatsAppOptInRequestMessageContent', version: number } };

export type WhatsAppStoreCsMessageFieldsFragment = { __typename?: 'WhatsAppStoreCSMessage', messageId: string, messageState: MessageState, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null }, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } };

export type WhatsAppUserMessageFieldsFragment = { __typename?: 'WhatsAppUserMessage', messageId: string, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppOptInMessageContent', text: string } | { __typename?: 'WhatsAppOptOutMessageContent', text: string } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename: 'WhatsAppUnsupportedContent' } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null } };

export type WhatsAppMessageFields_WhatsAppAutoReplyMessage_Fragment = { __typename?: 'WhatsAppAutoReplyMessage', messageId: string, content: { __typename?: 'WhatsAppOptInRequestMessageContent', version: number } };

export type WhatsAppMessageFields_WhatsAppStoreCsMessage_Fragment = { __typename?: 'WhatsAppStoreCSMessage', messageId: string, messageState: MessageState, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null }, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } };

export type WhatsAppMessageFields_WhatsAppUserMessage_Fragment = { __typename?: 'WhatsAppUserMessage', messageId: string, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppOptInMessageContent', text: string } | { __typename?: 'WhatsAppOptOutMessageContent', text: string } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename: 'WhatsAppUnsupportedContent' } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null } };

export type WhatsAppMessageFieldsFragment = WhatsAppMessageFields_WhatsAppAutoReplyMessage_Fragment | WhatsAppMessageFields_WhatsAppStoreCsMessage_Fragment | WhatsAppMessageFields_WhatsAppUserMessage_Fragment;

export type WhatsAppMessageEventFieldsFragment = { __typename?: 'WhatsAppMessageEvent', id: string, timestamp: number, status: WhatsAppMessageDeliveryStatus, seqNumber: string, message: { __typename?: 'WhatsAppAutoReplyMessage', messageId: string, content: { __typename?: 'WhatsAppOptInRequestMessageContent', version: number } } | { __typename?: 'WhatsAppStoreCSMessage', messageId: string, messageState: MessageState, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null }, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'WhatsAppUserMessage', messageId: string, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppOptInMessageContent', text: string } | { __typename?: 'WhatsAppOptOutMessageContent', text: string } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename: 'WhatsAppUnsupportedContent' } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null } } };

export type WhatsAppChatEventFields_CommonChatEvent_Fragment = { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } };

export type WhatsAppChatEventFields_WhatsAppMessageEvent_Fragment = { __typename?: 'WhatsAppMessageEvent', id: string, timestamp: number, status: WhatsAppMessageDeliveryStatus, seqNumber: string, message: { __typename?: 'WhatsAppAutoReplyMessage', messageId: string, content: { __typename?: 'WhatsAppOptInRequestMessageContent', version: number } } | { __typename?: 'WhatsAppStoreCSMessage', messageId: string, messageState: MessageState, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null }, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'WhatsAppUserMessage', messageId: string, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppOptInMessageContent', text: string } | { __typename?: 'WhatsAppOptOutMessageContent', text: string } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename: 'WhatsAppUnsupportedContent' } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null } } };

export type WhatsAppChatEventFieldsFragment = WhatsAppChatEventFields_CommonChatEvent_Fragment | WhatsAppChatEventFields_WhatsAppMessageEvent_Fragment;

export type WhatsAppChatTextMessageSendMutationVariables = Exact<{
  input: WhatsAppSendTextMessageRequestInput;
}>;


export type WhatsAppChatTextMessageSendMutation = { WhatsAppChatTextMessageSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'WhatsAppMessageEvent', id: string, timestamp: number, status: WhatsAppMessageDeliveryStatus, seqNumber: string, message: { __typename?: 'WhatsAppAutoReplyMessage', messageId: string, content: { __typename?: 'WhatsAppOptInRequestMessageContent', version: number } } | { __typename?: 'WhatsAppStoreCSMessage', messageId: string, messageState: MessageState, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null }, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'WhatsAppUserMessage', messageId: string, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppOptInMessageContent', text: string } | { __typename?: 'WhatsAppOptOutMessageContent', text: string } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename: 'WhatsAppUnsupportedContent' } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null } } } | null };

export type WhatsAppChatImageMessageSendMutationVariables = Exact<{
  input: WhatsAppSendImageMessageRequestInput;
}>;


export type WhatsAppChatImageMessageSendMutation = { WhatsAppChatImageMessageSend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'WhatsAppMessageEvent', id: string, timestamp: number, status: WhatsAppMessageDeliveryStatus, seqNumber: string, message: { __typename?: 'WhatsAppAutoReplyMessage', messageId: string, content: { __typename?: 'WhatsAppOptInRequestMessageContent', version: number } } | { __typename?: 'WhatsAppStoreCSMessage', messageId: string, messageState: MessageState, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null }, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'WhatsAppUserMessage', messageId: string, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppOptInMessageContent', text: string } | { __typename?: 'WhatsAppOptOutMessageContent', text: string } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename: 'WhatsAppUnsupportedContent' } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null } } } | null };

export type WhatsAppMessageResendMutationVariables = Exact<{
  messageId: Scalars['String']['input'];
}>;


export type WhatsAppMessageResendMutation = { WhatsAppMessageResend?: { __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'WhatsAppMessageEvent', id: string, timestamp: number, status: WhatsAppMessageDeliveryStatus, seqNumber: string, message: { __typename?: 'WhatsAppAutoReplyMessage', messageId: string, content: { __typename?: 'WhatsAppOptInRequestMessageContent', version: number } } | { __typename?: 'WhatsAppStoreCSMessage', messageId: string, messageState: MessageState, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null }, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'WhatsAppUserMessage', messageId: string, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppOptInMessageContent', text: string } | { __typename?: 'WhatsAppOptOutMessageContent', text: string } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename: 'WhatsAppUnsupportedContent' } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null } } } | null };

export type WhatsAppChatEventsQueryVariables = Exact<{
  chatId: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
  messageId?: InputMaybe<Scalars['String']['input']>;
  olderCursor?: InputMaybe<Scalars['String']['input']>;
  newerCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type WhatsAppChatEventsQuery = { WhatsAppChatEventsV2?: { __typename?: 'WhatsAppChatEvents', chatId: string, newerCursor?: string | null, olderCursor?: string | null, userName: string, lastCheckedAt?: number | null, chatEvents: Array<{ __typename?: 'CommonChatEvent', id: string, timestamp: number, event: { __typename: 'AIMessageFailedToSendEvent' } | { __typename?: 'ActivateAI', isAuto: boolean } | { __typename?: 'AddUserToAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'CloseChat' } | { __typename?: 'DeactivateAI', isAuto: boolean } | { __typename?: 'ManualAssign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'ManualUnassign', assignee: { __typename: 'ChatAIAssignee' } | { __typename?: 'ChatUserAssignee', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } } | { __typename?: 'MessageSendFailedEvent', platform: ChatType, content: { __typename?: 'FailedMessageFileContent', url: string } | { __typename?: 'FailedMessageImageContent', url: string } | { __typename?: 'FailedMessageTextContent', text: string } | { __typename?: 'FailedMessageVideoContent', url: string } } | { __typename?: 'MuteChat' } | { __typename?: 'RemoveUserFromAssigneeList', user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'ReopenChat' } | { __typename: 'SystemAutoAssignAI' } | { __typename: 'SystemAutoUnassignAI' } | { __typename?: 'UnmuteChat' } } | { __typename?: 'WhatsAppMessageEvent', id: string, timestamp: number, status: WhatsAppMessageDeliveryStatus, seqNumber: string, message: { __typename?: 'WhatsAppAutoReplyMessage', messageId: string, content: { __typename?: 'WhatsAppOptInRequestMessageContent', version: number } } | { __typename?: 'WhatsAppStoreCSMessage', messageId: string, messageState: MessageState, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null }, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'WhatsAppUserMessage', messageId: string, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppOptInMessageContent', text: string } | { __typename?: 'WhatsAppOptOutMessageContent', text: string } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename: 'WhatsAppUnsupportedContent' } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null } } }> } | null };

export type NewInstagramChatEventsFragment = { __typename?: 'InstagramChatEvents', chatEvents: Array<{ __typename?: 'CommonChatEvent' } | { __typename?: 'InstagramMessageEvent', id: string, timestamp: number, message: { __typename?: 'InstagramBotAutoReplyMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, autoReplyInfo: { __typename?: 'LiveCommentAutoReplyInfo', id: string, name: string, trigger: { __typename: 'AnyContent' } | { __typename?: 'ContainsKeyword', value: string } } } | { __typename?: 'InstagramBotAutoReplyMessageDelete', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> } | { __typename?: 'InstagramBotMessage', messageId: string, messageState: MessageState, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent' } | { __typename?: 'TextLiveCommentContent' } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent' } } | { __typename?: 'InstagramBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'InstagramUserMessage', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }>, content: { __typename?: 'AutoReplyContent' } | { __typename?: 'ImageMessageContent', previewUrl: string, originalUrl: string } | { __typename?: 'StoryMentionContent', story: { __typename?: 'Story', contentType?: string | null, originalUrl: string } } | { __typename?: 'TextLiveCommentContent', text: string } | { __typename?: 'TextMessageContent', text: string } | { __typename?: 'UnsupportedContent' } | { __typename?: 'VideoMessageContent', previewUrl: string, originalUrl: string } } | { __typename?: 'InstagramUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'BotReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } } | { __typename?: 'UserReaction', sign: { __typename?: 'Emoji', code: string } | { __typename?: 'InstagramSign', name: string } }> } }> };

export type NewLazadaChatEventsVideoFragment = { __typename?: 'LazadaChatEvents', chatEvents: Array<{ __typename?: 'CommonChatEvent' } | { __typename?: 'LazadaMessageEvent', id: string, timestamp: number, message: { __typename?: 'LazadaStoreCSMessage', messageId: string, settingPageUrl?: string | null, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } | { __typename: 'LazadaFAQBot' } | { __typename: 'RepliedFromLazada' }, content: { __typename?: 'LazadaEmojiMessageContent' } | { __typename?: 'LazadaFAQMessageContent', text: string, questions: Array<string> } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent' } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent', name: string, type: LazadaVoucherType, status: LazadaVoucherStatus, startDate: string, endDate: string, minSpend: string, currency: string, voucherMessageId: string, discount: { __typename?: 'LazadaVoucherMoneyValueOff', amount: string } | { __typename?: 'LazadaVoucherPercentageDiscountOff', percentage: string, maxValue: string } } } | { __typename?: 'LazadaUserMessage', messageId: string, content: { __typename?: 'LazadaEmojiMessageContent', iconUrl: string, text: string } | { __typename?: 'LazadaFAQMessageContent' } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent', id: string, title: string, iconUrl: string, anyxOrderId?: string | null } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent' } } }> };

export type NewLazadaChatEventsFragment = { __typename?: 'LazadaChatEvents', chatEvents: Array<{ __typename?: 'CommonChatEvent' } | { __typename?: 'LazadaMessageEvent', id: string, timestamp: number, message: { __typename?: 'LazadaStoreCSMessage', messageId: string, settingPageUrl?: string | null, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } | { __typename: 'LazadaFAQBot' } | { __typename: 'RepliedFromLazada' }, content: { __typename?: 'LazadaEmojiMessageContent' } | { __typename?: 'LazadaFAQMessageContent', text: string, questions: Array<string> } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent' } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent', name: string, type: LazadaVoucherType, status: LazadaVoucherStatus, startDate: string, endDate: string, minSpend: string, currency: string, voucherMessageId: string, discount: { __typename?: 'LazadaVoucherMoneyValueOff', amount: string } | { __typename?: 'LazadaVoucherPercentageDiscountOff', percentage: string, maxValue: string } } } | { __typename?: 'LazadaUserMessage', messageId: string, content: { __typename?: 'LazadaEmojiMessageContent', iconUrl: string, text: string } | { __typename?: 'LazadaFAQMessageContent' } | { __typename?: 'LazadaImageMessageContent', url: string } | { __typename?: 'LazadaItemMessageContent', id: string, title: string, iconUrl: string, actionUrl?: string | null, itemUrlPath?: string | null } | { __typename?: 'LazadaOrderMessageContent', id: string, title: string, iconUrl: string, anyxOrderId?: string | null } | { __typename?: 'LazadaTextMessageContent', text: string } | { __typename?: 'LazadaUnsupportedMessageContent' } | { __typename?: 'LazadaVideoMessageContent', firstFrameUrl: string, videoUrl?: string | null } | { __typename?: 'LazadaVoucherMessageContent' } } }> };

export type NewMessengerChatEventsFragment = { __typename?: 'MessengerChatEvents', chatEvents: Array<{ __typename?: 'CommonChatEvent' } | { __typename?: 'MessengerMessageEvent', id: string, timestamp: number, message: { __typename?: 'MessengerBotAutoMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent' } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent', title: string, imageUrl?: string | null, buttonText: OptInCallToActionText } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent' } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' } } | { __typename?: 'MessengerBotAutoMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> } | { __typename?: 'MessengerBotMessage', messageId: string, messageState: MessageState, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent' } | { __typename?: 'MessengerOptOutContent' } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent' } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent' } } | { __typename?: 'MessengerBotMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'MessengerUserMessage', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }>, content: { __typename?: 'MessengerImageCommentContent' } | { __typename?: 'MessengerImageMessageContent', images: Array<{ __typename?: 'MessengerImage', previewUrl: string, originalUrl: string }> } | { __typename?: 'MessengerOptInContent', title: string, buttonText: OptInCallToActionText } | { __typename?: 'MessengerOptOutContent', title: string } | { __typename?: 'MessengerPostOnPageContent' } | { __typename?: 'MessengerRequestOptInContent' } | { __typename?: 'MessengerResumeOptInContent', title: string } | { __typename?: 'MessengerTextCommentContent' } | { __typename?: 'MessengerTextMessageContent', text: string } | { __typename?: 'MessengerUnsupportedContent' } | { __typename?: 'MessengerVideoMessageContent', video: { __typename?: 'MessengerVideo', previewUrl: string, originalUrl: string } } } | { __typename?: 'MessengerUserMessageDeleted', messageId: string, reactions: Array<{ __typename?: 'MessengerBotReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } } | { __typename?: 'MessengerUserReaction', sign: { __typename?: 'MessengerEmoji', code: string } | { __typename?: 'MessengerSign', name: string } }> } }> };

export type NewShopeeChatEventsVideoFragment = { __typename?: 'ShopeeChatEvents', chatEvents: Array<{ __typename?: 'CommonChatEvent' } | { __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent', messages: Array<{ __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage' } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } }> } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } }> };

export type NewShopeeChatEventsFragment = { __typename?: 'ShopeeChatEvents', chatEvents: Array<{ __typename?: 'CommonChatEvent' } | { __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent', messages: Array<{ __typename?: 'ShopeeMessageEvent', id: string, timestamp: number, message: { __typename?: 'ShopeeAIMessage' } | { __typename?: 'ShopeeFAQBotMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent' } | { __typename?: 'ShopeeImageWithTextMessageContent' } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent' } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent' } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent' } | { __typename?: 'ShopeeVoucherMessageContent' } } | { __typename?: 'ShopeeStoreCSMessage', messageId: string, messageState: MessageState, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string }, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices' } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent' } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent', voucher: { __typename?: 'ChatShopeeVoucher', voucherId: string, voucherCode: string, name: string, minBasketPrice?: string | null, displayStartTime: string, validUntil: string, currency: string, status: ShopeeVoucherStatus, usageUrl: string, discount: { __typename?: 'ChatShopeeCoinCashBack', percentage: number } | { __typename?: 'ChatShopeeFixedDiscount', amount: string } | { __typename?: 'ChatShopeePercentageDiscount', percentage: number } } } } | { __typename?: 'ShopeeUserMessage', messageId: string, content: { __typename?: 'ShopeeFAQBundleContent' } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } }> } | { __typename?: 'ShopeeFAQChoices', faqTitle: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }, choices: Array<{ __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> }> } | { __typename?: 'ShopeeFAQFeedbackPrompt' } | { __typename?: 'ShopeeImageMessageContent', previewUrl: string, url: string } | { __typename?: 'ShopeeImageWithTextMessageContent', previewUrl: string, url: string, text: string } | { __typename?: 'ShopeeItemListMessageContent' } | { __typename?: 'ShopeeItemMessageContent', title: string, itemImageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, isShopItem: boolean } | { __typename?: 'ShopeeOrderMessageContent', shopeeOrderSN: string, itemCount: number, orderImageUrl?: string | null, anyXOrderId?: string | null, isShopOrder: boolean } | { __typename?: 'ShopeeStickerMessageContent', imageUrl: string } | { __typename?: 'ShopeeTextMessageContent', text: string } | { __typename?: 'ShopeeTextMessageContentV2', textV2: { __typename?: 'ShopeeNormalText', text: string } | { __typename?: 'ShopeeTranslatedText', translations: Array<{ __typename?: 'ShopeeTextTranslation', lang: string, text: string }> } } | { __typename?: 'ShopeeUnsupportedMessageContent', messageType: string } | { __typename?: 'ShopeeVideoMessageContent', previewUrl: string, videoUrl: string } | { __typename?: 'ShopeeVoucherMessageContent' }, source?: { __typename?: 'ItemSource', title: string, imageUrl?: string | null, itemUrlPath?: string | null, externalLink: string, shopeeItemId: string } | { __typename?: 'OrderSource', shopeeOrderSN: string, itemCount: number, imageUrl?: string | null, anyXOrderId?: string | null } | null } }> };

export type NewWhatsAppChatEventsFragment = { __typename?: 'WhatsAppChatEvents', chatEvents: Array<{ __typename?: 'CommonChatEvent' } | { __typename?: 'WhatsAppMessageEvent', id: string, timestamp: number, status: WhatsAppMessageDeliveryStatus, seqNumber: string, message: { __typename?: 'WhatsAppAutoReplyMessage', messageId: string, content: { __typename?: 'WhatsAppOptInRequestMessageContent', version: number } } | { __typename?: 'WhatsAppStoreCSMessage', messageId: string, messageState: MessageState, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null }, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename?: 'WhatsAppUserMessage', messageId: string, content: { __typename?: 'WhatsAppImageMessageContent', url: string, caption?: string | null } | { __typename?: 'WhatsAppOptInMessageContent', text: string } | { __typename?: 'WhatsAppOptOutMessageContent', text: string } | { __typename?: 'WhatsAppTextMessageContent', text: string } | { __typename: 'WhatsAppUnsupportedContent' } | { __typename?: 'WhatsAppVideoMessageContent', url: string, caption?: string | null } } }> };

export type CustomerOrdersV2QueryVariables = Exact<{
  input: GetCustomerOrderV2Request;
}>;


export type CustomerOrdersV2Query = { CustomerOrdersV2?: Array<{ __typename?: 'CustomerOrder', orderId: string, orderUrl?: string | null, orderedAt: number, status: DeliveryStatus, saleChannelType: AnyChatSaleChannelType, items: Array<{ __typename?: 'OrderItem', imageUrl?: string | null }>, totalPrice: { __typename?: 'AnyChatMoney', currencyCode: string, amount: string } }> | null };

export type CustomerShopifyMetafieldsQueryVariables = Exact<{
  input: CustomerIdInput;
}>;


export type CustomerShopifyMetafieldsQuery = { Customer?: { __typename?: 'Customer', id: string, shopifyMetafields: Array<{ __typename?: 'CustomerShopifyMetafield', displayName: string, value?: string | null, valueFormat: MetafieldValueFormat }> } | null };

export type CustomerHeaderInfoFragment = { __typename?: 'Customer', id: string, createdAt: number, amountSpent: string, amountOfOrders: number };

export type CustomerAddressFieldsFragment = { __typename?: 'CustomerAddress', city?: string | null, zip?: string | null, fallBackProvinceName?: string | null, address1?: string | null, address2?: string | null, country: { __typename?: 'MdCountry', id: string, name: string }, province?: { __typename?: 'MdProvince', id: string, name: string } | null };

export type CustomerProfileFieldsFragment = { __typename?: 'AnyChatCustomerProfile', name?: string | null, email?: string | null, phoneNumber?: string | null, birthDate?: any | null, age?: number | null, gender?: Gender | null, height?: number | null, weight?: number | null, size?: string | null, address?: { __typename?: 'CustomerAddress', city?: string | null, zip?: string | null, fallBackProvinceName?: string | null, address1?: string | null, address2?: string | null, country: { __typename?: 'MdCountry', id: string, name: string }, province?: { __typename?: 'MdProvince', id: string, name: string } | null } | null };

export type CustomerDetailInfoFragment = { __typename?: 'Customer', id: string, name: string, avatar?: string | null, email?: string | null, phoneNumber?: string | null, birthDate?: any | null, age?: number | null, gender?: Gender | null, height?: number | null, weight?: number | null, size?: string | null, createdAt: number, influencerId?: string | null, influencerLinkedAt?: number | null, customerTags: Array<{ __typename?: 'CustomerTag', id: string, name: string }>, address?: { __typename?: 'CustomerAddress', city?: string | null, zip?: string | null, fallBackProvinceName?: string | null, address1?: string | null, address2?: string | null, country: { __typename?: 'MdCountry', id: string, name: string }, province?: { __typename?: 'MdProvince', id: string, name: string } | null } | null, saleChannelCustomers: Array<{ __typename?: 'AnyChatSaleChannelCustomer', channelType: AnyChatSaleChannelType, createdAt: number, externalCustomerId: string, customerProfile?: { __typename?: 'AnyChatCustomerProfile', name?: string | null, email?: string | null, phoneNumber?: string | null, birthDate?: any | null, age?: number | null, gender?: Gender | null, height?: number | null, weight?: number | null, size?: string | null, address?: { __typename?: 'CustomerAddress', city?: string | null, zip?: string | null, fallBackProvinceName?: string | null, address1?: string | null, address2?: string | null, country: { __typename?: 'MdCountry', id: string, name: string }, province?: { __typename?: 'MdProvince', id: string, name: string } | null } | null } | null }>, chatChannels: Array<{ __typename?: 'ChatChannel', channel: ChatType, chatId: string, createdAt: number, customerProfile?: { __typename?: 'AnyChatCustomerProfile', name?: string | null, email?: string | null, phoneNumber?: string | null, birthDate?: any | null, age?: number | null, gender?: Gender | null, height?: number | null, weight?: number | null, size?: string | null, address?: { __typename?: 'CustomerAddress', city?: string | null, zip?: string | null, fallBackProvinceName?: string | null, address1?: string | null, address2?: string | null, country: { __typename?: 'MdCountry', id: string, name: string }, province?: { __typename?: 'MdProvince', id: string, name: string } | null } | null } | null }> };

export type CustomerDetailQueryVariables = Exact<{
  input: CustomerIdInput;
}>;


export type CustomerDetailQuery = { Customer?: { __typename?: 'Customer', id: string, createdAt: number, amountSpent: string, amountOfOrders: number, name: string, avatar?: string | null, email?: string | null, phoneNumber?: string | null, birthDate?: any | null, age?: number | null, gender?: Gender | null, height?: number | null, weight?: number | null, size?: string | null, influencerId?: string | null, influencerLinkedAt?: number | null, customerTags: Array<{ __typename?: 'CustomerTag', id: string, name: string }>, address?: { __typename?: 'CustomerAddress', city?: string | null, zip?: string | null, fallBackProvinceName?: string | null, address1?: string | null, address2?: string | null, country: { __typename?: 'MdCountry', id: string, name: string }, province?: { __typename?: 'MdProvince', id: string, name: string } | null } | null, saleChannelCustomers: Array<{ __typename?: 'AnyChatSaleChannelCustomer', channelType: AnyChatSaleChannelType, createdAt: number, externalCustomerId: string, customerProfile?: { __typename?: 'AnyChatCustomerProfile', name?: string | null, email?: string | null, phoneNumber?: string | null, birthDate?: any | null, age?: number | null, gender?: Gender | null, height?: number | null, weight?: number | null, size?: string | null, address?: { __typename?: 'CustomerAddress', city?: string | null, zip?: string | null, fallBackProvinceName?: string | null, address1?: string | null, address2?: string | null, country: { __typename?: 'MdCountry', id: string, name: string }, province?: { __typename?: 'MdProvince', id: string, name: string } | null } | null } | null }>, chatChannels: Array<{ __typename?: 'ChatChannel', channel: ChatType, chatId: string, createdAt: number, customerProfile?: { __typename?: 'AnyChatCustomerProfile', name?: string | null, email?: string | null, phoneNumber?: string | null, birthDate?: any | null, age?: number | null, gender?: Gender | null, height?: number | null, weight?: number | null, size?: string | null, address?: { __typename?: 'CustomerAddress', city?: string | null, zip?: string | null, fallBackProvinceName?: string | null, address1?: string | null, address2?: string | null, country: { __typename?: 'MdCountry', id: string, name: string }, province?: { __typename?: 'MdProvince', id: string, name: string } | null } | null } | null }> } | null };

export type AddCustomerTagsMutationVariables = Exact<{
  input: AddCustomerTagRequest;
}>;


export type AddCustomerTagsMutation = { AddCustomerTags?: Array<{ __typename?: 'CustomerTag', id: string }> | null };

export type UpdateCustomerTagMutationVariables = Exact<{
  input: UpdateCustomerTagRequest;
}>;


export type UpdateCustomerTagMutation = { UpdateCustomerTag?: { __typename?: 'CustomerTag', id: string, name: string } | null };

export type DeleteCustomerTagsMutationVariables = Exact<{
  input: DeleteCustomerTagsRequest;
}>;


export type DeleteCustomerTagsMutation = { DeleteCustomerTags?: { __typename?: 'CustomerTagDeleteFailure', customerTagInUses: Array<{ __typename?: 'CustomerTag', id: string, name: string }> } | { __typename: 'CustomerTagDeleteSuccess' } | null };

export type CustomerListV2QueryVariables = Exact<{
  input: GetCustomersV2Request;
}>;


export type CustomerListV2Query = { CustomersV2?: { __typename?: 'Customers', total: number, customers: Array<{ __typename?: 'Customer', id: string, name: string, amountOfOrders: number, amountSpent: string, lastOrderedAt?: number | null, influencerId?: string | null, phoneNumber?: string | null, email?: string | null, createdAt: number, chatChannels: Array<{ __typename?: 'ChatChannel', channel: ChatType, chatId: string }>, saleChannelCustomers: Array<{ __typename?: 'AnyChatSaleChannelCustomer', channelType: AnyChatSaleChannelType }>, address?: { __typename?: 'CustomerAddress', country: { __typename?: 'MdCountry', id: string, name: string } } | null }> } | null };

export type CustomerTagsListQueryVariables = Exact<{
  input: GetCustomerTagsRequest;
}>;


export type CustomerTagsListQuery = { CustomerTags?: { __typename?: 'CustomerTags', total: number, customerTags: Array<{ __typename?: 'CustomerTag', id: string, name: string, taggedCount: number }> } | null };

export type UpdateCustomerInformationMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCustomerInformationMutation = { UpdateCustomerV2?: { __typename?: 'Customer', id: string, name: string, email?: string | null, phoneNumber?: string | null, address?: { __typename?: 'CustomerAddress', zip?: string | null, city?: string | null, fallBackProvinceName?: string | null, address1?: string | null, address2?: string | null, country: { __typename?: 'MdCountry', id: string, name: string }, province?: { __typename?: 'MdProvince', id: string, name: string } | null } | null } | { __typename?: 'CustomerGroupProfileUpdateConflictError', emailConflicts: Array<string>, phoneConflicts: Array<string> } | null };

export type UpdateCustomerPersonalDetailsMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  birthday?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  height?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCustomerPersonalDetailsMutation = { UpdateCustomerV2?: { __typename?: 'Customer', id: string, birthDate?: any | null, age?: number | null, gender?: Gender | null, height?: number | null, weight?: number | null, size?: string | null } | { __typename?: 'CustomerGroupProfileUpdateConflictError' } | null };

export type AddAutomationFlowMutationVariables = Exact<{
  input: AddAutomationFlowRequest;
}>;


export type AddAutomationFlowMutation = { AddAutomationFlow?: { __typename?: 'AutomationFlow', id: string } | null };

export type EditAutomationFlowMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  trigger: AutomationFlowTriggerInput;
  replyContents: Array<AutomationFlowContentInput> | AutomationFlowContentInput;
  sendWhen: LiveCommentAutoReplyTiming;
}>;


export type EditAutomationFlowMutation = { UpdateAutomationFlow?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type ToggleAutomationEnabledMutationVariables = Exact<{
  id: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type ToggleAutomationEnabledMutation = { UpdateAutomationFlow?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type GetAutomationFlowQueryVariables = Exact<{
  input: GetAutomationFlowRequest;
}>;


export type GetAutomationFlowQuery = { AutomationFlow?: { __typename?: 'AutomationFlow', id: string, name: string, sendWhen: LiveCommentAutoReplyTiming, trigger: { __typename: 'AnyContent' } | { __typename?: 'ContainsKeyword', value: string }, replyContents: Array<{ __typename?: 'AutomationTemplateContent', title: string, imageUrl?: string | null, buttons: Array<{ __typename?: 'AutomationTemplateButton', title: string, buttonUrl: string }> } | { __typename?: 'AutomationTextContent', text: string }> } | null };

export type GetAutomationFlowsQueryVariables = Exact<{
  input: GetAutomationFlowsRequest;
}>;


export type GetAutomationFlowsQuery = { AutomationFlows?: { __typename?: 'PageResultAutomationFlow', total: number, records: Array<{ __typename?: 'AutomationFlow', id: string, name: string, enabled: boolean, sendWhen: LiveCommentAutoReplyTiming, trigger: { __typename: 'AnyContent' } | { __typename?: 'ContainsKeyword', value: string } }> } | null };

export type LineBroadcastMessageCreateMutationVariables = Exact<{
  input: LineBroadcastMessageCreateRequestInput;
}>;


export type LineBroadcastMessageCreateMutation = { LineBroadcastMessageCreate?: { __typename?: 'LineBroadcastMessageCreateResponse', messageId: string } | null };

export type LineBroadcastMessageUpdateMutationVariables = Exact<{
  input: LineBroadcastMessageUpdateRequestInput;
}>;


export type LineBroadcastMessageUpdateMutation = { LineBroadcastMessageUpdate?: { __typename?: 'LineBroadcastMessageUpdateResponse', messageId: string } | null };

export type LineBroadCastMessageSendMutationVariables = Exact<{
  input: SendBroadcastMessageRequestInput;
}>;


export type LineBroadCastMessageSendMutation = { LineBroadCastMessageSend?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type LineBroadCastMessageUnscheduleMutationVariables = Exact<{
  input: UnscheduleMessageRequestInput;
}>;


export type LineBroadCastMessageUnscheduleMutation = { LineBroadCastMessageUnschedule?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type SaveGreetingMessageMutationVariables = Exact<{
  input: SaveGreetingMessageRequest;
}>;


export type SaveGreetingMessageMutation = { SaveGreetingMessage?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type LineBroadcastMessagesQueryVariables = Exact<{
  input: GetLineBroadcastMessagesRequestInput;
}>;


export type LineBroadcastMessagesQuery = { LineBroadcastMessages?: { __typename?: 'LineBroadcastMessages', total: number, messages: Array<{ __typename?: 'LineBroadcastMessage', id: string, imageUrl?: string | null, name: string, status: BroadcastStatus, deliveredAt?: string | null, createdAt: string, recipient: { __typename?: 'All' } | { __typename?: 'Condition' } | { __typename?: 'CustomerTagNames', names: Array<string> } | { __typename?: 'InfluencerCondition' }, deliveryTiming: { __typename?: 'Immediately' } | { __typename?: 'Schedule', datetime: string }, statistics?: { __typename?: 'BroadcastStatistics', saleAmount: number, deliveredCount: number, openCount: number, openRate: number, clickCount: number, clickRate: number, conversionCount: number, conversionRate: number } | null }> } | null };

export type LineBroadcastStatisticSummariesQueryVariables = Exact<{
  input: GetLineBroadcastMessageStatSummaryRequestInput;
}>;


export type LineBroadcastStatisticSummariesQuery = { LineBroadcastStatisticSummaries?: { __typename?: 'LineBroadcastStatisticSummaries', sumStatistics: { __typename?: 'BroadcastStatistics', saleAmount: number, deliveredCount: number, openRate: number, clickCount: number, clickRate: number, conversionCount: number, conversionRate: number }, compareStatistics?: { __typename?: 'BroadcastStatistics', saleAmount: number, deliveredCount: number, openRate: number, clickCount: number, clickRate: number, conversionCount: number, conversionRate: number } | null } | null };

export type LineBroadcastMessageQueryVariables = Exact<{
  input: GetSingleLineBroadcastMessageRequestInput;
}>;


export type LineBroadcastMessageQuery = { LineBroadcastMessage?: { __typename?: 'LineBroadcastMessage', id: string, name: string, imageUrl?: string | null, trackingEnabled: boolean, urlLinkGroupId: string, status: BroadcastStatus, trackingUrls?: Array<{ __typename?: 'TrackingUrl', trackingUrl: string, originalUrl: string, shortUrl?: string | null }> | null, content: Array<{ __typename?: 'ButtonMessage', cards: Array<{ __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename?: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null }> } | { __typename?: 'FileMessage', fileUrl: string, card: { __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null } } | { __typename?: 'ImageMessage', images: Array<{ __typename?: 'ImageItem', imageUrl: string, label?: string | null, urlAction: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } }> } | { __typename?: 'PlainTextMessage', text: string, richText?: string | null, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'RichMessage', imageUrl: string, urlAction?: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } | null } | { __typename?: 'SingleImageMessage', originalUrl: string, previewUrl: string } | { __typename?: 'VideoMessage', originalUrl: string, previewUrl: string }>, recipient: { __typename?: 'All' } | { __typename?: 'Condition', condition: { __typename?: 'BroadcastConditionWrapper', combinator: BroadcastConditionsCombinator, conditions: Array<{ __typename?: 'BroadcastCondition', values: Array<string>, operator: BroadcastConditionOperator, type: BroadcastConditionType, id: string }> } } | { __typename?: 'CustomerTagNames', names: Array<string> } | { __typename?: 'InfluencerCondition', influencerCondition: { __typename?: 'BroadcastInfluencerConditionWrapper', combinator: BroadcastConditionsCombinator, conditions: Array<{ __typename?: 'BroadcastInfluencerCondition', values: Array<string>, operator: BroadcastConditionOperator, type: BroadcastInfluencerConditionType, id: string }> } }, deliveryTiming: { __typename?: 'Immediately' } | { __typename?: 'Schedule', datetime: string }, statistics?: { __typename?: 'BroadcastStatistics', deliveredCount: number, openCount: number, openRate: number, clickCount: number, clickRate: number, conversionCount: number, conversionRate: number, saleAmount: number } | null } | null };

export type LineBroadcastEstimateRecipientsQueryVariables = Exact<{
  input: GetEstimateRecipientRequestInput;
}>;


export type LineBroadcastEstimateRecipientsQuery = { LineBroadcastEstimateRecipients?: { __typename?: 'EstimateRecipient', estimateCount: number } | null };

export type QuotaInfosQueryVariables = Exact<{
  input: GetMessageQuotaInfoRequestInput;
}>;


export type QuotaInfosQuery = { QuotaInfos?: { __typename?: 'QuotaInfos', line: { __typename?: 'LineMessageQuotaInfo', limit?: number | null, consumption: number } } | null };

export type GetStoreGreetingMessageQueryVariables = Exact<{
  input: GetStoreGreetingMessageRequest;
}>;


export type GetStoreGreetingMessageQuery = { StoreGreetingMessage?: { __typename?: 'GreetingMessage', enabled: boolean, updatedAt: any, content: Array<{ __typename?: 'ButtonMessage', cards: Array<{ __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename?: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null }> } | { __typename?: 'FileMessage', fileUrl: string, card: { __typename?: 'Card', imageBelowDescription: boolean, image?: { __typename?: 'ButtonCardImage', url: string } | null, title?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, description?: { __typename?: 'TextComponent', text: string, weighted: boolean, fontSize: FontSize, align?: HorizontalAlignment | null, richText?: string | null } | null, actionLabelsV2?: Array<{ __typename?: 'ActionLabelV2', label: string, action: { __typename: 'ClipboardAction' } | { __typename?: 'LinkedPostbackAction', messageId: string } | { __typename?: 'UrlAction', url: string } | { __typename?: 'UrlVariableAction', variable: string } }> | null } } | { __typename?: 'ImageMessage', images: Array<{ __typename?: 'ImageItem', imageUrl: string, label?: string | null, urlAction: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } }> } | { __typename?: 'PlainTextMessage', text: string, richText?: string | null, quotedEvent?: { __typename?: 'QuotedLineChatEvent', id: string, messageNumber: number, message: { __typename: 'LineBotGreetingMessageEvent' } | { __typename: 'LineBotImageMessageEvent', originalUrl: string, author: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotTextMessageEvent', text: string, author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineBotUnitMessageEvent', author: { __typename: 'AIAuthor' } | { __typename: 'AutoAuthor' } | { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | { __typename: 'LineInfluencerJoinedCampaignEvent' } | { __typename: 'LineInquiryEvent' } | { __typename: 'LineInquiryFinishEvent' } | { __typename: 'LineMessageTemplateEvent' } | { __typename: 'LineStateUpdateEvent' } | { __typename: 'LineSystemFoundFollowerEvent' } | { __typename: 'LineUserAudioMessageEvent' } | { __typename: 'LineUserFileMessageEvent' } | { __typename: 'LineUserFollowedEvent' } | { __typename: 'LineUserImageMessageEvent', imageUrl: string } | { __typename: 'LineUserLocationMessageEvent' } | { __typename: 'LineUserPostbackEvent', displayText: string } | { __typename: 'LineUserStickerMessageEvent', stickerData: { __typename?: 'AnimatedSticker', url: string } | { __typename?: 'OtherSticker', url: string } | { __typename?: 'StaticSticker', url: string } } | { __typename: 'LineUserTextMessageEvent', text: string } | { __typename: 'LineUserUnFollowedEvent' } | { __typename: 'LineUserUnsentMessageEvent' } | { __typename: 'LineUserVideoMessageEvent' } } | null } | { __typename?: 'RichMessage', imageUrl: string, urlAction?: { __typename?: 'LineUrlText', url: string } | { __typename?: 'LineUrlVariable', variable: string } | null } | { __typename?: 'SingleImageMessage', originalUrl: string, previewUrl: string } | { __typename?: 'VideoMessage', originalUrl: string, previewUrl: string }> } | null };

export type RichMenuDisplayPeriodFragment = { __typename?: 'DateRange', from: string, to: string };

export type RichMenuTemplateFieldsFragment = { __typename?: 'LineRichMenuTemplate', id: LineRichMenuTemplateId, actions: Array<{ __typename?: 'LineRichMenuMessageAction', text: string } | { __typename?: 'LineRichMenuPostbackAction', trigger: string } | { __typename?: 'LineRichMenuUriAction', uri: string } | null> };

export type LineRichMenuSubmitMutationVariables = Exact<{
  input: LineRichMenuSubmitInput;
}>;


export type LineRichMenuSubmitMutation = { LineRichMenuSubmit?: { __typename?: 'LineRichMenuSubmitFailExistPermanent', existingId: string } | { __typename?: 'LineRichMenuSubmitFailOverlap', overlapIds: Array<string> } | { __typename?: 'LineRichMenuSubmitSuccess', id: string } | null };

export type LineRichMenuUpdateMutationVariables = Exact<{
  input: LineRichMenuUpdateInput;
}>;


export type LineRichMenuUpdateMutation = { LineRichMenuUpdate?: { __typename?: 'LineRichMenuUpdateFailExistPermanent', existingId: string } | { __typename?: 'LineRichMenuUpdateFailOverlap', overlapIds: Array<string> } | { __typename?: 'LineRichMenuUpdateSuccess', id: string } | null };

export type LineRichMenuCreateDraftMutationVariables = Exact<{
  input: LineRichMenuCreateDraftInput;
}>;


export type LineRichMenuCreateDraftMutation = { LineRichMenuCreateDraft?: { __typename?: 'LineRichMenuCreateDraftResponse', id: string } | null };

export type GetLineRichMenusQueryVariables = Exact<{
  input: LineRichMenusInput;
}>;


export type GetLineRichMenusQuery = { LineRichMenus?: { __typename?: 'PageResultLineRichMenuListItem', total: number, records: Array<{ __typename?: 'LineRichMenuListItem', id: string, status: LineRichMenuStatus, title: string, imageUrl?: string | null, displayPeriodType: LineRichMenuDisplayPeriodType, displayPeriod?: { __typename?: 'DateRange', from: string, to: string } | null }> } | null };

export type SingleLineRichMenuQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type SingleLineRichMenuQuery = { LineRichMenu?: { __typename?: 'LineRichMenu', id: string, status: LineRichMenuStatus, title: string, imageUrl?: string | null, showMenuByDefault: boolean, chatBarText: string, displayPeriodType: LineRichMenuDisplayPeriodType, displayPeriod?: { __typename?: 'DateRange', from: string, to: string } | null, template: { __typename?: 'LineRichMenuTemplate', id: LineRichMenuTemplateId, actions: Array<{ __typename?: 'LineRichMenuMessageAction', text: string } | { __typename?: 'LineRichMenuPostbackAction', trigger: string } | { __typename?: 'LineRichMenuUriAction', uri: string } | null> } } | null };

export type CurrentLineRichMenuQueryVariables = Exact<{
  storeId: Scalars['Long']['input'];
}>;


export type CurrentLineRichMenuQuery = { CurrentLineRichMenu?: { __typename?: 'LineRichMenu', id: string, status: LineRichMenuStatus, title: string, imageUrl?: string | null, showMenuByDefault: boolean, chatBarText: string, displayPeriodType: LineRichMenuDisplayPeriodType, displayPeriod?: { __typename?: 'DateRange', from: string, to: string } | null, template: { __typename?: 'LineRichMenuTemplate', id: LineRichMenuTemplateId, actions: Array<{ __typename?: 'LineRichMenuMessageAction', text: string } | { __typename?: 'LineRichMenuPostbackAction', trigger: string } | { __typename?: 'LineRichMenuUriAction', uri: string } | null> } } | null, LineRichMenus?: { __typename?: 'PageResultLineRichMenuListItem', total: number } | null };

export type MessengerBroadcastTextMessageFieldsFragment = { __typename?: 'MessengerTextContent', text: string };

export type MessengerBroadcastButtonMessageFieldsFragment = { __typename?: 'MessengerTemplateContent', cards: Array<{ __typename?: 'MessengerTemplateCard', title: string, description?: string | null, imageUrl: string, buttons: Array<{ __typename?: 'MessengerTemplateCardButton', title: string, buttonUrl: string }> }> };

export type MessengerBroadcastMessageCreateMutationVariables = Exact<{
  input: MessengerBroadcastMessageCreateRequestInput;
}>;


export type MessengerBroadcastMessageCreateMutation = { MessengerBroadcastMessageCreate?: { __typename?: 'MessengerBroadcastMessageCreateResponse', messageId: string } | null };

export type MessengerBroadcastMessageUpdateMutationVariables = Exact<{
  input: MessengerBroadcastMessageUpdateRequestInput;
}>;


export type MessengerBroadcastMessageUpdateMutation = { MessengerBroadcastMessageUpdate?: { __typename?: 'MessengerBroadcastMessageUpdateResponse', messageId: string } | null };

export type MessengerBroadCastMessageSendMutationVariables = Exact<{
  input: SendMessengerBroadcastMessageRequestInput;
}>;


export type MessengerBroadCastMessageSendMutation = { MessengerBroadCastMessageSend?: { __typename: 'CompleteSendingMessengerBroadcastSuccess' } | { __typename?: 'FailToStartSendingMessengerBroadcastTooManyUnavailableCustomer', waitUntil: string, availableRecipientsCount: number } | { __typename: 'StartSendingMessengerBroadcastSuccess' } | null };

export type MessengerBroadcastMessageUnscheduleMutationVariables = Exact<{
  input: UnscheduleMessengerMessageRequestInput;
}>;


export type MessengerBroadcastMessageUnscheduleMutation = { MessengerBroadCastMessageUnschedule?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type GetOptInSetupQueryVariables = Exact<{
  input: GetStoreMessengerOptInMessageRequestInput;
}>;


export type GetOptInSetupQuery = { StoreMessengerOptInMessage?: { __typename?: 'MessengerOptInMessage', title: string } | null };

export type MessengerBroadcastStatisticSummariesQueryVariables = Exact<{
  input: GetMessengerBroadcastMessageStatSummaryRequestInput;
}>;


export type MessengerBroadcastStatisticSummariesQuery = { MessengerBroadcastStatisticSummaries?: { __typename?: 'MessengerBroadcastStatisticSummaries', sumStatistics: { __typename?: 'MessengerBroadcastStatistics', deliveredCount: number, openRate: number, reactionRate: number }, compareStatistics?: { __typename?: 'MessengerBroadcastStatistics', deliveredCount: number, openRate: number, reactionRate: number } | null } | null };

export type MessengerBroadcastMessagesQueryVariables = Exact<{
  input: GetMessengerBroadcastMessagesRequestInput;
}>;


export type MessengerBroadcastMessagesQuery = { MessengerBroadcastMessages?: { __typename?: 'MessengerBroadcastMessages', total: number, messages: Array<{ __typename?: 'MessengerBroadcastMessage', id: string, name: string, imageUrl?: string | null, status: BroadcastStatus, deliveredAt?: string | null, createdAt: string, statistics?: { __typename?: 'MessengerBroadcastStatistics', deliveredCount: number, openCount: number, openRate: number, reactionCount: number, reactionRate: number } | null, recipient: { __typename?: 'All' } | { __typename?: 'CustomerTagName', name: string }, deliveryTiming: { __typename?: 'Immediately' } | { __typename?: 'Schedule', datetime: string } }> } | null };

export type MessengerBroadcastMessageQueryVariables = Exact<{
  input: GetSingleMessengerBroadcastMessageRequestInput;
}>;


export type MessengerBroadcastMessageQuery = { MessengerBroadcastMessage?: { __typename?: 'MessengerBroadcastMessage', id: string, name: string, createdAt: string, status: BroadcastStatus, recipient: { __typename?: 'All' } | { __typename?: 'CustomerTagName', name: string }, statistics?: { __typename?: 'MessengerBroadcastStatistics', deliveredCount: number } | null, deliveryTiming: { __typename?: 'Immediately' } | { __typename?: 'Schedule', datetime: string }, content: { __typename?: 'MessengerTemplateContent', cards: Array<{ __typename?: 'MessengerTemplateCard', title: string, description?: string | null, imageUrl: string, buttons: Array<{ __typename?: 'MessengerTemplateCardButton', title: string, buttonUrl: string }> }> } | { __typename?: 'MessengerTextContent', text: string } } | null };

export type MessengerBroadcastEstimateRecipientsQueryVariables = Exact<{
  input: GetMessengerEstimateRecipientRequestInput;
}>;


export type MessengerBroadcastEstimateRecipientsQuery = { MessengerBroadcastEstimateRecipients?: { __typename?: 'EstimateRecipient', estimateCount: number } | null };

export type SaveMessengerOptInMessageMutationVariables = Exact<{
  input: SaveMessengerOptInMessageRequestInput;
}>;


export type SaveMessengerOptInMessageMutation = { SaveMessengerOptInMessage?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type StoreMessengerOptInMessageQueryVariables = Exact<{
  input: GetStoreMessengerOptInMessageRequestInput;
}>;


export type StoreMessengerOptInMessageQuery = { StoreMessengerOptInMessage?: { __typename?: 'MessengerOptInMessage', buttonText: OptInCallToActionText, enabled: boolean, imageUrl?: string | null, title: string, updatedAt: string } | null };

export type CrmMetaTokenStatus_Mts_Invalid_Token_Fragment = { __typename: 'MTS_INVALID_TOKEN' };

export type CrmMetaTokenStatus_Mts_Token_Missing_Scope_Fragment = { __typename?: 'MTS_TOKEN_MISSING_SCOPE', scopes: Array<string> };

export type CrmMetaTokenStatus_Mts_Unknown_Fragment = { __typename?: 'MTS_UNKNOWN', message: string };

export type CrmMetaTokenStatus_Mts_Working_Fragment = { __typename: 'MTS_WORKING' };

export type CrmMetaTokenStatusFragment = CrmMetaTokenStatus_Mts_Invalid_Token_Fragment | CrmMetaTokenStatus_Mts_Token_Missing_Scope_Fragment | CrmMetaTokenStatus_Mts_Unknown_Fragment | CrmMetaTokenStatus_Mts_Working_Fragment;

export type CrmStoreDataFragment = { __typename?: 'AnyChatStore', id: string, name: string, isCrmEnabled: boolean, crmType: CrmType, hasSlackNotifications: boolean, draftReplyEnabled: boolean, slackChannelId?: string | null, saleChannels: Array<{ __typename?: 'StoreSaleChannel', id: string, type: AnyChatSaleChannelType }>, chats: Array<{ __typename?: 'InstagramStoreChat', id: string, type: ChatType, tokenStatusV2: { __typename: 'MTS_INVALID_TOKEN' } | { __typename?: 'MTS_TOKEN_MISSING_SCOPE', scopes: Array<string> } | { __typename?: 'MTS_UNKNOWN', message: string } | { __typename: 'MTS_WORKING' } } | { __typename?: 'LazadaStoreChat', tokenUpdatedSuccessfully: boolean, id: string, type: ChatType } | { __typename?: 'LineStoreChat', isRefreshTokenSuccess: boolean, isAIReplyEnable: boolean, id: string, type: ChatType, messageQuota: { __typename?: 'LineMessageQuotaInfo', consumption: number, limit?: number | null } } | { __typename?: 'MessengerStoreChat', id: string, type: ChatType, tokenStatusV2: { __typename: 'MTS_INVALID_TOKEN' } | { __typename?: 'MTS_TOKEN_MISSING_SCOPE', scopes: Array<string> } | { __typename?: 'MTS_UNKNOWN', message: string } | { __typename: 'MTS_WORKING' } } | { __typename?: 'ShopeeStoreChat', isAIReplyEnable: boolean, tokenUpdatedSuccessfully: boolean, id: string, type: ChatType } | { __typename?: 'TikTokShopStoreChat', id: string, type: ChatType } | { __typename?: 'WhatsAppStoreChat', name: string, optInEnabled: boolean, isAIReplyEnable: boolean, id: string, type: ChatType }> };

export type ValidateCrmStoreQueryVariables = Exact<{
  input: AnyChatGetStoreRequest;
}>;


export type ValidateCrmStoreQuery = { AnyChatStore?: { __typename?: 'AnyChatStore', id: string, name: string, isCrmEnabled: boolean, crmType: CrmType, hasSlackNotifications: boolean, draftReplyEnabled: boolean, slackChannelId?: string | null, saleChannels: Array<{ __typename?: 'StoreSaleChannel', id: string, type: AnyChatSaleChannelType }>, chats: Array<{ __typename?: 'InstagramStoreChat', id: string, type: ChatType, tokenStatusV2: { __typename: 'MTS_INVALID_TOKEN' } | { __typename?: 'MTS_TOKEN_MISSING_SCOPE', scopes: Array<string> } | { __typename?: 'MTS_UNKNOWN', message: string } | { __typename: 'MTS_WORKING' } } | { __typename?: 'LazadaStoreChat', tokenUpdatedSuccessfully: boolean, id: string, type: ChatType } | { __typename?: 'LineStoreChat', isRefreshTokenSuccess: boolean, isAIReplyEnable: boolean, id: string, type: ChatType, messageQuota: { __typename?: 'LineMessageQuotaInfo', consumption: number, limit?: number | null } } | { __typename?: 'MessengerStoreChat', id: string, type: ChatType, tokenStatusV2: { __typename: 'MTS_INVALID_TOKEN' } | { __typename?: 'MTS_TOKEN_MISSING_SCOPE', scopes: Array<string> } | { __typename?: 'MTS_UNKNOWN', message: string } | { __typename: 'MTS_WORKING' } } | { __typename?: 'ShopeeStoreChat', isAIReplyEnable: boolean, tokenUpdatedSuccessfully: boolean, id: string, type: ChatType } | { __typename?: 'TikTokShopStoreChat', id: string, type: ChatType } | { __typename?: 'WhatsAppStoreChat', name: string, optInEnabled: boolean, isAIReplyEnable: boolean, id: string, type: ChatType }> } | null };

export type BasicUserFieldsFragment = { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string };

export type CustomerCreatedChannelFields_CustomerCreatedMessagingChannel_Fragment = { __typename: 'CustomerCreatedMessagingChannel', chatType: ChatType };

export type CustomerCreatedChannelFields_CustomerCreatedSaleChannel_Fragment = { __typename: 'CustomerCreatedSaleChannel', saleChannel: AnyChatSaleChannelType };

export type CustomerCreatedChannelFieldsFragment = CustomerCreatedChannelFields_CustomerCreatedMessagingChannel_Fragment | CustomerCreatedChannelFields_CustomerCreatedSaleChannel_Fragment;

export type MessageAuthorFields_AiAuthor_Fragment = { __typename: 'AIAuthor' };

export type MessageAuthorFields_AutoAuthor_Fragment = { __typename: 'AutoAuthor' };

export type MessageAuthorFields_BasicUser_Fragment = { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string };

export type MessageAuthorFieldsFragment = MessageAuthorFields_AiAuthor_Fragment | MessageAuthorFields_AutoAuthor_Fragment | MessageAuthorFields_BasicUser_Fragment;

export type CustomerNoteFieldsFragment = { __typename?: 'CustomerNote', id: string, text: string, createdAt: number, updatedAt: number, channel: { __typename: 'CustomerCreatedMessagingChannel', chatType: ChatType } | { __typename: 'CustomerCreatedSaleChannel', saleChannel: AnyChatSaleChannelType }, user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } };

export type CustomerActivityV4_CustomerCreatedFragment = { __typename?: 'CustomerCreatedActivityV4', channel: { __typename: 'CustomerCreatedMessagingChannel', chatType: ChatType } | { __typename: 'CustomerCreatedSaleChannel', saleChannel: AnyChatSaleChannelType } };

export type CustomerActivityV4_InfluencerJoinedCampaignFragment = { __typename?: 'InfluencerJoinedCampaignActivityV4', campaignName: string, campaignUrl: string };

export type CustomerActivityV4_InfluencerPublishedPostFragment = { __typename?: 'InfluencerPublishedPostActivityV4', campaignName: string, campaignUrl: string };

export type CustomerActivityV4_InfluencerSubmittedPostFragment = { __typename?: 'InfluencerSubmittedPostActivityV4', campaignName: string, campaignUrl: string };

export type CustomerActivityV4_OptInFragment = { __typename?: 'OptInActivityV4', title?: string | null, chatType: ChatType, optInOperation: OptInOperation };

export type CustomerActivityV4_OrderedFragment = { __typename?: 'OrderedActivityV4', externalOrderId: string, anyXRelativeUrl?: string | null, saleChannel: AnyChatSaleChannelType };

export type CustomerActivityV4_ProfileUpdatedFragment = { __typename?: 'ProfileUpdatedActivityV4', id: string, user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } };

export type SaveCustomerTagsMutationVariables = Exact<{
  input: SetCustomerTagsRequest;
}>;


export type SaveCustomerTagsMutation = { SetChatCustomerTags?: Array<{ __typename?: 'CustomerTag', name: string }> | null };

export type UpdateAiAutoReplySettingMutationVariables = Exact<{
  input: UpdateAiAutoReplySettingInput;
}>;


export type UpdateAiAutoReplySettingMutation = { updateAIAutoReplySetting?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type CustomerNoteV3CreateMutationVariables = Exact<{
  input: CustomerNoteV3CreateRequest;
}>;


export type CustomerNoteV3CreateMutation = { CustomerNoteV3Create?: { __typename?: 'CustomerNote', id: string, text: string, createdAt: number, updatedAt: number, channel: { __typename: 'CustomerCreatedMessagingChannel', chatType: ChatType } | { __typename: 'CustomerCreatedSaleChannel', saleChannel: AnyChatSaleChannelType }, user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } } | null };

export type CustomerNoteV3UpdateMutationVariables = Exact<{
  input: CustomerNoteV3UpdateRequest;
}>;


export type CustomerNoteV3UpdateMutation = { CustomerNoteV3Update?: { __typename?: 'CustomerNote', id: string, text: string, updatedAt: number } | null };

export type CustomerNoteV3DeleteMutationVariables = Exact<{
  input: CustomerNoteV3DeleteRequest;
}>;


export type CustomerNoteV3DeleteMutation = { CustomerNoteV3Delete?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type GetCustomerTagsQueryVariables = Exact<{
  input: GetCustomerTagsRequest;
  getCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCustomerTagsQuery = { CustomerTags?: { __typename?: 'CustomerTags', customerTags: Array<{ __typename?: 'CustomerTag', taggedCount: number, name: string }> } | null };

export type GetCustomerTagsV2QueryVariables = Exact<{
  input: GetCustomerTagsRequest;
  getCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCustomerTagsV2Query = { CustomerTags?: { __typename?: 'CustomerTags', customerTags: Array<{ __typename?: 'CustomerTag', taggedCount: number, id: string, name: string, isInfluencerTag: boolean }> } | null };

export type GetStoreSettingQueryVariables = Exact<{
  input: FetchAiAutoReplyStoreSettingInput;
}>;


export type GetStoreSettingQuery = { getStoreSetting?: { __typename?: 'AIAutoReplyStoreSetting', contextConfigId?: string | null, hasAiFooter: boolean } | null };

export type CustomerNotesQueryVariables = Exact<{
  customerGroupId: Scalars['String']['input'];
  channelCustomer?: InputMaybe<ChannelCustomerInput>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
}>;


export type CustomerNotesQuery = { CustomerNotesV3?: Array<{ __typename?: 'CustomerNote', id: string, text: string, createdAt: number, updatedAt: number, channel: { __typename: 'CustomerCreatedMessagingChannel', chatType: ChatType } | { __typename: 'CustomerCreatedSaleChannel', saleChannel: AnyChatSaleChannelType }, user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } }> | null };

export type CustomerActivityV4QueryVariables = Exact<{
  customerGroupId: Scalars['String']['input'];
  channelCustomerFilter?: InputMaybe<ChannelCustomerInput>;
  olderThan?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
}>;


export type CustomerActivityV4Query = { CustomerActivitiesV4?: { __typename?: 'PageResultCustomerActivityV4', total: number, records: Array<{ __typename?: 'CustomerCreatedActivityV4', id: string, timestamp: number, channel: { __typename: 'CustomerCreatedMessagingChannel', chatType: ChatType } | { __typename: 'CustomerCreatedSaleChannel', saleChannel: AnyChatSaleChannelType } } | { __typename?: 'InfluencerJoinedCampaignActivityV4', id: string, timestamp: number, campaignName: string, campaignUrl: string } | { __typename?: 'InfluencerPublishedPostActivityV4', id: string, timestamp: number, campaignName: string, campaignUrl: string } | { __typename?: 'InfluencerSubmittedPostActivityV4', id: string, timestamp: number, campaignName: string, campaignUrl: string } | { __typename?: 'OptInActivityV4', id: string, timestamp: number, title?: string | null, chatType: ChatType, optInOperation: OptInOperation } | { __typename?: 'OrderedActivityV4', id: string, timestamp: number, externalOrderId: string, anyXRelativeUrl?: string | null, saleChannel: AnyChatSaleChannelType } | { __typename?: 'ProfileUpdatedActivityV4', id: string, timestamp: number, user: { __typename: 'BasicUser', id: string, name: string, firstName: string, lastName: string } }> } | null };

export type AddChatTemplateMutationVariables = Exact<{
  input: StoreChatTemplatePlainMessageAddRequest;
}>;


export type AddChatTemplateMutation = { StoreChatTemplatePlainMessageAdd?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type DeleteChatTemplateMutationVariables = Exact<{
  input: StoreChatTemplatePlainMessagesDeleteRequest;
}>;


export type DeleteChatTemplateMutation = { StoreChatTemplatePlainMessageDelete?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type EditChatTemplateMutationVariables = Exact<{
  input: StoreChatTemplatePlainMessageUpdateRequest;
}>;


export type EditChatTemplateMutation = { StoreChatTemplatePlainMessageUpdate?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type AddChatTemplateCategoryMutationVariables = Exact<{
  input: StoreChatTemplatePlainMessageCategoryCreateRequest;
}>;


export type AddChatTemplateCategoryMutation = { StoreChatTemplatePlainMessageCategoryCreate?: { __typename?: 'TemplatePlainMessageCategory', id: string, name: string } | null };

export type EditChatTemplateCategoryMutationVariables = Exact<{
  input: StoreChatTemplatePlainMessageCategoryUpdateRequest;
}>;


export type EditChatTemplateCategoryMutation = { StoreChatTemplatePlainMessageCategoryUpdate?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type DeleteChatTemplateCategoryMutationVariables = Exact<{
  input: StoreChatTemplatePlainMessageCategoryDeleteRequest;
}>;


export type DeleteChatTemplateCategoryMutation = { StoreChatTemplatePlainMessageCategoryDelete?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type MoveChatTemplateCategoryMutationVariables = Exact<{
  input: StoreChatTemplatePlainMessageCategoryMoveRequest;
}>;


export type MoveChatTemplateCategoryMutation = { StoreChatTemplatePlainMessageCategoryMove?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type MoveChatTemplateMutationVariables = Exact<{
  input: StoreChatTemplatePlainMessageMoveRequest;
}>;


export type MoveChatTemplateMutation = { StoreChatTemplatePlainMessageMove?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type GetChatTemplateListQueryVariables = Exact<{
  input: StoreChatTemplatePlainMessagesRequest;
}>;


export type GetChatTemplateListQuery = { StoreChatTemplatePlainMessages?: { __typename?: 'TemplatePlainMessages', total: number, messages: Array<{ __typename?: 'TemplatePlainMessage', id: string, categoryId: string, title: string, plainText: string, createdAt: number }> } | null };

export type GetChatTemplateCategoriesListQueryVariables = Exact<{
  input: StoreChatTemplatePlainMessageCategoriesRequest;
}>;


export type GetChatTemplateCategoriesListQuery = { StoreChatTemplatePlainMessageCategories?: { __typename?: 'TemplatePlainMessageCategories', categories: Array<{ __typename?: 'TemplatePlainMessageCategory', id: string, name: string }> } | null };

export type WhatsappBroadcastFormFragmentFragment = { __typename?: 'WhatsAppBroadcastMessage', status: WhatsAppBroadcastStatus, name: string, id: string, statistics?: { __typename?: 'WhatsAppBroadcastStatistics', deliveredCount: number } | null, recipient: { __typename: 'All' } | { __typename?: 'WhatsAppRecipientCustomerTagName', name: string }, deliveryTiming: { __typename: 'Immediately' } | { __typename?: 'Schedule', datetime: string }, content: { __typename?: 'WhatsAppBroadcastCardContent', initialMessage: string, cards: Array<{ __typename?: 'WhatsAppBroadcastCard', title?: string | null, descriptionText: string, image: string, buttons: Array<{ __typename?: 'WhatsAppBroadcastUrlActionButton', buttonText: string, url: string }> }> } | { __typename?: 'WhatsAppBroadcastTextContent', text: string } };

export type WhatsAppBroadcastCreateMutationVariables = Exact<{
  input: WhatsAppBroadcastCreateRequestInput;
}>;


export type WhatsAppBroadcastCreateMutation = { WhatsAppBroadcastCreate?: string | null };

export type WhatsAppBroadcastUpdateMutationVariables = Exact<{
  input: WhatsAppBroadcastUpdateRequestInput;
}>;


export type WhatsAppBroadcastUpdateMutation = { WhatsAppBroadcastUpdate?: { __typename?: 'WhatsAppBroadcastUpdateResult', hasChanged: boolean, broadcast: { __typename?: 'WhatsAppBroadcastMessage', status: WhatsAppBroadcastStatus, name: string, id: string, statistics?: { __typename?: 'WhatsAppBroadcastStatistics', deliveredCount: number } | null, recipient: { __typename: 'All' } | { __typename?: 'WhatsAppRecipientCustomerTagName', name: string }, deliveryTiming: { __typename: 'Immediately' } | { __typename?: 'Schedule', datetime: string }, content: { __typename?: 'WhatsAppBroadcastCardContent', initialMessage: string, cards: Array<{ __typename?: 'WhatsAppBroadcastCard', title?: string | null, descriptionText: string, image: string, buttons: Array<{ __typename?: 'WhatsAppBroadcastUrlActionButton', buttonText: string, url: string }> }> } | { __typename?: 'WhatsAppBroadcastTextContent', text: string } } } | null };

export type WhatsAppBroadcastDrySubmitMutationVariables = Exact<{
  input: WhatsAppBroadcastUpdateRequestInput;
}>;


export type WhatsAppBroadcastDrySubmitMutation = { WhatsAppBroadcastUpdate?: { __typename?: 'WhatsAppBroadcastUpdateResult', hasChanged: boolean, broadcast: { __typename?: 'WhatsAppBroadcastMessage', status: WhatsAppBroadcastStatus } } | null };

export type WhatsAppBroadcastToDraftMutationVariables = Exact<{
  input: WhatsAppBroadcastToDraftRequest;
}>;


export type WhatsAppBroadcastToDraftMutation = { WhatsAppBroadcastToDraft?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type WhatsAppBroadcastTableQueryVariables = Exact<{
  input: GetWhatsAppBroadcastMessagesRequest;
}>;


export type WhatsAppBroadcastTableQuery = { WhatsAppBroadcastMessages?: { __typename?: 'WhatsAppBroadcastMessages', total: number, messages: Array<{ __typename?: 'WhatsAppBroadcastMessage', name: string, imageUrl?: string | null, id: string, status: WhatsAppBroadcastStatus, createdAt: string, deliveredAt?: string | null, recipient: { __typename: 'All' } | { __typename?: 'WhatsAppRecipientCustomerTagName', name: string }, deliveryTiming: { __typename: 'Immediately' } | { __typename?: 'Schedule', datetime: string }, statistics?: { __typename?: 'WhatsAppBroadcastStatistics', clickCount: number, clickRate: number, openCount: number, openRate: number, deliveredCount: number } | null }> } | null };

export type WhatsAppBroadcastTrendQueryVariables = Exact<{
  input: GetWhatsAppBroadcastMessageStatSummaryRequest;
}>;


export type WhatsAppBroadcastTrendQuery = { WhatsAppBroadcastStatisticSummaries?: { __typename?: 'WhatsAppBroadcastStatisticSummaries', sumStatistics: { __typename?: 'WhatsAppBroadcastStatistics', clickRate: number, openRate: number, deliveredCount: number }, compareStatistics?: { __typename?: 'WhatsAppBroadcastStatistics', openRate: number, clickRate: number, deliveredCount: number } | null } | null };

export type WhatsAppBroadcastMessageQueryVariables = Exact<{
  input: GetSingleWhatsAppBroadcastMessageRequest;
}>;


export type WhatsAppBroadcastMessageQuery = { WhatsAppBroadcastMessage?: { __typename?: 'WhatsAppBroadcastMessage', status: WhatsAppBroadcastStatus, name: string, id: string, statistics?: { __typename?: 'WhatsAppBroadcastStatistics', deliveredCount: number } | null, recipient: { __typename: 'All' } | { __typename?: 'WhatsAppRecipientCustomerTagName', name: string }, deliveryTiming: { __typename: 'Immediately' } | { __typename?: 'Schedule', datetime: string }, content: { __typename?: 'WhatsAppBroadcastCardContent', initialMessage: string, cards: Array<{ __typename?: 'WhatsAppBroadcastCard', title?: string | null, descriptionText: string, image: string, buttons: Array<{ __typename?: 'WhatsAppBroadcastUrlActionButton', buttonText: string, url: string }> }> } | { __typename?: 'WhatsAppBroadcastTextContent', text: string } } | null };

export type WhatsAppBroadcastEstimateRecipientsQueryVariables = Exact<{
  input: GetWhatsAppEstimateRecipientRequest;
}>;


export type WhatsAppBroadcastEstimateRecipientsQuery = { WhatsAppBroadcastEstimateRecipients?: { __typename?: 'EstimateRecipient', estimateCount: number } | null };

export type SaleChannelData_AmazonSaleChannelData_Fragment = { __typename?: 'AmazonSaleChannelData', amazonMarketplace: AmazonSellerCentralMarketplace };

export type SaleChannelData_EmptySaleChannelData_Fragment = { __typename?: 'EmptySaleChannelData' };

export type SaleChannelData_LazadaSaleChannelData_Fragment = { __typename?: 'LazadaSaleChannelData', lazadaMarketplace: LazadaMarketplace };

export type SaleChannelData_MomoSaleChannelData_Fragment = { __typename?: 'MomoSaleChannelData' };

export type SaleChannelData_Qoo10SaleChannelData_Fragment = { __typename?: 'Qoo10SaleChannelData', qoo10Marketplace: Qoo10Marketplace };

export type SaleChannelData_RakutenSaleChannelData_Fragment = { __typename?: 'RakutenSaleChannelData' };

export type SaleChannelData_ShopeeSaleChannelData_Fragment = { __typename?: 'ShopeeSaleChannelData', shopeeMarketplace: ShopeeMarketplace };

export type SaleChannelData_ShopifySaleChannelData_Fragment = { __typename?: 'ShopifySaleChannelData' };

export type SaleChannelData_TikTokSaleChannelData_Fragment = { __typename?: 'TikTokSaleChannelData', tiktokMarketplace: TikTokRegion };

export type SaleChannelData_TokopediaSaleChannelData_Fragment = { __typename?: 'TokopediaSaleChannelData' };

export type SaleChannelData_YahooSaleChannelData_Fragment = { __typename?: 'YahooSaleChannelData' };

export type SaleChannelDataFragment = SaleChannelData_AmazonSaleChannelData_Fragment | SaleChannelData_EmptySaleChannelData_Fragment | SaleChannelData_LazadaSaleChannelData_Fragment | SaleChannelData_MomoSaleChannelData_Fragment | SaleChannelData_Qoo10SaleChannelData_Fragment | SaleChannelData_RakutenSaleChannelData_Fragment | SaleChannelData_ShopeeSaleChannelData_Fragment | SaleChannelData_ShopifySaleChannelData_Fragment | SaleChannelData_TikTokSaleChannelData_Fragment | SaleChannelData_TokopediaSaleChannelData_Fragment | SaleChannelData_YahooSaleChannelData_Fragment;

export type AccountPageCreateAccountMutationVariables = Exact<{
  input: MdCreateAccountInput;
}>;


export type AccountPageCreateAccountMutation = { MdCreateAccount: { __typename?: 'MdAccount', id: string } };

export type AccountPageUpdateAccountMutationVariables = Exact<{
  input: MdUpdateAccountInput;
}>;


export type AccountPageUpdateAccountMutation = { MdUpdateAccount: { __typename?: 'MdAccount', id: string } };

export type AccountPageGetAccountQueryVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type AccountPageGetAccountQuery = { MdAccount: { __typename?: 'MdAccount', address1?: string | null, address2?: string | null, cityName?: string | null, countryId: string, createdAt: string, hubspotCustomerId?: string | null, id: string, name: string, netsuiteVendorId?: string | null, phoneNumber: string, phoneNumberCountryId: string, product: MdAccountProduct, provinceId?: string | null, status: MdAccountStatus, updatedAt: string, websiteUrl?: string | null, zipcode?: string | null } };

export type AccountListPagesQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<MdAccountFilterInput>;
  sortBy?: InputMaybe<MdAccountSortByInput>;
}>;


export type AccountListPagesQuery = { MdAccounts: { __typename?: 'MdAccounts', total: number, start: number, limit: number, length: number, items: Array<{ __typename?: 'MdAccount', name: string, id: string, websiteUrl?: string | null, zipcode?: string | null, status: MdAccountStatus, countryId: string, createdAt: string }> } };

export type AccountsCountryListQueryVariables = Exact<{
  filter?: InputMaybe<MdAccountFilterInput>;
}>;


export type AccountsCountryListQuery = { MdCountriesUsedByAccounts: Array<{ __typename?: 'MdCountry', id: string, name: string }> };

export type FacebookExchangeCodeMutationVariables = Exact<{
  redirectUri: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type FacebookExchangeCodeMutation = { facebookExchangeCode: { __typename?: 'FacebookExchangeCodePayload', datasourceTokenId: string } };

export type GoogleExchangeCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  type: GoogleLoginUrlType;
}>;


export type GoogleExchangeCodeMutation = { googleExchangeCode: { __typename?: 'GoogleExchangeCodePayload', datasourceTokenId: string } };

export type TikTokAdsExchangeCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type TikTokAdsExchangeCodeMutation = { tikTokAdsExchangeCode: { __typename?: 'TikTokExchangeCodePayload', datasourceTokenId: string } };

export type YahooAdsExchangeCodeMutationVariables = Exact<{
  input: YahooAdsExchangeCodeInput;
}>;


export type YahooAdsExchangeCodeMutation = { yahooAdsExchangeCode: { __typename?: 'YahooAdsDatasourceTokenPayload', datasourceTokenId: string } };

export type ShopifyLoginUrlV2QueryVariables = Exact<{
  input: ShopifyLoginUrlV2Input;
}>;


export type ShopifyLoginUrlV2Query = { shopifyLoginUrlV2: string };

export type StoreIntegrationsDetailQueryVariables = Exact<{
  mdStoreId: Scalars['Long']['input'];
}>;


export type StoreIntegrationsDetailQuery = { MdStore: { __typename?: 'MdStore', id: string, name: string, isInventoryChannelsSupported: boolean, account?: { __typename?: 'MdAccount', id: string, name: string } | null, channels: Array<{ __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType, isActive: boolean, logisticChannelFormStatus?: ChannelFormStatus | null, logisticChannel?: { __typename?: 'LogisticChannel', id: string, wmsType: WmsType, status?: LogisticChannelStatus | null } | null, fileUploadStatus: { __typename?: 'FileUploadStatus', lastUploadedAt?: string | null, warning?: FileUploadWarning | null }, costIndex?: { __typename?: 'SaleChannelCostIndexQueryPayload', saleChannelId: string } | null, data: { __typename?: 'AmazonSaleChannelData', amazonMarketplace: AmazonSellerCentralMarketplace } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData', showReconnectButton: boolean, refreshTokenExpirationDate: string, lazadaMarketplace: LazadaMarketplace } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData', qoo10Marketplace: Qoo10Marketplace } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData', showReconnectButton: boolean, expiresAt: string, shopeeMarketplace: ShopeeMarketplace } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData', tiktokMarketplace: TikTokRegion } | { __typename?: 'TokopediaSaleChannelData', isPending: boolean, linkedTikTokSaleChannelId?: string | null } | { __typename?: 'YahooSaleChannelData', refreshTokenExpirationDate: string, showReconnectButton: boolean } }>, shopeeAffiliateAuthorizations: Array<{ __typename?: 'ShopeeAffiliateAuthorization', id: string, isActive: boolean, data: { __typename?: 'ShopeeSaleChannelData', showReconnectButton: boolean, expiresAt: string, shopeeMarketplace: ShopeeMarketplace } }>, inventoryChannels: Array<{ __typename?: 'InventoryChannel', id: string, type: InventoryChannelType, isActive: boolean, isManual: boolean }> } };

export type StorePageDeleteStoreMutationVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type StorePageDeleteStoreMutation = { MdDeleteStore: string };

export type StorePageUpdateStoreMutationVariables = Exact<{
  input: MdUpdateStoreInput;
  crmInput: AnyChatStoreCrmConfigUpdateRequest;
  allowCrmUpdate: Scalars['Boolean']['input'];
}>;


export type StorePageUpdateStoreMutation = { AnyChatStoreCrmConfigUpdate?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null, MdUpdateStore?: { __typename?: 'MdStore', id: string, name: string } };

export type StorePageUpdateStoreMomoEntpCodeMutationVariables = Exact<{
  input: MomoSaleChannelEntpCodeSetInput;
}>;


export type StorePageUpdateStoreMomoEntpCodeMutation = { momoSaleChannelEntpCodeSet: string };

export type StorePageUpdateStoreSettingCountryOfOriginMutationVariables = Exact<{
  storeId: Scalars['Long']['input'];
  countryOfOrigin?: InputMaybe<Scalars['String']['input']>;
}>;


export type StorePageUpdateStoreSettingCountryOfOriginMutation = { storeSettingCountryOfOrigin: { __typename?: 'StoreSettingCountryOfOriginUpdateOutput', ok: boolean } };

export type StoreEditPageStoreDetailsQueryVariables = Exact<{
  mdStoreId: Scalars['Long']['input'];
}>;


export type StoreEditPageStoreDetailsQuery = { MdStore: { __typename?: 'MdStore', id: string, name: string, countryId: string, zipcode?: string | null, provinceId?: string | null, cityName?: string | null, address1?: string | null, address2?: string | null, defaultCourierType?: CourierType | null, phoneNumberCountryId: string, phoneNumber: string, category: MdStoreCategory, account?: { __typename?: 'MdAccount', id: string, name: string } | null, storeSetting: { __typename?: 'StoreSetting', countryOfOrigin?: ShopifySupportedCountry | null }, channels: Array<{ __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType, isActive: boolean, data: { __typename?: 'AmazonSaleChannelData' } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData' } | { __typename?: 'MomoSaleChannelData', entpCode?: string | null } | { __typename?: 'Qoo10SaleChannelData' } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData' } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData' } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' } }>, crmStore?: { __typename?: 'AnyChatStore', crmType: CrmType, draftReplyEnabled: boolean, unrepliedLineNotificationEnabled: boolean, slackChannelId?: string | null } | null } };

export type AddStoreModalMutationVariables = Exact<{
  input: MdCreateStoreInput;
}>;


export type AddStoreModalMutation = { MdCreateStore: { __typename?: 'MdStore', id: string, name: string } };

export type StoreListPageQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<StoreWithChanelFilterInput>;
}>;


export type StoreListPageQuery = { storesWithChannel: { __typename?: 'StoreList', length: number, limit: number, start: number, total: number, items: Array<{ __typename?: 'MdStore', id: string, name: string, createdAt: string, account?: { __typename?: 'MdAccount', name: string, id: string } | null, channels: Array<{ __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType, isActive: boolean, data: { __typename?: 'AmazonSaleChannelData', amazonMarketplace: AmazonSellerCentralMarketplace } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData', lazadaMarketplace: LazadaMarketplace } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData', qoo10Marketplace: Qoo10Marketplace } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData', shopeeMarketplace: ShopeeMarketplace } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData', tiktokMarketplace: TikTokRegion } | { __typename?: 'TokopediaSaleChannelData', isPending: boolean } | { __typename?: 'YahooSaleChannelData' } }> }> } };

export type UserModalDeleteUsersMutationVariables = Exact<{
  userIds: Array<Scalars['Long']['input']> | Scalars['Long']['input'];
}>;


export type UserModalDeleteUsersMutation = { MdDeleteUsers: Array<string> };

export type MinimalMdStoresQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<MdStoreFilterInput>;
  sortBy?: InputMaybe<MdStoreSortByInput>;
}>;


export type MinimalMdStoresQuery = { MdStores: { __typename?: 'MdStores', length: number, limit: number, start: number, total: number, items: Array<{ __typename?: 'MdStore', id: string, name: string, account?: { __typename?: 'MdAccount', name: string, id: string } | null }> } };

export type UserAddPageCreateUserMutationVariables = Exact<{
  input: MdCreateUserInput;
}>;


export type UserAddPageCreateUserMutation = { MdCreateUser: { __typename?: 'MdUser', id: string, createdAt: string } };

export type UserEditPageUpdateUserMutationVariables = Exact<{
  input: MdUpdateUserInput;
}>;


export type UserEditPageUpdateUserMutation = { MdUpdateUser: { __typename?: 'MdUser', id: string } };

export type UserEditPageGetUserQueryVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type UserEditPageGetUserQuery = { MdUser: { __typename?: 'MdUser', accessAllStores: boolean, accountIds: Array<string>, canManageUsers: boolean, availableModules: Array<MdAnyXModuleEnum>, email: string, firstName: string, lastName?: string | null, id: string, role: MdUserRole, language: UserLanguage, currency: Currency, timezoneId: string, accounts: Array<{ __typename?: 'MdAccount', id: string, name: string }>, stores: Array<{ __typename?: 'MdStore', name: string, id: string, account?: { __typename?: 'MdAccount', id: string, name: string } | null }> } };

export type UserListResendInvitationMutationVariables = Exact<{
  input: MdSendVerificationEmailInput;
}>;


export type UserListResendInvitationMutation = { MdSendVerificationEmail: { __typename?: 'MdSendVerificationEmailPayload', ok: boolean } };

export type UserListGetUsersQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<MdUserFilterInput>;
  sortBy?: InputMaybe<MdUserSortByInput>;
}>;


export type UserListGetUsersQuery = { MdUsers: { __typename?: 'MdUsers', length: number, limit: number, start: number, total: number, items: Array<{ __typename?: 'MdUser', id: string, email: string, firstName: string, lastName?: string | null, createdAt: string, role: MdUserRole, status: MdUserStatus, accounts: Array<{ __typename?: 'MdAccount', name: string, id: string }> }> } };

export type ProductVariantsForAddInboundQueryVariables = Exact<{
  filter: ProductVariantForAddInboundFilterInput;
  pageNumber: Scalars['Int']['input'];
}>;


export type ProductVariantsForAddInboundQuery = { productVariantsForAddInbound: { __typename?: 'ProductVariantForAddInboundView', total: number, page: number, productVariants: Array<{ __typename?: 'ProductVariantForAddInboundRecord', warehouseCode?: string | null, variantName: string, productVariantId: string, productName: string, productCode: string, media?: string | null }> } };

export type CreateInboundMutationVariables = Exact<{
  storeId: Scalars['Long']['input'];
  supplierId: Scalars['ID']['input'];
  inboundDate: Scalars['Time']['input'];
  comment: Scalars['String']['input'];
  products: Array<InboundSku> | InboundSku;
}>;


export type CreateInboundMutation = { createInbound?: { __typename?: 'InboundIds', id: string, inboundId: string } | null };

export type UpdateInboundMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
  inboundDate: Scalars['Time']['input'];
  comment: Scalars['String']['input'];
  products: Array<InboundSku> | InboundSku;
}>;


export type UpdateInboundMutation = { updateInbound: { __typename?: 'StatusOk', ok: boolean } };

export type GetInboundQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInboundQuery = { getInbound: { __typename?: 'InboundDetailed', id: string, inboundId: string, status: InboundStatus, inboundDate: any, comment: string, created: any, quantity: number, inspectedQuantity?: number | null, deliveryDestination?: string | null, mdAccount?: { __typename?: 'MdAccount', id: string, name: string } | null, mdStore?: { __typename?: 'MdStore', id: string, name: string } | null, supplier: { __typename?: 'Supplier', id: string, name: string }, products: Array<{ __typename?: 'InboundProductDetailed', name: string, image: string, gtin: string, code: string, quantity: number, inspectedQuantity?: number | null }>, deliveryAddress?: { __typename?: 'Address', country: Country, provinceId: string, city: string, postalCode: string, addressFirst: string, addressSecond: string } | null, deliveryPhoneNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: Country } | null } };

export type GetInboundPdfQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  language: Language;
}>;


export type GetInboundPdfQuery = { getInboundPdf: { __typename?: 'Document', filepath: string } };

export type CancelInboundsMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  selectAll?: InputMaybe<Scalars['Boolean']['input']>;
  filters: InboundFilters;
}>;


export type CancelInboundsMutation = { cancelInbounds: { __typename?: 'BulkOperationResponse', failed: number, succeeded: number } };

export type GetInboundPdfsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  language: Language;
}>;


export type GetInboundPdfsQuery = { getInboundPdfs: { __typename?: 'Document', filepath: string } };

export type UploadInboundsWithCsvMutationVariables = Exact<{
  csvUrl: Scalars['String']['input'];
  storeId?: InputMaybe<Scalars['Long']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UploadInboundsWithCsvMutation = { uploadInboundsWithCsv: { __typename?: 'StatusOk', ok: boolean } };

export type GetInboundsQueryVariables = Exact<{
  filters: InboundFilters;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetInboundsQuery = { getInbounds: { __typename?: 'InboundsPaginated', total: number, page: number, records: Array<{ __typename?: 'Inbound', id: string, inboundId: string, image: string, productCount: number, status: InboundStatus, inboundDate: any, deliveryDestination?: string | null, quantity: number, inspectedQuantity?: number | null, created: any, mdAccount?: { __typename?: 'MdAccount', id: string, name: string } | null, mdStore?: { __typename?: 'MdStore', id: string, name: string } | null, supplier: { __typename?: 'Supplier', id: string, name: string } }> } };

export type GetInboundsOverviewQueryVariables = Exact<{
  filters: InboundFilters;
}>;


export type GetInboundsOverviewQuery = { getInboundsOverview: { __typename?: 'InboundOverview', all: number, reviewing: number, completed: number, warehousing: number } };

export type GetInventoriesCsvQueryVariables = Exact<{
  input: InventoryExportCsvInput;
}>;


export type GetInventoriesCsvQuery = { inventoryExportCsv: { __typename?: 'InventoryExportCsvResult', fileUrl: string } };

export type GetInventoriesOverviewQueryVariables = Exact<{
  input: InventoryOverviewQueryInput;
}>;


export type GetInventoriesOverviewQuery = { inventoryOverview: { __typename?: 'InventoryOverviewOutput', allCount: number, arrivingCount: number, allocatingCount: number, damagedCount: number, warehousingCount: number, freeCount: number, preparingCount: number, outOfStockCount: number } };

export type GetInventoriesQueryVariables = Exact<{
  input: InventoryListQueryInput;
}>;


export type GetInventoriesQuery = { inventoryListView: { __typename?: 'InventoryListView', page: number, total: number, items: Array<{ __typename?: 'InventoryRecord', allocating?: number | null, arriving?: number | null, content: string, damaged?: number | null, free?: number | null, media?: string | null, preparing?: number | null, productCode: string, productId: string, productName: string, productType: ProductType, productVariantId: string, warehousing?: number | null, store: { __typename?: 'MdStore', id: string, name: string, account?: { __typename?: 'MdAccount', id: string, name: string } | null } }> } };

export type GetSupplierQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSupplierQuery = { getSupplier: { __typename?: 'SupplierDetailed', id: string, name: string, country?: Country | null, postalCode?: string | null, provinceId?: string | null, city?: string | null, addressFirst?: string | null, addressSecond?: string | null, supportEmail?: string | null, mdAccount?: { __typename?: 'MdAccount', id: string, name: string } | null, phoneNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: Country } | null } };

export type UpdateSupplierMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country>;
  addressFirst?: InputMaybe<Scalars['String']['input']>;
  addressSecond?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<PhoneNumberInput>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSupplierMutation = { updateSupplier: { __typename?: 'StatusOk', ok: boolean } };

export type GetSuppliersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filters: SupplierFilters;
}>;


export type GetSuppliersQuery = { getSuppliers: { __typename?: 'SuppliersPaginated', total: number, page: number, records: Array<{ __typename?: 'Supplier', id: string, name: string, users: number, country?: Country | null, created: any, mdAccount?: { __typename?: 'MdAccount', id: string, name: string } | null }> } };

export type CreateWarehouseMutationVariables = Exact<{
  name: Scalars['String']['input'];
  vendor: Wms;
  wmsWarehouseId: Scalars['String']['input'];
  deliveryDestination: Scalars['String']['input'];
  countryCode: Country;
  addressFirst: Scalars['String']['input'];
  addressSecond?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: PhoneNumberInput;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateWarehouseMutation = { createWarehouse: { __typename?: 'Id', id: string } };

export type UpdateWarehouseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  deliveryDestination: Scalars['String']['input'];
  countryCode: Country;
  addressFirst: Scalars['String']['input'];
  addressSecond?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: PhoneNumberInput;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateWarehouseMutation = { updateWarehouse: { __typename?: 'StatusOk', ok: boolean } };

export type GetWarehouseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWarehouseQuery = { getWarehouse: { __typename?: 'WarehouseDetailed', id: string, name: string, wms: Wms, wmsWarehouseId: string, deliveryDestination: string, postalCode?: string | null, provinceId?: string | null, country: Country, city?: string | null, addressFirst: string, addressSecond?: string | null, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: Country } } };

export type GetWarehousesQueryVariables = Exact<{
  filters: WarehouseFilters;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetWarehousesQuery = { getWarehouses: { __typename?: 'WarehousesPaginated', total: number, page: number, records: Array<{ __typename?: 'Warehouse', id: string, name: string, wms: Wms, wmsWarehouseId: string, country: Country, created: any }> } };

export type OrderListCancelOrderMutationVariables = Exact<{
  input: CancelOrderInput;
}>;


export type OrderListCancelOrderMutation = { orderCancel: { __typename?: 'CancelOrderPayload', successOrderIds: Array<string>, failureOrderIds: Array<{ __typename?: 'FailureCancelOrder', orderId: string, reason: string }> } };

export type ManualSaleChannelsByStoreIdQueryVariables = Exact<{
  storeId: Scalars['Long']['input'];
}>;


export type ManualSaleChannelsByStoreIdQuery = { manualSaleChannelsByStoreId: Array<{ __typename?: 'SaleChannelForManualOrder', saleChannelType: MarketplaceSaleChannelType, saleChannelId?: string | null, hasAnyLogiConnection: boolean }> };

export type MdStoreAdvancedLogisticsQueryVariables = Exact<{
  mdStoreId: Scalars['Long']['input'];
}>;


export type MdStoreAdvancedLogisticsQuery = { MdStore: { __typename?: 'MdStore', id: string, name: string, defaultCourierType?: CourierType | null } };

export type ProductVariantForOrderAddProductV2QueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  input: ProductVariantForOrderAddProductInput;
}>;


export type ProductVariantForOrderAddProductV2Query = { productVariantForOrderAddProductV2: { __typename?: 'ProductVariantForOrderAddProductView', total: number, productVariants: Array<{ __typename?: 'ProductVariantForOrderAddProductRecord', productName: string, variantName: string, productCode: string, media?: string | null, type: ProductType, freeStock?: number | null, priceV2: { __typename?: 'Money', amount: string, currency: CurrencyCode } }> } };

export type GetCourierServiceListQueryVariables = Exact<{
  storeId: Scalars['Long']['input'];
  paymentMethodV2?: InputMaybe<PaymentMethodV2>;
}>;


export type GetCourierServiceListQuery = { courierServiceList: Array<CourierService> };

export type GetCourierServiceDetailQueryVariables = Exact<{
  courierService: CourierService;
  storeId: Scalars['Long']['input'];
}>;


export type GetCourierServiceDetailQuery = { courierServiceDetailV2: { __typename?: 'CourierServiceDetail', paymentMethodsV2: Array<PaymentMethodV2>, preferredDeliveryTimeFrames: Array<PreferredDeliveryTime> } };

export type PaymentMethodsQueryVariables = Exact<{
  filter: PaymentMethodFilterInput;
}>;


export type PaymentMethodsQuery = { paymentMethodsV2: { __typename?: 'PaymentMethodsPayload', paymentMethodsV2: Array<PaymentMethodV2> } };

export type OrderPageCreateOrderMutationVariables = Exact<{
  input: CreateManualOrderInput;
}>;


export type OrderPageCreateOrderMutation = { orderManualCreate: string };

export type OrderCreationStoreInformationQueryVariables = Exact<{
  mdStoreId: Scalars['Long']['input'];
}>;


export type OrderCreationStoreInformationQuery = { MdStore: { __typename?: 'MdStore', id: string, defaultCourierType?: CourierType | null } };

export type ConfirmValidJapanAddressMutationVariables = Exact<{
  input: ConfirmValidJapanOrderAddressInput;
}>;


export type ConfirmValidJapanAddressMutation = { confirmValidJapanAddress: { __typename?: 'ConfirmValidJapanOrderAddressPayload', ok: boolean } };

export type IgnoreOrderValidationMutationVariables = Exact<{
  orderId: Scalars['Long']['input'];
}>;


export type IgnoreOrderValidationMutation = { orderIgnoreAddressValidationError: { __typename?: 'OrderIgnoreAddressValidationErrorPayload', ok: boolean } };

export type OrderManualUpdateV2MutationVariables = Exact<{
  input: UpdateManualOrderV2Input;
}>;


export type OrderManualUpdateV2Mutation = { orderManualUpdateV2: string };

export type OrderManualUpdateWithLogiMutationVariables = Exact<{
  input: UpdateManualOrderWithLogiInput;
}>;


export type OrderManualUpdateWithLogiMutation = { orderManualUpdateWithLogi: string };

export type GetAwbFileQueryVariables = Exact<{
  orderId: Scalars['Long']['input'];
}>;


export type GetAwbFileQuery = { awbFile: string };

export type GetValidJapanAddressesQueryVariables = Exact<{
  orderId: Scalars['Long']['input'];
}>;


export type GetValidJapanAddressesQuery = { getValidJapanAddresses: { __typename?: 'ValidJapanOrderAddressPayload', addressList: Array<{ __typename?: 'ValidJapanOrderAddress', addressLine1?: string | null, cityName: string, id: number, isEditable: boolean, provinceName: string }> } };

export type OrderPageGetOrderQueryVariables = Exact<{
  orderId: Scalars['Long']['input'];
}>;


export type OrderPageGetOrderQuery = { order: { __typename?: 'OrderDetail', id: string, hasAwb: boolean, sellerChannelOrderId: string, discount?: string | null, deliveryStatus: DeliveryStatus, createdDate: string, cancelledDate?: string | null, currency: string, paymentMethod: PaymentMethodV2, shipping?: string | null, subtotal?: string | null, totalTax?: string | null, total?: string | null, note: string, shippingDate?: string | null, saleChannelSpecific?: { __typename?: 'LazadaSpecificData' } | { __typename?: 'ManualsSpecificData', editable: boolean } | { __typename?: 'ShopifySpecificData', orderUrl: string, tags: Array<string>, currency?: OrderCheckoutCurrency | null, discount?: string | null, isShowCheckoutCurrency: boolean, shipping?: string | null, subtotal?: string | null, total?: string | null, totalTax?: string | null } | null, billingAddress?: { __typename?: 'OrderAddress', email: string, country?: string | null, company?: string | null, cityName: string, address2?: string | null, address1: string, phoneNumber: string, phoneNumberCountry: string, province: string, zipcode: string, name: { __typename?: 'Name', last: string, first: string } } | null, orderProducts: Array<{ __typename?: 'OrderProduct', externalId: string, media?: string | null, name: string, price: string, quantity: number, sellerSku?: string | null, amount: string, productCode?: string | null, fulfillable: boolean, logistics?: { __typename?: 'ReadOrderProductLogistics', deliveryStatus?: OrderProductDeliveryStatus | null, unknown: boolean } | null, saleChannelSpecificProductData?: { __typename?: 'ShopifySpecificProductData', amount: string, price: string } | null }>, shippingAddress?: { __typename?: 'OrderAddress', phoneNumber: string, country?: string | null, company?: string | null, cityName: string, address2?: string | null, address1: string, phoneNumberCountry: string, province: string, zipcode: string, email: string, name: { __typename?: 'Name', last: string, first: string } } | null, saleChannel: { __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType, data: { __typename?: 'AmazonSaleChannelData', amazonMarketplace: AmazonSellerCentralMarketplace } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData', lazadaMarketplace: LazadaMarketplace } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData', qoo10Marketplace: Qoo10Marketplace } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData', shopeeMarketplace: ShopeeMarketplace } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData', tiktokMarketplace: TikTokRegion } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' }, store: { __typename?: 'MdStore', id: string, name: string, account?: { __typename?: 'MdAccount', id: string, name: string } | null } }, orderLogistics?: { __typename?: 'OrderLogistics', anylogiId: string, codFee?: string | null, courierService: CourierService, deliveryNote: string, desiredDeliveryDate?: any | null, desiredDeliveryTime: PreferredDeliveryTime, temperature: OrderTemperature, trackingNumber?: string | null, trackingURL?: string | null, shippingAddressValidationResult: ShippingAddressValidationResult } | null, customer?: { __typename?: 'ReadOrderCustomer', email?: string | null, phoneNumber: string, phoneNumberCountry?: ShopifySupportedCountry | null, name: { __typename?: 'Name', first: string, last: string } } | null } };

export type RegisterManualOrderCsvUploadV2MutationVariables = Exact<{
  fileUri: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
  manualOrderUploadType: ManualOrderUploadType;
}>;


export type RegisterManualOrderCsvUploadV2Mutation = { registerManualOrderCsvUploadV2: { __typename?: 'RegisterManualOrderCsvUploadPayload', ok: boolean } };

export type OrderListCsvImportQueryVariables = Exact<{
  fileName: Scalars['String']['input'];
}>;


export type OrderListCsvImportQuery = { orderCSVUpload: { __typename?: 'UploadFilePayload', fileName: string, fileUri: string, signedUrl: string } };

export type OrderListInvalidOrdersQueryVariables = Exact<{
  filter: OrderListFilterInput;
  pageNumber: Scalars['Int']['input'];
}>;


export type OrderListInvalidOrdersQuery = { orderListView: { __typename?: 'OrderListView', total: number } };

export type OrderListOverviewQueryVariables = Exact<{
  filter: OrderListFilterInput;
}>;


export type OrderListOverviewQuery = { orderOverviewV2: { __typename?: 'OrderOverview', deliveryStatuses: Array<DeliveryStatus>, all: number, allocating: number, cancelled: number, paying: number, pending: number, preparing: number, shipped: number, working: number } };

export type OrderListCsvExportQueryVariables = Exact<{
  input: OrderCsvExportV2Input;
}>;


export type OrderListCsvExportQuery = { orderCSVExportV3: { __typename?: 'OrderCSVExportV3Output', documentId: string } };

export type OrderOnboardingQueryVariables = Exact<{
  storeId: Scalars['Long']['input'];
}>;


export type OrderOnboardingQuery = { orderOnboarding: OrderOnboardingStatus };

export type OrdersListPagesQueryVariables = Exact<{
  filter: OrderListFilterInput;
  pageNumber: Scalars['Int']['input'];
}>;


export type OrdersListPagesQuery = { orderListView: { __typename?: 'OrderListView', end: number, page: number, start: number, total: number, totalPage: number, items: Array<{ __typename?: 'OrderRecord', id: string, externalOrderId: string, cancelable: boolean, createdAt: string, currency: CurrencyCode, deliveryStatus: DeliveryStatus, itemCount: number, media?: string | null, paymentMethod: PaymentMethodV2, shippedAt?: string | null, total: string, customerName?: { __typename?: 'Name', first: string, last: string } | null, logistics?: { __typename?: 'OrderLogisticsForList', anylogiId: string, shippingAddressValidationResult: ShippingAddressValidationResult, courierService: CourierService, warehouse?: { __typename?: 'AnyXWarehouse', id: string, name: string } | null } | null, saleChannel: { __typename?: 'SaleChannel', type: MarketplaceSaleChannelType, data: { __typename?: 'AmazonSaleChannelData', amazonMarketplace: AmazonSellerCentralMarketplace } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData', lazadaMarketplace: LazadaMarketplace } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData', qoo10Marketplace: Qoo10Marketplace } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData', shopeeMarketplace: ShopeeMarketplace } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData', tiktokMarketplace: TikTokRegion } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' }, store: { __typename?: 'MdStore', id: string, name: string, account?: { __typename?: 'MdAccount', id: string, name: string } | null } } }> } };

export type ArchiveProductVariantsMutationVariables = Exact<{
  productVariantIds: Array<Scalars['Long']['input']> | Scalars['Long']['input'];
}>;


export type ArchiveProductVariantsMutation = { archiveProductVariants: { __typename?: 'ArchiveProductVariantsOutput', ok: boolean } };

export type DisableProductVariantsInventorySyncMutationVariables = Exact<{
  input: BulkInventorySyncInput;
}>;


export type DisableProductVariantsInventorySyncMutation = { disableProductVariantsInventorySync: { __typename?: 'DisableInventorySyncOutput', ok: boolean } };

export type EnableProductVariantsInventorySyncMutationVariables = Exact<{
  input: BulkInventorySyncInput;
}>;


export type EnableProductVariantsInventorySyncMutation = { enableProductVariantsInventorySync: { __typename?: 'EnableInventorySyncOutput', ok: boolean, forceSyncWarning?: string | null } };

export type UnarchiveProductVariantMutationVariables = Exact<{
  productVariantIds: Array<Scalars['Long']['input']> | Scalars['Long']['input'];
}>;


export type UnarchiveProductVariantMutation = { unarchiveProductVariants: { __typename?: 'UnarchiveProductVariantsOutput', ok: boolean } };

export type ProductPageCreateProductMutationVariables = Exact<{
  input: CreateProductV2Input;
}>;


export type ProductPageCreateProductMutation = { productCreateV2: string };

export type UpdateDdiProductStatusMutationVariables = Exact<{
  input: SaveDdiProductStatusListInput;
}>;


export type UpdateDdiProductStatusMutation = { saveDdiProductStatus: { __typename?: 'OperationResultPayload', success: boolean } };

export type DdiProductsBulkPageQueryVariables = Exact<{
  input: DdiProductStatusInput;
}>;


export type DdiProductsBulkPageQuery = { ddiProductStatus: { __typename?: 'DdiProductStatusPayloadList', products: Array<{ __typename?: 'DdiProductStatusPayload', imageUrl?: string | null, isListed: boolean, productCode?: string | null, productName?: string | null, productVariantId: string, productVariantName?: string | null, warehouseData: Array<{ __typename?: 'DdiProductWarehouseStatusPayload', isActive: boolean, segment: DdiProductSegment, warehouse: DdiWarehouse }> }> } };

export type ProductVariantsMergeV3MutationVariables = Exact<{
  input: MergeProductVariantV3Input;
}>;


export type ProductVariantsMergeV3Mutation = { productVariantsMergeV3: { __typename?: 'MergeProductVariantV3Output', ok: boolean } };

export type ProductVariantForMergeSelectorQueryVariables = Exact<{
  filter: ProductVariantForMergeFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type ProductVariantForMergeSelectorQuery = { productVariantsForProductMerge: { __typename?: 'ProductVariantForMergeView', total: number, productVariants: Array<{ __typename?: 'ProductVariantForMergeRecord', variantName: string, productName: string, productCode: string, media?: string | null, inUseReasons: Array<ProductVariantInUseReason>, saleChannels: Array<{ __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType, data: { __typename?: 'AmazonSaleChannelData', amazonMarketplace: AmazonSellerCentralMarketplace } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData', lazadaMarketplace: LazadaMarketplace } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData', qoo10Marketplace: Qoo10Marketplace } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData', shopeeMarketplace: ShopeeMarketplace } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData', tiktokMarketplace: TikTokRegion } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' } }> }> } };

export type UpdateProductWithMultiVariantsMutationVariables = Exact<{
  input: UpdateProductWithMultiVariantsInput;
}>;


export type UpdateProductWithMultiVariantsMutation = { productUpdateWithMultiVariants: string };

export type UpdateProductWithSingleVariantMutationVariables = Exact<{
  input: UpdateProductWithSingleVariantInput;
}>;


export type UpdateProductWithSingleVariantMutation = { productUpdateWithSingleVariant: string };

export type ProductEditDetailQueryVariables = Exact<{
  productId: Scalars['Long']['input'];
}>;


export type ProductEditDetailQuery = { productDetail: { __typename?: 'ProductDetail', id: string, name: string, nameEn?: string | null, media: Array<string>, description: string, store: { __typename?: 'MdStore', id: string, name: string, account?: { __typename?: 'MdAccount', id: string, name: string } | null }, singleVariant?: { __typename?: 'ProductVariantSingle', inUseReasons: Array<ProductVariantInUseReason>, id: string, status: ProductVariantStatus, productCode: string, productId: string, media: Array<string>, tags: Array<string>, name?: string | null, nameEn?: string | null, countryOfOrigin?: ShopifySupportedCountry | null, weightInGrams?: string | null, hsCode?: string | null, logistics?: { __typename?: 'ProductVariantLogistics', width_mm?: string | null, warehouseCode: string, sizeCoefficient?: number | null, size?: string | null, note: string, length_mm?: string | null, inventorySync: boolean, height_mm?: string | null, defaultCourier?: CourierService | null, content: string, color?: string | null, supplier?: { __typename?: 'AnyXSupplier', name: string, id: string } | null } | null, price: { __typename?: 'GraphQLMoney', amount: string, currency: CurrencyCode }, setProductItems: Array<{ __typename?: 'SetProductItem', productVariantId: string, quantity: number, variantV2: { __typename?: 'ProductVariantV2', id: string, name?: string | null, media?: string | null, productCode: string, product: { __typename?: 'Product', name: string } } }>, listingVariants: Array<{ __typename?: 'ListingVariant', id: string, price: string, values: Array<string>, currency: string, sellerSKUCode: string, freeStock: number, listing: { __typename?: 'Listing', id: string, saleChannel: { __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType, isActive: boolean, data: { __typename?: 'AmazonSaleChannelData', amazonMarketplace: AmazonSellerCentralMarketplace } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData', lazadaMarketplace: LazadaMarketplace } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData', qoo10Marketplace: Qoo10Marketplace } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData', shopeeMarketplace: ShopeeMarketplace } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData', tiktokMarketplace: TikTokRegion } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' } } } }>, unitCost?: { __typename?: 'GraphQLMoney', amount: string, currency: CurrencyCode } | null } | null, variantsV2: Array<{ __typename?: 'ProductVariantV2', status: ProductVariantStatus, productId: string, productCode: string, name?: string | null, media?: string | null, id: string, unitCost?: { __typename?: 'Money', currency: CurrencyCode, amount: string } | null, price: { __typename?: 'Money', currency: CurrencyCode, amount: string } }> } };

export type UpdateProductVariantMutationVariables = Exact<{
  input: UpdateProductVariantV3Input;
}>;


export type UpdateProductVariantMutation = { productVariantUpdateV3: string };

export type ProductVariantEditDetailQueryVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type ProductVariantEditDetailQuery = { productVariant: { __typename?: 'ProductVariantDetail', countryOfOrigin?: ShopifySupportedCountry | null, hsCode?: string | null, id: string, name?: string | null, nameEn?: string | null, weightInGrams?: string | null, productCode: string, media: Array<string>, tags: Array<string>, status: ProductVariantStatus, inUseReasons: Array<ProductVariantInUseReason>, price: { __typename?: 'GraphQLMoney', amount: string, currency: CurrencyCode }, unitCost?: { __typename?: 'GraphQLMoney', amount: string, currency: CurrencyCode } | null, productInfo: { __typename?: 'ProductInformation', id: string, media?: string | null, name: string, variantCount: number, store: { __typename?: 'MdStore', id: string, name: string, account?: { __typename?: 'MdAccount', id: string, name: string } | null } }, logistics?: { __typename?: 'ProductVariantLogistics', width_mm?: string | null, warehouseCode: string, sizeCoefficient?: number | null, size?: string | null, note: string, length_mm?: string | null, inventorySync: boolean, height_mm?: string | null, defaultCourier?: CourierService | null, content: string, color?: string | null, supplier?: { __typename?: 'AnyXSupplier', name: string, id: string } | null } | null, setProductItems: Array<{ __typename?: 'SetProductItem', productVariantId: string, quantity: number, variantV2: { __typename?: 'ProductVariantV2', id: string, name?: string | null, media?: string | null, productCode: string, product: { __typename?: 'Product', name: string } } }>, listingVariants: Array<{ __typename?: 'ListingVariant', id: string, price: string, values: Array<string>, currency: string, sellerSKUCode: string, freeStock: number, listing: { __typename?: 'Listing', id: string, saleChannel: { __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType, isActive: boolean, data: { __typename?: 'AmazonSaleChannelData', amazonMarketplace: AmazonSellerCentralMarketplace } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData', lazadaMarketplace: LazadaMarketplace } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData', qoo10Marketplace: Qoo10Marketplace } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData', shopeeMarketplace: ShopeeMarketplace } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData', tiktokMarketplace: TikTokRegion } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' } } } }> } };

export type ProductCreateSetStartImportMutationVariables = Exact<{
  input: ManualSetProductCsvUploadInput;
}>;


export type ProductCreateSetStartImportMutation = { registerManualSetProductCsvUpload: { __typename?: 'ManualSetProductCsvUploadPayload', ok: boolean } };

export type ProductCreateSingleStartImportMutationVariables = Exact<{
  input: ManualSingleProductCsvUploadInput;
}>;


export type ProductCreateSingleStartImportMutation = { registerManualSingleProductCsvUpload: { __typename?: 'ManualSingleProductCsvUploadPayload', ok: boolean } };

export type ProductUpdateStartImportMutationVariables = Exact<{
  input: ManualUpdateProductCsvUploadInput;
}>;


export type ProductUpdateStartImportMutation = { registerManualUpdateProductCsvUpload: { __typename?: 'ManualUpdateProductCsvUploadPayload', ok: boolean } };

export type ProductCsvGenerateSignedUrlQueryVariables = Exact<{
  fileName: Scalars['String']['input'];
}>;


export type ProductCsvGenerateSignedUrlQuery = { productCSVUpload: { __typename?: 'UploadFilePayload', fileName: string, signedUrl: string, fileUri: string, fileUrl: string } };

export type ProductOnboardingQueryVariables = Exact<{
  storeId: Scalars['Long']['input'];
}>;


export type ProductOnboardingQuery = { productOnboarding: ProductOnboardingStatus };

export type ProductCsvExportQueryVariables = Exact<{
  input: ProductCsvExportInput;
}>;


export type ProductCsvExportQuery = { productCSVExport: { __typename?: 'ProductCSVExportFileResult', fileUri: string } | { __typename?: 'ProductCSVExportJobResult', documentId: string } };

export type ListingsPageTriggerSyncMutationVariables = Exact<{
  input: ListingTriggerSyncInput;
}>;


export type ListingsPageTriggerSyncMutation = { listingTriggerSync: string };

export type SyncListingModalChannelsQueryVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type SyncListingModalChannelsQuery = { MdStore: { __typename?: 'MdStore', channels: Array<{ __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType, isActive: boolean, data: { __typename?: 'AmazonSaleChannelData', amazonMarketplace: AmazonSellerCentralMarketplace } | { __typename?: 'EmptySaleChannelData', dummyData: boolean } | { __typename?: 'LazadaSaleChannelData', lazadaMarketplace: LazadaMarketplace } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData', sellerUserId: string, qoo10Marketplace: Qoo10Marketplace } | { __typename?: 'RakutenSaleChannelData', shopUrl: string } | { __typename?: 'ShopeeSaleChannelData', shopId: string, shopeeMarketplace: ShopeeMarketplace } | { __typename?: 'ShopifySaleChannelData', shopifyDomain: string } | { __typename?: 'TikTokSaleChannelData', tiktokMarketplace: TikTokRegion } | { __typename?: 'TokopediaSaleChannelData', tokopediaDomain?: string | null } | { __typename?: 'YahooSaleChannelData', sellerId: string } }> } };

export type ProductVariantCsvExportQueryVariables = Exact<{
  input: ProductVariantCsvExportInput;
}>;


export type ProductVariantCsvExportQuery = { productVariantCSVExport: { __typename?: 'ProductVariantCSVExportFileResult', fileUri: string } | { __typename?: 'ProductVariantCSVExportJobResult', documentId: string } };

export type ProductVariantsListPageQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter: ProductVariantListFilterInput;
}>;


export type ProductVariantsListPageQuery = { productVariantListView: { __typename?: 'ProductVariantListView', total: number, page: number, end: number, start: number, items: Array<{ __typename?: 'ProductVariantRecord', id: string, name: string, media?: string | null, status: ProductVariantStatus, hasSiblings: boolean, createdAt: string, warehouseCode?: string | null, productCode: string, listingVariantSaleChannelIds: Array<string>, productType: ProductType, product: { __typename?: 'Product', id: string, name: string, store: { __typename?: 'MdStore', id: string, name: string, account?: { __typename?: 'MdAccount', id: string, name: string } | null } }, listingVariantSaleChannels: Array<{ __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType, isActive: boolean, data: { __typename?: 'AmazonSaleChannelData', amazonMarketplace: AmazonSellerCentralMarketplace } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData', lazadaMarketplace: LazadaMarketplace } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData', qoo10Marketplace: Qoo10Marketplace } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData', shopeeMarketplace: ShopeeMarketplace } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData', tiktokMarketplace: TikTokRegion } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' } }> }> } };

export type ProductsListPageQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter: ProductListFilterInput;
}>;


export type ProductsListPageQuery = { productListView: { __typename?: 'ProductListView', total: number, page: number, end: number, start: number, items: Array<{ __typename?: 'ProductRecord', id: string, name: string, media?: string | null, createdAt: string, warehouseCode?: string | null, variantProductCode?: string | null, listingVariantSaleChannelIds: Array<string>, variantCount: number, variantProductType: VariantProductType, store: { __typename?: 'MdStore', id: string, name: string, account?: { __typename?: 'MdAccount', id: string, name: string } | null }, listingVariantSaleChannels: Array<{ __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType, isActive: boolean, data: { __typename?: 'AmazonSaleChannelData', amazonMarketplace: AmazonSellerCentralMarketplace } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData', lazadaMarketplace: LazadaMarketplace } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData', qoo10Marketplace: Qoo10Marketplace } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData', shopeeMarketplace: ShopeeMarketplace } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData', tiktokMarketplace: TikTokRegion } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' } }> }> } };

export type DefaultAccountQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<MdAccountFilterInput>;
  sortBy?: InputMaybe<MdAccountSortByInput>;
}>;


export type DefaultAccountQuery = { MdAccounts: { __typename?: 'MdAccounts', items: Array<{ __typename?: 'MdAccount', id: string }> } };

export type ProductSalesChannelsQueryVariables = Exact<{
  input: ProductSaleChannelsInput;
}>;


export type ProductSalesChannelsQuery = { productSaleChannels: { __typename?: 'ProductSaleChannelsPayload', saleChannelTypes: Array<SaleChannelType> } };

export type ReportDocumentDetailQueryVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type ReportDocumentDetailQuery = { reportDocument: { __typename?: 'ReportDocumentPayload', id: string, status: ReportDocumentStatus, url?: string | null } };

export type MdStoreChannelsQueryVariables = Exact<{
  mdStoreId: Scalars['Long']['input'];
}>;


export type MdStoreChannelsQuery = { MdStore: { __typename?: 'MdStore', channels: Array<{ __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType }> } };

export type AdCampaignDetailedReportQueryVariables = Exact<{
  input: AdCampaignDetailedReportInput;
}>;


export type AdCampaignDetailedReportQuery = { adCampaignDetailedReport: { __typename?: 'AdCampaignDetailedReportPayloadList', items: Array<{ __typename?: 'AdCampaignDetailedReportPayload', type?: string | null, budget?: string | null, budgetType?: string | null, clicks: string, conversions: string, cost: string, cpa: string, cpc: string, cpm: string, ctr: string, currency: ReportSupportedCurrency, cvr: string, datasourceId: string, id: string, impressions: string, masterDataStoreId: string, name?: string | null, platform: AdReportPlatform, roas: string, sales: string, status?: string | null, dimensionValues?: Array<{ __typename?: 'AdCampaignDetailedReportDimensionValuesPayload', clicks: string, conversions: string, cost: string, cpa: string, cpc: string, cpm: string, ctr: string, cvr: string, day?: any | null, impressions: string, month?: any | null, roas: string, sales: string, week?: any | null }> | null }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type AdDetailedReportQueryVariables = Exact<{
  input: AdDetailedReportInput;
}>;


export type AdDetailedReportQuery = { adDetailedReport: { __typename?: 'AdDetailedReportPayloadList', items: Array<{ __typename?: 'AdDetailedReportPayload', clicks: string, conversions: string, cost: string, cpa: string, cpc: string, cpm: string, ctr: string, currency: ReportSupportedCurrency, cvr: string, id: string, impressions: string, name?: string | null, roas: string, sales: string, status?: string | null, thumbnail?: string | null, type?: string | null, dimensionValues?: Array<{ __typename?: 'AdDetailedReportDimensionValuesPayload', clicks: string, conversions: string, cost: string, cpa: string, cpc: string, cpm: string, ctr: string, cvr: string, day?: any | null, impressions: string, month?: any | null, roas: string, sales: string, week?: any | null }> | null }>, meta: { __typename?: 'AdDetailedListMeta', length: number, limit: number, start: number, total: number, types: Array<string> } } };

export type AdGroupDetailedReportQueryVariables = Exact<{
  input: AdGroupDetailedReportInput;
}>;


export type AdGroupDetailedReportQuery = { adGroupDetailedReport: { __typename?: 'AdGroupDetailedReportPayloadList', items: Array<{ __typename?: 'AdGroupDetailedReportPayload', budget?: string | null, budgetType?: string | null, clicks: string, conversions: string, cost: string, cpa: string, cpc: string, cpm: string, ctr: string, currency: ReportSupportedCurrency, cvr: string, id: string, impressions: string, name?: string | null, roas: string, sales: string, status?: string | null, type?: string | null, dimensionValues?: Array<{ __typename?: 'AdGroupDetailedReportDimensionValuesPayload', clicks: string, conversions: string, cost: string, cpa: string, cpc: string, cpm: string, ctr: string, cvr: string, day?: any | null, impressions: string, month?: any | null, roas: string, sales: string, week?: any | null }> | null }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type KeywordDetailedReportQueryVariables = Exact<{
  input: KeywordDetailedReportInput;
}>;


export type KeywordDetailedReportQuery = { keywordDetailedReport: { __typename?: 'KeywordDetailedReportPayloadList', items: Array<{ __typename?: 'KeywordDetailedReportPayload', clicks: string, conversions: string, cost: string, cpa: string, cpc: string, cpm: string, ctr: string, currency: ReportSupportedCurrency, cvr: string, impressions: string, keyword: string, roas: string, sales: string, status?: string | null, dimensionValues?: Array<{ __typename?: 'KeywordDetailedReportDimensionValuesPayload', clicks: string, conversions: string, cost: string, cpa: string, cpc: string, cpm: string, ctr: string, cvr: string, day?: any | null, impressions: string, month?: any | null, roas: string, sales: string, week?: any | null }> | null }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type AdOverviewReportQueryVariables = Exact<{
  input: AdOverviewReportInput;
}>;


export type AdOverviewReportQuery = { adOverviewReport: { __typename?: 'AdOverviewReportPayloadList', items: Array<{ __typename?: 'AdOverviewReportPayload', clicks: string, conversions: string, cost: string, cpa: string, cpc: string, cpm: string, ctr: string, currency: ReportSupportedCurrency, cvr: string, day?: any | null, impressions: string, month?: any | null, roas: string, sales: string, week?: any | null }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type AdCampaignReportExportQueryVariables = Exact<{
  input: AdCampaignDetailedReportInput;
}>;


export type AdCampaignReportExportQuery = { exportAdCampaignReport: { __typename?: 'ReportDocumentResult', documentId: string } };

export type AdGroupReportExportQueryVariables = Exact<{
  input: AdGroupDetailedReportInput;
}>;


export type AdGroupReportExportQuery = { exportAdGroupReport: { __typename?: 'ReportDocumentResult', documentId: string } };

export type AdOverviewReportExportQueryVariables = Exact<{
  input: AdOverviewReportInput;
}>;


export type AdOverviewReportExportQuery = { exportAdOverviewReport: { __typename?: 'ReportDocumentResult', documentId: string } };

export type AdReportExportQueryVariables = Exact<{
  input: AdDetailedReportInput;
}>;


export type AdReportExportQuery = { exportAdReport: { __typename?: 'ReportDocumentResult', documentId: string } };

export type KeywordReportExportQueryVariables = Exact<{
  input: KeywordDetailedReportInput;
}>;


export type KeywordReportExportQuery = { exportKeywordReport: { __typename?: 'ReportDocumentResult', documentId: string } };

export type AdChartQueryVariables = Exact<{
  input: AdChartInput;
}>;


export type AdChartQuery = { adChart: { __typename?: 'AdChartPayload', clicks: Array<Record<string, any>>, conversions: Array<Record<string, any>>, cost: Array<Record<string, any>>, cpa: Array<Record<string, any>>, cpc: Array<Record<string, any>>, cpm: Array<Record<string, any>>, ctr: Array<Record<string, any>>, currency: ReportSupportedCurrency, cvr: Array<Record<string, any>>, impressions: Array<Record<string, any>>, roas: Array<Record<string, any>>, sales: Array<Record<string, any>> } };

export type AdSummaryQueryVariables = Exact<{
  input: AdSummaryInput;
}>;


export type AdSummaryQuery = { adSummary: { __typename?: 'AdSummaryPayload', currency: ReportSupportedCurrency, clicks: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, conversions: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, cost: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, cpa: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, impressions: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, roas: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, sales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string } } };

export type AvailableDatasourcesQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<DatasourceFilterInput>;
  sortBy?: InputMaybe<DatasourceSortByInput>;
}>;


export type AvailableDatasourcesQuery = { allDatasources: { __typename?: 'DatasourcePayloadList', items: Array<{ __typename?: 'DatasourcePayload', id: string, type: DatasourceType }> } };

export type KeywordChartQueryVariables = Exact<{
  input: KeywordChartInput;
}>;


export type KeywordChartQuery = { keywordChart: { __typename?: 'AdChartPayload', clicks: Array<Record<string, any>>, conversions: Array<Record<string, any>>, cost: Array<Record<string, any>>, cpa: Array<Record<string, any>>, cpc: Array<Record<string, any>>, cpm: Array<Record<string, any>>, ctr: Array<Record<string, any>>, currency: ReportSupportedCurrency, cvr: Array<Record<string, any>>, impressions: Array<Record<string, any>>, roas: Array<Record<string, any>>, sales: Array<Record<string, any>> } };

export type KeywordSummaryQueryVariables = Exact<{
  input: KeywordSummaryInput;
}>;


export type KeywordSummaryQuery = { keywordSummary: { __typename?: 'AdSummaryPayload', currency: ReportSupportedCurrency, clicks: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, conversions: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, cost: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, cpa: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, impressions: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, roas: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, sales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string } } };

export type MarketplaceCalendarEventCreateMutationVariables = Exact<{
  input: CreateMarketplaceCalendarEventInput;
}>;


export type MarketplaceCalendarEventCreateMutation = { createMarketplaceCalendarEvent: { __typename?: 'MarketplaceCalendarEventPayload', endDate: string, id: string, masterDataStoreId?: string | null, saleChannelType: SaleChannelType, startDate: string, title: string } };

export type MarketplaceCalendarEventDeleteMutationVariables = Exact<{
  input: DeleteMarketplaceCalendarEventInput;
}>;


export type MarketplaceCalendarEventDeleteMutation = { deleteMarketplaceCalendarEvent: string };

export type MarketplaceCalendarEventUpdateMutationVariables = Exact<{
  input: UpdateMarketplaceCalendarEventInput;
}>;


export type MarketplaceCalendarEventUpdateMutation = { updateMarketplaceCalendarEvent: { __typename?: 'MarketplaceCalendarEventPayload', endDate: string, id: string, masterDataStoreId?: string | null, saleChannelType: SaleChannelType, startDate: string, title: string } };

export type SaleChannelCurrencyQueryVariables = Exact<{
  saleChannelType: SaleChannelType;
}>;


export type SaleChannelCurrencyQuery = { saleChannelCurrency: ReportSupportedCurrency };

export type StoreForCalendarQueryVariables = Exact<{
  mdStoreId: Scalars['Long']['input'];
}>;


export type StoreForCalendarQuery = { MdStore: { __typename?: 'MdStore', id: string, channels: Array<{ __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType, isActive: boolean, data: { __typename?: 'AmazonSaleChannelData', amazonMarketplace: AmazonSellerCentralMarketplace } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData', lazadaMarketplace: LazadaMarketplace } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData', sellerUserId: string, qoo10Marketplace: Qoo10Marketplace } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData', shopeeMarketplace: ShopeeMarketplace } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData', tiktokMarketplace: TikTokRegion } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' } }> } };

export type MarketplaceCalendarEventsQueryVariables = Exact<{
  input: MarketplaceCalendarEventQueryInput;
}>;


export type MarketplaceCalendarEventsQuery = { marketplaceCalendarEvents: { __typename?: 'MarketplaceCalendarEventPayloadList', items: Array<{ __typename?: 'MarketplaceCalendarEventPayload', endDate: string, id: string, masterDataStoreId?: string | null, saleChannelType: SaleChannelType, saleChannelCountry?: string | null, startDate: string, createdAt: string, title: string }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type MarketplaceCalendarStoresQueryVariables = Exact<{
  mdStoreId: Scalars['Long']['input'];
}>;


export type MarketplaceCalendarStoresQuery = { MdStore: { __typename?: 'MdStore', id: string, channels: Array<{ __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType, isActive: boolean, data: { __typename?: 'AmazonSaleChannelData', amazonMarketplace: AmazonSellerCentralMarketplace } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData', lazadaMarketplace: LazadaMarketplace } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData', qoo10Marketplace: Qoo10Marketplace } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData', shopeeMarketplace: ShopeeMarketplace } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData', tiktokMarketplace: TikTokRegion } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' } }> } };

export type MarketplaceCalendarSummaryQueryVariables = Exact<{
  input: MarketplaceCalendarSummaryQueryInput;
}>;


export type MarketplaceCalendarSummaryQuery = { marketplaceCalendarSummary: { __typename?: 'MarketplaceCalendarRevenueSummaryPayload', actual: { __typename?: 'MarketplaceCalendarSummaryActualRevenuePayload', value: string, diffValue: string, currency: ReportSupportedCurrency }, forecast: { __typename?: 'MarketplaceCalendarSummaryForecastRevenuePayload', value: string, diffValue: string, currency: ReportSupportedCurrency } } };

export type InventoryStockDailyReportExportQueryVariables = Exact<{
  input: DdiInventoryStockValueDailyReportExportInput;
}>;


export type InventoryStockDailyReportExportQuery = { exportDdiInventoryStockValueDailyReport: { __typename?: 'ReportDocumentResult', documentId: string } };

export type InventoryStockVariantReportExportQueryVariables = Exact<{
  input: DdiInventoryStockValueProductReportExportInput;
}>;


export type InventoryStockVariantReportExportQuery = { exportDdiInventoryStockValueProductReport: { __typename?: 'ReportDocumentResult', documentId: string } };

export type InventoryStockDailyReportQueryVariables = Exact<{
  input: DdiInventoryStockValueDailyReportInput;
}>;


export type InventoryStockDailyReportQuery = { ddiInventoryStockValueDailyReport: { __typename?: 'DdiInventoryStockValueDailyReportPayloadList', days: Array<{ __typename?: 'DdiInventoryStockValueDailyReportPayload', availableToPurchase: string, date: any, daysOfInventory: string, stockOnHand: string, stockOnHandValue: string }>, meta: { __typename?: 'ReportListMeta', length: number, total: number } } };

export type InventoryStockVariantReportQueryVariables = Exact<{
  input: DdiInventoryStockValueProductReportInput;
}>;


export type InventoryStockVariantReportQuery = { ddiInventoryStockValueProductReport: { __typename?: 'DdiInventoryStockValueProductReportPayloadList', products: Array<{ __typename?: 'DdiInventoryStockValueProductReportPayload', daysOfInventory: string, inventoryStatus: InventoryStatus, productCode?: string | null, productId: string, productImageUrl?: string | null, productVariantName?: string | null, productVariantId: string, stockOnHand: string, stockOnHandValue: string, productName?: string | null }>, meta: { __typename?: 'ReportListMeta', length: number, total: number } } };

export type DdiInventoryTrackerReportPeopleInChargeQueryVariables = Exact<{ [key: string]: never; }>;


export type DdiInventoryTrackerReportPeopleInChargeQuery = { ddiInventoryReportPeopleInCharge: { __typename?: 'DdiPersonInChargePayloadList', data: Array<{ __typename?: 'DdiPersonInChargePayload', id: string, name: string, assignedStores: Array<{ __typename?: 'DdiPersonInChargeAssignedStorePayload', masterDataStoreId: string, storeName: string }> }> } };

export type DdiInventoryTrackerReportQueryVariables = Exact<{
  input: DdiInventoryTrackerReportInput;
}>;


export type DdiInventoryTrackerReportQuery = { ddiInventoryTrackerReport: { __typename?: 'DdiInventoryTrackerReportPayload', warehouseData: Array<{ __typename?: 'DdiInventoryTrackerReportWarehouseDataPayload', warehouse: DdiWarehouse, segmentData: Array<{ __typename?: 'DdiInventoryTrackerReportSegmentDataPayload', availableToPurchase: string, daysOfInventory: string, segment: DdiProductSegment, stockOnHand: string, stockOnHandValue: string }> }> } };

export type DdiInventoryTrackerReportStoresQueryVariables = Exact<{ [key: string]: never; }>;


export type DdiInventoryTrackerReportStoresQuery = { ddiInventoryTrackerReportStores: { __typename?: 'DdiInventoryTrackerReportStores', stores: Array<{ __typename?: 'DdiInventoryTrackerReportStore', masterDataStoreId: string, storeName: string }> } };

export type ProductReportExportQueryVariables = Exact<{
  filter: ProductReportExportFilterInput;
}>;


export type ProductReportExportQuery = { exportProductReport: { __typename?: 'ReportDocumentResult', documentId: string } };

export type VariantReportExportQueryVariables = Exact<{
  filter: ProductVariantReportExportFilterInput;
}>;


export type VariantReportExportQuery = { exportVariantReport: { __typename?: 'ReportDocumentResult', documentId: string } };

export type ProductReportSummaryQueryVariables = Exact<{
  filter: VariantReportFilterInput;
}>;


export type ProductReportSummaryQuery = { reportByProductSummary: { __typename?: 'ProductReportSummaryPayload', currency: ReportSupportedCurrency, summary: { __typename?: 'ProductReportSummary', cancelAndOrRefund: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null }, grossProfit: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null }, grossProfitRate: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null }, grossSales: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null }, marginalProfit: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null }, marginalProfitRate: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null }, netSales: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null }, totalSales: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null } }, total: { __typename?: 'ProductReportTotalData', advertisingCost?: string | null, avgSalesValue: string, cancelAndOrRefund: string, commissionFees: string, daysSalesOfInventory?: string | null, discountRate: string, discounts: string, grossProfit: string, grossProfitRate: string, grossSales: string, marginalProfit: string, marginalProfitRate: string, merchandiseCost?: string | null, netSales: string, revenueAdv: string, roas: string, shippingFee: string, totalSales: string, unitSold?: number | null, warehouseInventory?: number | null } } };

export type ProductReportTableQueryVariables = Exact<{
  filter: ProductReportPaginatedFilterInput;
}>;


export type ProductReportTableQuery = { reportByProduct: { __typename?: 'ProductReportPayload', currency: ReportSupportedCurrency, items: Array<{ __typename?: 'ProductReportData', accountName?: string | null, masterDataAccountId?: string | null, storeName?: string | null, advertisingCost: string, avgSalesValue: string, cancelAndOrRefund: string, commissionFees: string, daysSalesOfInventory?: string | null, discountRate: string, discounts: string, grossProfit: string, grossProfitRate: string, grossSales: string, marginalProfit: string, marginalProfitRate: string, masterDataStoreId?: string | null, media?: string | null, merchandiseCost: string, netSales: string, productCode?: string | null, productId?: string | null, productName?: string | null, revenueAdv: string, roas: string, shippingFee: string, totalSales: string, unitSold?: number | null, warehouseInventory?: number | null }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type VariantReportTableQueryVariables = Exact<{
  filter: VariantReportPaginatedFilterInput;
}>;


export type VariantReportTableQuery = { reportByVariant: { __typename?: 'VariantReportPayload', currency: ReportSupportedCurrency, items: Array<{ __typename?: 'ProductVariantReportData', accountName?: string | null, masterDataAccountId?: string | null, storeName?: string | null, advertisingCost: string, avgSalesValue: string, cancelAndOrRefund: string, commissionFees: string, daysSalesOfInventory?: string | null, discountRate: string, discounts: string, grossProfit: string, grossProfitRate: string, grossSales: string, marginalProfit: string, marginalProfitRate: string, masterDataStoreId?: string | null, media?: string | null, merchandiseCost: string, netSales: string, productCode?: string | null, productId?: string | null, productName?: string | null, productVariantId?: string | null, revenueAdv: string, roas: string, shippingFee: string, totalSales: string, unitSold?: number | null, variantName?: string | null, variantStatus?: ProductVariantStatus | null, warehouseInventory?: number | null }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type DdiProductAnalyticsReportExportQueryVariables = Exact<{
  input: DdiProductAnalyticsReportExportInput;
}>;


export type DdiProductAnalyticsReportExportQuery = { ddiProductAnalyticsReportExport: { __typename?: 'ReportDocumentResult', documentId: string, ok: boolean } };

export type DdiProductAnalyticsDetailedReportQueryVariables = Exact<{
  input: DdiProductAnalyticsDetailedReportInput;
}>;


export type DdiProductAnalyticsDetailedReportQuery = { ddiProductAnalyticsDetailedReport: { __typename?: 'DdiProductAnalyticsDetailedReportPayloadList', items: Array<{ __typename?: 'DdiProductAnalyticsDetailedReportPayload', avgSales: string, currency: ReportSupportedCurrency, discount: string, discountRate: string, grossSales: string, masterDataStoreId: string, netSales: string, productCode?: string | null, productId?: string | null, productMedia?: string | null, productName?: string | null, productStatus?: ProductVariantStatus | null, productVariantId?: string | null, subsidy: string, unitsSold: string }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number }, total: { __typename?: 'DdiProductAnalyticsDetailedReportTotalPayload', avgSales: string, currency: ReportSupportedCurrency, discount: string, discountRate: string, grossSales: string, netSales: string, subsidy: string, unitsSold: string } } };

export type DdiProductAnalyticsSummaryQueryVariables = Exact<{
  input: DdiProductAnalyticsSummaryInput;
}>;


export type DdiProductAnalyticsSummaryQuery = { ddiProductAnalyticsSummary: { __typename?: 'DdiProductAnalyticsSummaryPayload', currency: ReportSupportedCurrency, grossSales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, netSales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, unitsSold: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string } } };

export type StartProductReviewCompetitorMutationVariables = Exact<{
  input: ProductReviewCompetitorAnalysisRequestInput;
}>;


export type StartProductReviewCompetitorMutation = { startProductReviewCompetitorAnalysis: { __typename?: 'ProductReviewCompetitorAnalysisStatusDto', nextAvailableTime?: string | null, status: ProductReviewCompetitorAnalysisStatus } };

export type ProductReviewCompetitorQueryVariables = Exact<{
  input: ProductReviewCompetitorAnalysisRequestInput;
}>;


export type ProductReviewCompetitorQuery = { productReviewCompetitorAnalysis: { __typename?: 'ProductReviewCompetitorAnalysisPayload', nextAvailableTime?: string | null, status: ProductReviewCompetitorAnalysisStatus, data?: { __typename?: 'ProductReviewCompetitorResponsePayload', brand?: string | null, currency?: ReportSupportedCurrency | null, discountedPrice?: string | null, image?: string | null, itemId: string, masterDataStoreId: string, originalPrice?: string | null, productId: string, productUrl?: string | null, rating?: string | null, reviewCount?: string | null, saleChannelType: SaleChannelType, title?: string | null, competitors: Array<{ __typename?: 'ProductReviewCompetitorsResponse', brand?: string | null, currency?: ReportSupportedCurrency | null, discountedPrice?: string | null, image?: string | null, itemId: string, originalPrice?: string | null, productUrl?: string | null, rating?: string | null, reviewCount?: string | null, title?: string | null, criteria: Array<{ __typename?: 'ProductReviewCriteriaResponseDto', criteria: string, negative?: string | null, positive?: string | null }> }>, criteria: Array<{ __typename?: 'ProductReviewCriteriaResponseDto', criteria: string, negative?: string | null, positive?: string | null }> } | null } };

export type ProductReviewSummaryQueryVariables = Exact<{
  input: ProductReviewAnalysisFilterInput;
}>;


export type ProductReviewSummaryQuery = { productReviewSummarization: { __typename?: 'ProductReviewSummarizationPayload', text: string } };

export type ProductCommentsQueryVariables = Exact<{
  input: ProductReviewsInput;
}>;


export type ProductCommentsQuery = { productReviews: { __typename?: 'ProductReviewsPayloadList', meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number }, reviews: Array<{ __typename?: 'ProductReviewPayload', comment: string, date: any, rating: string }> } };

export type ProductReviewSentimentQueryVariables = Exact<{
  input: ProductReviewAnalysisFilterInput;
}>;


export type ProductReviewSentimentQuery = { productReviewSentimentAnalysis: { __typename?: 'ProductReviewSentimentAnalysisPayload', data: Array<{ __typename?: 'ProductReviewSentimentResponsePayload', key: string, percentage: string, reviewIds: Array<string> }> } };

export type ProductReviewTopicQueryVariables = Exact<{
  input: ProductReviewAnalysisFilterInput;
}>;


export type ProductReviewTopicQuery = { productReviewTopicAnalysis: { __typename?: 'ProductReviewTopicAnalysisPayload', data: Array<{ __typename?: 'ProductReviewTopicResponsePayload', percentage: string, reviewIds: Array<string>, topic: string, topicSummary: string }> } };

export type ProductRatingsQueryVariables = Exact<{
  input: ProductReviewAnalysisFilterInput;
}>;


export type ProductRatingsQuery = { productRatingOverview: { __typename?: 'ProductRatingOverviewPayload', averageRating: string, fiveStarsCount: string, fourStarsCount: string, oneStarCount: string, threeStarsCount: string, totalRatings: string, twoStarsCount: string } };

export type ProductDetailQueryVariables = Exact<{
  productId: Scalars['Long']['input'];
}>;


export type ProductDetailQuery = { productDetail: { __typename?: 'ProductDetail', id: string, name: string, media: Array<string>, description: string, store: { __typename?: 'MdStore', id: string, name: string, account?: { __typename?: 'MdAccount', id: string, name: string } | null } } };

export type ProductDetailsForReviewAnalysisQueryVariables = Exact<{
  input: ProductReviewAnalysisFilterInput;
}>;


export type ProductDetailsForReviewAnalysisQuery = { productDetailsForReviewAnalysis: { __typename?: 'ProductCategoryAndPricePayload', category?: Array<string> | null, currency?: ReportSupportedCurrency | null, price?: string | null, productUrl?: string | null } };

export type ProductSalesChartQueryVariables = Exact<{
  input: ProductChartInput;
}>;


export type ProductSalesChartQuery = { productChart: { __typename?: 'ProductChartPayload', advertisingFee: Array<Record<string, any>>, avgOrderValues: Array<Record<string, any>>, cancelAndOrRefund: Array<Record<string, any>>, currency: ReportSupportedCurrency, discount: Array<Record<string, any>>, discountRate: Array<Record<string, any>>, grossSales: Array<Record<string, any>>, netSales: Array<Record<string, any>>, orders: Array<Record<string, any>>, revenueViaAds: Array<Record<string, any>>, roas: Array<Record<string, any>>, shippingFee: Array<Record<string, any>>, totalSales: Array<Record<string, any>>, unitSold: Array<Record<string, any>> } };

export type ProductSalesSummaryQueryVariables = Exact<{
  input: ProductSummaryInput;
}>;


export type ProductSalesSummaryQuery = { productSummary: { __typename?: 'ProductSummaryPayload', currency: ReportSupportedCurrency, advertisingFee: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, avgOrderValues: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, cancelAndOrRefund: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, discount: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, discountRate: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, grossSales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, netSales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, orders: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, revenueViaAds: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, roas: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, shippingFee: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, totalSales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, unitSold: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string } } };

export type ProductSalesTableQueryVariables = Exact<{
  input: ProductDetailedReportInput;
}>;


export type ProductSalesTableQuery = { productDetailedReport: { __typename?: 'ProductDetailedReportPayloadList', items: Array<{ __typename?: 'ProductDetailedReportPayload', advertisingFee: string, avgOrderValues: string, cancelAndOrRefund: string, currency: ReportSupportedCurrency, date: any, discount: string, discountRate: string, grossSales: string, netSales: string, orders: string, revenueViaAds: string, roas: string, shippingFee: string, totalSales: string, unitSold: string }>, total: { __typename?: 'ProductDetailedReportTotalPayload', advertisingFee: string, avgOrderValues: string, cancelAndOrRefund: string, currency: ReportSupportedCurrency, discount: string, discountRate: string, grossSales: string, netSales: string, orders: string, revenueViaAds: string, roas: string, shippingFee: string, totalSales: string, unitSold: string } } };

export type ProductSalesWidgetQueryVariables = Exact<{
  input: ProductSalesAnalyticsInput;
}>;


export type ProductSalesWidgetQuery = { productSalesAnalytics: { __typename?: 'ProductSalesAnalyticsPayload', chart: Array<Record<string, any>>, currency: ReportSupportedCurrency, summary: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string } } };

export type SalesChannelReportExportQueryVariables = Exact<{
  filter: SaleChannelReportTableFilterInput;
}>;


export type SalesChannelReportExportQuery = { exportSaleChannelReport: { __typename?: 'ReportDocumentResult', documentId: string } };

export type SalesChannelReportChartQueryVariables = Exact<{
  filter: SaleChannelReportTableFilterInput;
}>;


export type SalesChannelReportChartQuery = { saleChannelReportChart: { __typename?: 'SaleChannelReportChartPayload', channels: Array<SaleChannelType>, currency: ReportSupportedCurrency, totalItems: number, list: Array<{ __typename?: 'SaleChannelReportChartData', advertisingCost: string, advertisingRevenue: string, avgOrderValues: string, channel?: SaleChannelType | null, commissionFee: string, cvr?: string | null, dailySales?: string | null, day?: any | null, discountRate: string, discounts: string, dow?: number | null, grossProfit: string, grossProfitRate: string, grossSales: string, netSales: string, totalSales: string, cancelAndOrRefund: string, marginalProfit: string, marginalProfitRate: string, masterDataStoreId?: string | null, merchandiseCost: string, orders: string, roas: string, sessions: string, shippingFee: string, storeName?: string | null, yearMonth?: any | null, yearWeek?: any | null }>, stores: Array<{ __typename?: 'SaleChannelReportChartStore', id: string, name: string }> } };

export type SalesChannelReportSummaryQueryVariables = Exact<{
  filter: SaleChannelReportSummaryFilterInput;
}>;


export type SalesChannelReportSummaryQuery = { saleChannelReportSummary: { __typename?: 'ReportSummaryPayload', currency: ReportSupportedCurrency, comparisonSummary: { __typename?: 'ReportSummaryComparisonData', avgOrderValues: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null }, cvr?: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null } | null, grossProfit?: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null } | null, grossProfitRate?: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null } | null, grossSales: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null }, marginalProfit?: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null } | null, marginalProfitRate?: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null } | null, orders: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null }, roas?: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null } | null, sessions?: { __typename?: 'ReportCompareData', current?: string | null, diff?: string | null, isPercentage: boolean, percentage?: string | null } | null }, tableSummary: { __typename?: 'SaleChannelReportSummaryData', advertisingCost?: string | null, advertisingRevenue?: string | null, avgOrderValues: string, commissionFee?: string | null, cvr?: string | null, discountRate: string, discounts: string, grossProfit: string, grossProfitRate?: string | null, grossSales: string, netSales: string, totalSales: string, cancelAndOrRefund: string, marginalProfit: string, marginalProfitRate?: string | null, merchandiseCost?: string | null, orders: string, roas?: string | null, sessions?: string | null, shippingFee: string } } };

export type SalesChannelReportTableQueryVariables = Exact<{
  filter: SaleChannelReportTableFilterInput;
}>;


export type SalesChannelReportTableQuery = { saleChannelReportTable: { __typename?: 'SaleChannelReportPayload', currency: ReportSupportedCurrency, totalItems: number, list: Array<{ __typename?: 'SaleChannelReportTableData', advertisingCost?: string | null, advertisingRevenue?: string | null, avgOrderValues: string, commissionFee?: string | null, cvr?: string | null, discountRate: string, discounts: string, grossProfit: string, grossProfitRate?: string | null, grossSales: string, netSales: string, totalSales: string, cancelAndOrRefund: string, marginalProfit: string, marginalProfitRate?: string | null, merchandiseCost?: string | null, metric: string, orders: string, roas?: string | null, sessions?: string | null, shippingFee: string }> } };

export type DdiAnalyticsReportExportQueryVariables = Exact<{
  input: DdiAnalyticsReportExportInput;
}>;


export type DdiAnalyticsReportExportQuery = { ddiAnalyticsReportExport: { __typename?: 'ReportDocumentResult', documentId: string, ok: boolean } };

export type DdiAnalyticsChartQueryVariables = Exact<{
  input: DdiAnalyticsChartInput;
}>;


export type DdiAnalyticsChartQuery = { ddiAnalyticsChart: { __typename?: 'DdiAnalyticsChartPayload', saleChannelTypes: Array<SaleChannelType>, currency: ReportSupportedCurrency, grossSales: Array<Record<string, any>>, netSales: Array<Record<string, any>>, orders: Array<Record<string, any>> } };

export type DdiAnalyticsDetailedReportQueryVariables = Exact<{
  input: DdiAnalyticsDetailedReportInput;
}>;


export type DdiAnalyticsDetailedReportQuery = { ddiAnalyticsDetailedReport: { __typename?: 'DdiAnalyticsDetailedReportPayloadList', items: Array<{ __typename?: 'DdiAnalyticsDetailedReportPayload', avgOrderValue: string, cancelledOrders: string, cancellationRate: string, channel?: SaleChannelType | null, cvr: string, day?: any | null, discount: string, discountRate: string, dow?: number | null, grossSales: string, month?: any | null, netSales: string, orders: string, sessions: string, subsidy: string, week?: any | null }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number }, total: { __typename?: 'DdiAnalyticsDetailedReportTotalPayload', avgOrderValue: string, cancelledOrders: string, cancellationRate: string, cvr: string, discount: string, discountRate: string, grossSales: string, netSales: string, orders: string, sessions: string, subsidy: string } } };

export type DdiAnalyticsSummaryQueryVariables = Exact<{
  input: DdiAnalyticsSummaryInput;
}>;


export type DdiAnalyticsSummaryQuery = { ddiAnalyticsSummary: { __typename?: 'DdiAnalyticsSummaryPayload', currency: ReportSupportedCurrency, grossSales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, netSales: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string }, orders: { __typename?: 'NumericValueWithDiffPayload', diff: string, diffPercentage: string, value: string } } };

export type UpdateCourierSettingsMutationVariables = Exact<{
  input: CourierSettingsInput;
}>;


export type UpdateCourierSettingsMutation = { updateCourierSettings: { __typename?: 'StatusOk', ok: boolean } };

export type GetCourierAccountProviderListQueryVariables = Exact<{
  filters: GetCourierAccountListInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type GetCourierAccountProviderListQuery = { getCourierAccountList: { __typename?: 'CourierAccountDetailsListResponse', total: number, page: number, courierAccountDetails: Array<{ __typename?: 'CourierAccountDetails', id: string, created: any, crossBorderCourierProvider: CrossBorderCourierProvider, account: { __typename?: 'IdName', id: string, name: string } }> } };

export type GetCourierSettingsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetCourierSettingsQuery = { getCourierSettings?: { __typename?: 'CourierSettings', accountId: string, category: Category, letterHeadImage?: string | null, signatureImage?: string | null, boxSizes?: Array<{ __typename?: 'BoxSize', default: boolean, depth: number, height: number, name: string, width: number, weight?: number | null }> | null } | null };

export type GetCourierSettingsListQueryVariables = Exact<{
  filter?: InputMaybe<CourierSettingsFilterInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type GetCourierSettingsListQuery = { getCourierSettingsList: { __typename?: 'getCourierSettingsListResponse', page: number, total: number, accountCourierSettings: Array<{ __typename?: 'AccountCourierSettings', companyName: string, country: Country, accountId: string, ready: AccountCourierSettingsStatus, updated?: any | null, websiteUrl: string }> } };

export type DeliverySlipMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type DeliverySlipMutation = { deliverySlip: { __typename?: 'Path', url: string } };

export type InvoiceSlipMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type InvoiceSlipMutation = { invoiceSlip: { __typename?: 'InvoiceSlip', url: string, documents: Array<{ __typename?: 'InvoiceSlipDocument', kind: InvoiceSlipDocumentKind, url: string }> } };

export type SetDeclaredUnitPricesMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  declaredUnitPrices: Array<DeclaredUnitPriceInput> | DeclaredUnitPriceInput;
}>;


export type SetDeclaredUnitPricesMutation = { setDeclaredUnitPrices: boolean };

export type AnylogiOrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AnylogiOrderQuery = { anylogiOrder: { __typename?: 'AnylogiOrder', id: string, displayId: string, anyXOrderId: string, editable: boolean, validationStatus?: ValidationStatus | null, courierType?: CourierType | null, temperature: Temperature, channelUrl?: string | null, discount?: number | null, totalAmount?: number | null, subtotalAmount?: number | null, fulfillmentAmount?: string | null, tax?: number | null, shippingCost?: number | null, shippingDate?: string | null, preferredDeliveryDate?: any | null, preferredDeliveryTime?: DeliveryTimeframe | null, shippingInstructions?: string | null, trackingNumber?: string | null, trackingUrl?: string | null, note?: string | null, codFee?: number | null, channelProvider: ChannelProvider, created: string, totalWeight?: number | null, anylogiId: string, channelOrderId: string, currency: string, image: string, items: number, productCount: number, warehouseName: string, paymentMethod: AnylogiPaymentMethod, deliveryStatus: DeliveryStatus, crossBorderValidationErrors?: Array<CrossBorderValidationError> | null, store: { __typename?: 'IdName', id: string, name: string }, account: { __typename?: 'IdName', id: string, name: string }, customer?: { __typename?: 'AnylogiReadOrderCustomer', email: string, phoneNumber: string, numberOfPurchases: string, name: { __typename?: 'Name', first: string, last: string } } | null, shipping: { __typename?: 'AnylogiShipping', trackingURL: string, status?: ShippingStatus | null, signatureOption: boolean, shipperAddressID: string, shipmentCategory?: Category | null, orderID: string, deliveryDutyPaid: boolean, specialServiceTypes?: Array<SpecialServiceType> | null, insurance?: { __typename?: 'AnylogiMoney', amount: string, currency: AnylogiCurrency } | null, boxSizes?: Array<{ __typename?: 'ShippingBoxSize', width: number, weight?: number | null, quantity: number, height: number, depth: number, packageType?: { __typename?: 'DHLPackageWrapper', DHLPackageType?: DhlPackageType | null } | { __typename?: 'FedExPackageWrapper', FedExPackageType?: FedExPackageType | null } | null }> | null, shipmentPrice?: { __typename?: 'AnylogiMoney', currency: AnylogiCurrency, amount: string } | null, serviceCode?: { __typename?: 'DHLServiceCodeWrapper', dhlServiceCode?: DhlServiceCode | null } | { __typename?: 'FedExServiceCodeWrapper', fedExServiceCode?: FedExServiceCode | null } | { __typename?: 'JapanPostServiceCodeWrapper', japanPostServiceCode?: JapanPostServiceCode | null } | { __typename?: 'UPSServiceCodeWrapper', upsServiceCode?: UpsServiceCode | null } | null }, products: Array<{ __typename?: 'AnyLogiSkuForOrderDetailed', name: string, gtin: string, quantity: number, code: string, image: string, price: string, unknown: boolean, shippingNotRequired: boolean, shippingStatus?: AnylogiItemShippingStatus | null, declaredUnitPrice?: string | null, suggestedDeclaredUnitPrice: string, currency: { __typename?: 'AnylogiMoney', amount: string, currency: AnylogiCurrency } }>, shippingAddress?: { __typename?: 'FullAddress', firstName: string, lastName: string, companyName?: string | null, country?: Country | null, regionId?: string | null, regionName?: string | null, regionLocalName?: string | null, city?: string | null, postalCode?: string | null, provinceId?: string | null, addressFirst: string, addressSecond?: string | null, phone: { __typename?: 'PhoneNumber', countryCode: Country, number: string } } | null, translatedShippingAddress?: { __typename?: 'FullAddress', firstName: string, lastName: string, companyName?: string | null, country?: Country | null, regionId?: string | null, regionName?: string | null, regionLocalName?: string | null, city?: string | null, postalCode?: string | null, addressFirst: string, addressSecond?: string | null, provinceId?: string | null, phone: { __typename?: 'PhoneNumber', countryCode: Country, number: string } } | null, billingAddress?: { __typename?: 'FullAddress', firstName: string, lastName: string, companyName?: string | null, country?: Country | null, regionId?: string | null, regionName?: string | null, regionLocalName?: string | null, city?: string | null, postalCode?: string | null, provinceId?: string | null, addressFirst: string, addressSecond?: string | null, phone: { __typename?: 'PhoneNumber', countryCode: Country, number: string } } | null, warehouse: { __typename?: 'IdName', name: string, id: string } } };

export type CreateShippingMutationVariables = Exact<{
  input: ShippingInput;
  crossBorderCourierProvider: CrossBorderCourierProvider;
  serviceCode: ServiceCodeInput;
}>;


export type CreateShippingMutation = { createShipping: { __typename?: 'Shipping', orderID: string, trackingURL: string, shipperAddressID: string, signatureOption: boolean, deliveryDutyPaid: boolean, shipmentCategory: Category, status: ShippingStatus, boxSizes?: Array<{ __typename?: 'ShippingBoxSize', depth: number, width: number, height: number, weight?: number | null }> | null, insurance?: { __typename?: 'AnylogiMoney', amount: string, currency: AnylogiCurrency } | null } };

export type UpdateAnylogiCrossBorderShippingOrderMutationVariables = Exact<{
  input: AnylogiUpdateCrossBorderShippingOrderInput;
}>;


export type UpdateAnylogiCrossBorderShippingOrderMutation = { updateAnylogiCrossBorderShippingOrder: { __typename?: 'StatusOk', ok: boolean } };

export type GetCourierAccountProviderQueryVariables = Exact<{
  filters: GetCourierAccountListInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type GetCourierAccountProviderQuery = { getCourierAccountList: { __typename?: 'CourierAccountDetailsListResponse', total: number, page: number, courierAccountDetails: Array<{ __typename?: 'CourierAccountDetails', id: string, crossBorderCourierProvider: CrossBorderCourierProvider, courierDetails?: { __typename?: 'DHLAccountDetails', dhlApiKey: string, dhlApiSecret: string, dhlAccountNumber: string, dhlCorporateNumber?: string | null, dhlCorporateNumberInJP: boolean, dhlShipperAddressId: string, dhlSupportPackageTypes?: Array<DhlPackageType> | null, dhlSignatureImageURL?: string | null } | { __typename?: 'FedExAccountDetails', fedExAccountNumber: string, fedExContactName: string, fedExShipperAddressId: string, fedExSupportPackageTypes?: Array<FedExPackageType> | null, fedExSignatureOption: FedExSignatureOptionType, fedExLetterheadImageURL?: string | null, fedExSignatureImageURL?: string | null } | { __typename: 'JapanPostAccountDetails', japanPostCardNumber?: string | null, japanPostSupportServiceCodes?: Array<JapanPostServiceCode> | null } | { __typename?: 'UPSAccountDetails' } | null }> } };

export type GetShippingRatesQueryVariables = Exact<{
  input: ShippingInput;
}>;


export type GetShippingRatesQuery = { getShippingRates: { __typename?: 'getShippingRateResponse', errors?: Array<{ __typename?: 'shippingRateError', crossBorderCourierProvider: CrossBorderCourierProvider, messages?: Array<string> | null }> | null, shippingRates?: Array<{ __typename?: 'ShippingRateDetail', crossBorderCourierProvider: CrossBorderCourierProvider, serviceCode?: { __typename?: 'DHLServiceCodeWrapper', dhlServiceCode?: DhlServiceCode | null } | { __typename?: 'FedExServiceCodeWrapper', fedExServiceCode?: FedExServiceCode | null } | { __typename?: 'JapanPostServiceCodeWrapper', japanPostServiceCode?: JapanPostServiceCode | null } | { __typename?: 'UPSServiceCodeWrapper', upsServiceCode?: UpsServiceCode | null } | null, totalCharge: { __typename?: 'AnylogiMoney', amount: string, currency: AnylogiCurrency }, ratedShipmentAlert?: Array<{ __typename?: 'RatedShipmentAlert', code: string, description: string }> | null, estimateDeliveryDate?: { __typename?: 'DateRangeResponse', from?: any | null, to?: any | null } | null }> | null } };

export type ShipOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type ShipOrderMutation = { shipOrder: { __typename?: 'StatusOk', ok: boolean } };

export type VoidShippingMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type VoidShippingMutation = { voidShipping: { __typename?: 'Shipping', orderID: string } };

export type OrderListCsvStartImportMutationVariables = Exact<{
  fileUri: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
  manualOrderUploadType: ManualOrderUploadType;
}>;


export type OrderListCsvStartImportMutation = { registerManualOrderCsvUploadV2: { __typename?: 'RegisterManualOrderCsvUploadPayload', ok: boolean } };

export type AnylogiOrdersQueryVariables = Exact<{
  filters: OrderFilters;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage: Scalars['Int']['input'];
}>;


export type AnylogiOrdersQuery = { anylogiOrders: { __typename?: 'AnylogiOrdersPaginated', total: number, page: number, totalInvalid: number, records: Array<{ __typename?: 'AnylogiOrder', id: string, displayId: string, crossBorderValidationErrors?: Array<CrossBorderValidationError> | null, created: string, trackingNumber?: string | null, trackingUrl?: string | null, trackingStatus?: AnylogiOrderTrackingStatus | null, courierType?: CourierType | null, channelProvider: ChannelProvider, deliveryStatus: DeliveryStatus, customer?: { __typename?: 'AnylogiReadOrderCustomer', name: { __typename?: 'Name', first: string, last: string } } | null, warehouse: { __typename?: 'IdName', name: string }, account: { __typename?: 'IdName', id: string, name: string }, store: { __typename?: 'IdName', id: string, name: string } }> } };

export type AddShipperAddressMutationVariables = Exact<{
  input: ShipperAddressInput;
}>;


export type AddShipperAddressMutation = { addShipperAddress: { __typename?: 'ShipperAddress', accountId: string, websiteUrl?: string | null, personInCharge: string, id: string, email: string, country: Country, companyName?: string | null, postalCode?: string | null, city?: string | null, addressFirst: string, addressSecond?: string | null, region?: { __typename?: 'Region', id: string, name: string, localName: string } | null, phone: { __typename?: 'PhoneNumber', number: string, countryCode: Country } } };

export type GetShipperAddressesTotalQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  filter: GetShipperAddressFilter;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type GetShipperAddressesTotalQuery = { getShipperAddresses: { __typename?: 'shipperAddressesListResponse', total: number } };

export type EditShipperAddressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ShipperAddressInput;
}>;


export type EditShipperAddressMutation = { editShipperAddress: { __typename?: 'ShipperAddress', accountId: string, websiteUrl?: string | null, personInCharge: string, id: string, email: string, country: Country, companyName?: string | null, postalCode?: string | null, city?: string | null, addressFirst: string, addressSecond?: string | null, region?: { __typename?: 'Region', id: string, name: string, localName: string } | null, phone: { __typename?: 'PhoneNumber', number: string, countryCode: Country } } };

export type GetShipperAddressesListQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  filter: GetShipperAddressFilter;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type GetShipperAddressesListQuery = { getShipperAddresses: { __typename?: 'shipperAddressesListResponse', page: number, perPage: number, total: number, shipperAddresses: Array<{ __typename?: 'ShipperAddress', id: string, accountId: string, personInCharge: string, addressFirst: string, addressSecond?: string | null, city?: string | null, country: Country, postalCode?: string | null, default: boolean, region?: { __typename?: 'Region', id: string, localName: string, name: string, language: Language, provinceId: string } | null }> } };

export type WorkflowAuditLogFieldsFragment = { __typename?: 'WorkflowAuditLog', id: string, status: WorkflowAuditLogStatus, durationMillis: string, startedAt: string };

export type GetWorkflowAuditLogListQueryVariables = Exact<{
  workflowId: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetWorkflowAuditLogListQuery = { Workflow?: { __typename?: 'Workflow', title: string, id: string } | null, WorkflowAuditLogs?: { __typename?: 'WorkflowAuditLogs', total: number, auditLogs: Array<{ __typename?: 'WorkflowAuditLog', id: string, status: WorkflowAuditLogStatus, durationMillis: string, startedAt: string, errors: Array<{ __typename?: 'WorkflowAuditLogError', errorType: WorkflowAuditLogErrorType, errorLocation: WorkflowAuditLogErrorLocation }> }> } | null };

export type ConditionalSplitBlockFieldsFragment = { __typename?: 'ConditionalSplitBlock', combinator: ConditionsCombinator, nextMeetBlockId?: string | null, nextOtherBlockId?: string | null, conditions: Array<{ __typename?: 'WorkflowCondition', id: string, type: ConditionType, operator: ConditionOperator, values: Array<string> }> };

export type ActionBlockFieldsFragment = { __typename?: 'ActionSettingBlock', nextBlockId?: string | null, actions: Array<{ __typename?: 'WorkflowAction', id: string, delay?: { __typename?: 'DelayAction', time: number, unit: DelayUnit } | null, lineMessage?: { __typename?: 'LINEMessageAction', templateId: string } | null }> };

export type FlowBlockFieldsFragment = { __typename?: 'FlowBlock', id: string, actionBlock?: { __typename?: 'ActionSettingBlock', nextBlockId?: string | null, actions: Array<{ __typename?: 'WorkflowAction', id: string, delay?: { __typename?: 'DelayAction', time: number, unit: DelayUnit } | null, lineMessage?: { __typename?: 'LINEMessageAction', templateId: string } | null }> } | null, conditionalSplitBlock?: { __typename?: 'ConditionalSplitBlock', combinator: ConditionsCombinator, nextMeetBlockId?: string | null, nextOtherBlockId?: string | null, conditions: Array<{ __typename?: 'WorkflowCondition', id: string, type: ConditionType, operator: ConditionOperator, values: Array<string> }> } | null };

export type DuplicateWorkflowMutationVariables = Exact<{
  duplicateWorkflowId: Scalars['String']['input'];
}>;


export type DuplicateWorkflowMutation = { DuplicateWorkflow?: { __typename?: 'Workflow', id: string } | null };

export type DeleteWorkflowMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteWorkflowMutation = { DeleteWorkflow?: { __typename?: 'WorkflowStatusOk', ok: boolean } | null };

export type AddWorkflowMutationVariables = Exact<{
  body: WorkflowBodyInput;
  title: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
  schedule?: InputMaybe<WorkflowScheduleInput>;
  testMode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddWorkflowMutation = { AddWorkflow?: { __typename?: 'Workflow', id: string } | null };

export type UpdateWorkflowMutationVariables = Exact<{
  updateWorkflowId: Scalars['String']['input'];
  body: WorkflowBodyInput;
  schedule?: InputMaybe<WorkflowScheduleInput>;
  title: Scalars['String']['input'];
  testMode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateWorkflowMutation = { UpdateWorkflow?: { __typename?: 'Workflow', id: string } | null };

export type ToggleEnabledWorkflowMutationVariables = Exact<{
  id: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type ToggleEnabledWorkflowMutation = { ToggleEnableWorkflow?: { __typename?: 'WorkflowStatusOk', ok: boolean } | null };

export type GetSingleWorkflowQueryVariables = Exact<{
  workflowId: Scalars['String']['input'];
}>;


export type GetSingleWorkflowQuery = { Workflow?: { __typename?: 'Workflow', id: string, title: string, testMode: boolean, enabled: boolean, body: { __typename?: 'WorkflowBody', type: WorkflowType, initialFlowBlockId: string, blocks: Array<{ __typename?: 'FlowBlock', id: string, actionBlock?: { __typename?: 'ActionSettingBlock', nextBlockId?: string | null, actions: Array<{ __typename?: 'WorkflowAction', id: string, delay?: { __typename?: 'DelayAction', time: number, unit: DelayUnit } | null, lineMessage?: { __typename?: 'LINEMessageAction', templateId: string } | null }> } | null, conditionalSplitBlock?: { __typename?: 'ConditionalSplitBlock', combinator: ConditionsCombinator, nextMeetBlockId?: string | null, nextOtherBlockId?: string | null, conditions: Array<{ __typename?: 'WorkflowCondition', id: string, type: ConditionType, operator: ConditionOperator, values: Array<string> }> } | null }> }, schedule?: { __typename?: 'WorkflowSchedule', startAt: string, endAt: string } | null } | null };

export type GetWorkflowsQueryVariables = Exact<{
  storeId: Scalars['Long']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkflowsQuery = { Workflows?: { __typename?: 'Workflows', total: number, workflows: Array<{ __typename?: 'Workflow', id: string, title: string, enabled: boolean, createdAt: string, lastActivatedAt?: string | null }> } | null };

export type ValidateWorkflowStoreQueryVariables = Exact<{
  storeId: Scalars['Long']['input'];
}>;


export type ValidateWorkflowStoreQuery = { MdStore: { __typename?: 'MdStore', id: string, name: string } };

export type SaveAdSetMappingMutationVariables = Exact<{
  input: AdSetMappingSaveInput;
}>;


export type SaveAdSetMappingMutation = { saveAdSetMapping: { __typename?: 'AdSetMappingSavePayload', ok: boolean } };

export type AdSetMappingCampaignQueryVariables = Exact<{
  adSetMappingCampaignId: Scalars['Long']['input'];
  masterDataStoreId: Scalars['Long']['input'];
}>;


export type AdSetMappingCampaignQuery = { getAdSetMappingCampaign: { __typename?: 'AdSetMappingCampaignPayload', adSetMappingCampaignId: string, campaignId: string, campaignName: string, campaignStatus?: AdSetCampaignStatus | null, marginPercentage: string, status?: string | null } };

export type AdSetMappingGroupQueryVariables = Exact<{
  adSetMappingGroupId: Scalars['Long']['input'];
}>;


export type AdSetMappingGroupQuery = { getAdSetMappingGroup: { __typename?: 'AdSetMappingGroupInfoPayload', adGroupId: string, adGroupName: string, campaignId: string, campaignName: string, saleChannels: Array<string>, products: Array<{ __typename?: 'ProductAdSetMappingInfoPayload', media?: string | null, productCode: string, productId: string, productName: string, productVariantId: string, productVariantName: string, saleChannels?: Array<{ __typename?: 'ListingInfoPayload', country?: string | null, saleChannelType: SaleChannelType }> | null }> } };

export type AdSetMappingGroupsQueryVariables = Exact<{
  filter: AdSetMappingGroupListFilterInput;
}>;


export type AdSetMappingGroupsQuery = { getAdSetMappingGroups: { __typename?: 'AdSetMappingGroupListPayload', items: Array<{ __typename?: 'AdSetMappingGroupListInfoPayload', adGroupId: string, adGroupName: string, adGroupStatus?: AdSetGroupStatus | null, adSetMappingGroupId: string, numberOfProductVariants: number, numberOfSaleChannels: number, status?: string | null }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type DeleteAdvertisementConnectionMutationVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type DeleteAdvertisementConnectionMutation = { deleteDatasource: string };

export type CreateFacebookConnectionMutationVariables = Exact<{
  input: CreateDatasourceInput;
}>;


export type CreateFacebookConnectionMutation = { createDatasource: { __typename?: 'DatasourcePayload', id: string } };

export type CheckExistingFacebookConnectionQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<DatasourceFilterInput>;
  sortBy?: InputMaybe<DatasourceSortByInput>;
}>;


export type CheckExistingFacebookConnectionQuery = { allDatasources: { __typename?: 'DatasourcePayloadList', items: Array<{ __typename?: 'DatasourcePayload', type: DatasourceType }>, meta: { __typename?: 'ReportListMeta', total: number } } };

export type FacebookAdsAccountsQueryVariables = Exact<{
  datasourceTokenId: Scalars['Long']['input'];
}>;


export type FacebookAdsAccountsQuery = { facebookAdsAccounts: { __typename?: 'FacebookAdsAdAccountPayloadList', items: Array<{ __typename?: 'FacebookAdsAdAccount', id: string, name?: string | null }> } };

export type FacebookLoginUrlQueryVariables = Exact<{
  redirectUri: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type FacebookLoginUrlQuery = { facebookLoginUrl: string };

export type FacebookAdSetCampaignQueryVariables = Exact<{
  adSetMappingCampaignId: Scalars['Long']['input'];
  masterDataStoreId: Scalars['Long']['input'];
}>;


export type FacebookAdSetCampaignQuery = { getAdSetMappingCampaign: { __typename?: 'AdSetMappingCampaignPayload', campaignId: string, campaignName: string } };

export type FacebookAdSetsGroupsQueryVariables = Exact<{
  filter: AdSetMappingGroupListFilterInput;
}>;


export type FacebookAdSetsGroupsQuery = { getAdSetMappingGroups: { __typename: 'AdSetMappingGroupListPayload', items: Array<{ __typename: 'AdSetMappingGroupListInfoPayload', adGroupId: string, adGroupName: string, adGroupStatus?: AdSetGroupStatus | null, adSetMappingGroupId: string, numberOfProductVariants: number, numberOfSaleChannels: number, status?: string | null }>, meta: { __typename: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type SaveAdSetMappingMarginMutationVariables = Exact<{
  input: AdSetMappingSetMarginInput;
}>;


export type SaveAdSetMappingMarginMutation = { setAdSetMappingMargin: { __typename?: 'AdSetMappingSetMarginPayload', ok: boolean } };

export type GetFacebookAdSetMappingCampaignQueryVariables = Exact<{
  filter: AdSetMappingCampaignListFilterInput;
}>;


export type GetFacebookAdSetMappingCampaignQuery = { getAdSetMappingCampaigns: { __typename?: 'AdSetMappingCampaignsListPayload', items: Array<{ __typename?: 'AdSetMappingCampaignPayload', adSetMappingCampaignId: string, campaignId: string, campaignName: string, campaignStatus?: AdSetCampaignStatus | null, marginPercentage: string, status?: string | null }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type GetFacebookDetailQueryVariables = Exact<{
  datasourceId: Scalars['Long']['input'];
}>;


export type GetFacebookDetailQuery = { datasource?: { __typename?: 'DatasourcePayload', id: string, type: DatasourceType, status: DatasourceStatus, statusDetail?: Record<string, any> | null, isActive: boolean, createdAt: string, updatedAt: string, setting?: Record<string, any> | null, user?: { __typename?: 'MdUser', id: string, firstName: string, lastName?: string | null } | null } | null };

export type CreateGoogleAdsConnectionMutationVariables = Exact<{
  input: CreateDatasourceInput;
}>;


export type CreateGoogleAdsConnectionMutation = { createDatasource: { __typename?: 'DatasourcePayload', id: string } };

export type CheckExistingGoogleAdsConnectionQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<DatasourceFilterInput>;
  sortBy?: InputMaybe<DatasourceSortByInput>;
}>;


export type CheckExistingGoogleAdsConnectionQuery = { allDatasources: { __typename?: 'DatasourcePayloadList', items: Array<{ __typename?: 'DatasourcePayload', type: DatasourceType }>, meta: { __typename?: 'ReportListMeta', total: number } } };

export type GoogleAdsClientAccountsQueryVariables = Exact<{
  datasourceTokenId: Scalars['Long']['input'];
  customerId: Scalars['String']['input'];
}>;


export type GoogleAdsClientAccountsQuery = { googleAdsClientAccounts: { __typename?: 'GoogleAdsAccountPayloadList', items: Array<{ __typename?: 'GoogleAdsAccountPayload', id: string, name?: string | null, manager: boolean }> } };

export type GoogleAdsCustomersQueryVariables = Exact<{
  datasourceTokenId: Scalars['Long']['input'];
}>;


export type GoogleAdsCustomersQuery = { googleAdsCustomers: { __typename?: 'GoogleAdsCustomerPayloadList', items: Array<{ __typename?: 'GoogleAdsCustomerPayload', id: string, descriptiveName?: string | null }> } };

export type GoogleAdsLoginUrlQueryVariables = Exact<{
  redirectUri: Scalars['String']['input'];
  type: GoogleLoginUrlType;
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type GoogleAdsLoginUrlQuery = { googleLoginUrl: string };

export type GoogleAdsAdSetCampaignQueryVariables = Exact<{
  adSetMappingCampaignId: Scalars['Long']['input'];
  masterDataStoreId: Scalars['Long']['input'];
}>;


export type GoogleAdsAdSetCampaignQuery = { getAdSetMappingCampaign: { __typename?: 'AdSetMappingCampaignPayload', campaignId: string, campaignName: string } };

export type GoogleAdsAdSetsGroupsQueryVariables = Exact<{
  filter: AdSetMappingGroupListFilterInput;
}>;


export type GoogleAdsAdSetsGroupsQuery = { getAdSetMappingGroups: { __typename: 'AdSetMappingGroupListPayload', items: Array<{ __typename: 'AdSetMappingGroupListInfoPayload', adGroupId: string, adGroupName: string, adGroupStatus?: AdSetGroupStatus | null, adSetMappingGroupId: string, numberOfProductVariants: number, numberOfSaleChannels: number, status?: string | null }>, meta: { __typename: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type GetGoogleAdsAdSetMappingCampaignQueryVariables = Exact<{
  filter: AdSetMappingCampaignListFilterInput;
}>;


export type GetGoogleAdsAdSetMappingCampaignQuery = { getAdSetMappingCampaigns: { __typename?: 'AdSetMappingCampaignsListPayload', items: Array<{ __typename?: 'AdSetMappingCampaignPayload', adSetMappingCampaignId: string, campaignId: string, campaignName: string, campaignStatus?: AdSetCampaignStatus | null, marginPercentage: string, status?: string | null }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type GetGoogleAdsDetailQueryVariables = Exact<{
  datasourceId: Scalars['Long']['input'];
}>;


export type GetGoogleAdsDetailQuery = { datasource?: { __typename?: 'DatasourcePayload', id: string, type: DatasourceType, status: DatasourceStatus, statusDetail?: Record<string, any> | null, isActive: boolean, createdAt: string, updatedAt: string, setting?: Record<string, any> | null, user?: { __typename?: 'MdUser', id: string, firstName: string, lastName?: string | null } | null } | null };

export type CreateTikTokConnectionMutationVariables = Exact<{
  input: CreateDatasourceInput;
}>;


export type CreateTikTokConnectionMutation = { createDatasource: { __typename?: 'DatasourcePayload', id: string } };

export type CheckExistingTikTokConnectionQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<DatasourceFilterInput>;
  sortBy?: InputMaybe<DatasourceSortByInput>;
}>;


export type CheckExistingTikTokConnectionQuery = { allDatasources: { __typename?: 'DatasourcePayloadList', items: Array<{ __typename?: 'DatasourcePayload', type: DatasourceType }>, meta: { __typename?: 'ReportListMeta', total: number } } };

export type TikTokAdsAdAccountsQueryVariables = Exact<{
  datasourceTokenId: Scalars['Long']['input'];
}>;


export type TikTokAdsAdAccountsQuery = { tikTokAdsAdAccounts: { __typename?: 'TikTokAdsAdAccountPayloadList', items: Array<{ __typename?: 'TikTokAdsAdAccountPayload', advertiserId: string, advertiserName: string }> } };

export type TikTokAdsLoginUrlQueryVariables = Exact<{
  redirectUri: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type TikTokAdsLoginUrlQuery = { tikTokAdsLoginUrl: string };

export type TikTokAdSetCampaignQueryVariables = Exact<{
  adSetMappingCampaignId: Scalars['Long']['input'];
  masterDataStoreId: Scalars['Long']['input'];
}>;


export type TikTokAdSetCampaignQuery = { getAdSetMappingCampaign: { __typename?: 'AdSetMappingCampaignPayload', campaignId: string, campaignName: string } };

export type TikTokAdSetsGroupsQueryVariables = Exact<{
  filter: AdSetMappingGroupListFilterInput;
}>;


export type TikTokAdSetsGroupsQuery = { getAdSetMappingGroups: { __typename: 'AdSetMappingGroupListPayload', items: Array<{ __typename: 'AdSetMappingGroupListInfoPayload', adGroupId: string, adGroupName: string, adGroupStatus?: AdSetGroupStatus | null, adSetMappingGroupId: string, numberOfProductVariants: number, numberOfSaleChannels: number, status?: string | null }>, meta: { __typename: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type GetTikTokAdSetMappingCampaignQueryVariables = Exact<{
  filter: AdSetMappingCampaignListFilterInput;
}>;


export type GetTikTokAdSetMappingCampaignQuery = { getAdSetMappingCampaigns: { __typename?: 'AdSetMappingCampaignsListPayload', items: Array<{ __typename?: 'AdSetMappingCampaignPayload', adSetMappingCampaignId: string, campaignId: string, campaignName: string, campaignStatus?: AdSetCampaignStatus | null, marginPercentage: string, status?: string | null }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type GetTikTokDetailQueryVariables = Exact<{
  datasourceId: Scalars['Long']['input'];
}>;


export type GetTikTokDetailQuery = { datasource?: { __typename?: 'DatasourcePayload', id: string, type: DatasourceType, status: DatasourceStatus, statusDetail?: Record<string, any> | null, isActive: boolean, createdAt: string, updatedAt: string, setting?: Record<string, any> | null, user?: { __typename?: 'MdUser', id: string, firstName: string, lastName?: string | null } | null } | null };

export type YahooAdSetCampaignQueryVariables = Exact<{
  adSetMappingCampaignId: Scalars['Long']['input'];
  masterDataStoreId: Scalars['Long']['input'];
}>;


export type YahooAdSetCampaignQuery = { getAdSetMappingCampaign: { __typename?: 'AdSetMappingCampaignPayload', campaignId: string, campaignName: string } };

export type YahooAdSetsGroupsQueryVariables = Exact<{
  filter: AdSetMappingGroupListFilterInput;
}>;


export type YahooAdSetsGroupsQuery = { getAdSetMappingGroups: { __typename: 'AdSetMappingGroupListPayload', items: Array<{ __typename: 'AdSetMappingGroupListInfoPayload', adGroupId: string, adGroupName: string, adGroupStatus?: AdSetGroupStatus | null, adSetMappingGroupId: string, numberOfProductVariants: number, numberOfSaleChannels: number, status?: string | null }>, meta: { __typename: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type CreateYahooConnectionMutationVariables = Exact<{
  input: CreateDatasourceInput;
}>;


export type CreateYahooConnectionMutation = { createDatasource: { __typename?: 'DatasourcePayload', id: string } };

export type CheckExistingYahooConnectionQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<DatasourceFilterInput>;
  sortBy?: InputMaybe<DatasourceSortByInput>;
}>;


export type CheckExistingYahooConnectionQuery = { allDatasources: { __typename?: 'DatasourcePayloadList', items: Array<{ __typename?: 'DatasourcePayload', type: DatasourceType }>, meta: { __typename?: 'ReportListMeta', total: number } } };

export type YahooAdsAdAccountsQueryVariables = Exact<{
  input: YahooAdsAccountsInput;
}>;


export type YahooAdsAdAccountsQuery = { yahooAdsAccounts: { __typename?: 'YahooAdsAccountsPayload', accounts: Array<{ __typename?: 'YahooAdsAccountPayload', id: string, name: string }> } };

export type YahooAdsLoginUrlQueryVariables = Exact<{
  input: YahooAdsLoginUrlInput;
}>;


export type YahooAdsLoginUrlQuery = { yahooAdsLoginUrl: { __typename?: 'YahooAdsLoginUrlPayload', loginUrl: string } };

export type GetYahooAdSetMappingCampaignQueryVariables = Exact<{
  filter: AdSetMappingCampaignListFilterInput;
}>;


export type GetYahooAdSetMappingCampaignQuery = { getAdSetMappingCampaigns: { __typename?: 'AdSetMappingCampaignsListPayload', items: Array<{ __typename?: 'AdSetMappingCampaignPayload', adSetMappingCampaignId: string, campaignId: string, campaignName: string, campaignStatus?: AdSetCampaignStatus | null, marginPercentage: string, status?: string | null }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type GetYahooDetailQueryVariables = Exact<{
  datasourceId: Scalars['Long']['input'];
}>;


export type GetYahooDetailQuery = { datasource?: { __typename?: 'DatasourcePayload', id: string, type: DatasourceType, status: DatasourceStatus, statusDetail?: Record<string, any> | null, isActive: boolean, createdAt: string, updatedAt: string, setting?: Record<string, any> | null, user?: { __typename?: 'MdUser', id: string, firstName: string, lastName?: string | null } | null } | null };

export type DeleteAnalyticsConnectionMutationVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type DeleteAnalyticsConnectionMutation = { deleteDatasource: string };

export type CreateGoogleGa4ConnectionMutationVariables = Exact<{
  input: CreateDatasourceInput;
}>;


export type CreateGoogleGa4ConnectionMutation = { createDatasource: { __typename?: 'DatasourcePayload', id: string, type: DatasourceType } };

export type CheckExistingGa4ConnectionQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<DatasourceFilterInput>;
  sortBy?: InputMaybe<DatasourceSortByInput>;
}>;


export type CheckExistingGa4ConnectionQuery = { allDatasources: { __typename?: 'DatasourcePayloadList', items: Array<{ __typename?: 'DatasourcePayload', type: DatasourceType }>, meta: { __typename?: 'ReportListMeta', total: number } } };

export type GoogleAnalytics4AccountsQueryVariables = Exact<{
  datasourceTokenId: Scalars['Long']['input'];
}>;


export type GoogleAnalytics4AccountsQuery = { googleAnalytics4Accounts: { __typename?: 'GoogleAnalytics4AccountSummaries', accountSummaries: Array<{ __typename?: 'GoogleAnalytics4AccountSummary', account: string, displayName: string, name: string, propertySummaries?: Array<{ __typename?: 'GoogleAnalytics4PropertySummary', displayName: string, property: string, propertyType?: string | null }> | null }> } };

export type GoogleLoginUrlQueryVariables = Exact<{
  redirectUri: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  type: GoogleLoginUrlType;
}>;


export type GoogleLoginUrlQuery = { googleLoginUrl: string };

export type GetGoogleGa4DetailQueryVariables = Exact<{
  datasourceId: Scalars['Long']['input'];
}>;


export type GetGoogleGa4DetailQuery = { datasource?: { __typename?: 'DatasourcePayload', id: string, type: DatasourceType, status: DatasourceStatus, statusDetail?: Record<string, any> | null, isActive: boolean, createdAt: string, updatedAt: string, setting?: Record<string, any> | null, user?: { __typename?: 'MdUser', id: string, firstName: string, lastName?: string | null } | null } | null };

export type DeleteCourierAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCourierAccountMutation = { deleteCourierAccount: { __typename?: 'StatusOk', ok: boolean } };

export type DhlCreateCourierMutationVariables = Exact<{
  input: DhlCreateCourierInput;
}>;


export type DhlCreateCourierMutation = { DHLCreateCourier: { __typename?: 'CourierAccountDetails', id: string, merchantId: string, created: any, updated: any, status: CourierStatus, crossBorderCourierProvider: CrossBorderCourierProvider, account: { __typename?: 'IdName', id: string, name: string }, courierDetails?: { __typename?: 'DHLAccountDetails', dhlAccountNumber: string, dhlApiKey: string, dhlApiSecret: string, dhlCorporateNumber?: string | null, dhlCorporateNumberInJP: boolean, dhlShipperAddressId: string, dhlSignatureImageURL?: string | null, dhlSupportPackageTypes?: Array<DhlPackageType> | null } | { __typename?: 'FedExAccountDetails' } | { __typename?: 'JapanPostAccountDetails' } | { __typename?: 'UPSAccountDetails' } | null } };

export type DhlUpdateCourierMutationVariables = Exact<{
  input: DhlUpdateCourierInput;
}>;


export type DhlUpdateCourierMutation = { DHLUpdateCourier: { __typename?: 'CourierAccountDetails', id: string, merchantId: string, created: any, updated: any, status: CourierStatus, crossBorderCourierProvider: CrossBorderCourierProvider, account: { __typename?: 'IdName', id: string, name: string }, courierDetails?: { __typename?: 'DHLAccountDetails', dhlAccountNumber: string, dhlApiKey: string, dhlApiSecret: string, dhlCorporateNumber?: string | null, dhlCorporateNumberInJP: boolean, dhlShipperAddressId: string, dhlSignatureImageURL?: string | null, dhlSupportPackageTypes?: Array<DhlPackageType> | null } | { __typename?: 'FedExAccountDetails' } | { __typename?: 'JapanPostAccountDetails' } | { __typename?: 'UPSAccountDetails' } | null } };

export type GetDhlCourierAccountProviderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDhlCourierAccountProviderQuery = { getCourierAccount: { __typename?: 'CourierAccountDetails', id: string, merchantId: string, created: any, updated: any, status: CourierStatus, crossBorderCourierProvider: CrossBorderCourierProvider, account: { __typename?: 'IdName', id: string, name: string }, courierDetails?: { __typename?: 'DHLAccountDetails', dhlAccountNumber: string, dhlApiKey: string, dhlApiSecret: string, dhlCorporateNumber?: string | null, dhlCorporateNumberInJP: boolean, dhlShipperAddressId: string, dhlSignatureImageURL?: string | null, dhlSupportPackageTypes?: Array<DhlPackageType> | null } | { __typename?: 'FedExAccountDetails' } | { __typename?: 'JapanPostAccountDetails' } | { __typename?: 'UPSAccountDetails' } | null } };

export type FedExCreateCourierMutationVariables = Exact<{
  input: FedExCreateCourier;
}>;


export type FedExCreateCourierMutation = { FedExCreateCourier: { __typename?: 'CourierAccountDetails', id: string, merchantId: string, created: any, updated: any, status: CourierStatus, crossBorderCourierProvider: CrossBorderCourierProvider, account: { __typename?: 'IdName', id: string, name: string }, courierDetails?: { __typename?: 'DHLAccountDetails' } | { __typename?: 'FedExAccountDetails', fedExAccountNumber: string, fedExSupportPackageTypes?: Array<FedExPackageType> | null, fedExSignatureOption: FedExSignatureOptionType, fedExContactName: string, fedExLetterheadImageURL?: string | null, fedExSignatureImageURL?: string | null, fedExShipperAddressId: string } | { __typename?: 'JapanPostAccountDetails' } | { __typename?: 'UPSAccountDetails' } | null } };

export type FedExAddressValidationMutationVariables = Exact<{
  input: FedExAddressValidationInput;
}>;


export type FedExAddressValidationMutation = { FedExAddressValidation: { __typename?: 'FedExAddressValidationDetails', accountAuthToken: string, email?: string | null, phone?: string | null, supportedValidationOptions: Array<ValidationOption> } };

export type FedExGeneratePinCodeMutationVariables = Exact<{
  input: FedExGeneratePinCodeInput;
}>;


export type FedExGeneratePinCodeMutation = { FedExGeneratePinCode: { __typename?: 'StatusOk', ok: boolean } };

export type FedExUpdateCourierMutationVariables = Exact<{
  input: FedExUpdateCourier;
}>;


export type FedExUpdateCourierMutation = { FedExUpdateCourier: { __typename?: 'CourierAccountDetails', id: string, merchantId: string, created: any, updated: any, status: CourierStatus, crossBorderCourierProvider: CrossBorderCourierProvider, account: { __typename?: 'IdName', id: string, name: string }, courierDetails?: { __typename?: 'DHLAccountDetails' } | { __typename?: 'FedExAccountDetails', fedExAccountNumber: string, fedExSupportPackageTypes?: Array<FedExPackageType> | null, fedExSignatureOption: FedExSignatureOptionType, fedExContactName: string, fedExLetterheadImageURL?: string | null, fedExSignatureImageURL?: string | null, fedExShipperAddressId: string } | { __typename?: 'JapanPostAccountDetails' } | { __typename?: 'UPSAccountDetails' } | null } };

export type GetFedexCourierAccountProviderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFedexCourierAccountProviderQuery = { getCourierAccount: { __typename?: 'CourierAccountDetails', id: string, merchantId: string, created: any, updated: any, status: CourierStatus, crossBorderCourierProvider: CrossBorderCourierProvider, account: { __typename?: 'IdName', id: string, name: string }, courierDetails?: { __typename?: 'DHLAccountDetails' } | { __typename?: 'FedExAccountDetails', fedExAccountNumber: string, fedExSupportPackageTypes?: Array<FedExPackageType> | null, fedExSignatureOption: FedExSignatureOptionType, fedExContactName: string, fedExLetterheadImageURL?: string | null, fedExSignatureImageURL?: string | null, fedExShipperAddressId: string } | { __typename?: 'JapanPostAccountDetails' } | { __typename?: 'UPSAccountDetails' } | null } };

export type JapanPostCreateCourierMutationVariables = Exact<{
  input: JapanPostCreateCourierInput;
}>;


export type JapanPostCreateCourierMutation = { JapanPostCreateCourier: { __typename?: 'CourierAccountDetails', id: string, merchantId: string, created: any, updated: any, status: CourierStatus, crossBorderCourierProvider: CrossBorderCourierProvider, account: { __typename?: 'IdName', id: string, name: string }, courierDetails?: { __typename?: 'DHLAccountDetails' } | { __typename?: 'FedExAccountDetails' } | { __typename?: 'JapanPostAccountDetails', japanPostCardNumber?: string | null, japanPostSupportServiceCodes?: Array<JapanPostServiceCode> | null } | { __typename?: 'UPSAccountDetails' } | null } };

export type JapanPostUpdateCourierMutationVariables = Exact<{
  input: JapanPostUpdateCourierInput;
}>;


export type JapanPostUpdateCourierMutation = { JapanPostUpdateCourier: { __typename?: 'CourierAccountDetails', id: string, merchantId: string, created: any, updated: any, status: CourierStatus, crossBorderCourierProvider: CrossBorderCourierProvider, account: { __typename?: 'IdName', id: string, name: string }, courierDetails?: { __typename?: 'DHLAccountDetails' } | { __typename?: 'FedExAccountDetails' } | { __typename?: 'JapanPostAccountDetails', japanPostCardNumber?: string | null, japanPostSupportServiceCodes?: Array<JapanPostServiceCode> | null } | { __typename?: 'UPSAccountDetails' } | null } };

export type GetJapanPostCourierAccountProviderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetJapanPostCourierAccountProviderQuery = { getCourierAccount: { __typename?: 'CourierAccountDetails', id: string, merchantId: string, created: any, updated: any, status: CourierStatus, crossBorderCourierProvider: CrossBorderCourierProvider, account: { __typename?: 'IdName', id: string, name: string }, courierDetails?: { __typename?: 'DHLAccountDetails' } | { __typename?: 'FedExAccountDetails' } | { __typename?: 'JapanPostAccountDetails', japanPostCardNumber?: string | null, japanPostSupportServiceCodes?: Array<JapanPostServiceCode> | null } | { __typename?: 'UPSAccountDetails' } | null } };

export type UpsAddAccountNumberMutationVariables = Exact<{
  courierId: Scalars['ID']['input'];
  accountNumber: Scalars['String']['input'];
}>;


export type UpsAddAccountNumberMutation = { UPSAddAccountNumber: { __typename?: 'CourierAccountDetails', id: string, merchantId: string, created: any, updated: any, status: CourierStatus, crossBorderCourierProvider: CrossBorderCourierProvider, account: { __typename?: 'IdName', id: string, name: string }, courierDetails?: { __typename?: 'DHLAccountDetails' } | { __typename?: 'FedExAccountDetails' } | { __typename?: 'JapanPostAccountDetails' } | { __typename?: 'UPSAccountDetails', upsAccountNumber?: string | null } | null } };

export type UpsInstallationMutationVariables = Exact<{
  merchantId: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
  callbackUrl: Scalars['String']['input'];
}>;


export type UpsInstallationMutation = { UPSInstallation: { __typename?: 'UPSPath', url: string, courierID: string } };

export type UpsOpenAccountMutationVariables = Exact<{
  input: UpsOpenAccountInput;
}>;


export type UpsOpenAccountMutation = { UPSOpenAccount: { __typename?: 'CourierAccountDetails', id: string, merchantId: string, created: any, updated: any, status: CourierStatus, crossBorderCourierProvider: CrossBorderCourierProvider, account: { __typename?: 'IdName', id: string, name: string }, courierDetails?: { __typename?: 'DHLAccountDetails' } | { __typename?: 'FedExAccountDetails' } | { __typename?: 'JapanPostAccountDetails' } | { __typename?: 'UPSAccountDetails', upsAccountNumber?: string | null } | null } };

export type UpsRegisterCustomerMutationVariables = Exact<{
  input: UpsRegisterCustomerInput;
}>;


export type UpsRegisterCustomerMutation = { UPSRegisterCustomer: { __typename?: 'StatusOk', ok: boolean } };

export type GetUpsCourierAccountProviderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUpsCourierAccountProviderQuery = { getCourierAccount: { __typename?: 'CourierAccountDetails', id: string, merchantId: string, created: any, updated: any, status: CourierStatus, crossBorderCourierProvider: CrossBorderCourierProvider, account: { __typename?: 'IdName', id: string, name: string }, courierDetails?: { __typename?: 'DHLAccountDetails' } | { __typename?: 'FedExAccountDetails' } | { __typename?: 'JapanPostAccountDetails' } | { __typename?: 'UPSAccountDetails', upsAccountNumber?: string | null } | null } };

export type ConnectLazadaMutationVariables = Exact<{
  input: ConnectLazadaRequest;
}>;


export type ConnectLazadaMutation = { ConnectLazada?: { __typename?: 'ConnectLazadaResponseSuccess', connectionId: string } | { __typename?: 'UnknownErrorConnectLazadaError', message: string } | null };

export type GenerateLinePublicKeyMutationVariables = Exact<{
  input: StoreChatLinePublicKeyGenerateRequestV2;
}>;


export type GenerateLinePublicKeyMutation = { StoreChatLinePublicKeyGenerateV2?: { __typename?: 'StoreChatLinePublicKeyGenerateResponseV2', publicKeyJson: string } | null };

export type ConnectLineChatMutationVariables = Exact<{
  input: StoreChatLineConnectRequestV2;
}>;


export type ConnectLineChatMutation = { StoreChatLineConnectV2?: { __typename?: 'StoreChatLineConnectResponseV2', storeId: string } | null };

export type ConnectLineShopifyByLiffUrlMutationVariables = Exact<{
  input: StoreChatLineConnectionUpdateRequest;
}>;


export type ConnectLineShopifyByLiffUrlMutation = { StoreChatLineConnectionUpdate?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type CrmConnection_InstagramStoreChat_Fragment = { __typename?: 'InstagramStoreChat', id: string, name: string, type: ChatType };

export type CrmConnection_LazadaStoreChat_Fragment = { __typename?: 'LazadaStoreChat', id: string, name: string, type: ChatType };

export type CrmConnection_LineStoreChat_Fragment = { __typename?: 'LineStoreChat', id: string, name: string, type: ChatType };

export type CrmConnection_MessengerStoreChat_Fragment = { __typename?: 'MessengerStoreChat', id: string, name: string, type: ChatType };

export type CrmConnection_ShopeeStoreChat_Fragment = { __typename?: 'ShopeeStoreChat', id: string, name: string, type: ChatType };

export type CrmConnection_TikTokShopStoreChat_Fragment = { __typename?: 'TikTokShopStoreChat', id: string, name: string, type: ChatType };

export type CrmConnection_WhatsAppStoreChat_Fragment = { __typename?: 'WhatsAppStoreChat', id: string, name: string, type: ChatType };

export type CrmConnectionFragment = CrmConnection_InstagramStoreChat_Fragment | CrmConnection_LazadaStoreChat_Fragment | CrmConnection_LineStoreChat_Fragment | CrmConnection_MessengerStoreChat_Fragment | CrmConnection_ShopeeStoreChat_Fragment | CrmConnection_TikTokShopStoreChat_Fragment | CrmConnection_WhatsAppStoreChat_Fragment;

export type CrmInstagramConnectionFragment = { __typename?: 'InstagramStoreChat', username: string, pageId: string, isPrimaryReceiver: boolean, id: string, name: string, type: ChatType, tokenStatusV2: { __typename: 'MTS_INVALID_TOKEN' } | { __typename?: 'MTS_TOKEN_MISSING_SCOPE', scopes: Array<string> } | { __typename?: 'MTS_UNKNOWN', message: string } | { __typename: 'MTS_WORKING' } };

export type CrmMessengerConnectionFragment = { __typename?: 'MessengerStoreChat', pageId: string, isPrimaryReceiver: boolean, id: string, name: string, type: ChatType, tokenStatusV2: { __typename: 'MTS_INVALID_TOKEN' } | { __typename?: 'MTS_TOKEN_MISSING_SCOPE', scopes: Array<string> } | { __typename?: 'MTS_UNKNOWN', message: string } | { __typename: 'MTS_WORKING' } };

export type CrmLineConnectionFragment = { __typename?: 'LineStoreChat', isRefreshTokenSuccess: boolean, liffUrl?: string | null, id: string, name: string, type: ChatType };

export type CrmLazadaConnectionFragment = { __typename?: 'LazadaStoreChat', createdAt: string, tokenUpdatedSuccessfully: boolean, connectionExpiryTime: string, id: string, name: string, type: ChatType };

export type CrmWhatsAppConnectionFragment = { __typename?: 'WhatsAppStoreChat', businessAccountId: string, optInEnabled: boolean, id: string, name: string, type: ChatType, phones: Array<{ __typename?: 'WhatsAppPhoneNumber', number: string, name: string, id: string }> };

export type CrmShopeeConnectionFragment = { __typename?: 'ShopeeStoreChat', shopId: string, tokenUpdatedSuccessfully: boolean, connectionExpiryTime: string, id: string, name: string, type: ChatType };

export type CrmTikTokShopConnectionFragment = { __typename?: 'TikTokShopStoreChat', id: string, name: string, type: ChatType };

export type ConnectToFacebookV2MutationVariables = Exact<{
  input: ConnectToFacebookRequestV2Input;
}>;


export type ConnectToFacebookV2Mutation = { ConnectToFacebookV2?: { __typename?: 'AccountAlreadyHaveConnection', message: string } | { __typename?: 'ConnectToFacebookResponseSuccess', connectionId: string } | { __typename?: 'MessengerNotSupportChatPlugInWithAnonymousUserFacebookError', message: string } | { __typename?: 'NoInstagramAccountConnectToFacebookError', message: string } | { __typename?: 'PageHaveConnectedToOtherStore', message: string, storeId: string } | { __typename?: 'UnknownErrorConnectToFacebookError', message: string } | null };

export type RefreshFacebookTokenConnectionMutationVariables = Exact<{
  input: ConnectToFacebookRequestV2Input;
}>;


export type RefreshFacebookTokenConnectionMutation = { RefreshFacebookTokenConnection?: { __typename?: 'NoInstagramAccountRefreshTokenError', message: string } | { __typename?: 'RefreshFacebookTokenResponseSuccess', connectionId: string } | { __typename?: 'UnknownErrorRefreshTokenError', message: string } | { __typename?: 'WrongPageSelectedRefreshTokenError', message: string, pageId: string } | null };

export type CrmStoreConnectionQueryVariables = Exact<{
  input: AnyChatGetStoreRequest;
}>;


export type CrmStoreConnectionQuery = { AnyChatStore?: { __typename?: 'AnyChatStore', id: string, name: string, isCrmMerchantEnabled: boolean, chats: Array<{ __typename?: 'InstagramStoreChat', username: string, pageId: string, isPrimaryReceiver: boolean, id: string, name: string, type: ChatType, tokenStatusV2: { __typename: 'MTS_INVALID_TOKEN' } | { __typename?: 'MTS_TOKEN_MISSING_SCOPE', scopes: Array<string> } | { __typename?: 'MTS_UNKNOWN', message: string } | { __typename: 'MTS_WORKING' } } | { __typename?: 'LazadaStoreChat', createdAt: string, tokenUpdatedSuccessfully: boolean, connectionExpiryTime: string, id: string, name: string, type: ChatType } | { __typename?: 'LineStoreChat', isRefreshTokenSuccess: boolean, liffUrl?: string | null, id: string, name: string, type: ChatType } | { __typename?: 'MessengerStoreChat', pageId: string, isPrimaryReceiver: boolean, id: string, name: string, type: ChatType, tokenStatusV2: { __typename: 'MTS_INVALID_TOKEN' } | { __typename?: 'MTS_TOKEN_MISSING_SCOPE', scopes: Array<string> } | { __typename?: 'MTS_UNKNOWN', message: string } | { __typename: 'MTS_WORKING' } } | { __typename?: 'ShopeeStoreChat', shopId: string, tokenUpdatedSuccessfully: boolean, connectionExpiryTime: string, id: string, name: string, type: ChatType } | { __typename?: 'TikTokShopStoreChat', id: string, name: string, type: ChatType } | { __typename?: 'WhatsAppStoreChat', businessAccountId: string, optInEnabled: boolean, id: string, name: string, type: ChatType, phones: Array<{ __typename?: 'WhatsAppPhoneNumber', number: string, name: string, id: string }> }> } | null };

export type CrmStoreConnectionStatusQueryVariables = Exact<{
  input: AnyChatGetStoreRequest;
}>;


export type CrmStoreConnectionStatusQuery = { AnyChatStore?: { __typename?: 'AnyChatStore', id: string, chats: Array<{ __typename?: 'InstagramStoreChat', id: string, tokenStatusV2: { __typename: 'MTS_INVALID_TOKEN' } | { __typename?: 'MTS_TOKEN_MISSING_SCOPE', scopes: Array<string> } | { __typename?: 'MTS_UNKNOWN', message: string } | { __typename: 'MTS_WORKING' } } | { __typename?: 'LazadaStoreChat', id: string } | { __typename?: 'LineStoreChat', id: string } | { __typename?: 'MessengerStoreChat', id: string, tokenStatusV2: { __typename: 'MTS_INVALID_TOKEN' } | { __typename?: 'MTS_TOKEN_MISSING_SCOPE', scopes: Array<string> } | { __typename?: 'MTS_UNKNOWN', message: string } | { __typename: 'MTS_WORKING' } } | { __typename?: 'ShopeeStoreChat', id: string } | { __typename?: 'TikTokShopStoreChat', id: string } | { __typename?: 'WhatsAppStoreChat', id: string }> } | null };

export type ConnectShopeeChatMutationVariables = Exact<{
  input: ConnectShopeeChatRequestInput;
}>;


export type ConnectShopeeChatMutation = { ConnectShopeeChat?: { __typename?: 'ConnectShopeeChatContinueSelectShopResponse', tempConnectionId: string, shops: Array<{ __typename?: 'ShopeeContinueShopSelectionItem', shopId: string, displayName: string }> } | { __typename?: 'ConnectShopeeChatSuccessResponse', connectionId: string } | null };

export type RefreshShopeeChatMutationVariables = Exact<{
  input: RefreshShopeeConnectionRequest;
}>;


export type RefreshShopeeChatMutation = { RefreshShopeeChatConnection?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type GenerateShopeeChatAuthorizationLinkQueryVariables = Exact<{
  input: GenerateShopeeChatAuthorizationLinkRequest;
}>;


export type GenerateShopeeChatAuthorizationLinkQuery = { GenerateShopeeChatAuthorizationLink?: { __typename?: 'GenerateShopeeChatAuthorizationLinkResponse', url: string } | null };

export type ConnectTikTokShopChatMutationVariables = Exact<{
  input: ConnectTikTokShopRequest;
}>;


export type ConnectTikTokShopChatMutation = { ConnectTikTokShop?: { __typename?: 'ConnectTikTokShopResponse', id: string } | null };

export type ConnectToWhatsAppMutationVariables = Exact<{
  input: ConnectWhatsAppRequestInput;
}>;


export type ConnectToWhatsAppMutation = { ConnectToWhatsApp?: { __typename?: 'ConnectToWhatsAppAccountAlreadyHaveConnection', message: string } | { __typename?: 'ConnectToWhatsAppResponseSuccess', connectionId: string } | { __typename?: 'UnknownErrorConnectToWhatsAppError', message: string } | null };

export type UpdateWhatsAppOptInSettingMutationVariables = Exact<{
  input: UpdateWhatsAppOptInSettingRequest;
}>;


export type UpdateWhatsAppOptInSettingMutation = { UpdateWhatsAppOptInSetting?: { __typename?: 'AnyChatOKResponse', ok: boolean } | null };

export type InventoryFileUploadHistoryQueryVariables = Exact<{
  input: InventoryFileUploadHistoryInput;
}>;


export type InventoryFileUploadHistoryQuery = { inventoryFileUploadHistory: { __typename?: 'InventoryFileUploadHistoryPayload', items: Array<{ __typename?: 'FileUploadHistoryItemPayload', fileName: string, fileType: InventoryFileType, fileUrl?: string | null, saleChannelType?: SaleChannelType | null, status: FileUploadHistoryStatusReporting, uploadDate: string }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type FileUploadMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
}>;


export type FileUploadMutation = { fileUpload: { __typename?: 'FileUploadPayload', fileName: string, fileUri: string, signedUrl: string } };

export type UploadInventoryFileMutationVariables = Exact<{
  input: InventoryUploadInput;
}>;


export type UploadInventoryFileMutation = { uploadInventoryFile: { __typename?: 'UploadInventoryFilePayload', uploadId: string } };

export type ConnectChannelToWarehouseMutationVariables = Exact<{
  storeId: Scalars['Long']['input'];
  saleChannelId: Scalars['Long']['input'];
  externalStoreId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
  merchantId: Scalars['String']['input'];
}>;


export type ConnectChannelToWarehouseMutation = { connectChannelToWarehouse: { __typename?: 'StatusOk', ok: boolean } };

export type ConnectedSalesChannelsQueryVariables = Exact<{
  mdStoreId: Scalars['Long']['input'];
}>;


export type ConnectedSalesChannelsQuery = { MdStore: { __typename?: 'MdStore', id: string, channels: Array<{ __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType, isActive: boolean, data: { __typename?: 'AmazonSaleChannelData', amazonMarketplace: AmazonSellerCentralMarketplace } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData', lazadaMarketplace: LazadaMarketplace } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData', qoo10Marketplace: Qoo10Marketplace } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData', shopeeMarketplace: ShopeeMarketplace } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData', tiktokMarketplace: TikTokRegion } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' } }> } };

export type GetWarehousesListQueryVariables = Exact<{
  filters: WarehouseFilters;
}>;


export type GetWarehousesListQuery = { getWarehousesList?: Array<{ __typename?: 'Warehouse', id: string, name: string, wms: Wms, wmsWarehouseId: string, country: Country, created: any }> | null };

export type GetWmsStoresQueryVariables = Exact<{
  vendor: Wms;
  associationKey: Scalars['String']['input'];
  storeId?: InputMaybe<Scalars['Long']['input']>;
}>;


export type GetWmsStoresQuery = { getWmsStores: Array<{ __typename?: 'WMSName', id: string, name: string }> };

export type DisconnectChannelFromWarehouseMutationVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type DisconnectChannelFromWarehouseMutation = { disconnectChannelFromWarehouse: { __typename?: 'StatusOk', ok: boolean } };

export type DisconnectStoreFromWmsMutationVariables = Exact<{
  storeId: Scalars['Long']['input'];
}>;


export type DisconnectStoreFromWmsMutation = { disconnectStoreFromWms: { __typename?: 'StatusOk', ok: boolean } };

export type UpdateAnylogiChannelMutationVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
  verified: Scalars['Boolean']['input'];
  validateAddress: Scalars['Boolean']['input'];
  chargeCodFee: Scalars['Boolean']['input'];
  preferredDeliveryDateTime: Scalars['Boolean']['input'];
}>;


export type UpdateAnylogiChannelMutation = { updateLogisticChannel: { __typename?: 'StatusOk', ok: boolean } };

export type GetSaleChannelDetailQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type GetSaleChannelDetailQuery = { saleChannel: { __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType, isActive: boolean, data: { __typename?: 'AmazonSaleChannelData', amazonMarketplace: AmazonSellerCentralMarketplace } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData', lazadaMarketplace: LazadaMarketplace } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData', qoo10Marketplace: Qoo10Marketplace } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData', shopeeMarketplace: ShopeeMarketplace } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData', tiktokMarketplace: TikTokRegion } | { __typename?: 'TokopediaSaleChannelData', isPending: boolean } | { __typename?: 'YahooSaleChannelData' }, logisticChannel?: { __typename?: 'LogisticChannel', id: string, saleChannelId?: string | null, created: any, provider: Provider, warehouseId?: string | null, warehouseName: string, wmsType: WmsType, merchantId?: string | null, verified: boolean, validateAddress: boolean, preferredDeliveryDateTime: boolean, externalStoreName?: string | null, chargeCODFee: boolean, status?: LogisticChannelStatus | null } | null } };

export type CreateLogisticChannelRequestFormMutationVariables = Exact<{
  input: InputCreateLogisticChannelRequestForm;
}>;


export type CreateLogisticChannelRequestFormMutation = { createLogisticChannelRequestForm?: { __typename?: 'StatusOk', ok: boolean } | null };

export type GetLogisticChannelRequestFormQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLogisticChannelRequestFormQuery = { getLogisticChannelRequestForm?: Array<{ __typename?: 'LogisticChannelRequestForm', id: string, saleChannelId: string, status: ChannelFormStatus }> | null };

export type GetStoreInformationQueryVariables = Exact<{
  mdStoreId: Scalars['Long']['input'];
}>;


export type GetStoreInformationQuery = { MdStore: { __typename?: 'MdStore', id: string, account?: { __typename?: 'MdAccount', id: string } | null, channels: Array<{ __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType }> } };

export type DeleteSaleChannelMutationVariables = Exact<{
  input: DeleteSaleChannelInput;
}>;


export type DeleteSaleChannelMutation = { deleteSaleChannel: { __typename?: 'DeleteSaleChannelPayload', ok: boolean } };

export type HasLogisticsChannelForDeleteQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type HasLogisticsChannelForDeleteQuery = { hasLogisticsChannelBySaleChannelId: { __typename?: 'HasLogisticsChannel', boolean: boolean } };

export type UploadHistoryListV2QueryVariables = Exact<{
  input: FileUploadHistoriesInput;
}>;


export type UploadHistoryListV2Query = { fileUploadHistoriesV2: { __typename?: 'FileUploadHistoriesPayloadV2', totalCount: number, items: Array<{ __typename?: 'FileUploadHistoryPayloadV2', createdAt: string, fileName: string, fileUploadCategory: FileUploadCategory, fileUrl: string, id: string, saleChannelId: string, status: FileUploadHistoryStatus }> } };

export type ImportFileQueryVariables = Exact<{
  fileName: Scalars['String']['input'];
}>;


export type ImportFileQuery = { importsFileUpload: { __typename?: 'UploadFilePayload', fileName: string, signedUrl: string, fileUri: string } };

export type RegisterFileV2MutationVariables = Exact<{
  input: FileUploadInputV2Input;
}>;


export type RegisterFileV2Mutation = { registerFileUploadV3: { __typename?: 'RegisterFileUploadPayload', fileUploadId: string } };

export type AmazonSaleChannelCreateQueryVariables = Exact<{
  input: AmazonSellerCentralLoginUrlV2Input;
}>;


export type AmazonSaleChannelCreateQuery = { amazonSellerCentralLoginUrlV2: string };

export type AdCostMappingCampaignsQueryVariables = Exact<{
  filter: AdCostCampaignMappingListFilterInput;
}>;


export type AdCostMappingCampaignsQuery = { getAdCostCampaignMappings: { __typename?: 'AdCostCampaignMappingListPayload', items: Array<{ __typename?: 'AdCostCampaignMappingListInfoPayload', adCostCampaignMappingGroupId: string, adsCostType: AdsCostType, campaignName: string, numberOfProductVariants?: number | null }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type AdsCostCampaignPreviewQueryVariables = Exact<{
  ascending: Scalars['Boolean']['input'];
  filter: AdsCostCsvFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type AdsCostCampaignPreviewQuery = { adsCostByCampaignCSVPreview: { __typename?: 'AdsCostByCampaignCSVPayloadList', items: Array<{ __typename?: 'AdsCostByCampaignCSVPayload', campaignName: string, clicks: string, cpc: string, cpcCurrency: ReportSupportedCurrency, ctr: string, date: any, impressions: string, numberOfOrders: string, roas: string, spend: string, spendCurrency: ReportSupportedCurrency, totalSales: string, totalSalesCurrency: ReportSupportedCurrency }>, meta: { __typename?: 'ReportListMeta', length: number, total: number } } };

export type SessionsPreviewQueryVariables = Exact<{
  ascending: Scalars['Boolean']['input'];
  filter: SessionsCsvFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type SessionsPreviewQuery = { sessionsCSVPreview: { __typename?: 'SessionsCSVPayloadList', items: Array<{ __typename?: 'SessionsCSVPayload', date: any, sessions: string }>, meta: { __typename?: 'ReportListMeta', length: number, total: number } } };

export type AmazonSaveCostIndexesMutationVariables = Exact<{
  input: SaleChannelSaveInput;
}>;


export type AmazonSaveCostIndexesMutation = { saveSaleChannelCostIndex: { __typename?: 'SaleChannelCostIndexPayload', ok: boolean } };

export type AmazonSaleChannelCostIndexesQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type AmazonSaleChannelCostIndexesQuery = { saleChannelCostIndex?: { __typename?: 'SaleChannelCostIndexQueryPayload', plan?: SaleChannelPlanType | null, referralFeeSoldPercentage?: string | null, taxRatePercentage?: string | null } | null };

export type AmazonSaleChannelDetailsQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type AmazonSaleChannelDetailsQuery = { saleChannel: { __typename?: 'SaleChannel', id: string, isActive: boolean, type: MarketplaceSaleChannelType, store: { __typename?: 'MdStore', id: string, name: string }, data: { __typename?: 'AmazonSaleChannelData', marketplace: AmazonSellerCentralMarketplace } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData' } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData' } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData' } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData' } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' } } };

export type AmazonSaleChannelPlansQueryVariables = Exact<{
  type: SaleChannelType;
}>;


export type AmazonSaleChannelPlansQuery = { saleChannelPlanV2: Array<{ __typename?: 'SaleChannelPlanPayload', value: SaleChannelPlanType, amount: string, unit: SaleChannelPlanUnit, price: string, currency: ReportSupportedCurrency }> };

export type AmazonSaleChannelReconnectQueryVariables = Exact<{
  input: AmazonSellerCentralLoginUrlV2Input;
}>;


export type AmazonSaleChannelReconnectQuery = { amazonSellerCentralLoginUrlV2: string };

export type LazadaSaleChannelCreateQueryVariables = Exact<{
  input: LazadaLoginUrlV2Input;
}>;


export type LazadaSaleChannelCreateQuery = { lazadaLoginUrlV2: string };

export type LazadaSaleChannelReconnectQueryVariables = Exact<{
  input: LazadaLoginUrlV2Input;
}>;


export type LazadaSaleChannelReconnectQuery = { lazadaLoginUrlV2: string };

export type LazadaSaveCostIndexesMutationVariables = Exact<{
  input: SaleChannelSaveInput;
}>;


export type LazadaSaveCostIndexesMutation = { saveSaleChannelCostIndex: { __typename?: 'SaleChannelCostIndexPayload', ok: boolean } };

export type LazadaSaleChannelCostIndexesQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type LazadaSaleChannelCostIndexesQuery = { saleChannelCostIndex?: { __typename?: 'SaleChannelCostIndexQueryPayload', commissionFeePercentage?: string | null, transactionFeePercentage?: string | null, taxRatePercentage?: string | null } | null };

export type LazadaSaleChannelDetailsQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type LazadaSaleChannelDetailsQuery = { saleChannel: { __typename?: 'SaleChannel', id: string, isActive: boolean, type: MarketplaceSaleChannelType, data: { __typename?: 'AmazonSaleChannelData' } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData', marketplace: LazadaMarketplace, showReconnectButton: boolean, refreshTokenExpirationDate: string } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData' } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData' } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData' } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' }, store: { __typename?: 'MdStore', id: string, name: string } } };

export type RegisterManualIntegrationOrderCsvUploadMutationVariables = Exact<{
  input: ManualIntegrationOrderCsvInput;
}>;


export type RegisterManualIntegrationOrderCsvUploadMutation = { registerManualIntegrationOrderCsvUpload: { __typename?: 'RegisterManualIntegrationOrderCsvPayload', fileUploadId: string } };

export type RegisterManualIntegrationProductCsvUploadMutationVariables = Exact<{
  input: ManualIntegrationProductCsvInput;
}>;


export type RegisterManualIntegrationProductCsvUploadMutation = { registerManualIntegrationProductCsvUpload: { __typename?: 'RegisterManualIntegrationProductCsvPayload', fileUploadId: string } };

export type ManualSaveCostIndexesMutationVariables = Exact<{
  input: SaleChannelSaveInput;
}>;


export type ManualSaveCostIndexesMutation = { saveSaleChannelCostIndex: { __typename?: 'SaleChannelCostIndexPayload', ok: boolean } };

export type ManualSaleChannelCostIndexesQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type ManualSaleChannelCostIndexesQuery = { saleChannelCostIndex?: { __typename?: 'SaleChannelCostIndexQueryPayload', commissionFeePercentage?: string | null, taxRatePercentage?: string | null } | null };

export type ManualSaleChannelDetailsQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type ManualSaleChannelDetailsQuery = { saleChannel: { __typename?: 'SaleChannel', id: string, isActive: boolean, type: MarketplaceSaleChannelType, store: { __typename?: 'MdStore', id: string, name: string } } };

export type Qoo10SaleChannelConnectMutationVariables = Exact<{
  input: Qoo10SaleChannelCreateInput;
}>;


export type Qoo10SaleChannelConnectMutation = { qoo10SaleChannelCreate: string };

export type Qoo10SaleChannelReconnectMutationVariables = Exact<{
  input: Qoo10SaleChannelReconnectInput;
}>;


export type Qoo10SaleChannelReconnectMutation = { qoo10SaleChannelReconnect: string };

export type Qoo10SaveCostIndexesMutationVariables = Exact<{
  input: SaleChannelSaveInput;
}>;


export type Qoo10SaveCostIndexesMutation = { saveSaleChannelCostIndex: { __typename?: 'SaleChannelCostIndexPayload', ok: boolean } };

export type Qoo10SaleChannelCostIndexesQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type Qoo10SaleChannelCostIndexesQuery = { saleChannelCostIndex?: { __typename?: 'SaleChannelCostIndexQueryPayload', commissionFeePercentage?: string | null, taxRatePercentage?: string | null } | null };

export type Qoo10SaleChannelDetailQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type Qoo10SaleChannelDetailQuery = { saleChannel: { __typename?: 'SaleChannel', id: string, isActive: boolean, type: MarketplaceSaleChannelType, data: { __typename?: 'AmazonSaleChannelData' } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData' } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData', sellerUserId: string, marketplace: Qoo10Marketplace } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData' } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData' } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' }, store: { __typename?: 'MdStore', id: string, name: string } } };

export type RakutenSaleChannelCreateMutationVariables = Exact<{
  licenseKey: Scalars['String']['input'];
  serviceSecret: Scalars['String']['input'];
  storeId: Scalars['Long']['input'];
}>;


export type RakutenSaleChannelCreateMutation = { connectRakuten: { __typename?: 'RakutenConnectPayload', ok: boolean, unavailableAPI?: Array<string> | null } };

export type RakutenSaleChannelReconnectMutationVariables = Exact<{
  licenseKey: Scalars['String']['input'];
  saleChannelId: Scalars['Long']['input'];
}>;


export type RakutenSaleChannelReconnectMutation = { reconnectRakuten: { __typename?: 'RakutenReconnectPayload', ok: boolean, unavailableAPI?: Array<string> | null } };

export type RakutenSaveCostIndexesMutationVariables = Exact<{
  input: SaleChannelSaveInput;
}>;


export type RakutenSaveCostIndexesMutation = { saveSaleChannelCostIndex: { __typename?: 'SaleChannelCostIndexPayload', ok: boolean } };

export type RakutenSaleChannelCostIndexesQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type RakutenSaleChannelCostIndexesQuery = { saleChannelCostIndex?: { __typename?: 'SaleChannelCostIndexQueryPayload', plan?: SaleChannelPlanType | null, rakutenSystemFeePercentage?: string | null, rakutenPayFeePercentage?: string | null, referralFeeSoldPercentage?: string | null, taxRatePercentage?: string | null } | null };

export type RakutenSaleChannelDetailsQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type RakutenSaleChannelDetailsQuery = { saleChannel: { __typename?: 'SaleChannel', id: string, isActive: boolean, type: MarketplaceSaleChannelType, data: { __typename?: 'AmazonSaleChannelData' } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData' } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData' } | { __typename?: 'RakutenSaleChannelData', shopUrl: string } | { __typename?: 'ShopeeSaleChannelData' } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData' } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' }, store: { __typename?: 'MdStore', id: string, name: string } } };

export type RakutenSaleChannelPlansQueryVariables = Exact<{
  type: SaleChannelType;
}>;


export type RakutenSaleChannelPlansQuery = { saleChannelPlanV2: Array<{ __typename?: 'SaleChannelPlanPayload', value: SaleChannelPlanType, amount: string, unit: SaleChannelPlanUnit, price: string, currency: ReportSupportedCurrency }> };

export type ShopeeAffiliateLoginUrlQueryVariables = Exact<{
  input: ShopeeAffiliateLoginUrlInput;
}>;


export type ShopeeAffiliateLoginUrlQuery = { shopeeAffiliateLoginUrl: string };

export type ShopeeAffiliateAuthorizationDetailsQueryVariables = Exact<{
  mdStoreId: Scalars['Long']['input'];
}>;


export type ShopeeAffiliateAuthorizationDetailsQuery = { MdStore: { __typename?: 'MdStore', id: string, shopeeAffiliateAuthorizations: Array<{ __typename?: 'ShopeeAffiliateAuthorization', id: string, isActive: boolean, data: { __typename?: 'ShopeeSaleChannelData', marketplace: ShopeeMarketplace, shopId: string, showReconnectButton: boolean, expiresAt: string } }> } };

export type ShopeeSaleChannelCreateQueryVariables = Exact<{
  input: ShopeeLoginUrlV2Input;
}>;


export type ShopeeSaleChannelCreateQuery = { shopeeLoginUrlV2: string };

export type ShopeeAdsCostRangeProductLevelDailyPreviewQueryVariables = Exact<{
  ascending: Scalars['Boolean']['input'];
  filter: AdsCostRangePerProductDailyCsvFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type ShopeeAdsCostRangeProductLevelDailyPreviewQuery = { adsCostRangeByProductDailyCSVPreview: { __typename?: 'AdsCostRangePerProductDailyCSVPayloadList', items: Array<{ __typename?: 'AdsCostRangePerProductDailyCSVPayload', clicks: string, ctr: string, date: any, impressions: string, masterDataStoreId: string, productVariantId: string, productName: string, roi: string, roiCurrency: ReportSupportedCurrency, saleChannelMarketplace: string, saleChannelType: SaleChannelType, sourceUrl: string, spend: string, spendCurrency: ReportSupportedCurrency, totalSales: string, totalSalesCurrency: ReportSupportedCurrency }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type ShopeeSaveCostIndexesMutationVariables = Exact<{
  input: SaleChannelSaveInput;
}>;


export type ShopeeSaveCostIndexesMutation = { saveSaleChannelCostIndex: { __typename?: 'SaleChannelCostIndexPayload', ok: boolean } };

export type ShopeeSaleChannelCostIndexesQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type ShopeeSaleChannelCostIndexesQuery = { saleChannelCostIndex?: { __typename?: 'SaleChannelCostIndexQueryPayload', commissionFeePercentage?: string | null, transactionFeePercentage?: string | null, taxRatePercentage?: string | null } | null };

export type ShopeeSaleChannelDetailsQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type ShopeeSaleChannelDetailsQuery = { saleChannel: { __typename?: 'SaleChannel', id: string, isActive: boolean, type: MarketplaceSaleChannelType, data: { __typename?: 'AmazonSaleChannelData' } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData' } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData' } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData', marketplace: ShopeeMarketplace, shopId: string, showReconnectButton: boolean } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData' } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' }, store: { __typename?: 'MdStore', id: string, name: string } } };

export type ShopeeSaleChannelReconnectQueryVariables = Exact<{
  input: ShopeeLoginUrlV2Input;
}>;


export type ShopeeSaleChannelReconnectQuery = { shopeeLoginUrlV2: string };

export type ShopifySaleChannelCreateQueryVariables = Exact<{
  input: ShopifyLoginUrlV2Input;
}>;


export type ShopifySaleChannelCreateQuery = { shopifyLoginUrlV2: string };

export type ShopifySaveCostIndexesMutationVariables = Exact<{
  input: SaleChannelSaveInput;
}>;


export type ShopifySaveCostIndexesMutation = { saveSaleChannelCostIndex: { __typename?: 'SaleChannelCostIndexPayload', ok: boolean } };

export type ShopifySaleChannelCostIndexesQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type ShopifySaleChannelCostIndexesQuery = { saleChannelCostIndex?: { __typename?: 'SaleChannelCostIndexQueryPayload', creditCardFeePercentage?: string | null, taxRatePercentage?: string | null, plan?: SaleChannelPlanType | null } | null };

export type ShopifySaleChannelDetailsQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type ShopifySaleChannelDetailsQuery = { saleChannel: { __typename?: 'SaleChannel', id: string, isActive: boolean, type: MarketplaceSaleChannelType, data: { __typename?: 'AmazonSaleChannelData' } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData' } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData' } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData' } | { __typename?: 'ShopifySaleChannelData', domain: string } | { __typename?: 'TikTokSaleChannelData' } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' }, store: { __typename?: 'MdStore', id: string, name: string } } };

export type ShopifySaleChannelPlansQueryVariables = Exact<{
  type: SaleChannelType;
}>;


export type ShopifySaleChannelPlansQuery = { saleChannelPlanV2: Array<{ __typename?: 'SaleChannelPlanPayload', value: SaleChannelPlanType, amount: string, unit: SaleChannelPlanUnit, price: string, currency: ReportSupportedCurrency }> };

export type SetLogisticShopifyCarrierServiceConditionMutationVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
  active: Scalars['Boolean']['input'];
  input?: InputMaybe<ShopifyCarrierServiceConditionInput>;
}>;


export type SetLogisticShopifyCarrierServiceConditionMutation = { setLogisticShopifyCarrierServiceCondition: { __typename?: 'ShopifyCarrierServiceCondition', id: string } };

export type SaleChannelDetailQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type SaleChannelDetailQuery = { saleChannel: { __typename?: 'SaleChannel', id: string, logisticChannelFormStatus?: ChannelFormStatus | null, logisticChannelShopifyCarrierServiceCondition?: { __typename?: 'ShopifyCarrierServiceCondition', condition: LogisticShippingRateConditionType, created: any, id: string, updated: any, minimumWeight?: number | null, maximumWeight?: number | null, dutyDisplayOption: DutyDisplayOption, maximumPrice?: { __typename?: 'AnylogiMoney', currency: AnylogiCurrency, amount: string } | null, minimumPrice?: { __typename?: 'AnylogiMoney', currency: AnylogiCurrency, amount: string } | null } | null, logisticChannelShopifyCarrierService?: { __typename?: 'ShopifyCarrierService', active: boolean } | null } };

export type TikTokChannelCreateQueryVariables = Exact<{
  input: TikTokLoginUrlV2Input;
}>;


export type TikTokChannelCreateQuery = { tikTokLoginUrlV2: string };

export type ConnectTokopediaFromTtsMutationVariables = Exact<{
  input: TokopediaSaleChannelLinkTikTokInput;
}>;


export type ConnectTokopediaFromTtsMutation = { tokopediaSaleChannelLinkTikTok: string };

export type TikTokSaveCostIndexesMutationVariables = Exact<{
  input: SaleChannelSaveInput;
}>;


export type TikTokSaveCostIndexesMutation = { saveSaleChannelCostIndex: { __typename?: 'SaleChannelCostIndexPayload', ok: boolean } };

export type TikTokSaleChannelCostIndexesQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type TikTokSaleChannelCostIndexesQuery = { saleChannelCostIndex?: { __typename?: 'SaleChannelCostIndexQueryPayload', commissionFeePercentage?: string | null, flatFee?: string | null, taxRatePercentage?: string | null } | null };

export type TikTokSaleChannelDetailsQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type TikTokSaleChannelDetailsQuery = { saleChannel: { __typename?: 'SaleChannel', id: string, isActive: boolean, type: MarketplaceSaleChannelType, data: { __typename?: 'AmazonSaleChannelData' } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData' } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData' } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData' } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData', marketplace: TikTokRegion } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData' } } };

export type TikTokSaleChannelReconnectQueryVariables = Exact<{
  input: TikTokLoginUrlV2Input;
}>;


export type TikTokSaleChannelReconnectQuery = { tikTokLoginUrlV2: string };

export type StoreTikTokShopChannelsQueryVariables = Exact<{
  storeId: Scalars['Long']['input'];
}>;


export type StoreTikTokShopChannelsQuery = { MdStore: { __typename?: 'MdStore', channels: Array<{ __typename?: 'SaleChannel', id: string, type: MarketplaceSaleChannelType, isActive: boolean, data: { __typename?: 'AmazonSaleChannelData' } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData' } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData' } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData' } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData', marketplace: TikTokRegion, shopId: string } | { __typename?: 'TokopediaSaleChannelData', linkedTikTokSaleChannelId?: string | null } | { __typename?: 'YahooSaleChannelData' } }> } };

export type TokopediaAdsCostRangeProductLevelDailyPreviewQueryVariables = Exact<{
  ascending: Scalars['Boolean']['input'];
  filter: AdsCostRangeProductLevelDailyCsvFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type TokopediaAdsCostRangeProductLevelDailyPreviewQuery = { adsCostRangeProductLevelDailyCSVPreview: { __typename?: 'AdsCostRangeProductLevelDailyCSVPayloadList', lastUpdated?: string | null, items: Array<{ __typename?: 'AdsCostRangeProductLevelDailyCSVPayload', clicks: string, ctr: string, date: any, impressions: string, masterDataStoreId: string, productId: string, productName: string, roi?: string | null, roiCurrency?: ReportSupportedCurrency | null, saleChannelMarketplace: string, saleChannelType: SaleChannelType, sourceUrl: string, spend: string, spendCurrency: ReportSupportedCurrency, totalSales: string, totalSalesCurrency: ReportSupportedCurrency }>, meta: { __typename?: 'ReportListMeta', length: number, limit: number, start: number, total: number } } };

export type TokopediaSaleChannelReconnectMutationVariables = Exact<{
  input: TokopediaSaleChannelReconnectInput;
}>;


export type TokopediaSaleChannelReconnectMutation = { tokopediaSaleChannelReconnect: string };

export type TokopediaSaveCostIndexesMutationVariables = Exact<{
  input: SaleChannelSaveInput;
}>;


export type TokopediaSaveCostIndexesMutation = { saveSaleChannelCostIndex: { __typename?: 'SaleChannelCostIndexPayload', ok: boolean } };

export type TokopediaSaleChannelCostIndexesQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type TokopediaSaleChannelCostIndexesQuery = { saleChannelCostIndex?: { __typename?: 'SaleChannelCostIndexQueryPayload', commissionFeePercentage?: string | null, freeShippingFeeAdjustmentPercentage?: string | null, taxRatePercentage?: string | null } | null };

export type TokopediaSaleChannelDetailsQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type TokopediaSaleChannelDetailsQuery = { saleChannel: { __typename?: 'SaleChannel', id: string, isActive: boolean, type: MarketplaceSaleChannelType, data: { __typename?: 'AmazonSaleChannelData' } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData' } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData' } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData' } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData' } | { __typename?: 'TokopediaSaleChannelData', domain?: string | null, isPending: boolean } | { __typename?: 'YahooSaleChannelData' }, store: { __typename?: 'MdStore', id: string, name: string } } };

export type YahooSaleChannelCreateQueryVariables = Exact<{
  input: YahooLoginUrlInput;
}>;


export type YahooSaleChannelCreateQuery = { yahooLoginUrl: string };

export type YahooSaveCostIndexesMutationVariables = Exact<{
  input: SaleChannelSaveInput;
}>;


export type YahooSaveCostIndexesMutation = { saveSaleChannelCostIndex: { __typename?: 'SaleChannelCostIndexPayload', ok: boolean } };

export type YahooSaleChannelDetailsQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type YahooSaleChannelDetailsQuery = { saleChannel: { __typename?: 'SaleChannel', id: string, isActive: boolean, type: MarketplaceSaleChannelType, data: { __typename?: 'AmazonSaleChannelData' } | { __typename?: 'EmptySaleChannelData' } | { __typename?: 'LazadaSaleChannelData' } | { __typename?: 'MomoSaleChannelData' } | { __typename?: 'Qoo10SaleChannelData' } | { __typename?: 'RakutenSaleChannelData' } | { __typename?: 'ShopeeSaleChannelData' } | { __typename?: 'ShopifySaleChannelData' } | { __typename?: 'TikTokSaleChannelData' } | { __typename?: 'TokopediaSaleChannelData' } | { __typename?: 'YahooSaleChannelData', sellerId: string, showReconnectButton: boolean, refreshTokenExpirationDate: string }, store: { __typename?: 'MdStore', id: string, name: string } } };

export type YahooSaleChannelCostIndexesQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type YahooSaleChannelCostIndexesQuery = { saleChannelCostIndex?: { __typename?: 'SaleChannelCostIndexQueryPayload', resourceBurdenRatioPercentage?: string | null, transactionFeePercentage?: string | null, taxRatePercentage?: string | null } | null };

export type AdsCostZozotownPreviewQueryVariables = Exact<{
  ascending: Scalars['Boolean']['input'];
  filter: AdsCostCsvFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type AdsCostZozotownPreviewQuery = { adsCostZozotownCSVPreview: { __typename?: 'AdsCostZozotownCSVPayloadList', items: Array<{ __typename?: 'AdsCostZozotownCSVPayload', clicks: string, cpc: string, cpcCurrency: ReportSupportedCurrency, ctr: string, date: any, impressions: string, numberOfOrders: string, productVariantId: string, roas: string, spend: string, spendCurrency: ReportSupportedCurrency, totalSales: string, totalSalesCurrency: ReportSupportedCurrency }>, meta: { __typename?: 'ReportListMeta', length: number, total: number } } };

export type ZozotownSaveCostIndexesMutationVariables = Exact<{
  input: SaleChannelSaveInput;
}>;


export type ZozotownSaveCostIndexesMutation = { saveSaleChannelCostIndex: { __typename?: 'SaleChannelCostIndexPayload', ok: boolean } };

export type ZozotownSaleChannelCostIndexesQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type ZozotownSaleChannelCostIndexesQuery = { saleChannelCostIndex?: { __typename?: 'SaleChannelCostIndexQueryPayload', commissionFeePercentage?: string | null, freeShippingFeeAdjustmentPercentage?: string | null, taxRatePercentage?: string | null } | null };

export type ZozotownSaleChannelDetailsQueryVariables = Exact<{
  saleChannelId: Scalars['Long']['input'];
}>;


export type ZozotownSaleChannelDetailsQuery = { saleChannel: { __typename?: 'SaleChannel', id: string, isActive: boolean, type: MarketplaceSaleChannelType, store: { __typename?: 'MdStore', id: string, name: string } } };
